/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  BetterDateTimeResolver: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AccountCreateManyUserInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  accessTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  accountId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['DateTime']['input'];
};

export type AccountCreateManyUserInputEnvelope = {
  data: Array<AccountCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<AccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AccountCreateWithoutUserInput>>;
  createMany?: InputMaybe<AccountCreateManyUserInputEnvelope>;
};

export type AccountCreateOrConnectWithoutUserInput = {
  create: AccountCreateWithoutUserInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateWithoutUserInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  accessTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  accountId: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['DateTime']['input'];
};

export type AccountListRelationFilter = {
  every?: InputMaybe<AccountWhereInput>;
  none?: InputMaybe<AccountWhereInput>;
  some?: InputMaybe<AccountWhereInput>;
};

export type AccountOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccountScalarWhereInput = {
  AND?: InputMaybe<Array<AccountScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccountScalarWhereInput>>;
  OR?: InputMaybe<Array<AccountScalarWhereInput>>;
  accessToken?: InputMaybe<StringNullableFilter>;
  accessTokenExpiresAt?: InputMaybe<DateTimeNullableFilter>;
  accountId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  idToken?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  providerId?: InputMaybe<StringFilter>;
  refreshToken?: InputMaybe<StringNullableFilter>;
  refreshTokenExpiresAt?: InputMaybe<DateTimeNullableFilter>;
  scope?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type AccountUpdateManyMutationInput = {
  accessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accessTokenExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  accountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refreshTokenExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountUpdateManyWithWhereWithoutUserInput = {
  data: AccountUpdateManyMutationInput;
  where: AccountScalarWhereInput;
};

export type AccountUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<AccountWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AccountCreateWithoutUserInput>>;
  createMany?: InputMaybe<AccountCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<AccountWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccountScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccountWhereUniqueInput>>;
  set?: InputMaybe<Array<AccountWhereUniqueInput>>;
  update?: InputMaybe<Array<AccountUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<AccountUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<AccountUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AccountUpdateWithWhereUniqueWithoutUserInput = {
  data: AccountUpdateWithoutUserInput;
  where: AccountWhereUniqueInput;
};

export type AccountUpdateWithoutUserInput = {
  accessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accessTokenExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  accountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refreshTokenExpiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountUpsertWithWhereUniqueWithoutUserInput = {
  create: AccountCreateWithoutUserInput;
  update: AccountUpdateWithoutUserInput;
  where: AccountWhereUniqueInput;
};

export type AccountWhereInput = {
  AND?: InputMaybe<Array<AccountWhereInput>>;
  NOT?: InputMaybe<Array<AccountWhereInput>>;
  OR?: InputMaybe<Array<AccountWhereInput>>;
  accessToken?: InputMaybe<StringNullableFilter>;
  accessTokenExpiresAt?: InputMaybe<DateTimeNullableFilter>;
  accountId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  idToken?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  providerId?: InputMaybe<StringFilter>;
  refreshToken?: InputMaybe<StringNullableFilter>;
  refreshTokenExpiresAt?: InputMaybe<DateTimeNullableFilter>;
  scope?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type AccountWhereUniqueInput = {
  AND?: InputMaybe<Array<AccountWhereInput>>;
  NOT?: InputMaybe<Array<AccountWhereInput>>;
  OR?: InputMaybe<Array<AccountWhereInput>>;
  accessToken?: InputMaybe<StringNullableFilter>;
  accessTokenExpiresAt?: InputMaybe<DateTimeNullableFilter>;
  accountId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  idToken?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  providerId?: InputMaybe<StringFilter>;
  refreshToken?: InputMaybe<StringNullableFilter>;
  refreshTokenExpiresAt?: InputMaybe<DateTimeNullableFilter>;
  scope?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type AddressShippingInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Admin = {
  __typename?: 'Admin';
  _count?: Maybe<AdminCount>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  permissions: Array<AdminPermission>;
  updatedAt: Scalars['DateTime']['output'];
  warehouseId?: Maybe<Scalars['String']['output']>;
};

export type AdminCount = {
  __typename?: 'AdminCount';
  bulkShippings: Scalars['Int']['output'];
  completedShipments: Scalars['Int']['output'];
  customOnHoldReasonsAdded: Scalars['Int']['output'];
  customOnHoldReasonsResolved: Scalars['Int']['output'];
  digitalServiceProducts: Scalars['Int']['output'];
  linePreparationHistory: Scalars['Int']['output'];
  lockedOrders: Scalars['Int']['output'];
  onHoldIntervalCreated: Scalars['Int']['output'];
  onHoldIntervalResolved: Scalars['Int']['output'];
  onHoldReasonIntervalCreated: Scalars['Int']['output'];
  onHoldReasonIntervalResolved: Scalars['Int']['output'];
  preparedLineItems: Scalars['Int']['output'];
  printBatches: Scalars['Int']['output'];
  productStockSnapshots: Scalars['Int']['output'];
  refundedLineItems: Scalars['Int']['output'];
  shipmentBatches: Scalars['Int']['output'];
  shipments: Scalars['Int']['output'];
  stripeCreditNotes: Scalars['Int']['output'];
  transactions: Scalars['Int']['output'];
  userProductLabelsVerified: Scalars['Int']['output'];
  voidedInvoices: Scalars['Int']['output'];
};


export type AdminCountBulkShippingsArgs = {
  where?: InputMaybe<BulkShippingWhereInput>;
};


export type AdminCountCompletedShipmentsArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};


export type AdminCountCustomOnHoldReasonsAddedArgs = {
  where?: InputMaybe<CustomOnHoldReasonWhereInput>;
};


export type AdminCountCustomOnHoldReasonsResolvedArgs = {
  where?: InputMaybe<CustomOnHoldReasonWhereInput>;
};


export type AdminCountDigitalServiceProductsArgs = {
  where?: InputMaybe<DigitalServiceProductWhereInput>;
};


export type AdminCountLinePreparationHistoryArgs = {
  where?: InputMaybe<UserProductOrderLinePreparationHistoryWhereInput>;
};


export type AdminCountLockedOrdersArgs = {
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type AdminCountOnHoldIntervalCreatedArgs = {
  where?: InputMaybe<UserProductOrderHoldStatusIntervalWhereInput>;
};


export type AdminCountOnHoldIntervalResolvedArgs = {
  where?: InputMaybe<UserProductOrderHoldStatusIntervalWhereInput>;
};


export type AdminCountOnHoldReasonIntervalCreatedArgs = {
  where?: InputMaybe<UserProductOrderOnHoldReasonIntervalWhereInput>;
};


export type AdminCountOnHoldReasonIntervalResolvedArgs = {
  where?: InputMaybe<UserProductOrderOnHoldReasonIntervalWhereInput>;
};


export type AdminCountPreparedLineItemsArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type AdminCountPrintBatchesArgs = {
  where?: InputMaybe<PrintBatchWhereInput>;
};


export type AdminCountProductStockSnapshotsArgs = {
  where?: InputMaybe<ProductStockSnapshotWhereInput>;
};


export type AdminCountRefundedLineItemsArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type AdminCountShipmentBatchesArgs = {
  where?: InputMaybe<ShipmentBatchWhereInput>;
};


export type AdminCountShipmentsArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};


export type AdminCountStripeCreditNotesArgs = {
  where?: InputMaybe<StripeCreditNoteWhereInput>;
};


export type AdminCountTransactionsArgs = {
  where?: InputMaybe<UserCreditsTransactionWhereInput>;
};


export type AdminCountUserProductLabelsVerifiedArgs = {
  where?: InputMaybe<UserProductLabelWhereInput>;
};


export type AdminCountVoidedInvoicesArgs = {
  where?: InputMaybe<StripeInvoiceWhereInput>;
};

export type AdminCreateManyWarehouseInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminCreateManyWarehouseInputEnvelope = {
  data: Array<AdminCreateManyWarehouseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminCreateNestedManyWithoutWarehouseInput = {
  connect?: InputMaybe<Array<AdminWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<AdminCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<AdminCreateManyWarehouseInputEnvelope>;
};

export type AdminCreateNestedOneWithoutBulkShippingsInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutBulkShippingsInput>;
  create?: InputMaybe<AdminCreateWithoutBulkShippingsInput>;
};

export type AdminCreateNestedOneWithoutCompletedShipmentsInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutCompletedShipmentsInput>;
  create?: InputMaybe<AdminCreateWithoutCompletedShipmentsInput>;
};

export type AdminCreateNestedOneWithoutCustomOnHoldReasonsAddedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutCustomOnHoldReasonsAddedInput>;
  create?: InputMaybe<AdminCreateWithoutCustomOnHoldReasonsAddedInput>;
};

export type AdminCreateNestedOneWithoutCustomOnHoldReasonsResolvedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutCustomOnHoldReasonsResolvedInput>;
  create?: InputMaybe<AdminCreateWithoutCustomOnHoldReasonsResolvedInput>;
};

export type AdminCreateNestedOneWithoutLinePreparationHistoryInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutLinePreparationHistoryInput>;
  create?: InputMaybe<AdminCreateWithoutLinePreparationHistoryInput>;
};

export type AdminCreateNestedOneWithoutLockedOrdersInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutLockedOrdersInput>;
  create?: InputMaybe<AdminCreateWithoutLockedOrdersInput>;
};

export type AdminCreateNestedOneWithoutOnHoldIntervalCreatedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutOnHoldIntervalCreatedInput>;
  create?: InputMaybe<AdminCreateWithoutOnHoldIntervalCreatedInput>;
};

export type AdminCreateNestedOneWithoutOnHoldIntervalResolvedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutOnHoldIntervalResolvedInput>;
  create?: InputMaybe<AdminCreateWithoutOnHoldIntervalResolvedInput>;
};

export type AdminCreateNestedOneWithoutOnHoldReasonIntervalCreatedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutOnHoldReasonIntervalCreatedInput>;
  create?: InputMaybe<AdminCreateWithoutOnHoldReasonIntervalCreatedInput>;
};

export type AdminCreateNestedOneWithoutOnHoldReasonIntervalResolvedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutOnHoldReasonIntervalResolvedInput>;
  create?: InputMaybe<AdminCreateWithoutOnHoldReasonIntervalResolvedInput>;
};

export type AdminCreateNestedOneWithoutPreparedLineItemsInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutPreparedLineItemsInput>;
  create?: InputMaybe<AdminCreateWithoutPreparedLineItemsInput>;
};

export type AdminCreateNestedOneWithoutPrintBatchesInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutPrintBatchesInput>;
  create?: InputMaybe<AdminCreateWithoutPrintBatchesInput>;
};

export type AdminCreateNestedOneWithoutProductStockSnapshotsInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutProductStockSnapshotsInput>;
  create?: InputMaybe<AdminCreateWithoutProductStockSnapshotsInput>;
};

export type AdminCreateNestedOneWithoutRefundedLineItemsInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutRefundedLineItemsInput>;
  create?: InputMaybe<AdminCreateWithoutRefundedLineItemsInput>;
};

export type AdminCreateNestedOneWithoutShipmentBatchesInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutShipmentBatchesInput>;
  create?: InputMaybe<AdminCreateWithoutShipmentBatchesInput>;
};

export type AdminCreateNestedOneWithoutShipmentsInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<AdminCreateWithoutShipmentsInput>;
};

export type AdminCreateNestedOneWithoutStripeCreditNotesInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutStripeCreditNotesInput>;
  create?: InputMaybe<AdminCreateWithoutStripeCreditNotesInput>;
};

export type AdminCreateNestedOneWithoutTransactionsInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<AdminCreateWithoutTransactionsInput>;
};

export type AdminCreateNestedOneWithoutVoidedInvoicesInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutVoidedInvoicesInput>;
  create?: InputMaybe<AdminCreateWithoutVoidedInvoicesInput>;
};

export type AdminCreateOrConnectWithoutBulkShippingsInput = {
  create: AdminCreateWithoutBulkShippingsInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutCompletedShipmentsInput = {
  create: AdminCreateWithoutCompletedShipmentsInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutCustomOnHoldReasonsAddedInput = {
  create: AdminCreateWithoutCustomOnHoldReasonsAddedInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutCustomOnHoldReasonsResolvedInput = {
  create: AdminCreateWithoutCustomOnHoldReasonsResolvedInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutDigitalServiceProductsInput = {
  create: AdminCreateWithoutDigitalServiceProductsInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutLinePreparationHistoryInput = {
  create: AdminCreateWithoutLinePreparationHistoryInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutLockedOrdersInput = {
  create: AdminCreateWithoutLockedOrdersInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutOnHoldIntervalCreatedInput = {
  create: AdminCreateWithoutOnHoldIntervalCreatedInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutOnHoldIntervalResolvedInput = {
  create: AdminCreateWithoutOnHoldIntervalResolvedInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutOnHoldReasonIntervalCreatedInput = {
  create: AdminCreateWithoutOnHoldReasonIntervalCreatedInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutOnHoldReasonIntervalResolvedInput = {
  create: AdminCreateWithoutOnHoldReasonIntervalResolvedInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutPreparedLineItemsInput = {
  create: AdminCreateWithoutPreparedLineItemsInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutPrintBatchesInput = {
  create: AdminCreateWithoutPrintBatchesInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutProductStockSnapshotsInput = {
  create: AdminCreateWithoutProductStockSnapshotsInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutRefundedLineItemsInput = {
  create: AdminCreateWithoutRefundedLineItemsInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutShipmentBatchesInput = {
  create: AdminCreateWithoutShipmentBatchesInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutShipmentsInput = {
  create: AdminCreateWithoutShipmentsInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutStripeCreditNotesInput = {
  create: AdminCreateWithoutStripeCreditNotesInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutTransactionsInput = {
  create: AdminCreateWithoutTransactionsInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutVoidedInvoicesInput = {
  create: AdminCreateWithoutVoidedInvoicesInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateOrConnectWithoutWarehouseInput = {
  create: AdminCreateWithoutWarehouseInput;
  where: AdminWhereUniqueInput;
};

export type AdminCreateWithoutBulkShippingsInput = {
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutCompletedShipmentsInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutCustomOnHoldReasonsAddedInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutCustomOnHoldReasonsResolvedInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutDigitalServiceProductsInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutLinePreparationHistoryInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutLockedOrdersInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutOnHoldIntervalCreatedInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutOnHoldIntervalResolvedInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutOnHoldReasonIntervalCreatedInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutOnHoldReasonIntervalResolvedInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutPreparedLineItemsInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutPrintBatchesInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutProductStockSnapshotsInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutRefundedLineItemsInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutShipmentBatchesInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutShipmentsInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutStripeCreditNotesInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutTransactionsInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutVoidedInvoicesInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutAdminsInput>;
};

export type AdminCreateWithoutWarehouseInput = {
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutCreatedByInput>;
  completedShipments?: InputMaybe<ShipmentCreateNestedManyWithoutCompletedByInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutAddedByInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductCreateNestedManyWithoutCreatedByInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput>;
  lockedOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutLockedByInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput>;
  password: Scalars['String']['input'];
  permissions?: InputMaybe<AdminCreatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutPreparedByInput>;
  printBatches?: InputMaybe<PrintBatchCreateNestedManyWithoutCreatedByInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutRecordedByInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRefundedByInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCompletedByInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCreatedByInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutCreatedByInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutCreatedByInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  voidedInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutVoidedByInput>;
};

export type AdminCreatepermissionsInput = {
  set: Array<AdminPermission>;
};

export type AdminDigitalServiceProductListItem = {
  __typename?: 'AdminDigitalServiceProductListItem';
  digitalServiceProduct: DigitalServiceProduct;
  stripeProduct?: Maybe<StripeProduct>;
};

export type AdminListRelationFilter = {
  every?: InputMaybe<AdminWhereInput>;
  none?: InputMaybe<AdminWhereInput>;
  some?: InputMaybe<AdminWhereInput>;
};

export type AdminNullableRelationFilter = {
  is?: InputMaybe<AdminWhereInput>;
  isNot?: InputMaybe<AdminWhereInput>;
};

export type AdminOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AdminOrderByWithRelationInput = {
  bulkShippings?: InputMaybe<BulkShippingOrderByRelationAggregateInput>;
  completedShipments?: InputMaybe<ShipmentOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonOrderByRelationAggregateInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonOrderByRelationAggregateInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductOrderByRelationAggregateInput>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDisabled?: InputMaybe<SortOrder>;
  lastLogin?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrder>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryOrderByRelationAggregateInput>;
  lockedOrders?: InputMaybe<UserProductOrderOrderByRelationAggregateInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalOrderByRelationAggregateInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalOrderByRelationAggregateInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalOrderByRelationAggregateInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalOrderByRelationAggregateInput>;
  password?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrder>;
  preparedLineItems?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  printBatches?: InputMaybe<PrintBatchOrderByRelationAggregateInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotOrderByRelationAggregateInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchOrderByRelationAggregateInput>;
  shipments?: InputMaybe<ShipmentOrderByRelationAggregateInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteOrderByRelationAggregateInput>;
  transactions?: InputMaybe<UserCreditsTransactionOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  voidedInvoices?: InputMaybe<StripeInvoiceOrderByRelationAggregateInput>;
  warehouse?: InputMaybe<WarehouseOrderByWithRelationInput>;
  warehouseId?: InputMaybe<SortOrderInput>;
};

export enum AdminPermission {
  Everything = 'EVERYTHING',
  EverythingElse = 'EVERYTHING_ELSE',
  FulfillmentAssociate = 'FULFILLMENT_ASSOCIATE',
  FulfillmentLead = 'FULFILLMENT_LEAD',
  LabelVerification = 'LABEL_VERIFICATION',
  PartnerProgramFeatures = 'PARTNER_PROGRAM_FEATURES'
}

export type AdminRelationFilter = {
  is?: InputMaybe<AdminWhereInput>;
  isNot?: InputMaybe<AdminWhereInput>;
};

export type AdminScalarWhereInput = {
  AND?: InputMaybe<Array<AdminScalarWhereInput>>;
  NOT?: InputMaybe<Array<AdminScalarWhereInput>>;
  OR?: InputMaybe<Array<AdminScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  lastName?: InputMaybe<StringFilter>;
  password?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<EnumAdminPermissionNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  warehouseId?: InputMaybe<UuidNullableFilter>;
};

export type AdminUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminUpdateManyWithWhereWithoutWarehouseInput = {
  data: AdminUpdateManyMutationInput;
  where: AdminScalarWhereInput;
};

export type AdminUpdateManyWithoutWarehouseNestedInput = {
  connect?: InputMaybe<Array<AdminWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<AdminCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<AdminCreateManyWarehouseInputEnvelope>;
  delete?: InputMaybe<Array<AdminWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdminScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdminWhereUniqueInput>>;
  set?: InputMaybe<Array<AdminWhereUniqueInput>>;
  update?: InputMaybe<Array<AdminUpdateWithWhereUniqueWithoutWarehouseInput>>;
  updateMany?: InputMaybe<Array<AdminUpdateManyWithWhereWithoutWarehouseInput>>;
  upsert?: InputMaybe<Array<AdminUpsertWithWhereUniqueWithoutWarehouseInput>>;
};

export type AdminUpdateOneRequiredWithoutBulkShippingsNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutBulkShippingsInput>;
  create?: InputMaybe<AdminCreateWithoutBulkShippingsInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutBulkShippingsInput>;
  upsert?: InputMaybe<AdminUpsertWithoutBulkShippingsInput>;
};

export type AdminUpdateOneRequiredWithoutDigitalServiceProductsNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutDigitalServiceProductsInput>;
  create?: InputMaybe<AdminCreateWithoutDigitalServiceProductsInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutDigitalServiceProductsInput>;
  upsert?: InputMaybe<AdminUpsertWithoutDigitalServiceProductsInput>;
};

export type AdminUpdateOneRequiredWithoutLinePreparationHistoryNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutLinePreparationHistoryInput>;
  create?: InputMaybe<AdminCreateWithoutLinePreparationHistoryInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutLinePreparationHistoryInput>;
  upsert?: InputMaybe<AdminUpsertWithoutLinePreparationHistoryInput>;
};

export type AdminUpdateOneRequiredWithoutPrintBatchesNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutPrintBatchesInput>;
  create?: InputMaybe<AdminCreateWithoutPrintBatchesInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutPrintBatchesInput>;
  upsert?: InputMaybe<AdminUpsertWithoutPrintBatchesInput>;
};

export type AdminUpdateOneRequiredWithoutProductStockSnapshotsNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutProductStockSnapshotsInput>;
  create?: InputMaybe<AdminCreateWithoutProductStockSnapshotsInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutProductStockSnapshotsInput>;
  upsert?: InputMaybe<AdminUpsertWithoutProductStockSnapshotsInput>;
};

export type AdminUpdateOneRequiredWithoutShipmentBatchesNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutShipmentBatchesInput>;
  create?: InputMaybe<AdminCreateWithoutShipmentBatchesInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutShipmentBatchesInput>;
  upsert?: InputMaybe<AdminUpsertWithoutShipmentBatchesInput>;
};

export type AdminUpdateOneRequiredWithoutShipmentsNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<AdminCreateWithoutShipmentsInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutShipmentsInput>;
  upsert?: InputMaybe<AdminUpsertWithoutShipmentsInput>;
};

export type AdminUpdateOneWithoutCompletedShipmentsNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutCompletedShipmentsInput>;
  create?: InputMaybe<AdminCreateWithoutCompletedShipmentsInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutCompletedShipmentsInput>;
  upsert?: InputMaybe<AdminUpsertWithoutCompletedShipmentsInput>;
};

export type AdminUpdateOneWithoutCustomOnHoldReasonsAddedNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutCustomOnHoldReasonsAddedInput>;
  create?: InputMaybe<AdminCreateWithoutCustomOnHoldReasonsAddedInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutCustomOnHoldReasonsAddedInput>;
  upsert?: InputMaybe<AdminUpsertWithoutCustomOnHoldReasonsAddedInput>;
};

export type AdminUpdateOneWithoutCustomOnHoldReasonsResolvedNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutCustomOnHoldReasonsResolvedInput>;
  create?: InputMaybe<AdminCreateWithoutCustomOnHoldReasonsResolvedInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutCustomOnHoldReasonsResolvedInput>;
  upsert?: InputMaybe<AdminUpsertWithoutCustomOnHoldReasonsResolvedInput>;
};

export type AdminUpdateOneWithoutLockedOrdersNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutLockedOrdersInput>;
  create?: InputMaybe<AdminCreateWithoutLockedOrdersInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutLockedOrdersInput>;
  upsert?: InputMaybe<AdminUpsertWithoutLockedOrdersInput>;
};

export type AdminUpdateOneWithoutOnHoldIntervalCreatedNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutOnHoldIntervalCreatedInput>;
  create?: InputMaybe<AdminCreateWithoutOnHoldIntervalCreatedInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutOnHoldIntervalCreatedInput>;
  upsert?: InputMaybe<AdminUpsertWithoutOnHoldIntervalCreatedInput>;
};

export type AdminUpdateOneWithoutOnHoldIntervalResolvedNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutOnHoldIntervalResolvedInput>;
  create?: InputMaybe<AdminCreateWithoutOnHoldIntervalResolvedInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutOnHoldIntervalResolvedInput>;
  upsert?: InputMaybe<AdminUpsertWithoutOnHoldIntervalResolvedInput>;
};

export type AdminUpdateOneWithoutOnHoldReasonIntervalCreatedNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutOnHoldReasonIntervalCreatedInput>;
  create?: InputMaybe<AdminCreateWithoutOnHoldReasonIntervalCreatedInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutOnHoldReasonIntervalCreatedInput>;
  upsert?: InputMaybe<AdminUpsertWithoutOnHoldReasonIntervalCreatedInput>;
};

export type AdminUpdateOneWithoutOnHoldReasonIntervalResolvedNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutOnHoldReasonIntervalResolvedInput>;
  create?: InputMaybe<AdminCreateWithoutOnHoldReasonIntervalResolvedInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutOnHoldReasonIntervalResolvedInput>;
  upsert?: InputMaybe<AdminUpsertWithoutOnHoldReasonIntervalResolvedInput>;
};

export type AdminUpdateOneWithoutPreparedLineItemsNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutPreparedLineItemsInput>;
  create?: InputMaybe<AdminCreateWithoutPreparedLineItemsInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutPreparedLineItemsInput>;
  upsert?: InputMaybe<AdminUpsertWithoutPreparedLineItemsInput>;
};

export type AdminUpdateOneWithoutRefundedLineItemsNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutRefundedLineItemsInput>;
  create?: InputMaybe<AdminCreateWithoutRefundedLineItemsInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutRefundedLineItemsInput>;
  upsert?: InputMaybe<AdminUpsertWithoutRefundedLineItemsInput>;
};

export type AdminUpdateOneWithoutStripeCreditNotesNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutStripeCreditNotesInput>;
  create?: InputMaybe<AdminCreateWithoutStripeCreditNotesInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutStripeCreditNotesInput>;
  upsert?: InputMaybe<AdminUpsertWithoutStripeCreditNotesInput>;
};

export type AdminUpdateOneWithoutTransactionsNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<AdminCreateWithoutTransactionsInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutTransactionsInput>;
  upsert?: InputMaybe<AdminUpsertWithoutTransactionsInput>;
};

export type AdminUpdateOneWithoutVoidedInvoicesNestedInput = {
  connect?: InputMaybe<AdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AdminCreateOrConnectWithoutVoidedInvoicesInput>;
  create?: InputMaybe<AdminCreateWithoutVoidedInvoicesInput>;
  delete?: InputMaybe<AdminWhereInput>;
  disconnect?: InputMaybe<AdminWhereInput>;
  update?: InputMaybe<AdminUpdateToOneWithWhereWithoutVoidedInvoicesInput>;
  upsert?: InputMaybe<AdminUpsertWithoutVoidedInvoicesInput>;
};

export type AdminUpdateToOneWithWhereWithoutBulkShippingsInput = {
  data: AdminUpdateWithoutBulkShippingsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutCompletedShipmentsInput = {
  data: AdminUpdateWithoutCompletedShipmentsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutCustomOnHoldReasonsAddedInput = {
  data: AdminUpdateWithoutCustomOnHoldReasonsAddedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutCustomOnHoldReasonsResolvedInput = {
  data: AdminUpdateWithoutCustomOnHoldReasonsResolvedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutDigitalServiceProductsInput = {
  data: AdminUpdateWithoutDigitalServiceProductsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutLinePreparationHistoryInput = {
  data: AdminUpdateWithoutLinePreparationHistoryInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutLockedOrdersInput = {
  data: AdminUpdateWithoutLockedOrdersInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutOnHoldIntervalCreatedInput = {
  data: AdminUpdateWithoutOnHoldIntervalCreatedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutOnHoldIntervalResolvedInput = {
  data: AdminUpdateWithoutOnHoldIntervalResolvedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutOnHoldReasonIntervalCreatedInput = {
  data: AdminUpdateWithoutOnHoldReasonIntervalCreatedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutOnHoldReasonIntervalResolvedInput = {
  data: AdminUpdateWithoutOnHoldReasonIntervalResolvedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutPreparedLineItemsInput = {
  data: AdminUpdateWithoutPreparedLineItemsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutPrintBatchesInput = {
  data: AdminUpdateWithoutPrintBatchesInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutProductStockSnapshotsInput = {
  data: AdminUpdateWithoutProductStockSnapshotsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutRefundedLineItemsInput = {
  data: AdminUpdateWithoutRefundedLineItemsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutShipmentBatchesInput = {
  data: AdminUpdateWithoutShipmentBatchesInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutShipmentsInput = {
  data: AdminUpdateWithoutShipmentsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutStripeCreditNotesInput = {
  data: AdminUpdateWithoutStripeCreditNotesInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutTransactionsInput = {
  data: AdminUpdateWithoutTransactionsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateToOneWithWhereWithoutVoidedInvoicesInput = {
  data: AdminUpdateWithoutVoidedInvoicesInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpdateWithWhereUniqueWithoutWarehouseInput = {
  data: AdminUpdateWithoutWarehouseInput;
  where: AdminWhereUniqueInput;
};

export type AdminUpdateWithoutBulkShippingsInput = {
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutCompletedShipmentsInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutCustomOnHoldReasonsAddedInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutCustomOnHoldReasonsResolvedInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutDigitalServiceProductsInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutLinePreparationHistoryInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutLockedOrdersInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutOnHoldIntervalCreatedInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductLabelsVerified?: InputMaybe<UserProductLabelUpdateManyWithoutVerifiedByNestedInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutOnHoldIntervalResolvedInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutOnHoldReasonIntervalCreatedInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductLabelsVerified?: InputMaybe<UserProductLabelUpdateManyWithoutVerifiedByNestedInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutOnHoldReasonIntervalResolvedInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutPreparedLineItemsInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutPrintBatchesInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutProductStockSnapshotsInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutRefundedLineItemsInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutShipmentBatchesInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutShipmentsInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutStripeCreditNotesInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutTransactionsInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutVoidedInvoicesInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutAdminsNestedInput>;
};

export type AdminUpdateWithoutWarehouseInput = {
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutCreatedByNestedInput>;
  completedShipments?: InputMaybe<ShipmentUpdateManyWithoutCompletedByNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductUpdateManyWithoutCreatedByNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput>;
  lockedOrders?: InputMaybe<UserProductOrderUpdateManyWithoutLockedByNestedInput>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  permissions?: InputMaybe<AdminUpdatepermissionsInput>;
  preparedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutPreparedByNestedInput>;
  printBatches?: InputMaybe<PrintBatchUpdateManyWithoutCreatedByNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput>;
  refundedLineItems?: InputMaybe<UserProductOrderLineUpdateManyWithoutRefundedByNestedInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCompletedByNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCreatedByNestedInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutCreatedByNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  voidedInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutVoidedByNestedInput>;
};

export type AdminUpdatepermissionsInput = {
  push?: InputMaybe<Array<AdminPermission>>;
  set?: InputMaybe<Array<AdminPermission>>;
};

export type AdminUpsertWithWhereUniqueWithoutWarehouseInput = {
  create: AdminCreateWithoutWarehouseInput;
  update: AdminUpdateWithoutWarehouseInput;
  where: AdminWhereUniqueInput;
};

export type AdminUpsertWithoutBulkShippingsInput = {
  create: AdminCreateWithoutBulkShippingsInput;
  update: AdminUpdateWithoutBulkShippingsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutCompletedShipmentsInput = {
  create: AdminCreateWithoutCompletedShipmentsInput;
  update: AdminUpdateWithoutCompletedShipmentsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutCustomOnHoldReasonsAddedInput = {
  create: AdminCreateWithoutCustomOnHoldReasonsAddedInput;
  update: AdminUpdateWithoutCustomOnHoldReasonsAddedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutCustomOnHoldReasonsResolvedInput = {
  create: AdminCreateWithoutCustomOnHoldReasonsResolvedInput;
  update: AdminUpdateWithoutCustomOnHoldReasonsResolvedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutDigitalServiceProductsInput = {
  create: AdminCreateWithoutDigitalServiceProductsInput;
  update: AdminUpdateWithoutDigitalServiceProductsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutLinePreparationHistoryInput = {
  create: AdminCreateWithoutLinePreparationHistoryInput;
  update: AdminUpdateWithoutLinePreparationHistoryInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutLockedOrdersInput = {
  create: AdminCreateWithoutLockedOrdersInput;
  update: AdminUpdateWithoutLockedOrdersInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutOnHoldIntervalCreatedInput = {
  create: AdminCreateWithoutOnHoldIntervalCreatedInput;
  update: AdminUpdateWithoutOnHoldIntervalCreatedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutOnHoldIntervalResolvedInput = {
  create: AdminCreateWithoutOnHoldIntervalResolvedInput;
  update: AdminUpdateWithoutOnHoldIntervalResolvedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutOnHoldReasonIntervalCreatedInput = {
  create: AdminCreateWithoutOnHoldReasonIntervalCreatedInput;
  update: AdminUpdateWithoutOnHoldReasonIntervalCreatedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutOnHoldReasonIntervalResolvedInput = {
  create: AdminCreateWithoutOnHoldReasonIntervalResolvedInput;
  update: AdminUpdateWithoutOnHoldReasonIntervalResolvedInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutPreparedLineItemsInput = {
  create: AdminCreateWithoutPreparedLineItemsInput;
  update: AdminUpdateWithoutPreparedLineItemsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutPrintBatchesInput = {
  create: AdminCreateWithoutPrintBatchesInput;
  update: AdminUpdateWithoutPrintBatchesInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutProductStockSnapshotsInput = {
  create: AdminCreateWithoutProductStockSnapshotsInput;
  update: AdminUpdateWithoutProductStockSnapshotsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutRefundedLineItemsInput = {
  create: AdminCreateWithoutRefundedLineItemsInput;
  update: AdminUpdateWithoutRefundedLineItemsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutShipmentBatchesInput = {
  create: AdminCreateWithoutShipmentBatchesInput;
  update: AdminUpdateWithoutShipmentBatchesInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutShipmentsInput = {
  create: AdminCreateWithoutShipmentsInput;
  update: AdminUpdateWithoutShipmentsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutStripeCreditNotesInput = {
  create: AdminCreateWithoutStripeCreditNotesInput;
  update: AdminUpdateWithoutStripeCreditNotesInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutTransactionsInput = {
  create: AdminCreateWithoutTransactionsInput;
  update: AdminUpdateWithoutTransactionsInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminUpsertWithoutVoidedInvoicesInput = {
  create: AdminCreateWithoutVoidedInvoicesInput;
  update: AdminUpdateWithoutVoidedInvoicesInput;
  where?: InputMaybe<AdminWhereInput>;
};

export type AdminWhereInput = {
  AND?: InputMaybe<Array<AdminWhereInput>>;
  NOT?: InputMaybe<Array<AdminWhereInput>>;
  OR?: InputMaybe<Array<AdminWhereInput>>;
  bulkShippings?: InputMaybe<BulkShippingListRelationFilter>;
  completedShipments?: InputMaybe<ShipmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonListRelationFilter>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonListRelationFilter>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductListRelationFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  lastName?: InputMaybe<StringFilter>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryListRelationFilter>;
  lockedOrders?: InputMaybe<UserProductOrderListRelationFilter>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalListRelationFilter>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalListRelationFilter>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalListRelationFilter>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalListRelationFilter>;
  password?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<EnumAdminPermissionNullableListFilter>;
  preparedLineItems?: InputMaybe<UserProductOrderLineListRelationFilter>;
  printBatches?: InputMaybe<PrintBatchListRelationFilter>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotListRelationFilter>;
  refundedLineItems?: InputMaybe<UserProductOrderLineListRelationFilter>;
  shipmentBatches?: InputMaybe<ShipmentBatchListRelationFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteListRelationFilter>;
  transactions?: InputMaybe<UserCreditsTransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  voidedInvoices?: InputMaybe<StripeInvoiceListRelationFilter>;
  warehouse?: InputMaybe<WarehouseNullableRelationFilter>;
  warehouseId?: InputMaybe<UuidNullableFilter>;
};

export type AdminWhereUniqueInput = {
  AND?: InputMaybe<Array<AdminWhereInput>>;
  NOT?: InputMaybe<Array<AdminWhereInput>>;
  OR?: InputMaybe<Array<AdminWhereInput>>;
  bulkShippings?: InputMaybe<BulkShippingListRelationFilter>;
  completedShipments?: InputMaybe<ShipmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customOnHoldReasonsAdded?: InputMaybe<CustomOnHoldReasonListRelationFilter>;
  customOnHoldReasonsResolved?: InputMaybe<CustomOnHoldReasonListRelationFilter>;
  digitalServiceProducts?: InputMaybe<DigitalServiceProductListRelationFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<BoolFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  lastName?: InputMaybe<StringFilter>;
  linePreparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryListRelationFilter>;
  lockedOrders?: InputMaybe<UserProductOrderListRelationFilter>;
  onHoldIntervalCreated?: InputMaybe<UserProductOrderHoldStatusIntervalListRelationFilter>;
  onHoldIntervalResolved?: InputMaybe<UserProductOrderHoldStatusIntervalListRelationFilter>;
  onHoldReasonIntervalCreated?: InputMaybe<UserProductOrderOnHoldReasonIntervalListRelationFilter>;
  onHoldReasonIntervalResolved?: InputMaybe<UserProductOrderOnHoldReasonIntervalListRelationFilter>;
  password?: InputMaybe<StringFilter>;
  permissions?: InputMaybe<EnumAdminPermissionNullableListFilter>;
  preparedLineItems?: InputMaybe<UserProductOrderLineListRelationFilter>;
  printBatches?: InputMaybe<PrintBatchListRelationFilter>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotListRelationFilter>;
  refundedLineItems?: InputMaybe<UserProductOrderLineListRelationFilter>;
  shipmentBatches?: InputMaybe<ShipmentBatchListRelationFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteListRelationFilter>;
  transactions?: InputMaybe<UserCreditsTransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  voidedInvoices?: InputMaybe<StripeInvoiceListRelationFilter>;
  warehouse?: InputMaybe<WarehouseNullableRelationFilter>;
  warehouseId?: InputMaybe<UuidNullableFilter>;
};

export type BasicUserModel = {
  __typename?: 'BasicUserModel';
  count?: Maybe<Scalars['Float']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type BigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']['input']>;
  divide?: InputMaybe<Scalars['BigInt']['input']>;
  increment?: InputMaybe<Scalars['BigInt']['input']>;
  multiply?: InputMaybe<Scalars['BigInt']['input']>;
  set?: InputMaybe<Scalars['BigInt']['input']>;
};

export type BigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BinsAssignedToOrderResponse = {
  __typename?: 'BinsAssignedToOrderResponse';
  returned: Array<WarehouseShelfReturnBin>;
  sorting: Array<WarehouseShelfBin>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BulkDueDateUpdateInput = {
  bulkPostPaymentDueDateDays: Scalars['Int']['input'];
  bulkPostPaymentDueDateDaysType: UserPostPaymentDueDateDaysType;
};

export type BulkShippingCount = {
  __typename?: 'BulkShippingCount';
  shipments: Scalars['Int']['output'];
};


export type BulkShippingCountShipmentsArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};

export type BulkShippingCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  warehouseId: Scalars['String']['input'];
};

export type BulkShippingCreateManyCreatedByInputEnvelope = {
  data: Array<BulkShippingCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkShippingCreateManyWarehouseInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkShippingCreateManyWarehouseInputEnvelope = {
  data: Array<BulkShippingCreateManyWarehouseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkShippingCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<BulkShippingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BulkShippingCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<BulkShippingCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<BulkShippingCreateManyCreatedByInputEnvelope>;
};

export type BulkShippingCreateNestedManyWithoutWarehouseInput = {
  connect?: InputMaybe<Array<BulkShippingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BulkShippingCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<BulkShippingCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<BulkShippingCreateManyWarehouseInputEnvelope>;
};

export type BulkShippingCreateNestedOneWithoutShipmentsInput = {
  connect?: InputMaybe<BulkShippingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BulkShippingCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<BulkShippingCreateWithoutShipmentsInput>;
};

export type BulkShippingCreateOrConnectWithoutCreatedByInput = {
  create: BulkShippingCreateWithoutCreatedByInput;
  where: BulkShippingWhereUniqueInput;
};

export type BulkShippingCreateOrConnectWithoutShipmentsInput = {
  create: BulkShippingCreateWithoutShipmentsInput;
  where: BulkShippingWhereUniqueInput;
};

export type BulkShippingCreateOrConnectWithoutWarehouseInput = {
  create: BulkShippingCreateWithoutWarehouseInput;
  where: BulkShippingWhereUniqueInput;
};

export type BulkShippingCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutBulkShippingInput>;
  warehouse: WarehouseCreateNestedOneWithoutBulkShippingsInput;
};

export type BulkShippingCreateWithoutShipmentsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutBulkShippingsInput;
  warehouse: WarehouseCreateNestedOneWithoutBulkShippingsInput;
};

export type BulkShippingCreateWithoutWarehouseInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutBulkShippingsInput;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutBulkShippingInput>;
};

export type BulkShippingListRelationFilter = {
  every?: InputMaybe<BulkShippingWhereInput>;
  none?: InputMaybe<BulkShippingWhereInput>;
  some?: InputMaybe<BulkShippingWhereInput>;
};

export type BulkShippingNullableRelationFilter = {
  is?: InputMaybe<BulkShippingWhereInput>;
  isNot?: InputMaybe<BulkShippingWhereInput>;
};

export type BulkShippingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BulkShippingOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<AdminOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  shipments?: InputMaybe<ShipmentOrderByRelationAggregateInput>;
  warehouse?: InputMaybe<WarehouseOrderByWithRelationInput>;
  warehouseId?: InputMaybe<SortOrder>;
};

export type BulkShippingScalarWhereInput = {
  AND?: InputMaybe<Array<BulkShippingScalarWhereInput>>;
  NOT?: InputMaybe<Array<BulkShippingScalarWhereInput>>;
  OR?: InputMaybe<Array<BulkShippingScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<UuidFilter>;
  id?: InputMaybe<IntFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type BulkShippingSuggestion = {
  __typename?: 'BulkShippingSuggestion';
  carrier: Carrier;
  id: Scalars['ID']['output'];
  orders: Array<OrderToShip>;
  serviceLevel: Scalars['String']['output'];
  user: User;
  userProducts: Array<ProductToShip>;
};

export type BulkShippingUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BulkShippingUpdateManyWithWhereWithoutCreatedByInput = {
  data: BulkShippingUpdateManyMutationInput;
  where: BulkShippingScalarWhereInput;
};

export type BulkShippingUpdateManyWithWhereWithoutWarehouseInput = {
  data: BulkShippingUpdateManyMutationInput;
  where: BulkShippingScalarWhereInput;
};

export type BulkShippingUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<BulkShippingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BulkShippingCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<BulkShippingCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<BulkShippingCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<BulkShippingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BulkShippingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BulkShippingWhereUniqueInput>>;
  set?: InputMaybe<Array<BulkShippingWhereUniqueInput>>;
  update?: InputMaybe<Array<BulkShippingUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<BulkShippingUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<BulkShippingUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type BulkShippingUpdateManyWithoutWarehouseNestedInput = {
  connect?: InputMaybe<Array<BulkShippingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BulkShippingCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<BulkShippingCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<BulkShippingCreateManyWarehouseInputEnvelope>;
  delete?: InputMaybe<Array<BulkShippingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BulkShippingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BulkShippingWhereUniqueInput>>;
  set?: InputMaybe<Array<BulkShippingWhereUniqueInput>>;
  update?: InputMaybe<Array<BulkShippingUpdateWithWhereUniqueWithoutWarehouseInput>>;
  updateMany?: InputMaybe<Array<BulkShippingUpdateManyWithWhereWithoutWarehouseInput>>;
  upsert?: InputMaybe<Array<BulkShippingUpsertWithWhereUniqueWithoutWarehouseInput>>;
};

export type BulkShippingUpdateOneWithoutShipmentsNestedInput = {
  connect?: InputMaybe<BulkShippingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BulkShippingCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<BulkShippingCreateWithoutShipmentsInput>;
  delete?: InputMaybe<BulkShippingWhereInput>;
  disconnect?: InputMaybe<BulkShippingWhereInput>;
  update?: InputMaybe<BulkShippingUpdateToOneWithWhereWithoutShipmentsInput>;
  upsert?: InputMaybe<BulkShippingUpsertWithoutShipmentsInput>;
};

export type BulkShippingUpdateToOneWithWhereWithoutShipmentsInput = {
  data: BulkShippingUpdateWithoutShipmentsInput;
  where?: InputMaybe<BulkShippingWhereInput>;
};

export type BulkShippingUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: BulkShippingUpdateWithoutCreatedByInput;
  where: BulkShippingWhereUniqueInput;
};

export type BulkShippingUpdateWithWhereUniqueWithoutWarehouseInput = {
  data: BulkShippingUpdateWithoutWarehouseInput;
  where: BulkShippingWhereUniqueInput;
};

export type BulkShippingUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutBulkShippingNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutBulkShippingsNestedInput>;
};

export type BulkShippingUpdateWithoutShipmentsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutBulkShippingsNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutBulkShippingsNestedInput>;
};

export type BulkShippingUpdateWithoutWarehouseInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutBulkShippingsNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutBulkShippingNestedInput>;
};

export type BulkShippingUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: BulkShippingCreateWithoutCreatedByInput;
  update: BulkShippingUpdateWithoutCreatedByInput;
  where: BulkShippingWhereUniqueInput;
};

export type BulkShippingUpsertWithWhereUniqueWithoutWarehouseInput = {
  create: BulkShippingCreateWithoutWarehouseInput;
  update: BulkShippingUpdateWithoutWarehouseInput;
  where: BulkShippingWhereUniqueInput;
};

export type BulkShippingUpsertWithoutShipmentsInput = {
  create: BulkShippingCreateWithoutShipmentsInput;
  update: BulkShippingUpdateWithoutShipmentsInput;
  where?: InputMaybe<BulkShippingWhereInput>;
};

export type BulkShippingWhereInput = {
  AND?: InputMaybe<Array<BulkShippingWhereInput>>;
  NOT?: InputMaybe<Array<BulkShippingWhereInput>>;
  OR?: InputMaybe<Array<BulkShippingWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminRelationFilter>;
  createdById?: InputMaybe<UuidFilter>;
  id?: InputMaybe<IntFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  warehouse?: InputMaybe<WarehouseRelationFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type BulkShippingWhereUniqueInput = {
  AND?: InputMaybe<Array<BulkShippingWhereInput>>;
  NOT?: InputMaybe<Array<BulkShippingWhereInput>>;
  OR?: InputMaybe<Array<BulkShippingWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminRelationFilter>;
  createdById?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  warehouse?: InputMaybe<WarehouseRelationFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type Carrier = {
  __typename?: 'Carrier';
  _count?: Maybe<CarrierCount>;
  defaultShippingPackageId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  manifestAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pickupAvailable: Scalars['Boolean']['output'];
  readable: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  warehouseId: Scalars['String']['output'];
};

export type CarrierCount = {
  __typename?: 'CarrierCount';
  defaultCarrierForWarehouses: Scalars['Int']['output'];
  defaultExpressCarrierForWarehouses: Scalars['Int']['output'];
  defaultInternationalCarrierForWarehouses: Scalars['Int']['output'];
  shipmentBatches: Scalars['Int']['output'];
  shipments: Scalars['Int']['output'];
  shippingPackages: Scalars['Int']['output'];
};


export type CarrierCountDefaultCarrierForWarehousesArgs = {
  where?: InputMaybe<WarehouseWhereInput>;
};


export type CarrierCountDefaultExpressCarrierForWarehousesArgs = {
  where?: InputMaybe<WarehouseWhereInput>;
};


export type CarrierCountDefaultInternationalCarrierForWarehousesArgs = {
  where?: InputMaybe<WarehouseWhereInput>;
};


export type CarrierCountShipmentBatchesArgs = {
  where?: InputMaybe<ShipmentBatchWhereInput>;
};


export type CarrierCountShipmentsArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};


export type CarrierCountShippingPackagesArgs = {
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type CarrierCreateManyDefaultShippingPackageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  manifestAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  readable: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
};

export type CarrierCreateManyDefaultShippingPackageInputEnvelope = {
  data: Array<CarrierCreateManyDefaultShippingPackageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CarrierCreateManyWarehouseInput = {
  defaultShippingPackageId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  manifestAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  readable: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CarrierCreateManyWarehouseInputEnvelope = {
  data: Array<CarrierCreateManyWarehouseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CarrierCreateNestedManyWithoutDefaultShippingPackageInput = {
  connect?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CarrierCreateOrConnectWithoutDefaultShippingPackageInput>>;
  create?: InputMaybe<Array<CarrierCreateWithoutDefaultShippingPackageInput>>;
  createMany?: InputMaybe<CarrierCreateManyDefaultShippingPackageInputEnvelope>;
};

export type CarrierCreateNestedManyWithoutShippingPackagesInput = {
  connect?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CarrierCreateOrConnectWithoutShippingPackagesInput>>;
  create?: InputMaybe<Array<CarrierCreateWithoutShippingPackagesInput>>;
};

export type CarrierCreateNestedManyWithoutWarehouseInput = {
  connect?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CarrierCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<CarrierCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<CarrierCreateManyWarehouseInputEnvelope>;
};

export type CarrierCreateNestedOneWithoutDefaultCarrierForWarehousesInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutDefaultCarrierForWarehousesInput>;
  create?: InputMaybe<CarrierCreateWithoutDefaultCarrierForWarehousesInput>;
};

export type CarrierCreateNestedOneWithoutDefaultExpressCarrierForWarehousesInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutDefaultExpressCarrierForWarehousesInput>;
  create?: InputMaybe<CarrierCreateWithoutDefaultExpressCarrierForWarehousesInput>;
};

export type CarrierCreateNestedOneWithoutDefaultInternationalCarrierForWarehousesInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutDefaultInternationalCarrierForWarehousesInput>;
  create?: InputMaybe<CarrierCreateWithoutDefaultInternationalCarrierForWarehousesInput>;
};

export type CarrierCreateNestedOneWithoutShipmentBatchesInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutShipmentBatchesInput>;
  create?: InputMaybe<CarrierCreateWithoutShipmentBatchesInput>;
};

export type CarrierCreateNestedOneWithoutShipmentsInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<CarrierCreateWithoutShipmentsInput>;
};

export type CarrierCreateOrConnectWithoutDefaultCarrierForWarehousesInput = {
  create: CarrierCreateWithoutDefaultCarrierForWarehousesInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateOrConnectWithoutDefaultExpressCarrierForWarehousesInput = {
  create: CarrierCreateWithoutDefaultExpressCarrierForWarehousesInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateOrConnectWithoutDefaultInternationalCarrierForWarehousesInput = {
  create: CarrierCreateWithoutDefaultInternationalCarrierForWarehousesInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateOrConnectWithoutDefaultShippingPackageInput = {
  create: CarrierCreateWithoutDefaultShippingPackageInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateOrConnectWithoutShipmentBatchesInput = {
  create: CarrierCreateWithoutShipmentBatchesInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateOrConnectWithoutShipmentsInput = {
  create: CarrierCreateWithoutShipmentsInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateOrConnectWithoutShippingPackagesInput = {
  create: CarrierCreateWithoutShippingPackagesInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateOrConnectWithoutWarehouseInput = {
  create: CarrierCreateWithoutWarehouseInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierCreateWithoutDefaultCarrierForWarehousesInput = {
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultExpressCarrierInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultInternationalCarrierInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageCarriersInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  manifestAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  readable: Scalars['String']['input'];
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCarrierInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCarrierInput>;
  shippingPackages?: InputMaybe<ShippingPackageCreateNestedManyWithoutCarriersInput>;
  slug: Scalars['String']['input'];
  warehouse: WarehouseCreateNestedOneWithoutCarriersInput;
};

export type CarrierCreateWithoutDefaultExpressCarrierForWarehousesInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultCarrierInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultInternationalCarrierInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageCarriersInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  manifestAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  readable: Scalars['String']['input'];
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCarrierInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCarrierInput>;
  shippingPackages?: InputMaybe<ShippingPackageCreateNestedManyWithoutCarriersInput>;
  slug: Scalars['String']['input'];
  warehouse: WarehouseCreateNestedOneWithoutCarriersInput;
};

export type CarrierCreateWithoutDefaultInternationalCarrierForWarehousesInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultCarrierInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultExpressCarrierInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageCarriersInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  manifestAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  readable: Scalars['String']['input'];
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCarrierInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCarrierInput>;
  shippingPackages?: InputMaybe<ShippingPackageCreateNestedManyWithoutCarriersInput>;
  slug: Scalars['String']['input'];
  warehouse: WarehouseCreateNestedOneWithoutCarriersInput;
};

export type CarrierCreateWithoutDefaultShippingPackageInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultCarrierInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultExpressCarrierInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultInternationalCarrierInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  manifestAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  readable: Scalars['String']['input'];
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCarrierInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCarrierInput>;
  shippingPackages?: InputMaybe<ShippingPackageCreateNestedManyWithoutCarriersInput>;
  slug: Scalars['String']['input'];
  warehouse: WarehouseCreateNestedOneWithoutCarriersInput;
};

export type CarrierCreateWithoutShipmentBatchesInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultCarrierInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultExpressCarrierInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultInternationalCarrierInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageCarriersInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  manifestAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  readable: Scalars['String']['input'];
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCarrierInput>;
  shippingPackages?: InputMaybe<ShippingPackageCreateNestedManyWithoutCarriersInput>;
  slug: Scalars['String']['input'];
  warehouse: WarehouseCreateNestedOneWithoutCarriersInput;
};

export type CarrierCreateWithoutShipmentsInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultCarrierInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultExpressCarrierInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultInternationalCarrierInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageCarriersInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  manifestAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  readable: Scalars['String']['input'];
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCarrierInput>;
  shippingPackages?: InputMaybe<ShippingPackageCreateNestedManyWithoutCarriersInput>;
  slug: Scalars['String']['input'];
  warehouse: WarehouseCreateNestedOneWithoutCarriersInput;
};

export type CarrierCreateWithoutShippingPackagesInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultCarrierInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultExpressCarrierInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultInternationalCarrierInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageCarriersInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  manifestAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  readable: Scalars['String']['input'];
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCarrierInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCarrierInput>;
  slug: Scalars['String']['input'];
  warehouse: WarehouseCreateNestedOneWithoutCarriersInput;
};

export type CarrierCreateWithoutWarehouseInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultCarrierInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultExpressCarrierInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseCreateNestedManyWithoutDefaultInternationalCarrierInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageCarriersInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  manifestAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickupAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  readable: Scalars['String']['input'];
  shipmentBatches?: InputMaybe<ShipmentBatchCreateNestedManyWithoutCarrierInput>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutCarrierInput>;
  shippingPackages?: InputMaybe<ShippingPackageCreateNestedManyWithoutCarriersInput>;
  slug: Scalars['String']['input'];
};

export type CarrierListRelationFilter = {
  every?: InputMaybe<CarrierWhereInput>;
  none?: InputMaybe<CarrierWhereInput>;
  some?: InputMaybe<CarrierWhereInput>;
};

export type CarrierNullableRelationFilter = {
  is?: InputMaybe<CarrierWhereInput>;
  isNot?: InputMaybe<CarrierWhereInput>;
};

export type CarrierOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CarrierOrderByWithRelationInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseOrderByRelationAggregateInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseOrderByRelationAggregateInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseOrderByRelationAggregateInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageOrderByWithRelationInput>;
  defaultShippingPackageId?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDisabled?: InputMaybe<SortOrder>;
  logo?: InputMaybe<SortOrderInput>;
  manifestAvailable?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pickupAvailable?: InputMaybe<SortOrder>;
  readable?: InputMaybe<SortOrder>;
  shipmentBatches?: InputMaybe<ShipmentBatchOrderByRelationAggregateInput>;
  shipments?: InputMaybe<ShipmentOrderByRelationAggregateInput>;
  shippingPackages?: InputMaybe<ShippingPackageOrderByRelationAggregateInput>;
  slug?: InputMaybe<SortOrder>;
  warehouse?: InputMaybe<WarehouseOrderByWithRelationInput>;
  warehouseId?: InputMaybe<SortOrder>;
};

export type CarrierRelationFilter = {
  is?: InputMaybe<CarrierWhereInput>;
  isNot?: InputMaybe<CarrierWhereInput>;
};

export type CarrierScalarWhereInput = {
  AND?: InputMaybe<Array<CarrierScalarWhereInput>>;
  NOT?: InputMaybe<Array<CarrierScalarWhereInput>>;
  OR?: InputMaybe<Array<CarrierScalarWhereInput>>;
  defaultShippingPackageId?: InputMaybe<UuidNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  logo?: InputMaybe<StringNullableFilter>;
  manifestAvailable?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  pickupAvailable?: InputMaybe<BoolFilter>;
  readable?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type CarrierUpdateManyMutationInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manifestAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readable?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CarrierUpdateManyWithWhereWithoutDefaultShippingPackageInput = {
  data: CarrierUpdateManyMutationInput;
  where: CarrierScalarWhereInput;
};

export type CarrierUpdateManyWithWhereWithoutShippingPackagesInput = {
  data: CarrierUpdateManyMutationInput;
  where: CarrierScalarWhereInput;
};

export type CarrierUpdateManyWithWhereWithoutWarehouseInput = {
  data: CarrierUpdateManyMutationInput;
  where: CarrierScalarWhereInput;
};

export type CarrierUpdateManyWithoutDefaultShippingPackageNestedInput = {
  connect?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CarrierCreateOrConnectWithoutDefaultShippingPackageInput>>;
  create?: InputMaybe<Array<CarrierCreateWithoutDefaultShippingPackageInput>>;
  createMany?: InputMaybe<CarrierCreateManyDefaultShippingPackageInputEnvelope>;
  delete?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CarrierScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  set?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  update?: InputMaybe<Array<CarrierUpdateWithWhereUniqueWithoutDefaultShippingPackageInput>>;
  updateMany?: InputMaybe<Array<CarrierUpdateManyWithWhereWithoutDefaultShippingPackageInput>>;
  upsert?: InputMaybe<Array<CarrierUpsertWithWhereUniqueWithoutDefaultShippingPackageInput>>;
};

export type CarrierUpdateManyWithoutShippingPackagesNestedInput = {
  connect?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CarrierCreateOrConnectWithoutShippingPackagesInput>>;
  create?: InputMaybe<Array<CarrierCreateWithoutShippingPackagesInput>>;
  delete?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CarrierScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  set?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  update?: InputMaybe<Array<CarrierUpdateWithWhereUniqueWithoutShippingPackagesInput>>;
  updateMany?: InputMaybe<Array<CarrierUpdateManyWithWhereWithoutShippingPackagesInput>>;
  upsert?: InputMaybe<Array<CarrierUpsertWithWhereUniqueWithoutShippingPackagesInput>>;
};

export type CarrierUpdateManyWithoutWarehouseNestedInput = {
  connect?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CarrierCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<CarrierCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<CarrierCreateManyWarehouseInputEnvelope>;
  delete?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CarrierScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  set?: InputMaybe<Array<CarrierWhereUniqueInput>>;
  update?: InputMaybe<Array<CarrierUpdateWithWhereUniqueWithoutWarehouseInput>>;
  updateMany?: InputMaybe<Array<CarrierUpdateManyWithWhereWithoutWarehouseInput>>;
  upsert?: InputMaybe<Array<CarrierUpsertWithWhereUniqueWithoutWarehouseInput>>;
};

export type CarrierUpdateOneRequiredWithoutShipmentBatchesNestedInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutShipmentBatchesInput>;
  create?: InputMaybe<CarrierCreateWithoutShipmentBatchesInput>;
  update?: InputMaybe<CarrierUpdateToOneWithWhereWithoutShipmentBatchesInput>;
  upsert?: InputMaybe<CarrierUpsertWithoutShipmentBatchesInput>;
};

export type CarrierUpdateOneWithoutDefaultCarrierForWarehousesNestedInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutDefaultCarrierForWarehousesInput>;
  create?: InputMaybe<CarrierCreateWithoutDefaultCarrierForWarehousesInput>;
  delete?: InputMaybe<CarrierWhereInput>;
  disconnect?: InputMaybe<CarrierWhereInput>;
  update?: InputMaybe<CarrierUpdateToOneWithWhereWithoutDefaultCarrierForWarehousesInput>;
  upsert?: InputMaybe<CarrierUpsertWithoutDefaultCarrierForWarehousesInput>;
};

export type CarrierUpdateOneWithoutDefaultExpressCarrierForWarehousesNestedInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutDefaultExpressCarrierForWarehousesInput>;
  create?: InputMaybe<CarrierCreateWithoutDefaultExpressCarrierForWarehousesInput>;
  delete?: InputMaybe<CarrierWhereInput>;
  disconnect?: InputMaybe<CarrierWhereInput>;
  update?: InputMaybe<CarrierUpdateToOneWithWhereWithoutDefaultExpressCarrierForWarehousesInput>;
  upsert?: InputMaybe<CarrierUpsertWithoutDefaultExpressCarrierForWarehousesInput>;
};

export type CarrierUpdateOneWithoutDefaultInternationalCarrierForWarehousesNestedInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutDefaultInternationalCarrierForWarehousesInput>;
  create?: InputMaybe<CarrierCreateWithoutDefaultInternationalCarrierForWarehousesInput>;
  delete?: InputMaybe<CarrierWhereInput>;
  disconnect?: InputMaybe<CarrierWhereInput>;
  update?: InputMaybe<CarrierUpdateToOneWithWhereWithoutDefaultInternationalCarrierForWarehousesInput>;
  upsert?: InputMaybe<CarrierUpsertWithoutDefaultInternationalCarrierForWarehousesInput>;
};

export type CarrierUpdateOneWithoutShipmentsNestedInput = {
  connect?: InputMaybe<CarrierWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CarrierCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<CarrierCreateWithoutShipmentsInput>;
  delete?: InputMaybe<CarrierWhereInput>;
  disconnect?: InputMaybe<CarrierWhereInput>;
  update?: InputMaybe<CarrierUpdateToOneWithWhereWithoutShipmentsInput>;
  upsert?: InputMaybe<CarrierUpsertWithoutShipmentsInput>;
};

export type CarrierUpdateToOneWithWhereWithoutDefaultCarrierForWarehousesInput = {
  data: CarrierUpdateWithoutDefaultCarrierForWarehousesInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpdateToOneWithWhereWithoutDefaultExpressCarrierForWarehousesInput = {
  data: CarrierUpdateWithoutDefaultExpressCarrierForWarehousesInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpdateToOneWithWhereWithoutDefaultInternationalCarrierForWarehousesInput = {
  data: CarrierUpdateWithoutDefaultInternationalCarrierForWarehousesInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpdateToOneWithWhereWithoutShipmentBatchesInput = {
  data: CarrierUpdateWithoutShipmentBatchesInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpdateToOneWithWhereWithoutShipmentsInput = {
  data: CarrierUpdateWithoutShipmentsInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpdateWithWhereUniqueWithoutDefaultShippingPackageInput = {
  data: CarrierUpdateWithoutDefaultShippingPackageInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierUpdateWithWhereUniqueWithoutShippingPackagesInput = {
  data: CarrierUpdateWithoutShippingPackagesInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierUpdateWithWhereUniqueWithoutWarehouseInput = {
  data: CarrierUpdateWithoutWarehouseInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierUpdateWithoutDefaultCarrierForWarehousesInput = {
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultExpressCarrierNestedInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultInternationalCarrierNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageCarriersNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manifestAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readable?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCarrierNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCarrierNestedInput>;
  shippingPackages?: InputMaybe<ShippingPackageUpdateManyWithoutCarriersNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutCarriersNestedInput>;
};

export type CarrierUpdateWithoutDefaultExpressCarrierForWarehousesInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultCarrierNestedInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultInternationalCarrierNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageCarriersNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manifestAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readable?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCarrierNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCarrierNestedInput>;
  shippingPackages?: InputMaybe<ShippingPackageUpdateManyWithoutCarriersNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutCarriersNestedInput>;
};

export type CarrierUpdateWithoutDefaultInternationalCarrierForWarehousesInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultCarrierNestedInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultExpressCarrierNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageCarriersNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manifestAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readable?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCarrierNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCarrierNestedInput>;
  shippingPackages?: InputMaybe<ShippingPackageUpdateManyWithoutCarriersNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutCarriersNestedInput>;
};

export type CarrierUpdateWithoutDefaultShippingPackageInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultCarrierNestedInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultExpressCarrierNestedInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultInternationalCarrierNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manifestAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readable?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCarrierNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCarrierNestedInput>;
  shippingPackages?: InputMaybe<ShippingPackageUpdateManyWithoutCarriersNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutCarriersNestedInput>;
};

export type CarrierUpdateWithoutShipmentBatchesInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultCarrierNestedInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultExpressCarrierNestedInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultInternationalCarrierNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageCarriersNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manifestAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readable?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCarrierNestedInput>;
  shippingPackages?: InputMaybe<ShippingPackageUpdateManyWithoutCarriersNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutCarriersNestedInput>;
};

export type CarrierUpdateWithoutShipmentsInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultCarrierNestedInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultExpressCarrierNestedInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultInternationalCarrierNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageCarriersNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manifestAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readable?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCarrierNestedInput>;
  shippingPackages?: InputMaybe<ShippingPackageUpdateManyWithoutCarriersNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutCarriersNestedInput>;
};

export type CarrierUpdateWithoutShippingPackagesInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultCarrierNestedInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultExpressCarrierNestedInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultInternationalCarrierNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageCarriersNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manifestAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readable?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCarrierNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCarrierNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutCarriersNestedInput>;
};

export type CarrierUpdateWithoutWarehouseInput = {
  defaultCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultCarrierNestedInput>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultExpressCarrierNestedInput>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseUpdateManyWithoutDefaultInternationalCarrierNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageCarriersNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  logo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  manifestAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readable?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipmentBatches?: InputMaybe<ShipmentBatchUpdateManyWithoutCarrierNestedInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutCarrierNestedInput>;
  shippingPackages?: InputMaybe<ShippingPackageUpdateManyWithoutCarriersNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CarrierUpsertWithWhereUniqueWithoutDefaultShippingPackageInput = {
  create: CarrierCreateWithoutDefaultShippingPackageInput;
  update: CarrierUpdateWithoutDefaultShippingPackageInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierUpsertWithWhereUniqueWithoutShippingPackagesInput = {
  create: CarrierCreateWithoutShippingPackagesInput;
  update: CarrierUpdateWithoutShippingPackagesInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierUpsertWithWhereUniqueWithoutWarehouseInput = {
  create: CarrierCreateWithoutWarehouseInput;
  update: CarrierUpdateWithoutWarehouseInput;
  where: CarrierWhereUniqueInput;
};

export type CarrierUpsertWithoutDefaultCarrierForWarehousesInput = {
  create: CarrierCreateWithoutDefaultCarrierForWarehousesInput;
  update: CarrierUpdateWithoutDefaultCarrierForWarehousesInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpsertWithoutDefaultExpressCarrierForWarehousesInput = {
  create: CarrierCreateWithoutDefaultExpressCarrierForWarehousesInput;
  update: CarrierUpdateWithoutDefaultExpressCarrierForWarehousesInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpsertWithoutDefaultInternationalCarrierForWarehousesInput = {
  create: CarrierCreateWithoutDefaultInternationalCarrierForWarehousesInput;
  update: CarrierUpdateWithoutDefaultInternationalCarrierForWarehousesInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpsertWithoutShipmentBatchesInput = {
  create: CarrierCreateWithoutShipmentBatchesInput;
  update: CarrierUpdateWithoutShipmentBatchesInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierUpsertWithoutShipmentsInput = {
  create: CarrierCreateWithoutShipmentsInput;
  update: CarrierUpdateWithoutShipmentsInput;
  where?: InputMaybe<CarrierWhereInput>;
};

export type CarrierWhereInput = {
  AND?: InputMaybe<Array<CarrierWhereInput>>;
  NOT?: InputMaybe<Array<CarrierWhereInput>>;
  OR?: InputMaybe<Array<CarrierWhereInput>>;
  defaultCarrierForWarehouses?: InputMaybe<WarehouseListRelationFilter>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseListRelationFilter>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseListRelationFilter>;
  defaultShippingPackage?: InputMaybe<ShippingPackageNullableRelationFilter>;
  defaultShippingPackageId?: InputMaybe<UuidNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  logo?: InputMaybe<StringNullableFilter>;
  manifestAvailable?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  pickupAvailable?: InputMaybe<BoolFilter>;
  readable?: InputMaybe<StringFilter>;
  shipmentBatches?: InputMaybe<ShipmentBatchListRelationFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  shippingPackages?: InputMaybe<ShippingPackageListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  warehouse?: InputMaybe<WarehouseRelationFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type CarrierWhereUniqueInput = {
  AND?: InputMaybe<Array<CarrierWhereInput>>;
  NOT?: InputMaybe<Array<CarrierWhereInput>>;
  OR?: InputMaybe<Array<CarrierWhereInput>>;
  defaultCarrierForWarehouses?: InputMaybe<WarehouseListRelationFilter>;
  defaultExpressCarrierForWarehouses?: InputMaybe<WarehouseListRelationFilter>;
  defaultInternationalCarrierForWarehouses?: InputMaybe<WarehouseListRelationFilter>;
  defaultShippingPackage?: InputMaybe<ShippingPackageNullableRelationFilter>;
  defaultShippingPackageId?: InputMaybe<UuidNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<BoolFilter>;
  logo?: InputMaybe<StringNullableFilter>;
  manifestAvailable?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  pickupAvailable?: InputMaybe<BoolFilter>;
  readable?: InputMaybe<StringFilter>;
  shipmentBatches?: InputMaybe<ShipmentBatchListRelationFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  shippingPackages?: InputMaybe<ShippingPackageListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  warehouse?: InputMaybe<WarehouseRelationFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type CatalogBanner = {
  __typename?: 'CatalogBanner';
  bannerImage?: Maybe<Scalars['String']['output']>;
  bannerImageSmall?: Maybe<Scalars['String']['output']>;
  bannerImageSmallUrl?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  bannerVideo?: Maybe<Scalars['String']['output']>;
  bannerVideoUrl?: Maybe<Scalars['String']['output']>;
  collectionId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pageImage?: Maybe<Scalars['String']['output']>;
  pageImageSmall?: Maybe<Scalars['String']['output']>;
  pageImageSmallUrl?: Maybe<Scalars['String']['output']>;
  pageImageUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  timerDeadline?: Maybe<Scalars['DateTime']['output']>;
  timerLabel?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

export type CatalogBannerCollection = {
  __typename?: 'CatalogBannerCollection';
  _count?: Maybe<CatalogBannerCollectionCount>;
  banners: Array<CatalogBanner>;
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};


export type CatalogBannerCollectionBannersArgs = {
  cursor?: InputMaybe<CatalogBannerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CatalogBannerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CatalogBannerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CatalogBannerWhereInput>;
};

export type CatalogBannerCollectionCount = {
  __typename?: 'CatalogBannerCollectionCount';
  banners: Scalars['Int']['output'];
};


export type CatalogBannerCollectionCountBannersArgs = {
  where?: InputMaybe<CatalogBannerWhereInput>;
};

export type CatalogBannerCollectionCreateInput = {
  banners?: InputMaybe<CatalogBannerCreateNestedManyWithoutCollectionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  kind: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogBannerCollectionCreateNestedOneWithoutBannersInput = {
  connect?: InputMaybe<CatalogBannerCollectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CatalogBannerCollectionCreateOrConnectWithoutBannersInput>;
  create?: InputMaybe<CatalogBannerCollectionCreateWithoutBannersInput>;
};

export type CatalogBannerCollectionCreateOrConnectWithoutBannersInput = {
  create: CatalogBannerCollectionCreateWithoutBannersInput;
  where: CatalogBannerCollectionWhereUniqueInput;
};

export type CatalogBannerCollectionCreateWithoutBannersInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  kind: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogBannerCollectionOrderByWithRelationInput = {
  banners?: InputMaybe<CatalogBannerOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isDisabled?: InputMaybe<SortOrder>;
  kind?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrderInput>;
};

export type CatalogBannerCollectionRelationFilter = {
  is?: InputMaybe<CatalogBannerCollectionWhereInput>;
  isNot?: InputMaybe<CatalogBannerCollectionWhereInput>;
};

export enum CatalogBannerCollectionScalarFieldEnum {
  Id = 'id',
  IsDisabled = 'isDisabled',
  Kind = 'kind',
  Name = 'name'
}

export type CatalogBannerCollectionUpdateInput = {
  banners?: InputMaybe<CatalogBannerUpdateManyWithoutCollectionNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kind?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CatalogBannerCollectionUpdateOneRequiredWithoutBannersNestedInput = {
  connect?: InputMaybe<CatalogBannerCollectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CatalogBannerCollectionCreateOrConnectWithoutBannersInput>;
  create?: InputMaybe<CatalogBannerCollectionCreateWithoutBannersInput>;
  update?: InputMaybe<CatalogBannerCollectionUpdateToOneWithWhereWithoutBannersInput>;
  upsert?: InputMaybe<CatalogBannerCollectionUpsertWithoutBannersInput>;
};

export type CatalogBannerCollectionUpdateToOneWithWhereWithoutBannersInput = {
  data: CatalogBannerCollectionUpdateWithoutBannersInput;
  where?: InputMaybe<CatalogBannerCollectionWhereInput>;
};

export type CatalogBannerCollectionUpdateWithoutBannersInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kind?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CatalogBannerCollectionUpsertWithoutBannersInput = {
  create: CatalogBannerCollectionCreateWithoutBannersInput;
  update: CatalogBannerCollectionUpdateWithoutBannersInput;
  where?: InputMaybe<CatalogBannerCollectionWhereInput>;
};

export type CatalogBannerCollectionWhereInput = {
  AND?: InputMaybe<Array<CatalogBannerCollectionWhereInput>>;
  NOT?: InputMaybe<Array<CatalogBannerCollectionWhereInput>>;
  OR?: InputMaybe<Array<CatalogBannerCollectionWhereInput>>;
  banners?: InputMaybe<CatalogBannerListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  kind?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
};

export type CatalogBannerCollectionWhereUniqueInput = {
  AND?: InputMaybe<Array<CatalogBannerCollectionWhereInput>>;
  NOT?: InputMaybe<Array<CatalogBannerCollectionWhereInput>>;
  OR?: InputMaybe<Array<CatalogBannerCollectionWhereInput>>;
  banners?: InputMaybe<CatalogBannerListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<BoolFilter>;
  kind?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
};

export type CatalogBannerCreateInput = {
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  bannerImageSmall?: InputMaybe<Scalars['String']['input']>;
  bannerVideo?: InputMaybe<Scalars['String']['input']>;
  collection: CatalogBannerCollectionCreateNestedOneWithoutBannersInput;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageImage?: InputMaybe<Scalars['String']['input']>;
  pageImageSmall?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timerDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  timerLabel?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogBannerCreateManyCollectionInput = {
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  bannerImageSmall?: InputMaybe<Scalars['String']['input']>;
  bannerVideo?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageImage?: InputMaybe<Scalars['String']['input']>;
  pageImageSmall?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timerDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  timerLabel?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogBannerCreateManyCollectionInputEnvelope = {
  data: Array<CatalogBannerCreateManyCollectionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CatalogBannerCreateNestedManyWithoutCollectionInput = {
  connect?: InputMaybe<Array<CatalogBannerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CatalogBannerCreateOrConnectWithoutCollectionInput>>;
  create?: InputMaybe<Array<CatalogBannerCreateWithoutCollectionInput>>;
  createMany?: InputMaybe<CatalogBannerCreateManyCollectionInputEnvelope>;
};

export type CatalogBannerCreateOrConnectWithoutCollectionInput = {
  create: CatalogBannerCreateWithoutCollectionInput;
  where: CatalogBannerWhereUniqueInput;
};

export type CatalogBannerCreateWithoutCollectionInput = {
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  bannerImageSmall?: InputMaybe<Scalars['String']['input']>;
  bannerVideo?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageImage?: InputMaybe<Scalars['String']['input']>;
  pageImageSmall?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timerDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  timerLabel?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogBannerListRelationFilter = {
  every?: InputMaybe<CatalogBannerWhereInput>;
  none?: InputMaybe<CatalogBannerWhereInput>;
  some?: InputMaybe<CatalogBannerWhereInput>;
};

export type CatalogBannerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CatalogBannerOrderByWithRelationInput = {
  bannerImage?: InputMaybe<SortOrderInput>;
  bannerImageSmall?: InputMaybe<SortOrderInput>;
  bannerVideo?: InputMaybe<SortOrderInput>;
  collection?: InputMaybe<CatalogBannerCollectionOrderByWithRelationInput>;
  collectionId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isDisabled?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrderInput>;
  pageImage?: InputMaybe<SortOrderInput>;
  pageImageSmall?: InputMaybe<SortOrderInput>;
  slug?: InputMaybe<SortOrderInput>;
  timerDeadline?: InputMaybe<SortOrderInput>;
  timerLabel?: InputMaybe<SortOrderInput>;
  url?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export enum CatalogBannerScalarFieldEnum {
  BannerImage = 'bannerImage',
  BannerImageSmall = 'bannerImageSmall',
  BannerVideo = 'bannerVideo',
  CollectionId = 'collectionId',
  Description = 'description',
  Id = 'id',
  IsDisabled = 'isDisabled',
  Name = 'name',
  PageImage = 'pageImage',
  PageImageSmall = 'pageImageSmall',
  Slug = 'slug',
  TimerDeadline = 'timerDeadline',
  TimerLabel = 'timerLabel',
  Url = 'url',
  Weight = 'weight'
}

export type CatalogBannerScalarWhereInput = {
  AND?: InputMaybe<Array<CatalogBannerScalarWhereInput>>;
  NOT?: InputMaybe<Array<CatalogBannerScalarWhereInput>>;
  OR?: InputMaybe<Array<CatalogBannerScalarWhereInput>>;
  bannerImage?: InputMaybe<StringNullableFilter>;
  bannerImageSmall?: InputMaybe<StringNullableFilter>;
  bannerVideo?: InputMaybe<StringNullableFilter>;
  collectionId?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  pageImage?: InputMaybe<StringNullableFilter>;
  pageImageSmall?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  timerDeadline?: InputMaybe<DateTimeNullableFilter>;
  timerLabel?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
  weight?: InputMaybe<IntFilter>;
};

export type CatalogBannerUpdateInput = {
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bannerImageSmall?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bannerVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collection?: InputMaybe<CatalogBannerCollectionUpdateOneRequiredWithoutBannersNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pageImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pageImageSmall?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timerDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timerLabel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  weight?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type CatalogBannerUpdateManyMutationInput = {
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bannerImageSmall?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bannerVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pageImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pageImageSmall?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timerDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timerLabel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  weight?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type CatalogBannerUpdateManyWithWhereWithoutCollectionInput = {
  data: CatalogBannerUpdateManyMutationInput;
  where: CatalogBannerScalarWhereInput;
};

export type CatalogBannerUpdateManyWithoutCollectionNestedInput = {
  connect?: InputMaybe<Array<CatalogBannerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CatalogBannerCreateOrConnectWithoutCollectionInput>>;
  create?: InputMaybe<Array<CatalogBannerCreateWithoutCollectionInput>>;
  createMany?: InputMaybe<CatalogBannerCreateManyCollectionInputEnvelope>;
  delete?: InputMaybe<Array<CatalogBannerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CatalogBannerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CatalogBannerWhereUniqueInput>>;
  set?: InputMaybe<Array<CatalogBannerWhereUniqueInput>>;
  update?: InputMaybe<Array<CatalogBannerUpdateWithWhereUniqueWithoutCollectionInput>>;
  updateMany?: InputMaybe<Array<CatalogBannerUpdateManyWithWhereWithoutCollectionInput>>;
  upsert?: InputMaybe<Array<CatalogBannerUpsertWithWhereUniqueWithoutCollectionInput>>;
};

export type CatalogBannerUpdateWithWhereUniqueWithoutCollectionInput = {
  data: CatalogBannerUpdateWithoutCollectionInput;
  where: CatalogBannerWhereUniqueInput;
};

export type CatalogBannerUpdateWithoutCollectionInput = {
  bannerImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bannerImageSmall?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bannerVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pageImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pageImageSmall?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timerDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  timerLabel?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  weight?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type CatalogBannerUpsertWithWhereUniqueWithoutCollectionInput = {
  create: CatalogBannerCreateWithoutCollectionInput;
  update: CatalogBannerUpdateWithoutCollectionInput;
  where: CatalogBannerWhereUniqueInput;
};

export type CatalogBannerWhereInput = {
  AND?: InputMaybe<Array<CatalogBannerWhereInput>>;
  NOT?: InputMaybe<Array<CatalogBannerWhereInput>>;
  OR?: InputMaybe<Array<CatalogBannerWhereInput>>;
  bannerImage?: InputMaybe<StringNullableFilter>;
  bannerImageSmall?: InputMaybe<StringNullableFilter>;
  bannerVideo?: InputMaybe<StringNullableFilter>;
  collection?: InputMaybe<CatalogBannerCollectionRelationFilter>;
  collectionId?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  pageImage?: InputMaybe<StringNullableFilter>;
  pageImageSmall?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  timerDeadline?: InputMaybe<DateTimeNullableFilter>;
  timerLabel?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
  weight?: InputMaybe<IntFilter>;
};

export type CatalogBannerWhereUniqueInput = {
  AND?: InputMaybe<Array<CatalogBannerWhereInput>>;
  NOT?: InputMaybe<Array<CatalogBannerWhereInput>>;
  OR?: InputMaybe<Array<CatalogBannerWhereInput>>;
  bannerImage?: InputMaybe<StringNullableFilter>;
  bannerImageSmall?: InputMaybe<StringNullableFilter>;
  bannerVideo?: InputMaybe<StringNullableFilter>;
  collection?: InputMaybe<CatalogBannerCollectionRelationFilter>;
  collectionId?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  pageImage?: InputMaybe<StringNullableFilter>;
  pageImageSmall?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timerDeadline?: InputMaybe<DateTimeNullableFilter>;
  timerLabel?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
  weight?: InputMaybe<IntFilter>;
};

export type CountShipmentsByCarrierResponse = {
  __typename?: 'CountShipmentsByCarrierResponse';
  carrierId: Scalars['String']['output'];
  count: Scalars['Float']['output'];
};

export type CreateBulkShippingInput = {
  carrierId: Scalars['ID']['input'];
  orders: Array<CreateOrderToShip>;
  shippingPackageId: Scalars['ID']['input'];
};

export type CreateBulkShippingOrderResult = {
  __typename?: 'CreateBulkShippingOrderResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: UserProductOrder;
};

export type CreateBulkShippingResponse = {
  __typename?: 'CreateBulkShippingResponse';
  bulkShippingId: Scalars['Int']['output'];
  results: Array<CreateBulkShippingOrderResult>;
};

export type CreateLineItemToShip = {
  count: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export type CreateOrderToShip = {
  id: Scalars['ID']['input'];
  linesToShip: Array<CreateLineItemToShip>;
};

export type CreatePrintBatchAndConnectOrderLinesInput = {
  isSingleItemOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isTodayPriority?: InputMaybe<Scalars['Boolean']['input']>;
  orderKind?: InputMaybe<Array<Scalars['String']['input']>>;
  sku: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePrintBatchAndConnectOrderLinesResult = {
  __typename?: 'CreatePrintBatchAndConnectOrderLinesResult';
  id: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type CreateProductStockSnapshotInput = {
  productStockId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
};

export type CreateQuickShipmentsFromPrintBatchInput = {
  printBatchId: Scalars['Int']['input'];
};

export type CreateQuickShipmentsFromPrintBatchResponse = {
  __typename?: 'CreateQuickShipmentsFromPrintBatchResponse';
  countFailed: Scalars['Float']['output'];
  countSucceeded: Scalars['Float']['output'];
};

export type CreateShipmentBatchInput = {
  carrierId: Scalars['String']['input'];
};

export type CreateShipmentInput = {
  orderId: Scalars['String']['input'];
  selectedCarrierExternalId: Scalars['String']['input'];
  selectedItems: Array<CreateShipmentItem>;
  shippingPackageId: Scalars['String']['input'];
};

export type CreateShipmentItem = {
  count: Scalars['Float']['input'];
  lineItemId: Scalars['String']['input'];
};

export type CreateWarehouseShelfInput = {
  /** Bin count on a shelf */
  binCount: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  returnBins?: InputMaybe<WarehouseShelfReturnBinCreateNestedManyWithoutWarehouseShelfInput>;
  type?: InputMaybe<WarehouseShelfType>;
  warehouse: WarehouseCreateNestedOneWithoutShelvesInput;
};

export type CustomOnHoldReason = {
  __typename?: 'CustomOnHoldReason';
  addedBy?: Maybe<Admin>;
  addedById?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  order: UserProductOrder;
  orderId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  resolved: Scalars['Boolean']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<Admin>;
  resolvedById?: Maybe<Scalars['String']['output']>;
};


export type CustomOnHoldReasonAddedByArgs = {
  where?: InputMaybe<AdminWhereInput>;
};


export type CustomOnHoldReasonResolvedByArgs = {
  where?: InputMaybe<AdminWhereInput>;
};

export type CustomOnHoldReasonCreateManyAddedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedById?: InputMaybe<Scalars['String']['input']>;
};

export type CustomOnHoldReasonCreateManyAddedByInputEnvelope = {
  data: Array<CustomOnHoldReasonCreateManyAddedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomOnHoldReasonCreateManyOrderInput = {
  addedById?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedById?: InputMaybe<Scalars['String']['input']>;
};

export type CustomOnHoldReasonCreateManyOrderInputEnvelope = {
  data: Array<CustomOnHoldReasonCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomOnHoldReasonCreateManyResolvedByInput = {
  addedById?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomOnHoldReasonCreateManyResolvedByInputEnvelope = {
  data: Array<CustomOnHoldReasonCreateManyResolvedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomOnHoldReasonCreateNestedManyWithoutAddedByInput = {
  connect?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CustomOnHoldReasonCreateOrConnectWithoutAddedByInput>>;
  create?: InputMaybe<Array<CustomOnHoldReasonCreateWithoutAddedByInput>>;
  createMany?: InputMaybe<CustomOnHoldReasonCreateManyAddedByInputEnvelope>;
};

export type CustomOnHoldReasonCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CustomOnHoldReasonCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<CustomOnHoldReasonCreateWithoutOrderInput>>;
  createMany?: InputMaybe<CustomOnHoldReasonCreateManyOrderInputEnvelope>;
};

export type CustomOnHoldReasonCreateNestedManyWithoutResolvedByInput = {
  connect?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CustomOnHoldReasonCreateOrConnectWithoutResolvedByInput>>;
  create?: InputMaybe<Array<CustomOnHoldReasonCreateWithoutResolvedByInput>>;
  createMany?: InputMaybe<CustomOnHoldReasonCreateManyResolvedByInputEnvelope>;
};

export type CustomOnHoldReasonCreateOrConnectWithoutAddedByInput = {
  create: CustomOnHoldReasonCreateWithoutAddedByInput;
  where: CustomOnHoldReasonWhereUniqueInput;
};

export type CustomOnHoldReasonCreateOrConnectWithoutOrderInput = {
  create: CustomOnHoldReasonCreateWithoutOrderInput;
  where: CustomOnHoldReasonWhereUniqueInput;
};

export type CustomOnHoldReasonCreateOrConnectWithoutResolvedByInput = {
  create: CustomOnHoldReasonCreateWithoutResolvedByInput;
  where: CustomOnHoldReasonWhereUniqueInput;
};

export type CustomOnHoldReasonCreateWithoutAddedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: UserProductOrderCreateNestedOneWithoutCustomOnHoldReasonsInput;
  reason: Scalars['String']['input'];
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<AdminCreateNestedOneWithoutCustomOnHoldReasonsResolvedInput>;
};

export type CustomOnHoldReasonCreateWithoutOrderInput = {
  addedBy?: InputMaybe<AdminCreateNestedOneWithoutCustomOnHoldReasonsAddedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<AdminCreateNestedOneWithoutCustomOnHoldReasonsResolvedInput>;
};

export type CustomOnHoldReasonCreateWithoutResolvedByInput = {
  addedBy?: InputMaybe<AdminCreateNestedOneWithoutCustomOnHoldReasonsAddedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: UserProductOrderCreateNestedOneWithoutCustomOnHoldReasonsInput;
  reason: Scalars['String']['input'];
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomOnHoldReasonListRelationFilter = {
  every?: InputMaybe<CustomOnHoldReasonWhereInput>;
  none?: InputMaybe<CustomOnHoldReasonWhereInput>;
  some?: InputMaybe<CustomOnHoldReasonWhereInput>;
};

export type CustomOnHoldReasonOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomOnHoldReasonOrderByWithRelationInput = {
  addedBy?: InputMaybe<AdminOrderByWithRelationInput>;
  addedById?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  resolved?: InputMaybe<SortOrder>;
  resolvedAt?: InputMaybe<SortOrderInput>;
  resolvedBy?: InputMaybe<AdminOrderByWithRelationInput>;
  resolvedById?: InputMaybe<SortOrderInput>;
};

export enum CustomOnHoldReasonScalarFieldEnum {
  AddedById = 'addedById',
  CreatedAt = 'createdAt',
  Id = 'id',
  OrderId = 'orderId',
  Reason = 'reason',
  Resolved = 'resolved',
  ResolvedAt = 'resolvedAt',
  ResolvedById = 'resolvedById'
}

export type CustomOnHoldReasonScalarWhereInput = {
  AND?: InputMaybe<Array<CustomOnHoldReasonScalarWhereInput>>;
  NOT?: InputMaybe<Array<CustomOnHoldReasonScalarWhereInput>>;
  OR?: InputMaybe<Array<CustomOnHoldReasonScalarWhereInput>>;
  addedById?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  orderId?: InputMaybe<UuidFilter>;
  reason?: InputMaybe<StringFilter>;
  resolved?: InputMaybe<BoolFilter>;
  resolvedAt?: InputMaybe<DateTimeNullableFilter>;
  resolvedById?: InputMaybe<UuidNullableFilter>;
};

export type CustomOnHoldReasonUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  resolved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CustomOnHoldReasonUpdateManyWithWhereWithoutAddedByInput = {
  data: CustomOnHoldReasonUpdateManyMutationInput;
  where: CustomOnHoldReasonScalarWhereInput;
};

export type CustomOnHoldReasonUpdateManyWithWhereWithoutOrderInput = {
  data: CustomOnHoldReasonUpdateManyMutationInput;
  where: CustomOnHoldReasonScalarWhereInput;
};

export type CustomOnHoldReasonUpdateManyWithWhereWithoutResolvedByInput = {
  data: CustomOnHoldReasonUpdateManyMutationInput;
  where: CustomOnHoldReasonScalarWhereInput;
};

export type CustomOnHoldReasonUpdateManyWithoutAddedByNestedInput = {
  connect?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CustomOnHoldReasonCreateOrConnectWithoutAddedByInput>>;
  create?: InputMaybe<Array<CustomOnHoldReasonCreateWithoutAddedByInput>>;
  createMany?: InputMaybe<CustomOnHoldReasonCreateManyAddedByInputEnvelope>;
  delete?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomOnHoldReasonScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  update?: InputMaybe<Array<CustomOnHoldReasonUpdateWithWhereUniqueWithoutAddedByInput>>;
  updateMany?: InputMaybe<Array<CustomOnHoldReasonUpdateManyWithWhereWithoutAddedByInput>>;
  upsert?: InputMaybe<Array<CustomOnHoldReasonUpsertWithWhereUniqueWithoutAddedByInput>>;
};

export type CustomOnHoldReasonUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CustomOnHoldReasonCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<CustomOnHoldReasonCreateWithoutOrderInput>>;
  createMany?: InputMaybe<CustomOnHoldReasonCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomOnHoldReasonScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  update?: InputMaybe<Array<CustomOnHoldReasonUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<CustomOnHoldReasonUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<CustomOnHoldReasonUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type CustomOnHoldReasonUpdateManyWithoutResolvedByNestedInput = {
  connect?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CustomOnHoldReasonCreateOrConnectWithoutResolvedByInput>>;
  create?: InputMaybe<Array<CustomOnHoldReasonCreateWithoutResolvedByInput>>;
  createMany?: InputMaybe<CustomOnHoldReasonCreateManyResolvedByInputEnvelope>;
  delete?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomOnHoldReasonScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomOnHoldReasonWhereUniqueInput>>;
  update?: InputMaybe<Array<CustomOnHoldReasonUpdateWithWhereUniqueWithoutResolvedByInput>>;
  updateMany?: InputMaybe<Array<CustomOnHoldReasonUpdateManyWithWhereWithoutResolvedByInput>>;
  upsert?: InputMaybe<Array<CustomOnHoldReasonUpsertWithWhereUniqueWithoutResolvedByInput>>;
};

export type CustomOnHoldReasonUpdateWithWhereUniqueWithoutAddedByInput = {
  data: CustomOnHoldReasonUpdateWithoutAddedByInput;
  where: CustomOnHoldReasonWhereUniqueInput;
};

export type CustomOnHoldReasonUpdateWithWhereUniqueWithoutOrderInput = {
  data: CustomOnHoldReasonUpdateWithoutOrderInput;
  where: CustomOnHoldReasonWhereUniqueInput;
};

export type CustomOnHoldReasonUpdateWithWhereUniqueWithoutResolvedByInput = {
  data: CustomOnHoldReasonUpdateWithoutResolvedByInput;
  where: CustomOnHoldReasonWhereUniqueInput;
};

export type CustomOnHoldReasonUpdateWithoutAddedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutCustomOnHoldReasonsNestedInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  resolved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  resolvedBy?: InputMaybe<AdminUpdateOneWithoutCustomOnHoldReasonsResolvedNestedInput>;
};

export type CustomOnHoldReasonUpdateWithoutOrderInput = {
  addedBy?: InputMaybe<AdminUpdateOneWithoutCustomOnHoldReasonsAddedNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  resolved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  resolvedBy?: InputMaybe<AdminUpdateOneWithoutCustomOnHoldReasonsResolvedNestedInput>;
};

export type CustomOnHoldReasonUpdateWithoutResolvedByInput = {
  addedBy?: InputMaybe<AdminUpdateOneWithoutCustomOnHoldReasonsAddedNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutCustomOnHoldReasonsNestedInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  resolved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CustomOnHoldReasonUpsertWithWhereUniqueWithoutAddedByInput = {
  create: CustomOnHoldReasonCreateWithoutAddedByInput;
  update: CustomOnHoldReasonUpdateWithoutAddedByInput;
  where: CustomOnHoldReasonWhereUniqueInput;
};

export type CustomOnHoldReasonUpsertWithWhereUniqueWithoutOrderInput = {
  create: CustomOnHoldReasonCreateWithoutOrderInput;
  update: CustomOnHoldReasonUpdateWithoutOrderInput;
  where: CustomOnHoldReasonWhereUniqueInput;
};

export type CustomOnHoldReasonUpsertWithWhereUniqueWithoutResolvedByInput = {
  create: CustomOnHoldReasonCreateWithoutResolvedByInput;
  update: CustomOnHoldReasonUpdateWithoutResolvedByInput;
  where: CustomOnHoldReasonWhereUniqueInput;
};

export type CustomOnHoldReasonWhereInput = {
  AND?: InputMaybe<Array<CustomOnHoldReasonWhereInput>>;
  NOT?: InputMaybe<Array<CustomOnHoldReasonWhereInput>>;
  OR?: InputMaybe<Array<CustomOnHoldReasonWhereInput>>;
  addedBy?: InputMaybe<AdminNullableRelationFilter>;
  addedById?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<UserProductOrderRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  reason?: InputMaybe<StringFilter>;
  resolved?: InputMaybe<BoolFilter>;
  resolvedAt?: InputMaybe<DateTimeNullableFilter>;
  resolvedBy?: InputMaybe<AdminNullableRelationFilter>;
  resolvedById?: InputMaybe<UuidNullableFilter>;
};

export type CustomOnHoldReasonWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomOnHoldReasonWhereInput>>;
  NOT?: InputMaybe<Array<CustomOnHoldReasonWhereInput>>;
  OR?: InputMaybe<Array<CustomOnHoldReasonWhereInput>>;
  addedBy?: InputMaybe<AdminNullableRelationFilter>;
  addedById?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<UserProductOrderRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  reason?: InputMaybe<StringFilter>;
  resolved?: InputMaybe<BoolFilter>;
  resolvedAt?: InputMaybe<DateTimeNullableFilter>;
  resolvedBy?: InputMaybe<AdminNullableRelationFilter>;
  resolvedById?: InputMaybe<UuidNullableFilter>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DigitalServiceProduct = {
  __typename?: 'DigitalServiceProduct';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Admin;
  createdById: Scalars['String']['output'];
  hubspotProductId?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  refundPolicy?: Maybe<Scalars['String']['output']>;
  stripeProductId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DigitalServiceProductCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotProductId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  refundPolicy?: InputMaybe<Scalars['String']['input']>;
  stripeProductId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DigitalServiceProductCreateManyCreatedByInputEnvelope = {
  data: Array<DigitalServiceProductCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DigitalServiceProductCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<DigitalServiceProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DigitalServiceProductCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<DigitalServiceProductCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<DigitalServiceProductCreateManyCreatedByInputEnvelope>;
};

export type DigitalServiceProductCreateOrConnectWithoutCreatedByInput = {
  create: DigitalServiceProductCreateWithoutCreatedByInput;
  where: DigitalServiceProductWhereUniqueInput;
};

export type DigitalServiceProductCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotProductId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  refundPolicy?: InputMaybe<Scalars['String']['input']>;
  stripeProductId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DigitalServiceProductListRelationFilter = {
  every?: InputMaybe<DigitalServiceProductWhereInput>;
  none?: InputMaybe<DigitalServiceProductWhereInput>;
  some?: InputMaybe<DigitalServiceProductWhereInput>;
};

export type DigitalServiceProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DigitalServiceProductScalarWhereInput = {
  AND?: InputMaybe<Array<DigitalServiceProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<DigitalServiceProductScalarWhereInput>>;
  OR?: InputMaybe<Array<DigitalServiceProductScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<UuidFilter>;
  hubspotProductId?: InputMaybe<StringNullableFilter>;
  isActive?: InputMaybe<BoolFilter>;
  refundPolicy?: InputMaybe<StringNullableFilter>;
  stripeProductId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DigitalServiceProductUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutDigitalServiceProductsNestedInput>;
  hubspotProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  refundPolicy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DigitalServiceProductUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hubspotProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  refundPolicy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DigitalServiceProductUpdateManyWithWhereWithoutCreatedByInput = {
  data: DigitalServiceProductUpdateManyMutationInput;
  where: DigitalServiceProductScalarWhereInput;
};

export type DigitalServiceProductUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<DigitalServiceProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DigitalServiceProductCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<DigitalServiceProductCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<DigitalServiceProductCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<DigitalServiceProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DigitalServiceProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DigitalServiceProductWhereUniqueInput>>;
  set?: InputMaybe<Array<DigitalServiceProductWhereUniqueInput>>;
  update?: InputMaybe<Array<DigitalServiceProductUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<DigitalServiceProductUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<DigitalServiceProductUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type DigitalServiceProductUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: DigitalServiceProductUpdateWithoutCreatedByInput;
  where: DigitalServiceProductWhereUniqueInput;
};

export type DigitalServiceProductUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hubspotProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  refundPolicy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DigitalServiceProductUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: DigitalServiceProductCreateWithoutCreatedByInput;
  update: DigitalServiceProductUpdateWithoutCreatedByInput;
  where: DigitalServiceProductWhereUniqueInput;
};

export type DigitalServiceProductWhereInput = {
  AND?: InputMaybe<Array<DigitalServiceProductWhereInput>>;
  NOT?: InputMaybe<Array<DigitalServiceProductWhereInput>>;
  OR?: InputMaybe<Array<DigitalServiceProductWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminRelationFilter>;
  createdById?: InputMaybe<UuidFilter>;
  hubspotProductId?: InputMaybe<StringNullableFilter>;
  isActive?: InputMaybe<BoolFilter>;
  refundPolicy?: InputMaybe<StringNullableFilter>;
  stripeProductId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DigitalServiceProductWhereUniqueInput = {
  AND?: InputMaybe<Array<DigitalServiceProductWhereInput>>;
  NOT?: InputMaybe<Array<DigitalServiceProductWhereInput>>;
  OR?: InputMaybe<Array<DigitalServiceProductWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminRelationFilter>;
  createdById?: InputMaybe<UuidFilter>;
  hubspotProductId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  refundPolicy?: InputMaybe<StringNullableFilter>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum EcommercePlatform {
  Amazon = 'AMAZON',
  Clickfunnels = 'CLICKFUNNELS',
  Shopify = 'SHOPIFY',
  Supliful = 'SUPLIFUL',
  Tiktok = 'TIKTOK',
  Wix = 'WIX',
  Woocommerce = 'WOOCOMMERCE'
}

export type EnumAdminPermissionNullableListFilter = {
  equals?: InputMaybe<Array<AdminPermission>>;
  has?: InputMaybe<AdminPermission>;
  hasEvery?: InputMaybe<Array<AdminPermission>>;
  hasSome?: InputMaybe<Array<AdminPermission>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumEcommercePlatformFieldUpdateOperationsInput = {
  set?: InputMaybe<EcommercePlatform>;
};

export type EnumEcommercePlatformFilter = {
  equals?: InputMaybe<EcommercePlatform>;
  in?: InputMaybe<Array<EcommercePlatform>>;
  not?: InputMaybe<NestedEnumEcommercePlatformFilter>;
  notIn?: InputMaybe<Array<EcommercePlatform>>;
};

export type EnumInvoiceModeFieldUpdateOperationsInput = {
  set?: InputMaybe<InvoiceMode>;
};

export type EnumInvoiceModeFilter = {
  equals?: InputMaybe<InvoiceMode>;
  in?: InputMaybe<Array<InvoiceMode>>;
  not?: InputMaybe<NestedEnumInvoiceModeFilter>;
  notIn?: InputMaybe<Array<InvoiceMode>>;
};

export type EnumLabelTransitionAdminStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<LabelTransitionAdminStatus>;
};

export type EnumLabelTransitionAdminStatusFilter = {
  equals?: InputMaybe<LabelTransitionAdminStatus>;
  in?: InputMaybe<Array<LabelTransitionAdminStatus>>;
  not?: InputMaybe<NestedEnumLabelTransitionAdminStatusFilter>;
  notIn?: InputMaybe<Array<LabelTransitionAdminStatus>>;
};

export type EnumLengthUnitFieldUpdateOperationsInput = {
  set?: InputMaybe<LengthUnit>;
};

export type EnumLengthUnitFilter = {
  equals?: InputMaybe<LengthUnit>;
  in?: InputMaybe<Array<LengthUnit>>;
  not?: InputMaybe<NestedEnumLengthUnitFilter>;
  notIn?: InputMaybe<Array<LengthUnit>>;
};

export type EnumNotificationReasonNullableListFilter = {
  equals?: InputMaybe<Array<NotificationReason>>;
  has?: InputMaybe<NotificationReason>;
  hasEvery?: InputMaybe<Array<NotificationReason>>;
  hasSome?: InputMaybe<Array<NotificationReason>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumOnHoldReasonFieldUpdateOperationsInput = {
  set?: InputMaybe<OnHoldReason>;
};

export type EnumOnHoldReasonFilter = {
  equals?: InputMaybe<OnHoldReason>;
  in?: InputMaybe<Array<OnHoldReason>>;
  not?: InputMaybe<NestedEnumOnHoldReasonFilter>;
  notIn?: InputMaybe<Array<OnHoldReason>>;
};

export type EnumOnHoldReasonNullableListFilter = {
  equals?: InputMaybe<Array<OnHoldReason>>;
  has?: InputMaybe<OnHoldReason>;
  hasEvery?: InputMaybe<Array<OnHoldReason>>;
  hasSome?: InputMaybe<Array<OnHoldReason>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumPostPaymentOrdersBucketStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PostPaymentOrdersBucketStatus>;
};

export type EnumPostPaymentOrdersBucketStatusFilter = {
  equals?: InputMaybe<PostPaymentOrdersBucketStatus>;
  in?: InputMaybe<Array<PostPaymentOrdersBucketStatus>>;
  not?: InputMaybe<NestedEnumPostPaymentOrdersBucketStatusFilter>;
  notIn?: InputMaybe<Array<PostPaymentOrdersBucketStatus>>;
};

export type EnumProductLabellingTechniqueFieldUpdateOperationsInput = {
  set?: InputMaybe<ProductLabellingTechnique>;
};

export type EnumProductLabellingTechniqueFilter = {
  equals?: InputMaybe<ProductLabellingTechnique>;
  in?: InputMaybe<Array<ProductLabellingTechnique>>;
  not?: InputMaybe<NestedEnumProductLabellingTechniqueFilter>;
  notIn?: InputMaybe<Array<ProductLabellingTechnique>>;
};

export type EnumProductStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ProductStatus>;
};

export type EnumProductStatusFilter = {
  equals?: InputMaybe<ProductStatus>;
  in?: InputMaybe<Array<ProductStatus>>;
  not?: InputMaybe<NestedEnumProductStatusFilter>;
  notIn?: InputMaybe<Array<ProductStatus>>;
};

export type EnumProductVariantKindFieldUpdateOperationsInput = {
  set?: InputMaybe<ProductVariantKind>;
};

export type EnumProductVariantKindFilter = {
  equals?: InputMaybe<ProductVariantKind>;
  in?: InputMaybe<Array<ProductVariantKind>>;
  not?: InputMaybe<NestedEnumProductVariantKindFilter>;
  notIn?: InputMaybe<Array<ProductVariantKind>>;
};

export type EnumServicePurchaseStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ServicePurchaseStatus>;
};

export type EnumServicePurchaseStatusFilter = {
  equals?: InputMaybe<ServicePurchaseStatus>;
  in?: InputMaybe<Array<ServicePurchaseStatus>>;
  not?: InputMaybe<NestedEnumServicePurchaseStatusFilter>;
  notIn?: InputMaybe<Array<ServicePurchaseStatus>>;
};

export type EnumShipmentStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ShipmentStatus>;
};

export type EnumShipmentStatusFilter = {
  equals?: InputMaybe<ShipmentStatus>;
  in?: InputMaybe<Array<ShipmentStatus>>;
  not?: InputMaybe<NestedEnumShipmentStatusFilter>;
  notIn?: InputMaybe<Array<ShipmentStatus>>;
};

export type EnumSocialNetworkNullableFilter = {
  equals?: InputMaybe<SocialNetwork>;
  in?: InputMaybe<Array<SocialNetwork>>;
  not?: InputMaybe<NestedEnumSocialNetworkNullableFilter>;
  notIn?: InputMaybe<Array<SocialNetwork>>;
};

export type EnumStripeCreditNoteKindFieldUpdateOperationsInput = {
  set?: InputMaybe<StripeCreditNoteKind>;
};

export type EnumStripeCreditNoteKindFilter = {
  equals?: InputMaybe<StripeCreditNoteKind>;
  in?: InputMaybe<Array<StripeCreditNoteKind>>;
  not?: InputMaybe<NestedEnumStripeCreditNoteKindFilter>;
  notIn?: InputMaybe<Array<StripeCreditNoteKind>>;
};

export type EnumStripeCreditNoteReasonNullableFilter = {
  equals?: InputMaybe<StripeCreditNoteReason>;
  in?: InputMaybe<Array<StripeCreditNoteReason>>;
  not?: InputMaybe<NestedEnumStripeCreditNoteReasonNullableFilter>;
  notIn?: InputMaybe<Array<StripeCreditNoteReason>>;
};

export type EnumStripeCreditNoteStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<StripeCreditNoteStatus>;
};

export type EnumStripeCreditNoteStatusFilter = {
  equals?: InputMaybe<StripeCreditNoteStatus>;
  in?: InputMaybe<Array<StripeCreditNoteStatus>>;
  not?: InputMaybe<NestedEnumStripeCreditNoteStatusFilter>;
  notIn?: InputMaybe<Array<StripeCreditNoteStatus>>;
};

export type EnumStripeCreditNoteTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<StripeCreditNoteType>;
};

export type EnumStripeCreditNoteTypeFilter = {
  equals?: InputMaybe<StripeCreditNoteType>;
  in?: InputMaybe<Array<StripeCreditNoteType>>;
  not?: InputMaybe<NestedEnumStripeCreditNoteTypeFilter>;
  notIn?: InputMaybe<Array<StripeCreditNoteType>>;
};

export type EnumStripeInvoiceKindFieldUpdateOperationsInput = {
  set?: InputMaybe<StripeInvoiceKind>;
};

export type EnumStripeInvoiceKindFilter = {
  equals?: InputMaybe<StripeInvoiceKind>;
  in?: InputMaybe<Array<StripeInvoiceKind>>;
  not?: InputMaybe<NestedEnumStripeInvoiceKindFilter>;
  notIn?: InputMaybe<Array<StripeInvoiceKind>>;
};

export type EnumStripeInvoiceStatusNullableFilter = {
  equals?: InputMaybe<StripeInvoiceStatus>;
  in?: InputMaybe<Array<StripeInvoiceStatus>>;
  not?: InputMaybe<NestedEnumStripeInvoiceStatusNullableFilter>;
  notIn?: InputMaybe<Array<StripeInvoiceStatus>>;
};

export type EnumUnprepareReasonNullableFilter = {
  equals?: InputMaybe<UnprepareReason>;
  in?: InputMaybe<Array<UnprepareReason>>;
  not?: InputMaybe<NestedEnumUnprepareReasonNullableFilter>;
  notIn?: InputMaybe<Array<UnprepareReason>>;
};

export type EnumUserCategoryNullableFilter = {
  equals?: InputMaybe<UserCategory>;
  in?: InputMaybe<Array<UserCategory>>;
  not?: InputMaybe<NestedEnumUserCategoryNullableFilter>;
  notIn?: InputMaybe<Array<UserCategory>>;
};

export type EnumUserCreditsTransactionTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UserCreditsTransactionType>;
};

export type EnumUserCreditsTransactionTypeFilter = {
  equals?: InputMaybe<UserCreditsTransactionType>;
  in?: InputMaybe<Array<UserCreditsTransactionType>>;
  not?: InputMaybe<NestedEnumUserCreditsTransactionTypeFilter>;
  notIn?: InputMaybe<Array<UserCreditsTransactionType>>;
};

export type EnumUserInvoiceTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UserInvoiceType>;
};

export type EnumUserInvoiceTypeFilter = {
  equals?: InputMaybe<UserInvoiceType>;
  in?: InputMaybe<Array<UserInvoiceType>>;
  not?: InputMaybe<NestedEnumUserInvoiceTypeFilter>;
  notIn?: InputMaybe<Array<UserInvoiceType>>;
};

export type EnumUserPaymentProcessorFieldUpdateOperationsInput = {
  set?: InputMaybe<UserPaymentProcessor>;
};

export type EnumUserPaymentProcessorFilter = {
  equals?: InputMaybe<UserPaymentProcessor>;
  in?: InputMaybe<Array<UserPaymentProcessor>>;
  not?: InputMaybe<NestedEnumUserPaymentProcessorFilter>;
  notIn?: InputMaybe<Array<UserPaymentProcessor>>;
};

export type EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UserPostPaymentDueDateDaysType>;
};

export type EnumUserPostPaymentDueDateDaysTypeFilter = {
  equals?: InputMaybe<UserPostPaymentDueDateDaysType>;
  in?: InputMaybe<Array<UserPostPaymentDueDateDaysType>>;
  not?: InputMaybe<NestedEnumUserPostPaymentDueDateDaysTypeFilter>;
  notIn?: InputMaybe<Array<UserPostPaymentDueDateDaysType>>;
};

export type EnumUserPostPaymentDueDateDaysTypeNullableFilter = {
  equals?: InputMaybe<UserPostPaymentDueDateDaysType>;
  in?: InputMaybe<Array<UserPostPaymentDueDateDaysType>>;
  not?: InputMaybe<NestedEnumUserPostPaymentDueDateDaysTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserPostPaymentDueDateDaysType>>;
};

export type EnumUserProductFileKindFieldUpdateOperationsInput = {
  set?: InputMaybe<UserProductFileKind>;
};

export type EnumUserProductFileKindFilter = {
  equals?: InputMaybe<UserProductFileKind>;
  in?: InputMaybe<Array<UserProductFileKind>>;
  not?: InputMaybe<NestedEnumUserProductFileKindFilter>;
  notIn?: InputMaybe<Array<UserProductFileKind>>;
};

export type EnumUserProductOrderKindFieldUpdateOperationsInput = {
  set?: InputMaybe<UserProductOrderKind>;
};

export type EnumUserProductOrderKindFilter = {
  equals?: InputMaybe<UserProductOrderKind>;
  in?: InputMaybe<Array<UserProductOrderKind>>;
  not?: InputMaybe<NestedEnumUserProductOrderKindFilter>;
  notIn?: InputMaybe<Array<UserProductOrderKind>>;
};

export type EnumUserProductOrderLineFulfillmentFeeTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UserProductOrderLineFulfillmentFeeType>;
};

export type EnumUserProductOrderLineFulfillmentFeeTypeFilter = {
  equals?: InputMaybe<UserProductOrderLineFulfillmentFeeType>;
  in?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeType>>;
  not?: InputMaybe<NestedEnumUserProductOrderLineFulfillmentFeeTypeFilter>;
  notIn?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeType>>;
};

export type EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput = {
  set?: InputMaybe<UserProductOrderManualPaymentKind>;
};

export type EnumUserProductOrderManualPaymentKindFilter = {
  equals?: InputMaybe<UserProductOrderManualPaymentKind>;
  in?: InputMaybe<Array<UserProductOrderManualPaymentKind>>;
  not?: InputMaybe<NestedEnumUserProductOrderManualPaymentKindFilter>;
  notIn?: InputMaybe<Array<UserProductOrderManualPaymentKind>>;
};

export type EnumUserProductOrderManualPaymentStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<UserProductOrderManualPaymentStatus>;
};

export type EnumUserProductOrderManualPaymentStatusFilter = {
  equals?: InputMaybe<UserProductOrderManualPaymentStatus>;
  in?: InputMaybe<Array<UserProductOrderManualPaymentStatus>>;
  not?: InputMaybe<NestedEnumUserProductOrderManualPaymentStatusFilter>;
  notIn?: InputMaybe<Array<UserProductOrderManualPaymentStatus>>;
};

export type EnumUserProductOrderPaymentStatusNullableFilter = {
  equals?: InputMaybe<UserProductOrderPaymentStatus>;
  in?: InputMaybe<Array<UserProductOrderPaymentStatus>>;
  not?: InputMaybe<NestedEnumUserProductOrderPaymentStatusNullableFilter>;
  notIn?: InputMaybe<Array<UserProductOrderPaymentStatus>>;
};

export type EnumUserProductOrderStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<UserProductOrderStatus>;
};

export type EnumUserProductOrderStatusFilter = {
  equals?: InputMaybe<UserProductOrderStatus>;
  in?: InputMaybe<Array<UserProductOrderStatus>>;
  not?: InputMaybe<NestedEnumUserProductOrderStatusFilter>;
  notIn?: InputMaybe<Array<UserProductOrderStatus>>;
};

export type EnumUserSubscriptionBillingIntervalFieldUpdateOperationsInput = {
  set?: InputMaybe<UserSubscriptionBillingInterval>;
};

export type EnumUserSubscriptionBillingIntervalFilter = {
  equals?: InputMaybe<UserSubscriptionBillingInterval>;
  in?: InputMaybe<Array<UserSubscriptionBillingInterval>>;
  not?: InputMaybe<NestedEnumUserSubscriptionBillingIntervalFilter>;
  notIn?: InputMaybe<Array<UserSubscriptionBillingInterval>>;
};

export type EnumUserSubscriptionEventTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UserSubscriptionEventType>;
};

export type EnumUserSubscriptionEventTypeFilter = {
  equals?: InputMaybe<UserSubscriptionEventType>;
  in?: InputMaybe<Array<UserSubscriptionEventType>>;
  not?: InputMaybe<NestedEnumUserSubscriptionEventTypeFilter>;
  notIn?: InputMaybe<Array<UserSubscriptionEventType>>;
};

export type EnumUserSubscriptionStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<UserSubscriptionStatus>;
};

export type EnumUserSubscriptionStatusFilter = {
  equals?: InputMaybe<UserSubscriptionStatus>;
  in?: InputMaybe<Array<UserSubscriptionStatus>>;
  not?: InputMaybe<NestedEnumUserSubscriptionStatusFilter>;
  notIn?: InputMaybe<Array<UserSubscriptionStatus>>;
};

export type EnumUserSubscriptionTierFieldUpdateOperationsInput = {
  set?: InputMaybe<UserSubscriptionTier>;
};

export type EnumUserSubscriptionTierFilter = {
  equals?: InputMaybe<UserSubscriptionTier>;
  in?: InputMaybe<Array<UserSubscriptionTier>>;
  not?: InputMaybe<NestedEnumUserSubscriptionTierFilter>;
  notIn?: InputMaybe<Array<UserSubscriptionTier>>;
};

export type EnumWarehouseShelfTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<WarehouseShelfType>;
};

export type EnumWarehouseShelfTypeFilter = {
  equals?: InputMaybe<WarehouseShelfType>;
  in?: InputMaybe<Array<WarehouseShelfType>>;
  not?: InputMaybe<NestedEnumWarehouseShelfTypeFilter>;
  notIn?: InputMaybe<Array<WarehouseShelfType>>;
};

export type EnumWeightUnitFieldUpdateOperationsInput = {
  set?: InputMaybe<WeightUnit>;
};

export type EnumWeightUnitFilter = {
  equals?: InputMaybe<WeightUnit>;
  in?: InputMaybe<Array<WeightUnit>>;
  not?: InputMaybe<NestedEnumWeightUnitFilter>;
  notIn?: InputMaybe<Array<WeightUnit>>;
};

export type EverlabOrder = {
  __typename?: 'EverlabOrder';
  _count?: Maybe<EverlabOrderCount>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userProductOrderId: Scalars['String']['output'];
};

export type EverlabOrderCount = {
  __typename?: 'EverlabOrderCount';
  orderLines: Scalars['Int']['output'];
};


export type EverlabOrderCountOrderLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type EverlabOrderCreateManyUserProductOrderInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type EverlabOrderCreateManyUserProductOrderInputEnvelope = {
  data: Array<EverlabOrderCreateManyUserProductOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EverlabOrderCreateNestedManyWithoutUserProductOrderInput = {
  connect?: InputMaybe<Array<EverlabOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EverlabOrderCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<EverlabOrderCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<EverlabOrderCreateManyUserProductOrderInputEnvelope>;
};

export type EverlabOrderCreateNestedOneWithoutOrderLinesInput = {
  connect?: InputMaybe<EverlabOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EverlabOrderCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<EverlabOrderCreateWithoutOrderLinesInput>;
};

export type EverlabOrderCreateNestedOneWithoutShipmentInput = {
  connect?: InputMaybe<EverlabOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EverlabOrderCreateOrConnectWithoutShipmentInput>;
  create?: InputMaybe<EverlabOrderCreateWithoutShipmentInput>;
};

export type EverlabOrderCreateOrConnectWithoutOrderLinesInput = {
  create: EverlabOrderCreateWithoutOrderLinesInput;
  where: EverlabOrderWhereUniqueInput;
};

export type EverlabOrderCreateOrConnectWithoutShipmentInput = {
  create: EverlabOrderCreateWithoutShipmentInput;
  where: EverlabOrderWhereUniqueInput;
};

export type EverlabOrderCreateOrConnectWithoutUserProductOrderInput = {
  create: EverlabOrderCreateWithoutUserProductOrderInput;
  where: EverlabOrderWhereUniqueInput;
};

export type EverlabOrderCreateWithoutOrderLinesInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutEverlabOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutEverlabOrdersInput;
};

export type EverlabOrderCreateWithoutShipmentInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutEverlabOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutEverlabOrdersInput;
};

export type EverlabOrderCreateWithoutUserProductOrderInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutEverlabOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutEverlabOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type EverlabOrderListRelationFilter = {
  every?: InputMaybe<EverlabOrderWhereInput>;
  none?: InputMaybe<EverlabOrderWhereInput>;
  some?: InputMaybe<EverlabOrderWhereInput>;
};

export type EverlabOrderNullableRelationFilter = {
  is?: InputMaybe<EverlabOrderWhereInput>;
  isNot?: InputMaybe<EverlabOrderWhereInput>;
};

export type EverlabOrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EverlabOrderOrderByWithRelationInput = {
  externalId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  orderLines?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  shipment?: InputMaybe<ShipmentOrderByWithRelationInput>;
  shipmentId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  userProductOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  userProductOrderId?: InputMaybe<SortOrder>;
};

export enum EverlabOrderScalarFieldEnum {
  ExternalId = 'externalId',
  Id = 'id',
  ShipmentId = 'shipmentId',
  Status = 'status',
  UserProductOrderId = 'userProductOrderId'
}

export type EverlabOrderScalarWhereInput = {
  AND?: InputMaybe<Array<EverlabOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<EverlabOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<EverlabOrderScalarWhereInput>>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type EverlabOrderUpdateManyMutationInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EverlabOrderUpdateManyWithWhereWithoutUserProductOrderInput = {
  data: EverlabOrderUpdateManyMutationInput;
  where: EverlabOrderScalarWhereInput;
};

export type EverlabOrderUpdateManyWithoutUserProductOrderNestedInput = {
  connect?: InputMaybe<Array<EverlabOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EverlabOrderCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<EverlabOrderCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<EverlabOrderCreateManyUserProductOrderInputEnvelope>;
  delete?: InputMaybe<Array<EverlabOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EverlabOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EverlabOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<EverlabOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<EverlabOrderUpdateWithWhereUniqueWithoutUserProductOrderInput>>;
  updateMany?: InputMaybe<Array<EverlabOrderUpdateManyWithWhereWithoutUserProductOrderInput>>;
  upsert?: InputMaybe<Array<EverlabOrderUpsertWithWhereUniqueWithoutUserProductOrderInput>>;
};

export type EverlabOrderUpdateOneWithoutOrderLinesNestedInput = {
  connect?: InputMaybe<EverlabOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EverlabOrderCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<EverlabOrderCreateWithoutOrderLinesInput>;
  delete?: InputMaybe<EverlabOrderWhereInput>;
  disconnect?: InputMaybe<EverlabOrderWhereInput>;
  update?: InputMaybe<EverlabOrderUpdateToOneWithWhereWithoutOrderLinesInput>;
  upsert?: InputMaybe<EverlabOrderUpsertWithoutOrderLinesInput>;
};

export type EverlabOrderUpdateOneWithoutShipmentNestedInput = {
  connect?: InputMaybe<EverlabOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EverlabOrderCreateOrConnectWithoutShipmentInput>;
  create?: InputMaybe<EverlabOrderCreateWithoutShipmentInput>;
  delete?: InputMaybe<EverlabOrderWhereInput>;
  disconnect?: InputMaybe<EverlabOrderWhereInput>;
  update?: InputMaybe<EverlabOrderUpdateToOneWithWhereWithoutShipmentInput>;
  upsert?: InputMaybe<EverlabOrderUpsertWithoutShipmentInput>;
};

export type EverlabOrderUpdateToOneWithWhereWithoutOrderLinesInput = {
  data: EverlabOrderUpdateWithoutOrderLinesInput;
  where?: InputMaybe<EverlabOrderWhereInput>;
};

export type EverlabOrderUpdateToOneWithWhereWithoutShipmentInput = {
  data: EverlabOrderUpdateWithoutShipmentInput;
  where?: InputMaybe<EverlabOrderWhereInput>;
};

export type EverlabOrderUpdateWithWhereUniqueWithoutUserProductOrderInput = {
  data: EverlabOrderUpdateWithoutUserProductOrderInput;
  where: EverlabOrderWhereUniqueInput;
};

export type EverlabOrderUpdateWithoutOrderLinesInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutEverlabOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutEverlabOrdersNestedInput>;
};

export type EverlabOrderUpdateWithoutShipmentInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutEverlabOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutEverlabOrdersNestedInput>;
};

export type EverlabOrderUpdateWithoutUserProductOrderInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutEverlabOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutEverlabOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EverlabOrderUpsertWithWhereUniqueWithoutUserProductOrderInput = {
  create: EverlabOrderCreateWithoutUserProductOrderInput;
  update: EverlabOrderUpdateWithoutUserProductOrderInput;
  where: EverlabOrderWhereUniqueInput;
};

export type EverlabOrderUpsertWithoutOrderLinesInput = {
  create: EverlabOrderCreateWithoutOrderLinesInput;
  update: EverlabOrderUpdateWithoutOrderLinesInput;
  where?: InputMaybe<EverlabOrderWhereInput>;
};

export type EverlabOrderUpsertWithoutShipmentInput = {
  create: EverlabOrderCreateWithoutShipmentInput;
  update: EverlabOrderUpdateWithoutShipmentInput;
  where?: InputMaybe<EverlabOrderWhereInput>;
};

export type EverlabOrderWhereInput = {
  AND?: InputMaybe<Array<EverlabOrderWhereInput>>;
  NOT?: InputMaybe<Array<EverlabOrderWhereInput>>;
  OR?: InputMaybe<Array<EverlabOrderWhereInput>>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  orderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  shipment?: InputMaybe<ShipmentNullableRelationFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrder?: InputMaybe<UserProductOrderRelationFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type EverlabOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<EverlabOrderWhereInput>>;
  NOT?: InputMaybe<Array<EverlabOrderWhereInput>>;
  OR?: InputMaybe<Array<EverlabOrderWhereInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  shipment?: InputMaybe<ShipmentNullableRelationFilter>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrder?: InputMaybe<UserProductOrderRelationFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type ExemptaxCustomerCertificate = {
  __typename?: 'ExemptaxCustomerCertificate';
  certificateId: Scalars['Int']['output'];
  exemptionReason: Scalars['String']['output'];
  expirationDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  state: Scalars['String']['output'];
  status: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ExemptaxCustomerCertificateCreateManyUserInput = {
  certificateId: Scalars['Int']['input'];
  exemptionReason: Scalars['String']['input'];
  expirationDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type ExemptaxCustomerCertificateCreateManyUserInputEnvelope = {
  data: Array<ExemptaxCustomerCertificateCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ExemptaxCustomerCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExemptaxCustomerCertificateCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ExemptaxCustomerCertificateCreateWithoutUserInput>>;
  createMany?: InputMaybe<ExemptaxCustomerCertificateCreateManyUserInputEnvelope>;
};

export type ExemptaxCustomerCertificateCreateOrConnectWithoutUserInput = {
  create: ExemptaxCustomerCertificateCreateWithoutUserInput;
  where: ExemptaxCustomerCertificateWhereUniqueInput;
};

export type ExemptaxCustomerCertificateCreateWithoutUserInput = {
  certificateId: Scalars['Int']['input'];
  exemptionReason: Scalars['String']['input'];
  expirationDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type ExemptaxCustomerCertificateListRelationFilter = {
  every?: InputMaybe<ExemptaxCustomerCertificateWhereInput>;
  none?: InputMaybe<ExemptaxCustomerCertificateWhereInput>;
  some?: InputMaybe<ExemptaxCustomerCertificateWhereInput>;
};

export type ExemptaxCustomerCertificateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ExemptaxCustomerCertificateScalarWhereInput = {
  AND?: InputMaybe<Array<ExemptaxCustomerCertificateScalarWhereInput>>;
  NOT?: InputMaybe<Array<ExemptaxCustomerCertificateScalarWhereInput>>;
  OR?: InputMaybe<Array<ExemptaxCustomerCertificateScalarWhereInput>>;
  certificateId?: InputMaybe<IntFilter>;
  exemptionReason?: InputMaybe<StringFilter>;
  expirationDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  state?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type ExemptaxCustomerCertificateUpdateManyMutationInput = {
  certificateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  exemptionReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  expirationDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ExemptaxCustomerCertificateUpdateManyWithWhereWithoutUserInput = {
  data: ExemptaxCustomerCertificateUpdateManyMutationInput;
  where: ExemptaxCustomerCertificateScalarWhereInput;
};

export type ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ExemptaxCustomerCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExemptaxCustomerCertificateCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ExemptaxCustomerCertificateCreateWithoutUserInput>>;
  createMany?: InputMaybe<ExemptaxCustomerCertificateCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ExemptaxCustomerCertificateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExemptaxCustomerCertificateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExemptaxCustomerCertificateWhereUniqueInput>>;
  set?: InputMaybe<Array<ExemptaxCustomerCertificateWhereUniqueInput>>;
  update?: InputMaybe<Array<ExemptaxCustomerCertificateUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ExemptaxCustomerCertificateUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ExemptaxCustomerCertificateUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ExemptaxCustomerCertificateUpdateWithWhereUniqueWithoutUserInput = {
  data: ExemptaxCustomerCertificateUpdateWithoutUserInput;
  where: ExemptaxCustomerCertificateWhereUniqueInput;
};

export type ExemptaxCustomerCertificateUpdateWithoutUserInput = {
  certificateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  exemptionReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  expirationDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  state?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ExemptaxCustomerCertificateUpsertWithWhereUniqueWithoutUserInput = {
  create: ExemptaxCustomerCertificateCreateWithoutUserInput;
  update: ExemptaxCustomerCertificateUpdateWithoutUserInput;
  where: ExemptaxCustomerCertificateWhereUniqueInput;
};

export type ExemptaxCustomerCertificateWhereInput = {
  AND?: InputMaybe<Array<ExemptaxCustomerCertificateWhereInput>>;
  NOT?: InputMaybe<Array<ExemptaxCustomerCertificateWhereInput>>;
  OR?: InputMaybe<Array<ExemptaxCustomerCertificateWhereInput>>;
  certificateId?: InputMaybe<IntFilter>;
  exemptionReason?: InputMaybe<StringFilter>;
  expirationDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  state?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type ExemptaxCustomerCertificateWhereUniqueInput = {
  AND?: InputMaybe<Array<ExemptaxCustomerCertificateWhereInput>>;
  NOT?: InputMaybe<Array<ExemptaxCustomerCertificateWhereInput>>;
  OR?: InputMaybe<Array<ExemptaxCustomerCertificateWhereInput>>;
  certificateId?: InputMaybe<Scalars['Int']['input']>;
  exemptionReason?: InputMaybe<StringFilter>;
  expirationDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type FbaDueDateUpdateInput = {
  fbaPostPaymentDueDateDays: Scalars['Int']['input'];
  fbaPostPaymentDueDateDaysType: UserPostPaymentDueDateDaysType;
};

export type FindManyInvoiceModelResponse = {
  __typename?: 'FindManyInvoiceModelResponse';
  count: Scalars['Int']['output'];
  items: Array<InvoiceModel>;
};

export type FindManyProductSettingsResponse = {
  __typename?: 'FindManyProductSettingsResponse';
  count: Scalars['Int']['output'];
  items: Array<ProductSettingsModel>;
};

export type FindManyProductStockResponse = {
  __typename?: 'FindManyProductStockResponse';
  count: Scalars['Int']['output'];
  items: Array<ProductStock>;
};

export type FindManyShipmentResponse = {
  __typename?: 'FindManyShipmentResponse';
  count: Scalars['Int']['output'];
  items: Array<Shipment>;
};

export type FindManyUserProductOrderLineResponse = {
  __typename?: 'FindManyUserProductOrderLineResponse';
  count: Scalars['Int']['output'];
  items: Array<UserProductOrderLineModel>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FulfillmentService = {
  __typename?: 'FulfillmentService';
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  platform: EcommercePlatform;
  storeId: Scalars['String']['output'];
};

export type FulfillmentServiceCreateNestedOneWithoutStoreInput = {
  connect?: InputMaybe<FulfillmentServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FulfillmentServiceCreateOrConnectWithoutStoreInput>;
  create?: InputMaybe<FulfillmentServiceCreateWithoutStoreInput>;
};

export type FulfillmentServiceCreateOrConnectWithoutStoreInput = {
  create: FulfillmentServiceCreateWithoutStoreInput;
  where: FulfillmentServiceWhereUniqueInput;
};

export type FulfillmentServiceCreateWithoutStoreInput = {
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  platform: EcommercePlatform;
};

export type FulfillmentServiceNullableRelationFilter = {
  is?: InputMaybe<FulfillmentServiceWhereInput>;
  isNot?: InputMaybe<FulfillmentServiceWhereInput>;
};

export type FulfillmentServiceOrderByWithRelationInput = {
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrderInput>;
  platform?: InputMaybe<SortOrder>;
  store?: InputMaybe<UserStoreOrderByWithRelationInput>;
  storeId?: InputMaybe<SortOrder>;
};

export type FulfillmentServiceUpdateOneWithoutStoreNestedInput = {
  connect?: InputMaybe<FulfillmentServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FulfillmentServiceCreateOrConnectWithoutStoreInput>;
  create?: InputMaybe<FulfillmentServiceCreateWithoutStoreInput>;
  delete?: InputMaybe<FulfillmentServiceWhereInput>;
  disconnect?: InputMaybe<FulfillmentServiceWhereInput>;
  update?: InputMaybe<FulfillmentServiceUpdateToOneWithWhereWithoutStoreInput>;
  upsert?: InputMaybe<FulfillmentServiceUpsertWithoutStoreInput>;
};

export type FulfillmentServiceUpdateToOneWithWhereWithoutStoreInput = {
  data: FulfillmentServiceUpdateWithoutStoreInput;
  where?: InputMaybe<FulfillmentServiceWhereInput>;
};

export type FulfillmentServiceUpdateWithoutStoreInput = {
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  platform?: InputMaybe<EnumEcommercePlatformFieldUpdateOperationsInput>;
};

export type FulfillmentServiceUpsertWithoutStoreInput = {
  create: FulfillmentServiceCreateWithoutStoreInput;
  update: FulfillmentServiceUpdateWithoutStoreInput;
  where?: InputMaybe<FulfillmentServiceWhereInput>;
};

export type FulfillmentServiceWhereInput = {
  AND?: InputMaybe<Array<FulfillmentServiceWhereInput>>;
  NOT?: InputMaybe<Array<FulfillmentServiceWhereInput>>;
  OR?: InputMaybe<Array<FulfillmentServiceWhereInput>>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  platform?: InputMaybe<EnumEcommercePlatformFilter>;
  store?: InputMaybe<UserStoreRelationFilter>;
  storeId?: InputMaybe<UuidFilter>;
};

export type FulfillmentServiceWhereUniqueInput = {
  AND?: InputMaybe<Array<FulfillmentServiceWhereInput>>;
  NOT?: InputMaybe<Array<FulfillmentServiceWhereInput>>;
  OR?: InputMaybe<Array<FulfillmentServiceWhereInput>>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<StringNullableFilter>;
  platform?: InputMaybe<EnumEcommercePlatformFilter>;
  store?: InputMaybe<UserStoreRelationFilter>;
  storeId?: InputMaybe<Scalars['String']['input']>;
};

export type GetBulkShippingDetailsResponse = {
  __typename?: 'GetBulkShippingDetailsResponse';
  _count?: Maybe<BulkShippingCount>;
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  productImageUrl?: Maybe<Scalars['String']['output']>;
  productSku?: Maybe<Scalars['String']['output']>;
  shipments: Array<Shipment>;
  warehouseId: Scalars['String']['output'];
};

export type HoldOrderInput = {
  addCustomHoldReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  addHoldReasons?: InputMaybe<Array<OnHoldReason>>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  removeHoldReasons?: InputMaybe<Array<OnHoldReason>>;
  updateCustomHoldReasons?: InputMaybe<Array<UpdateCustomHoldReasonInput>>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum InvoiceMode {
  Legacy = 'LEGACY',
  Stripe = 'STRIPE',
  StripePostPayment = 'STRIPE_POST_PAYMENT'
}

export type InvoiceModel = {
  __typename?: 'InvoiceModel';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  type: UserInvoiceType;
};

export type JetpackApiOrder = {
  __typename?: 'JetpackApiOrder';
  _count?: Maybe<JetpackApiOrderCount>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userProductOrderId: Scalars['String']['output'];
};

export type JetpackApiOrderCount = {
  __typename?: 'JetpackApiOrderCount';
  orderLines: Scalars['Int']['output'];
};


export type JetpackApiOrderCountOrderLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type JetpackApiOrderCreateManyUserProductOrderInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type JetpackApiOrderCreateManyUserProductOrderInputEnvelope = {
  data: Array<JetpackApiOrderCreateManyUserProductOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput = {
  connect?: InputMaybe<Array<JetpackApiOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JetpackApiOrderCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<JetpackApiOrderCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<JetpackApiOrderCreateManyUserProductOrderInputEnvelope>;
};

export type JetpackApiOrderCreateNestedOneWithoutOrderLinesInput = {
  connect?: InputMaybe<JetpackApiOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<JetpackApiOrderCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<JetpackApiOrderCreateWithoutOrderLinesInput>;
};

export type JetpackApiOrderCreateNestedOneWithoutShipmentInput = {
  connect?: InputMaybe<JetpackApiOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<JetpackApiOrderCreateOrConnectWithoutShipmentInput>;
  create?: InputMaybe<JetpackApiOrderCreateWithoutShipmentInput>;
};

export type JetpackApiOrderCreateOrConnectWithoutOrderLinesInput = {
  create: JetpackApiOrderCreateWithoutOrderLinesInput;
  where: JetpackApiOrderWhereUniqueInput;
};

export type JetpackApiOrderCreateOrConnectWithoutShipmentInput = {
  create: JetpackApiOrderCreateWithoutShipmentInput;
  where: JetpackApiOrderWhereUniqueInput;
};

export type JetpackApiOrderCreateOrConnectWithoutUserProductOrderInput = {
  create: JetpackApiOrderCreateWithoutUserProductOrderInput;
  where: JetpackApiOrderWhereUniqueInput;
};

export type JetpackApiOrderCreateWithoutOrderLinesInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutJetpackApiOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutJetpackApiOrdersInput;
};

export type JetpackApiOrderCreateWithoutShipmentInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutJetpackApiOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutJetpackApiOrdersInput;
};

export type JetpackApiOrderCreateWithoutUserProductOrderInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutJetpackApiOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutJetpackApiOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type JetpackApiOrderListRelationFilter = {
  every?: InputMaybe<JetpackApiOrderWhereInput>;
  none?: InputMaybe<JetpackApiOrderWhereInput>;
  some?: InputMaybe<JetpackApiOrderWhereInput>;
};

export type JetpackApiOrderNullableRelationFilter = {
  is?: InputMaybe<JetpackApiOrderWhereInput>;
  isNot?: InputMaybe<JetpackApiOrderWhereInput>;
};

export type JetpackApiOrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type JetpackApiOrderOrderByWithRelationInput = {
  externalId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  orderLines?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  shipment?: InputMaybe<ShipmentOrderByWithRelationInput>;
  shipmentId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  userProductOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  userProductOrderId?: InputMaybe<SortOrder>;
};

export enum JetpackApiOrderScalarFieldEnum {
  ExternalId = 'externalId',
  Id = 'id',
  ShipmentId = 'shipmentId',
  Status = 'status',
  UserProductOrderId = 'userProductOrderId'
}

export type JetpackApiOrderScalarWhereInput = {
  AND?: InputMaybe<Array<JetpackApiOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<JetpackApiOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<JetpackApiOrderScalarWhereInput>>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type JetpackApiOrderUpdateManyMutationInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type JetpackApiOrderUpdateManyWithWhereWithoutUserProductOrderInput = {
  data: JetpackApiOrderUpdateManyMutationInput;
  where: JetpackApiOrderScalarWhereInput;
};

export type JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput = {
  connect?: InputMaybe<Array<JetpackApiOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JetpackApiOrderCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<JetpackApiOrderCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<JetpackApiOrderCreateManyUserProductOrderInputEnvelope>;
  delete?: InputMaybe<Array<JetpackApiOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<JetpackApiOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<JetpackApiOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<JetpackApiOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<JetpackApiOrderUpdateWithWhereUniqueWithoutUserProductOrderInput>>;
  updateMany?: InputMaybe<Array<JetpackApiOrderUpdateManyWithWhereWithoutUserProductOrderInput>>;
  upsert?: InputMaybe<Array<JetpackApiOrderUpsertWithWhereUniqueWithoutUserProductOrderInput>>;
};

export type JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput = {
  connect?: InputMaybe<JetpackApiOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<JetpackApiOrderCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<JetpackApiOrderCreateWithoutOrderLinesInput>;
  delete?: InputMaybe<JetpackApiOrderWhereInput>;
  disconnect?: InputMaybe<JetpackApiOrderWhereInput>;
  update?: InputMaybe<JetpackApiOrderUpdateToOneWithWhereWithoutOrderLinesInput>;
  upsert?: InputMaybe<JetpackApiOrderUpsertWithoutOrderLinesInput>;
};

export type JetpackApiOrderUpdateOneWithoutShipmentNestedInput = {
  connect?: InputMaybe<JetpackApiOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<JetpackApiOrderCreateOrConnectWithoutShipmentInput>;
  create?: InputMaybe<JetpackApiOrderCreateWithoutShipmentInput>;
  delete?: InputMaybe<JetpackApiOrderWhereInput>;
  disconnect?: InputMaybe<JetpackApiOrderWhereInput>;
  update?: InputMaybe<JetpackApiOrderUpdateToOneWithWhereWithoutShipmentInput>;
  upsert?: InputMaybe<JetpackApiOrderUpsertWithoutShipmentInput>;
};

export type JetpackApiOrderUpdateToOneWithWhereWithoutOrderLinesInput = {
  data: JetpackApiOrderUpdateWithoutOrderLinesInput;
  where?: InputMaybe<JetpackApiOrderWhereInput>;
};

export type JetpackApiOrderUpdateToOneWithWhereWithoutShipmentInput = {
  data: JetpackApiOrderUpdateWithoutShipmentInput;
  where?: InputMaybe<JetpackApiOrderWhereInput>;
};

export type JetpackApiOrderUpdateWithWhereUniqueWithoutUserProductOrderInput = {
  data: JetpackApiOrderUpdateWithoutUserProductOrderInput;
  where: JetpackApiOrderWhereUniqueInput;
};

export type JetpackApiOrderUpdateWithoutOrderLinesInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutJetpackApiOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutJetpackApiOrdersNestedInput>;
};

export type JetpackApiOrderUpdateWithoutShipmentInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutJetpackApiOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutJetpackApiOrdersNestedInput>;
};

export type JetpackApiOrderUpdateWithoutUserProductOrderInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutJetpackApiOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutJetpackApiOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type JetpackApiOrderUpsertWithWhereUniqueWithoutUserProductOrderInput = {
  create: JetpackApiOrderCreateWithoutUserProductOrderInput;
  update: JetpackApiOrderUpdateWithoutUserProductOrderInput;
  where: JetpackApiOrderWhereUniqueInput;
};

export type JetpackApiOrderUpsertWithoutOrderLinesInput = {
  create: JetpackApiOrderCreateWithoutOrderLinesInput;
  update: JetpackApiOrderUpdateWithoutOrderLinesInput;
  where?: InputMaybe<JetpackApiOrderWhereInput>;
};

export type JetpackApiOrderUpsertWithoutShipmentInput = {
  create: JetpackApiOrderCreateWithoutShipmentInput;
  update: JetpackApiOrderUpdateWithoutShipmentInput;
  where?: InputMaybe<JetpackApiOrderWhereInput>;
};

export type JetpackApiOrderWhereInput = {
  AND?: InputMaybe<Array<JetpackApiOrderWhereInput>>;
  NOT?: InputMaybe<Array<JetpackApiOrderWhereInput>>;
  OR?: InputMaybe<Array<JetpackApiOrderWhereInput>>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  orderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  shipment?: InputMaybe<ShipmentNullableRelationFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrder?: InputMaybe<UserProductOrderRelationFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type JetpackApiOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<JetpackApiOrderWhereInput>>;
  NOT?: InputMaybe<Array<JetpackApiOrderWhereInput>>;
  OR?: InputMaybe<Array<JetpackApiOrderWhereInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  shipment?: InputMaybe<ShipmentNullableRelationFilter>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrder?: InputMaybe<UserProductOrderRelationFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type LabelRollCreateManyProductLabelSizeInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  inventory: Scalars['Int']['input'];
  labelsPerRoll: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  reorderThreshold: Scalars['Int']['input'];
  warehouseId: Scalars['String']['input'];
};

export type LabelRollCreateManyProductLabelSizeInputEnvelope = {
  data: Array<LabelRollCreateManyProductLabelSizeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LabelRollCreateManyWarehouseInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  inventory: Scalars['Int']['input'];
  labelsPerRoll: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  productLabelSizeId: Scalars['String']['input'];
  reorderThreshold: Scalars['Int']['input'];
};

export type LabelRollCreateManyWarehouseInputEnvelope = {
  data: Array<LabelRollCreateManyWarehouseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LabelRollCreateNestedManyWithoutProductLabelSizeInput = {
  connect?: InputMaybe<Array<LabelRollWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabelRollCreateOrConnectWithoutProductLabelSizeInput>>;
  create?: InputMaybe<Array<LabelRollCreateWithoutProductLabelSizeInput>>;
  createMany?: InputMaybe<LabelRollCreateManyProductLabelSizeInputEnvelope>;
};

export type LabelRollCreateNestedManyWithoutWarehouseInput = {
  connect?: InputMaybe<Array<LabelRollWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabelRollCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<LabelRollCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<LabelRollCreateManyWarehouseInputEnvelope>;
};

export type LabelRollCreateOrConnectWithoutProductLabelSizeInput = {
  create: LabelRollCreateWithoutProductLabelSizeInput;
  where: LabelRollWhereUniqueInput;
};

export type LabelRollCreateOrConnectWithoutWarehouseInput = {
  create: LabelRollCreateWithoutWarehouseInput;
  where: LabelRollWhereUniqueInput;
};

export type LabelRollCreateWithoutProductLabelSizeInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  inventory: Scalars['Int']['input'];
  labelsPerRoll: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  reorderThreshold: Scalars['Int']['input'];
  warehouse: WarehouseCreateNestedOneWithoutLabelRollInput;
};

export type LabelRollCreateWithoutWarehouseInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  inventory: Scalars['Int']['input'];
  labelsPerRoll: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  productLabelSize: ProductLabelSizeCreateNestedOneWithoutLabelRollInput;
  reorderThreshold: Scalars['Int']['input'];
};

export type LabelRollListRelationFilter = {
  every?: InputMaybe<LabelRollWhereInput>;
  none?: InputMaybe<LabelRollWhereInput>;
  some?: InputMaybe<LabelRollWhereInput>;
};

export type LabelRollOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LabelRollScalarWhereInput = {
  AND?: InputMaybe<Array<LabelRollScalarWhereInput>>;
  NOT?: InputMaybe<Array<LabelRollScalarWhereInput>>;
  OR?: InputMaybe<Array<LabelRollScalarWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  inventory?: InputMaybe<IntFilter>;
  labelsPerRoll?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  productLabelSizeId?: InputMaybe<UuidFilter>;
  reorderThreshold?: InputMaybe<IntFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type LabelRollUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inventory?: InputMaybe<IntFieldUpdateOperationsInput>;
  labelsPerRoll?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  reorderThreshold?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type LabelRollUpdateManyWithWhereWithoutProductLabelSizeInput = {
  data: LabelRollUpdateManyMutationInput;
  where: LabelRollScalarWhereInput;
};

export type LabelRollUpdateManyWithWhereWithoutWarehouseInput = {
  data: LabelRollUpdateManyMutationInput;
  where: LabelRollScalarWhereInput;
};

export type LabelRollUpdateManyWithoutProductLabelSizeNestedInput = {
  connect?: InputMaybe<Array<LabelRollWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabelRollCreateOrConnectWithoutProductLabelSizeInput>>;
  create?: InputMaybe<Array<LabelRollCreateWithoutProductLabelSizeInput>>;
  createMany?: InputMaybe<LabelRollCreateManyProductLabelSizeInputEnvelope>;
  delete?: InputMaybe<Array<LabelRollWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LabelRollScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LabelRollWhereUniqueInput>>;
  set?: InputMaybe<Array<LabelRollWhereUniqueInput>>;
  update?: InputMaybe<Array<LabelRollUpdateWithWhereUniqueWithoutProductLabelSizeInput>>;
  updateMany?: InputMaybe<Array<LabelRollUpdateManyWithWhereWithoutProductLabelSizeInput>>;
  upsert?: InputMaybe<Array<LabelRollUpsertWithWhereUniqueWithoutProductLabelSizeInput>>;
};

export type LabelRollUpdateManyWithoutWarehouseNestedInput = {
  connect?: InputMaybe<Array<LabelRollWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabelRollCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<LabelRollCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<LabelRollCreateManyWarehouseInputEnvelope>;
  delete?: InputMaybe<Array<LabelRollWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LabelRollScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LabelRollWhereUniqueInput>>;
  set?: InputMaybe<Array<LabelRollWhereUniqueInput>>;
  update?: InputMaybe<Array<LabelRollUpdateWithWhereUniqueWithoutWarehouseInput>>;
  updateMany?: InputMaybe<Array<LabelRollUpdateManyWithWhereWithoutWarehouseInput>>;
  upsert?: InputMaybe<Array<LabelRollUpsertWithWhereUniqueWithoutWarehouseInput>>;
};

export type LabelRollUpdateWithWhereUniqueWithoutProductLabelSizeInput = {
  data: LabelRollUpdateWithoutProductLabelSizeInput;
  where: LabelRollWhereUniqueInput;
};

export type LabelRollUpdateWithWhereUniqueWithoutWarehouseInput = {
  data: LabelRollUpdateWithoutWarehouseInput;
  where: LabelRollWhereUniqueInput;
};

export type LabelRollUpdateWithoutProductLabelSizeInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inventory?: InputMaybe<IntFieldUpdateOperationsInput>;
  labelsPerRoll?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  reorderThreshold?: InputMaybe<IntFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutLabelRollNestedInput>;
};

export type LabelRollUpdateWithoutWarehouseInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inventory?: InputMaybe<IntFieldUpdateOperationsInput>;
  labelsPerRoll?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  productLabelSize?: InputMaybe<ProductLabelSizeUpdateOneRequiredWithoutLabelRollNestedInput>;
  reorderThreshold?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type LabelRollUpsertWithWhereUniqueWithoutProductLabelSizeInput = {
  create: LabelRollCreateWithoutProductLabelSizeInput;
  update: LabelRollUpdateWithoutProductLabelSizeInput;
  where: LabelRollWhereUniqueInput;
};

export type LabelRollUpsertWithWhereUniqueWithoutWarehouseInput = {
  create: LabelRollCreateWithoutWarehouseInput;
  update: LabelRollUpdateWithoutWarehouseInput;
  where: LabelRollWhereUniqueInput;
};

export type LabelRollWhereInput = {
  AND?: InputMaybe<Array<LabelRollWhereInput>>;
  NOT?: InputMaybe<Array<LabelRollWhereInput>>;
  OR?: InputMaybe<Array<LabelRollWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  inventory?: InputMaybe<IntFilter>;
  labelsPerRoll?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  productLabelSize?: InputMaybe<ProductLabelSizeRelationFilter>;
  productLabelSizeId?: InputMaybe<UuidFilter>;
  reorderThreshold?: InputMaybe<IntFilter>;
  warehouse?: InputMaybe<WarehouseRelationFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type LabelRollWhereUniqueInput = {
  AND?: InputMaybe<Array<LabelRollWhereInput>>;
  NOT?: InputMaybe<Array<LabelRollWhereInput>>;
  OR?: InputMaybe<Array<LabelRollWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  inventory?: InputMaybe<IntFilter>;
  labelsPerRoll?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  productLabelSize?: InputMaybe<ProductLabelSizeRelationFilter>;
  productLabelSizeId?: InputMaybe<UuidFilter>;
  reorderThreshold?: InputMaybe<IntFilter>;
  warehouse?: InputMaybe<WarehouseRelationFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export enum LabelTransitionAdminStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type LabelTransitionCreateManyStripeInvoiceInput = {
  adminStatus?: InputMaybe<LabelTransitionAdminStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  resultFileKey?: InputMaybe<Scalars['String']['input']>;
  resultMetadata?: InputMaybe<Scalars['JSON']['input']>;
  sourceFileId?: InputMaybe<Scalars['String']['input']>;
  sourceImageFileKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductId: Scalars['String']['input'];
};

export type LabelTransitionCreateManyStripeInvoiceInputEnvelope = {
  data: Array<LabelTransitionCreateManyStripeInvoiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LabelTransitionCreateNestedManyWithoutStripeInvoiceInput = {
  connect?: InputMaybe<Array<LabelTransitionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabelTransitionCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: InputMaybe<Array<LabelTransitionCreateWithoutStripeInvoiceInput>>;
  createMany?: InputMaybe<LabelTransitionCreateManyStripeInvoiceInputEnvelope>;
};

export type LabelTransitionCreateOrConnectWithoutStripeInvoiceInput = {
  create: LabelTransitionCreateWithoutStripeInvoiceInput;
  where: LabelTransitionWhereUniqueInput;
};

export type LabelTransitionCreateWithoutStripeInvoiceInput = {
  adminStatus?: InputMaybe<LabelTransitionAdminStatus>;
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  resultFileKey?: InputMaybe<Scalars['String']['input']>;
  resultMetadata?: InputMaybe<Scalars['JSON']['input']>;
  sourceImageFileKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LabelTransitionListRelationFilter = {
  every?: InputMaybe<LabelTransitionWhereInput>;
  none?: InputMaybe<LabelTransitionWhereInput>;
  some?: InputMaybe<LabelTransitionWhereInput>;
};

export type LabelTransitionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LabelTransitionScalarWhereInput = {
  AND?: InputMaybe<Array<LabelTransitionScalarWhereInput>>;
  NOT?: InputMaybe<Array<LabelTransitionScalarWhereInput>>;
  OR?: InputMaybe<Array<LabelTransitionScalarWhereInput>>;
  adminStatus?: InputMaybe<EnumLabelTransitionAdminStatusFilter>;
  approvedAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  resultFileKey?: InputMaybe<StringNullableFilter>;
  resultMetadata?: InputMaybe<JsonNullableFilter>;
  sourceFileId?: InputMaybe<UuidNullableFilter>;
  sourceImageFileKey?: InputMaybe<StringNullableFilter>;
  stripeInvoiceId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProductId?: InputMaybe<UuidFilter>;
};

export type LabelTransitionUpdateManyMutationInput = {
  adminStatus?: InputMaybe<EnumLabelTransitionAdminStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  resultFileKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resultMetadata?: InputMaybe<Scalars['JSON']['input']>;
  sourceImageFileKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LabelTransitionUpdateManyWithWhereWithoutStripeInvoiceInput = {
  data: LabelTransitionUpdateManyMutationInput;
  where: LabelTransitionScalarWhereInput;
};

export type LabelTransitionUpdateManyWithoutStripeInvoiceNestedInput = {
  connect?: InputMaybe<Array<LabelTransitionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabelTransitionCreateOrConnectWithoutStripeInvoiceInput>>;
  create?: InputMaybe<Array<LabelTransitionCreateWithoutStripeInvoiceInput>>;
  createMany?: InputMaybe<LabelTransitionCreateManyStripeInvoiceInputEnvelope>;
  delete?: InputMaybe<Array<LabelTransitionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LabelTransitionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LabelTransitionWhereUniqueInput>>;
  set?: InputMaybe<Array<LabelTransitionWhereUniqueInput>>;
  update?: InputMaybe<Array<LabelTransitionUpdateWithWhereUniqueWithoutStripeInvoiceInput>>;
  updateMany?: InputMaybe<Array<LabelTransitionUpdateManyWithWhereWithoutStripeInvoiceInput>>;
  upsert?: InputMaybe<Array<LabelTransitionUpsertWithWhereUniqueWithoutStripeInvoiceInput>>;
};

export type LabelTransitionUpdateWithWhereUniqueWithoutStripeInvoiceInput = {
  data: LabelTransitionUpdateWithoutStripeInvoiceInput;
  where: LabelTransitionWhereUniqueInput;
};

export type LabelTransitionUpdateWithoutStripeInvoiceInput = {
  adminStatus?: InputMaybe<EnumLabelTransitionAdminStatusFieldUpdateOperationsInput>;
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  resultFileKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resultMetadata?: InputMaybe<Scalars['JSON']['input']>;
  sourceImageFileKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LabelTransitionUpsertWithWhereUniqueWithoutStripeInvoiceInput = {
  create: LabelTransitionCreateWithoutStripeInvoiceInput;
  update: LabelTransitionUpdateWithoutStripeInvoiceInput;
  where: LabelTransitionWhereUniqueInput;
};

export type LabelTransitionWhereInput = {
  AND?: InputMaybe<Array<LabelTransitionWhereInput>>;
  NOT?: InputMaybe<Array<LabelTransitionWhereInput>>;
  OR?: InputMaybe<Array<LabelTransitionWhereInput>>;
  adminStatus?: InputMaybe<EnumLabelTransitionAdminStatusFilter>;
  approvedAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  resultFileKey?: InputMaybe<StringNullableFilter>;
  resultMetadata?: InputMaybe<JsonNullableFilter>;
  sourceFileId?: InputMaybe<UuidNullableFilter>;
  sourceImageFileKey?: InputMaybe<StringNullableFilter>;
  stripeInvoiceId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProductId?: InputMaybe<UuidFilter>;
};

export type LabelTransitionWhereUniqueInput = {
  AND?: InputMaybe<Array<LabelTransitionWhereInput>>;
  NOT?: InputMaybe<Array<LabelTransitionWhereInput>>;
  OR?: InputMaybe<Array<LabelTransitionWhereInput>>;
  adminStatus?: InputMaybe<EnumLabelTransitionAdminStatusFilter>;
  approvedAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  resultFileKey?: InputMaybe<StringNullableFilter>;
  resultMetadata?: InputMaybe<JsonNullableFilter>;
  sourceFileId?: InputMaybe<UuidNullableFilter>;
  sourceImageFileKey?: InputMaybe<StringNullableFilter>;
  stripeInvoiceId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProductId?: InputMaybe<UuidFilter>;
};

export enum LengthUnit {
  Centimeter = 'CENTIMETER',
  Inch = 'INCH',
  Millimeter = 'MILLIMETER'
}

export type LineItemResult = {
  __typename?: 'LineItemResult';
  lineId: Scalars['String']['output'];
  success: SuccessResponse;
};

export type LineItemToShip = {
  __typename?: 'LineItemToShip';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type MarkOrderLineItemPreparedInput = {
  isPrepared: Scalars['Boolean']['input'];
  lineId: Scalars['String']['input'];
  subLineId?: InputMaybe<Scalars['String']['input']>;
  unprepareReason?: InputMaybe<UnprepareReason>;
};

export type MarkShipmentsAsShippedInput = {
  carrierId: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  adminRefundOrder: SuccessResponse;
  chargeReshipment: SuccessResponse;
  createBulkShipping: CreateBulkShippingResponse;
  createDigitalServiceProduct: DigitalServiceProduct;
  createOneCatalogBanner: CatalogBanner;
  createOneCatalogBannerCollection: CatalogBannerCollection;
  createOneProductLabelSize: ProductLabelSize;
  createOneProductStock: ProductStock;
  createOneWarehouseShelf: WarehouseShelf;
  createPrintBatchAndConnectOrderLines: CreatePrintBatchAndConnectOrderLinesResult;
  createProductStockSnapshot: SuccessResponse;
  createQuickShipment?: Maybe<Shipment>;
  createQuickShipmentsFromPrintBatch: CreateQuickShipmentsFromPrintBatchResponse;
  createShipment: Shipment;
  createShipmentBatch?: Maybe<ShipmentBatch>;
  deleteOneProductLabelSize?: Maybe<ProductLabelSize>;
  deleteOneWarehouseShelf?: Maybe<WarehouseShelf>;
  holdOrders: Array<UserProductOrderModel>;
  importExtendedCatalogProducts: ProductsImportResponse;
  importProductStockQuantity: ProductsImportResponse;
  importProductsSettings: ProductsImportResponse;
  manualUserCreditsTransaction?: Maybe<UserCreditsTransaction>;
  markBulkShippingShipmentsAsReadyToShip: SuccessResponse;
  markOrderLineItemPrepared: SuccessResponse;
  markShipmentsAsShipped?: Maybe<Scalars['Float']['output']>;
  ownAutoGeneratedShipment: Shipment;
  removeCatalogBanner: SuccessResponse;
  removeCatalogBannerCollection: SuccessResponse;
  reportLabelIssue: SuccessResponse;
  resetActivePrintBatchesOfSku: SuccessResponse;
  reship: Shipment;
  setLineItemCountPrepared: SuccessResponse;
  setLineItemCountPreparedInBulk: SetLineItemCountPreparedInBulkResponse;
  setOrderLock: SuccessResponse;
  setPriorityLaneFulfillment: UserModel;
  shipmentMarkAsReadyToShip: SuccessResponse;
  shipmentMarkAsReturned: SuccessResponse;
  shipmentRefundAndDelete: SuccessResponse;
  shopifyStoreAction: SuccessResponse;
  updateBulkDueDate: UserProductOrderModel;
  updateFbaDueDate: UserProductOrderModel;
  updateOneCatalogBanner?: Maybe<CatalogBanner>;
  updateOneCatalogBannerCollection?: Maybe<CatalogBannerCollection>;
  updateOneDigitalServiceProduct?: Maybe<DigitalServiceProduct>;
  updateOneProductLabelSize?: Maybe<ProductLabelSize>;
  updateOneProductStock?: Maybe<ProductStock>;
  updateOneWarehouseShelf: WarehouseShelf;
  updateOneWarehouseShelfReturnBin?: Maybe<WarehouseShelfReturnBin>;
  updateOrder: UserProductOrderModel;
  updateProductRestockDate?: Maybe<Array<ProductPublisherModel>>;
  updateProductSettings: ProductSettingsModel;
  updateUser: UserModel;
  updateUserProductOrderLineWarehouse: SuccessResponse;
};


export type MutationAdminRefundOrderArgs = {
  cancelRefundedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  data: RefundOrderInput;
  orderId: Scalars['String']['input'];
};


export type MutationChargeReshipmentArgs = {
  shipmentId: Scalars['String']['input'];
};


export type MutationCreateBulkShippingArgs = {
  data: CreateBulkShippingInput;
};


export type MutationCreateDigitalServiceProductArgs = {
  input: DigitalServiceProductCreateWithoutCreatedByInput;
};


export type MutationCreateOneCatalogBannerArgs = {
  data: CatalogBannerCreateInput;
};


export type MutationCreateOneCatalogBannerCollectionArgs = {
  data: CatalogBannerCollectionCreateInput;
};


export type MutationCreateOneProductLabelSizeArgs = {
  data: ProductLabelSizeCreateInput;
};


export type MutationCreateOneProductStockArgs = {
  data: ProductStockCreateInput;
};


export type MutationCreateOneWarehouseShelfArgs = {
  data: CreateWarehouseShelfInput;
};


export type MutationCreatePrintBatchAndConnectOrderLinesArgs = {
  data: CreatePrintBatchAndConnectOrderLinesInput;
};


export type MutationCreateProductStockSnapshotArgs = {
  data: CreateProductStockSnapshotInput;
};


export type MutationCreateQuickShipmentArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationCreateQuickShipmentsFromPrintBatchArgs = {
  data: CreateQuickShipmentsFromPrintBatchInput;
};


export type MutationCreateShipmentArgs = {
  input: CreateShipmentInput;
};


export type MutationCreateShipmentBatchArgs = {
  input: CreateShipmentBatchInput;
};


export type MutationDeleteOneProductLabelSizeArgs = {
  where: ProductLabelSizeWhereUniqueInput;
};


export type MutationDeleteOneWarehouseShelfArgs = {
  where: WarehouseShelfWhereUniqueInput;
};


export type MutationHoldOrdersArgs = {
  data: HoldOrderInput;
  orderIds: Array<Scalars['String']['input']>;
};


export type MutationImportExtendedCatalogProductsArgs = {
  data: ProductsSettingsImportInput;
};


export type MutationImportProductStockQuantityArgs = {
  data: ProductStockQuantityImportInput;
};


export type MutationImportProductsSettingsArgs = {
  data: ProductsSettingsImportInput;
};


export type MutationManualUserCreditsTransactionArgs = {
  amountCents: Scalars['Int']['input'];
  manualCreditChangeReason: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationMarkBulkShippingShipmentsAsReadyToShipArgs = {
  bulkShippingId: Scalars['Float']['input'];
};


export type MutationMarkOrderLineItemPreparedArgs = {
  data: MarkOrderLineItemPreparedInput;
};


export type MutationMarkShipmentsAsShippedArgs = {
  input: MarkShipmentsAsShippedInput;
};


export type MutationOwnAutoGeneratedShipmentArgs = {
  shipmentId: Scalars['String']['input'];
};


export type MutationRemoveCatalogBannerArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCatalogBannerCollectionArgs = {
  id: Scalars['String']['input'];
};


export type MutationReportLabelIssueArgs = {
  data: ReportLabelIssueInput;
};


export type MutationResetActivePrintBatchesOfSkuArgs = {
  sku: Scalars['String']['input'];
};


export type MutationReshipArgs = {
  input: ReshipInput;
};


export type MutationSetLineItemCountPreparedArgs = {
  data: SetLineItemCountPreparedInput;
};


export type MutationSetLineItemCountPreparedInBulkArgs = {
  data: SetLineItemCountPreparedInBulkInput;
};


export type MutationSetOrderLockArgs = {
  data: SetOrderLockInput;
};


export type MutationSetPriorityLaneFulfillmentArgs = {
  data: SetPriorityLaneFulfillmentInput;
  id: Scalars['String']['input'];
};


export type MutationShipmentMarkAsReadyToShipArgs = {
  shipmentId: Scalars['String']['input'];
};


export type MutationShipmentMarkAsReturnedArgs = {
  shipmentId: Scalars['String']['input'];
};


export type MutationShipmentRefundAndDeleteArgs = {
  shipmentId: Scalars['String']['input'];
};


export type MutationShopifyStoreActionArgs = {
  data: ShopifyStoreActionInput;
};


export type MutationUpdateBulkDueDateArgs = {
  data: BulkDueDateUpdateInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateFbaDueDateArgs = {
  data: FbaDueDateUpdateInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateOneCatalogBannerArgs = {
  data: CatalogBannerUpdateInput;
  where: CatalogBannerWhereUniqueInput;
};


export type MutationUpdateOneCatalogBannerCollectionArgs = {
  data: CatalogBannerCollectionUpdateInput;
  where: CatalogBannerCollectionWhereUniqueInput;
};


export type MutationUpdateOneDigitalServiceProductArgs = {
  data: DigitalServiceProductUpdateInput;
  where: DigitalServiceProductWhereUniqueInput;
};


export type MutationUpdateOneProductLabelSizeArgs = {
  data: ProductLabelSizeUpdateInput;
  where: ProductLabelSizeWhereUniqueInput;
};


export type MutationUpdateOneProductStockArgs = {
  data: ProductStockUpdateInput;
  where: ProductStockWhereUniqueInput;
};


export type MutationUpdateOneWarehouseShelfArgs = {
  data: UpdateWarehouseShelfInput;
  where: WarehouseShelfWhereUniqueInput;
};


export type MutationUpdateOneWarehouseShelfReturnBinArgs = {
  data: WarehouseShelfReturnBinUpdateInput;
  where: WarehouseShelfReturnBinWhereUniqueInput;
};


export type MutationUpdateOrderArgs = {
  data: OrderUpdateInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateProductRestockDateArgs = {
  data: UpdateProductRestockDateInput;
  productId: Scalars['String']['input'];
};


export type MutationUpdateProductSettingsArgs = {
  data: ProductSettingsUpdateInput;
  where: ProductSettingsWhereUniqueInput;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateUserProductOrderLineWarehouseArgs = {
  lineId: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
};

export type NestedBigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumEcommercePlatformFilter = {
  equals?: InputMaybe<EcommercePlatform>;
  in?: InputMaybe<Array<EcommercePlatform>>;
  not?: InputMaybe<NestedEnumEcommercePlatformFilter>;
  notIn?: InputMaybe<Array<EcommercePlatform>>;
};

export type NestedEnumInvoiceModeFilter = {
  equals?: InputMaybe<InvoiceMode>;
  in?: InputMaybe<Array<InvoiceMode>>;
  not?: InputMaybe<NestedEnumInvoiceModeFilter>;
  notIn?: InputMaybe<Array<InvoiceMode>>;
};

export type NestedEnumLabelTransitionAdminStatusFilter = {
  equals?: InputMaybe<LabelTransitionAdminStatus>;
  in?: InputMaybe<Array<LabelTransitionAdminStatus>>;
  not?: InputMaybe<NestedEnumLabelTransitionAdminStatusFilter>;
  notIn?: InputMaybe<Array<LabelTransitionAdminStatus>>;
};

export type NestedEnumLengthUnitFilter = {
  equals?: InputMaybe<LengthUnit>;
  in?: InputMaybe<Array<LengthUnit>>;
  not?: InputMaybe<NestedEnumLengthUnitFilter>;
  notIn?: InputMaybe<Array<LengthUnit>>;
};

export type NestedEnumOnHoldReasonFilter = {
  equals?: InputMaybe<OnHoldReason>;
  in?: InputMaybe<Array<OnHoldReason>>;
  not?: InputMaybe<NestedEnumOnHoldReasonFilter>;
  notIn?: InputMaybe<Array<OnHoldReason>>;
};

export type NestedEnumPostPaymentOrdersBucketStatusFilter = {
  equals?: InputMaybe<PostPaymentOrdersBucketStatus>;
  in?: InputMaybe<Array<PostPaymentOrdersBucketStatus>>;
  not?: InputMaybe<NestedEnumPostPaymentOrdersBucketStatusFilter>;
  notIn?: InputMaybe<Array<PostPaymentOrdersBucketStatus>>;
};

export type NestedEnumProductLabellingTechniqueFilter = {
  equals?: InputMaybe<ProductLabellingTechnique>;
  in?: InputMaybe<Array<ProductLabellingTechnique>>;
  not?: InputMaybe<NestedEnumProductLabellingTechniqueFilter>;
  notIn?: InputMaybe<Array<ProductLabellingTechnique>>;
};

export type NestedEnumProductStatusFilter = {
  equals?: InputMaybe<ProductStatus>;
  in?: InputMaybe<Array<ProductStatus>>;
  not?: InputMaybe<NestedEnumProductStatusFilter>;
  notIn?: InputMaybe<Array<ProductStatus>>;
};

export type NestedEnumProductVariantKindFilter = {
  equals?: InputMaybe<ProductVariantKind>;
  in?: InputMaybe<Array<ProductVariantKind>>;
  not?: InputMaybe<NestedEnumProductVariantKindFilter>;
  notIn?: InputMaybe<Array<ProductVariantKind>>;
};

export type NestedEnumServicePurchaseStatusFilter = {
  equals?: InputMaybe<ServicePurchaseStatus>;
  in?: InputMaybe<Array<ServicePurchaseStatus>>;
  not?: InputMaybe<NestedEnumServicePurchaseStatusFilter>;
  notIn?: InputMaybe<Array<ServicePurchaseStatus>>;
};

export type NestedEnumShipmentStatusFilter = {
  equals?: InputMaybe<ShipmentStatus>;
  in?: InputMaybe<Array<ShipmentStatus>>;
  not?: InputMaybe<NestedEnumShipmentStatusFilter>;
  notIn?: InputMaybe<Array<ShipmentStatus>>;
};

export type NestedEnumSocialNetworkNullableFilter = {
  equals?: InputMaybe<SocialNetwork>;
  in?: InputMaybe<Array<SocialNetwork>>;
  not?: InputMaybe<NestedEnumSocialNetworkNullableFilter>;
  notIn?: InputMaybe<Array<SocialNetwork>>;
};

export type NestedEnumStripeCreditNoteKindFilter = {
  equals?: InputMaybe<StripeCreditNoteKind>;
  in?: InputMaybe<Array<StripeCreditNoteKind>>;
  not?: InputMaybe<NestedEnumStripeCreditNoteKindFilter>;
  notIn?: InputMaybe<Array<StripeCreditNoteKind>>;
};

export type NestedEnumStripeCreditNoteReasonNullableFilter = {
  equals?: InputMaybe<StripeCreditNoteReason>;
  in?: InputMaybe<Array<StripeCreditNoteReason>>;
  not?: InputMaybe<NestedEnumStripeCreditNoteReasonNullableFilter>;
  notIn?: InputMaybe<Array<StripeCreditNoteReason>>;
};

export type NestedEnumStripeCreditNoteStatusFilter = {
  equals?: InputMaybe<StripeCreditNoteStatus>;
  in?: InputMaybe<Array<StripeCreditNoteStatus>>;
  not?: InputMaybe<NestedEnumStripeCreditNoteStatusFilter>;
  notIn?: InputMaybe<Array<StripeCreditNoteStatus>>;
};

export type NestedEnumStripeCreditNoteTypeFilter = {
  equals?: InputMaybe<StripeCreditNoteType>;
  in?: InputMaybe<Array<StripeCreditNoteType>>;
  not?: InputMaybe<NestedEnumStripeCreditNoteTypeFilter>;
  notIn?: InputMaybe<Array<StripeCreditNoteType>>;
};

export type NestedEnumStripeInvoiceKindFilter = {
  equals?: InputMaybe<StripeInvoiceKind>;
  in?: InputMaybe<Array<StripeInvoiceKind>>;
  not?: InputMaybe<NestedEnumStripeInvoiceKindFilter>;
  notIn?: InputMaybe<Array<StripeInvoiceKind>>;
};

export type NestedEnumStripeInvoiceStatusNullableFilter = {
  equals?: InputMaybe<StripeInvoiceStatus>;
  in?: InputMaybe<Array<StripeInvoiceStatus>>;
  not?: InputMaybe<NestedEnumStripeInvoiceStatusNullableFilter>;
  notIn?: InputMaybe<Array<StripeInvoiceStatus>>;
};

export type NestedEnumUnprepareReasonNullableFilter = {
  equals?: InputMaybe<UnprepareReason>;
  in?: InputMaybe<Array<UnprepareReason>>;
  not?: InputMaybe<NestedEnumUnprepareReasonNullableFilter>;
  notIn?: InputMaybe<Array<UnprepareReason>>;
};

export type NestedEnumUserCategoryNullableFilter = {
  equals?: InputMaybe<UserCategory>;
  in?: InputMaybe<Array<UserCategory>>;
  not?: InputMaybe<NestedEnumUserCategoryNullableFilter>;
  notIn?: InputMaybe<Array<UserCategory>>;
};

export type NestedEnumUserCreditsTransactionTypeFilter = {
  equals?: InputMaybe<UserCreditsTransactionType>;
  in?: InputMaybe<Array<UserCreditsTransactionType>>;
  not?: InputMaybe<NestedEnumUserCreditsTransactionTypeFilter>;
  notIn?: InputMaybe<Array<UserCreditsTransactionType>>;
};

export type NestedEnumUserInvoiceTypeFilter = {
  equals?: InputMaybe<UserInvoiceType>;
  in?: InputMaybe<Array<UserInvoiceType>>;
  not?: InputMaybe<NestedEnumUserInvoiceTypeFilter>;
  notIn?: InputMaybe<Array<UserInvoiceType>>;
};

export type NestedEnumUserPaymentProcessorFilter = {
  equals?: InputMaybe<UserPaymentProcessor>;
  in?: InputMaybe<Array<UserPaymentProcessor>>;
  not?: InputMaybe<NestedEnumUserPaymentProcessorFilter>;
  notIn?: InputMaybe<Array<UserPaymentProcessor>>;
};

export type NestedEnumUserPostPaymentDueDateDaysTypeFilter = {
  equals?: InputMaybe<UserPostPaymentDueDateDaysType>;
  in?: InputMaybe<Array<UserPostPaymentDueDateDaysType>>;
  not?: InputMaybe<NestedEnumUserPostPaymentDueDateDaysTypeFilter>;
  notIn?: InputMaybe<Array<UserPostPaymentDueDateDaysType>>;
};

export type NestedEnumUserPostPaymentDueDateDaysTypeNullableFilter = {
  equals?: InputMaybe<UserPostPaymentDueDateDaysType>;
  in?: InputMaybe<Array<UserPostPaymentDueDateDaysType>>;
  not?: InputMaybe<NestedEnumUserPostPaymentDueDateDaysTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserPostPaymentDueDateDaysType>>;
};

export type NestedEnumUserProductFileKindFilter = {
  equals?: InputMaybe<UserProductFileKind>;
  in?: InputMaybe<Array<UserProductFileKind>>;
  not?: InputMaybe<NestedEnumUserProductFileKindFilter>;
  notIn?: InputMaybe<Array<UserProductFileKind>>;
};

export type NestedEnumUserProductOrderKindFilter = {
  equals?: InputMaybe<UserProductOrderKind>;
  in?: InputMaybe<Array<UserProductOrderKind>>;
  not?: InputMaybe<NestedEnumUserProductOrderKindFilter>;
  notIn?: InputMaybe<Array<UserProductOrderKind>>;
};

export type NestedEnumUserProductOrderLineFulfillmentFeeTypeFilter = {
  equals?: InputMaybe<UserProductOrderLineFulfillmentFeeType>;
  in?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeType>>;
  not?: InputMaybe<NestedEnumUserProductOrderLineFulfillmentFeeTypeFilter>;
  notIn?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeType>>;
};

export type NestedEnumUserProductOrderManualPaymentKindFilter = {
  equals?: InputMaybe<UserProductOrderManualPaymentKind>;
  in?: InputMaybe<Array<UserProductOrderManualPaymentKind>>;
  not?: InputMaybe<NestedEnumUserProductOrderManualPaymentKindFilter>;
  notIn?: InputMaybe<Array<UserProductOrderManualPaymentKind>>;
};

export type NestedEnumUserProductOrderManualPaymentStatusFilter = {
  equals?: InputMaybe<UserProductOrderManualPaymentStatus>;
  in?: InputMaybe<Array<UserProductOrderManualPaymentStatus>>;
  not?: InputMaybe<NestedEnumUserProductOrderManualPaymentStatusFilter>;
  notIn?: InputMaybe<Array<UserProductOrderManualPaymentStatus>>;
};

export type NestedEnumUserProductOrderPaymentStatusNullableFilter = {
  equals?: InputMaybe<UserProductOrderPaymentStatus>;
  in?: InputMaybe<Array<UserProductOrderPaymentStatus>>;
  not?: InputMaybe<NestedEnumUserProductOrderPaymentStatusNullableFilter>;
  notIn?: InputMaybe<Array<UserProductOrderPaymentStatus>>;
};

export type NestedEnumUserProductOrderStatusFilter = {
  equals?: InputMaybe<UserProductOrderStatus>;
  in?: InputMaybe<Array<UserProductOrderStatus>>;
  not?: InputMaybe<NestedEnumUserProductOrderStatusFilter>;
  notIn?: InputMaybe<Array<UserProductOrderStatus>>;
};

export type NestedEnumUserSubscriptionBillingIntervalFilter = {
  equals?: InputMaybe<UserSubscriptionBillingInterval>;
  in?: InputMaybe<Array<UserSubscriptionBillingInterval>>;
  not?: InputMaybe<NestedEnumUserSubscriptionBillingIntervalFilter>;
  notIn?: InputMaybe<Array<UserSubscriptionBillingInterval>>;
};

export type NestedEnumUserSubscriptionEventTypeFilter = {
  equals?: InputMaybe<UserSubscriptionEventType>;
  in?: InputMaybe<Array<UserSubscriptionEventType>>;
  not?: InputMaybe<NestedEnumUserSubscriptionEventTypeFilter>;
  notIn?: InputMaybe<Array<UserSubscriptionEventType>>;
};

export type NestedEnumUserSubscriptionStatusFilter = {
  equals?: InputMaybe<UserSubscriptionStatus>;
  in?: InputMaybe<Array<UserSubscriptionStatus>>;
  not?: InputMaybe<NestedEnumUserSubscriptionStatusFilter>;
  notIn?: InputMaybe<Array<UserSubscriptionStatus>>;
};

export type NestedEnumUserSubscriptionTierFilter = {
  equals?: InputMaybe<UserSubscriptionTier>;
  in?: InputMaybe<Array<UserSubscriptionTier>>;
  not?: InputMaybe<NestedEnumUserSubscriptionTierFilter>;
  notIn?: InputMaybe<Array<UserSubscriptionTier>>;
};

export type NestedEnumWarehouseShelfTypeFilter = {
  equals?: InputMaybe<WarehouseShelfType>;
  in?: InputMaybe<Array<WarehouseShelfType>>;
  not?: InputMaybe<NestedEnumWarehouseShelfTypeFilter>;
  notIn?: InputMaybe<Array<WarehouseShelfType>>;
};

export type NestedEnumWeightUnitFilter = {
  equals?: InputMaybe<WeightUnit>;
  in?: InputMaybe<Array<WeightUnit>>;
  not?: InputMaybe<NestedEnumWeightUnitFilter>;
  notIn?: InputMaybe<Array<WeightUnit>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedUuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedUuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum NotificationReason {
  FulfillmentRequestRejected = 'FULFILLMENT_REQUEST_REJECTED',
  OrderShipped = 'ORDER_SHIPPED',
  PaymentFailed = 'PAYMENT_FAILED',
  ProductOutOfStock = 'PRODUCT_OUT_OF_STOCK',
  StorefrontOrderConfirmation = 'STOREFRONT_ORDER_CONFIRMATION',
  StorefrontOrderShipped = 'STOREFRONT_ORDER_SHIPPED',
  WoocommerceOrderImportedPartially = 'WOOCOMMERCE_ORDER_IMPORTED_PARTIALLY',
  WoocommerceOrderRejected = 'WOOCOMMERCE_ORDER_REJECTED'
}

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NullableEnumSocialNetworkFieldUpdateOperationsInput = {
  set?: InputMaybe<SocialNetwork>;
};

export type NullableEnumStripeCreditNoteReasonFieldUpdateOperationsInput = {
  set?: InputMaybe<StripeCreditNoteReason>;
};

export type NullableEnumStripeInvoiceStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<StripeInvoiceStatus>;
};

export type NullableEnumUnprepareReasonFieldUpdateOperationsInput = {
  set?: InputMaybe<UnprepareReason>;
};

export type NullableEnumUserCategoryFieldUpdateOperationsInput = {
  set?: InputMaybe<UserCategory>;
};

export type NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UserPostPaymentDueDateDaysType>;
};

export type NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<UserProductOrderPaymentStatus>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export enum OnHoldReason {
  BulkPayment = 'BULK_PAYMENT',
  BulkStock = 'BULK_STOCK',
  FailedPayment = 'FAILED_PAYMENT',
  FbaPayment = 'FBA_PAYMENT',
  FbaPostPaymentDueDate = 'FBA_POST_PAYMENT_DUE_DATE',
  FbaShippingLabel = 'FBA_SHIPPING_LABEL',
  FbaStock = 'FBA_STOCK',
  InvalidAddress = 'INVALID_ADDRESS',
  LabelIssue = 'LABEL_ISSUE',
  MissingEoriNumber = 'MISSING_EORI_NUMBER',
  MissingSubscription = 'MISSING_SUBSCRIPTION',
  MissingV2Label = 'MISSING_V2_LABEL',
  OutOfStock = 'OUT_OF_STOCK',
  PendingV2Fulfillment = 'PENDING_V2_FULFILLMENT',
  PreOrder = 'PRE_ORDER',
  TechBug = 'TECH_BUG',
  UnverifiedLabel = 'UNVERIFIED_LABEL'
}

export type OnboardingSampleOrderSession = {
  __typename?: 'OnboardingSampleOrderSession';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  imageFileKey: Scalars['String']['output'];
  labelFileKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productSettingsId: Scalars['String']['output'];
  submittedData?: Maybe<Scalars['JSON']['output']>;
};

export type OnboardingSampleOrderSessionCreateManyProductSettingsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageFileKey: Scalars['String']['input'];
  labelFileKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  submittedData?: InputMaybe<Scalars['JSON']['input']>;
};

export type OnboardingSampleOrderSessionCreateManyProductSettingsInputEnvelope = {
  data: Array<OnboardingSampleOrderSessionCreateManyProductSettingsInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingSampleOrderSessionCreateNestedManyWithoutProductSettingsInput = {
  connect?: InputMaybe<Array<OnboardingSampleOrderSessionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OnboardingSampleOrderSessionCreateOrConnectWithoutProductSettingsInput>>;
  create?: InputMaybe<Array<OnboardingSampleOrderSessionCreateWithoutProductSettingsInput>>;
  createMany?: InputMaybe<OnboardingSampleOrderSessionCreateManyProductSettingsInputEnvelope>;
};

export type OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductInput = {
  connect?: InputMaybe<OnboardingSampleOrderSessionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OnboardingSampleOrderSessionCreateOrConnectWithoutUserProductInput>;
  create?: InputMaybe<OnboardingSampleOrderSessionCreateWithoutUserProductInput>;
};

export type OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput = {
  connect?: InputMaybe<OnboardingSampleOrderSessionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OnboardingSampleOrderSessionCreateOrConnectWithoutUserProductOrderInput>;
  create?: InputMaybe<OnboardingSampleOrderSessionCreateWithoutUserProductOrderInput>;
};

export type OnboardingSampleOrderSessionCreateOrConnectWithoutProductSettingsInput = {
  create: OnboardingSampleOrderSessionCreateWithoutProductSettingsInput;
  where: OnboardingSampleOrderSessionWhereUniqueInput;
};

export type OnboardingSampleOrderSessionCreateOrConnectWithoutUserProductInput = {
  create: OnboardingSampleOrderSessionCreateWithoutUserProductInput;
  where: OnboardingSampleOrderSessionWhereUniqueInput;
};

export type OnboardingSampleOrderSessionCreateOrConnectWithoutUserProductOrderInput = {
  create: OnboardingSampleOrderSessionCreateWithoutUserProductOrderInput;
  where: OnboardingSampleOrderSessionWhereUniqueInput;
};

export type OnboardingSampleOrderSessionCreateWithoutProductSettingsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageFileKey: Scalars['String']['input'];
  labelFileKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  submittedData?: InputMaybe<Scalars['JSON']['input']>;
  userProduct?: InputMaybe<UserProductCreateNestedOneWithoutOnboardingSampleSessionInput>;
  userProductOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutOnboardingSampleSessionInput>;
};

export type OnboardingSampleOrderSessionCreateWithoutUserProductInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageFileKey: Scalars['String']['input'];
  labelFileKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productSettings: ProductSettingsCreateNestedOneWithoutOnboardingSampleOrderSessionsInput;
  submittedData?: InputMaybe<Scalars['JSON']['input']>;
  userProductOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutOnboardingSampleSessionInput>;
};

export type OnboardingSampleOrderSessionCreateWithoutUserProductOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageFileKey: Scalars['String']['input'];
  labelFileKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productSettings: ProductSettingsCreateNestedOneWithoutOnboardingSampleOrderSessionsInput;
  submittedData?: InputMaybe<Scalars['JSON']['input']>;
  userProduct?: InputMaybe<UserProductCreateNestedOneWithoutOnboardingSampleSessionInput>;
};

export type OnboardingSampleOrderSessionListRelationFilter = {
  every?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
  none?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
  some?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};

export type OnboardingSampleOrderSessionNullableRelationFilter = {
  is?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
  isNot?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};

export type OnboardingSampleOrderSessionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OnboardingSampleOrderSessionOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageFileKey?: InputMaybe<SortOrder>;
  labelFileKey?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  productSettings?: InputMaybe<ProductSettingsOrderByWithRelationInput>;
  productSettingsId?: InputMaybe<SortOrder>;
  submittedData?: InputMaybe<SortOrderInput>;
  userProduct?: InputMaybe<UserProductOrderByWithRelationInput>;
  userProductOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
};

export type OnboardingSampleOrderSessionScalarWhereInput = {
  AND?: InputMaybe<Array<OnboardingSampleOrderSessionScalarWhereInput>>;
  NOT?: InputMaybe<Array<OnboardingSampleOrderSessionScalarWhereInput>>;
  OR?: InputMaybe<Array<OnboardingSampleOrderSessionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  imageFileKey?: InputMaybe<StringFilter>;
  labelFileKey?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  productSettingsId?: InputMaybe<StringFilter>;
  submittedData?: InputMaybe<JsonNullableFilter>;
};

export type OnboardingSampleOrderSessionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageFileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  labelFileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  submittedData?: InputMaybe<Scalars['JSON']['input']>;
};

export type OnboardingSampleOrderSessionUpdateManyWithWhereWithoutProductSettingsInput = {
  data: OnboardingSampleOrderSessionUpdateManyMutationInput;
  where: OnboardingSampleOrderSessionScalarWhereInput;
};

export type OnboardingSampleOrderSessionUpdateManyWithoutProductSettingsNestedInput = {
  connect?: InputMaybe<Array<OnboardingSampleOrderSessionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OnboardingSampleOrderSessionCreateOrConnectWithoutProductSettingsInput>>;
  create?: InputMaybe<Array<OnboardingSampleOrderSessionCreateWithoutProductSettingsInput>>;
  createMany?: InputMaybe<OnboardingSampleOrderSessionCreateManyProductSettingsInputEnvelope>;
  delete?: InputMaybe<Array<OnboardingSampleOrderSessionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OnboardingSampleOrderSessionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OnboardingSampleOrderSessionWhereUniqueInput>>;
  set?: InputMaybe<Array<OnboardingSampleOrderSessionWhereUniqueInput>>;
  update?: InputMaybe<Array<OnboardingSampleOrderSessionUpdateWithWhereUniqueWithoutProductSettingsInput>>;
  updateMany?: InputMaybe<Array<OnboardingSampleOrderSessionUpdateManyWithWhereWithoutProductSettingsInput>>;
  upsert?: InputMaybe<Array<OnboardingSampleOrderSessionUpsertWithWhereUniqueWithoutProductSettingsInput>>;
};

export type OnboardingSampleOrderSessionUpdateOneWithoutUserProductNestedInput = {
  connect?: InputMaybe<OnboardingSampleOrderSessionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OnboardingSampleOrderSessionCreateOrConnectWithoutUserProductInput>;
  create?: InputMaybe<OnboardingSampleOrderSessionCreateWithoutUserProductInput>;
  delete?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
  disconnect?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
  update?: InputMaybe<OnboardingSampleOrderSessionUpdateToOneWithWhereWithoutUserProductInput>;
  upsert?: InputMaybe<OnboardingSampleOrderSessionUpsertWithoutUserProductInput>;
};

export type OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput = {
  connect?: InputMaybe<OnboardingSampleOrderSessionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OnboardingSampleOrderSessionCreateOrConnectWithoutUserProductOrderInput>;
  create?: InputMaybe<OnboardingSampleOrderSessionCreateWithoutUserProductOrderInput>;
  delete?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
  disconnect?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
  update?: InputMaybe<OnboardingSampleOrderSessionUpdateToOneWithWhereWithoutUserProductOrderInput>;
  upsert?: InputMaybe<OnboardingSampleOrderSessionUpsertWithoutUserProductOrderInput>;
};

export type OnboardingSampleOrderSessionUpdateToOneWithWhereWithoutUserProductInput = {
  data: OnboardingSampleOrderSessionUpdateWithoutUserProductInput;
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};

export type OnboardingSampleOrderSessionUpdateToOneWithWhereWithoutUserProductOrderInput = {
  data: OnboardingSampleOrderSessionUpdateWithoutUserProductOrderInput;
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};

export type OnboardingSampleOrderSessionUpdateWithWhereUniqueWithoutProductSettingsInput = {
  data: OnboardingSampleOrderSessionUpdateWithoutProductSettingsInput;
  where: OnboardingSampleOrderSessionWhereUniqueInput;
};

export type OnboardingSampleOrderSessionUpdateWithoutProductSettingsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageFileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  labelFileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  submittedData?: InputMaybe<Scalars['JSON']['input']>;
  userProduct?: InputMaybe<UserProductUpdateOneWithoutOnboardingSampleSessionNestedInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneWithoutOnboardingSampleSessionNestedInput>;
};

export type OnboardingSampleOrderSessionUpdateWithoutUserProductInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageFileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  labelFileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutOnboardingSampleOrderSessionsNestedInput>;
  submittedData?: InputMaybe<Scalars['JSON']['input']>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneWithoutOnboardingSampleSessionNestedInput>;
};

export type OnboardingSampleOrderSessionUpdateWithoutUserProductOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageFileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  labelFileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutOnboardingSampleOrderSessionsNestedInput>;
  submittedData?: InputMaybe<Scalars['JSON']['input']>;
  userProduct?: InputMaybe<UserProductUpdateOneWithoutOnboardingSampleSessionNestedInput>;
};

export type OnboardingSampleOrderSessionUpsertWithWhereUniqueWithoutProductSettingsInput = {
  create: OnboardingSampleOrderSessionCreateWithoutProductSettingsInput;
  update: OnboardingSampleOrderSessionUpdateWithoutProductSettingsInput;
  where: OnboardingSampleOrderSessionWhereUniqueInput;
};

export type OnboardingSampleOrderSessionUpsertWithoutUserProductInput = {
  create: OnboardingSampleOrderSessionCreateWithoutUserProductInput;
  update: OnboardingSampleOrderSessionUpdateWithoutUserProductInput;
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};

export type OnboardingSampleOrderSessionUpsertWithoutUserProductOrderInput = {
  create: OnboardingSampleOrderSessionCreateWithoutUserProductOrderInput;
  update: OnboardingSampleOrderSessionUpdateWithoutUserProductOrderInput;
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};

export type OnboardingSampleOrderSessionWhereInput = {
  AND?: InputMaybe<Array<OnboardingSampleOrderSessionWhereInput>>;
  NOT?: InputMaybe<Array<OnboardingSampleOrderSessionWhereInput>>;
  OR?: InputMaybe<Array<OnboardingSampleOrderSessionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  imageFileKey?: InputMaybe<StringFilter>;
  labelFileKey?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  productSettings?: InputMaybe<ProductSettingsRelationFilter>;
  productSettingsId?: InputMaybe<StringFilter>;
  submittedData?: InputMaybe<JsonNullableFilter>;
  userProduct?: InputMaybe<UserProductNullableRelationFilter>;
  userProductOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
};

export type OnboardingSampleOrderSessionWhereUniqueInput = {
  AND?: InputMaybe<Array<OnboardingSampleOrderSessionWhereInput>>;
  NOT?: InputMaybe<Array<OnboardingSampleOrderSessionWhereInput>>;
  OR?: InputMaybe<Array<OnboardingSampleOrderSessionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageFileKey?: InputMaybe<StringFilter>;
  labelFileKey?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  productSettings?: InputMaybe<ProductSettingsRelationFilter>;
  productSettingsId?: InputMaybe<StringFilter>;
  submittedData?: InputMaybe<JsonNullableFilter>;
  userProduct?: InputMaybe<UserProductNullableRelationFilter>;
  userProductOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
};

export type OrderToShip = {
  __typename?: 'OrderToShip';
  id: Scalars['ID']['output'];
  linesToShip: Array<LineItemToShip>;
  orderId: Scalars['Int']['output'];
};

export type OrderUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  shippingAddress?: InputMaybe<AddressShippingInput>;
};

export type PaymentMethodCreateManyUserInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type PaymentMethodCreateManyUserInputEnvelope = {
  data: Array<PaymentMethodCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentMethodCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<PaymentMethodWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentMethodCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PaymentMethodCreateWithoutUserInput>>;
  createMany?: InputMaybe<PaymentMethodCreateManyUserInputEnvelope>;
};

export type PaymentMethodCreateOrConnectWithoutUserInput = {
  create: PaymentMethodCreateWithoutUserInput;
  where: PaymentMethodWhereUniqueInput;
};

export type PaymentMethodCreateWithoutUserInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type PaymentMethodListRelationFilter = {
  every?: InputMaybe<PaymentMethodWhereInput>;
  none?: InputMaybe<PaymentMethodWhereInput>;
  some?: InputMaybe<PaymentMethodWhereInput>;
};

export type PaymentMethodOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PaymentMethodScalarWhereInput = {
  AND?: InputMaybe<Array<PaymentMethodScalarWhereInput>>;
  NOT?: InputMaybe<Array<PaymentMethodScalarWhereInput>>;
  OR?: InputMaybe<Array<PaymentMethodScalarWhereInput>>;
  brand?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  last4?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type PaymentMethodUpdateManyMutationInput = {
  brand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last4?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentMethodUpdateManyWithWhereWithoutUserInput = {
  data: PaymentMethodUpdateManyMutationInput;
  where: PaymentMethodScalarWhereInput;
};

export type PaymentMethodUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<PaymentMethodWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentMethodCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PaymentMethodCreateWithoutUserInput>>;
  createMany?: InputMaybe<PaymentMethodCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<PaymentMethodWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentMethodScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentMethodWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentMethodWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentMethodUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<PaymentMethodUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<PaymentMethodUpsertWithWhereUniqueWithoutUserInput>>;
};

export type PaymentMethodUpdateWithWhereUniqueWithoutUserInput = {
  data: PaymentMethodUpdateWithoutUserInput;
  where: PaymentMethodWhereUniqueInput;
};

export type PaymentMethodUpdateWithoutUserInput = {
  brand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  last4?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  stripePaymentMethodId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PaymentMethodUpsertWithWhereUniqueWithoutUserInput = {
  create: PaymentMethodCreateWithoutUserInput;
  update: PaymentMethodUpdateWithoutUserInput;
  where: PaymentMethodWhereUniqueInput;
};

export type PaymentMethodWhereInput = {
  AND?: InputMaybe<Array<PaymentMethodWhereInput>>;
  NOT?: InputMaybe<Array<PaymentMethodWhereInput>>;
  OR?: InputMaybe<Array<PaymentMethodWhereInput>>;
  brand?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  last4?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type PaymentMethodWhereUniqueInput = {
  AND?: InputMaybe<Array<PaymentMethodWhereInput>>;
  NOT?: InputMaybe<Array<PaymentMethodWhereInput>>;
  OR?: InputMaybe<Array<PaymentMethodWhereInput>>;
  brand?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  last4?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  stripePaymentMethodId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export enum PaymentType {
  All = 'All',
  CreditCard = 'CreditCard',
  Shopify = 'Shopify',
  UserCredits = 'UserCredits'
}

export type PostPaymentOrdersBucket = {
  __typename?: 'PostPaymentOrdersBucket';
  _count?: Maybe<PostPaymentOrdersBucketCount>;
  createdAt: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceNo: Scalars['String']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reminderAttemptCount: Scalars['Int']['output'];
  status: PostPaymentOrdersBucketStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PostPaymentOrdersBucketCount = {
  __typename?: 'PostPaymentOrdersBucketCount';
  invoices: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
};


export type PostPaymentOrdersBucketCountInvoicesArgs = {
  where?: InputMaybe<UserInvoiceWhereInput>;
};


export type PostPaymentOrdersBucketCountOrdersArgs = {
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type PostPaymentOrdersBucketCreateManyCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reminderAttemptCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PostPaymentOrdersBucketStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostPaymentOrdersBucketCreateManyCustomerInputEnvelope = {
  data: Array<PostPaymentOrdersBucketCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<PostPaymentOrdersBucketWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PostPaymentOrdersBucketCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<PostPaymentOrdersBucketCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<PostPaymentOrdersBucketCreateManyCustomerInputEnvelope>;
};

export type PostPaymentOrdersBucketCreateNestedOneWithoutInvoicesInput = {
  connect?: InputMaybe<PostPaymentOrdersBucketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostPaymentOrdersBucketCreateOrConnectWithoutInvoicesInput>;
  create?: InputMaybe<PostPaymentOrdersBucketCreateWithoutInvoicesInput>;
};

export type PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<PostPaymentOrdersBucketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostPaymentOrdersBucketCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<PostPaymentOrdersBucketCreateWithoutOrdersInput>;
};

export type PostPaymentOrdersBucketCreateOrConnectWithoutCustomerInput = {
  create: PostPaymentOrdersBucketCreateWithoutCustomerInput;
  where: PostPaymentOrdersBucketWhereUniqueInput;
};

export type PostPaymentOrdersBucketCreateOrConnectWithoutInvoicesInput = {
  create: PostPaymentOrdersBucketCreateWithoutInvoicesInput;
  where: PostPaymentOrdersBucketWhereUniqueInput;
};

export type PostPaymentOrdersBucketCreateOrConnectWithoutOrdersInput = {
  create: PostPaymentOrdersBucketCreateWithoutOrdersInput;
  where: PostPaymentOrdersBucketWhereUniqueInput;
};

export type PostPaymentOrdersBucketCreateWithoutCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutPostPaymentBucketInput>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutPostPaymentBucketInput>;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reminderAttemptCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PostPaymentOrdersBucketStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostPaymentOrdersBucketCreateWithoutInvoicesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: UserCreateNestedOneWithoutPostPaymentBucketsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutPostPaymentBucketInput>;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reminderAttemptCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PostPaymentOrdersBucketStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostPaymentOrdersBucketCreateWithoutOrdersInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: UserCreateNestedOneWithoutPostPaymentBucketsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutPostPaymentBucketInput>;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reminderAttemptCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PostPaymentOrdersBucketStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostPaymentOrdersBucketCustomerIdPeriodStartPeriodEndCompoundUniqueInput = {
  customerId: Scalars['String']['input'];
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
};

export type PostPaymentOrdersBucketListRelationFilter = {
  every?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
  none?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
  some?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
};

export type PostPaymentOrdersBucketNullableRelationFilter = {
  is?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
  isNot?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
};

export type PostPaymentOrdersBucketOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PostPaymentOrdersBucketOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<UserOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invoiceNo?: InputMaybe<SortOrder>;
  invoices?: InputMaybe<UserInvoiceOrderByRelationAggregateInput>;
  orders?: InputMaybe<UserProductOrderOrderByRelationAggregateInput>;
  periodEnd?: InputMaybe<SortOrder>;
  periodStart?: InputMaybe<SortOrder>;
  processedAt?: InputMaybe<SortOrderInput>;
  reminderAttemptCount?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PostPaymentOrdersBucketScalarWhereInput = {
  AND?: InputMaybe<Array<PostPaymentOrdersBucketScalarWhereInput>>;
  NOT?: InputMaybe<Array<PostPaymentOrdersBucketScalarWhereInput>>;
  OR?: InputMaybe<Array<PostPaymentOrdersBucketScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  invoiceNo?: InputMaybe<StringFilter>;
  periodEnd?: InputMaybe<DateTimeFilter>;
  periodStart?: InputMaybe<DateTimeFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  reminderAttemptCount?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumPostPaymentOrdersBucketStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum PostPaymentOrdersBucketStatus {
  Active = 'ACTIVE',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Empty = 'EMPTY',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID'
}

export type PostPaymentOrdersBucketUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNo?: InputMaybe<StringFieldUpdateOperationsInput>;
  periodEnd?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reminderAttemptCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPostPaymentOrdersBucketStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PostPaymentOrdersBucketUpdateManyWithWhereWithoutCustomerInput = {
  data: PostPaymentOrdersBucketUpdateManyMutationInput;
  where: PostPaymentOrdersBucketScalarWhereInput;
};

export type PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<PostPaymentOrdersBucketWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PostPaymentOrdersBucketCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<PostPaymentOrdersBucketCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<PostPaymentOrdersBucketCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<PostPaymentOrdersBucketWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PostPaymentOrdersBucketScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PostPaymentOrdersBucketWhereUniqueInput>>;
  set?: InputMaybe<Array<PostPaymentOrdersBucketWhereUniqueInput>>;
  update?: InputMaybe<Array<PostPaymentOrdersBucketUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<PostPaymentOrdersBucketUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<PostPaymentOrdersBucketUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type PostPaymentOrdersBucketUpdateOneWithoutInvoicesNestedInput = {
  connect?: InputMaybe<PostPaymentOrdersBucketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostPaymentOrdersBucketCreateOrConnectWithoutInvoicesInput>;
  create?: InputMaybe<PostPaymentOrdersBucketCreateWithoutInvoicesInput>;
  delete?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
  disconnect?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
  update?: InputMaybe<PostPaymentOrdersBucketUpdateToOneWithWhereWithoutInvoicesInput>;
  upsert?: InputMaybe<PostPaymentOrdersBucketUpsertWithoutInvoicesInput>;
};

export type PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput = {
  connect?: InputMaybe<PostPaymentOrdersBucketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostPaymentOrdersBucketCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<PostPaymentOrdersBucketCreateWithoutOrdersInput>;
  delete?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
  disconnect?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
  update?: InputMaybe<PostPaymentOrdersBucketUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<PostPaymentOrdersBucketUpsertWithoutOrdersInput>;
};

export type PostPaymentOrdersBucketUpdateToOneWithWhereWithoutInvoicesInput = {
  data: PostPaymentOrdersBucketUpdateWithoutInvoicesInput;
  where?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
};

export type PostPaymentOrdersBucketUpdateToOneWithWhereWithoutOrdersInput = {
  data: PostPaymentOrdersBucketUpdateWithoutOrdersInput;
  where?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
};

export type PostPaymentOrdersBucketUpdateWithWhereUniqueWithoutCustomerInput = {
  data: PostPaymentOrdersBucketUpdateWithoutCustomerInput;
  where: PostPaymentOrdersBucketWhereUniqueInput;
};

export type PostPaymentOrdersBucketUpdateWithoutCustomerInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNo?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutPostPaymentBucketNestedInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutPostPaymentBucketNestedInput>;
  periodEnd?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reminderAttemptCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPostPaymentOrdersBucketStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PostPaymentOrdersBucketUpdateWithoutInvoicesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<UserUpdateOneRequiredWithoutPostPaymentBucketsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNo?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutPostPaymentBucketNestedInput>;
  periodEnd?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reminderAttemptCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPostPaymentOrdersBucketStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PostPaymentOrdersBucketUpdateWithoutOrdersInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<UserUpdateOneRequiredWithoutPostPaymentBucketsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNo?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutPostPaymentBucketNestedInput>;
  periodEnd?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  periodStart?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reminderAttemptCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPostPaymentOrdersBucketStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PostPaymentOrdersBucketUpsertWithWhereUniqueWithoutCustomerInput = {
  create: PostPaymentOrdersBucketCreateWithoutCustomerInput;
  update: PostPaymentOrdersBucketUpdateWithoutCustomerInput;
  where: PostPaymentOrdersBucketWhereUniqueInput;
};

export type PostPaymentOrdersBucketUpsertWithoutInvoicesInput = {
  create: PostPaymentOrdersBucketCreateWithoutInvoicesInput;
  update: PostPaymentOrdersBucketUpdateWithoutInvoicesInput;
  where?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
};

export type PostPaymentOrdersBucketUpsertWithoutOrdersInput = {
  create: PostPaymentOrdersBucketCreateWithoutOrdersInput;
  update: PostPaymentOrdersBucketUpdateWithoutOrdersInput;
  where?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
};

export type PostPaymentOrdersBucketWhereInput = {
  AND?: InputMaybe<Array<PostPaymentOrdersBucketWhereInput>>;
  NOT?: InputMaybe<Array<PostPaymentOrdersBucketWhereInput>>;
  OR?: InputMaybe<Array<PostPaymentOrdersBucketWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<UserRelationFilter>;
  customerId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  invoiceNo?: InputMaybe<StringFilter>;
  invoices?: InputMaybe<UserInvoiceListRelationFilter>;
  orders?: InputMaybe<UserProductOrderListRelationFilter>;
  periodEnd?: InputMaybe<DateTimeFilter>;
  periodStart?: InputMaybe<DateTimeFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  reminderAttemptCount?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumPostPaymentOrdersBucketStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PostPaymentOrdersBucketWhereUniqueInput = {
  AND?: InputMaybe<Array<PostPaymentOrdersBucketWhereInput>>;
  NOT?: InputMaybe<Array<PostPaymentOrdersBucketWhereInput>>;
  OR?: InputMaybe<Array<PostPaymentOrdersBucketWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<UserRelationFilter>;
  customerId?: InputMaybe<UuidFilter>;
  customerId_periodStart_periodEnd?: InputMaybe<PostPaymentOrdersBucketCustomerIdPeriodStartPeriodEndCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo?: InputMaybe<Scalars['String']['input']>;
  invoices?: InputMaybe<UserInvoiceListRelationFilter>;
  orders?: InputMaybe<UserProductOrderListRelationFilter>;
  periodEnd?: InputMaybe<DateTimeFilter>;
  periodStart?: InputMaybe<DateTimeFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  reminderAttemptCount?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumPostPaymentOrdersBucketStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PrintBatchCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isSingleItemOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isTiktokOrder?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PrintBatchCreateManyCreatedByInputEnvelope = {
  data: Array<PrintBatchCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrintBatchCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<PrintBatchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PrintBatchCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<PrintBatchCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<PrintBatchCreateManyCreatedByInputEnvelope>;
};

export type PrintBatchCreateNestedOneWithoutLinesInput = {
  connect?: InputMaybe<PrintBatchWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PrintBatchCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<PrintBatchCreateWithoutLinesInput>;
};

export type PrintBatchCreateOrConnectWithoutCreatedByInput = {
  create: PrintBatchCreateWithoutCreatedByInput;
  where: PrintBatchWhereUniqueInput;
};

export type PrintBatchCreateOrConnectWithoutLinesInput = {
  create: PrintBatchCreateWithoutLinesInput;
  where: PrintBatchWhereUniqueInput;
};

export type PrintBatchCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isSingleItemOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isTiktokOrder?: InputMaybe<Scalars['Boolean']['input']>;
  lines?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutPrintBatchInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PrintBatchCreateWithoutLinesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutPrintBatchesInput;
  isSingleItemOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isTiktokOrder?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PrintBatchListRelationFilter = {
  every?: InputMaybe<PrintBatchWhereInput>;
  none?: InputMaybe<PrintBatchWhereInput>;
  some?: InputMaybe<PrintBatchWhereInput>;
};

export type PrintBatchOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PrintBatchOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<AdminOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSingleItemOrder?: InputMaybe<SortOrderInput>;
  isTiktokOrder?: InputMaybe<SortOrderInput>;
  lines?: InputMaybe<PrintBatchOrderLineOrderByRelationAggregateInput>;
  url?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export type PrintBatchOrderLine = {
  __typename?: 'PrintBatchOrderLine';
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  countBatched: Scalars['Int']['output'];
  countPrepared: Scalars['Int']['output'];
  lineId: Scalars['String']['output'];
  printBatchId: Scalars['Int']['output'];
  sequence: Scalars['Int']['output'];
};

export type PrintBatchOrderLineCreateManyLineInput = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  countBatched: Scalars['Int']['input'];
  countPrepared: Scalars['Int']['input'];
  printBatchId: Scalars['Int']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export type PrintBatchOrderLineCreateManyLineInputEnvelope = {
  data: Array<PrintBatchOrderLineCreateManyLineInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrintBatchOrderLineCreateManyPrintBatchInput = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  countBatched: Scalars['Int']['input'];
  countPrepared: Scalars['Int']['input'];
  lineId: Scalars['String']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export type PrintBatchOrderLineCreateManyPrintBatchInputEnvelope = {
  data: Array<PrintBatchOrderLineCreateManyPrintBatchInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrintBatchOrderLineCreateNestedManyWithoutLineInput = {
  connect?: InputMaybe<Array<PrintBatchOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PrintBatchOrderLineCreateOrConnectWithoutLineInput>>;
  create?: InputMaybe<Array<PrintBatchOrderLineCreateWithoutLineInput>>;
  createMany?: InputMaybe<PrintBatchOrderLineCreateManyLineInputEnvelope>;
};

export type PrintBatchOrderLineCreateNestedManyWithoutPrintBatchInput = {
  connect?: InputMaybe<Array<PrintBatchOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PrintBatchOrderLineCreateOrConnectWithoutPrintBatchInput>>;
  create?: InputMaybe<Array<PrintBatchOrderLineCreateWithoutPrintBatchInput>>;
  createMany?: InputMaybe<PrintBatchOrderLineCreateManyPrintBatchInputEnvelope>;
};

export type PrintBatchOrderLineCreateOrConnectWithoutLineInput = {
  create: PrintBatchOrderLineCreateWithoutLineInput;
  where: PrintBatchOrderLineWhereUniqueInput;
};

export type PrintBatchOrderLineCreateOrConnectWithoutPrintBatchInput = {
  create: PrintBatchOrderLineCreateWithoutPrintBatchInput;
  where: PrintBatchOrderLineWhereUniqueInput;
};

export type PrintBatchOrderLineCreateWithoutLineInput = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  countBatched: Scalars['Int']['input'];
  countPrepared: Scalars['Int']['input'];
  printBatch: PrintBatchCreateNestedOneWithoutLinesInput;
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export type PrintBatchOrderLineCreateWithoutPrintBatchInput = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  countBatched: Scalars['Int']['input'];
  countPrepared: Scalars['Int']['input'];
  line: UserProductOrderLineCreateNestedOneWithoutPrintBatchesInput;
  sequence?: InputMaybe<Scalars['Int']['input']>;
};

export type PrintBatchOrderLineLineIdPrintBatchIdCompoundUniqueInput = {
  lineId: Scalars['String']['input'];
  printBatchId: Scalars['Int']['input'];
};

export type PrintBatchOrderLineListRelationFilter = {
  every?: InputMaybe<PrintBatchOrderLineWhereInput>;
  none?: InputMaybe<PrintBatchOrderLineWhereInput>;
  some?: InputMaybe<PrintBatchOrderLineWhereInput>;
};

export type PrintBatchOrderLineOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PrintBatchOrderLineOrderByWithRelationInput = {
  confirmed?: InputMaybe<SortOrderInput>;
  countBatched?: InputMaybe<SortOrder>;
  countPrepared?: InputMaybe<SortOrder>;
  line?: InputMaybe<UserProductOrderLineOrderByWithRelationInput>;
  lineId?: InputMaybe<SortOrder>;
  printBatch?: InputMaybe<PrintBatchOrderByWithRelationInput>;
  printBatchId?: InputMaybe<SortOrder>;
  sequence?: InputMaybe<SortOrder>;
};

export enum PrintBatchOrderLineScalarFieldEnum {
  Confirmed = 'confirmed',
  CountBatched = 'countBatched',
  CountPrepared = 'countPrepared',
  LineId = 'lineId',
  PrintBatchId = 'printBatchId',
  Sequence = 'sequence'
}

export type PrintBatchOrderLineScalarWhereInput = {
  AND?: InputMaybe<Array<PrintBatchOrderLineScalarWhereInput>>;
  NOT?: InputMaybe<Array<PrintBatchOrderLineScalarWhereInput>>;
  OR?: InputMaybe<Array<PrintBatchOrderLineScalarWhereInput>>;
  confirmed?: InputMaybe<BoolNullableFilter>;
  countBatched?: InputMaybe<IntFilter>;
  countPrepared?: InputMaybe<IntFilter>;
  lineId?: InputMaybe<UuidFilter>;
  printBatchId?: InputMaybe<IntFilter>;
  sequence?: InputMaybe<IntFilter>;
};

export type PrintBatchOrderLineUpdateManyMutationInput = {
  confirmed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  countBatched?: InputMaybe<IntFieldUpdateOperationsInput>;
  countPrepared?: InputMaybe<IntFieldUpdateOperationsInput>;
  sequence?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type PrintBatchOrderLineUpdateManyWithWhereWithoutLineInput = {
  data: PrintBatchOrderLineUpdateManyMutationInput;
  where: PrintBatchOrderLineScalarWhereInput;
};

export type PrintBatchOrderLineUpdateManyWithWhereWithoutPrintBatchInput = {
  data: PrintBatchOrderLineUpdateManyMutationInput;
  where: PrintBatchOrderLineScalarWhereInput;
};

export type PrintBatchOrderLineUpdateManyWithoutLineNestedInput = {
  connect?: InputMaybe<Array<PrintBatchOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PrintBatchOrderLineCreateOrConnectWithoutLineInput>>;
  create?: InputMaybe<Array<PrintBatchOrderLineCreateWithoutLineInput>>;
  createMany?: InputMaybe<PrintBatchOrderLineCreateManyLineInputEnvelope>;
  delete?: InputMaybe<Array<PrintBatchOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PrintBatchOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PrintBatchOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<PrintBatchOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<PrintBatchOrderLineUpdateWithWhereUniqueWithoutLineInput>>;
  updateMany?: InputMaybe<Array<PrintBatchOrderLineUpdateManyWithWhereWithoutLineInput>>;
  upsert?: InputMaybe<Array<PrintBatchOrderLineUpsertWithWhereUniqueWithoutLineInput>>;
};

export type PrintBatchOrderLineUpdateManyWithoutPrintBatchNestedInput = {
  connect?: InputMaybe<Array<PrintBatchOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PrintBatchOrderLineCreateOrConnectWithoutPrintBatchInput>>;
  create?: InputMaybe<Array<PrintBatchOrderLineCreateWithoutPrintBatchInput>>;
  createMany?: InputMaybe<PrintBatchOrderLineCreateManyPrintBatchInputEnvelope>;
  delete?: InputMaybe<Array<PrintBatchOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PrintBatchOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PrintBatchOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<PrintBatchOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<PrintBatchOrderLineUpdateWithWhereUniqueWithoutPrintBatchInput>>;
  updateMany?: InputMaybe<Array<PrintBatchOrderLineUpdateManyWithWhereWithoutPrintBatchInput>>;
  upsert?: InputMaybe<Array<PrintBatchOrderLineUpsertWithWhereUniqueWithoutPrintBatchInput>>;
};

export type PrintBatchOrderLineUpdateWithWhereUniqueWithoutLineInput = {
  data: PrintBatchOrderLineUpdateWithoutLineInput;
  where: PrintBatchOrderLineWhereUniqueInput;
};

export type PrintBatchOrderLineUpdateWithWhereUniqueWithoutPrintBatchInput = {
  data: PrintBatchOrderLineUpdateWithoutPrintBatchInput;
  where: PrintBatchOrderLineWhereUniqueInput;
};

export type PrintBatchOrderLineUpdateWithoutLineInput = {
  confirmed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  countBatched?: InputMaybe<IntFieldUpdateOperationsInput>;
  countPrepared?: InputMaybe<IntFieldUpdateOperationsInput>;
  printBatch?: InputMaybe<PrintBatchUpdateOneRequiredWithoutLinesNestedInput>;
  sequence?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type PrintBatchOrderLineUpdateWithoutPrintBatchInput = {
  confirmed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  countBatched?: InputMaybe<IntFieldUpdateOperationsInput>;
  countPrepared?: InputMaybe<IntFieldUpdateOperationsInput>;
  line?: InputMaybe<UserProductOrderLineUpdateOneRequiredWithoutPrintBatchesNestedInput>;
  sequence?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type PrintBatchOrderLineUpsertWithWhereUniqueWithoutLineInput = {
  create: PrintBatchOrderLineCreateWithoutLineInput;
  update: PrintBatchOrderLineUpdateWithoutLineInput;
  where: PrintBatchOrderLineWhereUniqueInput;
};

export type PrintBatchOrderLineUpsertWithWhereUniqueWithoutPrintBatchInput = {
  create: PrintBatchOrderLineCreateWithoutPrintBatchInput;
  update: PrintBatchOrderLineUpdateWithoutPrintBatchInput;
  where: PrintBatchOrderLineWhereUniqueInput;
};

export type PrintBatchOrderLineWhereInput = {
  AND?: InputMaybe<Array<PrintBatchOrderLineWhereInput>>;
  NOT?: InputMaybe<Array<PrintBatchOrderLineWhereInput>>;
  OR?: InputMaybe<Array<PrintBatchOrderLineWhereInput>>;
  confirmed?: InputMaybe<BoolNullableFilter>;
  countBatched?: InputMaybe<IntFilter>;
  countPrepared?: InputMaybe<IntFilter>;
  line?: InputMaybe<UserProductOrderLineRelationFilter>;
  lineId?: InputMaybe<UuidFilter>;
  printBatch?: InputMaybe<PrintBatchRelationFilter>;
  printBatchId?: InputMaybe<IntFilter>;
  sequence?: InputMaybe<IntFilter>;
};

export type PrintBatchOrderLineWhereUniqueInput = {
  AND?: InputMaybe<Array<PrintBatchOrderLineWhereInput>>;
  NOT?: InputMaybe<Array<PrintBatchOrderLineWhereInput>>;
  OR?: InputMaybe<Array<PrintBatchOrderLineWhereInput>>;
  confirmed?: InputMaybe<BoolNullableFilter>;
  countBatched?: InputMaybe<IntFilter>;
  countPrepared?: InputMaybe<IntFilter>;
  line?: InputMaybe<UserProductOrderLineRelationFilter>;
  lineId?: InputMaybe<UuidFilter>;
  lineId_printBatchId?: InputMaybe<PrintBatchOrderLineLineIdPrintBatchIdCompoundUniqueInput>;
  printBatch?: InputMaybe<PrintBatchRelationFilter>;
  printBatchId?: InputMaybe<IntFilter>;
  sequence?: InputMaybe<IntFilter>;
};

export type PrintBatchRelationFilter = {
  is?: InputMaybe<PrintBatchWhereInput>;
  isNot?: InputMaybe<PrintBatchWhereInput>;
};

export type PrintBatchScalarWhereInput = {
  AND?: InputMaybe<Array<PrintBatchScalarWhereInput>>;
  NOT?: InputMaybe<Array<PrintBatchScalarWhereInput>>;
  OR?: InputMaybe<Array<PrintBatchScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<UuidFilter>;
  id?: InputMaybe<IntFilter>;
  isSingleItemOrder?: InputMaybe<BoolNullableFilter>;
  isTiktokOrder?: InputMaybe<BoolNullableFilter>;
  url?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type PrintBatchUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isSingleItemOrder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isTiktokOrder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PrintBatchUpdateManyWithWhereWithoutCreatedByInput = {
  data: PrintBatchUpdateManyMutationInput;
  where: PrintBatchScalarWhereInput;
};

export type PrintBatchUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<PrintBatchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PrintBatchCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<PrintBatchCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<PrintBatchCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<PrintBatchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PrintBatchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PrintBatchWhereUniqueInput>>;
  set?: InputMaybe<Array<PrintBatchWhereUniqueInput>>;
  update?: InputMaybe<Array<PrintBatchUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<PrintBatchUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<PrintBatchUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type PrintBatchUpdateOneRequiredWithoutLinesNestedInput = {
  connect?: InputMaybe<PrintBatchWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PrintBatchCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<PrintBatchCreateWithoutLinesInput>;
  update?: InputMaybe<PrintBatchUpdateToOneWithWhereWithoutLinesInput>;
  upsert?: InputMaybe<PrintBatchUpsertWithoutLinesInput>;
};

export type PrintBatchUpdateToOneWithWhereWithoutLinesInput = {
  data: PrintBatchUpdateWithoutLinesInput;
  where?: InputMaybe<PrintBatchWhereInput>;
};

export type PrintBatchUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: PrintBatchUpdateWithoutCreatedByInput;
  where: PrintBatchWhereUniqueInput;
};

export type PrintBatchUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isSingleItemOrder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isTiktokOrder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lines?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutPrintBatchNestedInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PrintBatchUpdateWithoutLinesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutPrintBatchesNestedInput>;
  isSingleItemOrder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isTiktokOrder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PrintBatchUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: PrintBatchCreateWithoutCreatedByInput;
  update: PrintBatchUpdateWithoutCreatedByInput;
  where: PrintBatchWhereUniqueInput;
};

export type PrintBatchUpsertWithoutLinesInput = {
  create: PrintBatchCreateWithoutLinesInput;
  update: PrintBatchUpdateWithoutLinesInput;
  where?: InputMaybe<PrintBatchWhereInput>;
};

export type PrintBatchWhereInput = {
  AND?: InputMaybe<Array<PrintBatchWhereInput>>;
  NOT?: InputMaybe<Array<PrintBatchWhereInput>>;
  OR?: InputMaybe<Array<PrintBatchWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminRelationFilter>;
  createdById?: InputMaybe<UuidFilter>;
  id?: InputMaybe<IntFilter>;
  isSingleItemOrder?: InputMaybe<BoolNullableFilter>;
  isTiktokOrder?: InputMaybe<BoolNullableFilter>;
  lines?: InputMaybe<PrintBatchOrderLineListRelationFilter>;
  url?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type PrintBatchWhereUniqueInput = {
  AND?: InputMaybe<Array<PrintBatchWhereInput>>;
  NOT?: InputMaybe<Array<PrintBatchWhereInput>>;
  OR?: InputMaybe<Array<PrintBatchWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminRelationFilter>;
  createdById?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isSingleItemOrder?: InputMaybe<BoolNullableFilter>;
  isTiktokOrder?: InputMaybe<BoolNullableFilter>;
  lines?: InputMaybe<PrintBatchOrderLineListRelationFilter>;
  url?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type PrintFileFilterOrderKindsListInput = {
  isSingleItemOrder: Scalars['Boolean']['input'];
  isTodayPriority?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PrintFileFilterUserListInput = {
  isSingleItemOrder: Scalars['Boolean']['input'];
  isTodayPriority?: InputMaybe<Scalars['Boolean']['input']>;
  orderKind?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PrintFileQueueInput = {
  isSingleItemOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isTodayPriority?: InputMaybe<Scalars['Boolean']['input']>;
  orderKind?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PrintFileQueueResponse = {
  __typename?: 'PrintFileQueueResponse';
  height: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  internalId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  printFilesBySku: Array<PrintFilesBySku>;
  unit: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type PrintFilesBySku = {
  __typename?: 'PrintFilesBySku';
  activeBatches: Array<Scalars['Int']['output']>;
  labellingTechnique: ProductLabellingTechnique;
  name?: Maybe<Scalars['String']['output']>;
  productForm?: Maybe<SanityProductForm>;
  sku: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  totalPriority: Scalars['Float']['output'];
};

export type ProductFulfillmentChecklist = {
  __typename?: 'ProductFulfillmentChecklist';
  containerMockups: Scalars['Boolean']['output'];
  denverWarehouseAssigned: Scalars['Boolean']['output'];
  labelSizeAndDesign: Scalars['Boolean']['output'];
  nameAndSku: Scalars['Boolean']['output'];
  shipHeroProductStockSetup: Scalars['Boolean']['output'];
  stockLevel: Scalars['Boolean']['output'];
  stripeProductCreated: Scalars['Boolean']['output'];
};

export type ProductLabelSize = {
  __typename?: 'ProductLabelSize';
  _count?: Maybe<ProductLabelSizeCount>;
  height: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  internalId: Scalars['String']['output'];
  labelsPerProduct: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sanityLabelSizeId?: Maybe<Scalars['String']['output']>;
  unit: LengthUnit;
  width: Scalars['Float']['output'];
};

export type ProductLabelSizeCount = {
  __typename?: 'ProductLabelSizeCount';
  labelRoll: Scalars['Int']['output'];
  productSettings: Scalars['Int']['output'];
};


export type ProductLabelSizeCountLabelRollArgs = {
  where?: InputMaybe<LabelRollWhereInput>;
};


export type ProductLabelSizeCountProductSettingsArgs = {
  where?: InputMaybe<ProductSettingsWhereInput>;
};

export type ProductLabelSizeCreateInput = {
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  internalId: Scalars['String']['input'];
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutProductLabelSizeInput>;
  labelsPerProduct?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sanityLabelSizeId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<LengthUnit>;
  width: Scalars['Float']['input'];
};

export type ProductLabelSizeCreateNestedOneWithoutLabelRollInput = {
  connect?: InputMaybe<ProductLabelSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductLabelSizeCreateOrConnectWithoutLabelRollInput>;
  create?: InputMaybe<ProductLabelSizeCreateWithoutLabelRollInput>;
};

export type ProductLabelSizeCreateNestedOneWithoutProductSettingsInput = {
  connect?: InputMaybe<ProductLabelSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductLabelSizeCreateOrConnectWithoutProductSettingsInput>;
  create?: InputMaybe<ProductLabelSizeCreateWithoutProductSettingsInput>;
};

export type ProductLabelSizeCreateOrConnectWithoutLabelRollInput = {
  create: ProductLabelSizeCreateWithoutLabelRollInput;
  where: ProductLabelSizeWhereUniqueInput;
};

export type ProductLabelSizeCreateOrConnectWithoutProductSettingsInput = {
  create: ProductLabelSizeCreateWithoutProductSettingsInput;
  where: ProductLabelSizeWhereUniqueInput;
};

export type ProductLabelSizeCreateWithoutLabelRollInput = {
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  internalId: Scalars['String']['input'];
  labelsPerProduct?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sanityLabelSizeId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<LengthUnit>;
  width: Scalars['Float']['input'];
};

export type ProductLabelSizeCreateWithoutProductSettingsInput = {
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  internalId: Scalars['String']['input'];
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutProductLabelSizeInput>;
  labelsPerProduct?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  sanityLabelSizeId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<LengthUnit>;
  width: Scalars['Float']['input'];
};

export type ProductLabelSizeNullableRelationFilter = {
  is?: InputMaybe<ProductLabelSizeWhereInput>;
  isNot?: InputMaybe<ProductLabelSizeWhereInput>;
};

export type ProductLabelSizeOrderByWithRelationInput = {
  height?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalId?: InputMaybe<SortOrder>;
  labelRoll?: InputMaybe<LabelRollOrderByRelationAggregateInput>;
  labelsPerProduct?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  sanityLabelSizeId?: InputMaybe<SortOrderInput>;
  unit?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type ProductLabelSizeRelationFilter = {
  is?: InputMaybe<ProductLabelSizeWhereInput>;
  isNot?: InputMaybe<ProductLabelSizeWhereInput>;
};

export enum ProductLabelSizeScalarFieldEnum {
  Height = 'height',
  Id = 'id',
  InternalId = 'internalId',
  LabelOverlayFile = 'labelOverlayFile',
  LabelsPerProduct = 'labelsPerProduct',
  Name = 'name',
  SanityLabelSizeId = 'sanityLabelSizeId',
  Unit = 'unit',
  Width = 'width'
}

export type ProductLabelSizeUpdateInput = {
  height?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutProductLabelSizeNestedInput>;
  labelsPerProduct?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  sanityLabelSizeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumLengthUnitFieldUpdateOperationsInput>;
  width?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ProductLabelSizeUpdateOneRequiredWithoutLabelRollNestedInput = {
  connect?: InputMaybe<ProductLabelSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductLabelSizeCreateOrConnectWithoutLabelRollInput>;
  create?: InputMaybe<ProductLabelSizeCreateWithoutLabelRollInput>;
  update?: InputMaybe<ProductLabelSizeUpdateToOneWithWhereWithoutLabelRollInput>;
  upsert?: InputMaybe<ProductLabelSizeUpsertWithoutLabelRollInput>;
};

export type ProductLabelSizeUpdateOneWithoutProductSettingsNestedInput = {
  connect?: InputMaybe<ProductLabelSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductLabelSizeCreateOrConnectWithoutProductSettingsInput>;
  create?: InputMaybe<ProductLabelSizeCreateWithoutProductSettingsInput>;
  delete?: InputMaybe<ProductLabelSizeWhereInput>;
  disconnect?: InputMaybe<ProductLabelSizeWhereInput>;
  update?: InputMaybe<ProductLabelSizeUpdateToOneWithWhereWithoutProductSettingsInput>;
  upsert?: InputMaybe<ProductLabelSizeUpsertWithoutProductSettingsInput>;
};

export type ProductLabelSizeUpdateToOneWithWhereWithoutLabelRollInput = {
  data: ProductLabelSizeUpdateWithoutLabelRollInput;
  where?: InputMaybe<ProductLabelSizeWhereInput>;
};

export type ProductLabelSizeUpdateToOneWithWhereWithoutProductSettingsInput = {
  data: ProductLabelSizeUpdateWithoutProductSettingsInput;
  where?: InputMaybe<ProductLabelSizeWhereInput>;
};

export type ProductLabelSizeUpdateWithoutLabelRollInput = {
  height?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  labelsPerProduct?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  sanityLabelSizeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumLengthUnitFieldUpdateOperationsInput>;
  width?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ProductLabelSizeUpdateWithoutProductSettingsInput = {
  height?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutProductLabelSizeNestedInput>;
  labelsPerProduct?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  sanityLabelSizeId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  unit?: InputMaybe<EnumLengthUnitFieldUpdateOperationsInput>;
  width?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ProductLabelSizeUpsertWithoutLabelRollInput = {
  create: ProductLabelSizeCreateWithoutLabelRollInput;
  update: ProductLabelSizeUpdateWithoutLabelRollInput;
  where?: InputMaybe<ProductLabelSizeWhereInput>;
};

export type ProductLabelSizeUpsertWithoutProductSettingsInput = {
  create: ProductLabelSizeCreateWithoutProductSettingsInput;
  update: ProductLabelSizeUpdateWithoutProductSettingsInput;
  where?: InputMaybe<ProductLabelSizeWhereInput>;
};

export type ProductLabelSizeWhereInput = {
  AND?: InputMaybe<Array<ProductLabelSizeWhereInput>>;
  NOT?: InputMaybe<Array<ProductLabelSizeWhereInput>>;
  OR?: InputMaybe<Array<ProductLabelSizeWhereInput>>;
  height?: InputMaybe<FloatFilter>;
  id?: InputMaybe<UuidFilter>;
  internalId?: InputMaybe<StringFilter>;
  labelRoll?: InputMaybe<LabelRollListRelationFilter>;
  labelsPerProduct?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  sanityLabelSizeId?: InputMaybe<StringNullableFilter>;
  unit?: InputMaybe<EnumLengthUnitFilter>;
  width?: InputMaybe<FloatFilter>;
};

export type ProductLabelSizeWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductLabelSizeWhereInput>>;
  NOT?: InputMaybe<Array<ProductLabelSizeWhereInput>>;
  OR?: InputMaybe<Array<ProductLabelSizeWhereInput>>;
  height?: InputMaybe<FloatFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  labelRoll?: InputMaybe<LabelRollListRelationFilter>;
  labelsPerProduct?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  sanityLabelSizeId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<EnumLengthUnitFilter>;
  width?: InputMaybe<FloatFilter>;
};

export enum ProductLabellingTechnique {
  AutoLabeller = 'AUTO_LABELLER',
  HandLabelling = 'HAND_LABELLING'
}

export type ProductPublisherModel = {
  __typename?: 'ProductPublisherModel';
  _count?: Maybe<UserProductCount>;
  baseId?: Maybe<Scalars['String']['output']>;
  clickfunnelsId?: Maybe<Scalars['String']['output']>;
  clickfunnelsVariantId?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<UserProductFile>;
  coverImageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customSkuId?: Maybe<Scalars['String']['output']>;
  defaultShippingPackage?: Maybe<ShippingPackage>;
  defaultShippingPackageId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eligibilityCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  eligibilityResult?: Maybe<Scalars['JSON']['output']>;
  eligibilityScore?: Maybe<Scalars['Float']['output']>;
  email: Scalars['String']['output'];
  files: Array<UserProductFile>;
  fullName: Scalars['String']['output'];
  generatedSku?: Maybe<Scalars['String']['output']>;
  hasInsert: Scalars['Boolean']['output'];
  hasUnpushedImageChanges: Scalars['Boolean']['output'];
  hasV1LabelFile: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insertImage?: Maybe<Scalars['String']['output']>;
  isOnboardingSampleLabel: Scalars['Boolean']['output'];
  isPrelabeled: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isSingleSkuBundle: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  labelDraft?: Maybe<UserProductLabelDraft>;
  labelId?: Maybe<Scalars['String']['output']>;
  layoutId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onboardingSampleSession?: Maybe<OnboardingSampleOrderSession>;
  onboardingSampleSessionId?: Maybe<Scalars['String']['output']>;
  prePaidUnits?: Maybe<Scalars['Int']['output']>;
  preventEmailNotifications?: Maybe<Array<NotificationReason>>;
  price: Scalars['Float']['output'];
  pricePrePaid?: Maybe<Scalars['Float']['output']>;
  priceSpecial?: Maybe<Scalars['Float']['output']>;
  productSettings: ProductSettings;
  productSettingsId: Scalars['String']['output'];
  sanityProductId: Scalars['String']['output'];
  shipheroProductId?: Maybe<Scalars['String']['output']>;
  shipheroSampleProductId?: Maybe<Scalars['String']['output']>;
  shopifyId?: Maybe<Scalars['String']['output']>;
  shopifyVariantId?: Maybe<Scalars['String']['output']>;
  shortDescription: Scalars['String']['output'];
  singleSkuBundleQuantity?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  store?: Maybe<UserStore>;
  storeId?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  tiktokId?: Maybe<Scalars['String']['output']>;
  tiktokSkuId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  woocommerceId?: Maybe<Scalars['String']['output']>;
};


export type ProductPublisherModelCoverImageArgs = {
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type ProductPublisherModelDefaultShippingPackageArgs = {
  where?: InputMaybe<ShippingPackageWhereInput>;
};


export type ProductPublisherModelFilesArgs = {
  cursor?: InputMaybe<UserProductFileWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductFileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductFileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type ProductPublisherModelLabelDraftArgs = {
  where?: InputMaybe<UserProductLabelDraftWhereInput>;
};


export type ProductPublisherModelOnboardingSampleSessionArgs = {
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};


export type ProductPublisherModelStoreArgs = {
  where?: InputMaybe<UserStoreWhereInput>;
};

export type ProductReview = {
  __typename?: 'ProductReview';
  author: Scalars['String']['output'];
  id: Scalars['String']['output'];
  productSettingsId: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type ProductReviewWhereInput = {
  AND?: InputMaybe<Array<ProductReviewWhereInput>>;
  NOT?: InputMaybe<Array<ProductReviewWhereInput>>;
  OR?: InputMaybe<Array<ProductReviewWhereInput>>;
  author?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  productSettings?: InputMaybe<ProductSettingsRelationFilter>;
  productSettingsId?: InputMaybe<StringFilter>;
  rating?: InputMaybe<IntFilter>;
  text?: InputMaybe<StringFilter>;
};

export type ProductSettings = {
  __typename?: 'ProductSettings';
  _count?: Maybe<ProductSettingsCount>;
  canvaTemplate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customsDescription?: Maybe<Scalars['String']['output']>;
  defaultInternationalShippingPackageId?: Maybe<Scalars['String']['output']>;
  defaultShippingPackageId?: Maybe<Scalars['String']['output']>;
  discontinued: Scalars['Boolean']['output'];
  featuredMockup?: Maybe<Scalars['String']['output']>;
  genericLabelFile?: Maybe<Scalars['String']['output']>;
  holdOrdersWhenOutOfStock: Scalars['Boolean']['output'];
  hsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isFulfillmentReady: Scalars['Boolean']['output'];
  isInExtendedCatalog: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  odfId?: Maybe<Scalars['String']['output']>;
  priceSubscribed?: Maybe<Scalars['Float']['output']>;
  priceSupliful?: Maybe<Scalars['Float']['output']>;
  productLabelSizeId?: Maybe<Scalars['String']['output']>;
  productLabellingTechnique: ProductLabellingTechnique;
  restockDate?: Maybe<Scalars['DateTime']['output']>;
  shelf?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: ProductStatus;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  subscriptionDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variantsId?: Maybe<Scalars['String']['output']>;
};

export type ProductSettingsCount = {
  __typename?: 'ProductSettingsCount';
  onboardingSampleOrderSessions: Scalars['Int']['output'];
  reviews: Scalars['Int']['output'];
  stockLevel: Scalars['Int']['output'];
  userProducts: Scalars['Int']['output'];
};


export type ProductSettingsCountOnboardingSampleOrderSessionsArgs = {
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};


export type ProductSettingsCountReviewsArgs = {
  where?: InputMaybe<ProductReviewWhereInput>;
};


export type ProductSettingsCountStockLevelArgs = {
  where?: InputMaybe<ProductStockWhereInput>;
};


export type ProductSettingsCountUserProductsArgs = {
  where?: InputMaybe<UserProductWhereInput>;
};

export type ProductSettingsCreateManyDefaultInternationalShippingPackageInput = {
  canvaTemplate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsDescription?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackageId?: InputMaybe<Scalars['String']['input']>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  featuredMockup?: InputMaybe<Scalars['String']['input']>;
  genericLabelFile?: InputMaybe<Scalars['String']['input']>;
  holdOrdersWhenOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isFulfillmentReady?: InputMaybe<Scalars['Boolean']['input']>;
  isInExtendedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  odfId?: InputMaybe<Scalars['String']['input']>;
  priceSubscribed?: InputMaybe<Scalars['Float']['input']>;
  priceSupliful?: InputMaybe<Scalars['Float']['input']>;
  productLabelSizeId?: InputMaybe<Scalars['String']['input']>;
  productLabellingTechnique?: InputMaybe<ProductLabellingTechnique>;
  restockDate?: InputMaybe<Scalars['DateTime']['input']>;
  shelf?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  subscriptionDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variantsId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSettingsCreateManyDefaultInternationalShippingPackageInputEnvelope = {
  data: Array<ProductSettingsCreateManyDefaultInternationalShippingPackageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductSettingsCreateManyDefaultShippingPackageInput = {
  canvaTemplate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsDescription?: InputMaybe<Scalars['String']['input']>;
  defaultInternationalShippingPackageId?: InputMaybe<Scalars['String']['input']>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  featuredMockup?: InputMaybe<Scalars['String']['input']>;
  genericLabelFile?: InputMaybe<Scalars['String']['input']>;
  holdOrdersWhenOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isFulfillmentReady?: InputMaybe<Scalars['Boolean']['input']>;
  isInExtendedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  odfId?: InputMaybe<Scalars['String']['input']>;
  priceSubscribed?: InputMaybe<Scalars['Float']['input']>;
  priceSupliful?: InputMaybe<Scalars['Float']['input']>;
  productLabelSizeId?: InputMaybe<Scalars['String']['input']>;
  productLabellingTechnique?: InputMaybe<ProductLabellingTechnique>;
  restockDate?: InputMaybe<Scalars['DateTime']['input']>;
  shelf?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  subscriptionDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variantsId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSettingsCreateManyDefaultShippingPackageInputEnvelope = {
  data: Array<ProductSettingsCreateManyDefaultShippingPackageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductSettingsCreateNestedManyWithoutDefaultInternationalShippingPackageInput = {
  connect?: InputMaybe<Array<ProductSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductSettingsCreateOrConnectWithoutDefaultInternationalShippingPackageInput>>;
  create?: InputMaybe<Array<ProductSettingsCreateWithoutDefaultInternationalShippingPackageInput>>;
  createMany?: InputMaybe<ProductSettingsCreateManyDefaultInternationalShippingPackageInputEnvelope>;
};

export type ProductSettingsCreateNestedManyWithoutDefaultShippingPackageInput = {
  connect?: InputMaybe<Array<ProductSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductSettingsCreateOrConnectWithoutDefaultShippingPackageInput>>;
  create?: InputMaybe<Array<ProductSettingsCreateWithoutDefaultShippingPackageInput>>;
  createMany?: InputMaybe<ProductSettingsCreateManyDefaultShippingPackageInputEnvelope>;
};

export type ProductSettingsCreateNestedOneWithoutOnboardingSampleOrderSessionsInput = {
  connect?: InputMaybe<ProductSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSettingsCreateOrConnectWithoutOnboardingSampleOrderSessionsInput>;
  create?: InputMaybe<ProductSettingsCreateWithoutOnboardingSampleOrderSessionsInput>;
};

export type ProductSettingsCreateNestedOneWithoutStockLevelInput = {
  connect?: InputMaybe<ProductSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSettingsCreateOrConnectWithoutStockLevelInput>;
  create?: InputMaybe<ProductSettingsCreateWithoutStockLevelInput>;
};

export type ProductSettingsCreateNestedOneWithoutUserProductsInput = {
  connect?: InputMaybe<ProductSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSettingsCreateOrConnectWithoutUserProductsInput>;
  create?: InputMaybe<ProductSettingsCreateWithoutUserProductsInput>;
};

export type ProductSettingsCreateOrConnectWithoutDefaultInternationalShippingPackageInput = {
  create: ProductSettingsCreateWithoutDefaultInternationalShippingPackageInput;
  where: ProductSettingsWhereUniqueInput;
};

export type ProductSettingsCreateOrConnectWithoutDefaultShippingPackageInput = {
  create: ProductSettingsCreateWithoutDefaultShippingPackageInput;
  where: ProductSettingsWhereUniqueInput;
};

export type ProductSettingsCreateOrConnectWithoutOnboardingSampleOrderSessionsInput = {
  create: ProductSettingsCreateWithoutOnboardingSampleOrderSessionsInput;
  where: ProductSettingsWhereUniqueInput;
};

export type ProductSettingsCreateOrConnectWithoutStockLevelInput = {
  create: ProductSettingsCreateWithoutStockLevelInput;
  where: ProductSettingsWhereUniqueInput;
};

export type ProductSettingsCreateOrConnectWithoutUserProductsInput = {
  create: ProductSettingsCreateWithoutUserProductsInput;
  where: ProductSettingsWhereUniqueInput;
};

export type ProductSettingsCreateWithoutDefaultInternationalShippingPackageInput = {
  canvaTemplate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsDescription?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageProductsInput>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  featuredMockup?: InputMaybe<Scalars['String']['input']>;
  genericLabelFile?: InputMaybe<Scalars['String']['input']>;
  holdOrdersWhenOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isFulfillmentReady?: InputMaybe<Scalars['Boolean']['input']>;
  isInExtendedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  labelSize?: InputMaybe<ProductLabelSizeCreateNestedOneWithoutProductSettingsInput>;
  name: Scalars['String']['input'];
  odfId?: InputMaybe<Scalars['String']['input']>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionCreateNestedManyWithoutProductSettingsInput>;
  priceSubscribed?: InputMaybe<Scalars['Float']['input']>;
  priceSupliful?: InputMaybe<Scalars['Float']['input']>;
  productLabellingTechnique?: InputMaybe<ProductLabellingTechnique>;
  restockDate?: InputMaybe<Scalars['DateTime']['input']>;
  shelf?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  stockLevel?: InputMaybe<ProductStockCreateNestedManyWithoutProductSettingsInput>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  subscriptionDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProducts?: InputMaybe<UserProductCreateNestedManyWithoutProductSettingsInput>;
  variants?: InputMaybe<ProductVariantsCreateNestedOneWithoutProductsInput>;
};

export type ProductSettingsCreateWithoutDefaultShippingPackageInput = {
  canvaTemplate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsDescription?: InputMaybe<Scalars['String']['input']>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultInternationalShippingPackageProductsInput>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  featuredMockup?: InputMaybe<Scalars['String']['input']>;
  genericLabelFile?: InputMaybe<Scalars['String']['input']>;
  holdOrdersWhenOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isFulfillmentReady?: InputMaybe<Scalars['Boolean']['input']>;
  isInExtendedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  labelSize?: InputMaybe<ProductLabelSizeCreateNestedOneWithoutProductSettingsInput>;
  name: Scalars['String']['input'];
  odfId?: InputMaybe<Scalars['String']['input']>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionCreateNestedManyWithoutProductSettingsInput>;
  priceSubscribed?: InputMaybe<Scalars['Float']['input']>;
  priceSupliful?: InputMaybe<Scalars['Float']['input']>;
  productLabellingTechnique?: InputMaybe<ProductLabellingTechnique>;
  restockDate?: InputMaybe<Scalars['DateTime']['input']>;
  shelf?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  stockLevel?: InputMaybe<ProductStockCreateNestedManyWithoutProductSettingsInput>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  subscriptionDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProducts?: InputMaybe<UserProductCreateNestedManyWithoutProductSettingsInput>;
  variants?: InputMaybe<ProductVariantsCreateNestedOneWithoutProductsInput>;
};

export type ProductSettingsCreateWithoutOnboardingSampleOrderSessionsInput = {
  canvaTemplate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsDescription?: InputMaybe<Scalars['String']['input']>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultInternationalShippingPackageProductsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageProductsInput>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  featuredMockup?: InputMaybe<Scalars['String']['input']>;
  genericLabelFile?: InputMaybe<Scalars['String']['input']>;
  holdOrdersWhenOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isFulfillmentReady?: InputMaybe<Scalars['Boolean']['input']>;
  isInExtendedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  labelSize?: InputMaybe<ProductLabelSizeCreateNestedOneWithoutProductSettingsInput>;
  name: Scalars['String']['input'];
  odfId?: InputMaybe<Scalars['String']['input']>;
  priceSubscribed?: InputMaybe<Scalars['Float']['input']>;
  priceSupliful?: InputMaybe<Scalars['Float']['input']>;
  productLabellingTechnique?: InputMaybe<ProductLabellingTechnique>;
  restockDate?: InputMaybe<Scalars['DateTime']['input']>;
  shelf?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  stockLevel?: InputMaybe<ProductStockCreateNestedManyWithoutProductSettingsInput>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  subscriptionDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProducts?: InputMaybe<UserProductCreateNestedManyWithoutProductSettingsInput>;
  variants?: InputMaybe<ProductVariantsCreateNestedOneWithoutProductsInput>;
};

export type ProductSettingsCreateWithoutStockLevelInput = {
  canvaTemplate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsDescription?: InputMaybe<Scalars['String']['input']>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultInternationalShippingPackageProductsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageProductsInput>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  featuredMockup?: InputMaybe<Scalars['String']['input']>;
  genericLabelFile?: InputMaybe<Scalars['String']['input']>;
  holdOrdersWhenOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isFulfillmentReady?: InputMaybe<Scalars['Boolean']['input']>;
  isInExtendedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  labelSize?: InputMaybe<ProductLabelSizeCreateNestedOneWithoutProductSettingsInput>;
  name: Scalars['String']['input'];
  odfId?: InputMaybe<Scalars['String']['input']>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionCreateNestedManyWithoutProductSettingsInput>;
  priceSubscribed?: InputMaybe<Scalars['Float']['input']>;
  priceSupliful?: InputMaybe<Scalars['Float']['input']>;
  productLabellingTechnique?: InputMaybe<ProductLabellingTechnique>;
  restockDate?: InputMaybe<Scalars['DateTime']['input']>;
  shelf?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  subscriptionDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProducts?: InputMaybe<UserProductCreateNestedManyWithoutProductSettingsInput>;
  variants?: InputMaybe<ProductVariantsCreateNestedOneWithoutProductsInput>;
};

export type ProductSettingsCreateWithoutUserProductsInput = {
  canvaTemplate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customsDescription?: InputMaybe<Scalars['String']['input']>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultInternationalShippingPackageProductsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageProductsInput>;
  discontinued?: InputMaybe<Scalars['Boolean']['input']>;
  featuredMockup?: InputMaybe<Scalars['String']['input']>;
  genericLabelFile?: InputMaybe<Scalars['String']['input']>;
  holdOrdersWhenOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isFulfillmentReady?: InputMaybe<Scalars['Boolean']['input']>;
  isInExtendedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  labelSize?: InputMaybe<ProductLabelSizeCreateNestedOneWithoutProductSettingsInput>;
  name: Scalars['String']['input'];
  odfId?: InputMaybe<Scalars['String']['input']>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionCreateNestedManyWithoutProductSettingsInput>;
  priceSubscribed?: InputMaybe<Scalars['Float']['input']>;
  priceSupliful?: InputMaybe<Scalars['Float']['input']>;
  productLabellingTechnique?: InputMaybe<ProductLabellingTechnique>;
  restockDate?: InputMaybe<Scalars['DateTime']['input']>;
  shelf?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  status?: InputMaybe<ProductStatus>;
  stockLevel?: InputMaybe<ProductStockCreateNestedManyWithoutProductSettingsInput>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  subscriptionDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variants?: InputMaybe<ProductVariantsCreateNestedOneWithoutProductsInput>;
};

export type ProductSettingsIdFeaturedMockupCompoundUniqueInput = {
  featuredMockup: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type ProductSettingsListRelationFilter = {
  every?: InputMaybe<ProductSettingsWhereInput>;
  none?: InputMaybe<ProductSettingsWhereInput>;
  some?: InputMaybe<ProductSettingsWhereInput>;
};

export type ProductSettingsModel = {
  __typename?: 'ProductSettingsModel';
  _count?: Maybe<ProductSettingsCount>;
  canvaTemplate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customsDescription?: Maybe<Scalars['String']['output']>;
  defaultInternationalShippingPackageId?: Maybe<Scalars['String']['output']>;
  defaultShippingPackageId?: Maybe<Scalars['String']['output']>;
  discontinued: Scalars['Boolean']['output'];
  featuredMockup?: Maybe<Scalars['String']['output']>;
  fulfillmentChecklist: ProductFulfillmentChecklist;
  genericLabelFile?: Maybe<Scalars['String']['output']>;
  holdOrdersWhenOutOfStock: Scalars['Boolean']['output'];
  hsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isFulfillmentReady: Scalars['Boolean']['output'];
  isInExtendedCatalog: Scalars['Boolean']['output'];
  labelMockupsFile?: Maybe<Scalars['String']['output']>;
  labelMockupsFileV2?: Maybe<Scalars['String']['output']>;
  labelSize?: Maybe<ProductLabelSize>;
  name: Scalars['String']['output'];
  odfId?: Maybe<Scalars['String']['output']>;
  priceSubscribed?: Maybe<Scalars['Float']['output']>;
  priceSupliful?: Maybe<Scalars['Float']['output']>;
  productLabelSizeId?: Maybe<Scalars['String']['output']>;
  productLabellingTechnique: ProductLabellingTechnique;
  restockDate?: Maybe<Scalars['DateTime']['output']>;
  reviews?: Maybe<Array<ProductReview>>;
  shelf?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: ProductStatus;
  stockLevel?: Maybe<Array<ProductStock>>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  subscriptionDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variantsId?: Maybe<Scalars['String']['output']>;
};

export type ProductSettingsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductSettingsOrderByWithRelationInput = {
  canvaTemplate?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customsDescription?: InputMaybe<SortOrderInput>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageOrderByWithRelationInput>;
  defaultInternationalShippingPackageId?: InputMaybe<SortOrderInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageOrderByWithRelationInput>;
  defaultShippingPackageId?: InputMaybe<SortOrderInput>;
  discontinued?: InputMaybe<SortOrder>;
  featuredMockup?: InputMaybe<SortOrderInput>;
  genericLabelFile?: InputMaybe<SortOrderInput>;
  holdOrdersWhenOutOfStock?: InputMaybe<SortOrder>;
  hsCode?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isExclusive?: InputMaybe<SortOrder>;
  isFulfillmentReady?: InputMaybe<SortOrder>;
  isInExtendedCatalog?: InputMaybe<SortOrder>;
  labelSize?: InputMaybe<ProductLabelSizeOrderByWithRelationInput>;
  name?: InputMaybe<SortOrder>;
  odfId?: InputMaybe<SortOrderInput>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionOrderByRelationAggregateInput>;
  priceSubscribed?: InputMaybe<SortOrderInput>;
  priceSupliful?: InputMaybe<SortOrderInput>;
  productLabelSizeId?: InputMaybe<SortOrderInput>;
  productLabellingTechnique?: InputMaybe<SortOrder>;
  restockDate?: InputMaybe<SortOrderInput>;
  shelf?: InputMaybe<SortOrderInput>;
  sku?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  stockLevel?: InputMaybe<ProductStockOrderByRelationAggregateInput>;
  stripeProductId?: InputMaybe<SortOrderInput>;
  subscriptionDiscountPercentage?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userProducts?: InputMaybe<UserProductOrderByRelationAggregateInput>;
  variants?: InputMaybe<ProductVariantsOrderByWithRelationInput>;
  variantsId?: InputMaybe<SortOrderInput>;
};

export type ProductSettingsRelationFilter = {
  is?: InputMaybe<ProductSettingsWhereInput>;
  isNot?: InputMaybe<ProductSettingsWhereInput>;
};

export enum ProductSettingsScalarFieldEnum {
  Availability = 'availability',
  BenefitsSubtitle = 'benefitsSubtitle',
  Bestseller = 'bestseller',
  BuyNowButtonLink = 'buyNowButtonLink',
  CanEditBackground = 'canEditBackground',
  CanPublishToTiktok = 'canPublishToTiktok',
  CanvaTemplate = 'canvaTemplate',
  CategoryId = 'categoryId',
  CountryOfOrigin = 'countryOfOrigin',
  CreatedAt = 'createdAt',
  CustomizationPreviewImage = 'customizationPreviewImage',
  CustomsDescription = 'customsDescription',
  DefaultInternationalShippingPackageId = 'defaultInternationalShippingPackageId',
  DefaultShippingPackageId = 'defaultShippingPackageId',
  Description = 'description',
  Discontinued = 'discontinued',
  EverlabId = 'everlabId',
  ExternalSlug = 'externalSlug',
  FeaturedMockup = 'featuredMockup',
  GenericLabelFile = 'genericLabelFile',
  GenericLabelTemplateFile = 'genericLabelTemplateFile',
  HoldOrdersWhenOutOfStock = 'holdOrdersWhenOutOfStock',
  HsCode = 'hsCode',
  Id = 'id',
  Ingredients = 'ingredients',
  IsDiscontinuedSoon = 'isDiscontinuedSoon',
  IsExclusive = 'isExclusive',
  IsFulfillmentReady = 'isFulfillmentReady',
  IsInExtendedCatalog = 'isInExtendedCatalog',
  IsNew = 'isNew',
  IsPublished = 'isPublished',
  IsRestrictedForNewYork = 'isRestrictedForNewYork',
  JetpackApiId = 'jetpackApiId',
  LabelMockupsFile = 'labelMockupsFile',
  LeadTime = 'leadTime',
  Moq = 'moq',
  Name = 'name',
  NutritionFactsImage = 'nutritionFactsImage',
  OdfId = 'odfId',
  PreOrder = 'preOrder',
  PreOrderText = 'preOrderText',
  PriceDiscounted = 'priceDiscounted',
  PriceManufacturer = 'priceManufacturer',
  PriceRetail = 'priceRetail',
  PriceSubscribed = 'priceSubscribed',
  PriceSupliful = 'priceSupliful',
  ProductAlternativeImage = 'productAlternativeImage',
  ProductFormEnum = 'productFormEnum',
  ProductFormId = 'productFormId',
  ProductGalleryImages = 'productGalleryImages',
  ProductImage = 'productImage',
  ProductLabelSizeId = 'productLabelSizeId',
  ProductLabellingTechnique = 'productLabellingTechnique',
  RestockDate = 'restockDate',
  RoastifyId = 'roastifyId',
  Sequence = 'sequence',
  Shelf = 'shelf',
  ShipbobId = 'shipbobId',
  ShortDescription = 'shortDescription',
  Sku = 'sku',
  Slug = 'slug',
  StartingPrice = 'startingPrice',
  Status = 'status',
  StripeProductId = 'stripeProductId',
  SubscriptionDiscountPercentage = 'subscriptionDiscountPercentage',
  SupplierId = 'supplierId',
  TiktokAgeWarning = 'tiktokAgeWarning',
  TiktokCategoryId = 'tiktokCategoryId',
  UpdatedAt = 'updatedAt',
  VariantsId = 'variantsId'
}

export type ProductSettingsScalarWhereInput = {
  AND?: InputMaybe<Array<ProductSettingsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductSettingsScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductSettingsScalarWhereInput>>;
  canvaTemplate?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customsDescription?: InputMaybe<StringNullableFilter>;
  defaultInternationalShippingPackageId?: InputMaybe<UuidNullableFilter>;
  defaultShippingPackageId?: InputMaybe<UuidNullableFilter>;
  discontinued?: InputMaybe<BoolFilter>;
  featuredMockup?: InputMaybe<StringNullableFilter>;
  genericLabelFile?: InputMaybe<StringNullableFilter>;
  holdOrdersWhenOutOfStock?: InputMaybe<BoolFilter>;
  hsCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isExclusive?: InputMaybe<BoolFilter>;
  isFulfillmentReady?: InputMaybe<BoolFilter>;
  isInExtendedCatalog?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  odfId?: InputMaybe<StringNullableFilter>;
  priceSubscribed?: InputMaybe<FloatNullableFilter>;
  priceSupliful?: InputMaybe<FloatNullableFilter>;
  productLabelSizeId?: InputMaybe<UuidNullableFilter>;
  productLabellingTechnique?: InputMaybe<EnumProductLabellingTechniqueFilter>;
  restockDate?: InputMaybe<DateTimeNullableFilter>;
  shelf?: InputMaybe<StringNullableFilter>;
  sku?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumProductStatusFilter>;
  stripeProductId?: InputMaybe<StringNullableFilter>;
  subscriptionDiscountPercentage?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  variantsId?: InputMaybe<UuidNullableFilter>;
};

export type ProductSettingsUpdateInput = {
  canvaTemplate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultInternationalShippingPackageProductsNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageProductsNestedInput>;
  discontinued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  featuredMockup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  genericLabelFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  holdOrdersWhenOutOfStock?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hsCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isExclusive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFulfillmentReady?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInExtendedCatalog?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelSize?: InputMaybe<ProductLabelSizeUpdateOneWithoutProductSettingsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  odfId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionUpdateManyWithoutProductSettingsNestedInput>;
  priceSubscribed?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSupliful?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productLabellingTechnique?: InputMaybe<EnumProductLabellingTechniqueFieldUpdateOperationsInput>;
  restockDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shelf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumProductStatusFieldUpdateOperationsInput>;
  stockLevel?: InputMaybe<ProductStockUpdateManyWithoutProductSettingsNestedInput>;
  stripeProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subscriptionDiscountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProducts?: InputMaybe<UserProductUpdateManyWithoutProductSettingsNestedInput>;
  variants?: InputMaybe<ProductVariantsUpdateOneWithoutProductsNestedInput>;
};

export type ProductSettingsUpdateManyMutationInput = {
  canvaTemplate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discontinued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  featuredMockup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  genericLabelFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  holdOrdersWhenOutOfStock?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hsCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isExclusive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFulfillmentReady?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInExtendedCatalog?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  odfId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceSubscribed?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSupliful?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productLabellingTechnique?: InputMaybe<EnumProductLabellingTechniqueFieldUpdateOperationsInput>;
  restockDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shelf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumProductStatusFieldUpdateOperationsInput>;
  stripeProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subscriptionDiscountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductSettingsUpdateManyWithWhereWithoutDefaultInternationalShippingPackageInput = {
  data: ProductSettingsUpdateManyMutationInput;
  where: ProductSettingsScalarWhereInput;
};

export type ProductSettingsUpdateManyWithWhereWithoutDefaultShippingPackageInput = {
  data: ProductSettingsUpdateManyMutationInput;
  where: ProductSettingsScalarWhereInput;
};

export type ProductSettingsUpdateManyWithoutDefaultInternationalShippingPackageNestedInput = {
  connect?: InputMaybe<Array<ProductSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductSettingsCreateOrConnectWithoutDefaultInternationalShippingPackageInput>>;
  create?: InputMaybe<Array<ProductSettingsCreateWithoutDefaultInternationalShippingPackageInput>>;
  createMany?: InputMaybe<ProductSettingsCreateManyDefaultInternationalShippingPackageInputEnvelope>;
  delete?: InputMaybe<Array<ProductSettingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductSettingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductSettingsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductSettingsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductSettingsUpdateWithWhereUniqueWithoutDefaultInternationalShippingPackageInput>>;
  updateMany?: InputMaybe<Array<ProductSettingsUpdateManyWithWhereWithoutDefaultInternationalShippingPackageInput>>;
  upsert?: InputMaybe<Array<ProductSettingsUpsertWithWhereUniqueWithoutDefaultInternationalShippingPackageInput>>;
};

export type ProductSettingsUpdateManyWithoutDefaultShippingPackageNestedInput = {
  connect?: InputMaybe<Array<ProductSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductSettingsCreateOrConnectWithoutDefaultShippingPackageInput>>;
  create?: InputMaybe<Array<ProductSettingsCreateWithoutDefaultShippingPackageInput>>;
  createMany?: InputMaybe<ProductSettingsCreateManyDefaultShippingPackageInputEnvelope>;
  delete?: InputMaybe<Array<ProductSettingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductSettingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductSettingsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductSettingsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductSettingsUpdateWithWhereUniqueWithoutDefaultShippingPackageInput>>;
  updateMany?: InputMaybe<Array<ProductSettingsUpdateManyWithWhereWithoutDefaultShippingPackageInput>>;
  upsert?: InputMaybe<Array<ProductSettingsUpsertWithWhereUniqueWithoutDefaultShippingPackageInput>>;
};

export type ProductSettingsUpdateOneRequiredWithoutOnboardingSampleOrderSessionsNestedInput = {
  connect?: InputMaybe<ProductSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSettingsCreateOrConnectWithoutOnboardingSampleOrderSessionsInput>;
  create?: InputMaybe<ProductSettingsCreateWithoutOnboardingSampleOrderSessionsInput>;
  update?: InputMaybe<ProductSettingsUpdateToOneWithWhereWithoutOnboardingSampleOrderSessionsInput>;
  upsert?: InputMaybe<ProductSettingsUpsertWithoutOnboardingSampleOrderSessionsInput>;
};

export type ProductSettingsUpdateOneRequiredWithoutStockLevelNestedInput = {
  connect?: InputMaybe<ProductSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSettingsCreateOrConnectWithoutStockLevelInput>;
  create?: InputMaybe<ProductSettingsCreateWithoutStockLevelInput>;
  update?: InputMaybe<ProductSettingsUpdateToOneWithWhereWithoutStockLevelInput>;
  upsert?: InputMaybe<ProductSettingsUpsertWithoutStockLevelInput>;
};

export type ProductSettingsUpdateOneRequiredWithoutUserProductsNestedInput = {
  connect?: InputMaybe<ProductSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSettingsCreateOrConnectWithoutUserProductsInput>;
  create?: InputMaybe<ProductSettingsCreateWithoutUserProductsInput>;
  update?: InputMaybe<ProductSettingsUpdateToOneWithWhereWithoutUserProductsInput>;
  upsert?: InputMaybe<ProductSettingsUpsertWithoutUserProductsInput>;
};

export type ProductSettingsUpdateToOneWithWhereWithoutOnboardingSampleOrderSessionsInput = {
  data: ProductSettingsUpdateWithoutOnboardingSampleOrderSessionsInput;
  where?: InputMaybe<ProductSettingsWhereInput>;
};

export type ProductSettingsUpdateToOneWithWhereWithoutStockLevelInput = {
  data: ProductSettingsUpdateWithoutStockLevelInput;
  where?: InputMaybe<ProductSettingsWhereInput>;
};

export type ProductSettingsUpdateToOneWithWhereWithoutUserProductsInput = {
  data: ProductSettingsUpdateWithoutUserProductsInput;
  where?: InputMaybe<ProductSettingsWhereInput>;
};

export type ProductSettingsUpdateWithWhereUniqueWithoutDefaultInternationalShippingPackageInput = {
  data: ProductSettingsUpdateWithoutDefaultInternationalShippingPackageInput;
  where: ProductSettingsWhereUniqueInput;
};

export type ProductSettingsUpdateWithWhereUniqueWithoutDefaultShippingPackageInput = {
  data: ProductSettingsUpdateWithoutDefaultShippingPackageInput;
  where: ProductSettingsWhereUniqueInput;
};

export type ProductSettingsUpdateWithoutDefaultInternationalShippingPackageInput = {
  canvaTemplate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageProductsNestedInput>;
  discontinued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  featuredMockup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  genericLabelFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  holdOrdersWhenOutOfStock?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hsCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isExclusive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFulfillmentReady?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInExtendedCatalog?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelSize?: InputMaybe<ProductLabelSizeUpdateOneWithoutProductSettingsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  odfId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionUpdateManyWithoutProductSettingsNestedInput>;
  priceSubscribed?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSupliful?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productLabellingTechnique?: InputMaybe<EnumProductLabellingTechniqueFieldUpdateOperationsInput>;
  restockDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shelf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumProductStatusFieldUpdateOperationsInput>;
  stockLevel?: InputMaybe<ProductStockUpdateManyWithoutProductSettingsNestedInput>;
  stripeProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subscriptionDiscountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProducts?: InputMaybe<UserProductUpdateManyWithoutProductSettingsNestedInput>;
  variants?: InputMaybe<ProductVariantsUpdateOneWithoutProductsNestedInput>;
};

export type ProductSettingsUpdateWithoutDefaultShippingPackageInput = {
  canvaTemplate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultInternationalShippingPackageProductsNestedInput>;
  discontinued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  featuredMockup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  genericLabelFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  holdOrdersWhenOutOfStock?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hsCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isExclusive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFulfillmentReady?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInExtendedCatalog?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelSize?: InputMaybe<ProductLabelSizeUpdateOneWithoutProductSettingsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  odfId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionUpdateManyWithoutProductSettingsNestedInput>;
  priceSubscribed?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSupliful?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productLabellingTechnique?: InputMaybe<EnumProductLabellingTechniqueFieldUpdateOperationsInput>;
  restockDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shelf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumProductStatusFieldUpdateOperationsInput>;
  stockLevel?: InputMaybe<ProductStockUpdateManyWithoutProductSettingsNestedInput>;
  stripeProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subscriptionDiscountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProducts?: InputMaybe<UserProductUpdateManyWithoutProductSettingsNestedInput>;
  variants?: InputMaybe<ProductVariantsUpdateOneWithoutProductsNestedInput>;
};

export type ProductSettingsUpdateWithoutOnboardingSampleOrderSessionsInput = {
  canvaTemplate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultInternationalShippingPackageProductsNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageProductsNestedInput>;
  discontinued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  featuredMockup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  genericLabelFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  holdOrdersWhenOutOfStock?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hsCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isExclusive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFulfillmentReady?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInExtendedCatalog?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelSize?: InputMaybe<ProductLabelSizeUpdateOneWithoutProductSettingsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  odfId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceSubscribed?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSupliful?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productLabellingTechnique?: InputMaybe<EnumProductLabellingTechniqueFieldUpdateOperationsInput>;
  restockDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shelf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumProductStatusFieldUpdateOperationsInput>;
  stockLevel?: InputMaybe<ProductStockUpdateManyWithoutProductSettingsNestedInput>;
  stripeProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subscriptionDiscountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProducts?: InputMaybe<UserProductUpdateManyWithoutProductSettingsNestedInput>;
  variants?: InputMaybe<ProductVariantsUpdateOneWithoutProductsNestedInput>;
};

export type ProductSettingsUpdateWithoutStockLevelInput = {
  canvaTemplate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultInternationalShippingPackageProductsNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageProductsNestedInput>;
  discontinued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  featuredMockup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  genericLabelFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  holdOrdersWhenOutOfStock?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hsCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isExclusive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFulfillmentReady?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInExtendedCatalog?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelSize?: InputMaybe<ProductLabelSizeUpdateOneWithoutProductSettingsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  odfId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionUpdateManyWithoutProductSettingsNestedInput>;
  priceSubscribed?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSupliful?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productLabellingTechnique?: InputMaybe<EnumProductLabellingTechniqueFieldUpdateOperationsInput>;
  restockDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shelf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumProductStatusFieldUpdateOperationsInput>;
  stripeProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subscriptionDiscountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProducts?: InputMaybe<UserProductUpdateManyWithoutProductSettingsNestedInput>;
  variants?: InputMaybe<ProductVariantsUpdateOneWithoutProductsNestedInput>;
};

export type ProductSettingsUpdateWithoutUserProductsInput = {
  canvaTemplate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultInternationalShippingPackageProductsNestedInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageProductsNestedInput>;
  discontinued?: InputMaybe<BoolFieldUpdateOperationsInput>;
  featuredMockup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  genericLabelFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  holdOrdersWhenOutOfStock?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hsCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isExclusive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isFulfillmentReady?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isInExtendedCatalog?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelSize?: InputMaybe<ProductLabelSizeUpdateOneWithoutProductSettingsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  odfId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionUpdateManyWithoutProductSettingsNestedInput>;
  priceSubscribed?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSupliful?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productLabellingTechnique?: InputMaybe<EnumProductLabellingTechniqueFieldUpdateOperationsInput>;
  restockDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shelf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumProductStatusFieldUpdateOperationsInput>;
  stockLevel?: InputMaybe<ProductStockUpdateManyWithoutProductSettingsNestedInput>;
  stripeProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subscriptionDiscountPercentage?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  variants?: InputMaybe<ProductVariantsUpdateOneWithoutProductsNestedInput>;
};

export type ProductSettingsUpsertWithWhereUniqueWithoutDefaultInternationalShippingPackageInput = {
  create: ProductSettingsCreateWithoutDefaultInternationalShippingPackageInput;
  update: ProductSettingsUpdateWithoutDefaultInternationalShippingPackageInput;
  where: ProductSettingsWhereUniqueInput;
};

export type ProductSettingsUpsertWithWhereUniqueWithoutDefaultShippingPackageInput = {
  create: ProductSettingsCreateWithoutDefaultShippingPackageInput;
  update: ProductSettingsUpdateWithoutDefaultShippingPackageInput;
  where: ProductSettingsWhereUniqueInput;
};

export type ProductSettingsUpsertWithoutOnboardingSampleOrderSessionsInput = {
  create: ProductSettingsCreateWithoutOnboardingSampleOrderSessionsInput;
  update: ProductSettingsUpdateWithoutOnboardingSampleOrderSessionsInput;
  where?: InputMaybe<ProductSettingsWhereInput>;
};

export type ProductSettingsUpsertWithoutStockLevelInput = {
  create: ProductSettingsCreateWithoutStockLevelInput;
  update: ProductSettingsUpdateWithoutStockLevelInput;
  where?: InputMaybe<ProductSettingsWhereInput>;
};

export type ProductSettingsUpsertWithoutUserProductsInput = {
  create: ProductSettingsCreateWithoutUserProductsInput;
  update: ProductSettingsUpdateWithoutUserProductsInput;
  where?: InputMaybe<ProductSettingsWhereInput>;
};

export type ProductSettingsWhereInput = {
  AND?: InputMaybe<Array<ProductSettingsWhereInput>>;
  NOT?: InputMaybe<Array<ProductSettingsWhereInput>>;
  OR?: InputMaybe<Array<ProductSettingsWhereInput>>;
  canvaTemplate?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customsDescription?: InputMaybe<StringNullableFilter>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageNullableRelationFilter>;
  defaultInternationalShippingPackageId?: InputMaybe<UuidNullableFilter>;
  defaultShippingPackage?: InputMaybe<ShippingPackageNullableRelationFilter>;
  defaultShippingPackageId?: InputMaybe<UuidNullableFilter>;
  discontinued?: InputMaybe<BoolFilter>;
  featuredMockup?: InputMaybe<StringNullableFilter>;
  genericLabelFile?: InputMaybe<StringNullableFilter>;
  holdOrdersWhenOutOfStock?: InputMaybe<BoolFilter>;
  hsCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isExclusive?: InputMaybe<BoolFilter>;
  isFulfillmentReady?: InputMaybe<BoolFilter>;
  isInExtendedCatalog?: InputMaybe<BoolFilter>;
  labelSize?: InputMaybe<ProductLabelSizeNullableRelationFilter>;
  name?: InputMaybe<StringFilter>;
  odfId?: InputMaybe<StringNullableFilter>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionListRelationFilter>;
  priceSubscribed?: InputMaybe<FloatNullableFilter>;
  priceSupliful?: InputMaybe<FloatNullableFilter>;
  productLabelSizeId?: InputMaybe<UuidNullableFilter>;
  productLabellingTechnique?: InputMaybe<EnumProductLabellingTechniqueFilter>;
  restockDate?: InputMaybe<DateTimeNullableFilter>;
  shelf?: InputMaybe<StringNullableFilter>;
  sku?: InputMaybe<StringFilter>;
  slug?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumProductStatusFilter>;
  stockLevel?: InputMaybe<ProductStockListRelationFilter>;
  stripeProductId?: InputMaybe<StringNullableFilter>;
  subscriptionDiscountPercentage?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProducts?: InputMaybe<UserProductListRelationFilter>;
  variants?: InputMaybe<ProductVariantsNullableRelationFilter>;
  variantsId?: InputMaybe<UuidNullableFilter>;
};

export type ProductSettingsWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductSettingsWhereInput>>;
  NOT?: InputMaybe<Array<ProductSettingsWhereInput>>;
  OR?: InputMaybe<Array<ProductSettingsWhereInput>>;
  canvaTemplate?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customsDescription?: InputMaybe<StringNullableFilter>;
  defaultInternationalShippingPackage?: InputMaybe<ShippingPackageNullableRelationFilter>;
  defaultInternationalShippingPackageId?: InputMaybe<UuidNullableFilter>;
  defaultShippingPackage?: InputMaybe<ShippingPackageNullableRelationFilter>;
  defaultShippingPackageId?: InputMaybe<UuidNullableFilter>;
  discontinued?: InputMaybe<BoolFilter>;
  featuredMockup?: InputMaybe<StringNullableFilter>;
  genericLabelFile?: InputMaybe<StringNullableFilter>;
  holdOrdersWhenOutOfStock?: InputMaybe<BoolFilter>;
  hsCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_featuredMockup?: InputMaybe<ProductSettingsIdFeaturedMockupCompoundUniqueInput>;
  isExclusive?: InputMaybe<BoolFilter>;
  isFulfillmentReady?: InputMaybe<BoolFilter>;
  isInExtendedCatalog?: InputMaybe<BoolFilter>;
  labelSize?: InputMaybe<ProductLabelSizeNullableRelationFilter>;
  name?: InputMaybe<StringFilter>;
  odfId?: InputMaybe<Scalars['String']['input']>;
  onboardingSampleOrderSessions?: InputMaybe<OnboardingSampleOrderSessionListRelationFilter>;
  priceSubscribed?: InputMaybe<FloatNullableFilter>;
  priceSupliful?: InputMaybe<FloatNullableFilter>;
  productLabelSizeId?: InputMaybe<UuidNullableFilter>;
  productLabellingTechnique?: InputMaybe<EnumProductLabellingTechniqueFilter>;
  restockDate?: InputMaybe<DateTimeNullableFilter>;
  shelf?: InputMaybe<StringNullableFilter>;
  sku?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumProductStatusFilter>;
  stockLevel?: InputMaybe<ProductStockListRelationFilter>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  subscriptionDiscountPercentage?: InputMaybe<FloatNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProducts?: InputMaybe<UserProductListRelationFilter>;
  variants?: InputMaybe<ProductVariantsNullableRelationFilter>;
  variantsId?: InputMaybe<UuidNullableFilter>;
};

export enum ProductStatus {
  Discontinued = 'DISCONTINUED',
  InStock = 'IN_STOCK',
  OutOfStock = 'OUT_OF_STOCK',
  TemporarilyUnavailable = 'TEMPORARILY_UNAVAILABLE'
}

export type ProductStock = {
  __typename?: 'ProductStock';
  _count?: Maybe<ProductStockCount>;
  fulfillmentSku: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  lastStockSnapshotDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  pendingItems: Scalars['Float']['output'];
  priority: Scalars['Int']['output'];
  productSettingsId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['String']['output'];
};

export type ProductStockCount = {
  __typename?: 'ProductStockCount';
  productStockSnapshots: Scalars['Int']['output'];
};


export type ProductStockCountProductStockSnapshotsArgs = {
  where?: InputMaybe<ProductStockSnapshotWhereInput>;
};

export type ProductStockCreateInput = {
  fulfillmentSku: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['Int']['input'];
  productSettings: ProductSettingsCreateNestedOneWithoutStockLevelInput;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutProductStockInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  warehouse: WarehouseCreateNestedOneWithoutProductStockInput;
};

export type ProductStockCreateManyProductSettingsInput = {
  fulfillmentSku: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  warehouseId: Scalars['String']['input'];
};

export type ProductStockCreateManyProductSettingsInputEnvelope = {
  data: Array<ProductStockCreateManyProductSettingsInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductStockCreateManyWarehouseInput = {
  fulfillmentSku: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['Int']['input'];
  productSettingsId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductStockCreateManyWarehouseInputEnvelope = {
  data: Array<ProductStockCreateManyWarehouseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductStockCreateNestedManyWithoutProductSettingsInput = {
  connect?: InputMaybe<Array<ProductStockWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductStockCreateOrConnectWithoutProductSettingsInput>>;
  create?: InputMaybe<Array<ProductStockCreateWithoutProductSettingsInput>>;
  createMany?: InputMaybe<ProductStockCreateManyProductSettingsInputEnvelope>;
};

export type ProductStockCreateNestedManyWithoutWarehouseInput = {
  connect?: InputMaybe<Array<ProductStockWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductStockCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<ProductStockCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<ProductStockCreateManyWarehouseInputEnvelope>;
};

export type ProductStockCreateNestedOneWithoutProductStockSnapshotsInput = {
  connect?: InputMaybe<ProductStockWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductStockCreateOrConnectWithoutProductStockSnapshotsInput>;
  create?: InputMaybe<ProductStockCreateWithoutProductStockSnapshotsInput>;
};

export type ProductStockCreateOrConnectWithoutProductSettingsInput = {
  create: ProductStockCreateWithoutProductSettingsInput;
  where: ProductStockWhereUniqueInput;
};

export type ProductStockCreateOrConnectWithoutProductStockSnapshotsInput = {
  create: ProductStockCreateWithoutProductStockSnapshotsInput;
  where: ProductStockWhereUniqueInput;
};

export type ProductStockCreateOrConnectWithoutWarehouseInput = {
  create: ProductStockCreateWithoutWarehouseInput;
  where: ProductStockWhereUniqueInput;
};

export type ProductStockCreateWithoutProductSettingsInput = {
  fulfillmentSku: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['Int']['input'];
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutProductStockInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  warehouse: WarehouseCreateNestedOneWithoutProductStockInput;
};

export type ProductStockCreateWithoutProductStockSnapshotsInput = {
  fulfillmentSku: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['Int']['input'];
  productSettings: ProductSettingsCreateNestedOneWithoutStockLevelInput;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  warehouse: WarehouseCreateNestedOneWithoutProductStockInput;
};

export type ProductStockCreateWithoutWarehouseInput = {
  fulfillmentSku: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['Int']['input'];
  productSettings: ProductSettingsCreateNestedOneWithoutStockLevelInput;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotCreateNestedManyWithoutProductStockInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductStockListRelationFilter = {
  every?: InputMaybe<ProductStockWhereInput>;
  none?: InputMaybe<ProductStockWhereInput>;
  some?: InputMaybe<ProductStockWhereInput>;
};

export type ProductStockOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductStockOrderByWithRelationInput = {
  fulfillmentSku?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAvailable?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrder>;
  productSettings?: InputMaybe<ProductSettingsOrderByWithRelationInput>;
  productSettingsId?: InputMaybe<SortOrder>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotOrderByRelationAggregateInput>;
  quantity?: InputMaybe<SortOrder>;
  warehouse?: InputMaybe<WarehouseOrderByWithRelationInput>;
  warehouseId?: InputMaybe<SortOrder>;
};

export type ProductStockProductSettingsIdWarehouseIdCompoundUniqueInput = {
  productSettingsId: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
};

export type ProductStockQuantityImportInput = {
  importFile: Scalars['Upload']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductStockRelationFilter = {
  is?: InputMaybe<ProductStockWhereInput>;
  isNot?: InputMaybe<ProductStockWhereInput>;
};

export enum ProductStockScalarFieldEnum {
  FulfillmentSku = 'fulfillmentSku',
  Id = 'id',
  IsAvailable = 'isAvailable',
  Priority = 'priority',
  ProductSettingsId = 'productSettingsId',
  Quantity = 'quantity',
  WarehouseId = 'warehouseId'
}

export type ProductStockScalarWhereInput = {
  AND?: InputMaybe<Array<ProductStockScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductStockScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductStockScalarWhereInput>>;
  fulfillmentSku?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isAvailable?: InputMaybe<BoolFilter>;
  priority?: InputMaybe<IntFilter>;
  productSettingsId?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type ProductStockSnapshotCreateManyProductStockInput = {
  finalStockQuantity: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inTransitQuantity: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
  recordedById: Scalars['String']['input'];
};

export type ProductStockSnapshotCreateManyProductStockInputEnvelope = {
  data: Array<ProductStockSnapshotCreateManyProductStockInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductStockSnapshotCreateManyRecordedByInput = {
  finalStockQuantity: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inTransitQuantity: Scalars['Int']['input'];
  productStockId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
};

export type ProductStockSnapshotCreateManyRecordedByInputEnvelope = {
  data: Array<ProductStockSnapshotCreateManyRecordedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductStockSnapshotCreateNestedManyWithoutProductStockInput = {
  connect?: InputMaybe<Array<ProductStockSnapshotWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductStockSnapshotCreateOrConnectWithoutProductStockInput>>;
  create?: InputMaybe<Array<ProductStockSnapshotCreateWithoutProductStockInput>>;
  createMany?: InputMaybe<ProductStockSnapshotCreateManyProductStockInputEnvelope>;
};

export type ProductStockSnapshotCreateNestedManyWithoutRecordedByInput = {
  connect?: InputMaybe<Array<ProductStockSnapshotWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductStockSnapshotCreateOrConnectWithoutRecordedByInput>>;
  create?: InputMaybe<Array<ProductStockSnapshotCreateWithoutRecordedByInput>>;
  createMany?: InputMaybe<ProductStockSnapshotCreateManyRecordedByInputEnvelope>;
};

export type ProductStockSnapshotCreateOrConnectWithoutProductStockInput = {
  create: ProductStockSnapshotCreateWithoutProductStockInput;
  where: ProductStockSnapshotWhereUniqueInput;
};

export type ProductStockSnapshotCreateOrConnectWithoutRecordedByInput = {
  create: ProductStockSnapshotCreateWithoutRecordedByInput;
  where: ProductStockSnapshotWhereUniqueInput;
};

export type ProductStockSnapshotCreateWithoutProductStockInput = {
  finalStockQuantity: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inTransitQuantity: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
  recordedBy: AdminCreateNestedOneWithoutProductStockSnapshotsInput;
};

export type ProductStockSnapshotCreateWithoutRecordedByInput = {
  finalStockQuantity: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inTransitQuantity: Scalars['Int']['input'];
  productStock: ProductStockCreateNestedOneWithoutProductStockSnapshotsInput;
  quantity: Scalars['Int']['input'];
  recordedAt: Scalars['DateTime']['input'];
};

export type ProductStockSnapshotListRelationFilter = {
  every?: InputMaybe<ProductStockSnapshotWhereInput>;
  none?: InputMaybe<ProductStockSnapshotWhereInput>;
  some?: InputMaybe<ProductStockSnapshotWhereInput>;
};

export type ProductStockSnapshotOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductStockSnapshotScalarWhereInput = {
  AND?: InputMaybe<Array<ProductStockSnapshotScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductStockSnapshotScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductStockSnapshotScalarWhereInput>>;
  finalStockQuantity?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  inTransitQuantity?: InputMaybe<IntFilter>;
  productStockId?: InputMaybe<UuidFilter>;
  quantity?: InputMaybe<IntFilter>;
  recordedAt?: InputMaybe<DateTimeFilter>;
  recordedById?: InputMaybe<UuidFilter>;
};

export type ProductStockSnapshotUpdateManyMutationInput = {
  finalStockQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inTransitQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  recordedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductStockSnapshotUpdateManyWithWhereWithoutProductStockInput = {
  data: ProductStockSnapshotUpdateManyMutationInput;
  where: ProductStockSnapshotScalarWhereInput;
};

export type ProductStockSnapshotUpdateManyWithWhereWithoutRecordedByInput = {
  data: ProductStockSnapshotUpdateManyMutationInput;
  where: ProductStockSnapshotScalarWhereInput;
};

export type ProductStockSnapshotUpdateManyWithoutProductStockNestedInput = {
  connect?: InputMaybe<Array<ProductStockSnapshotWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductStockSnapshotCreateOrConnectWithoutProductStockInput>>;
  create?: InputMaybe<Array<ProductStockSnapshotCreateWithoutProductStockInput>>;
  createMany?: InputMaybe<ProductStockSnapshotCreateManyProductStockInputEnvelope>;
  delete?: InputMaybe<Array<ProductStockSnapshotWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductStockSnapshotScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductStockSnapshotWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductStockSnapshotWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductStockSnapshotUpdateWithWhereUniqueWithoutProductStockInput>>;
  updateMany?: InputMaybe<Array<ProductStockSnapshotUpdateManyWithWhereWithoutProductStockInput>>;
  upsert?: InputMaybe<Array<ProductStockSnapshotUpsertWithWhereUniqueWithoutProductStockInput>>;
};

export type ProductStockSnapshotUpdateManyWithoutRecordedByNestedInput = {
  connect?: InputMaybe<Array<ProductStockSnapshotWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductStockSnapshotCreateOrConnectWithoutRecordedByInput>>;
  create?: InputMaybe<Array<ProductStockSnapshotCreateWithoutRecordedByInput>>;
  createMany?: InputMaybe<ProductStockSnapshotCreateManyRecordedByInputEnvelope>;
  delete?: InputMaybe<Array<ProductStockSnapshotWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductStockSnapshotScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductStockSnapshotWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductStockSnapshotWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductStockSnapshotUpdateWithWhereUniqueWithoutRecordedByInput>>;
  updateMany?: InputMaybe<Array<ProductStockSnapshotUpdateManyWithWhereWithoutRecordedByInput>>;
  upsert?: InputMaybe<Array<ProductStockSnapshotUpsertWithWhereUniqueWithoutRecordedByInput>>;
};

export type ProductStockSnapshotUpdateWithWhereUniqueWithoutProductStockInput = {
  data: ProductStockSnapshotUpdateWithoutProductStockInput;
  where: ProductStockSnapshotWhereUniqueInput;
};

export type ProductStockSnapshotUpdateWithWhereUniqueWithoutRecordedByInput = {
  data: ProductStockSnapshotUpdateWithoutRecordedByInput;
  where: ProductStockSnapshotWhereUniqueInput;
};

export type ProductStockSnapshotUpdateWithoutProductStockInput = {
  finalStockQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inTransitQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  recordedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  recordedBy?: InputMaybe<AdminUpdateOneRequiredWithoutProductStockSnapshotsNestedInput>;
};

export type ProductStockSnapshotUpdateWithoutRecordedByInput = {
  finalStockQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inTransitQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  productStock?: InputMaybe<ProductStockUpdateOneRequiredWithoutProductStockSnapshotsNestedInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  recordedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductStockSnapshotUpsertWithWhereUniqueWithoutProductStockInput = {
  create: ProductStockSnapshotCreateWithoutProductStockInput;
  update: ProductStockSnapshotUpdateWithoutProductStockInput;
  where: ProductStockSnapshotWhereUniqueInput;
};

export type ProductStockSnapshotUpsertWithWhereUniqueWithoutRecordedByInput = {
  create: ProductStockSnapshotCreateWithoutRecordedByInput;
  update: ProductStockSnapshotUpdateWithoutRecordedByInput;
  where: ProductStockSnapshotWhereUniqueInput;
};

export type ProductStockSnapshotWhereInput = {
  AND?: InputMaybe<Array<ProductStockSnapshotWhereInput>>;
  NOT?: InputMaybe<Array<ProductStockSnapshotWhereInput>>;
  OR?: InputMaybe<Array<ProductStockSnapshotWhereInput>>;
  finalStockQuantity?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  inTransitQuantity?: InputMaybe<IntFilter>;
  productStock?: InputMaybe<ProductStockRelationFilter>;
  productStockId?: InputMaybe<UuidFilter>;
  quantity?: InputMaybe<IntFilter>;
  recordedAt?: InputMaybe<DateTimeFilter>;
  recordedBy?: InputMaybe<AdminRelationFilter>;
  recordedById?: InputMaybe<UuidFilter>;
};

export type ProductStockSnapshotWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductStockSnapshotWhereInput>>;
  NOT?: InputMaybe<Array<ProductStockSnapshotWhereInput>>;
  OR?: InputMaybe<Array<ProductStockSnapshotWhereInput>>;
  finalStockQuantity?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  inTransitQuantity?: InputMaybe<IntFilter>;
  productStock?: InputMaybe<ProductStockRelationFilter>;
  productStockId?: InputMaybe<UuidFilter>;
  quantity?: InputMaybe<IntFilter>;
  recordedAt?: InputMaybe<DateTimeFilter>;
  recordedBy?: InputMaybe<AdminRelationFilter>;
  recordedById?: InputMaybe<UuidFilter>;
};

export type ProductStockUpdateInput = {
  fulfillmentSku?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutStockLevelNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutProductStockNestedInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutProductStockNestedInput>;
};

export type ProductStockUpdateManyMutationInput = {
  fulfillmentSku?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProductStockUpdateManyWithWhereWithoutProductSettingsInput = {
  data: ProductStockUpdateManyMutationInput;
  where: ProductStockScalarWhereInput;
};

export type ProductStockUpdateManyWithWhereWithoutWarehouseInput = {
  data: ProductStockUpdateManyMutationInput;
  where: ProductStockScalarWhereInput;
};

export type ProductStockUpdateManyWithoutProductSettingsNestedInput = {
  connect?: InputMaybe<Array<ProductStockWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductStockCreateOrConnectWithoutProductSettingsInput>>;
  create?: InputMaybe<Array<ProductStockCreateWithoutProductSettingsInput>>;
  createMany?: InputMaybe<ProductStockCreateManyProductSettingsInputEnvelope>;
  delete?: InputMaybe<Array<ProductStockWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductStockScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductStockWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductStockWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductStockUpdateWithWhereUniqueWithoutProductSettingsInput>>;
  updateMany?: InputMaybe<Array<ProductStockUpdateManyWithWhereWithoutProductSettingsInput>>;
  upsert?: InputMaybe<Array<ProductStockUpsertWithWhereUniqueWithoutProductSettingsInput>>;
};

export type ProductStockUpdateManyWithoutWarehouseNestedInput = {
  connect?: InputMaybe<Array<ProductStockWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductStockCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<ProductStockCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<ProductStockCreateManyWarehouseInputEnvelope>;
  delete?: InputMaybe<Array<ProductStockWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductStockScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductStockWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductStockWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductStockUpdateWithWhereUniqueWithoutWarehouseInput>>;
  updateMany?: InputMaybe<Array<ProductStockUpdateManyWithWhereWithoutWarehouseInput>>;
  upsert?: InputMaybe<Array<ProductStockUpsertWithWhereUniqueWithoutWarehouseInput>>;
};

export type ProductStockUpdateOneRequiredWithoutProductStockSnapshotsNestedInput = {
  connect?: InputMaybe<ProductStockWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductStockCreateOrConnectWithoutProductStockSnapshotsInput>;
  create?: InputMaybe<ProductStockCreateWithoutProductStockSnapshotsInput>;
  update?: InputMaybe<ProductStockUpdateToOneWithWhereWithoutProductStockSnapshotsInput>;
  upsert?: InputMaybe<ProductStockUpsertWithoutProductStockSnapshotsInput>;
};

export type ProductStockUpdateToOneWithWhereWithoutProductStockSnapshotsInput = {
  data: ProductStockUpdateWithoutProductStockSnapshotsInput;
  where?: InputMaybe<ProductStockWhereInput>;
};

export type ProductStockUpdateWithWhereUniqueWithoutProductSettingsInput = {
  data: ProductStockUpdateWithoutProductSettingsInput;
  where: ProductStockWhereUniqueInput;
};

export type ProductStockUpdateWithWhereUniqueWithoutWarehouseInput = {
  data: ProductStockUpdateWithoutWarehouseInput;
  where: ProductStockWhereUniqueInput;
};

export type ProductStockUpdateWithoutProductSettingsInput = {
  fulfillmentSku?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutProductStockNestedInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutProductStockNestedInput>;
};

export type ProductStockUpdateWithoutProductStockSnapshotsInput = {
  fulfillmentSku?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutStockLevelNestedInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutProductStockNestedInput>;
};

export type ProductStockUpdateWithoutWarehouseInput = {
  fulfillmentSku?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutStockLevelNestedInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotUpdateManyWithoutProductStockNestedInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProductStockUpsertWithWhereUniqueWithoutProductSettingsInput = {
  create: ProductStockCreateWithoutProductSettingsInput;
  update: ProductStockUpdateWithoutProductSettingsInput;
  where: ProductStockWhereUniqueInput;
};

export type ProductStockUpsertWithWhereUniqueWithoutWarehouseInput = {
  create: ProductStockCreateWithoutWarehouseInput;
  update: ProductStockUpdateWithoutWarehouseInput;
  where: ProductStockWhereUniqueInput;
};

export type ProductStockUpsertWithoutProductStockSnapshotsInput = {
  create: ProductStockCreateWithoutProductStockSnapshotsInput;
  update: ProductStockUpdateWithoutProductStockSnapshotsInput;
  where?: InputMaybe<ProductStockWhereInput>;
};

export type ProductStockWhereInput = {
  AND?: InputMaybe<Array<ProductStockWhereInput>>;
  NOT?: InputMaybe<Array<ProductStockWhereInput>>;
  OR?: InputMaybe<Array<ProductStockWhereInput>>;
  fulfillmentSku?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isAvailable?: InputMaybe<BoolFilter>;
  priority?: InputMaybe<IntFilter>;
  productSettings?: InputMaybe<ProductSettingsRelationFilter>;
  productSettingsId?: InputMaybe<StringFilter>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotListRelationFilter>;
  quantity?: InputMaybe<IntFilter>;
  warehouse?: InputMaybe<WarehouseRelationFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type ProductStockWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductStockWhereInput>>;
  NOT?: InputMaybe<Array<ProductStockWhereInput>>;
  OR?: InputMaybe<Array<ProductStockWhereInput>>;
  fulfillmentSku?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isAvailable?: InputMaybe<BoolFilter>;
  priority?: InputMaybe<IntFilter>;
  productSettings?: InputMaybe<ProductSettingsRelationFilter>;
  productSettingsId?: InputMaybe<StringFilter>;
  productSettingsId_warehouseId?: InputMaybe<ProductStockProductSettingsIdWarehouseIdCompoundUniqueInput>;
  productStockSnapshots?: InputMaybe<ProductStockSnapshotListRelationFilter>;
  quantity?: InputMaybe<IntFilter>;
  warehouse?: InputMaybe<WarehouseRelationFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type ProductToShip = {
  __typename?: 'ProductToShip';
  count: Scalars['Int']['output'];
  userProduct: UserProductToShip;
};

export enum ProductVariantKind {
  Flavour = 'FLAVOUR',
  Size = 'SIZE'
}

export type ProductVariantsCreateNestedOneWithoutProductsInput = {
  connect?: InputMaybe<ProductVariantsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductVariantsCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<ProductVariantsCreateWithoutProductsInput>;
};

export type ProductVariantsCreateOrConnectWithoutProductsInput = {
  create: ProductVariantsCreateWithoutProductsInput;
  where: ProductVariantsWhereUniqueInput;
};

export type ProductVariantsCreateWithoutProductsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  kind: ProductVariantKind;
  name: Scalars['String']['input'];
};

export type ProductVariantsNullableRelationFilter = {
  is?: InputMaybe<ProductVariantsWhereInput>;
  isNot?: InputMaybe<ProductVariantsWhereInput>;
};

export type ProductVariantsOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  kind?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  products?: InputMaybe<ProductSettingsOrderByRelationAggregateInput>;
};

export type ProductVariantsUpdateOneWithoutProductsNestedInput = {
  connect?: InputMaybe<ProductVariantsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductVariantsCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<ProductVariantsCreateWithoutProductsInput>;
  delete?: InputMaybe<ProductVariantsWhereInput>;
  disconnect?: InputMaybe<ProductVariantsWhereInput>;
  update?: InputMaybe<ProductVariantsUpdateToOneWithWhereWithoutProductsInput>;
  upsert?: InputMaybe<ProductVariantsUpsertWithoutProductsInput>;
};

export type ProductVariantsUpdateToOneWithWhereWithoutProductsInput = {
  data: ProductVariantsUpdateWithoutProductsInput;
  where?: InputMaybe<ProductVariantsWhereInput>;
};

export type ProductVariantsUpdateWithoutProductsInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumProductVariantKindFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductVariantsUpsertWithoutProductsInput = {
  create: ProductVariantsCreateWithoutProductsInput;
  update: ProductVariantsUpdateWithoutProductsInput;
  where?: InputMaybe<ProductVariantsWhereInput>;
};

export type ProductVariantsWhereInput = {
  AND?: InputMaybe<Array<ProductVariantsWhereInput>>;
  NOT?: InputMaybe<Array<ProductVariantsWhereInput>>;
  OR?: InputMaybe<Array<ProductVariantsWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  kind?: InputMaybe<EnumProductVariantKindFilter>;
  name?: InputMaybe<StringFilter>;
  products?: InputMaybe<ProductSettingsListRelationFilter>;
};

export type ProductVariantsWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductVariantsWhereInput>>;
  NOT?: InputMaybe<Array<ProductVariantsWhereInput>>;
  OR?: InputMaybe<Array<ProductVariantsWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<EnumProductVariantKindFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<ProductSettingsListRelationFilter>;
};

export type ProductsImportResponse = {
  __typename?: 'ProductsImportResponse';
  failedCount: Scalars['Float']['output'];
  importedCount: Scalars['Float']['output'];
};

export type ProductsSettingsImportInput = {
  importFile: Scalars['Upload']['input'];
};

export type Query = {
  __typename?: 'Query';
  adminDigitalServiceProductList: Array<AdminDigitalServiceProductListItem>;
  adminFindManyUserProductOrderLines?: Maybe<FindManyUserProductOrderLineResponse>;
  adminFindOneUserProductOrderLine?: Maybe<UserProductOrderLineModel>;
  adminOrder?: Maybe<UserProductOrderModel>;
  adminOrderInvoices: FindManyInvoiceModelResponse;
  adminOrders: UserProductOrderResponse;
  binsAssignedToOrder: BinsAssignedToOrderResponse;
  countShipmentsByCarrier: Array<CountShipmentsByCarrierResponse>;
  findManyCatalogBannerCollection: Array<CatalogBannerCollection>;
  findManyProductLabelSize: Array<ProductLabelSize>;
  findManyProductSettingsWithCount: FindManyProductSettingsResponse;
  findManyProductStock: Array<ProductStock>;
  findManyShipmentBatch: Array<ShipmentBatch>;
  findManyUserProductOrderLinesPublic?: Maybe<FindManyUserProductOrderLineResponse>;
  findManyWarehouseShelf: Array<WarehouseShelf>;
  findOneUserProductOrderLinePublic?: Maybe<UserProductOrderLineModel>;
  findUniqueProductLabelSize?: Maybe<ProductLabelSize>;
  findUniqueWarehouseShelf?: Maybe<WarehouseShelf>;
  getActivePublishers: Array<ProductPublisherModel>;
  getBulkShippingDetails: GetBulkShippingDetailsResponse;
  getBulkShippingSuggestions: Array<BulkShippingSuggestion>;
  getLatestBulkShipping: GetBulkShippingDetailsResponse;
  orderShipments: Array<Shipment>;
  printFileFilterOrderKindList: Array<Scalars['String']['output']>;
  printFileFilterUserBasicInfo: BasicUserModel;
  printFileFilterUserList: Array<BasicUserModel>;
  printFileQueue?: Maybe<Array<PrintFileQueueResponse>>;
  productSettings?: Maybe<ProductSettingsModel>;
  productsStock: FindManyProductStockResponse;
  returnedAdminOrders: UserProductOrderResponse;
  shipments: FindManyShipmentResponse;
  user: UserModel;
  userProductOrderRefundStatus: UserProductOrderRefundStatusResponse;
  userTransactions: Array<UserTransaction>;
};


export type QueryAdminDigitalServiceProductListArgs = {
  where?: InputMaybe<DigitalServiceProductWhereInput>;
};


export type QueryAdminFindManyUserProductOrderLinesArgs = {
  cursor?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type QueryAdminFindOneUserProductOrderLineArgs = {
  cursor?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type QueryAdminOrderArgs = {
  cursor?: InputMaybe<UserProductOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type QueryAdminOrderInvoicesArgs = {
  userProductOrderId: Scalars['String']['input'];
};


export type QueryAdminOrdersArgs = {
  cursor?: InputMaybe<UserProductOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type QueryBinsAssignedToOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryCountShipmentsByCarrierArgs = {
  status: ShipmentStatus;
};


export type QueryFindManyCatalogBannerCollectionArgs = {
  cursor?: InputMaybe<CatalogBannerCollectionWhereUniqueInput>;
  distinct?: InputMaybe<Array<CatalogBannerCollectionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CatalogBannerCollectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CatalogBannerCollectionWhereInput>;
};


export type QueryFindManyProductLabelSizeArgs = {
  cursor?: InputMaybe<ProductLabelSizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductLabelSizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductLabelSizeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLabelSizeWhereInput>;
};


export type QueryFindManyProductSettingsWithCountArgs = {
  cursor?: InputMaybe<ProductSettingsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductSettingsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductSettingsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductSettingsWhereInput>;
};


export type QueryFindManyProductStockArgs = {
  cursor?: InputMaybe<ProductStockWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductStockScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductStockOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductStockWhereInput>;
};


export type QueryFindManyShipmentBatchArgs = {
  cursor?: InputMaybe<ShipmentBatchWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShipmentBatchScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShipmentBatchOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ShipmentBatchWhereInput>;
};


export type QueryFindManyUserProductOrderLinesPublicArgs = {
  cursor?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type QueryFindManyWarehouseShelfArgs = {
  cursor?: InputMaybe<WarehouseShelfWhereUniqueInput>;
  distinct?: InputMaybe<Array<WarehouseShelfScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WarehouseShelfOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WarehouseShelfWhereInput>;
};


export type QueryFindOneUserProductOrderLinePublicArgs = {
  cursor?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type QueryFindUniqueProductLabelSizeArgs = {
  where: ProductLabelSizeWhereUniqueInput;
};


export type QueryFindUniqueWarehouseShelfArgs = {
  where: WarehouseShelfWhereUniqueInput;
};


export type QueryGetActivePublishersArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetBulkShippingDetailsArgs = {
  bulkShippingId: Scalars['Float']['input'];
};


export type QueryOrderShipmentsArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryPrintFileFilterOrderKindListArgs = {
  data: PrintFileFilterOrderKindsListInput;
};


export type QueryPrintFileFilterUserBasicInfoArgs = {
  id: Scalars['String']['input'];
};


export type QueryPrintFileFilterUserListArgs = {
  data: PrintFileFilterUserListInput;
};


export type QueryPrintFileQueueArgs = {
  data: PrintFileQueueInput;
};


export type QueryProductSettingsArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductsStockArgs = {
  cursor?: InputMaybe<ProductStockWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductStockScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductStockOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductStockWhereInput>;
};


export type QueryReturnedAdminOrdersArgs = {
  cursor?: InputMaybe<UserProductOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type QueryShipmentsArgs = {
  cursor?: InputMaybe<ShipmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShipmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShipmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ShipmentWhereInput>;
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserProductOrderRefundStatusArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserTransactionsArgs = {
  adminId?: InputMaybe<Scalars['ID']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  type?: InputMaybe<TransactionType>;
  userId: Scalars['ID']['input'];
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RefundOrderInput = {
  refundNote: Scalars['String']['input'];
  refundWithUserCredits: Scalars['Boolean']['input'];
};

export type ReportLabelIssueInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  issue: Scalars['String']['input'];
  userProductOrderLineId: Scalars['ID']['input'];
};

export type ReshipInput = {
  selectedCarrierExternalId: Scalars['String']['input'];
  shipmentId: Scalars['String']['input'];
  shippingPackageId: Scalars['String']['input'];
};

export type RoastifyOrder = {
  __typename?: 'RoastifyOrder';
  _count?: Maybe<RoastifyOrderCount>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userProductOrderId: Scalars['String']['output'];
};

export type RoastifyOrderCount = {
  __typename?: 'RoastifyOrderCount';
  orderLines: Scalars['Int']['output'];
};


export type RoastifyOrderCountOrderLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type RoastifyOrderCreateManyUserProductOrderInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RoastifyOrderCreateManyUserProductOrderInputEnvelope = {
  data: Array<RoastifyOrderCreateManyUserProductOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoastifyOrderCreateNestedManyWithoutUserProductOrderInput = {
  connect?: InputMaybe<Array<RoastifyOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RoastifyOrderCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<RoastifyOrderCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<RoastifyOrderCreateManyUserProductOrderInputEnvelope>;
};

export type RoastifyOrderCreateNestedOneWithoutOrderLinesInput = {
  connect?: InputMaybe<RoastifyOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoastifyOrderCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<RoastifyOrderCreateWithoutOrderLinesInput>;
};

export type RoastifyOrderCreateNestedOneWithoutShipmentInput = {
  connect?: InputMaybe<RoastifyOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoastifyOrderCreateOrConnectWithoutShipmentInput>;
  create?: InputMaybe<RoastifyOrderCreateWithoutShipmentInput>;
};

export type RoastifyOrderCreateOrConnectWithoutOrderLinesInput = {
  create: RoastifyOrderCreateWithoutOrderLinesInput;
  where: RoastifyOrderWhereUniqueInput;
};

export type RoastifyOrderCreateOrConnectWithoutShipmentInput = {
  create: RoastifyOrderCreateWithoutShipmentInput;
  where: RoastifyOrderWhereUniqueInput;
};

export type RoastifyOrderCreateOrConnectWithoutUserProductOrderInput = {
  create: RoastifyOrderCreateWithoutUserProductOrderInput;
  where: RoastifyOrderWhereUniqueInput;
};

export type RoastifyOrderCreateWithoutOrderLinesInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutRoastifyOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutRoastifyOrdersInput;
};

export type RoastifyOrderCreateWithoutShipmentInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRoastifyOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutRoastifyOrdersInput;
};

export type RoastifyOrderCreateWithoutUserProductOrderInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutRoastifyOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutRoastifyOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RoastifyOrderListRelationFilter = {
  every?: InputMaybe<RoastifyOrderWhereInput>;
  none?: InputMaybe<RoastifyOrderWhereInput>;
  some?: InputMaybe<RoastifyOrderWhereInput>;
};

export type RoastifyOrderNullableRelationFilter = {
  is?: InputMaybe<RoastifyOrderWhereInput>;
  isNot?: InputMaybe<RoastifyOrderWhereInput>;
};

export type RoastifyOrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RoastifyOrderOrderByWithRelationInput = {
  externalId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  orderLines?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  shipment?: InputMaybe<ShipmentOrderByWithRelationInput>;
  shipmentId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  userProductOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  userProductOrderId?: InputMaybe<SortOrder>;
};

export enum RoastifyOrderScalarFieldEnum {
  ExternalId = 'externalId',
  Id = 'id',
  ShipmentId = 'shipmentId',
  Status = 'status',
  UserProductOrderId = 'userProductOrderId'
}

export type RoastifyOrderScalarWhereInput = {
  AND?: InputMaybe<Array<RoastifyOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<RoastifyOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<RoastifyOrderScalarWhereInput>>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type RoastifyOrderUpdateManyMutationInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type RoastifyOrderUpdateManyWithWhereWithoutUserProductOrderInput = {
  data: RoastifyOrderUpdateManyMutationInput;
  where: RoastifyOrderScalarWhereInput;
};

export type RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput = {
  connect?: InputMaybe<Array<RoastifyOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RoastifyOrderCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<RoastifyOrderCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<RoastifyOrderCreateManyUserProductOrderInputEnvelope>;
  delete?: InputMaybe<Array<RoastifyOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RoastifyOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RoastifyOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<RoastifyOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<RoastifyOrderUpdateWithWhereUniqueWithoutUserProductOrderInput>>;
  updateMany?: InputMaybe<Array<RoastifyOrderUpdateManyWithWhereWithoutUserProductOrderInput>>;
  upsert?: InputMaybe<Array<RoastifyOrderUpsertWithWhereUniqueWithoutUserProductOrderInput>>;
};

export type RoastifyOrderUpdateOneWithoutOrderLinesNestedInput = {
  connect?: InputMaybe<RoastifyOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoastifyOrderCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<RoastifyOrderCreateWithoutOrderLinesInput>;
  delete?: InputMaybe<RoastifyOrderWhereInput>;
  disconnect?: InputMaybe<RoastifyOrderWhereInput>;
  update?: InputMaybe<RoastifyOrderUpdateToOneWithWhereWithoutOrderLinesInput>;
  upsert?: InputMaybe<RoastifyOrderUpsertWithoutOrderLinesInput>;
};

export type RoastifyOrderUpdateOneWithoutShipmentNestedInput = {
  connect?: InputMaybe<RoastifyOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoastifyOrderCreateOrConnectWithoutShipmentInput>;
  create?: InputMaybe<RoastifyOrderCreateWithoutShipmentInput>;
  delete?: InputMaybe<RoastifyOrderWhereInput>;
  disconnect?: InputMaybe<RoastifyOrderWhereInput>;
  update?: InputMaybe<RoastifyOrderUpdateToOneWithWhereWithoutShipmentInput>;
  upsert?: InputMaybe<RoastifyOrderUpsertWithoutShipmentInput>;
};

export type RoastifyOrderUpdateToOneWithWhereWithoutOrderLinesInput = {
  data: RoastifyOrderUpdateWithoutOrderLinesInput;
  where?: InputMaybe<RoastifyOrderWhereInput>;
};

export type RoastifyOrderUpdateToOneWithWhereWithoutShipmentInput = {
  data: RoastifyOrderUpdateWithoutShipmentInput;
  where?: InputMaybe<RoastifyOrderWhereInput>;
};

export type RoastifyOrderUpdateWithWhereUniqueWithoutUserProductOrderInput = {
  data: RoastifyOrderUpdateWithoutUserProductOrderInput;
  where: RoastifyOrderWhereUniqueInput;
};

export type RoastifyOrderUpdateWithoutOrderLinesInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutRoastifyOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutRoastifyOrdersNestedInput>;
};

export type RoastifyOrderUpdateWithoutShipmentInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutRoastifyOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutRoastifyOrdersNestedInput>;
};

export type RoastifyOrderUpdateWithoutUserProductOrderInput = {
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutRoastifyOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutRoastifyOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type RoastifyOrderUpsertWithWhereUniqueWithoutUserProductOrderInput = {
  create: RoastifyOrderCreateWithoutUserProductOrderInput;
  update: RoastifyOrderUpdateWithoutUserProductOrderInput;
  where: RoastifyOrderWhereUniqueInput;
};

export type RoastifyOrderUpsertWithoutOrderLinesInput = {
  create: RoastifyOrderCreateWithoutOrderLinesInput;
  update: RoastifyOrderUpdateWithoutOrderLinesInput;
  where?: InputMaybe<RoastifyOrderWhereInput>;
};

export type RoastifyOrderUpsertWithoutShipmentInput = {
  create: RoastifyOrderCreateWithoutShipmentInput;
  update: RoastifyOrderUpdateWithoutShipmentInput;
  where?: InputMaybe<RoastifyOrderWhereInput>;
};

export type RoastifyOrderWhereInput = {
  AND?: InputMaybe<Array<RoastifyOrderWhereInput>>;
  NOT?: InputMaybe<Array<RoastifyOrderWhereInput>>;
  OR?: InputMaybe<Array<RoastifyOrderWhereInput>>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  orderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  shipment?: InputMaybe<ShipmentNullableRelationFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrder?: InputMaybe<UserProductOrderRelationFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type RoastifyOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<RoastifyOrderWhereInput>>;
  NOT?: InputMaybe<Array<RoastifyOrderWhereInput>>;
  OR?: InputMaybe<Array<RoastifyOrderWhereInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  shipment?: InputMaybe<ShipmentNullableRelationFilter>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrder?: InputMaybe<UserProductOrderRelationFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type SanityProductForm = {
  __typename?: 'SanityProductForm';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export type ServicePurchaseCreateManyUserInput = {
  amountSubtotal?: InputMaybe<Scalars['Float']['input']>;
  amountTotal?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentProcessor: UserPaymentProcessor;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ServicePurchaseStatus>;
  tracked?: InputMaybe<Scalars['Boolean']['input']>;
  userSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  webhookEventId?: InputMaybe<Scalars['String']['input']>;
};

export type ServicePurchaseCreateManyUserInputEnvelope = {
  data: Array<ServicePurchaseCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServicePurchaseCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ServicePurchaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServicePurchaseCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ServicePurchaseCreateWithoutUserInput>>;
  createMany?: InputMaybe<ServicePurchaseCreateManyUserInputEnvelope>;
};

export type ServicePurchaseCreateNestedOneWithoutInvoicesInput = {
  connect?: InputMaybe<ServicePurchaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServicePurchaseCreateOrConnectWithoutInvoicesInput>;
  create?: InputMaybe<ServicePurchaseCreateWithoutInvoicesInput>;
};

export type ServicePurchaseCreateNestedOneWithoutStripeInvoicesInput = {
  connect?: InputMaybe<ServicePurchaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServicePurchaseCreateOrConnectWithoutStripeInvoicesInput>;
  create?: InputMaybe<ServicePurchaseCreateWithoutStripeInvoicesInput>;
};

export type ServicePurchaseCreateOrConnectWithoutInvoicesInput = {
  create: ServicePurchaseCreateWithoutInvoicesInput;
  where: ServicePurchaseWhereUniqueInput;
};

export type ServicePurchaseCreateOrConnectWithoutStripeInvoicesInput = {
  create: ServicePurchaseCreateWithoutStripeInvoicesInput;
  where: ServicePurchaseWhereUniqueInput;
};

export type ServicePurchaseCreateOrConnectWithoutUserInput = {
  create: ServicePurchaseCreateWithoutUserInput;
  where: ServicePurchaseWhereUniqueInput;
};

export type ServicePurchaseCreateWithoutInvoicesInput = {
  amountSubtotal?: InputMaybe<Scalars['Float']['input']>;
  amountTotal?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  lineItems?: InputMaybe<ServicePurchaseLineItemCreateNestedManyWithoutServicePurchaseInput>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentProcessor: UserPaymentProcessor;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ServicePurchaseStatus>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutServicePurchaseInput>;
  tracked?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutServicePurchasesInput>;
  userSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  webhookEventId?: InputMaybe<Scalars['String']['input']>;
};

export type ServicePurchaseCreateWithoutStripeInvoicesInput = {
  amountSubtotal?: InputMaybe<Scalars['Float']['input']>;
  amountTotal?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutServicePurchaseInput>;
  lineItems?: InputMaybe<ServicePurchaseLineItemCreateNestedManyWithoutServicePurchaseInput>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentProcessor: UserPaymentProcessor;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ServicePurchaseStatus>;
  tracked?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutServicePurchasesInput>;
  userSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  webhookEventId?: InputMaybe<Scalars['String']['input']>;
};

export type ServicePurchaseCreateWithoutUserInput = {
  amountSubtotal?: InputMaybe<Scalars['Float']['input']>;
  amountTotal?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutServicePurchaseInput>;
  lineItems?: InputMaybe<ServicePurchaseLineItemCreateNestedManyWithoutServicePurchaseInput>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentProcessor: UserPaymentProcessor;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ServicePurchaseStatus>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutServicePurchaseInput>;
  tracked?: InputMaybe<Scalars['Boolean']['input']>;
  userSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  webhookEventId?: InputMaybe<Scalars['String']['input']>;
};

export type ServicePurchaseLineItemCreateManyServicePurchaseInput = {
  amountSubtotal: Scalars['Float']['input'];
  amountTotal: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  stripePriceId: Scalars['String']['input'];
  stripeProductId: Scalars['String']['input'];
};

export type ServicePurchaseLineItemCreateManyServicePurchaseInputEnvelope = {
  data: Array<ServicePurchaseLineItemCreateManyServicePurchaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServicePurchaseLineItemCreateNestedManyWithoutServicePurchaseInput = {
  connect?: InputMaybe<Array<ServicePurchaseLineItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServicePurchaseLineItemCreateOrConnectWithoutServicePurchaseInput>>;
  create?: InputMaybe<Array<ServicePurchaseLineItemCreateWithoutServicePurchaseInput>>;
  createMany?: InputMaybe<ServicePurchaseLineItemCreateManyServicePurchaseInputEnvelope>;
};

export type ServicePurchaseLineItemCreateOrConnectWithoutServicePurchaseInput = {
  create: ServicePurchaseLineItemCreateWithoutServicePurchaseInput;
  where: ServicePurchaseLineItemWhereUniqueInput;
};

export type ServicePurchaseLineItemCreateWithoutServicePurchaseInput = {
  amountSubtotal: Scalars['Float']['input'];
  amountTotal: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  stripePriceId: Scalars['String']['input'];
  stripeProductId: Scalars['String']['input'];
};

export type ServicePurchaseLineItemListRelationFilter = {
  every?: InputMaybe<ServicePurchaseLineItemWhereInput>;
  none?: InputMaybe<ServicePurchaseLineItemWhereInput>;
  some?: InputMaybe<ServicePurchaseLineItemWhereInput>;
};

export type ServicePurchaseLineItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ServicePurchaseLineItemScalarWhereInput = {
  AND?: InputMaybe<Array<ServicePurchaseLineItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<ServicePurchaseLineItemScalarWhereInput>>;
  OR?: InputMaybe<Array<ServicePurchaseLineItemScalarWhereInput>>;
  amountSubtotal?: InputMaybe<FloatFilter>;
  amountTotal?: InputMaybe<FloatFilter>;
  description?: InputMaybe<StringFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  quantity?: InputMaybe<FloatFilter>;
  servicePurchaseId?: InputMaybe<UuidFilter>;
  stripePriceId?: InputMaybe<StringFilter>;
  stripeProductId?: InputMaybe<StringFilter>;
};

export type ServicePurchaseLineItemUpdateManyMutationInput = {
  amountSubtotal?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountTotal?: InputMaybe<FloatFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<FloatFieldUpdateOperationsInput>;
  stripePriceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  stripeProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ServicePurchaseLineItemUpdateManyWithWhereWithoutServicePurchaseInput = {
  data: ServicePurchaseLineItemUpdateManyMutationInput;
  where: ServicePurchaseLineItemScalarWhereInput;
};

export type ServicePurchaseLineItemUpdateManyWithoutServicePurchaseNestedInput = {
  connect?: InputMaybe<Array<ServicePurchaseLineItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServicePurchaseLineItemCreateOrConnectWithoutServicePurchaseInput>>;
  create?: InputMaybe<Array<ServicePurchaseLineItemCreateWithoutServicePurchaseInput>>;
  createMany?: InputMaybe<ServicePurchaseLineItemCreateManyServicePurchaseInputEnvelope>;
  delete?: InputMaybe<Array<ServicePurchaseLineItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServicePurchaseLineItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServicePurchaseLineItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ServicePurchaseLineItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ServicePurchaseLineItemUpdateWithWhereUniqueWithoutServicePurchaseInput>>;
  updateMany?: InputMaybe<Array<ServicePurchaseLineItemUpdateManyWithWhereWithoutServicePurchaseInput>>;
  upsert?: InputMaybe<Array<ServicePurchaseLineItemUpsertWithWhereUniqueWithoutServicePurchaseInput>>;
};

export type ServicePurchaseLineItemUpdateWithWhereUniqueWithoutServicePurchaseInput = {
  data: ServicePurchaseLineItemUpdateWithoutServicePurchaseInput;
  where: ServicePurchaseLineItemWhereUniqueInput;
};

export type ServicePurchaseLineItemUpdateWithoutServicePurchaseInput = {
  amountSubtotal?: InputMaybe<FloatFieldUpdateOperationsInput>;
  amountTotal?: InputMaybe<FloatFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<FloatFieldUpdateOperationsInput>;
  stripePriceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  stripeProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ServicePurchaseLineItemUpsertWithWhereUniqueWithoutServicePurchaseInput = {
  create: ServicePurchaseLineItemCreateWithoutServicePurchaseInput;
  update: ServicePurchaseLineItemUpdateWithoutServicePurchaseInput;
  where: ServicePurchaseLineItemWhereUniqueInput;
};

export type ServicePurchaseLineItemWhereInput = {
  AND?: InputMaybe<Array<ServicePurchaseLineItemWhereInput>>;
  NOT?: InputMaybe<Array<ServicePurchaseLineItemWhereInput>>;
  OR?: InputMaybe<Array<ServicePurchaseLineItemWhereInput>>;
  amountSubtotal?: InputMaybe<FloatFilter>;
  amountTotal?: InputMaybe<FloatFilter>;
  description?: InputMaybe<StringFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  quantity?: InputMaybe<FloatFilter>;
  servicePurchase?: InputMaybe<ServicePurchaseNullableRelationFilter>;
  servicePurchaseId?: InputMaybe<UuidFilter>;
  stripePriceId?: InputMaybe<StringFilter>;
  stripeProductId?: InputMaybe<StringFilter>;
};

export type ServicePurchaseLineItemWhereUniqueInput = {
  AND?: InputMaybe<Array<ServicePurchaseLineItemWhereInput>>;
  NOT?: InputMaybe<Array<ServicePurchaseLineItemWhereInput>>;
  OR?: InputMaybe<Array<ServicePurchaseLineItemWhereInput>>;
  amountSubtotal?: InputMaybe<FloatFilter>;
  amountTotal?: InputMaybe<FloatFilter>;
  description?: InputMaybe<StringFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<FloatFilter>;
  servicePurchase?: InputMaybe<ServicePurchaseNullableRelationFilter>;
  servicePurchaseId?: InputMaybe<UuidFilter>;
  stripePriceId?: InputMaybe<StringFilter>;
  stripeProductId?: InputMaybe<StringFilter>;
};

export type ServicePurchaseListRelationFilter = {
  every?: InputMaybe<ServicePurchaseWhereInput>;
  none?: InputMaybe<ServicePurchaseWhereInput>;
  some?: InputMaybe<ServicePurchaseWhereInput>;
};

export type ServicePurchaseNullableRelationFilter = {
  is?: InputMaybe<ServicePurchaseWhereInput>;
  isNot?: InputMaybe<ServicePurchaseWhereInput>;
};

export type ServicePurchaseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ServicePurchaseOrderByWithRelationInput = {
  amountSubtotal?: InputMaybe<SortOrderInput>;
  amountTotal?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  invoiceId?: InputMaybe<SortOrderInput>;
  invoiceNumber?: InputMaybe<SortOrder>;
  invoices?: InputMaybe<UserInvoiceOrderByRelationAggregateInput>;
  lineItems?: InputMaybe<ServicePurchaseLineItemOrderByRelationAggregateInput>;
  paymentIntentId?: InputMaybe<SortOrderInput>;
  paymentProcessor?: InputMaybe<SortOrder>;
  sessionId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  stripeInvoices?: InputMaybe<StripeInvoiceOrderByRelationAggregateInput>;
  tracked?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
  userSubscriptionId?: InputMaybe<SortOrderInput>;
  webhookEventId?: InputMaybe<SortOrderInput>;
};

export type ServicePurchaseScalarWhereInput = {
  AND?: InputMaybe<Array<ServicePurchaseScalarWhereInput>>;
  NOT?: InputMaybe<Array<ServicePurchaseScalarWhereInput>>;
  OR?: InputMaybe<Array<ServicePurchaseScalarWhereInput>>;
  amountSubtotal?: InputMaybe<FloatNullableFilter>;
  amountTotal?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  invoiceId?: InputMaybe<StringNullableFilter>;
  invoiceNumber?: InputMaybe<IntFilter>;
  paymentIntentId?: InputMaybe<StringNullableFilter>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFilter>;
  sessionId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumServicePurchaseStatusFilter>;
  tracked?: InputMaybe<BoolFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
  userSubscriptionId?: InputMaybe<StringNullableFilter>;
  webhookEventId?: InputMaybe<StringNullableFilter>;
};

export enum ServicePurchaseStatus {
  Expired = 'EXPIRED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type ServicePurchaseUpdateManyMutationInput = {
  amountSubtotal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  amountTotal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumServicePurchaseStatusFieldUpdateOperationsInput>;
  tracked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userSubscriptionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  webhookEventId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServicePurchaseUpdateManyWithWhereWithoutUserInput = {
  data: ServicePurchaseUpdateManyMutationInput;
  where: ServicePurchaseScalarWhereInput;
};

export type ServicePurchaseUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ServicePurchaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServicePurchaseCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ServicePurchaseCreateWithoutUserInput>>;
  createMany?: InputMaybe<ServicePurchaseCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ServicePurchaseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServicePurchaseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServicePurchaseWhereUniqueInput>>;
  set?: InputMaybe<Array<ServicePurchaseWhereUniqueInput>>;
  update?: InputMaybe<Array<ServicePurchaseUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ServicePurchaseUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ServicePurchaseUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ServicePurchaseUpdateOneWithoutInvoicesNestedInput = {
  connect?: InputMaybe<ServicePurchaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServicePurchaseCreateOrConnectWithoutInvoicesInput>;
  create?: InputMaybe<ServicePurchaseCreateWithoutInvoicesInput>;
  delete?: InputMaybe<ServicePurchaseWhereInput>;
  disconnect?: InputMaybe<ServicePurchaseWhereInput>;
  update?: InputMaybe<ServicePurchaseUpdateToOneWithWhereWithoutInvoicesInput>;
  upsert?: InputMaybe<ServicePurchaseUpsertWithoutInvoicesInput>;
};

export type ServicePurchaseUpdateOneWithoutStripeInvoicesNestedInput = {
  connect?: InputMaybe<ServicePurchaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServicePurchaseCreateOrConnectWithoutStripeInvoicesInput>;
  create?: InputMaybe<ServicePurchaseCreateWithoutStripeInvoicesInput>;
  delete?: InputMaybe<ServicePurchaseWhereInput>;
  disconnect?: InputMaybe<ServicePurchaseWhereInput>;
  update?: InputMaybe<ServicePurchaseUpdateToOneWithWhereWithoutStripeInvoicesInput>;
  upsert?: InputMaybe<ServicePurchaseUpsertWithoutStripeInvoicesInput>;
};

export type ServicePurchaseUpdateToOneWithWhereWithoutInvoicesInput = {
  data: ServicePurchaseUpdateWithoutInvoicesInput;
  where?: InputMaybe<ServicePurchaseWhereInput>;
};

export type ServicePurchaseUpdateToOneWithWhereWithoutStripeInvoicesInput = {
  data: ServicePurchaseUpdateWithoutStripeInvoicesInput;
  where?: InputMaybe<ServicePurchaseWhereInput>;
};

export type ServicePurchaseUpdateWithWhereUniqueWithoutUserInput = {
  data: ServicePurchaseUpdateWithoutUserInput;
  where: ServicePurchaseWhereUniqueInput;
};

export type ServicePurchaseUpdateWithoutInvoicesInput = {
  amountSubtotal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  amountTotal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  lineItems?: InputMaybe<ServicePurchaseLineItemUpdateManyWithoutServicePurchaseNestedInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumServicePurchaseStatusFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutServicePurchaseNestedInput>;
  tracked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutServicePurchasesNestedInput>;
  userSubscriptionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  webhookEventId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServicePurchaseUpdateWithoutStripeInvoicesInput = {
  amountSubtotal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  amountTotal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutServicePurchaseNestedInput>;
  lineItems?: InputMaybe<ServicePurchaseLineItemUpdateManyWithoutServicePurchaseNestedInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumServicePurchaseStatusFieldUpdateOperationsInput>;
  tracked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutServicePurchasesNestedInput>;
  userSubscriptionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  webhookEventId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServicePurchaseUpdateWithoutUserInput = {
  amountSubtotal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  amountTotal?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<IntFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutServicePurchaseNestedInput>;
  lineItems?: InputMaybe<ServicePurchaseLineItemUpdateManyWithoutServicePurchaseNestedInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumServicePurchaseStatusFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutServicePurchaseNestedInput>;
  tracked?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userSubscriptionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  webhookEventId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServicePurchaseUpsertWithWhereUniqueWithoutUserInput = {
  create: ServicePurchaseCreateWithoutUserInput;
  update: ServicePurchaseUpdateWithoutUserInput;
  where: ServicePurchaseWhereUniqueInput;
};

export type ServicePurchaseUpsertWithoutInvoicesInput = {
  create: ServicePurchaseCreateWithoutInvoicesInput;
  update: ServicePurchaseUpdateWithoutInvoicesInput;
  where?: InputMaybe<ServicePurchaseWhereInput>;
};

export type ServicePurchaseUpsertWithoutStripeInvoicesInput = {
  create: ServicePurchaseCreateWithoutStripeInvoicesInput;
  update: ServicePurchaseUpdateWithoutStripeInvoicesInput;
  where?: InputMaybe<ServicePurchaseWhereInput>;
};

export type ServicePurchaseWhereInput = {
  AND?: InputMaybe<Array<ServicePurchaseWhereInput>>;
  NOT?: InputMaybe<Array<ServicePurchaseWhereInput>>;
  OR?: InputMaybe<Array<ServicePurchaseWhereInput>>;
  amountSubtotal?: InputMaybe<FloatNullableFilter>;
  amountTotal?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  invoiceId?: InputMaybe<StringNullableFilter>;
  invoiceNumber?: InputMaybe<IntFilter>;
  invoices?: InputMaybe<UserInvoiceListRelationFilter>;
  lineItems?: InputMaybe<ServicePurchaseLineItemListRelationFilter>;
  paymentIntentId?: InputMaybe<StringNullableFilter>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFilter>;
  sessionId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumServicePurchaseStatusFilter>;
  stripeInvoices?: InputMaybe<StripeInvoiceListRelationFilter>;
  tracked?: InputMaybe<BoolFilter>;
  user?: InputMaybe<UserNullableRelationFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
  userSubscriptionId?: InputMaybe<StringNullableFilter>;
  webhookEventId?: InputMaybe<StringNullableFilter>;
};

export type ServicePurchaseWhereUniqueInput = {
  AND?: InputMaybe<Array<ServicePurchaseWhereInput>>;
  NOT?: InputMaybe<Array<ServicePurchaseWhereInput>>;
  OR?: InputMaybe<Array<ServicePurchaseWhereInput>>;
  amountSubtotal?: InputMaybe<FloatNullableFilter>;
  amountTotal?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<StringNullableFilter>;
  invoiceNumber?: InputMaybe<IntFilter>;
  invoices?: InputMaybe<UserInvoiceListRelationFilter>;
  lineItems?: InputMaybe<ServicePurchaseLineItemListRelationFilter>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFilter>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumServicePurchaseStatusFilter>;
  stripeInvoices?: InputMaybe<StripeInvoiceListRelationFilter>;
  tracked?: InputMaybe<BoolFilter>;
  user?: InputMaybe<UserNullableRelationFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
  userSubscriptionId?: InputMaybe<StringNullableFilter>;
  webhookEventId?: InputMaybe<Scalars['String']['input']>;
};

export type SessionCreateManyUserInput = {
  createdAt: Scalars['DateTime']['input'];
  expiresAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  impersonatedByAdminId?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type SessionCreateManyUserInputEnvelope = {
  data: Array<SessionCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SessionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SessionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SessionCreateWithoutUserInput>>;
  createMany?: InputMaybe<SessionCreateManyUserInputEnvelope>;
};

export type SessionCreateOrConnectWithoutUserInput = {
  create: SessionCreateWithoutUserInput;
  where: SessionWhereUniqueInput;
};

export type SessionCreateWithoutUserInput = {
  createdAt: Scalars['DateTime']['input'];
  expiresAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  impersonatedByAdminId?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type SessionListRelationFilter = {
  every?: InputMaybe<SessionWhereInput>;
  none?: InputMaybe<SessionWhereInput>;
  some?: InputMaybe<SessionWhereInput>;
};

export type SessionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SessionScalarWhereInput = {
  AND?: InputMaybe<Array<SessionScalarWhereInput>>;
  NOT?: InputMaybe<Array<SessionScalarWhereInput>>;
  OR?: InputMaybe<Array<SessionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  impersonatedByAdminId?: InputMaybe<StringNullableFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userAgent?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type SessionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  impersonatedByAdminId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SessionUpdateManyWithWhereWithoutUserInput = {
  data: SessionUpdateManyMutationInput;
  where: SessionScalarWhereInput;
};

export type SessionUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SessionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SessionCreateWithoutUserInput>>;
  createMany?: InputMaybe<SessionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<SessionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SessionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  set?: InputMaybe<Array<SessionWhereUniqueInput>>;
  update?: InputMaybe<Array<SessionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<SessionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<SessionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SessionUpdateWithWhereUniqueWithoutUserInput = {
  data: SessionUpdateWithoutUserInput;
  where: SessionWhereUniqueInput;
};

export type SessionUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  impersonatedByAdminId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type SessionUpsertWithWhereUniqueWithoutUserInput = {
  create: SessionCreateWithoutUserInput;
  update: SessionUpdateWithoutUserInput;
  where: SessionWhereUniqueInput;
};

export type SessionWhereInput = {
  AND?: InputMaybe<Array<SessionWhereInput>>;
  NOT?: InputMaybe<Array<SessionWhereInput>>;
  OR?: InputMaybe<Array<SessionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  impersonatedByAdminId?: InputMaybe<StringNullableFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userAgent?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type SessionWhereUniqueInput = {
  AND?: InputMaybe<Array<SessionWhereInput>>;
  NOT?: InputMaybe<Array<SessionWhereInput>>;
  OR?: InputMaybe<Array<SessionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  impersonatedByAdminId?: InputMaybe<StringNullableFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userAgent?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type SetLineItemCountPreparedInBulkInput = {
  bulkItems: Array<SetLineItemCountPreparedInput>;
};

export type SetLineItemCountPreparedInBulkResponse = {
  __typename?: 'SetLineItemCountPreparedInBulkResponse';
  results: Array<LineItemResult>;
};

export type SetLineItemCountPreparedInput = {
  countPrepared: Scalars['Int']['input'];
  lineId: Scalars['String']['input'];
  printBatchId: Scalars['Int']['input'];
};

export type SetOrderLockInput = {
  id: Scalars['String']['input'];
  isLocked: Scalars['Boolean']['input'];
};

export type SetPriorityLaneFulfillmentInput = {
  isPriorityLaneFulfillment: Scalars['Boolean']['input'];
  updateExistingOrders: Scalars['Boolean']['input'];
};

export type ShipbobOrder = {
  __typename?: 'ShipbobOrder';
  _count?: Maybe<ShipbobOrderCount>;
  externalId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userProductOrderId: Scalars['String']['output'];
};

export type ShipbobOrderCount = {
  __typename?: 'ShipbobOrderCount';
  orderLines: Scalars['Int']['output'];
};


export type ShipbobOrderCountOrderLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type ShipbobOrderCreateManyUserProductOrderInput = {
  externalId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ShipbobOrderCreateManyUserProductOrderInputEnvelope = {
  data: Array<ShipbobOrderCreateManyUserProductOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipbobOrderCreateNestedManyWithoutUserProductOrderInput = {
  connect?: InputMaybe<Array<ShipbobOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipbobOrderCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<ShipbobOrderCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<ShipbobOrderCreateManyUserProductOrderInputEnvelope>;
};

export type ShipbobOrderCreateNestedOneWithoutOrderLinesInput = {
  connect?: InputMaybe<ShipbobOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipbobOrderCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<ShipbobOrderCreateWithoutOrderLinesInput>;
};

export type ShipbobOrderCreateNestedOneWithoutShipmentInput = {
  connect?: InputMaybe<ShipbobOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipbobOrderCreateOrConnectWithoutShipmentInput>;
  create?: InputMaybe<ShipbobOrderCreateWithoutShipmentInput>;
};

export type ShipbobOrderCreateOrConnectWithoutOrderLinesInput = {
  create: ShipbobOrderCreateWithoutOrderLinesInput;
  where: ShipbobOrderWhereUniqueInput;
};

export type ShipbobOrderCreateOrConnectWithoutShipmentInput = {
  create: ShipbobOrderCreateWithoutShipmentInput;
  where: ShipbobOrderWhereUniqueInput;
};

export type ShipbobOrderCreateOrConnectWithoutUserProductOrderInput = {
  create: ShipbobOrderCreateWithoutUserProductOrderInput;
  where: ShipbobOrderWhereUniqueInput;
};

export type ShipbobOrderCreateWithoutOrderLinesInput = {
  externalId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutShipbobOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipbobOrdersInput;
};

export type ShipbobOrderCreateWithoutShipmentInput = {
  externalId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipbobOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipbobOrdersInput;
};

export type ShipbobOrderCreateWithoutUserProductOrderInput = {
  externalId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipbobOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutShipbobOrderInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ShipbobOrderListRelationFilter = {
  every?: InputMaybe<ShipbobOrderWhereInput>;
  none?: InputMaybe<ShipbobOrderWhereInput>;
  some?: InputMaybe<ShipbobOrderWhereInput>;
};

export type ShipbobOrderNullableRelationFilter = {
  is?: InputMaybe<ShipbobOrderWhereInput>;
  isNot?: InputMaybe<ShipbobOrderWhereInput>;
};

export type ShipbobOrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShipbobOrderOrderByWithRelationInput = {
  externalId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  orderLines?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  shipment?: InputMaybe<ShipmentOrderByWithRelationInput>;
  shipmentId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  userProductOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  userProductOrderId?: InputMaybe<SortOrder>;
};

export enum ShipbobOrderScalarFieldEnum {
  ExternalId = 'externalId',
  Id = 'id',
  ShipmentId = 'shipmentId',
  Status = 'status',
  UserProductOrderId = 'userProductOrderId'
}

export type ShipbobOrderScalarWhereInput = {
  AND?: InputMaybe<Array<ShipbobOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShipbobOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<ShipbobOrderScalarWhereInput>>;
  externalId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type ShipbobOrderUpdateManyMutationInput = {
  externalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ShipbobOrderUpdateManyWithWhereWithoutUserProductOrderInput = {
  data: ShipbobOrderUpdateManyMutationInput;
  where: ShipbobOrderScalarWhereInput;
};

export type ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput = {
  connect?: InputMaybe<Array<ShipbobOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipbobOrderCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<ShipbobOrderCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<ShipbobOrderCreateManyUserProductOrderInputEnvelope>;
  delete?: InputMaybe<Array<ShipbobOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShipbobOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShipbobOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<ShipbobOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<ShipbobOrderUpdateWithWhereUniqueWithoutUserProductOrderInput>>;
  updateMany?: InputMaybe<Array<ShipbobOrderUpdateManyWithWhereWithoutUserProductOrderInput>>;
  upsert?: InputMaybe<Array<ShipbobOrderUpsertWithWhereUniqueWithoutUserProductOrderInput>>;
};

export type ShipbobOrderUpdateOneWithoutOrderLinesNestedInput = {
  connect?: InputMaybe<ShipbobOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipbobOrderCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<ShipbobOrderCreateWithoutOrderLinesInput>;
  delete?: InputMaybe<ShipbobOrderWhereInput>;
  disconnect?: InputMaybe<ShipbobOrderWhereInput>;
  update?: InputMaybe<ShipbobOrderUpdateToOneWithWhereWithoutOrderLinesInput>;
  upsert?: InputMaybe<ShipbobOrderUpsertWithoutOrderLinesInput>;
};

export type ShipbobOrderUpdateOneWithoutShipmentNestedInput = {
  connect?: InputMaybe<ShipbobOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipbobOrderCreateOrConnectWithoutShipmentInput>;
  create?: InputMaybe<ShipbobOrderCreateWithoutShipmentInput>;
  delete?: InputMaybe<ShipbobOrderWhereInput>;
  disconnect?: InputMaybe<ShipbobOrderWhereInput>;
  update?: InputMaybe<ShipbobOrderUpdateToOneWithWhereWithoutShipmentInput>;
  upsert?: InputMaybe<ShipbobOrderUpsertWithoutShipmentInput>;
};

export type ShipbobOrderUpdateToOneWithWhereWithoutOrderLinesInput = {
  data: ShipbobOrderUpdateWithoutOrderLinesInput;
  where?: InputMaybe<ShipbobOrderWhereInput>;
};

export type ShipbobOrderUpdateToOneWithWhereWithoutShipmentInput = {
  data: ShipbobOrderUpdateWithoutShipmentInput;
  where?: InputMaybe<ShipbobOrderWhereInput>;
};

export type ShipbobOrderUpdateWithWhereUniqueWithoutUserProductOrderInput = {
  data: ShipbobOrderUpdateWithoutUserProductOrderInput;
  where: ShipbobOrderWhereUniqueInput;
};

export type ShipbobOrderUpdateWithoutOrderLinesInput = {
  externalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutShipbobOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipbobOrdersNestedInput>;
};

export type ShipbobOrderUpdateWithoutShipmentInput = {
  externalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipbobOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipbobOrdersNestedInput>;
};

export type ShipbobOrderUpdateWithoutUserProductOrderInput = {
  externalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipbobOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutShipbobOrderNestedInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ShipbobOrderUpsertWithWhereUniqueWithoutUserProductOrderInput = {
  create: ShipbobOrderCreateWithoutUserProductOrderInput;
  update: ShipbobOrderUpdateWithoutUserProductOrderInput;
  where: ShipbobOrderWhereUniqueInput;
};

export type ShipbobOrderUpsertWithoutOrderLinesInput = {
  create: ShipbobOrderCreateWithoutOrderLinesInput;
  update: ShipbobOrderUpdateWithoutOrderLinesInput;
  where?: InputMaybe<ShipbobOrderWhereInput>;
};

export type ShipbobOrderUpsertWithoutShipmentInput = {
  create: ShipbobOrderCreateWithoutShipmentInput;
  update: ShipbobOrderUpdateWithoutShipmentInput;
  where?: InputMaybe<ShipbobOrderWhereInput>;
};

export type ShipbobOrderWhereInput = {
  AND?: InputMaybe<Array<ShipbobOrderWhereInput>>;
  NOT?: InputMaybe<Array<ShipbobOrderWhereInput>>;
  OR?: InputMaybe<Array<ShipbobOrderWhereInput>>;
  externalId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  orderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  shipment?: InputMaybe<ShipmentNullableRelationFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrder?: InputMaybe<UserProductOrderRelationFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type ShipbobOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<ShipbobOrderWhereInput>>;
  NOT?: InputMaybe<Array<ShipbobOrderWhereInput>>;
  OR?: InputMaybe<Array<ShipbobOrderWhereInput>>;
  externalId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  shipment?: InputMaybe<ShipmentNullableRelationFilter>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringNullableFilter>;
  userProductOrder?: InputMaybe<UserProductOrderRelationFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export type Shipment = {
  __typename?: 'Shipment';
  _count?: Maybe<ShipmentCount>;
  afterShipTrackingCreated: Scalars['Boolean']['output'];
  bulkShippingId?: Maybe<Scalars['Int']['output']>;
  carrier?: Maybe<Carrier>;
  carrierId?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['BetterDateTimeResolver']['output']>;
  completedById?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['BetterDateTimeResolver']['output'];
  createdBy?: Maybe<Admin>;
  createdById: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  pickupAt?: Maybe<Scalars['BetterDateTimeResolver']['output']>;
  replacement: Scalars['Boolean']['output'];
  reshipmentId?: Maybe<Scalars['String']['output']>;
  reshipmentTo?: Maybe<Shipment>;
  reshippedOrderLines?: Maybe<Array<UserProductOrderLineModel>>;
  reshippingCost?: Maybe<Scalars['Float']['output']>;
  sent: Scalars['Boolean']['output'];
  shipmentBatchId?: Maybe<Scalars['String']['output']>;
  shipmentWeight: Scalars['Float']['output'];
  shippingLabelCost: Scalars['Float']['output'];
  shippingLabelCreated: Scalars['Boolean']['output'];
  shippingLabelUrl: Scalars['String']['output'];
  shippingPackage?: Maybe<ShippingPackage>;
  shippingPackageId?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated
   * shopifyFulfillmentCreated should be replaced with trackingSyncedToStore
   */
  shopifyFulfillmentCreated: Scalars['Boolean']['output'];
  status: ShipmentStatus;
  trackingNumber: Scalars['String']['output'];
  trackingSyncedToStore: Scalars['Boolean']['output'];
  trackingUrl: Scalars['String']['output'];
  updatedAt: Scalars['BetterDateTimeResolver']['output'];
  userProductOrder?: Maybe<UserProductOrder>;
  userProductOrderId: Scalars['String']['output'];
  userProductOrderLines?: Maybe<Array<UserProductOrderLineModel>>;
  warehouseName?: Maybe<Scalars['String']['output']>;
};

export type ShipmentBatch = {
  __typename?: 'ShipmentBatch';
  _count?: Maybe<ShipmentBatchCount>;
  carrier?: Maybe<Carrier>;
  carrierId: Scalars['String']['output'];
  completedBy?: Maybe<Admin>;
  completedById: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  printFileUrl: Scalars['String']['output'];
  shipments?: Maybe<Array<Shipment>>;
  totalWeight: Scalars['Float']['output'];
};

export type ShipmentBatchCount = {
  __typename?: 'ShipmentBatchCount';
  shipments: Scalars['Int']['output'];
};


export type ShipmentBatchCountShipmentsArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentBatchCreateManyCarrierInput = {
  completedById: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  printFileUrl: Scalars['String']['input'];
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ShipmentBatchCreateManyCarrierInputEnvelope = {
  data: Array<ShipmentBatchCreateManyCarrierInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipmentBatchCreateManyCompletedByInput = {
  carrierId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  printFileUrl: Scalars['String']['input'];
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ShipmentBatchCreateManyCompletedByInputEnvelope = {
  data: Array<ShipmentBatchCreateManyCompletedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipmentBatchCreateNestedManyWithoutCarrierInput = {
  connect?: InputMaybe<Array<ShipmentBatchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentBatchCreateOrConnectWithoutCarrierInput>>;
  create?: InputMaybe<Array<ShipmentBatchCreateWithoutCarrierInput>>;
  createMany?: InputMaybe<ShipmentBatchCreateManyCarrierInputEnvelope>;
};

export type ShipmentBatchCreateNestedManyWithoutCompletedByInput = {
  connect?: InputMaybe<Array<ShipmentBatchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentBatchCreateOrConnectWithoutCompletedByInput>>;
  create?: InputMaybe<Array<ShipmentBatchCreateWithoutCompletedByInput>>;
  createMany?: InputMaybe<ShipmentBatchCreateManyCompletedByInputEnvelope>;
};

export type ShipmentBatchCreateNestedOneWithoutShipmentsInput = {
  connect?: InputMaybe<ShipmentBatchWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentBatchCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<ShipmentBatchCreateWithoutShipmentsInput>;
};

export type ShipmentBatchCreateOrConnectWithoutCarrierInput = {
  create: ShipmentBatchCreateWithoutCarrierInput;
  where: ShipmentBatchWhereUniqueInput;
};

export type ShipmentBatchCreateOrConnectWithoutCompletedByInput = {
  create: ShipmentBatchCreateWithoutCompletedByInput;
  where: ShipmentBatchWhereUniqueInput;
};

export type ShipmentBatchCreateOrConnectWithoutShipmentsInput = {
  create: ShipmentBatchCreateWithoutShipmentsInput;
  where: ShipmentBatchWhereUniqueInput;
};

export type ShipmentBatchCreateWithoutCarrierInput = {
  completedBy: AdminCreateNestedOneWithoutShipmentBatchesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  printFileUrl: Scalars['String']['input'];
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutShipmentBatchInput>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ShipmentBatchCreateWithoutCompletedByInput = {
  carrier: CarrierCreateNestedOneWithoutShipmentBatchesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  printFileUrl: Scalars['String']['input'];
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutShipmentBatchInput>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ShipmentBatchCreateWithoutShipmentsInput = {
  carrier: CarrierCreateNestedOneWithoutShipmentBatchesInput;
  completedBy: AdminCreateNestedOneWithoutShipmentBatchesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  printFileUrl: Scalars['String']['input'];
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ShipmentBatchListRelationFilter = {
  every?: InputMaybe<ShipmentBatchWhereInput>;
  none?: InputMaybe<ShipmentBatchWhereInput>;
  some?: InputMaybe<ShipmentBatchWhereInput>;
};

export type ShipmentBatchNullableRelationFilter = {
  is?: InputMaybe<ShipmentBatchWhereInput>;
  isNot?: InputMaybe<ShipmentBatchWhereInput>;
};

export type ShipmentBatchOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShipmentBatchOrderByWithRelationInput = {
  carrier?: InputMaybe<CarrierOrderByWithRelationInput>;
  carrierId?: InputMaybe<SortOrder>;
  completedBy?: InputMaybe<AdminOrderByWithRelationInput>;
  completedById?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  printFileUrl?: InputMaybe<SortOrder>;
  shipments?: InputMaybe<ShipmentOrderByRelationAggregateInput>;
  totalWeight?: InputMaybe<SortOrder>;
};

export enum ShipmentBatchScalarFieldEnum {
  CarrierId = 'carrierId',
  CompletedById = 'completedById',
  CreatedAt = 'createdAt',
  Id = 'id',
  PrintFileUrl = 'printFileUrl',
  TotalWeight = 'totalWeight'
}

export type ShipmentBatchScalarWhereInput = {
  AND?: InputMaybe<Array<ShipmentBatchScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShipmentBatchScalarWhereInput>>;
  OR?: InputMaybe<Array<ShipmentBatchScalarWhereInput>>;
  carrierId?: InputMaybe<UuidFilter>;
  completedById?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  printFileUrl?: InputMaybe<StringFilter>;
  totalWeight?: InputMaybe<FloatFilter>;
};

export type ShipmentBatchUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  printFileUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShipmentBatchUpdateManyWithWhereWithoutCarrierInput = {
  data: ShipmentBatchUpdateManyMutationInput;
  where: ShipmentBatchScalarWhereInput;
};

export type ShipmentBatchUpdateManyWithWhereWithoutCompletedByInput = {
  data: ShipmentBatchUpdateManyMutationInput;
  where: ShipmentBatchScalarWhereInput;
};

export type ShipmentBatchUpdateManyWithoutCarrierNestedInput = {
  connect?: InputMaybe<Array<ShipmentBatchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentBatchCreateOrConnectWithoutCarrierInput>>;
  create?: InputMaybe<Array<ShipmentBatchCreateWithoutCarrierInput>>;
  createMany?: InputMaybe<ShipmentBatchCreateManyCarrierInputEnvelope>;
  delete?: InputMaybe<Array<ShipmentBatchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShipmentBatchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShipmentBatchWhereUniqueInput>>;
  set?: InputMaybe<Array<ShipmentBatchWhereUniqueInput>>;
  update?: InputMaybe<Array<ShipmentBatchUpdateWithWhereUniqueWithoutCarrierInput>>;
  updateMany?: InputMaybe<Array<ShipmentBatchUpdateManyWithWhereWithoutCarrierInput>>;
  upsert?: InputMaybe<Array<ShipmentBatchUpsertWithWhereUniqueWithoutCarrierInput>>;
};

export type ShipmentBatchUpdateManyWithoutCompletedByNestedInput = {
  connect?: InputMaybe<Array<ShipmentBatchWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentBatchCreateOrConnectWithoutCompletedByInput>>;
  create?: InputMaybe<Array<ShipmentBatchCreateWithoutCompletedByInput>>;
  createMany?: InputMaybe<ShipmentBatchCreateManyCompletedByInputEnvelope>;
  delete?: InputMaybe<Array<ShipmentBatchWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShipmentBatchScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShipmentBatchWhereUniqueInput>>;
  set?: InputMaybe<Array<ShipmentBatchWhereUniqueInput>>;
  update?: InputMaybe<Array<ShipmentBatchUpdateWithWhereUniqueWithoutCompletedByInput>>;
  updateMany?: InputMaybe<Array<ShipmentBatchUpdateManyWithWhereWithoutCompletedByInput>>;
  upsert?: InputMaybe<Array<ShipmentBatchUpsertWithWhereUniqueWithoutCompletedByInput>>;
};

export type ShipmentBatchUpdateOneWithoutShipmentsNestedInput = {
  connect?: InputMaybe<ShipmentBatchWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentBatchCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<ShipmentBatchCreateWithoutShipmentsInput>;
  delete?: InputMaybe<ShipmentBatchWhereInput>;
  disconnect?: InputMaybe<ShipmentBatchWhereInput>;
  update?: InputMaybe<ShipmentBatchUpdateToOneWithWhereWithoutShipmentsInput>;
  upsert?: InputMaybe<ShipmentBatchUpsertWithoutShipmentsInput>;
};

export type ShipmentBatchUpdateToOneWithWhereWithoutShipmentsInput = {
  data: ShipmentBatchUpdateWithoutShipmentsInput;
  where?: InputMaybe<ShipmentBatchWhereInput>;
};

export type ShipmentBatchUpdateWithWhereUniqueWithoutCarrierInput = {
  data: ShipmentBatchUpdateWithoutCarrierInput;
  where: ShipmentBatchWhereUniqueInput;
};

export type ShipmentBatchUpdateWithWhereUniqueWithoutCompletedByInput = {
  data: ShipmentBatchUpdateWithoutCompletedByInput;
  where: ShipmentBatchWhereUniqueInput;
};

export type ShipmentBatchUpdateWithoutCarrierInput = {
  completedBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentBatchesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  printFileUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutShipmentBatchNestedInput>;
  totalWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShipmentBatchUpdateWithoutCompletedByInput = {
  carrier?: InputMaybe<CarrierUpdateOneRequiredWithoutShipmentBatchesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  printFileUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutShipmentBatchNestedInput>;
  totalWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShipmentBatchUpdateWithoutShipmentsInput = {
  carrier?: InputMaybe<CarrierUpdateOneRequiredWithoutShipmentBatchesNestedInput>;
  completedBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentBatchesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  printFileUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShipmentBatchUpsertWithWhereUniqueWithoutCarrierInput = {
  create: ShipmentBatchCreateWithoutCarrierInput;
  update: ShipmentBatchUpdateWithoutCarrierInput;
  where: ShipmentBatchWhereUniqueInput;
};

export type ShipmentBatchUpsertWithWhereUniqueWithoutCompletedByInput = {
  create: ShipmentBatchCreateWithoutCompletedByInput;
  update: ShipmentBatchUpdateWithoutCompletedByInput;
  where: ShipmentBatchWhereUniqueInput;
};

export type ShipmentBatchUpsertWithoutShipmentsInput = {
  create: ShipmentBatchCreateWithoutShipmentsInput;
  update: ShipmentBatchUpdateWithoutShipmentsInput;
  where?: InputMaybe<ShipmentBatchWhereInput>;
};

export type ShipmentBatchWhereInput = {
  AND?: InputMaybe<Array<ShipmentBatchWhereInput>>;
  NOT?: InputMaybe<Array<ShipmentBatchWhereInput>>;
  OR?: InputMaybe<Array<ShipmentBatchWhereInput>>;
  carrier?: InputMaybe<CarrierRelationFilter>;
  carrierId?: InputMaybe<UuidFilter>;
  completedBy?: InputMaybe<AdminRelationFilter>;
  completedById?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  printFileUrl?: InputMaybe<StringFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  totalWeight?: InputMaybe<FloatFilter>;
};

export type ShipmentBatchWhereUniqueInput = {
  AND?: InputMaybe<Array<ShipmentBatchWhereInput>>;
  NOT?: InputMaybe<Array<ShipmentBatchWhereInput>>;
  OR?: InputMaybe<Array<ShipmentBatchWhereInput>>;
  carrier?: InputMaybe<CarrierRelationFilter>;
  carrierId?: InputMaybe<UuidFilter>;
  completedBy?: InputMaybe<AdminRelationFilter>;
  completedById?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  printFileUrl?: InputMaybe<StringFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  totalWeight?: InputMaybe<FloatFilter>;
};

export type ShipmentCount = {
  __typename?: 'ShipmentCount';
  reshippedOrderLines: Scalars['Int']['output'];
  userProductOrderLines: Scalars['Int']['output'];
};


export type ShipmentCountReshippedOrderLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type ShipmentCountUserProductOrderLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type ShipmentCreateManyBulkShippingInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  carrierId?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedById?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentBatchId?: InputMaybe<Scalars['String']['input']>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackageId?: InputMaybe<Scalars['String']['input']>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrderId: Scalars['String']['input'];
};

export type ShipmentCreateManyBulkShippingInputEnvelope = {
  data: Array<ShipmentCreateManyBulkShippingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipmentCreateManyCarrierInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShippingId?: InputMaybe<Scalars['Int']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedById?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentBatchId?: InputMaybe<Scalars['String']['input']>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackageId?: InputMaybe<Scalars['String']['input']>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrderId: Scalars['String']['input'];
};

export type ShipmentCreateManyCarrierInputEnvelope = {
  data: Array<ShipmentCreateManyCarrierInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipmentCreateManyCompletedByInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShippingId?: InputMaybe<Scalars['Int']['input']>;
  carrierId?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentBatchId?: InputMaybe<Scalars['String']['input']>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackageId?: InputMaybe<Scalars['String']['input']>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrderId: Scalars['String']['input'];
};

export type ShipmentCreateManyCompletedByInputEnvelope = {
  data: Array<ShipmentCreateManyCompletedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipmentCreateManyCreatedByInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShippingId?: InputMaybe<Scalars['Int']['input']>;
  carrierId?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedById?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentBatchId?: InputMaybe<Scalars['String']['input']>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackageId?: InputMaybe<Scalars['String']['input']>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrderId: Scalars['String']['input'];
};

export type ShipmentCreateManyCreatedByInputEnvelope = {
  data: Array<ShipmentCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipmentCreateManyShipmentBatchInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShippingId?: InputMaybe<Scalars['Int']['input']>;
  carrierId?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedById?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackageId?: InputMaybe<Scalars['String']['input']>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrderId: Scalars['String']['input'];
};

export type ShipmentCreateManyShipmentBatchInputEnvelope = {
  data: Array<ShipmentCreateManyShipmentBatchInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipmentCreateManyShippingPackageInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShippingId?: InputMaybe<Scalars['Int']['input']>;
  carrierId?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedById?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentBatchId?: InputMaybe<Scalars['String']['input']>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrderId: Scalars['String']['input'];
};

export type ShipmentCreateManyShippingPackageInputEnvelope = {
  data: Array<ShipmentCreateManyShippingPackageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipmentCreateManyUserProductOrderInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShippingId?: InputMaybe<Scalars['Int']['input']>;
  carrierId?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedById?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentBatchId?: InputMaybe<Scalars['String']['input']>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackageId?: InputMaybe<Scalars['String']['input']>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShipmentCreateManyUserProductOrderInputEnvelope = {
  data: Array<ShipmentCreateManyUserProductOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShipmentCreateNestedManyWithoutBulkShippingInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutBulkShippingInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutBulkShippingInput>>;
  createMany?: InputMaybe<ShipmentCreateManyBulkShippingInputEnvelope>;
};

export type ShipmentCreateNestedManyWithoutCarrierInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutCarrierInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutCarrierInput>>;
  createMany?: InputMaybe<ShipmentCreateManyCarrierInputEnvelope>;
};

export type ShipmentCreateNestedManyWithoutCompletedByInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutCompletedByInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutCompletedByInput>>;
  createMany?: InputMaybe<ShipmentCreateManyCompletedByInputEnvelope>;
};

export type ShipmentCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<ShipmentCreateManyCreatedByInputEnvelope>;
};

export type ShipmentCreateNestedManyWithoutShipmentBatchInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutShipmentBatchInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutShipmentBatchInput>>;
  createMany?: InputMaybe<ShipmentCreateManyShipmentBatchInputEnvelope>;
};

export type ShipmentCreateNestedManyWithoutShippingPackageInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutShippingPackageInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutShippingPackageInput>>;
  createMany?: InputMaybe<ShipmentCreateManyShippingPackageInputEnvelope>;
};

export type ShipmentCreateNestedManyWithoutUserProductOrderInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<ShipmentCreateManyUserProductOrderInputEnvelope>;
};

export type ShipmentCreateNestedOneWithoutEverlabOrderInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutEverlabOrderInput>;
  create?: InputMaybe<ShipmentCreateWithoutEverlabOrderInput>;
};

export type ShipmentCreateNestedOneWithoutJetpackApiOrderInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutJetpackApiOrderInput>;
  create?: InputMaybe<ShipmentCreateWithoutJetpackApiOrderInput>;
};

export type ShipmentCreateNestedOneWithoutReshipmentInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutReshipmentInput>;
  create?: InputMaybe<ShipmentCreateWithoutReshipmentInput>;
};

export type ShipmentCreateNestedOneWithoutReshipmentToInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutReshipmentToInput>;
  create?: InputMaybe<ShipmentCreateWithoutReshipmentToInput>;
};

export type ShipmentCreateNestedOneWithoutReshippedOrderLinesInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutReshippedOrderLinesInput>;
  create?: InputMaybe<ShipmentCreateWithoutReshippedOrderLinesInput>;
};

export type ShipmentCreateNestedOneWithoutRoastifyOrderInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutRoastifyOrderInput>;
  create?: InputMaybe<ShipmentCreateWithoutRoastifyOrderInput>;
};

export type ShipmentCreateNestedOneWithoutShipbobOrderInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutShipbobOrderInput>;
  create?: InputMaybe<ShipmentCreateWithoutShipbobOrderInput>;
};

export type ShipmentCreateNestedOneWithoutUserProductOrderLinesInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutUserProductOrderLinesInput>;
  create?: InputMaybe<ShipmentCreateWithoutUserProductOrderLinesInput>;
};

export type ShipmentCreateOrConnectWithoutBulkShippingInput = {
  create: ShipmentCreateWithoutBulkShippingInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutCarrierInput = {
  create: ShipmentCreateWithoutCarrierInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutCompletedByInput = {
  create: ShipmentCreateWithoutCompletedByInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutCreatedByInput = {
  create: ShipmentCreateWithoutCreatedByInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutEverlabOrderInput = {
  create: ShipmentCreateWithoutEverlabOrderInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutJetpackApiOrderInput = {
  create: ShipmentCreateWithoutJetpackApiOrderInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutReshipmentInput = {
  create: ShipmentCreateWithoutReshipmentInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutReshipmentToInput = {
  create: ShipmentCreateWithoutReshipmentToInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutReshippedOrderLinesInput = {
  create: ShipmentCreateWithoutReshippedOrderLinesInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutRoastifyOrderInput = {
  create: ShipmentCreateWithoutRoastifyOrderInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutShipbobOrderInput = {
  create: ShipmentCreateWithoutShipbobOrderInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutShipmentBatchInput = {
  create: ShipmentCreateWithoutShipmentBatchInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutShippingPackageInput = {
  create: ShipmentCreateWithoutShippingPackageInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutUserProductOrderInput = {
  create: ShipmentCreateWithoutUserProductOrderInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateOrConnectWithoutUserProductOrderLinesInput = {
  create: ShipmentCreateWithoutUserProductOrderLinesInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateWithoutBulkShippingInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutCarrierInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutCompletedByInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutCreatedByInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutEverlabOrderInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutJetpackApiOrderInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutReshipmentInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutReshipmentToInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutReshippedOrderLinesInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutRoastifyOrderInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutShipbobOrderInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutShipmentBatchInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutShippingPackageInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutUserProductOrderInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutShipmentInput>;
};

export type ShipmentCreateWithoutUserProductOrderLinesInput = {
  afterShipTrackingCreated?: InputMaybe<Scalars['Boolean']['input']>;
  bulkShipping?: InputMaybe<BulkShippingCreateNestedOneWithoutShipmentsInput>;
  carrier?: InputMaybe<CarrierCreateNestedOneWithoutShipmentsInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<AdminCreateNestedOneWithoutCompletedShipmentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutShipmentsInput;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutShipmentInput>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutShipmentInput>;
  pickupAt?: InputMaybe<Scalars['DateTime']['input']>;
  replacement?: InputMaybe<Scalars['Boolean']['input']>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentToInput>;
  reshipmentTo?: InputMaybe<ShipmentCreateNestedOneWithoutReshipmentInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutReshipmentInput>;
  reshippingCost?: InputMaybe<Scalars['Float']['input']>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutShipmentInput>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutShipmentInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchCreateNestedOneWithoutShipmentsInput>;
  shipmentWeight?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCost?: InputMaybe<Scalars['Float']['input']>;
  shippingLabelCreated?: InputMaybe<Scalars['Boolean']['input']>;
  shippingLabelUrl: Scalars['String']['input'];
  shippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutShipmentsInput>;
  shopifyFulfillmentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  trackingNumber: Scalars['String']['input'];
  trackingSyncedToStore?: InputMaybe<Scalars['Boolean']['input']>;
  trackingUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder: UserProductOrderCreateNestedOneWithoutShipmentsInput;
};

export type ShipmentListRelationFilter = {
  every?: InputMaybe<ShipmentWhereInput>;
  none?: InputMaybe<ShipmentWhereInput>;
  some?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentNullableRelationFilter = {
  is?: InputMaybe<ShipmentWhereInput>;
  isNot?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShipmentOrderByWithRelationInput = {
  afterShipTrackingCreated?: InputMaybe<SortOrder>;
  bulkShipping?: InputMaybe<BulkShippingOrderByWithRelationInput>;
  bulkShippingId?: InputMaybe<SortOrderInput>;
  carrier?: InputMaybe<CarrierOrderByWithRelationInput>;
  carrierId?: InputMaybe<SortOrderInput>;
  completed?: InputMaybe<SortOrder>;
  completedAt?: InputMaybe<SortOrderInput>;
  completedBy?: InputMaybe<AdminOrderByWithRelationInput>;
  completedById?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<AdminOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrder>;
  everlabOrder?: InputMaybe<EverlabOrderOrderByWithRelationInput>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderOrderByWithRelationInput>;
  pickupAt?: InputMaybe<SortOrderInput>;
  replacement?: InputMaybe<SortOrder>;
  reshipment?: InputMaybe<ShipmentOrderByWithRelationInput>;
  reshipmentId?: InputMaybe<SortOrderInput>;
  reshipmentTo?: InputMaybe<ShipmentOrderByWithRelationInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  reshippingCost?: InputMaybe<SortOrderInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderOrderByWithRelationInput>;
  sent?: InputMaybe<SortOrder>;
  shipbobOrder?: InputMaybe<ShipbobOrderOrderByWithRelationInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchOrderByWithRelationInput>;
  shipmentBatchId?: InputMaybe<SortOrderInput>;
  shipmentWeight?: InputMaybe<SortOrder>;
  shippingLabelCost?: InputMaybe<SortOrder>;
  shippingLabelCreated?: InputMaybe<SortOrder>;
  shippingLabelUrl?: InputMaybe<SortOrder>;
  shippingPackage?: InputMaybe<ShippingPackageOrderByWithRelationInput>;
  shippingPackageId?: InputMaybe<SortOrderInput>;
  shopifyFulfillmentCreated?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  trackingNumber?: InputMaybe<SortOrder>;
  trackingSyncedToStore?: InputMaybe<SortOrder>;
  trackingUrl?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userProductOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  userProductOrderId?: InputMaybe<SortOrder>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
};

export enum ShipmentScalarFieldEnum {
  AfterShipTrackingCreated = 'afterShipTrackingCreated',
  BulkShippingId = 'bulkShippingId',
  CarrierId = 'carrierId',
  Completed = 'completed',
  CompletedAt = 'completedAt',
  CompletedById = 'completedById',
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  ExternalId = 'externalId',
  Id = 'id',
  PickupAt = 'pickupAt',
  Replacement = 'replacement',
  ReshipmentId = 'reshipmentId',
  ReshippingCost = 'reshippingCost',
  Sent = 'sent',
  ShipmentBatchId = 'shipmentBatchId',
  ShipmentWeight = 'shipmentWeight',
  ShippingLabelCost = 'shippingLabelCost',
  ShippingLabelCreated = 'shippingLabelCreated',
  ShippingLabelUrl = 'shippingLabelUrl',
  ShippingPackageId = 'shippingPackageId',
  ShopifyFulfillmentCreated = 'shopifyFulfillmentCreated',
  Status = 'status',
  TrackingNumber = 'trackingNumber',
  TrackingSyncedToStore = 'trackingSyncedToStore',
  TrackingUrl = 'trackingUrl',
  UpdatedAt = 'updatedAt',
  UserProductOrderId = 'userProductOrderId'
}

export type ShipmentScalarWhereInput = {
  AND?: InputMaybe<Array<ShipmentScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShipmentScalarWhereInput>>;
  OR?: InputMaybe<Array<ShipmentScalarWhereInput>>;
  afterShipTrackingCreated?: InputMaybe<BoolFilter>;
  bulkShippingId?: InputMaybe<IntNullableFilter>;
  carrierId?: InputMaybe<UuidNullableFilter>;
  completed?: InputMaybe<BoolFilter>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  completedById?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<UuidFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  pickupAt?: InputMaybe<DateTimeNullableFilter>;
  replacement?: InputMaybe<BoolFilter>;
  reshipmentId?: InputMaybe<StringNullableFilter>;
  reshippingCost?: InputMaybe<FloatNullableFilter>;
  sent?: InputMaybe<BoolFilter>;
  shipmentBatchId?: InputMaybe<UuidNullableFilter>;
  shipmentWeight?: InputMaybe<FloatFilter>;
  shippingLabelCost?: InputMaybe<FloatFilter>;
  shippingLabelCreated?: InputMaybe<BoolFilter>;
  shippingLabelUrl?: InputMaybe<StringFilter>;
  shippingPackageId?: InputMaybe<UuidNullableFilter>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumShipmentStatusFilter>;
  trackingNumber?: InputMaybe<StringFilter>;
  trackingSyncedToStore?: InputMaybe<BoolFilter>;
  trackingUrl?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
};

export enum ShipmentStatus {
  New = 'NEW',
  ReadyToShip = 'READY_TO_SHIP',
  Returned = 'RETURNED',
  Shipped = 'SHIPPED'
}

export type ShipmentUpdateManyMutationInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShipmentUpdateManyWithWhereWithoutBulkShippingInput = {
  data: ShipmentUpdateManyMutationInput;
  where: ShipmentScalarWhereInput;
};

export type ShipmentUpdateManyWithWhereWithoutCarrierInput = {
  data: ShipmentUpdateManyMutationInput;
  where: ShipmentScalarWhereInput;
};

export type ShipmentUpdateManyWithWhereWithoutCompletedByInput = {
  data: ShipmentUpdateManyMutationInput;
  where: ShipmentScalarWhereInput;
};

export type ShipmentUpdateManyWithWhereWithoutCreatedByInput = {
  data: ShipmentUpdateManyMutationInput;
  where: ShipmentScalarWhereInput;
};

export type ShipmentUpdateManyWithWhereWithoutShipmentBatchInput = {
  data: ShipmentUpdateManyMutationInput;
  where: ShipmentScalarWhereInput;
};

export type ShipmentUpdateManyWithWhereWithoutShippingPackageInput = {
  data: ShipmentUpdateManyMutationInput;
  where: ShipmentScalarWhereInput;
};

export type ShipmentUpdateManyWithWhereWithoutUserProductOrderInput = {
  data: ShipmentUpdateManyMutationInput;
  where: ShipmentScalarWhereInput;
};

export type ShipmentUpdateManyWithoutBulkShippingNestedInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutBulkShippingInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutBulkShippingInput>>;
  createMany?: InputMaybe<ShipmentCreateManyBulkShippingInputEnvelope>;
  delete?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShipmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  set?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  update?: InputMaybe<Array<ShipmentUpdateWithWhereUniqueWithoutBulkShippingInput>>;
  updateMany?: InputMaybe<Array<ShipmentUpdateManyWithWhereWithoutBulkShippingInput>>;
  upsert?: InputMaybe<Array<ShipmentUpsertWithWhereUniqueWithoutBulkShippingInput>>;
};

export type ShipmentUpdateManyWithoutCarrierNestedInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutCarrierInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutCarrierInput>>;
  createMany?: InputMaybe<ShipmentCreateManyCarrierInputEnvelope>;
  delete?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShipmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  set?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  update?: InputMaybe<Array<ShipmentUpdateWithWhereUniqueWithoutCarrierInput>>;
  updateMany?: InputMaybe<Array<ShipmentUpdateManyWithWhereWithoutCarrierInput>>;
  upsert?: InputMaybe<Array<ShipmentUpsertWithWhereUniqueWithoutCarrierInput>>;
};

export type ShipmentUpdateManyWithoutCompletedByNestedInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutCompletedByInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutCompletedByInput>>;
  createMany?: InputMaybe<ShipmentCreateManyCompletedByInputEnvelope>;
  delete?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShipmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  set?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  update?: InputMaybe<Array<ShipmentUpdateWithWhereUniqueWithoutCompletedByInput>>;
  updateMany?: InputMaybe<Array<ShipmentUpdateManyWithWhereWithoutCompletedByInput>>;
  upsert?: InputMaybe<Array<ShipmentUpsertWithWhereUniqueWithoutCompletedByInput>>;
};

export type ShipmentUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<ShipmentCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShipmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  set?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  update?: InputMaybe<Array<ShipmentUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<ShipmentUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<ShipmentUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type ShipmentUpdateManyWithoutShipmentBatchNestedInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutShipmentBatchInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutShipmentBatchInput>>;
  createMany?: InputMaybe<ShipmentCreateManyShipmentBatchInputEnvelope>;
  delete?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShipmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  set?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  update?: InputMaybe<Array<ShipmentUpdateWithWhereUniqueWithoutShipmentBatchInput>>;
  updateMany?: InputMaybe<Array<ShipmentUpdateManyWithWhereWithoutShipmentBatchInput>>;
  upsert?: InputMaybe<Array<ShipmentUpsertWithWhereUniqueWithoutShipmentBatchInput>>;
};

export type ShipmentUpdateManyWithoutShippingPackageNestedInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutShippingPackageInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutShippingPackageInput>>;
  createMany?: InputMaybe<ShipmentCreateManyShippingPackageInputEnvelope>;
  delete?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShipmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  set?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  update?: InputMaybe<Array<ShipmentUpdateWithWhereUniqueWithoutShippingPackageInput>>;
  updateMany?: InputMaybe<Array<ShipmentUpdateManyWithWhereWithoutShippingPackageInput>>;
  upsert?: InputMaybe<Array<ShipmentUpsertWithWhereUniqueWithoutShippingPackageInput>>;
};

export type ShipmentUpdateManyWithoutUserProductOrderNestedInput = {
  connect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShipmentCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<ShipmentCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<ShipmentCreateManyUserProductOrderInputEnvelope>;
  delete?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShipmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  set?: InputMaybe<Array<ShipmentWhereUniqueInput>>;
  update?: InputMaybe<Array<ShipmentUpdateWithWhereUniqueWithoutUserProductOrderInput>>;
  updateMany?: InputMaybe<Array<ShipmentUpdateManyWithWhereWithoutUserProductOrderInput>>;
  upsert?: InputMaybe<Array<ShipmentUpsertWithWhereUniqueWithoutUserProductOrderInput>>;
};

export type ShipmentUpdateOneWithoutEverlabOrderNestedInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutEverlabOrderInput>;
  create?: InputMaybe<ShipmentCreateWithoutEverlabOrderInput>;
  delete?: InputMaybe<ShipmentWhereInput>;
  disconnect?: InputMaybe<ShipmentWhereInput>;
  update?: InputMaybe<ShipmentUpdateToOneWithWhereWithoutEverlabOrderInput>;
  upsert?: InputMaybe<ShipmentUpsertWithoutEverlabOrderInput>;
};

export type ShipmentUpdateOneWithoutJetpackApiOrderNestedInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutJetpackApiOrderInput>;
  create?: InputMaybe<ShipmentCreateWithoutJetpackApiOrderInput>;
  delete?: InputMaybe<ShipmentWhereInput>;
  disconnect?: InputMaybe<ShipmentWhereInput>;
  update?: InputMaybe<ShipmentUpdateToOneWithWhereWithoutJetpackApiOrderInput>;
  upsert?: InputMaybe<ShipmentUpsertWithoutJetpackApiOrderInput>;
};

export type ShipmentUpdateOneWithoutReshipmentNestedInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutReshipmentInput>;
  create?: InputMaybe<ShipmentCreateWithoutReshipmentInput>;
  delete?: InputMaybe<ShipmentWhereInput>;
  disconnect?: InputMaybe<ShipmentWhereInput>;
  update?: InputMaybe<ShipmentUpdateToOneWithWhereWithoutReshipmentInput>;
  upsert?: InputMaybe<ShipmentUpsertWithoutReshipmentInput>;
};

export type ShipmentUpdateOneWithoutReshipmentToNestedInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutReshipmentToInput>;
  create?: InputMaybe<ShipmentCreateWithoutReshipmentToInput>;
  delete?: InputMaybe<ShipmentWhereInput>;
  disconnect?: InputMaybe<ShipmentWhereInput>;
  update?: InputMaybe<ShipmentUpdateToOneWithWhereWithoutReshipmentToInput>;
  upsert?: InputMaybe<ShipmentUpsertWithoutReshipmentToInput>;
};

export type ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutReshippedOrderLinesInput>;
  create?: InputMaybe<ShipmentCreateWithoutReshippedOrderLinesInput>;
  delete?: InputMaybe<ShipmentWhereInput>;
  disconnect?: InputMaybe<ShipmentWhereInput>;
  update?: InputMaybe<ShipmentUpdateToOneWithWhereWithoutReshippedOrderLinesInput>;
  upsert?: InputMaybe<ShipmentUpsertWithoutReshippedOrderLinesInput>;
};

export type ShipmentUpdateOneWithoutRoastifyOrderNestedInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutRoastifyOrderInput>;
  create?: InputMaybe<ShipmentCreateWithoutRoastifyOrderInput>;
  delete?: InputMaybe<ShipmentWhereInput>;
  disconnect?: InputMaybe<ShipmentWhereInput>;
  update?: InputMaybe<ShipmentUpdateToOneWithWhereWithoutRoastifyOrderInput>;
  upsert?: InputMaybe<ShipmentUpsertWithoutRoastifyOrderInput>;
};

export type ShipmentUpdateOneWithoutShipbobOrderNestedInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutShipbobOrderInput>;
  create?: InputMaybe<ShipmentCreateWithoutShipbobOrderInput>;
  delete?: InputMaybe<ShipmentWhereInput>;
  disconnect?: InputMaybe<ShipmentWhereInput>;
  update?: InputMaybe<ShipmentUpdateToOneWithWhereWithoutShipbobOrderInput>;
  upsert?: InputMaybe<ShipmentUpsertWithoutShipbobOrderInput>;
};

export type ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutUserProductOrderLinesInput>;
  create?: InputMaybe<ShipmentCreateWithoutUserProductOrderLinesInput>;
  delete?: InputMaybe<ShipmentWhereInput>;
  disconnect?: InputMaybe<ShipmentWhereInput>;
  update?: InputMaybe<ShipmentUpdateToOneWithWhereWithoutUserProductOrderLinesInput>;
  upsert?: InputMaybe<ShipmentUpsertWithoutUserProductOrderLinesInput>;
};

export type ShipmentUpdateToOneWithWhereWithoutEverlabOrderInput = {
  data: ShipmentUpdateWithoutEverlabOrderInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpdateToOneWithWhereWithoutJetpackApiOrderInput = {
  data: ShipmentUpdateWithoutJetpackApiOrderInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpdateToOneWithWhereWithoutReshipmentInput = {
  data: ShipmentUpdateWithoutReshipmentInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpdateToOneWithWhereWithoutReshipmentToInput = {
  data: ShipmentUpdateWithoutReshipmentToInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpdateToOneWithWhereWithoutReshippedOrderLinesInput = {
  data: ShipmentUpdateWithoutReshippedOrderLinesInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpdateToOneWithWhereWithoutRoastifyOrderInput = {
  data: ShipmentUpdateWithoutRoastifyOrderInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpdateToOneWithWhereWithoutShipbobOrderInput = {
  data: ShipmentUpdateWithoutShipbobOrderInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpdateToOneWithWhereWithoutUserProductOrderLinesInput = {
  data: ShipmentUpdateWithoutUserProductOrderLinesInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpdateWithWhereUniqueWithoutBulkShippingInput = {
  data: ShipmentUpdateWithoutBulkShippingInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpdateWithWhereUniqueWithoutCarrierInput = {
  data: ShipmentUpdateWithoutCarrierInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpdateWithWhereUniqueWithoutCompletedByInput = {
  data: ShipmentUpdateWithoutCompletedByInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: ShipmentUpdateWithoutCreatedByInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpdateWithWhereUniqueWithoutShipmentBatchInput = {
  data: ShipmentUpdateWithoutShipmentBatchInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpdateWithWhereUniqueWithoutShippingPackageInput = {
  data: ShipmentUpdateWithoutShippingPackageInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpdateWithWhereUniqueWithoutUserProductOrderInput = {
  data: ShipmentUpdateWithoutUserProductOrderInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpdateWithoutBulkShippingInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutCarrierInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutCompletedByInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutCreatedByInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutEverlabOrderInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutJetpackApiOrderInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutReshipmentInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutReshipmentToInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutReshippedOrderLinesInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutRoastifyOrderInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutShipbobOrderInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutShipmentBatchInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutShippingPackageInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutUserProductOrderInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutShipmentNestedInput>;
};

export type ShipmentUpdateWithoutUserProductOrderLinesInput = {
  afterShipTrackingCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bulkShipping?: InputMaybe<BulkShippingUpdateOneWithoutShipmentsNestedInput>;
  carrier?: InputMaybe<CarrierUpdateOneWithoutShipmentsNestedInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedBy?: InputMaybe<AdminUpdateOneWithoutCompletedShipmentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutShipmentsNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutShipmentNestedInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutShipmentNestedInput>;
  pickupAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshipmentToNestedInput>;
  reshipmentTo?: InputMaybe<ShipmentUpdateOneWithoutReshipmentNestedInput>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutReshipmentNestedInput>;
  reshippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutShipmentNestedInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutShipmentNestedInput>;
  shipmentBatch?: InputMaybe<ShipmentBatchUpdateOneWithoutShipmentsNestedInput>;
  shipmentWeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCost?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shippingLabelCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutShipmentsNestedInput>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumShipmentStatusFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  trackingSyncedToStore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trackingUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput>;
};

export type ShipmentUpsertWithWhereUniqueWithoutBulkShippingInput = {
  create: ShipmentCreateWithoutBulkShippingInput;
  update: ShipmentUpdateWithoutBulkShippingInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpsertWithWhereUniqueWithoutCarrierInput = {
  create: ShipmentCreateWithoutCarrierInput;
  update: ShipmentUpdateWithoutCarrierInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpsertWithWhereUniqueWithoutCompletedByInput = {
  create: ShipmentCreateWithoutCompletedByInput;
  update: ShipmentUpdateWithoutCompletedByInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: ShipmentCreateWithoutCreatedByInput;
  update: ShipmentUpdateWithoutCreatedByInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpsertWithWhereUniqueWithoutShipmentBatchInput = {
  create: ShipmentCreateWithoutShipmentBatchInput;
  update: ShipmentUpdateWithoutShipmentBatchInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpsertWithWhereUniqueWithoutShippingPackageInput = {
  create: ShipmentCreateWithoutShippingPackageInput;
  update: ShipmentUpdateWithoutShippingPackageInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpsertWithWhereUniqueWithoutUserProductOrderInput = {
  create: ShipmentCreateWithoutUserProductOrderInput;
  update: ShipmentUpdateWithoutUserProductOrderInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentUpsertWithoutEverlabOrderInput = {
  create: ShipmentCreateWithoutEverlabOrderInput;
  update: ShipmentUpdateWithoutEverlabOrderInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpsertWithoutJetpackApiOrderInput = {
  create: ShipmentCreateWithoutJetpackApiOrderInput;
  update: ShipmentUpdateWithoutJetpackApiOrderInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpsertWithoutReshipmentInput = {
  create: ShipmentCreateWithoutReshipmentInput;
  update: ShipmentUpdateWithoutReshipmentInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpsertWithoutReshipmentToInput = {
  create: ShipmentCreateWithoutReshipmentToInput;
  update: ShipmentUpdateWithoutReshipmentToInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpsertWithoutReshippedOrderLinesInput = {
  create: ShipmentCreateWithoutReshippedOrderLinesInput;
  update: ShipmentUpdateWithoutReshippedOrderLinesInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpsertWithoutRoastifyOrderInput = {
  create: ShipmentCreateWithoutRoastifyOrderInput;
  update: ShipmentUpdateWithoutRoastifyOrderInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpsertWithoutShipbobOrderInput = {
  create: ShipmentCreateWithoutShipbobOrderInput;
  update: ShipmentUpdateWithoutShipbobOrderInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpsertWithoutUserProductOrderLinesInput = {
  create: ShipmentCreateWithoutUserProductOrderLinesInput;
  update: ShipmentUpdateWithoutUserProductOrderLinesInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentWhereInput = {
  AND?: InputMaybe<Array<ShipmentWhereInput>>;
  NOT?: InputMaybe<Array<ShipmentWhereInput>>;
  OR?: InputMaybe<Array<ShipmentWhereInput>>;
  afterShipTrackingCreated?: InputMaybe<BoolFilter>;
  bulkShipping?: InputMaybe<BulkShippingNullableRelationFilter>;
  bulkShippingId?: InputMaybe<IntNullableFilter>;
  carrier?: InputMaybe<CarrierNullableRelationFilter>;
  carrierId?: InputMaybe<UuidNullableFilter>;
  completed?: InputMaybe<BoolFilter>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  completedBy?: InputMaybe<AdminNullableRelationFilter>;
  completedById?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminRelationFilter>;
  createdById?: InputMaybe<UuidFilter>;
  everlabOrder?: InputMaybe<EverlabOrderNullableRelationFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderNullableRelationFilter>;
  pickupAt?: InputMaybe<DateTimeNullableFilter>;
  replacement?: InputMaybe<BoolFilter>;
  reshipment?: InputMaybe<ShipmentNullableRelationFilter>;
  reshipmentId?: InputMaybe<StringNullableFilter>;
  reshipmentTo?: InputMaybe<ShipmentNullableRelationFilter>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  reshippingCost?: InputMaybe<FloatNullableFilter>;
  roastifyOrder?: InputMaybe<RoastifyOrderNullableRelationFilter>;
  sent?: InputMaybe<BoolFilter>;
  shipbobOrder?: InputMaybe<ShipbobOrderNullableRelationFilter>;
  shipmentBatch?: InputMaybe<ShipmentBatchNullableRelationFilter>;
  shipmentBatchId?: InputMaybe<UuidNullableFilter>;
  shipmentWeight?: InputMaybe<FloatFilter>;
  shippingLabelCost?: InputMaybe<FloatFilter>;
  shippingLabelCreated?: InputMaybe<BoolFilter>;
  shippingLabelUrl?: InputMaybe<StringFilter>;
  shippingPackage?: InputMaybe<ShippingPackageNullableRelationFilter>;
  shippingPackageId?: InputMaybe<UuidNullableFilter>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumShipmentStatusFilter>;
  trackingNumber?: InputMaybe<StringFilter>;
  trackingSyncedToStore?: InputMaybe<BoolFilter>;
  trackingUrl?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProductOrder?: InputMaybe<UserProductOrderRelationFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
};

export type ShipmentWhereUniqueInput = {
  AND?: InputMaybe<Array<ShipmentWhereInput>>;
  NOT?: InputMaybe<Array<ShipmentWhereInput>>;
  OR?: InputMaybe<Array<ShipmentWhereInput>>;
  afterShipTrackingCreated?: InputMaybe<BoolFilter>;
  bulkShipping?: InputMaybe<BulkShippingNullableRelationFilter>;
  bulkShippingId?: InputMaybe<IntNullableFilter>;
  carrier?: InputMaybe<CarrierNullableRelationFilter>;
  carrierId?: InputMaybe<UuidNullableFilter>;
  completed?: InputMaybe<BoolFilter>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  completedBy?: InputMaybe<AdminNullableRelationFilter>;
  completedById?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminRelationFilter>;
  createdById?: InputMaybe<UuidFilter>;
  everlabOrder?: InputMaybe<EverlabOrderNullableRelationFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderNullableRelationFilter>;
  pickupAt?: InputMaybe<DateTimeNullableFilter>;
  replacement?: InputMaybe<BoolFilter>;
  reshipment?: InputMaybe<ShipmentNullableRelationFilter>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  reshipmentTo?: InputMaybe<ShipmentNullableRelationFilter>;
  reshippedOrderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  reshippingCost?: InputMaybe<FloatNullableFilter>;
  roastifyOrder?: InputMaybe<RoastifyOrderNullableRelationFilter>;
  sent?: InputMaybe<BoolFilter>;
  shipbobOrder?: InputMaybe<ShipbobOrderNullableRelationFilter>;
  shipmentBatch?: InputMaybe<ShipmentBatchNullableRelationFilter>;
  shipmentBatchId?: InputMaybe<UuidNullableFilter>;
  shipmentWeight?: InputMaybe<FloatFilter>;
  shippingLabelCost?: InputMaybe<FloatFilter>;
  shippingLabelCreated?: InputMaybe<BoolFilter>;
  shippingLabelUrl?: InputMaybe<StringFilter>;
  shippingPackage?: InputMaybe<ShippingPackageNullableRelationFilter>;
  shippingPackageId?: InputMaybe<UuidNullableFilter>;
  shopifyFulfillmentCreated?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumShipmentStatusFilter>;
  trackingNumber?: InputMaybe<StringFilter>;
  trackingSyncedToStore?: InputMaybe<BoolFilter>;
  trackingUrl?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProductOrder?: InputMaybe<UserProductOrderRelationFilter>;
  userProductOrderId?: InputMaybe<UuidFilter>;
  userProductOrderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
};

export type ShippingPackage = {
  __typename?: 'ShippingPackage';
  _count?: Maybe<ShippingPackageCount>;
  bundleSize?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dimensionsUnit: LengthUnit;
  easypostPredefinedPackage?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  length: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  packageImage?: Maybe<Scalars['String']['output']>;
  sortWeight: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  width: Scalars['Float']['output'];
};

export type ShippingPackageCount = {
  __typename?: 'ShippingPackageCount';
  carriers: Scalars['Int']['output'];
  defaultInternationalShippingPackageProducts: Scalars['Int']['output'];
  defaultShippingPackageCarriers: Scalars['Int']['output'];
  defaultShippingPackageProducts: Scalars['Int']['output'];
  defaultShippingPackageUserProducts: Scalars['Int']['output'];
  shipments: Scalars['Int']['output'];
};


export type ShippingPackageCountCarriersArgs = {
  where?: InputMaybe<CarrierWhereInput>;
};


export type ShippingPackageCountDefaultInternationalShippingPackageProductsArgs = {
  where?: InputMaybe<ProductSettingsWhereInput>;
};


export type ShippingPackageCountDefaultShippingPackageCarriersArgs = {
  where?: InputMaybe<CarrierWhereInput>;
};


export type ShippingPackageCountDefaultShippingPackageProductsArgs = {
  where?: InputMaybe<ProductSettingsWhereInput>;
};


export type ShippingPackageCountDefaultShippingPackageUserProductsArgs = {
  where?: InputMaybe<UserProductWhereInput>;
};


export type ShippingPackageCountShipmentsArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShippingPackageCreateNestedManyWithoutCarriersInput = {
  connect?: InputMaybe<Array<ShippingPackageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingPackageCreateOrConnectWithoutCarriersInput>>;
  create?: InputMaybe<Array<ShippingPackageCreateWithoutCarriersInput>>;
};

export type ShippingPackageCreateNestedOneWithoutDefaultInternationalShippingPackageProductsInput = {
  connect?: InputMaybe<ShippingPackageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingPackageCreateOrConnectWithoutDefaultInternationalShippingPackageProductsInput>;
  create?: InputMaybe<ShippingPackageCreateWithoutDefaultInternationalShippingPackageProductsInput>;
};

export type ShippingPackageCreateNestedOneWithoutDefaultShippingPackageCarriersInput = {
  connect?: InputMaybe<ShippingPackageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingPackageCreateOrConnectWithoutDefaultShippingPackageCarriersInput>;
  create?: InputMaybe<ShippingPackageCreateWithoutDefaultShippingPackageCarriersInput>;
};

export type ShippingPackageCreateNestedOneWithoutDefaultShippingPackageProductsInput = {
  connect?: InputMaybe<ShippingPackageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingPackageCreateOrConnectWithoutDefaultShippingPackageProductsInput>;
  create?: InputMaybe<ShippingPackageCreateWithoutDefaultShippingPackageProductsInput>;
};

export type ShippingPackageCreateNestedOneWithoutDefaultShippingPackageUserProductsInput = {
  connect?: InputMaybe<ShippingPackageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingPackageCreateOrConnectWithoutDefaultShippingPackageUserProductsInput>;
  create?: InputMaybe<ShippingPackageCreateWithoutDefaultShippingPackageUserProductsInput>;
};

export type ShippingPackageCreateNestedOneWithoutShipmentsInput = {
  connect?: InputMaybe<ShippingPackageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingPackageCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<ShippingPackageCreateWithoutShipmentsInput>;
};

export type ShippingPackageCreateOrConnectWithoutCarriersInput = {
  create: ShippingPackageCreateWithoutCarriersInput;
  where: ShippingPackageWhereUniqueInput;
};

export type ShippingPackageCreateOrConnectWithoutDefaultInternationalShippingPackageProductsInput = {
  create: ShippingPackageCreateWithoutDefaultInternationalShippingPackageProductsInput;
  where: ShippingPackageWhereUniqueInput;
};

export type ShippingPackageCreateOrConnectWithoutDefaultShippingPackageCarriersInput = {
  create: ShippingPackageCreateWithoutDefaultShippingPackageCarriersInput;
  where: ShippingPackageWhereUniqueInput;
};

export type ShippingPackageCreateOrConnectWithoutDefaultShippingPackageProductsInput = {
  create: ShippingPackageCreateWithoutDefaultShippingPackageProductsInput;
  where: ShippingPackageWhereUniqueInput;
};

export type ShippingPackageCreateOrConnectWithoutDefaultShippingPackageUserProductsInput = {
  create: ShippingPackageCreateWithoutDefaultShippingPackageUserProductsInput;
  where: ShippingPackageWhereUniqueInput;
};

export type ShippingPackageCreateOrConnectWithoutShipmentsInput = {
  create: ShippingPackageCreateWithoutShipmentsInput;
  where: ShippingPackageWhereUniqueInput;
};

export type ShippingPackageCreateWithoutCarriersInput = {
  bundleSize?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsCreateNestedManyWithoutDefaultInternationalShippingPackageInput>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierCreateNestedManyWithoutDefaultShippingPackageInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsCreateNestedManyWithoutDefaultShippingPackageInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductCreateNestedManyWithoutDefaultShippingPackageInput>;
  dimensionsUnit: LengthUnit;
  easypostPredefinedPackage?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  length: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  packageImage?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutShippingPackageInput>;
  sortWeight?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  width: Scalars['Float']['input'];
};

export type ShippingPackageCreateWithoutDefaultInternationalShippingPackageProductsInput = {
  bundleSize?: InputMaybe<Scalars['Int']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutShippingPackagesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierCreateNestedManyWithoutDefaultShippingPackageInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsCreateNestedManyWithoutDefaultShippingPackageInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductCreateNestedManyWithoutDefaultShippingPackageInput>;
  dimensionsUnit: LengthUnit;
  easypostPredefinedPackage?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  length: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  packageImage?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutShippingPackageInput>;
  sortWeight?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  width: Scalars['Float']['input'];
};

export type ShippingPackageCreateWithoutDefaultShippingPackageCarriersInput = {
  bundleSize?: InputMaybe<Scalars['Int']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutShippingPackagesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsCreateNestedManyWithoutDefaultInternationalShippingPackageInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsCreateNestedManyWithoutDefaultShippingPackageInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductCreateNestedManyWithoutDefaultShippingPackageInput>;
  dimensionsUnit: LengthUnit;
  easypostPredefinedPackage?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  length: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  packageImage?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutShippingPackageInput>;
  sortWeight?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  width: Scalars['Float']['input'];
};

export type ShippingPackageCreateWithoutDefaultShippingPackageProductsInput = {
  bundleSize?: InputMaybe<Scalars['Int']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutShippingPackagesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsCreateNestedManyWithoutDefaultInternationalShippingPackageInput>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierCreateNestedManyWithoutDefaultShippingPackageInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductCreateNestedManyWithoutDefaultShippingPackageInput>;
  dimensionsUnit: LengthUnit;
  easypostPredefinedPackage?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  length: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  packageImage?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutShippingPackageInput>;
  sortWeight?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  width: Scalars['Float']['input'];
};

export type ShippingPackageCreateWithoutDefaultShippingPackageUserProductsInput = {
  bundleSize?: InputMaybe<Scalars['Int']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutShippingPackagesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsCreateNestedManyWithoutDefaultInternationalShippingPackageInput>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierCreateNestedManyWithoutDefaultShippingPackageInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsCreateNestedManyWithoutDefaultShippingPackageInput>;
  dimensionsUnit: LengthUnit;
  easypostPredefinedPackage?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  length: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  packageImage?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutShippingPackageInput>;
  sortWeight?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  width: Scalars['Float']['input'];
};

export type ShippingPackageCreateWithoutShipmentsInput = {
  bundleSize?: InputMaybe<Scalars['Int']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutShippingPackagesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsCreateNestedManyWithoutDefaultInternationalShippingPackageInput>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierCreateNestedManyWithoutDefaultShippingPackageInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsCreateNestedManyWithoutDefaultShippingPackageInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductCreateNestedManyWithoutDefaultShippingPackageInput>;
  dimensionsUnit: LengthUnit;
  easypostPredefinedPackage?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  length: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  packageImage?: InputMaybe<Scalars['String']['input']>;
  sortWeight?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  width: Scalars['Float']['input'];
};

export type ShippingPackageListRelationFilter = {
  every?: InputMaybe<ShippingPackageWhereInput>;
  none?: InputMaybe<ShippingPackageWhereInput>;
  some?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageNullableRelationFilter = {
  is?: InputMaybe<ShippingPackageWhereInput>;
  isNot?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShippingPackageOrderByWithRelationInput = {
  bundleSize?: InputMaybe<SortOrderInput>;
  carriers?: InputMaybe<CarrierOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsOrderByRelationAggregateInput>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierOrderByRelationAggregateInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsOrderByRelationAggregateInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductOrderByRelationAggregateInput>;
  dimensionsUnit?: InputMaybe<SortOrder>;
  easypostPredefinedPackage?: InputMaybe<SortOrderInput>;
  height?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDisabled?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  packageImage?: InputMaybe<SortOrderInput>;
  shipments?: InputMaybe<ShipmentOrderByRelationAggregateInput>;
  sortWeight?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type ShippingPackageScalarWhereInput = {
  AND?: InputMaybe<Array<ShippingPackageScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShippingPackageScalarWhereInput>>;
  OR?: InputMaybe<Array<ShippingPackageScalarWhereInput>>;
  bundleSize?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dimensionsUnit?: InputMaybe<EnumLengthUnitFilter>;
  easypostPredefinedPackage?: InputMaybe<StringNullableFilter>;
  height?: InputMaybe<FloatFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  length?: InputMaybe<FloatFilter>;
  name?: InputMaybe<StringFilter>;
  packageImage?: InputMaybe<StringNullableFilter>;
  sortWeight?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  width?: InputMaybe<FloatFilter>;
};

export type ShippingPackageUpdateManyMutationInput = {
  bundleSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dimensionsUnit?: InputMaybe<EnumLengthUnitFieldUpdateOperationsInput>;
  easypostPredefinedPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  length?: InputMaybe<FloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sortWeight?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  width?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShippingPackageUpdateManyWithWhereWithoutCarriersInput = {
  data: ShippingPackageUpdateManyMutationInput;
  where: ShippingPackageScalarWhereInput;
};

export type ShippingPackageUpdateManyWithoutCarriersNestedInput = {
  connect?: InputMaybe<Array<ShippingPackageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingPackageCreateOrConnectWithoutCarriersInput>>;
  create?: InputMaybe<Array<ShippingPackageCreateWithoutCarriersInput>>;
  delete?: InputMaybe<Array<ShippingPackageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShippingPackageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShippingPackageWhereUniqueInput>>;
  set?: InputMaybe<Array<ShippingPackageWhereUniqueInput>>;
  update?: InputMaybe<Array<ShippingPackageUpdateWithWhereUniqueWithoutCarriersInput>>;
  updateMany?: InputMaybe<Array<ShippingPackageUpdateManyWithWhereWithoutCarriersInput>>;
  upsert?: InputMaybe<Array<ShippingPackageUpsertWithWhereUniqueWithoutCarriersInput>>;
};

export type ShippingPackageUpdateOneWithoutDefaultInternationalShippingPackageProductsNestedInput = {
  connect?: InputMaybe<ShippingPackageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingPackageCreateOrConnectWithoutDefaultInternationalShippingPackageProductsInput>;
  create?: InputMaybe<ShippingPackageCreateWithoutDefaultInternationalShippingPackageProductsInput>;
  delete?: InputMaybe<ShippingPackageWhereInput>;
  disconnect?: InputMaybe<ShippingPackageWhereInput>;
  update?: InputMaybe<ShippingPackageUpdateToOneWithWhereWithoutDefaultInternationalShippingPackageProductsInput>;
  upsert?: InputMaybe<ShippingPackageUpsertWithoutDefaultInternationalShippingPackageProductsInput>;
};

export type ShippingPackageUpdateOneWithoutDefaultShippingPackageCarriersNestedInput = {
  connect?: InputMaybe<ShippingPackageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingPackageCreateOrConnectWithoutDefaultShippingPackageCarriersInput>;
  create?: InputMaybe<ShippingPackageCreateWithoutDefaultShippingPackageCarriersInput>;
  delete?: InputMaybe<ShippingPackageWhereInput>;
  disconnect?: InputMaybe<ShippingPackageWhereInput>;
  update?: InputMaybe<ShippingPackageUpdateToOneWithWhereWithoutDefaultShippingPackageCarriersInput>;
  upsert?: InputMaybe<ShippingPackageUpsertWithoutDefaultShippingPackageCarriersInput>;
};

export type ShippingPackageUpdateOneWithoutDefaultShippingPackageProductsNestedInput = {
  connect?: InputMaybe<ShippingPackageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingPackageCreateOrConnectWithoutDefaultShippingPackageProductsInput>;
  create?: InputMaybe<ShippingPackageCreateWithoutDefaultShippingPackageProductsInput>;
  delete?: InputMaybe<ShippingPackageWhereInput>;
  disconnect?: InputMaybe<ShippingPackageWhereInput>;
  update?: InputMaybe<ShippingPackageUpdateToOneWithWhereWithoutDefaultShippingPackageProductsInput>;
  upsert?: InputMaybe<ShippingPackageUpsertWithoutDefaultShippingPackageProductsInput>;
};

export type ShippingPackageUpdateOneWithoutDefaultShippingPackageUserProductsNestedInput = {
  connect?: InputMaybe<ShippingPackageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingPackageCreateOrConnectWithoutDefaultShippingPackageUserProductsInput>;
  create?: InputMaybe<ShippingPackageCreateWithoutDefaultShippingPackageUserProductsInput>;
  delete?: InputMaybe<ShippingPackageWhereInput>;
  disconnect?: InputMaybe<ShippingPackageWhereInput>;
  update?: InputMaybe<ShippingPackageUpdateToOneWithWhereWithoutDefaultShippingPackageUserProductsInput>;
  upsert?: InputMaybe<ShippingPackageUpsertWithoutDefaultShippingPackageUserProductsInput>;
};

export type ShippingPackageUpdateOneWithoutShipmentsNestedInput = {
  connect?: InputMaybe<ShippingPackageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingPackageCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<ShippingPackageCreateWithoutShipmentsInput>;
  delete?: InputMaybe<ShippingPackageWhereInput>;
  disconnect?: InputMaybe<ShippingPackageWhereInput>;
  update?: InputMaybe<ShippingPackageUpdateToOneWithWhereWithoutShipmentsInput>;
  upsert?: InputMaybe<ShippingPackageUpsertWithoutShipmentsInput>;
};

export type ShippingPackageUpdateToOneWithWhereWithoutDefaultInternationalShippingPackageProductsInput = {
  data: ShippingPackageUpdateWithoutDefaultInternationalShippingPackageProductsInput;
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageUpdateToOneWithWhereWithoutDefaultShippingPackageCarriersInput = {
  data: ShippingPackageUpdateWithoutDefaultShippingPackageCarriersInput;
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageUpdateToOneWithWhereWithoutDefaultShippingPackageProductsInput = {
  data: ShippingPackageUpdateWithoutDefaultShippingPackageProductsInput;
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageUpdateToOneWithWhereWithoutDefaultShippingPackageUserProductsInput = {
  data: ShippingPackageUpdateWithoutDefaultShippingPackageUserProductsInput;
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageUpdateToOneWithWhereWithoutShipmentsInput = {
  data: ShippingPackageUpdateWithoutShipmentsInput;
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageUpdateWithWhereUniqueWithoutCarriersInput = {
  data: ShippingPackageUpdateWithoutCarriersInput;
  where: ShippingPackageWhereUniqueInput;
};

export type ShippingPackageUpdateWithoutCarriersInput = {
  bundleSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsUpdateManyWithoutDefaultInternationalShippingPackageNestedInput>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierUpdateManyWithoutDefaultShippingPackageNestedInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsUpdateManyWithoutDefaultShippingPackageNestedInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductUpdateManyWithoutDefaultShippingPackageNestedInput>;
  dimensionsUnit?: InputMaybe<EnumLengthUnitFieldUpdateOperationsInput>;
  easypostPredefinedPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  length?: InputMaybe<FloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutShippingPackageNestedInput>;
  sortWeight?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  width?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShippingPackageUpdateWithoutDefaultInternationalShippingPackageProductsInput = {
  bundleSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutShippingPackagesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierUpdateManyWithoutDefaultShippingPackageNestedInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsUpdateManyWithoutDefaultShippingPackageNestedInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductUpdateManyWithoutDefaultShippingPackageNestedInput>;
  dimensionsUnit?: InputMaybe<EnumLengthUnitFieldUpdateOperationsInput>;
  easypostPredefinedPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  length?: InputMaybe<FloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutShippingPackageNestedInput>;
  sortWeight?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  width?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShippingPackageUpdateWithoutDefaultShippingPackageCarriersInput = {
  bundleSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutShippingPackagesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsUpdateManyWithoutDefaultInternationalShippingPackageNestedInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsUpdateManyWithoutDefaultShippingPackageNestedInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductUpdateManyWithoutDefaultShippingPackageNestedInput>;
  dimensionsUnit?: InputMaybe<EnumLengthUnitFieldUpdateOperationsInput>;
  easypostPredefinedPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  length?: InputMaybe<FloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutShippingPackageNestedInput>;
  sortWeight?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  width?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShippingPackageUpdateWithoutDefaultShippingPackageProductsInput = {
  bundleSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutShippingPackagesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsUpdateManyWithoutDefaultInternationalShippingPackageNestedInput>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierUpdateManyWithoutDefaultShippingPackageNestedInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductUpdateManyWithoutDefaultShippingPackageNestedInput>;
  dimensionsUnit?: InputMaybe<EnumLengthUnitFieldUpdateOperationsInput>;
  easypostPredefinedPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  length?: InputMaybe<FloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutShippingPackageNestedInput>;
  sortWeight?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  width?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShippingPackageUpdateWithoutDefaultShippingPackageUserProductsInput = {
  bundleSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutShippingPackagesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsUpdateManyWithoutDefaultInternationalShippingPackageNestedInput>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierUpdateManyWithoutDefaultShippingPackageNestedInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsUpdateManyWithoutDefaultShippingPackageNestedInput>;
  dimensionsUnit?: InputMaybe<EnumLengthUnitFieldUpdateOperationsInput>;
  easypostPredefinedPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  length?: InputMaybe<FloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutShippingPackageNestedInput>;
  sortWeight?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  width?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShippingPackageUpdateWithoutShipmentsInput = {
  bundleSize?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutShippingPackagesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsUpdateManyWithoutDefaultInternationalShippingPackageNestedInput>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierUpdateManyWithoutDefaultShippingPackageNestedInput>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsUpdateManyWithoutDefaultShippingPackageNestedInput>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductUpdateManyWithoutDefaultShippingPackageNestedInput>;
  dimensionsUnit?: InputMaybe<EnumLengthUnitFieldUpdateOperationsInput>;
  easypostPredefinedPackage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  height?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  length?: InputMaybe<FloatFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packageImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sortWeight?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  width?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ShippingPackageUpsertWithWhereUniqueWithoutCarriersInput = {
  create: ShippingPackageCreateWithoutCarriersInput;
  update: ShippingPackageUpdateWithoutCarriersInput;
  where: ShippingPackageWhereUniqueInput;
};

export type ShippingPackageUpsertWithoutDefaultInternationalShippingPackageProductsInput = {
  create: ShippingPackageCreateWithoutDefaultInternationalShippingPackageProductsInput;
  update: ShippingPackageUpdateWithoutDefaultInternationalShippingPackageProductsInput;
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageUpsertWithoutDefaultShippingPackageCarriersInput = {
  create: ShippingPackageCreateWithoutDefaultShippingPackageCarriersInput;
  update: ShippingPackageUpdateWithoutDefaultShippingPackageCarriersInput;
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageUpsertWithoutDefaultShippingPackageProductsInput = {
  create: ShippingPackageCreateWithoutDefaultShippingPackageProductsInput;
  update: ShippingPackageUpdateWithoutDefaultShippingPackageProductsInput;
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageUpsertWithoutDefaultShippingPackageUserProductsInput = {
  create: ShippingPackageCreateWithoutDefaultShippingPackageUserProductsInput;
  update: ShippingPackageUpdateWithoutDefaultShippingPackageUserProductsInput;
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageUpsertWithoutShipmentsInput = {
  create: ShippingPackageCreateWithoutShipmentsInput;
  update: ShippingPackageUpdateWithoutShipmentsInput;
  where?: InputMaybe<ShippingPackageWhereInput>;
};

export type ShippingPackageWhereInput = {
  AND?: InputMaybe<Array<ShippingPackageWhereInput>>;
  NOT?: InputMaybe<Array<ShippingPackageWhereInput>>;
  OR?: InputMaybe<Array<ShippingPackageWhereInput>>;
  bundleSize?: InputMaybe<IntNullableFilter>;
  carriers?: InputMaybe<CarrierListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsListRelationFilter>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierListRelationFilter>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsListRelationFilter>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductListRelationFilter>;
  dimensionsUnit?: InputMaybe<EnumLengthUnitFilter>;
  easypostPredefinedPackage?: InputMaybe<StringNullableFilter>;
  height?: InputMaybe<FloatFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  length?: InputMaybe<FloatFilter>;
  name?: InputMaybe<StringFilter>;
  packageImage?: InputMaybe<StringNullableFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  sortWeight?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  width?: InputMaybe<FloatFilter>;
};

export type ShippingPackageWhereUniqueInput = {
  AND?: InputMaybe<Array<ShippingPackageWhereInput>>;
  NOT?: InputMaybe<Array<ShippingPackageWhereInput>>;
  OR?: InputMaybe<Array<ShippingPackageWhereInput>>;
  bundleSize?: InputMaybe<IntNullableFilter>;
  carriers?: InputMaybe<CarrierListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultInternationalShippingPackageProducts?: InputMaybe<ProductSettingsListRelationFilter>;
  defaultShippingPackageCarriers?: InputMaybe<CarrierListRelationFilter>;
  defaultShippingPackageProducts?: InputMaybe<ProductSettingsListRelationFilter>;
  defaultShippingPackageUserProducts?: InputMaybe<UserProductListRelationFilter>;
  dimensionsUnit?: InputMaybe<EnumLengthUnitFilter>;
  easypostPredefinedPackage?: InputMaybe<StringNullableFilter>;
  height?: InputMaybe<FloatFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<BoolFilter>;
  length?: InputMaybe<FloatFilter>;
  name?: InputMaybe<StringFilter>;
  packageImage?: InputMaybe<StringNullableFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  sortWeight?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  width?: InputMaybe<FloatFilter>;
};

export type ShopifyStoreActionInput = {
  action: ShopifyStoreActionType;
  storeId: Scalars['String']['input'];
};

export enum ShopifyStoreActionType {
  CheckFulfillmentRequests = 'CHECK_FULFILLMENT_REQUESTS',
  InitFulfillmentService = 'INIT_FULFILLMENT_SERVICE',
  InitWebhooks = 'INIT_WEBHOOKS'
}

export enum SocialNetwork {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Other = 'OTHER',
  Snapchat = 'SNAPCHAT',
  Tiktok = 'TIKTOK',
  Twitch = 'TWITCH'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeCreditNoteCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  kind: StripeCreditNoteKind;
  memo?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  pdf: Scalars['String']['input'];
  reason?: InputMaybe<StripeCreditNoteReason>;
  status: StripeCreditNoteStatus;
  total: Scalars['Int']['input'];
  type: StripeCreditNoteType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StripeCreditNoteCreateManyCreatedByInputEnvelope = {
  data: Array<StripeCreditNoteCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeCreditNoteCreateManyInvoiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  kind: StripeCreditNoteKind;
  memo?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  pdf: Scalars['String']['input'];
  reason?: InputMaybe<StripeCreditNoteReason>;
  status: StripeCreditNoteStatus;
  total: Scalars['Int']['input'];
  type: StripeCreditNoteType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StripeCreditNoteCreateManyInvoiceInputEnvelope = {
  data: Array<StripeCreditNoteCreateManyInvoiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeCreditNoteCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<StripeCreditNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeCreditNoteCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<StripeCreditNoteCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<StripeCreditNoteCreateManyCreatedByInputEnvelope>;
};

export type StripeCreditNoteCreateNestedManyWithoutInvoiceInput = {
  connect?: InputMaybe<Array<StripeCreditNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeCreditNoteCreateOrConnectWithoutInvoiceInput>>;
  create?: InputMaybe<Array<StripeCreditNoteCreateWithoutInvoiceInput>>;
  createMany?: InputMaybe<StripeCreditNoteCreateManyInvoiceInputEnvelope>;
};

export type StripeCreditNoteCreateOrConnectWithoutCreatedByInput = {
  create: StripeCreditNoteCreateWithoutCreatedByInput;
  where: StripeCreditNoteWhereUniqueInput;
};

export type StripeCreditNoteCreateOrConnectWithoutInvoiceInput = {
  create: StripeCreditNoteCreateWithoutInvoiceInput;
  where: StripeCreditNoteWhereUniqueInput;
};

export type StripeCreditNoteCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoice: StripeInvoiceCreateNestedOneWithoutStripeCreditNotesInput;
  kind: StripeCreditNoteKind;
  memo?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  pdf: Scalars['String']['input'];
  reason?: InputMaybe<StripeCreditNoteReason>;
  status: StripeCreditNoteStatus;
  total: Scalars['Int']['input'];
  type: StripeCreditNoteType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StripeCreditNoteCreateWithoutInvoiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<AdminCreateNestedOneWithoutStripeCreditNotesInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  kind: StripeCreditNoteKind;
  memo?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  pdf: Scalars['String']['input'];
  reason?: InputMaybe<StripeCreditNoteReason>;
  status: StripeCreditNoteStatus;
  total: Scalars['Int']['input'];
  type: StripeCreditNoteType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum StripeCreditNoteKind {
  OrderCancellation = 'ORDER_CANCELLATION',
  OrderCancellationRefund = 'ORDER_CANCELLATION_REFUND',
  OrderRefund = 'ORDER_REFUND',
  PartialRefundItemQuantityChanged = 'PARTIAL_REFUND_ITEM_QUANTITY_CHANGED',
  PartialRefundItemRemoved = 'PARTIAL_REFUND_ITEM_REMOVED'
}

export type StripeCreditNoteListRelationFilter = {
  every?: InputMaybe<StripeCreditNoteWhereInput>;
  none?: InputMaybe<StripeCreditNoteWhereInput>;
  some?: InputMaybe<StripeCreditNoteWhereInput>;
};

export type StripeCreditNoteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum StripeCreditNoteReason {
  Duplicate = 'DUPLICATE',
  Fraudulent = 'FRAUDULENT',
  OrderChange = 'ORDER_CHANGE',
  ProductUnsatisfactory = 'PRODUCT_UNSATISFACTORY'
}

export type StripeCreditNoteScalarWhereInput = {
  AND?: InputMaybe<Array<StripeCreditNoteScalarWhereInput>>;
  NOT?: InputMaybe<Array<StripeCreditNoteScalarWhereInput>>;
  OR?: InputMaybe<Array<StripeCreditNoteScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  currency?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  invoiceId?: InputMaybe<StringFilter>;
  kind?: InputMaybe<EnumStripeCreditNoteKindFilter>;
  memo?: InputMaybe<StringNullableFilter>;
  number?: InputMaybe<StringFilter>;
  pdf?: InputMaybe<StringFilter>;
  reason?: InputMaybe<EnumStripeCreditNoteReasonNullableFilter>;
  status?: InputMaybe<EnumStripeCreditNoteStatusFilter>;
  total?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumStripeCreditNoteTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum StripeCreditNoteStatus {
  Issued = 'ISSUED',
  Void = 'VOID'
}

export enum StripeCreditNoteType {
  PostPayment = 'POST_PAYMENT',
  PrePayment = 'PRE_PAYMENT'
}

export type StripeCreditNoteUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumStripeCreditNoteKindFieldUpdateOperationsInput>;
  memo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  pdf?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableEnumStripeCreditNoteReasonFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStripeCreditNoteStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumStripeCreditNoteTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StripeCreditNoteUpdateManyWithWhereWithoutCreatedByInput = {
  data: StripeCreditNoteUpdateManyMutationInput;
  where: StripeCreditNoteScalarWhereInput;
};

export type StripeCreditNoteUpdateManyWithWhereWithoutInvoiceInput = {
  data: StripeCreditNoteUpdateManyMutationInput;
  where: StripeCreditNoteScalarWhereInput;
};

export type StripeCreditNoteUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<StripeCreditNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeCreditNoteCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<StripeCreditNoteCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<StripeCreditNoteCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<StripeCreditNoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StripeCreditNoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StripeCreditNoteWhereUniqueInput>>;
  set?: InputMaybe<Array<StripeCreditNoteWhereUniqueInput>>;
  update?: InputMaybe<Array<StripeCreditNoteUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<StripeCreditNoteUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<StripeCreditNoteUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type StripeCreditNoteUpdateManyWithoutInvoiceNestedInput = {
  connect?: InputMaybe<Array<StripeCreditNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeCreditNoteCreateOrConnectWithoutInvoiceInput>>;
  create?: InputMaybe<Array<StripeCreditNoteCreateWithoutInvoiceInput>>;
  createMany?: InputMaybe<StripeCreditNoteCreateManyInvoiceInputEnvelope>;
  delete?: InputMaybe<Array<StripeCreditNoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StripeCreditNoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StripeCreditNoteWhereUniqueInput>>;
  set?: InputMaybe<Array<StripeCreditNoteWhereUniqueInput>>;
  update?: InputMaybe<Array<StripeCreditNoteUpdateWithWhereUniqueWithoutInvoiceInput>>;
  updateMany?: InputMaybe<Array<StripeCreditNoteUpdateManyWithWhereWithoutInvoiceInput>>;
  upsert?: InputMaybe<Array<StripeCreditNoteUpsertWithWhereUniqueWithoutInvoiceInput>>;
};

export type StripeCreditNoteUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: StripeCreditNoteUpdateWithoutCreatedByInput;
  where: StripeCreditNoteWhereUniqueInput;
};

export type StripeCreditNoteUpdateWithWhereUniqueWithoutInvoiceInput = {
  data: StripeCreditNoteUpdateWithoutInvoiceInput;
  where: StripeCreditNoteWhereUniqueInput;
};

export type StripeCreditNoteUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoice?: InputMaybe<StripeInvoiceUpdateOneRequiredWithoutStripeCreditNotesNestedInput>;
  kind?: InputMaybe<EnumStripeCreditNoteKindFieldUpdateOperationsInput>;
  memo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  pdf?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableEnumStripeCreditNoteReasonFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStripeCreditNoteStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumStripeCreditNoteTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StripeCreditNoteUpdateWithoutInvoiceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneWithoutStripeCreditNotesNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumStripeCreditNoteKindFieldUpdateOperationsInput>;
  memo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  pdf?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableEnumStripeCreditNoteReasonFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStripeCreditNoteStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumStripeCreditNoteTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StripeCreditNoteUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: StripeCreditNoteCreateWithoutCreatedByInput;
  update: StripeCreditNoteUpdateWithoutCreatedByInput;
  where: StripeCreditNoteWhereUniqueInput;
};

export type StripeCreditNoteUpsertWithWhereUniqueWithoutInvoiceInput = {
  create: StripeCreditNoteCreateWithoutInvoiceInput;
  update: StripeCreditNoteUpdateWithoutInvoiceInput;
  where: StripeCreditNoteWhereUniqueInput;
};

export type StripeCreditNoteWhereInput = {
  AND?: InputMaybe<Array<StripeCreditNoteWhereInput>>;
  NOT?: InputMaybe<Array<StripeCreditNoteWhereInput>>;
  OR?: InputMaybe<Array<StripeCreditNoteWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminNullableRelationFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  currency?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  invoice?: InputMaybe<StripeInvoiceRelationFilter>;
  invoiceId?: InputMaybe<StringFilter>;
  kind?: InputMaybe<EnumStripeCreditNoteKindFilter>;
  memo?: InputMaybe<StringNullableFilter>;
  number?: InputMaybe<StringFilter>;
  pdf?: InputMaybe<StringFilter>;
  reason?: InputMaybe<EnumStripeCreditNoteReasonNullableFilter>;
  status?: InputMaybe<EnumStripeCreditNoteStatusFilter>;
  total?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumStripeCreditNoteTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StripeCreditNoteWhereUniqueInput = {
  AND?: InputMaybe<Array<StripeCreditNoteWhereInput>>;
  NOT?: InputMaybe<Array<StripeCreditNoteWhereInput>>;
  OR?: InputMaybe<Array<StripeCreditNoteWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminNullableRelationFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  currency?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<StripeInvoiceRelationFilter>;
  invoiceId?: InputMaybe<StringFilter>;
  kind?: InputMaybe<EnumStripeCreditNoteKindFilter>;
  memo?: InputMaybe<StringNullableFilter>;
  number?: InputMaybe<StringFilter>;
  pdf?: InputMaybe<StringFilter>;
  reason?: InputMaybe<EnumStripeCreditNoteReasonNullableFilter>;
  status?: InputMaybe<EnumStripeCreditNoteStatusFilter>;
  total?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumStripeCreditNoteTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  _count?: Maybe<StripeInvoiceCount>;
  amountDue: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  /** Stripe invoice id */
  id: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  kind: StripeInvoiceKind;
  number?: Maybe<Scalars['String']['output']>;
  postPaymentBillingPeriod?: Maybe<Scalars['String']['output']>;
  servicePurchaseId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StripeInvoiceStatus>;
  total: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  userProductOrderId?: Maybe<Scalars['String']['output']>;
  voidedById?: Maybe<Scalars['String']['output']>;
};

export type StripeInvoiceCount = {
  __typename?: 'StripeInvoiceCount';
  labelTransitions: Scalars['Int']['output'];
  stripeCreditNotes: Scalars['Int']['output'];
};


export type StripeInvoiceCountLabelTransitionsArgs = {
  where?: InputMaybe<LabelTransitionWhereInput>;
};


export type StripeInvoiceCountStripeCreditNotesArgs = {
  where?: InputMaybe<StripeCreditNoteWhereInput>;
};

export type StripeInvoiceCreateManyServicePurchaseInput = {
  amountDue: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoicePdf?: InputMaybe<Scalars['String']['input']>;
  kind: StripeInvoiceKind;
  number?: InputMaybe<Scalars['String']['input']>;
  postPaymentBillingPeriod?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StripeInvoiceStatus>;
  total: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  userProductOrderId?: InputMaybe<Scalars['String']['input']>;
  voidedById?: InputMaybe<Scalars['String']['input']>;
};

export type StripeInvoiceCreateManyServicePurchaseInputEnvelope = {
  data: Array<StripeInvoiceCreateManyServicePurchaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeInvoiceCreateManyUserInput = {
  amountDue: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoicePdf?: InputMaybe<Scalars['String']['input']>;
  kind: StripeInvoiceKind;
  number?: InputMaybe<Scalars['String']['input']>;
  postPaymentBillingPeriod?: InputMaybe<Scalars['String']['input']>;
  servicePurchaseId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StripeInvoiceStatus>;
  total: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrderId?: InputMaybe<Scalars['String']['input']>;
  voidedById?: InputMaybe<Scalars['String']['input']>;
};

export type StripeInvoiceCreateManyUserInputEnvelope = {
  data: Array<StripeInvoiceCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeInvoiceCreateManyUserProductOrderInput = {
  amountDue: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoicePdf?: InputMaybe<Scalars['String']['input']>;
  kind: StripeInvoiceKind;
  number?: InputMaybe<Scalars['String']['input']>;
  postPaymentBillingPeriod?: InputMaybe<Scalars['String']['input']>;
  servicePurchaseId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StripeInvoiceStatus>;
  total: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  voidedById?: InputMaybe<Scalars['String']['input']>;
};

export type StripeInvoiceCreateManyUserProductOrderInputEnvelope = {
  data: Array<StripeInvoiceCreateManyUserProductOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeInvoiceCreateManyVoidedByInput = {
  amountDue: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoicePdf?: InputMaybe<Scalars['String']['input']>;
  kind: StripeInvoiceKind;
  number?: InputMaybe<Scalars['String']['input']>;
  postPaymentBillingPeriod?: InputMaybe<Scalars['String']['input']>;
  servicePurchaseId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StripeInvoiceStatus>;
  total: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  userProductOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type StripeInvoiceCreateManyVoidedByInputEnvelope = {
  data: Array<StripeInvoiceCreateManyVoidedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeInvoiceCreateNestedManyWithoutServicePurchaseInput = {
  connect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeInvoiceCreateOrConnectWithoutServicePurchaseInput>>;
  create?: InputMaybe<Array<StripeInvoiceCreateWithoutServicePurchaseInput>>;
  createMany?: InputMaybe<StripeInvoiceCreateManyServicePurchaseInputEnvelope>;
};

export type StripeInvoiceCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeInvoiceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<StripeInvoiceCreateWithoutUserInput>>;
  createMany?: InputMaybe<StripeInvoiceCreateManyUserInputEnvelope>;
};

export type StripeInvoiceCreateNestedManyWithoutUserProductOrderInput = {
  connect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeInvoiceCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<StripeInvoiceCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<StripeInvoiceCreateManyUserProductOrderInputEnvelope>;
};

export type StripeInvoiceCreateNestedManyWithoutVoidedByInput = {
  connect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeInvoiceCreateOrConnectWithoutVoidedByInput>>;
  create?: InputMaybe<Array<StripeInvoiceCreateWithoutVoidedByInput>>;
  createMany?: InputMaybe<StripeInvoiceCreateManyVoidedByInputEnvelope>;
};

export type StripeInvoiceCreateNestedOneWithoutStripeCreditNotesInput = {
  connect?: InputMaybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StripeInvoiceCreateOrConnectWithoutStripeCreditNotesInput>;
  create?: InputMaybe<StripeInvoiceCreateWithoutStripeCreditNotesInput>;
};

export type StripeInvoiceCreateOrConnectWithoutServicePurchaseInput = {
  create: StripeInvoiceCreateWithoutServicePurchaseInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutStripeCreditNotesInput = {
  create: StripeInvoiceCreateWithoutStripeCreditNotesInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutUserInput = {
  create: StripeInvoiceCreateWithoutUserInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutUserProductOrderInput = {
  create: StripeInvoiceCreateWithoutUserProductOrderInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateOrConnectWithoutVoidedByInput = {
  create: StripeInvoiceCreateWithoutVoidedByInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceCreateWithoutServicePurchaseInput = {
  amountDue: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoicePdf?: InputMaybe<Scalars['String']['input']>;
  kind: StripeInvoiceKind;
  labelTransitions?: InputMaybe<LabelTransitionCreateNestedManyWithoutStripeInvoiceInput>;
  number?: InputMaybe<Scalars['String']['input']>;
  postPaymentBillingPeriod?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StripeInvoiceStatus>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutInvoiceInput>;
  total: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutStripeInvoicesInput;
  userProductOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutStripeInvoicesInput>;
  voidedBy?: InputMaybe<AdminCreateNestedOneWithoutVoidedInvoicesInput>;
};

export type StripeInvoiceCreateWithoutStripeCreditNotesInput = {
  amountDue: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoicePdf?: InputMaybe<Scalars['String']['input']>;
  kind: StripeInvoiceKind;
  labelTransitions?: InputMaybe<LabelTransitionCreateNestedManyWithoutStripeInvoiceInput>;
  number?: InputMaybe<Scalars['String']['input']>;
  postPaymentBillingPeriod?: InputMaybe<Scalars['String']['input']>;
  servicePurchase?: InputMaybe<ServicePurchaseCreateNestedOneWithoutStripeInvoicesInput>;
  status?: InputMaybe<StripeInvoiceStatus>;
  total: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutStripeInvoicesInput;
  userProductOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutStripeInvoicesInput>;
  voidedBy?: InputMaybe<AdminCreateNestedOneWithoutVoidedInvoicesInput>;
};

export type StripeInvoiceCreateWithoutUserInput = {
  amountDue: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoicePdf?: InputMaybe<Scalars['String']['input']>;
  kind: StripeInvoiceKind;
  labelTransitions?: InputMaybe<LabelTransitionCreateNestedManyWithoutStripeInvoiceInput>;
  number?: InputMaybe<Scalars['String']['input']>;
  postPaymentBillingPeriod?: InputMaybe<Scalars['String']['input']>;
  servicePurchase?: InputMaybe<ServicePurchaseCreateNestedOneWithoutStripeInvoicesInput>;
  status?: InputMaybe<StripeInvoiceStatus>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutInvoiceInput>;
  total: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutStripeInvoicesInput>;
  voidedBy?: InputMaybe<AdminCreateNestedOneWithoutVoidedInvoicesInput>;
};

export type StripeInvoiceCreateWithoutUserProductOrderInput = {
  amountDue: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoicePdf?: InputMaybe<Scalars['String']['input']>;
  kind: StripeInvoiceKind;
  labelTransitions?: InputMaybe<LabelTransitionCreateNestedManyWithoutStripeInvoiceInput>;
  number?: InputMaybe<Scalars['String']['input']>;
  postPaymentBillingPeriod?: InputMaybe<Scalars['String']['input']>;
  servicePurchase?: InputMaybe<ServicePurchaseCreateNestedOneWithoutStripeInvoicesInput>;
  status?: InputMaybe<StripeInvoiceStatus>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutInvoiceInput>;
  total: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutStripeInvoicesInput;
  voidedBy?: InputMaybe<AdminCreateNestedOneWithoutVoidedInvoicesInput>;
};

export type StripeInvoiceCreateWithoutVoidedByInput = {
  amountDue: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hostedInvoiceUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoicePdf?: InputMaybe<Scalars['String']['input']>;
  kind: StripeInvoiceKind;
  labelTransitions?: InputMaybe<LabelTransitionCreateNestedManyWithoutStripeInvoiceInput>;
  number?: InputMaybe<Scalars['String']['input']>;
  postPaymentBillingPeriod?: InputMaybe<Scalars['String']['input']>;
  servicePurchase?: InputMaybe<ServicePurchaseCreateNestedOneWithoutStripeInvoicesInput>;
  status?: InputMaybe<StripeInvoiceStatus>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteCreateNestedManyWithoutInvoiceInput>;
  total: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutStripeInvoicesInput;
  userProductOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutStripeInvoicesInput>;
};

export enum StripeInvoiceKind {
  DigitalService = 'DIGITAL_SERVICE',
  LabelDesignUpgrade = 'LABEL_DESIGN_UPGRADE',
  Order = 'ORDER',
  OrderReshipment = 'ORDER_RESHIPMENT',
  Subscription = 'SUBSCRIPTION'
}

export type StripeInvoiceListRelationFilter = {
  every?: InputMaybe<StripeInvoiceWhereInput>;
  none?: InputMaybe<StripeInvoiceWhereInput>;
  some?: InputMaybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StripeInvoiceOrderByWithRelationInput = {
  amountDue?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrderInput>;
  hostedInvoiceUrl?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  invoicePdf?: InputMaybe<SortOrderInput>;
  kind?: InputMaybe<SortOrder>;
  labelTransitions?: InputMaybe<LabelTransitionOrderByRelationAggregateInput>;
  number?: InputMaybe<SortOrderInput>;
  postPaymentBillingPeriod?: InputMaybe<SortOrderInput>;
  servicePurchase?: InputMaybe<ServicePurchaseOrderByWithRelationInput>;
  servicePurchaseId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteOrderByRelationAggregateInput>;
  total?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  userProductOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  userProductOrderId?: InputMaybe<SortOrderInput>;
  voidedBy?: InputMaybe<AdminOrderByWithRelationInput>;
  voidedById?: InputMaybe<SortOrderInput>;
};

export type StripeInvoiceRelationFilter = {
  is?: InputMaybe<StripeInvoiceWhereInput>;
  isNot?: InputMaybe<StripeInvoiceWhereInput>;
};

export enum StripeInvoiceScalarFieldEnum {
  AmountDue = 'amountDue',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  DueDate = 'dueDate',
  HostedInvoiceUrl = 'hostedInvoiceUrl',
  Id = 'id',
  InvoicePdf = 'invoicePdf',
  Kind = 'kind',
  Number = 'number',
  PostPaymentBillingPeriod = 'postPaymentBillingPeriod',
  ServicePurchaseId = 'servicePurchaseId',
  Status = 'status',
  Total = 'total',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  UserProductOrderId = 'userProductOrderId',
  VoidedById = 'voidedById'
}

export type StripeInvoiceScalarWhereInput = {
  AND?: InputMaybe<Array<StripeInvoiceScalarWhereInput>>;
  NOT?: InputMaybe<Array<StripeInvoiceScalarWhereInput>>;
  OR?: InputMaybe<Array<StripeInvoiceScalarWhereInput>>;
  amountDue?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateTimeNullableFilter>;
  hostedInvoiceUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invoicePdf?: InputMaybe<StringNullableFilter>;
  kind?: InputMaybe<EnumStripeInvoiceKindFilter>;
  number?: InputMaybe<StringNullableFilter>;
  postPaymentBillingPeriod?: InputMaybe<StringNullableFilter>;
  servicePurchaseId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumStripeInvoiceStatusNullableFilter>;
  total?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProductOrderId?: InputMaybe<UuidNullableFilter>;
  voidedById?: InputMaybe<UuidNullableFilter>;
};

export enum StripeInvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export type StripeInvoiceUpdateManyMutationInput = {
  amountDue?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hostedInvoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoicePdf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumStripeInvoiceKindFieldUpdateOperationsInput>;
  number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBillingPeriod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumStripeInvoiceStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StripeInvoiceUpdateManyWithWhereWithoutServicePurchaseInput = {
  data: StripeInvoiceUpdateManyMutationInput;
  where: StripeInvoiceScalarWhereInput;
};

export type StripeInvoiceUpdateManyWithWhereWithoutUserInput = {
  data: StripeInvoiceUpdateManyMutationInput;
  where: StripeInvoiceScalarWhereInput;
};

export type StripeInvoiceUpdateManyWithWhereWithoutUserProductOrderInput = {
  data: StripeInvoiceUpdateManyMutationInput;
  where: StripeInvoiceScalarWhereInput;
};

export type StripeInvoiceUpdateManyWithWhereWithoutVoidedByInput = {
  data: StripeInvoiceUpdateManyMutationInput;
  where: StripeInvoiceScalarWhereInput;
};

export type StripeInvoiceUpdateManyWithoutServicePurchaseNestedInput = {
  connect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeInvoiceCreateOrConnectWithoutServicePurchaseInput>>;
  create?: InputMaybe<Array<StripeInvoiceCreateWithoutServicePurchaseInput>>;
  createMany?: InputMaybe<StripeInvoiceCreateManyServicePurchaseInputEnvelope>;
  delete?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StripeInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<StripeInvoiceUpdateWithWhereUniqueWithoutServicePurchaseInput>>;
  updateMany?: InputMaybe<Array<StripeInvoiceUpdateManyWithWhereWithoutServicePurchaseInput>>;
  upsert?: InputMaybe<Array<StripeInvoiceUpsertWithWhereUniqueWithoutServicePurchaseInput>>;
};

export type StripeInvoiceUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeInvoiceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<StripeInvoiceCreateWithoutUserInput>>;
  createMany?: InputMaybe<StripeInvoiceCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StripeInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<StripeInvoiceUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<StripeInvoiceUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<StripeInvoiceUpsertWithWhereUniqueWithoutUserInput>>;
};

export type StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput = {
  connect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeInvoiceCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<StripeInvoiceCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<StripeInvoiceCreateManyUserProductOrderInputEnvelope>;
  delete?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StripeInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<StripeInvoiceUpdateWithWhereUniqueWithoutUserProductOrderInput>>;
  updateMany?: InputMaybe<Array<StripeInvoiceUpdateManyWithWhereWithoutUserProductOrderInput>>;
  upsert?: InputMaybe<Array<StripeInvoiceUpsertWithWhereUniqueWithoutUserProductOrderInput>>;
};

export type StripeInvoiceUpdateManyWithoutVoidedByNestedInput = {
  connect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripeInvoiceCreateOrConnectWithoutVoidedByInput>>;
  create?: InputMaybe<Array<StripeInvoiceCreateWithoutVoidedByInput>>;
  createMany?: InputMaybe<StripeInvoiceCreateManyVoidedByInputEnvelope>;
  delete?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StripeInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<StripeInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<StripeInvoiceUpdateWithWhereUniqueWithoutVoidedByInput>>;
  updateMany?: InputMaybe<Array<StripeInvoiceUpdateManyWithWhereWithoutVoidedByInput>>;
  upsert?: InputMaybe<Array<StripeInvoiceUpsertWithWhereUniqueWithoutVoidedByInput>>;
};

export type StripeInvoiceUpdateOneRequiredWithoutStripeCreditNotesNestedInput = {
  connect?: InputMaybe<StripeInvoiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StripeInvoiceCreateOrConnectWithoutStripeCreditNotesInput>;
  create?: InputMaybe<StripeInvoiceCreateWithoutStripeCreditNotesInput>;
  update?: InputMaybe<StripeInvoiceUpdateToOneWithWhereWithoutStripeCreditNotesInput>;
  upsert?: InputMaybe<StripeInvoiceUpsertWithoutStripeCreditNotesInput>;
};

export type StripeInvoiceUpdateToOneWithWhereWithoutStripeCreditNotesInput = {
  data: StripeInvoiceUpdateWithoutStripeCreditNotesInput;
  where?: InputMaybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceUpdateWithWhereUniqueWithoutServicePurchaseInput = {
  data: StripeInvoiceUpdateWithoutServicePurchaseInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpdateWithWhereUniqueWithoutUserInput = {
  data: StripeInvoiceUpdateWithoutUserInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpdateWithWhereUniqueWithoutUserProductOrderInput = {
  data: StripeInvoiceUpdateWithoutUserProductOrderInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpdateWithWhereUniqueWithoutVoidedByInput = {
  data: StripeInvoiceUpdateWithoutVoidedByInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpdateWithoutServicePurchaseInput = {
  amountDue?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hostedInvoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoicePdf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumStripeInvoiceKindFieldUpdateOperationsInput>;
  labelTransitions?: InputMaybe<LabelTransitionUpdateManyWithoutStripeInvoiceNestedInput>;
  number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBillingPeriod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumStripeInvoiceStatusFieldUpdateOperationsInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutInvoiceNestedInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutStripeInvoicesNestedInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneWithoutStripeInvoicesNestedInput>;
  voidedBy?: InputMaybe<AdminUpdateOneWithoutVoidedInvoicesNestedInput>;
};

export type StripeInvoiceUpdateWithoutStripeCreditNotesInput = {
  amountDue?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hostedInvoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoicePdf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumStripeInvoiceKindFieldUpdateOperationsInput>;
  labelTransitions?: InputMaybe<LabelTransitionUpdateManyWithoutStripeInvoiceNestedInput>;
  number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBillingPeriod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchase?: InputMaybe<ServicePurchaseUpdateOneWithoutStripeInvoicesNestedInput>;
  status?: InputMaybe<NullableEnumStripeInvoiceStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutStripeInvoicesNestedInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneWithoutStripeInvoicesNestedInput>;
  voidedBy?: InputMaybe<AdminUpdateOneWithoutVoidedInvoicesNestedInput>;
};

export type StripeInvoiceUpdateWithoutUserInput = {
  amountDue?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hostedInvoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoicePdf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumStripeInvoiceKindFieldUpdateOperationsInput>;
  labelTransitions?: InputMaybe<LabelTransitionUpdateManyWithoutStripeInvoiceNestedInput>;
  number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBillingPeriod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchase?: InputMaybe<ServicePurchaseUpdateOneWithoutStripeInvoicesNestedInput>;
  status?: InputMaybe<NullableEnumStripeInvoiceStatusFieldUpdateOperationsInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutInvoiceNestedInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneWithoutStripeInvoicesNestedInput>;
  voidedBy?: InputMaybe<AdminUpdateOneWithoutVoidedInvoicesNestedInput>;
};

export type StripeInvoiceUpdateWithoutUserProductOrderInput = {
  amountDue?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hostedInvoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoicePdf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumStripeInvoiceKindFieldUpdateOperationsInput>;
  labelTransitions?: InputMaybe<LabelTransitionUpdateManyWithoutStripeInvoiceNestedInput>;
  number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBillingPeriod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchase?: InputMaybe<ServicePurchaseUpdateOneWithoutStripeInvoicesNestedInput>;
  status?: InputMaybe<NullableEnumStripeInvoiceStatusFieldUpdateOperationsInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutInvoiceNestedInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutStripeInvoicesNestedInput>;
  voidedBy?: InputMaybe<AdminUpdateOneWithoutVoidedInvoicesNestedInput>;
};

export type StripeInvoiceUpdateWithoutVoidedByInput = {
  amountDue?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hostedInvoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoicePdf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumStripeInvoiceKindFieldUpdateOperationsInput>;
  labelTransitions?: InputMaybe<LabelTransitionUpdateManyWithoutStripeInvoiceNestedInput>;
  number?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBillingPeriod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchase?: InputMaybe<ServicePurchaseUpdateOneWithoutStripeInvoicesNestedInput>;
  status?: InputMaybe<NullableEnumStripeInvoiceStatusFieldUpdateOperationsInput>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteUpdateManyWithoutInvoiceNestedInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutStripeInvoicesNestedInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneWithoutStripeInvoicesNestedInput>;
};

export type StripeInvoiceUpsertWithWhereUniqueWithoutServicePurchaseInput = {
  create: StripeInvoiceCreateWithoutServicePurchaseInput;
  update: StripeInvoiceUpdateWithoutServicePurchaseInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpsertWithWhereUniqueWithoutUserInput = {
  create: StripeInvoiceCreateWithoutUserInput;
  update: StripeInvoiceUpdateWithoutUserInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpsertWithWhereUniqueWithoutUserProductOrderInput = {
  create: StripeInvoiceCreateWithoutUserProductOrderInput;
  update: StripeInvoiceUpdateWithoutUserProductOrderInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpsertWithWhereUniqueWithoutVoidedByInput = {
  create: StripeInvoiceCreateWithoutVoidedByInput;
  update: StripeInvoiceUpdateWithoutVoidedByInput;
  where: StripeInvoiceWhereUniqueInput;
};

export type StripeInvoiceUpsertWithoutStripeCreditNotesInput = {
  create: StripeInvoiceCreateWithoutStripeCreditNotesInput;
  update: StripeInvoiceUpdateWithoutStripeCreditNotesInput;
  where?: InputMaybe<StripeInvoiceWhereInput>;
};

export type StripeInvoiceWhereInput = {
  AND?: InputMaybe<Array<StripeInvoiceWhereInput>>;
  NOT?: InputMaybe<Array<StripeInvoiceWhereInput>>;
  OR?: InputMaybe<Array<StripeInvoiceWhereInput>>;
  amountDue?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateTimeNullableFilter>;
  hostedInvoiceUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invoicePdf?: InputMaybe<StringNullableFilter>;
  kind?: InputMaybe<EnumStripeInvoiceKindFilter>;
  labelTransitions?: InputMaybe<LabelTransitionListRelationFilter>;
  number?: InputMaybe<StringNullableFilter>;
  postPaymentBillingPeriod?: InputMaybe<StringNullableFilter>;
  servicePurchase?: InputMaybe<ServicePurchaseNullableRelationFilter>;
  servicePurchaseId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumStripeInvoiceStatusNullableFilter>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteListRelationFilter>;
  total?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProductOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  userProductOrderId?: InputMaybe<UuidNullableFilter>;
  voidedBy?: InputMaybe<AdminNullableRelationFilter>;
  voidedById?: InputMaybe<UuidNullableFilter>;
};

export type StripeInvoiceWhereUniqueInput = {
  AND?: InputMaybe<Array<StripeInvoiceWhereInput>>;
  NOT?: InputMaybe<Array<StripeInvoiceWhereInput>>;
  OR?: InputMaybe<Array<StripeInvoiceWhereInput>>;
  amountDue?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  dueDate?: InputMaybe<DateTimeNullableFilter>;
  hostedInvoiceUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoicePdf?: InputMaybe<StringNullableFilter>;
  kind?: InputMaybe<EnumStripeInvoiceKindFilter>;
  labelTransitions?: InputMaybe<LabelTransitionListRelationFilter>;
  number?: InputMaybe<StringNullableFilter>;
  postPaymentBillingPeriod?: InputMaybe<StringNullableFilter>;
  servicePurchase?: InputMaybe<ServicePurchaseNullableRelationFilter>;
  servicePurchaseId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumStripeInvoiceStatusNullableFilter>;
  stripeCreditNotes?: InputMaybe<StripeCreditNoteListRelationFilter>;
  total?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProductOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  userProductOrderId?: InputMaybe<UuidNullableFilter>;
  voidedBy?: InputMaybe<AdminNullableRelationFilter>;
  voidedById?: InputMaybe<UuidNullableFilter>;
};

export type StripePostPaymentStatementCreateManyUserInput = {
  amountPaid?: InputMaybe<Scalars['Int']['input']>;
  billingPeriod: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  totalAmountDue: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StripePostPaymentStatementCreateManyUserInputEnvelope = {
  data: Array<StripePostPaymentStatementCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripePostPaymentStatementCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<StripePostPaymentStatementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripePostPaymentStatementCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<StripePostPaymentStatementCreateWithoutUserInput>>;
  createMany?: InputMaybe<StripePostPaymentStatementCreateManyUserInputEnvelope>;
};

export type StripePostPaymentStatementCreateOrConnectWithoutUserInput = {
  create: StripePostPaymentStatementCreateWithoutUserInput;
  where: StripePostPaymentStatementWhereUniqueInput;
};

export type StripePostPaymentStatementCreateWithoutUserInput = {
  amountPaid?: InputMaybe<Scalars['Int']['input']>;
  billingPeriod: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  totalAmountDue: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StripePostPaymentStatementListRelationFilter = {
  every?: InputMaybe<StripePostPaymentStatementWhereInput>;
  none?: InputMaybe<StripePostPaymentStatementWhereInput>;
  some?: InputMaybe<StripePostPaymentStatementWhereInput>;
};

export type StripePostPaymentStatementOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StripePostPaymentStatementScalarWhereInput = {
  AND?: InputMaybe<Array<StripePostPaymentStatementScalarWhereInput>>;
  NOT?: InputMaybe<Array<StripePostPaymentStatementScalarWhereInput>>;
  OR?: InputMaybe<Array<StripePostPaymentStatementScalarWhereInput>>;
  amountPaid?: InputMaybe<IntFilter>;
  billingPeriod?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  totalAmountDue?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type StripePostPaymentStatementUpdateManyMutationInput = {
  amountPaid?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingPeriod?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalAmountDue?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StripePostPaymentStatementUpdateManyWithWhereWithoutUserInput = {
  data: StripePostPaymentStatementUpdateManyMutationInput;
  where: StripePostPaymentStatementScalarWhereInput;
};

export type StripePostPaymentStatementUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<StripePostPaymentStatementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StripePostPaymentStatementCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<StripePostPaymentStatementCreateWithoutUserInput>>;
  createMany?: InputMaybe<StripePostPaymentStatementCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<StripePostPaymentStatementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StripePostPaymentStatementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StripePostPaymentStatementWhereUniqueInput>>;
  set?: InputMaybe<Array<StripePostPaymentStatementWhereUniqueInput>>;
  update?: InputMaybe<Array<StripePostPaymentStatementUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<StripePostPaymentStatementUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<StripePostPaymentStatementUpsertWithWhereUniqueWithoutUserInput>>;
};

export type StripePostPaymentStatementUpdateWithWhereUniqueWithoutUserInput = {
  data: StripePostPaymentStatementUpdateWithoutUserInput;
  where: StripePostPaymentStatementWhereUniqueInput;
};

export type StripePostPaymentStatementUpdateWithoutUserInput = {
  amountPaid?: InputMaybe<IntFieldUpdateOperationsInput>;
  billingPeriod?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalAmountDue?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StripePostPaymentStatementUpsertWithWhereUniqueWithoutUserInput = {
  create: StripePostPaymentStatementCreateWithoutUserInput;
  update: StripePostPaymentStatementUpdateWithoutUserInput;
  where: StripePostPaymentStatementWhereUniqueInput;
};

export type StripePostPaymentStatementUserIdBillingPeriodCompoundUniqueInput = {
  billingPeriod: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type StripePostPaymentStatementWhereInput = {
  AND?: InputMaybe<Array<StripePostPaymentStatementWhereInput>>;
  NOT?: InputMaybe<Array<StripePostPaymentStatementWhereInput>>;
  OR?: InputMaybe<Array<StripePostPaymentStatementWhereInput>>;
  amountPaid?: InputMaybe<IntFilter>;
  billingPeriod?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  totalAmountDue?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type StripePostPaymentStatementWhereUniqueInput = {
  AND?: InputMaybe<Array<StripePostPaymentStatementWhereInput>>;
  NOT?: InputMaybe<Array<StripePostPaymentStatementWhereInput>>;
  OR?: InputMaybe<Array<StripePostPaymentStatementWhereInput>>;
  amountPaid?: InputMaybe<IntFilter>;
  billingPeriod?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  totalAmountDue?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userId_billingPeriod?: InputMaybe<StripePostPaymentStatementUserIdBillingPeriodCompoundUniqueInput>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  active: Scalars['Boolean']['output'];
  created: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  images: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updated: Scalars['Float']['output'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum TransactionMethod {
  CreditCard = 'CREDIT_CARD',
  Shopify = 'SHOPIFY',
  UserCredits = 'USER_CREDITS'
}

export enum TransactionType {
  All = 'All',
  BalanceDeduction = 'BalanceDeduction',
  BalanceTopup = 'BalanceTopup',
  DigitalProducts = 'DigitalProducts',
  OrderCancellation = 'OrderCancellation',
  OrderPayment = 'OrderPayment',
  OrderRefund = 'OrderRefund',
  Other = 'Other',
  PartialRefund = 'PartialRefund',
  SubscriptionCreation = 'SubscriptionCreation',
  SubscriptionRenewal = 'SubscriptionRenewal',
  SubscriptionUpdate = 'SubscriptionUpdate'
}

export enum UnprepareReason {
  CancelOrder = 'CANCEL_ORDER',
  LabelingError = 'LABELING_ERROR',
  PrintingError = 'PRINTING_ERROR',
  ProductMia = 'PRODUCT_MIA'
}

export type UpdateCustomHoldReasonInput = {
  id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  resolved: Scalars['Boolean']['input'];
};

export type UpdateProductRestockDateInput = {
  holdOrders: Scalars['Boolean']['input'];
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  restockDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Float']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Float']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Float']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Float']['input']>;
  vip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWarehouseShelfInput = {
  /** Bin count on a shelf */
  binCount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  returnBins?: InputMaybe<WarehouseShelfReturnBinUpdateManyWithoutWarehouseShelfNestedInput>;
  type?: InputMaybe<EnumWarehouseShelfTypeFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutShelvesNestedInput>;
};

export type User = {
  __typename?: 'User';
  _count?: Maybe<UserCount>;
  avatar?: Maybe<Scalars['String']['output']>;
  becameActiveAt?: Maybe<Scalars['DateTime']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  billingAddress1?: Maybe<Scalars['String']['output']>;
  billingAddress2?: Maybe<Scalars['String']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  billingState?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  bulkOrderPaymentKind: UserProductOrderManualPaymentKind;
  bulkOrderPostPaymentDueDateDays?: Maybe<Scalars['Int']['output']>;
  bulkOrderPostPaymentDueDateDaysType?: Maybe<UserPostPaymentDueDateDaysType>;
  completedOnboardingSteps: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  eoriNumber?: Maybe<Scalars['String']['output']>;
  exemptEmailVerified: Scalars['Boolean']['output'];
  exemptaxCustomerId?: Maybe<Scalars['Int']['output']>;
  /** @ignored Temporary flag to distinguish users who got extended free trial on freemium init */
  extendedFreeTrialGrantedOnInit: Scalars['Boolean']['output'];
  fbaPaymentKind: UserProductOrderManualPaymentKind;
  fbaPostPaymentDueDateDays?: Maybe<Scalars['Int']['output']>;
  fbaPostPaymentDueDateDaysType?: Maybe<UserPostPaymentDueDateDaysType>;
  firstSessionCampaign?: Maybe<Scalars['String']['output']>;
  firstSessionCreative?: Maybe<Scalars['String']['output']>;
  firstSessionDevice?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lastSession* fields for click IDs */
  firstSessionGclid?: Maybe<Scalars['String']['output']>;
  firstSessionKeyword?: Maybe<Scalars['String']['output']>;
  firstSessionMedium?: Maybe<Scalars['String']['output']>;
  firstSessionQueryParams?: Maybe<Scalars['JSON']['output']>;
  firstSessionSet?: Maybe<Scalars['String']['output']>;
  firstSessionSource?: Maybe<Scalars['String']['output']>;
  firstSessionSourceMedium?: Maybe<Scalars['String']['output']>;
  firstSessionType?: Maybe<Scalars['String']['output']>;
  firstSessionUrl?: Maybe<Scalars['String']['output']>;
  /** @ignored */
  freeTrialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  fullName: Scalars['String']['output'];
  hasCompletedOnboardingSteps: Scalars['Boolean']['output'];
  hasCompletedOnboardingStepsAt?: Maybe<Scalars['DateTime']['output']>;
  hasPublishedFirstProduct: Scalars['Boolean']['output'];
  /** @ignored */
  hasSeenFreeTrialEndedModal: Scalars['Boolean']['output'];
  /** @ignored */
  hasSeenFreeTrialStartedModal: Scalars['Boolean']['output'];
  hasSeenWelcomeModalAt?: Maybe<Scalars['DateTime']['output']>;
  hubspotContactId?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  intercomId?: Maybe<Scalars['String']['output']>;
  invoiceEmails: Array<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isBrandAcceleratorParticipant: Scalars['Boolean']['output'];
  isDeactivated: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isPostPaymentEnabled: Scalars['Boolean']['output'];
  isPriorityLaneFulfillment: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  /** Meta _fbc cookie set by the base Pixel (preferred over a synthesized fbc) */
  lastSessionFbc?: Maybe<Scalars['String']['output']>;
  lastSessionFbclid?: Maybe<Scalars['String']['output']>;
  lastSessionFbclidUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Meta _fbp browser-id cookie set by the base Pixel */
  lastSessionFbp?: Maybe<Scalars['String']['output']>;
  lastSessionGbraid?: Maybe<Scalars['String']['output']>;
  /** Last-session ad click IDs — overwritten on every new ad click */
  lastSessionGclid?: Maybe<Scalars['String']['output']>;
  /** Client IP at capture time — feeds Meta CAPI client_ip_address */
  lastSessionIp?: Maybe<Scalars['String']['output']>;
  /** Full landing URL of the last ad touch — feeds Meta CAPI event_source_url */
  lastSessionLandingUrl?: Maybe<Scalars['String']['output']>;
  lastSessionLiFatId?: Maybe<Scalars['String']['output']>;
  lastSessionRdtCid?: Maybe<Scalars['String']['output']>;
  lastSessionUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Client user agent at capture time — feeds Meta CAPI client_user_agent */
  lastSessionUserAgent?: Maybe<Scalars['String']['output']>;
  lastSessionWbraid?: Maybe<Scalars['String']['output']>;
  leadGenerated?: Maybe<Scalars['Boolean']['output']>;
  onboardingSurveyDone: Scalars['Boolean']['output'];
  onboardingSurveyDoneAt?: Maybe<Scalars['DateTime']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postPaymentDueDateDays: Scalars['Int']['output'];
  postPaymentDueDateDaysType: UserPostPaymentDueDateDaysType;
  postPaymentPeriodWeeks: Scalars['Int']['output'];
  preventEmailNotifications: Array<NotificationReason>;
  preventShopifyUpdateOnPrintfileChange?: Maybe<Scalars['Boolean']['output']>;
  primaryPaymentSuplifulCredits: Scalars['Boolean']['output'];
  referral?: Maybe<Scalars['String']['output']>;
  regNumber?: Maybe<Scalars['String']['output']>;
  resetShopifyStockOnSellout: Scalars['Boolean']['output'];
  returnAddress1?: Maybe<Scalars['String']['output']>;
  returnAddress2?: Maybe<Scalars['String']['output']>;
  returnCity?: Maybe<Scalars['String']['output']>;
  returnCompany?: Maybe<Scalars['String']['output']>;
  returnCountry?: Maybe<Scalars['String']['output']>;
  returnPhone?: Maybe<Scalars['String']['output']>;
  returnState?: Maybe<Scalars['String']['output']>;
  returnZip?: Maybe<Scalars['String']['output']>;
  rewardfulId?: Maybe<Scalars['String']['output']>;
  /** Whether the user has opted in to marketing SMS. Mirrored to HubSpot/Intercom. */
  smsMarketingConsent: Scalars['Boolean']['output'];
  socialNetwork?: Maybe<SocialNetwork>;
  socialUsername?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePostPaymentCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  useCustomReturnAddress: Scalars['Boolean']['output'];
  userCategory?: Maybe<UserCategory>;
  userCategoryOther?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  vip: Scalars['Boolean']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum UserCategory {
  Business = 'BUSINESS',
  Creator = 'CREATOR',
  Dropshipper = 'DROPSHIPPER',
  FitnessCoach = 'FITNESS_COACH',
  OnlineMarketer = 'ONLINE_MARKETER',
  Other = 'OTHER',
  Solopreneur = 'SOLOPRENEUR',
  WellnessApp = 'WELLNESS_APP'
}

export type UserCount = {
  __typename?: 'UserCount';
  accounts: Scalars['Int']['output'];
  certificates: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  invoices: Scalars['Int']['output'];
  labelAssets: Scalars['Int']['output'];
  labelFonts: Scalars['Int']['output'];
  labelPalettes: Scalars['Int']['output'];
  orderLines: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  paymentMethods: Scalars['Int']['output'];
  postPaymentBuckets: Scalars['Int']['output'];
  products: Scalars['Int']['output'];
  servicePurchases: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  stores: Scalars['Int']['output'];
  stripeInvoices: Scalars['Int']['output'];
  stripePostPaymentStatements: Scalars['Int']['output'];
  subscriptions: Scalars['Int']['output'];
  transactions: Scalars['Int']['output'];
};


export type UserCountAccountsArgs = {
  where?: InputMaybe<AccountWhereInput>;
};


export type UserCountCertificatesArgs = {
  where?: InputMaybe<ExemptaxCustomerCertificateWhereInput>;
};


export type UserCountFilesArgs = {
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type UserCountInvoicesArgs = {
  where?: InputMaybe<UserInvoiceWhereInput>;
};


export type UserCountLabelAssetsArgs = {
  where?: InputMaybe<UserLabelAssetWhereInput>;
};


export type UserCountLabelFontsArgs = {
  where?: InputMaybe<UserLabelFontWhereInput>;
};


export type UserCountLabelPalettesArgs = {
  where?: InputMaybe<UserLabelPaletteWhereInput>;
};


export type UserCountOrderLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type UserCountOrdersArgs = {
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type UserCountPaymentMethodsArgs = {
  where?: InputMaybe<PaymentMethodWhereInput>;
};


export type UserCountPostPaymentBucketsArgs = {
  where?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
};


export type UserCountProductsArgs = {
  where?: InputMaybe<UserProductWhereInput>;
};


export type UserCountServicePurchasesArgs = {
  where?: InputMaybe<ServicePurchaseWhereInput>;
};


export type UserCountSessionsArgs = {
  where?: InputMaybe<SessionWhereInput>;
};


export type UserCountStoresArgs = {
  where?: InputMaybe<UserStoreWhereInput>;
};


export type UserCountStripeInvoicesArgs = {
  where?: InputMaybe<StripeInvoiceWhereInput>;
};


export type UserCountStripePostPaymentStatementsArgs = {
  where?: InputMaybe<StripePostPaymentStatementWhereInput>;
};


export type UserCountSubscriptionsArgs = {
  where?: InputMaybe<UserSubscriptionWhereInput>;
};


export type UserCountTransactionsArgs = {
  where?: InputMaybe<UserCreditsTransactionWhereInput>;
};

export type UserCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<UserCreateWithoutFilesInput>;
};

export type UserCreateNestedOneWithoutInvoicesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutInvoicesInput>;
  create?: InputMaybe<UserCreateWithoutInvoicesInput>;
};

export type UserCreateNestedOneWithoutOrderLinesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<UserCreateWithoutOrderLinesInput>;
};

export type UserCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<UserCreateWithoutOrdersInput>;
};

export type UserCreateNestedOneWithoutPostPaymentBucketsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPostPaymentBucketsInput>;
  create?: InputMaybe<UserCreateWithoutPostPaymentBucketsInput>;
};

export type UserCreateNestedOneWithoutProductsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<UserCreateWithoutProductsInput>;
};

export type UserCreateNestedOneWithoutServicePurchasesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutServicePurchasesInput>;
  create?: InputMaybe<UserCreateWithoutServicePurchasesInput>;
};

export type UserCreateNestedOneWithoutStoresInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutStoresInput>;
  create?: InputMaybe<UserCreateWithoutStoresInput>;
};

export type UserCreateNestedOneWithoutStripeInvoicesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutStripeInvoicesInput>;
  create?: InputMaybe<UserCreateWithoutStripeInvoicesInput>;
};

export type UserCreateNestedOneWithoutSubscriptionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSubscriptionsInput>;
  create?: InputMaybe<UserCreateWithoutSubscriptionsInput>;
};

export type UserCreateNestedOneWithoutTransactionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<UserCreateWithoutTransactionsInput>;
};

export type UserCreateOrConnectWithoutFilesInput = {
  create: UserCreateWithoutFilesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutInvoicesInput = {
  create: UserCreateWithoutInvoicesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrderLinesInput = {
  create: UserCreateWithoutOrderLinesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrdersInput = {
  create: UserCreateWithoutOrdersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPostPaymentBucketsInput = {
  create: UserCreateWithoutPostPaymentBucketsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutProductsInput = {
  create: UserCreateWithoutProductsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutServicePurchasesInput = {
  create: UserCreateWithoutServicePurchasesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutStoresInput = {
  create: UserCreateWithoutStoresInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutStripeInvoicesInput = {
  create: UserCreateWithoutStripeInvoicesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSubscriptionsInput = {
  create: UserCreateWithoutSubscriptionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTransactionsInput = {
  create: UserCreateWithoutTransactionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutFilesInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutCustomerInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<UserProductCreateNestedManyWithoutUserInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  servicePurchases?: InputMaybe<ServicePurchaseCreateNestedManyWithoutUserInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stores?: InputMaybe<UserStoreCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserInput>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  subscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutInvoicesInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserInput>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<UserProductCreateNestedManyWithoutUserInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  servicePurchases?: InputMaybe<ServicePurchaseCreateNestedManyWithoutUserInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stores?: InputMaybe<UserStoreCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserInput>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  subscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutOrderLinesInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserInput>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutCustomerInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<UserProductCreateNestedManyWithoutUserInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  servicePurchases?: InputMaybe<ServicePurchaseCreateNestedManyWithoutUserInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stores?: InputMaybe<UserStoreCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserInput>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  subscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutOrdersInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserInput>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutCustomerInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<UserProductCreateNestedManyWithoutUserInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  servicePurchases?: InputMaybe<ServicePurchaseCreateNestedManyWithoutUserInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stores?: InputMaybe<UserStoreCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserInput>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  subscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutPostPaymentBucketsInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserInput>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutCustomerInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<UserProductCreateNestedManyWithoutUserInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  servicePurchases?: InputMaybe<ServicePurchaseCreateNestedManyWithoutUserInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stores?: InputMaybe<UserStoreCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserInput>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  subscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutProductsInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserInput>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutCustomerInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  servicePurchases?: InputMaybe<ServicePurchaseCreateNestedManyWithoutUserInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stores?: InputMaybe<UserStoreCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserInput>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  subscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutServicePurchasesInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserInput>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutCustomerInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<UserProductCreateNestedManyWithoutUserInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stores?: InputMaybe<UserStoreCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserInput>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  subscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutStoresInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserInput>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutCustomerInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<UserProductCreateNestedManyWithoutUserInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  servicePurchases?: InputMaybe<ServicePurchaseCreateNestedManyWithoutUserInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserInput>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  subscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutStripeInvoicesInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserInput>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutCustomerInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<UserProductCreateNestedManyWithoutUserInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  servicePurchases?: InputMaybe<ServicePurchaseCreateNestedManyWithoutUserInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stores?: InputMaybe<UserStoreCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  subscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutSubscriptionsInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserInput>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutCustomerInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<UserProductCreateNestedManyWithoutUserInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  servicePurchases?: InputMaybe<ServicePurchaseCreateNestedManyWithoutUserInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stores?: InputMaybe<UserStoreCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserInput>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  transactions?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutTransactionsInput = {
  accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  becameActiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  bulkOrderPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateCreateNestedManyWithoutUserInput>;
  completedOnboardingSteps?: InputMaybe<UserCreatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationScheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPaymentProcessor?: InputMaybe<UserPaymentProcessor>;
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eoriNumber?: InputMaybe<Scalars['String']['input']>;
  exemptEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<Scalars['Boolean']['input']>;
  fbaPaymentKind?: InputMaybe<UserProductOrderManualPaymentKind>;
  fbaPostPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserInput>;
  firstMonthDiscountAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  firstSessionCampaign?: InputMaybe<Scalars['String']['input']>;
  firstSessionCreative?: InputMaybe<Scalars['String']['input']>;
  firstSessionDevice?: InputMaybe<Scalars['String']['input']>;
  firstSessionGclid?: InputMaybe<Scalars['String']['input']>;
  firstSessionKeyword?: InputMaybe<Scalars['String']['input']>;
  firstSessionMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<Scalars['String']['input']>;
  firstSessionSource?: InputMaybe<Scalars['String']['input']>;
  firstSessionSourceMedium?: InputMaybe<Scalars['String']['input']>;
  firstSessionType?: InputMaybe<Scalars['String']['input']>;
  firstSessionUrl?: InputMaybe<Scalars['String']['input']>;
  freeTrialEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  hasCompletedOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedOnboardingStepsAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasPublishedFirstProduct?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialEndedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenFreeTrialStartedModal?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenWelcomeModalAt?: InputMaybe<Scalars['DateTime']['input']>;
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  intercomId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<UserCreateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutCustomerInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandAcceleratorParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPostPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  labelAssets?: InputMaybe<UserLabelAssetCreateNestedManyWithoutUserInput>;
  labelFonts?: InputMaybe<UserLabelFontCreateNestedManyWithoutUserInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteCreateNestedManyWithoutUserInput>;
  lastLogin?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbc?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionFbclidUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionFbp?: InputMaybe<Scalars['String']['input']>;
  lastSessionGbraid?: InputMaybe<Scalars['String']['input']>;
  lastSessionGclid?: InputMaybe<Scalars['String']['input']>;
  lastSessionIp?: InputMaybe<Scalars['String']['input']>;
  lastSessionLandingUrl?: InputMaybe<Scalars['String']['input']>;
  lastSessionLiFatId?: InputMaybe<Scalars['String']['input']>;
  lastSessionRdtCid?: InputMaybe<Scalars['String']['input']>;
  lastSessionUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSessionUserAgent?: InputMaybe<Scalars['String']['input']>;
  lastSessionWbraid?: InputMaybe<Scalars['String']['input']>;
  leadGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPricingTier?: InputMaybe<Scalars['Int']['input']>;
  onboardingSurveyDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingSurveyDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<UserProductOrderCreateNestedManyWithoutUserInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutUserInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketCreateNestedManyWithoutCustomerInput>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  postPaymentPeriodWeeks?: InputMaybe<Scalars['Int']['input']>;
  preventEmailNotifications?: InputMaybe<UserCreatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPaymentSuplifulCredits?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<UserProductCreateNestedManyWithoutUserInput>;
  referral?: InputMaybe<Scalars['String']['input']>;
  regNumber?: InputMaybe<Scalars['String']['input']>;
  resetShopifyStockOnSellout?: InputMaybe<Scalars['Boolean']['input']>;
  returnAddress1?: InputMaybe<Scalars['String']['input']>;
  returnAddress2?: InputMaybe<Scalars['String']['input']>;
  returnCity?: InputMaybe<Scalars['String']['input']>;
  returnCompany?: InputMaybe<Scalars['String']['input']>;
  returnCountry?: InputMaybe<Scalars['String']['input']>;
  returnPhone?: InputMaybe<Scalars['String']['input']>;
  returnState?: InputMaybe<Scalars['String']['input']>;
  returnZip?: InputMaybe<Scalars['String']['input']>;
  rewardfulId?: InputMaybe<Scalars['String']['input']>;
  servicePurchases?: InputMaybe<ServicePurchaseCreateNestedManyWithoutUserInput>;
  sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
  smsMarketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialUsername?: InputMaybe<Scalars['String']['input']>;
  stores?: InputMaybe<UserStoreCreateNestedManyWithoutUserInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserInput>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementCreateNestedManyWithoutUserInput>;
  subscriptions?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useCustomReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  userCategory?: InputMaybe<UserCategory>;
  userCategoryOther?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreatecompletedOnboardingStepsInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserCreateinvoiceEmailsInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserCreatepreventEmailNotificationsInput = {
  set: Array<NotificationReason>;
};

export type UserCreditsTransaction = {
  __typename?: 'UserCreditsTransaction';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isFreeCredits: Scalars['Boolean']['output'];
  manualCreditChangeReason?: Maybe<Scalars['String']['output']>;
  payForOrderId?: Maybe<Scalars['String']['output']>;
  refundOrderId?: Maybe<Scalars['String']['output']>;
  refundOrderLineItemProductCount?: Maybe<Scalars['Int']['output']>;
  refundOrderLineItemProductSku?: Maybe<Scalars['String']['output']>;
  userCreditsTransactionType: UserCreditsTransactionType;
  userId: Scalars['String']['output'];
};

export type UserCreditsTransactionCreateManyCreatedByInput = {
  amountCents: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFreeCredits?: InputMaybe<Scalars['Boolean']['input']>;
  manualCreditChangeReason?: InputMaybe<Scalars['String']['input']>;
  payForOrderId?: InputMaybe<Scalars['String']['input']>;
  refundOrderId?: InputMaybe<Scalars['String']['input']>;
  refundOrderLineItemProductCount?: InputMaybe<Scalars['Int']['input']>;
  refundOrderLineItemProductSku?: InputMaybe<Scalars['String']['input']>;
  userCreditsTransactionType: UserCreditsTransactionType;
  userId: Scalars['String']['input'];
};

export type UserCreditsTransactionCreateManyCreatedByInputEnvelope = {
  data: Array<UserCreditsTransactionCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreditsTransactionCreateManyPayForOrderInput = {
  amountCents: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFreeCredits?: InputMaybe<Scalars['Boolean']['input']>;
  manualCreditChangeReason?: InputMaybe<Scalars['String']['input']>;
  refundOrderId?: InputMaybe<Scalars['String']['input']>;
  refundOrderLineItemProductCount?: InputMaybe<Scalars['Int']['input']>;
  refundOrderLineItemProductSku?: InputMaybe<Scalars['String']['input']>;
  userCreditsTransactionType: UserCreditsTransactionType;
  userId: Scalars['String']['input'];
};

export type UserCreditsTransactionCreateManyPayForOrderInputEnvelope = {
  data: Array<UserCreditsTransactionCreateManyPayForOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreditsTransactionCreateManyRefundOrderInput = {
  amountCents: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFreeCredits?: InputMaybe<Scalars['Boolean']['input']>;
  manualCreditChangeReason?: InputMaybe<Scalars['String']['input']>;
  payForOrderId?: InputMaybe<Scalars['String']['input']>;
  refundOrderLineItemProductCount?: InputMaybe<Scalars['Int']['input']>;
  refundOrderLineItemProductSku?: InputMaybe<Scalars['String']['input']>;
  userCreditsTransactionType: UserCreditsTransactionType;
  userId: Scalars['String']['input'];
};

export type UserCreditsTransactionCreateManyRefundOrderInputEnvelope = {
  data: Array<UserCreditsTransactionCreateManyRefundOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreditsTransactionCreateManyUserInput = {
  amountCents: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFreeCredits?: InputMaybe<Scalars['Boolean']['input']>;
  manualCreditChangeReason?: InputMaybe<Scalars['String']['input']>;
  payForOrderId?: InputMaybe<Scalars['String']['input']>;
  refundOrderId?: InputMaybe<Scalars['String']['input']>;
  refundOrderLineItemProductCount?: InputMaybe<Scalars['Int']['input']>;
  refundOrderLineItemProductSku?: InputMaybe<Scalars['String']['input']>;
  userCreditsTransactionType: UserCreditsTransactionType;
};

export type UserCreditsTransactionCreateManyUserInputEnvelope = {
  data: Array<UserCreditsTransactionCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreditsTransactionCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreditsTransactionCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<UserCreditsTransactionCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<UserCreditsTransactionCreateManyCreatedByInputEnvelope>;
};

export type UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput = {
  connect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreditsTransactionCreateOrConnectWithoutPayForOrderInput>>;
  create?: InputMaybe<Array<UserCreditsTransactionCreateWithoutPayForOrderInput>>;
  createMany?: InputMaybe<UserCreditsTransactionCreateManyPayForOrderInputEnvelope>;
};

export type UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput = {
  connect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreditsTransactionCreateOrConnectWithoutRefundOrderInput>>;
  create?: InputMaybe<Array<UserCreditsTransactionCreateWithoutRefundOrderInput>>;
  createMany?: InputMaybe<UserCreditsTransactionCreateManyRefundOrderInputEnvelope>;
};

export type UserCreditsTransactionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreditsTransactionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserCreditsTransactionCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserCreditsTransactionCreateManyUserInputEnvelope>;
};

export type UserCreditsTransactionCreateOrConnectWithoutCreatedByInput = {
  create: UserCreditsTransactionCreateWithoutCreatedByInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionCreateOrConnectWithoutPayForOrderInput = {
  create: UserCreditsTransactionCreateWithoutPayForOrderInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionCreateOrConnectWithoutRefundOrderInput = {
  create: UserCreditsTransactionCreateWithoutRefundOrderInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionCreateOrConnectWithoutUserInput = {
  create: UserCreditsTransactionCreateWithoutUserInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionCreateWithoutCreatedByInput = {
  amountCents: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFreeCredits?: InputMaybe<Scalars['Boolean']['input']>;
  manualCreditChangeReason?: InputMaybe<Scalars['String']['input']>;
  payForOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutCreditsPaymentsInput>;
  refundOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutCreditsRefundInput>;
  refundOrderLineItemProductCount?: InputMaybe<Scalars['Int']['input']>;
  refundOrderLineItemProductSku?: InputMaybe<Scalars['String']['input']>;
  user: UserCreateNestedOneWithoutTransactionsInput;
  userCreditsTransactionType: UserCreditsTransactionType;
};

export type UserCreditsTransactionCreateWithoutPayForOrderInput = {
  amountCents: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<AdminCreateNestedOneWithoutTransactionsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFreeCredits?: InputMaybe<Scalars['Boolean']['input']>;
  manualCreditChangeReason?: InputMaybe<Scalars['String']['input']>;
  refundOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutCreditsRefundInput>;
  refundOrderLineItemProductCount?: InputMaybe<Scalars['Int']['input']>;
  refundOrderLineItemProductSku?: InputMaybe<Scalars['String']['input']>;
  user: UserCreateNestedOneWithoutTransactionsInput;
  userCreditsTransactionType: UserCreditsTransactionType;
};

export type UserCreditsTransactionCreateWithoutRefundOrderInput = {
  amountCents: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<AdminCreateNestedOneWithoutTransactionsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFreeCredits?: InputMaybe<Scalars['Boolean']['input']>;
  manualCreditChangeReason?: InputMaybe<Scalars['String']['input']>;
  payForOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutCreditsPaymentsInput>;
  refundOrderLineItemProductCount?: InputMaybe<Scalars['Int']['input']>;
  refundOrderLineItemProductSku?: InputMaybe<Scalars['String']['input']>;
  user: UserCreateNestedOneWithoutTransactionsInput;
  userCreditsTransactionType: UserCreditsTransactionType;
};

export type UserCreditsTransactionCreateWithoutUserInput = {
  amountCents: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<AdminCreateNestedOneWithoutTransactionsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFreeCredits?: InputMaybe<Scalars['Boolean']['input']>;
  manualCreditChangeReason?: InputMaybe<Scalars['String']['input']>;
  payForOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutCreditsPaymentsInput>;
  refundOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutCreditsRefundInput>;
  refundOrderLineItemProductCount?: InputMaybe<Scalars['Int']['input']>;
  refundOrderLineItemProductSku?: InputMaybe<Scalars['String']['input']>;
  userCreditsTransactionType: UserCreditsTransactionType;
};

export type UserCreditsTransactionListRelationFilter = {
  every?: InputMaybe<UserCreditsTransactionWhereInput>;
  none?: InputMaybe<UserCreditsTransactionWhereInput>;
  some?: InputMaybe<UserCreditsTransactionWhereInput>;
};

export type UserCreditsTransactionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserCreditsTransactionOrderByWithRelationInput = {
  amountCents?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<AdminOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isFreeCredits?: InputMaybe<SortOrder>;
  manualCreditChangeReason?: InputMaybe<SortOrderInput>;
  payForOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  payForOrderId?: InputMaybe<SortOrderInput>;
  refundOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  refundOrderId?: InputMaybe<SortOrderInput>;
  refundOrderLineItemProductCount?: InputMaybe<SortOrderInput>;
  refundOrderLineItemProductSku?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userCreditsTransactionType?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserCreditsTransactionScalarFieldEnum {
  AmountCents = 'amountCents',
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  Id = 'id',
  IsFreeCredits = 'isFreeCredits',
  ManualCreditChangeReason = 'manualCreditChangeReason',
  PayForOrderId = 'payForOrderId',
  RefundOrderId = 'refundOrderId',
  RefundOrderLineItemProductCount = 'refundOrderLineItemProductCount',
  RefundOrderLineItemProductSku = 'refundOrderLineItemProductSku',
  UserCreditsTransactionType = 'userCreditsTransactionType',
  UserId = 'userId'
}

export type UserCreditsTransactionScalarWhereInput = {
  AND?: InputMaybe<Array<UserCreditsTransactionScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserCreditsTransactionScalarWhereInput>>;
  OR?: InputMaybe<Array<UserCreditsTransactionScalarWhereInput>>;
  amountCents?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isFreeCredits?: InputMaybe<BoolFilter>;
  manualCreditChangeReason?: InputMaybe<StringNullableFilter>;
  payForOrderId?: InputMaybe<UuidNullableFilter>;
  refundOrderId?: InputMaybe<UuidNullableFilter>;
  refundOrderLineItemProductCount?: InputMaybe<IntNullableFilter>;
  refundOrderLineItemProductSku?: InputMaybe<StringNullableFilter>;
  userCreditsTransactionType?: InputMaybe<EnumUserCreditsTransactionTypeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export enum UserCreditsTransactionType {
  BalanceDeduction = 'BALANCE_DEDUCTION',
  BalanceTopup = 'BALANCE_TOPUP',
  OrderCancellationRefund = 'ORDER_CANCELLATION_REFUND',
  OrderPayment = 'ORDER_PAYMENT',
  OrderRefund = 'ORDER_REFUND',
  PartialRefundItemQuantityChanged = 'PARTIAL_REFUND_ITEM_QUANTITY_CHANGED',
  PartialRefundItemRemoved = 'PARTIAL_REFUND_ITEM_REMOVED'
}

export type UserCreditsTransactionUpdateManyMutationInput = {
  amountCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFreeCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  manualCreditChangeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundOrderLineItemProductCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  refundOrderLineItemProductSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCreditsTransactionType?: InputMaybe<EnumUserCreditsTransactionTypeFieldUpdateOperationsInput>;
};

export type UserCreditsTransactionUpdateManyWithWhereWithoutCreatedByInput = {
  data: UserCreditsTransactionUpdateManyMutationInput;
  where: UserCreditsTransactionScalarWhereInput;
};

export type UserCreditsTransactionUpdateManyWithWhereWithoutPayForOrderInput = {
  data: UserCreditsTransactionUpdateManyMutationInput;
  where: UserCreditsTransactionScalarWhereInput;
};

export type UserCreditsTransactionUpdateManyWithWhereWithoutRefundOrderInput = {
  data: UserCreditsTransactionUpdateManyMutationInput;
  where: UserCreditsTransactionScalarWhereInput;
};

export type UserCreditsTransactionUpdateManyWithWhereWithoutUserInput = {
  data: UserCreditsTransactionUpdateManyMutationInput;
  where: UserCreditsTransactionScalarWhereInput;
};

export type UserCreditsTransactionUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreditsTransactionCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<UserCreditsTransactionCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<UserCreditsTransactionCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserCreditsTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<UserCreditsTransactionUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<UserCreditsTransactionUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<UserCreditsTransactionUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput = {
  connect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreditsTransactionCreateOrConnectWithoutPayForOrderInput>>;
  create?: InputMaybe<Array<UserCreditsTransactionCreateWithoutPayForOrderInput>>;
  createMany?: InputMaybe<UserCreditsTransactionCreateManyPayForOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserCreditsTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<UserCreditsTransactionUpdateWithWhereUniqueWithoutPayForOrderInput>>;
  updateMany?: InputMaybe<Array<UserCreditsTransactionUpdateManyWithWhereWithoutPayForOrderInput>>;
  upsert?: InputMaybe<Array<UserCreditsTransactionUpsertWithWhereUniqueWithoutPayForOrderInput>>;
};

export type UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput = {
  connect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreditsTransactionCreateOrConnectWithoutRefundOrderInput>>;
  create?: InputMaybe<Array<UserCreditsTransactionCreateWithoutRefundOrderInput>>;
  createMany?: InputMaybe<UserCreditsTransactionCreateManyRefundOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserCreditsTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<UserCreditsTransactionUpdateWithWhereUniqueWithoutRefundOrderInput>>;
  updateMany?: InputMaybe<Array<UserCreditsTransactionUpdateManyWithWhereWithoutRefundOrderInput>>;
  upsert?: InputMaybe<Array<UserCreditsTransactionUpsertWithWhereUniqueWithoutRefundOrderInput>>;
};

export type UserCreditsTransactionUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreditsTransactionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserCreditsTransactionCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserCreditsTransactionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserCreditsTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<UserCreditsTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<UserCreditsTransactionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserCreditsTransactionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserCreditsTransactionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserCreditsTransactionUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: UserCreditsTransactionUpdateWithoutCreatedByInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionUpdateWithWhereUniqueWithoutPayForOrderInput = {
  data: UserCreditsTransactionUpdateWithoutPayForOrderInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionUpdateWithWhereUniqueWithoutRefundOrderInput = {
  data: UserCreditsTransactionUpdateWithoutRefundOrderInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionUpdateWithWhereUniqueWithoutUserInput = {
  data: UserCreditsTransactionUpdateWithoutUserInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionUpdateWithoutCreatedByInput = {
  amountCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFreeCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  manualCreditChangeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payForOrder?: InputMaybe<UserProductOrderUpdateOneWithoutCreditsPaymentsNestedInput>;
  refundOrder?: InputMaybe<UserProductOrderUpdateOneWithoutCreditsRefundNestedInput>;
  refundOrderLineItemProductCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  refundOrderLineItemProductSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutTransactionsNestedInput>;
  userCreditsTransactionType?: InputMaybe<EnumUserCreditsTransactionTypeFieldUpdateOperationsInput>;
};

export type UserCreditsTransactionUpdateWithoutPayForOrderInput = {
  amountCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneWithoutTransactionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFreeCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  manualCreditChangeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refundOrder?: InputMaybe<UserProductOrderUpdateOneWithoutCreditsRefundNestedInput>;
  refundOrderLineItemProductCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  refundOrderLineItemProductSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutTransactionsNestedInput>;
  userCreditsTransactionType?: InputMaybe<EnumUserCreditsTransactionTypeFieldUpdateOperationsInput>;
};

export type UserCreditsTransactionUpdateWithoutRefundOrderInput = {
  amountCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneWithoutTransactionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFreeCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  manualCreditChangeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payForOrder?: InputMaybe<UserProductOrderUpdateOneWithoutCreditsPaymentsNestedInput>;
  refundOrderLineItemProductCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  refundOrderLineItemProductSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutTransactionsNestedInput>;
  userCreditsTransactionType?: InputMaybe<EnumUserCreditsTransactionTypeFieldUpdateOperationsInput>;
};

export type UserCreditsTransactionUpdateWithoutUserInput = {
  amountCents?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneWithoutTransactionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFreeCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  manualCreditChangeReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payForOrder?: InputMaybe<UserProductOrderUpdateOneWithoutCreditsPaymentsNestedInput>;
  refundOrder?: InputMaybe<UserProductOrderUpdateOneWithoutCreditsRefundNestedInput>;
  refundOrderLineItemProductCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  refundOrderLineItemProductSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userCreditsTransactionType?: InputMaybe<EnumUserCreditsTransactionTypeFieldUpdateOperationsInput>;
};

export type UserCreditsTransactionUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: UserCreditsTransactionCreateWithoutCreatedByInput;
  update: UserCreditsTransactionUpdateWithoutCreatedByInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionUpsertWithWhereUniqueWithoutPayForOrderInput = {
  create: UserCreditsTransactionCreateWithoutPayForOrderInput;
  update: UserCreditsTransactionUpdateWithoutPayForOrderInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionUpsertWithWhereUniqueWithoutRefundOrderInput = {
  create: UserCreditsTransactionCreateWithoutRefundOrderInput;
  update: UserCreditsTransactionUpdateWithoutRefundOrderInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionUpsertWithWhereUniqueWithoutUserInput = {
  create: UserCreditsTransactionCreateWithoutUserInput;
  update: UserCreditsTransactionUpdateWithoutUserInput;
  where: UserCreditsTransactionWhereUniqueInput;
};

export type UserCreditsTransactionWhereInput = {
  AND?: InputMaybe<Array<UserCreditsTransactionWhereInput>>;
  NOT?: InputMaybe<Array<UserCreditsTransactionWhereInput>>;
  OR?: InputMaybe<Array<UserCreditsTransactionWhereInput>>;
  amountCents?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminNullableRelationFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isFreeCredits?: InputMaybe<BoolFilter>;
  manualCreditChangeReason?: InputMaybe<StringNullableFilter>;
  payForOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  payForOrderId?: InputMaybe<UuidNullableFilter>;
  refundOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  refundOrderId?: InputMaybe<UuidNullableFilter>;
  refundOrderLineItemProductCount?: InputMaybe<IntNullableFilter>;
  refundOrderLineItemProductSku?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userCreditsTransactionType?: InputMaybe<EnumUserCreditsTransactionTypeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserCreditsTransactionWhereUniqueInput = {
  AND?: InputMaybe<Array<UserCreditsTransactionWhereInput>>;
  NOT?: InputMaybe<Array<UserCreditsTransactionWhereInput>>;
  OR?: InputMaybe<Array<UserCreditsTransactionWhereInput>>;
  amountCents?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminNullableRelationFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isFreeCredits?: InputMaybe<BoolFilter>;
  manualCreditChangeReason?: InputMaybe<StringNullableFilter>;
  payForOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  payForOrderId?: InputMaybe<UuidNullableFilter>;
  refundOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  refundOrderId?: InputMaybe<UuidNullableFilter>;
  refundOrderLineItemProductCount?: InputMaybe<IntNullableFilter>;
  refundOrderLineItemProductSku?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userCreditsTransactionType?: InputMaybe<EnumUserCreditsTransactionTypeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserInvoice = {
  __typename?: 'UserInvoice';
  createdAt: Scalars['DateTime']['output'];
  csvUrl?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceNo: Scalars['String']['output'];
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  isMarkedInQuickBooks: Scalars['Boolean']['output'];
  paymentDeadline?: Maybe<Scalars['DateTime']['output']>;
  postPaymentBucketId?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  servicePurchaseId?: Maybe<Scalars['String']['output']>;
  totalAmount: Scalars['Float']['output'];
  type: UserInvoiceType;
  userProductOrderId?: Maybe<Scalars['String']['output']>;
};

export type UserInvoiceCreateManyCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  invoiceUrl?: InputMaybe<Scalars['String']['input']>;
  isMarkedInQuickBooks?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  postPaymentBucketId?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  servicePurchaseId?: InputMaybe<Scalars['String']['input']>;
  totalAmount: Scalars['Float']['input'];
  type: UserInvoiceType;
  userProductOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type UserInvoiceCreateManyCustomerInputEnvelope = {
  data: Array<UserInvoiceCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserInvoiceCreateManyPostPaymentBucketInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  invoiceUrl?: InputMaybe<Scalars['String']['input']>;
  isMarkedInQuickBooks?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  servicePurchaseId?: InputMaybe<Scalars['String']['input']>;
  totalAmount: Scalars['Float']['input'];
  type: UserInvoiceType;
  userProductOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type UserInvoiceCreateManyPostPaymentBucketInputEnvelope = {
  data: Array<UserInvoiceCreateManyPostPaymentBucketInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserInvoiceCreateManyServicePurchaseInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  invoiceUrl?: InputMaybe<Scalars['String']['input']>;
  isMarkedInQuickBooks?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  postPaymentBucketId?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount: Scalars['Float']['input'];
  type: UserInvoiceType;
  userProductOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type UserInvoiceCreateManyServicePurchaseInputEnvelope = {
  data: Array<UserInvoiceCreateManyServicePurchaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserInvoiceCreateManyUserProductOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  invoiceUrl?: InputMaybe<Scalars['String']['input']>;
  isMarkedInQuickBooks?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  postPaymentBucketId?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  servicePurchaseId?: InputMaybe<Scalars['String']['input']>;
  totalAmount: Scalars['Float']['input'];
  type: UserInvoiceType;
};

export type UserInvoiceCreateManyUserProductOrderInputEnvelope = {
  data: Array<UserInvoiceCreateManyUserProductOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserInvoiceCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserInvoiceCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<UserInvoiceCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<UserInvoiceCreateManyCustomerInputEnvelope>;
};

export type UserInvoiceCreateNestedManyWithoutPostPaymentBucketInput = {
  connect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserInvoiceCreateOrConnectWithoutPostPaymentBucketInput>>;
  create?: InputMaybe<Array<UserInvoiceCreateWithoutPostPaymentBucketInput>>;
  createMany?: InputMaybe<UserInvoiceCreateManyPostPaymentBucketInputEnvelope>;
};

export type UserInvoiceCreateNestedManyWithoutServicePurchaseInput = {
  connect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserInvoiceCreateOrConnectWithoutServicePurchaseInput>>;
  create?: InputMaybe<Array<UserInvoiceCreateWithoutServicePurchaseInput>>;
  createMany?: InputMaybe<UserInvoiceCreateManyServicePurchaseInputEnvelope>;
};

export type UserInvoiceCreateNestedManyWithoutUserProductOrderInput = {
  connect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserInvoiceCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<UserInvoiceCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<UserInvoiceCreateManyUserProductOrderInputEnvelope>;
};

export type UserInvoiceCreateOrConnectWithoutCustomerInput = {
  create: UserInvoiceCreateWithoutCustomerInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceCreateOrConnectWithoutPostPaymentBucketInput = {
  create: UserInvoiceCreateWithoutPostPaymentBucketInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceCreateOrConnectWithoutServicePurchaseInput = {
  create: UserInvoiceCreateWithoutServicePurchaseInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceCreateOrConnectWithoutUserProductOrderInput = {
  create: UserInvoiceCreateWithoutUserProductOrderInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceCreateWithoutCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  invoiceUrl?: InputMaybe<Scalars['String']['input']>;
  isMarkedInQuickBooks?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutInvoicesInput>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  servicePurchase?: InputMaybe<ServicePurchaseCreateNestedOneWithoutInvoicesInput>;
  totalAmount: Scalars['Float']['input'];
  type: UserInvoiceType;
  userProductOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutInvoicesInput>;
};

export type UserInvoiceCreateWithoutPostPaymentBucketInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer: UserCreateNestedOneWithoutInvoicesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  invoiceUrl?: InputMaybe<Scalars['String']['input']>;
  isMarkedInQuickBooks?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  servicePurchase?: InputMaybe<ServicePurchaseCreateNestedOneWithoutInvoicesInput>;
  totalAmount: Scalars['Float']['input'];
  type: UserInvoiceType;
  userProductOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutInvoicesInput>;
};

export type UserInvoiceCreateWithoutServicePurchaseInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer: UserCreateNestedOneWithoutInvoicesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  invoiceUrl?: InputMaybe<Scalars['String']['input']>;
  isMarkedInQuickBooks?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutInvoicesInput>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount: Scalars['Float']['input'];
  type: UserInvoiceType;
  userProductOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutInvoicesInput>;
};

export type UserInvoiceCreateWithoutUserProductOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer: UserCreateNestedOneWithoutInvoicesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo: Scalars['String']['input'];
  invoiceUrl?: InputMaybe<Scalars['String']['input']>;
  isMarkedInQuickBooks?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutInvoicesInput>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  servicePurchase?: InputMaybe<ServicePurchaseCreateNestedOneWithoutInvoicesInput>;
  totalAmount: Scalars['Float']['input'];
  type: UserInvoiceType;
};

export type UserInvoiceListRelationFilter = {
  every?: InputMaybe<UserInvoiceWhereInput>;
  none?: InputMaybe<UserInvoiceWhereInput>;
  some?: InputMaybe<UserInvoiceWhereInput>;
};

export type UserInvoiceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserInvoiceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  csvUrl?: InputMaybe<SortOrderInput>;
  currency?: InputMaybe<SortOrder>;
  customer?: InputMaybe<UserOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invoiceNo?: InputMaybe<SortOrder>;
  invoiceUrl?: InputMaybe<SortOrderInput>;
  isMarkedInQuickBooks?: InputMaybe<SortOrder>;
  paymentDeadline?: InputMaybe<SortOrderInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketOrderByWithRelationInput>;
  postPaymentBucketId?: InputMaybe<SortOrderInput>;
  processedAt?: InputMaybe<SortOrderInput>;
  servicePurchase?: InputMaybe<ServicePurchaseOrderByWithRelationInput>;
  servicePurchaseId?: InputMaybe<SortOrderInput>;
  totalAmount?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userProductOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  userProductOrderId?: InputMaybe<SortOrderInput>;
};

export enum UserInvoiceScalarFieldEnum {
  CreatedAt = 'createdAt',
  CsvUrl = 'csvUrl',
  Currency = 'currency',
  CustomerId = 'customerId',
  Id = 'id',
  InvoiceNo = 'invoiceNo',
  InvoiceUrl = 'invoiceUrl',
  IsMarkedInQuickBooks = 'isMarkedInQuickBooks',
  Payload = 'payload',
  PaymentDeadline = 'paymentDeadline',
  PostPaymentBucketId = 'postPaymentBucketId',
  ProcessedAt = 'processedAt',
  ServicePurchaseId = 'servicePurchaseId',
  TotalAmount = 'totalAmount',
  Type = 'type',
  UserProductOrderId = 'userProductOrderId'
}

export type UserInvoiceScalarWhereInput = {
  AND?: InputMaybe<Array<UserInvoiceScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserInvoiceScalarWhereInput>>;
  OR?: InputMaybe<Array<UserInvoiceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  csvUrl?: InputMaybe<StringNullableFilter>;
  currency?: InputMaybe<StringFilter>;
  customerId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  invoiceNo?: InputMaybe<StringFilter>;
  invoiceUrl?: InputMaybe<StringNullableFilter>;
  isMarkedInQuickBooks?: InputMaybe<BoolFilter>;
  paymentDeadline?: InputMaybe<DateTimeNullableFilter>;
  postPaymentBucketId?: InputMaybe<UuidNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  servicePurchaseId?: InputMaybe<UuidNullableFilter>;
  totalAmount?: InputMaybe<FloatFilter>;
  type?: InputMaybe<EnumUserInvoiceTypeFilter>;
  userProductOrderId?: InputMaybe<UuidNullableFilter>;
};

export enum UserInvoiceType {
  DigitalService = 'DIGITAL_SERVICE',
  Order = 'ORDER',
  OrderRefund = 'ORDER_REFUND',
  OrderReshipment = 'ORDER_RESHIPMENT',
  PostPayment = 'POST_PAYMENT',
  Subscription = 'SUBSCRIPTION'
}

export type UserInvoiceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  csvUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNo?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isMarkedInQuickBooks?: InputMaybe<BoolFieldUpdateOperationsInput>;
  paymentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  totalAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserInvoiceTypeFieldUpdateOperationsInput>;
};

export type UserInvoiceUpdateManyWithWhereWithoutCustomerInput = {
  data: UserInvoiceUpdateManyMutationInput;
  where: UserInvoiceScalarWhereInput;
};

export type UserInvoiceUpdateManyWithWhereWithoutPostPaymentBucketInput = {
  data: UserInvoiceUpdateManyMutationInput;
  where: UserInvoiceScalarWhereInput;
};

export type UserInvoiceUpdateManyWithWhereWithoutServicePurchaseInput = {
  data: UserInvoiceUpdateManyMutationInput;
  where: UserInvoiceScalarWhereInput;
};

export type UserInvoiceUpdateManyWithWhereWithoutUserProductOrderInput = {
  data: UserInvoiceUpdateManyMutationInput;
  where: UserInvoiceScalarWhereInput;
};

export type UserInvoiceUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserInvoiceCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<UserInvoiceCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<UserInvoiceCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<UserInvoiceUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<UserInvoiceUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<UserInvoiceUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type UserInvoiceUpdateManyWithoutPostPaymentBucketNestedInput = {
  connect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserInvoiceCreateOrConnectWithoutPostPaymentBucketInput>>;
  create?: InputMaybe<Array<UserInvoiceCreateWithoutPostPaymentBucketInput>>;
  createMany?: InputMaybe<UserInvoiceCreateManyPostPaymentBucketInputEnvelope>;
  delete?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<UserInvoiceUpdateWithWhereUniqueWithoutPostPaymentBucketInput>>;
  updateMany?: InputMaybe<Array<UserInvoiceUpdateManyWithWhereWithoutPostPaymentBucketInput>>;
  upsert?: InputMaybe<Array<UserInvoiceUpsertWithWhereUniqueWithoutPostPaymentBucketInput>>;
};

export type UserInvoiceUpdateManyWithoutServicePurchaseNestedInput = {
  connect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserInvoiceCreateOrConnectWithoutServicePurchaseInput>>;
  create?: InputMaybe<Array<UserInvoiceCreateWithoutServicePurchaseInput>>;
  createMany?: InputMaybe<UserInvoiceCreateManyServicePurchaseInputEnvelope>;
  delete?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<UserInvoiceUpdateWithWhereUniqueWithoutServicePurchaseInput>>;
  updateMany?: InputMaybe<Array<UserInvoiceUpdateManyWithWhereWithoutServicePurchaseInput>>;
  upsert?: InputMaybe<Array<UserInvoiceUpsertWithWhereUniqueWithoutServicePurchaseInput>>;
};

export type UserInvoiceUpdateManyWithoutUserProductOrderNestedInput = {
  connect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserInvoiceCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<UserInvoiceCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<UserInvoiceCreateManyUserProductOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<UserInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<UserInvoiceUpdateWithWhereUniqueWithoutUserProductOrderInput>>;
  updateMany?: InputMaybe<Array<UserInvoiceUpdateManyWithWhereWithoutUserProductOrderInput>>;
  upsert?: InputMaybe<Array<UserInvoiceUpsertWithWhereUniqueWithoutUserProductOrderInput>>;
};

export type UserInvoiceUpdateWithWhereUniqueWithoutCustomerInput = {
  data: UserInvoiceUpdateWithoutCustomerInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceUpdateWithWhereUniqueWithoutPostPaymentBucketInput = {
  data: UserInvoiceUpdateWithoutPostPaymentBucketInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceUpdateWithWhereUniqueWithoutServicePurchaseInput = {
  data: UserInvoiceUpdateWithoutServicePurchaseInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceUpdateWithWhereUniqueWithoutUserProductOrderInput = {
  data: UserInvoiceUpdateWithoutUserProductOrderInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceUpdateWithoutCustomerInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  csvUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNo?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isMarkedInQuickBooks?: InputMaybe<BoolFieldUpdateOperationsInput>;
  paymentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutInvoicesNestedInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  servicePurchase?: InputMaybe<ServicePurchaseUpdateOneWithoutInvoicesNestedInput>;
  totalAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserInvoiceTypeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneWithoutInvoicesNestedInput>;
};

export type UserInvoiceUpdateWithoutPostPaymentBucketInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  csvUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  customer?: InputMaybe<UserUpdateOneRequiredWithoutInvoicesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNo?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isMarkedInQuickBooks?: InputMaybe<BoolFieldUpdateOperationsInput>;
  paymentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  servicePurchase?: InputMaybe<ServicePurchaseUpdateOneWithoutInvoicesNestedInput>;
  totalAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserInvoiceTypeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneWithoutInvoicesNestedInput>;
};

export type UserInvoiceUpdateWithoutServicePurchaseInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  csvUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  customer?: InputMaybe<UserUpdateOneRequiredWithoutInvoicesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNo?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isMarkedInQuickBooks?: InputMaybe<BoolFieldUpdateOperationsInput>;
  paymentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutInvoicesNestedInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  totalAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserInvoiceTypeFieldUpdateOperationsInput>;
  userProductOrder?: InputMaybe<UserProductOrderUpdateOneWithoutInvoicesNestedInput>;
};

export type UserInvoiceUpdateWithoutUserProductOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  csvUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  customer?: InputMaybe<UserUpdateOneRequiredWithoutInvoicesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNo?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isMarkedInQuickBooks?: InputMaybe<BoolFieldUpdateOperationsInput>;
  paymentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutInvoicesNestedInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  servicePurchase?: InputMaybe<ServicePurchaseUpdateOneWithoutInvoicesNestedInput>;
  totalAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserInvoiceTypeFieldUpdateOperationsInput>;
};

export type UserInvoiceUpsertWithWhereUniqueWithoutCustomerInput = {
  create: UserInvoiceCreateWithoutCustomerInput;
  update: UserInvoiceUpdateWithoutCustomerInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceUpsertWithWhereUniqueWithoutPostPaymentBucketInput = {
  create: UserInvoiceCreateWithoutPostPaymentBucketInput;
  update: UserInvoiceUpdateWithoutPostPaymentBucketInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceUpsertWithWhereUniqueWithoutServicePurchaseInput = {
  create: UserInvoiceCreateWithoutServicePurchaseInput;
  update: UserInvoiceUpdateWithoutServicePurchaseInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceUpsertWithWhereUniqueWithoutUserProductOrderInput = {
  create: UserInvoiceCreateWithoutUserProductOrderInput;
  update: UserInvoiceUpdateWithoutUserProductOrderInput;
  where: UserInvoiceWhereUniqueInput;
};

export type UserInvoiceWhereInput = {
  AND?: InputMaybe<Array<UserInvoiceWhereInput>>;
  NOT?: InputMaybe<Array<UserInvoiceWhereInput>>;
  OR?: InputMaybe<Array<UserInvoiceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  csvUrl?: InputMaybe<StringNullableFilter>;
  currency?: InputMaybe<StringFilter>;
  customer?: InputMaybe<UserRelationFilter>;
  customerId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  invoiceNo?: InputMaybe<StringFilter>;
  invoiceUrl?: InputMaybe<StringNullableFilter>;
  isMarkedInQuickBooks?: InputMaybe<BoolFilter>;
  paymentDeadline?: InputMaybe<DateTimeNullableFilter>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketNullableRelationFilter>;
  postPaymentBucketId?: InputMaybe<UuidNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  servicePurchase?: InputMaybe<ServicePurchaseNullableRelationFilter>;
  servicePurchaseId?: InputMaybe<UuidNullableFilter>;
  totalAmount?: InputMaybe<FloatFilter>;
  type?: InputMaybe<EnumUserInvoiceTypeFilter>;
  userProductOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  userProductOrderId?: InputMaybe<UuidNullableFilter>;
};

export type UserInvoiceWhereUniqueInput = {
  AND?: InputMaybe<Array<UserInvoiceWhereInput>>;
  NOT?: InputMaybe<Array<UserInvoiceWhereInput>>;
  OR?: InputMaybe<Array<UserInvoiceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  csvUrl?: InputMaybe<StringNullableFilter>;
  currency?: InputMaybe<StringFilter>;
  customer?: InputMaybe<UserRelationFilter>;
  customerId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceNo?: InputMaybe<Scalars['String']['input']>;
  invoiceUrl?: InputMaybe<StringNullableFilter>;
  isMarkedInQuickBooks?: InputMaybe<BoolFilter>;
  paymentDeadline?: InputMaybe<DateTimeNullableFilter>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketNullableRelationFilter>;
  postPaymentBucketId?: InputMaybe<UuidNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  servicePurchase?: InputMaybe<ServicePurchaseNullableRelationFilter>;
  servicePurchaseId?: InputMaybe<UuidNullableFilter>;
  totalAmount?: InputMaybe<FloatFilter>;
  type?: InputMaybe<EnumUserInvoiceTypeFilter>;
  userProductOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  userProductOrderId?: InputMaybe<UuidNullableFilter>;
};

export type UserLabelAssetCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserLabelAssetCreateManyUserInputEnvelope = {
  data: Array<UserLabelAssetCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLabelAssetCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserLabelAssetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserLabelAssetCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserLabelAssetCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserLabelAssetCreateManyUserInputEnvelope>;
};

export type UserLabelAssetCreateOrConnectWithoutUserInput = {
  create: UserLabelAssetCreateWithoutUserInput;
  where: UserLabelAssetWhereUniqueInput;
};

export type UserLabelAssetCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserLabelAssetListRelationFilter = {
  every?: InputMaybe<UserLabelAssetWhereInput>;
  none?: InputMaybe<UserLabelAssetWhereInput>;
  some?: InputMaybe<UserLabelAssetWhereInput>;
};

export type UserLabelAssetOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserLabelAssetScalarWhereInput = {
  AND?: InputMaybe<Array<UserLabelAssetScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserLabelAssetScalarWhereInput>>;
  OR?: InputMaybe<Array<UserLabelAssetScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileKey?: InputMaybe<StringFilter>;
  fileName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  mimeType?: InputMaybe<StringNullableFilter>;
  sizeBytes?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserLabelAssetUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mimeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sizeBytes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserLabelAssetUpdateManyWithWhereWithoutUserInput = {
  data: UserLabelAssetUpdateManyMutationInput;
  where: UserLabelAssetScalarWhereInput;
};

export type UserLabelAssetUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserLabelAssetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserLabelAssetCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserLabelAssetCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserLabelAssetCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserLabelAssetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserLabelAssetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserLabelAssetWhereUniqueInput>>;
  set?: InputMaybe<Array<UserLabelAssetWhereUniqueInput>>;
  update?: InputMaybe<Array<UserLabelAssetUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserLabelAssetUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserLabelAssetUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserLabelAssetUpdateWithWhereUniqueWithoutUserInput = {
  data: UserLabelAssetUpdateWithoutUserInput;
  where: UserLabelAssetWhereUniqueInput;
};

export type UserLabelAssetUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mimeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sizeBytes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserLabelAssetUpsertWithWhereUniqueWithoutUserInput = {
  create: UserLabelAssetCreateWithoutUserInput;
  update: UserLabelAssetUpdateWithoutUserInput;
  where: UserLabelAssetWhereUniqueInput;
};

export type UserLabelAssetWhereInput = {
  AND?: InputMaybe<Array<UserLabelAssetWhereInput>>;
  NOT?: InputMaybe<Array<UserLabelAssetWhereInput>>;
  OR?: InputMaybe<Array<UserLabelAssetWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileKey?: InputMaybe<StringFilter>;
  fileName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  mimeType?: InputMaybe<StringNullableFilter>;
  sizeBytes?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserLabelAssetWhereUniqueInput = {
  AND?: InputMaybe<Array<UserLabelAssetWhereInput>>;
  NOT?: InputMaybe<Array<UserLabelAssetWhereInput>>;
  OR?: InputMaybe<Array<UserLabelAssetWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileKey?: InputMaybe<StringFilter>;
  fileName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<StringNullableFilter>;
  sizeBytes?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserLabelFontCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fontFamily: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserLabelFontCreateManyUserInputEnvelope = {
  data: Array<UserLabelFontCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLabelFontCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserLabelFontWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserLabelFontCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserLabelFontCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserLabelFontCreateManyUserInputEnvelope>;
};

export type UserLabelFontCreateOrConnectWithoutUserInput = {
  create: UserLabelFontCreateWithoutUserInput;
  where: UserLabelFontWhereUniqueInput;
};

export type UserLabelFontCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fontFamily: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserLabelFontListRelationFilter = {
  every?: InputMaybe<UserLabelFontWhereInput>;
  none?: InputMaybe<UserLabelFontWhereInput>;
  some?: InputMaybe<UserLabelFontWhereInput>;
};

export type UserLabelFontOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserLabelFontScalarWhereInput = {
  AND?: InputMaybe<Array<UserLabelFontScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserLabelFontScalarWhereInput>>;
  OR?: InputMaybe<Array<UserLabelFontScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileKey?: InputMaybe<StringFilter>;
  fileName?: InputMaybe<StringFilter>;
  fontFamily?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  sizeBytes?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserLabelFontUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fontFamily?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sizeBytes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserLabelFontUpdateManyWithWhereWithoutUserInput = {
  data: UserLabelFontUpdateManyMutationInput;
  where: UserLabelFontScalarWhereInput;
};

export type UserLabelFontUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserLabelFontWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserLabelFontCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserLabelFontCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserLabelFontCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserLabelFontWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserLabelFontScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserLabelFontWhereUniqueInput>>;
  set?: InputMaybe<Array<UserLabelFontWhereUniqueInput>>;
  update?: InputMaybe<Array<UserLabelFontUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserLabelFontUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserLabelFontUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserLabelFontUpdateWithWhereUniqueWithoutUserInput = {
  data: UserLabelFontUpdateWithoutUserInput;
  where: UserLabelFontWhereUniqueInput;
};

export type UserLabelFontUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  fontFamily?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sizeBytes?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserLabelFontUpsertWithWhereUniqueWithoutUserInput = {
  create: UserLabelFontCreateWithoutUserInput;
  update: UserLabelFontUpdateWithoutUserInput;
  where: UserLabelFontWhereUniqueInput;
};

export type UserLabelFontUserIdFontFamilyCompoundUniqueInput = {
  fontFamily: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserLabelFontWhereInput = {
  AND?: InputMaybe<Array<UserLabelFontWhereInput>>;
  NOT?: InputMaybe<Array<UserLabelFontWhereInput>>;
  OR?: InputMaybe<Array<UserLabelFontWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileKey?: InputMaybe<StringFilter>;
  fileName?: InputMaybe<StringFilter>;
  fontFamily?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  sizeBytes?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserLabelFontWhereUniqueInput = {
  AND?: InputMaybe<Array<UserLabelFontWhereInput>>;
  NOT?: InputMaybe<Array<UserLabelFontWhereInput>>;
  OR?: InputMaybe<Array<UserLabelFontWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileKey?: InputMaybe<StringFilter>;
  fileName?: InputMaybe<StringFilter>;
  fontFamily?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  sizeBytes?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userId_fontFamily?: InputMaybe<UserLabelFontUserIdFontFamilyCompoundUniqueInput>;
};

export type UserLabelPaletteCreateManyUserInput = {
  bodyFont?: InputMaybe<Scalars['String']['input']>;
  colors?: InputMaybe<UserLabelPaletteCreatecolorsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mainFont?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  source: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserLabelPaletteCreateManyUserInputEnvelope = {
  data: Array<UserLabelPaletteCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLabelPaletteCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserLabelPaletteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserLabelPaletteCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserLabelPaletteCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserLabelPaletteCreateManyUserInputEnvelope>;
};

export type UserLabelPaletteCreateOrConnectWithoutUserInput = {
  create: UserLabelPaletteCreateWithoutUserInput;
  where: UserLabelPaletteWhereUniqueInput;
};

export type UserLabelPaletteCreateWithoutUserInput = {
  bodyFont?: InputMaybe<Scalars['String']['input']>;
  colors?: InputMaybe<UserLabelPaletteCreatecolorsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  mainFont?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  source: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserLabelPaletteCreatecolorsInput = {
  set: Array<Scalars['String']['input']>;
};

export type UserLabelPaletteListRelationFilter = {
  every?: InputMaybe<UserLabelPaletteWhereInput>;
  none?: InputMaybe<UserLabelPaletteWhereInput>;
  some?: InputMaybe<UserLabelPaletteWhereInput>;
};

export type UserLabelPaletteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserLabelPaletteScalarWhereInput = {
  AND?: InputMaybe<Array<UserLabelPaletteScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserLabelPaletteScalarWhereInput>>;
  OR?: InputMaybe<Array<UserLabelPaletteScalarWhereInput>>;
  bodyFont?: InputMaybe<StringNullableFilter>;
  colors?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  mainFont?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserLabelPaletteUpdateManyMutationInput = {
  bodyFont?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  colors?: InputMaybe<UserLabelPaletteUpdatecolorsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainFont?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  source?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserLabelPaletteUpdateManyWithWhereWithoutUserInput = {
  data: UserLabelPaletteUpdateManyMutationInput;
  where: UserLabelPaletteScalarWhereInput;
};

export type UserLabelPaletteUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserLabelPaletteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserLabelPaletteCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserLabelPaletteCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserLabelPaletteCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserLabelPaletteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserLabelPaletteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserLabelPaletteWhereUniqueInput>>;
  set?: InputMaybe<Array<UserLabelPaletteWhereUniqueInput>>;
  update?: InputMaybe<Array<UserLabelPaletteUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserLabelPaletteUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserLabelPaletteUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserLabelPaletteUpdateWithWhereUniqueWithoutUserInput = {
  data: UserLabelPaletteUpdateWithoutUserInput;
  where: UserLabelPaletteWhereUniqueInput;
};

export type UserLabelPaletteUpdateWithoutUserInput = {
  bodyFont?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  colors?: InputMaybe<UserLabelPaletteUpdatecolorsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainFont?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  source?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserLabelPaletteUpdatecolorsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserLabelPaletteUpsertWithWhereUniqueWithoutUserInput = {
  create: UserLabelPaletteCreateWithoutUserInput;
  update: UserLabelPaletteUpdateWithoutUserInput;
  where: UserLabelPaletteWhereUniqueInput;
};

export type UserLabelPaletteWhereInput = {
  AND?: InputMaybe<Array<UserLabelPaletteWhereInput>>;
  NOT?: InputMaybe<Array<UserLabelPaletteWhereInput>>;
  OR?: InputMaybe<Array<UserLabelPaletteWhereInput>>;
  bodyFont?: InputMaybe<StringNullableFilter>;
  colors?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  mainFont?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserLabelPaletteWhereUniqueInput = {
  AND?: InputMaybe<Array<UserLabelPaletteWhereInput>>;
  NOT?: InputMaybe<Array<UserLabelPaletteWhereInput>>;
  OR?: InputMaybe<Array<UserLabelPaletteWhereInput>>;
  bodyFont?: InputMaybe<StringNullableFilter>;
  colors?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  mainFont?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserModel = {
  __typename?: 'UserModel';
  _count?: Maybe<UserCount>;
  avatar?: Maybe<Scalars['String']['output']>;
  becameActiveAt?: Maybe<Scalars['DateTime']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  billingAddress1?: Maybe<Scalars['String']['output']>;
  billingAddress2?: Maybe<Scalars['String']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  billingState?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  bulkOrderPaymentKind: UserProductOrderManualPaymentKind;
  bulkOrderPostPaymentDueDateDays?: Maybe<Scalars['Int']['output']>;
  bulkOrderPostPaymentDueDateDaysType?: Maybe<UserPostPaymentDueDateDaysType>;
  certificates: Array<ExemptaxCustomerCertificate>;
  completedOnboardingSteps: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentSubscription?: Maybe<UserSubscription>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivationScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  eoriNumber?: Maybe<Scalars['String']['output']>;
  exemptEmailVerified: Scalars['Boolean']['output'];
  exemptaxCustomerId?: Maybe<Scalars['Int']['output']>;
  /** @ignored Temporary flag to distinguish users who got extended free trial on freemium init */
  extendedFreeTrialGrantedOnInit: Scalars['Boolean']['output'];
  failedOrderPaymentsCount: Scalars['Float']['output'];
  fbaPaymentKind: UserProductOrderManualPaymentKind;
  fbaPostPaymentDueDateDays?: Maybe<Scalars['Int']['output']>;
  fbaPostPaymentDueDateDaysType?: Maybe<UserPostPaymentDueDateDaysType>;
  firstSessionCampaign?: Maybe<Scalars['String']['output']>;
  firstSessionCreative?: Maybe<Scalars['String']['output']>;
  firstSessionDevice?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lastSession* fields for click IDs */
  firstSessionGclid?: Maybe<Scalars['String']['output']>;
  firstSessionKeyword?: Maybe<Scalars['String']['output']>;
  firstSessionMedium?: Maybe<Scalars['String']['output']>;
  firstSessionQueryParams?: Maybe<Scalars['JSON']['output']>;
  firstSessionSet?: Maybe<Scalars['String']['output']>;
  firstSessionSource?: Maybe<Scalars['String']['output']>;
  firstSessionSourceMedium?: Maybe<Scalars['String']['output']>;
  firstSessionType?: Maybe<Scalars['String']['output']>;
  firstSessionUrl?: Maybe<Scalars['String']['output']>;
  /** @ignored */
  freeTrialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  fullName: Scalars['String']['output'];
  hasCompletedOnboardingSteps: Scalars['Boolean']['output'];
  hasCompletedOnboardingStepsAt?: Maybe<Scalars['DateTime']['output']>;
  hasPublishedFirstProduct: Scalars['Boolean']['output'];
  /** @ignored */
  hasSeenFreeTrialEndedModal: Scalars['Boolean']['output'];
  /** @ignored */
  hasSeenFreeTrialStartedModal: Scalars['Boolean']['output'];
  hasSeenWelcomeModalAt?: Maybe<Scalars['DateTime']['output']>;
  hubspotContactId?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  intercomId?: Maybe<Scalars['String']['output']>;
  invoiceEmails: Array<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isBrandAcceleratorParticipant: Scalars['Boolean']['output'];
  isDeactivated: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isPostPaymentEnabled: Scalars['Boolean']['output'];
  isPriorityLaneFulfillment: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  /** Meta _fbc cookie set by the base Pixel (preferred over a synthesized fbc) */
  lastSessionFbc?: Maybe<Scalars['String']['output']>;
  lastSessionFbclid?: Maybe<Scalars['String']['output']>;
  lastSessionFbclidUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Meta _fbp browser-id cookie set by the base Pixel */
  lastSessionFbp?: Maybe<Scalars['String']['output']>;
  lastSessionGbraid?: Maybe<Scalars['String']['output']>;
  /** Last-session ad click IDs — overwritten on every new ad click */
  lastSessionGclid?: Maybe<Scalars['String']['output']>;
  /** Client IP at capture time — feeds Meta CAPI client_ip_address */
  lastSessionIp?: Maybe<Scalars['String']['output']>;
  /** Full landing URL of the last ad touch — feeds Meta CAPI event_source_url */
  lastSessionLandingUrl?: Maybe<Scalars['String']['output']>;
  lastSessionLiFatId?: Maybe<Scalars['String']['output']>;
  lastSessionRdtCid?: Maybe<Scalars['String']['output']>;
  lastSessionUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Client user agent at capture time — feeds Meta CAPI client_user_agent */
  lastSessionUserAgent?: Maybe<Scalars['String']['output']>;
  lastSessionWbraid?: Maybe<Scalars['String']['output']>;
  leadGenerated?: Maybe<Scalars['Boolean']['output']>;
  onboardingSurveyDone: Scalars['Boolean']['output'];
  onboardingSurveyDoneAt?: Maybe<Scalars['DateTime']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postPaymentDueDateDays: Scalars['Int']['output'];
  postPaymentDueDateDaysType: UserPostPaymentDueDateDaysType;
  postPaymentPeriodWeeks: Scalars['Int']['output'];
  preventEmailNotifications: Array<NotificationReason>;
  preventShopifyUpdateOnPrintfileChange?: Maybe<Scalars['Boolean']['output']>;
  primaryPaymentSuplifulCredits: Scalars['Boolean']['output'];
  referral?: Maybe<Scalars['String']['output']>;
  regNumber?: Maybe<Scalars['String']['output']>;
  resetShopifyStockOnSellout: Scalars['Boolean']['output'];
  returnAddress1?: Maybe<Scalars['String']['output']>;
  returnAddress2?: Maybe<Scalars['String']['output']>;
  returnCity?: Maybe<Scalars['String']['output']>;
  returnCompany?: Maybe<Scalars['String']['output']>;
  returnCountry?: Maybe<Scalars['String']['output']>;
  returnPhone?: Maybe<Scalars['String']['output']>;
  returnState?: Maybe<Scalars['String']['output']>;
  returnZip?: Maybe<Scalars['String']['output']>;
  rewardfulId?: Maybe<Scalars['String']['output']>;
  /** Whether the user has opted in to marketing SMS. Mirrored to HubSpot/Intercom. */
  smsMarketingConsent: Scalars['Boolean']['output'];
  socialNetwork?: Maybe<SocialNetwork>;
  socialUsername?: Maybe<Scalars['String']['output']>;
  stores?: Maybe<Array<UserStoreModel>>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePostPaymentCustomerId?: Maybe<Scalars['String']['output']>;
  suplifulCredits: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  useCustomReturnAddress: Scalars['Boolean']['output'];
  userCategory?: Maybe<UserCategory>;
  userCategoryOther?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  vip: Scalars['Boolean']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type UserNullableRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserOrderByWithRelationInput = {
  accounts?: InputMaybe<AccountOrderByRelationAggregateInput>;
  avatar?: InputMaybe<SortOrderInput>;
  becameActiveAt?: InputMaybe<SortOrderInput>;
  bic?: InputMaybe<SortOrderInput>;
  billingAddress1?: InputMaybe<SortOrderInput>;
  billingAddress2?: InputMaybe<SortOrderInput>;
  billingCity?: InputMaybe<SortOrderInput>;
  billingCountry?: InputMaybe<SortOrderInput>;
  billingName?: InputMaybe<SortOrderInput>;
  billingState?: InputMaybe<SortOrderInput>;
  billingZip?: InputMaybe<SortOrderInput>;
  bulkOrderPaymentKind?: InputMaybe<SortOrder>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<SortOrderInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<SortOrderInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateOrderByRelationAggregateInput>;
  completedOnboardingSteps?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deactivatedAt?: InputMaybe<SortOrderInput>;
  deactivationScheduledAt?: InputMaybe<SortOrderInput>;
  defaultPaymentProcessor?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailVerified?: InputMaybe<SortOrderInput>;
  emailVerifiedAt?: InputMaybe<SortOrderInput>;
  eoriNumber?: InputMaybe<SortOrderInput>;
  exemptEmailVerified?: InputMaybe<SortOrder>;
  exemptaxCustomerId?: InputMaybe<SortOrderInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<SortOrder>;
  fbaPaymentKind?: InputMaybe<SortOrder>;
  fbaPostPaymentDueDateDays?: InputMaybe<SortOrderInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<SortOrderInput>;
  files?: InputMaybe<UserProductFileOrderByRelationAggregateInput>;
  firstMonthDiscountAvailable?: InputMaybe<SortOrder>;
  firstSessionCampaign?: InputMaybe<SortOrderInput>;
  firstSessionCreative?: InputMaybe<SortOrderInput>;
  firstSessionDevice?: InputMaybe<SortOrderInput>;
  firstSessionGclid?: InputMaybe<SortOrderInput>;
  firstSessionKeyword?: InputMaybe<SortOrderInput>;
  firstSessionMedium?: InputMaybe<SortOrderInput>;
  firstSessionQueryParams?: InputMaybe<SortOrderInput>;
  firstSessionSet?: InputMaybe<SortOrderInput>;
  firstSessionSource?: InputMaybe<SortOrderInput>;
  firstSessionSourceMedium?: InputMaybe<SortOrderInput>;
  firstSessionType?: InputMaybe<SortOrderInput>;
  firstSessionUrl?: InputMaybe<SortOrderInput>;
  freeTrialEndsAt?: InputMaybe<SortOrderInput>;
  fullName?: InputMaybe<SortOrder>;
  hasCompletedOnboardingSteps?: InputMaybe<SortOrder>;
  hasCompletedOnboardingStepsAt?: InputMaybe<SortOrderInput>;
  hasPublishedFirstProduct?: InputMaybe<SortOrder>;
  hasSeenFreeTrialEndedModal?: InputMaybe<SortOrder>;
  hasSeenFreeTrialStartedModal?: InputMaybe<SortOrder>;
  hasSeenWelcomeModalAt?: InputMaybe<SortOrderInput>;
  hubspotContactId?: InputMaybe<SortOrderInput>;
  iban?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrderInput>;
  intercomId?: InputMaybe<SortOrderInput>;
  invoiceEmails?: InputMaybe<SortOrder>;
  invoices?: InputMaybe<UserInvoiceOrderByRelationAggregateInput>;
  isActive?: InputMaybe<SortOrder>;
  isBrandAcceleratorParticipant?: InputMaybe<SortOrder>;
  isDeactivated?: InputMaybe<SortOrder>;
  isDisabled?: InputMaybe<SortOrder>;
  isPostPaymentEnabled?: InputMaybe<SortOrder>;
  isPriorityLaneFulfillment?: InputMaybe<SortOrder>;
  labelAssets?: InputMaybe<UserLabelAssetOrderByRelationAggregateInput>;
  labelFonts?: InputMaybe<UserLabelFontOrderByRelationAggregateInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteOrderByRelationAggregateInput>;
  lastLogin?: InputMaybe<SortOrderInput>;
  lastSessionFbc?: InputMaybe<SortOrderInput>;
  lastSessionFbclid?: InputMaybe<SortOrderInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<SortOrderInput>;
  lastSessionFbp?: InputMaybe<SortOrderInput>;
  lastSessionGbraid?: InputMaybe<SortOrderInput>;
  lastSessionGclid?: InputMaybe<SortOrderInput>;
  lastSessionIp?: InputMaybe<SortOrderInput>;
  lastSessionLandingUrl?: InputMaybe<SortOrderInput>;
  lastSessionLiFatId?: InputMaybe<SortOrderInput>;
  lastSessionRdtCid?: InputMaybe<SortOrderInput>;
  lastSessionUpdatedAt?: InputMaybe<SortOrderInput>;
  lastSessionUserAgent?: InputMaybe<SortOrderInput>;
  lastSessionWbraid?: InputMaybe<SortOrderInput>;
  leadGenerated?: InputMaybe<SortOrderInput>;
  minimumPricingTier?: InputMaybe<SortOrder>;
  onboardingSurveyDone?: InputMaybe<SortOrder>;
  onboardingSurveyDoneAt?: InputMaybe<SortOrderInput>;
  orderLines?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  orders?: InputMaybe<UserProductOrderOrderByRelationAggregateInput>;
  password?: InputMaybe<SortOrderInput>;
  paymentMethods?: InputMaybe<PaymentMethodOrderByRelationAggregateInput>;
  phone?: InputMaybe<SortOrderInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketOrderByRelationAggregateInput>;
  postPaymentDueDateDays?: InputMaybe<SortOrder>;
  postPaymentDueDateDaysType?: InputMaybe<SortOrder>;
  postPaymentPeriodWeeks?: InputMaybe<SortOrder>;
  preventEmailNotifications?: InputMaybe<SortOrder>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<SortOrderInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<SortOrder>;
  products?: InputMaybe<UserProductOrderByRelationAggregateInput>;
  referral?: InputMaybe<SortOrderInput>;
  regNumber?: InputMaybe<SortOrderInput>;
  resetShopifyStockOnSellout?: InputMaybe<SortOrder>;
  returnAddress1?: InputMaybe<SortOrderInput>;
  returnAddress2?: InputMaybe<SortOrderInput>;
  returnCity?: InputMaybe<SortOrderInput>;
  returnCompany?: InputMaybe<SortOrderInput>;
  returnCountry?: InputMaybe<SortOrderInput>;
  returnPhone?: InputMaybe<SortOrderInput>;
  returnState?: InputMaybe<SortOrderInput>;
  returnZip?: InputMaybe<SortOrderInput>;
  rewardfulId?: InputMaybe<SortOrderInput>;
  servicePurchases?: InputMaybe<ServicePurchaseOrderByRelationAggregateInput>;
  sessions?: InputMaybe<SessionOrderByRelationAggregateInput>;
  smsMarketingConsent?: InputMaybe<SortOrder>;
  socialNetwork?: InputMaybe<SortOrderInput>;
  socialUsername?: InputMaybe<SortOrderInput>;
  stores?: InputMaybe<UserStoreOrderByRelationAggregateInput>;
  stripeCustomerId?: InputMaybe<SortOrderInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceOrderByRelationAggregateInput>;
  stripePostPaymentCustomerId?: InputMaybe<SortOrderInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementOrderByRelationAggregateInput>;
  subscriptions?: InputMaybe<UserSubscriptionOrderByRelationAggregateInput>;
  transactions?: InputMaybe<UserCreditsTransactionOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  useCustomReturnAddress?: InputMaybe<SortOrder>;
  userCategory?: InputMaybe<SortOrderInput>;
  userCategoryOther?: InputMaybe<SortOrderInput>;
  username?: InputMaybe<SortOrder>;
  vip?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrderInput>;
};

export enum UserPaymentProcessor {
  Shopify = 'SHOPIFY',
  Stripe = 'STRIPE'
}

export enum UserPostPaymentDueDateDaysType {
  Business = 'BUSINESS',
  Calendar = 'CALENDAR'
}

export type UserProduct = {
  __typename?: 'UserProduct';
  _count?: Maybe<UserProductCount>;
  baseId?: Maybe<Scalars['String']['output']>;
  clickfunnelsId?: Maybe<Scalars['String']['output']>;
  clickfunnelsVariantId?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<UserProductFile>;
  coverImageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customSkuId?: Maybe<Scalars['String']['output']>;
  defaultShippingPackage?: Maybe<ShippingPackage>;
  defaultShippingPackageId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eligibilityCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  eligibilityResult?: Maybe<Scalars['JSON']['output']>;
  eligibilityScore?: Maybe<Scalars['Float']['output']>;
  files: Array<UserProductFile>;
  generatedSku?: Maybe<Scalars['String']['output']>;
  hasInsert: Scalars['Boolean']['output'];
  hasUnpushedImageChanges: Scalars['Boolean']['output'];
  hasV1LabelFile: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insertImage?: Maybe<Scalars['String']['output']>;
  isOnboardingSampleLabel: Scalars['Boolean']['output'];
  isPrelabeled: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isSingleSkuBundle: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  labelDraft?: Maybe<UserProductLabelDraft>;
  labelId?: Maybe<Scalars['String']['output']>;
  layoutId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onboardingSampleSession?: Maybe<OnboardingSampleOrderSession>;
  onboardingSampleSessionId?: Maybe<Scalars['String']['output']>;
  prePaidUnits?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  pricePrePaid?: Maybe<Scalars['Float']['output']>;
  priceSpecial?: Maybe<Scalars['Float']['output']>;
  productSettings: ProductSettings;
  productSettingsId: Scalars['String']['output'];
  sanityProductId: Scalars['String']['output'];
  shipheroProductId?: Maybe<Scalars['String']['output']>;
  shipheroSampleProductId?: Maybe<Scalars['String']['output']>;
  shopifyId?: Maybe<Scalars['String']['output']>;
  shopifyVariantId?: Maybe<Scalars['String']['output']>;
  shortDescription: Scalars['String']['output'];
  singleSkuBundleQuantity?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  store?: Maybe<UserStore>;
  storeId?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  tiktokId?: Maybe<Scalars['String']['output']>;
  tiktokSkuId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  woocommerceId?: Maybe<Scalars['String']['output']>;
};


export type UserProductCoverImageArgs = {
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type UserProductDefaultShippingPackageArgs = {
  where?: InputMaybe<ShippingPackageWhereInput>;
};


export type UserProductFilesArgs = {
  cursor?: InputMaybe<UserProductFileWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductFileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductFileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type UserProductLabelDraftArgs = {
  where?: InputMaybe<UserProductLabelDraftWhereInput>;
};


export type UserProductOnboardingSampleSessionArgs = {
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};


export type UserProductStoreArgs = {
  where?: InputMaybe<UserStoreWhereInput>;
};

export type UserProductCount = {
  __typename?: 'UserProductCount';
  files: Scalars['Int']['output'];
  labelTransitions: Scalars['Int']['output'];
  labels: Scalars['Int']['output'];
  orderLines: Scalars['Int']['output'];
};


export type UserProductCountFilesArgs = {
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type UserProductCountLabelTransitionsArgs = {
  where?: InputMaybe<LabelTransitionWhereInput>;
};


export type UserProductCountLabelsArgs = {
  where?: InputMaybe<UserProductLabelWhereInput>;
};


export type UserProductCountOrderLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductCreateManyCoverImageInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackageId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  layoutId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettingsId: Scalars['String']['input'];
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateManyCoverImageInputEnvelope = {
  data: Array<UserProductCreateManyCoverImageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductCreateManyDefaultShippingPackageInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImageId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  layoutId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettingsId: Scalars['String']['input'];
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateManyDefaultShippingPackageInputEnvelope = {
  data: Array<UserProductCreateManyDefaultShippingPackageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductCreateManyProductSettingsInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImageId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackageId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  layoutId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateManyProductSettingsInputEnvelope = {
  data: Array<UserProductCreateManyProductSettingsInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductCreateManyStoreInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImageId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackageId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  layoutId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettingsId: Scalars['String']['input'];
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateManyStoreInputEnvelope = {
  data: Array<UserProductCreateManyStoreInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductCreateManyUserInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImageId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackageId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  layoutId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettingsId: Scalars['String']['input'];
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateManyUserInputEnvelope = {
  data: Array<UserProductCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductCreateNestedManyWithoutCoverImageInput = {
  connect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductCreateOrConnectWithoutCoverImageInput>>;
  create?: InputMaybe<Array<UserProductCreateWithoutCoverImageInput>>;
  createMany?: InputMaybe<UserProductCreateManyCoverImageInputEnvelope>;
};

export type UserProductCreateNestedManyWithoutDefaultShippingPackageInput = {
  connect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductCreateOrConnectWithoutDefaultShippingPackageInput>>;
  create?: InputMaybe<Array<UserProductCreateWithoutDefaultShippingPackageInput>>;
  createMany?: InputMaybe<UserProductCreateManyDefaultShippingPackageInputEnvelope>;
};

export type UserProductCreateNestedManyWithoutProductSettingsInput = {
  connect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductCreateOrConnectWithoutProductSettingsInput>>;
  create?: InputMaybe<Array<UserProductCreateWithoutProductSettingsInput>>;
  createMany?: InputMaybe<UserProductCreateManyProductSettingsInputEnvelope>;
};

export type UserProductCreateNestedManyWithoutStoreInput = {
  connect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductCreateOrConnectWithoutStoreInput>>;
  create?: InputMaybe<Array<UserProductCreateWithoutStoreInput>>;
  createMany?: InputMaybe<UserProductCreateManyStoreInputEnvelope>;
};

export type UserProductCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserProductCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserProductCreateManyUserInputEnvelope>;
};

export type UserProductCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<UserProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<UserProductCreateWithoutFilesInput>;
};

export type UserProductCreateNestedOneWithoutOnboardingSampleSessionInput = {
  connect?: InputMaybe<UserProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductCreateOrConnectWithoutOnboardingSampleSessionInput>;
  create?: InputMaybe<UserProductCreateWithoutOnboardingSampleSessionInput>;
};

export type UserProductCreateNestedOneWithoutOrderLinesInput = {
  connect?: InputMaybe<UserProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<UserProductCreateWithoutOrderLinesInput>;
};

export type UserProductCreateOrConnectWithoutCoverImageInput = {
  create: UserProductCreateWithoutCoverImageInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductCreateOrConnectWithoutDefaultShippingPackageInput = {
  create: UserProductCreateWithoutDefaultShippingPackageInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductCreateOrConnectWithoutFilesInput = {
  create: UserProductCreateWithoutFilesInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductCreateOrConnectWithoutOnboardingSampleSessionInput = {
  create: UserProductCreateWithoutOnboardingSampleSessionInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductCreateOrConnectWithoutOrderLinesInput = {
  create: UserProductCreateWithoutOrderLinesInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductCreateOrConnectWithoutProductSettingsInput = {
  create: UserProductCreateWithoutProductSettingsInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductCreateOrConnectWithoutStoreInput = {
  create: UserProductCreateWithoutStoreInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductCreateOrConnectWithoutUserInput = {
  create: UserProductCreateWithoutUserInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductCreateWithoutCoverImageInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageUserProductsInput>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserProductInput>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelDraft?: InputMaybe<UserProductLabelDraftCreateNestedOneWithoutUserProductInput>;
  name: Scalars['String']['input'];
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductInput>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettings: ProductSettingsCreateNestedOneWithoutUserProductsInput;
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductsInput>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutProductsInput;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateWithoutDefaultShippingPackageInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<UserProductFileCreateNestedOneWithoutUserProductsCoverImageInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserProductInput>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelDraft?: InputMaybe<UserProductLabelDraftCreateNestedOneWithoutUserProductInput>;
  name: Scalars['String']['input'];
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductInput>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettings: ProductSettingsCreateNestedOneWithoutUserProductsInput;
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductsInput>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutProductsInput;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateWithoutFilesInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<UserProductFileCreateNestedOneWithoutUserProductsCoverImageInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageUserProductsInput>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelDraft?: InputMaybe<UserProductLabelDraftCreateNestedOneWithoutUserProductInput>;
  name: Scalars['String']['input'];
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductInput>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettings: ProductSettingsCreateNestedOneWithoutUserProductsInput;
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductsInput>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutProductsInput;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateWithoutOnboardingSampleSessionInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<UserProductFileCreateNestedOneWithoutUserProductsCoverImageInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageUserProductsInput>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserProductInput>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelDraft?: InputMaybe<UserProductLabelDraftCreateNestedOneWithoutUserProductInput>;
  name: Scalars['String']['input'];
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettings: ProductSettingsCreateNestedOneWithoutUserProductsInput;
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductsInput>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutProductsInput;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateWithoutOrderLinesInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<UserProductFileCreateNestedOneWithoutUserProductsCoverImageInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageUserProductsInput>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserProductInput>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelDraft?: InputMaybe<UserProductLabelDraftCreateNestedOneWithoutUserProductInput>;
  name: Scalars['String']['input'];
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductInput>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettings: ProductSettingsCreateNestedOneWithoutUserProductsInput;
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductsInput>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutProductsInput;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateWithoutProductSettingsInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<UserProductFileCreateNestedOneWithoutUserProductsCoverImageInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageUserProductsInput>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserProductInput>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelDraft?: InputMaybe<UserProductLabelDraftCreateNestedOneWithoutUserProductInput>;
  name: Scalars['String']['input'];
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductInput>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductsInput>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutProductsInput;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateWithoutStoreInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<UserProductFileCreateNestedOneWithoutUserProductsCoverImageInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageUserProductsInput>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserProductInput>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelDraft?: InputMaybe<UserProductLabelDraftCreateNestedOneWithoutUserProductInput>;
  name: Scalars['String']['input'];
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductInput>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettings: ProductSettingsCreateNestedOneWithoutUserProductsInput;
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutProductsInput;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductCreateWithoutUserInput = {
  baseId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsVariantId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<UserProductFileCreateNestedOneWithoutUserProductsCoverImageInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customSkuId?: InputMaybe<Scalars['String']['input']>;
  defaultShippingPackage?: InputMaybe<ShippingPackageCreateNestedOneWithoutDefaultShippingPackageUserProductsInput>;
  description: Scalars['String']['input'];
  eligibilityCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<Scalars['Float']['input']>;
  files?: InputMaybe<UserProductFileCreateNestedManyWithoutUserProductInput>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnpushedImageChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<Scalars['String']['input']>;
  isOnboardingSampleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  isPrelabeled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSingleSkuBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  labelDraft?: InputMaybe<UserProductLabelDraftCreateNestedOneWithoutUserProductInput>;
  name: Scalars['String']['input'];
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductInput>;
  prePaidUnits?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  pricePrePaid?: InputMaybe<Scalars['Float']['input']>;
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  productSettings: ProductSettingsCreateNestedOneWithoutUserProductsInput;
  sanityProductId: Scalars['String']['input'];
  shipheroProductId?: InputMaybe<Scalars['String']['input']>;
  shipheroSampleProductId?: InputMaybe<Scalars['String']['input']>;
  shopifyId?: InputMaybe<Scalars['String']['input']>;
  shopifyVariantId?: InputMaybe<Scalars['String']['input']>;
  shortDescription: Scalars['String']['input'];
  singleSkuBundleQuantity?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductsInput>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  tiktokId?: InputMaybe<Scalars['String']['input']>;
  tiktokSkuId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  woocommerceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductFile = {
  __typename?: 'UserProductFile';
  _count?: Maybe<UserProductFileCount>;
  createdAt: Scalars['DateTime']['output'];
  fileKey: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /**
   * @deprecated No longer used, watermarking was removed. Will be dropped in a future release.
   * @ignored
   */
  isWatermarkApplied: Scalars['Boolean']['output'];
  kind: UserProductFileKind;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  userProductId: Scalars['String']['output'];
  userProductLabelMockupId?: Maybe<Scalars['String']['output']>;
};

export type UserProductFileCount = {
  __typename?: 'UserProductFileCount';
  labelTransitionSources: Scalars['Int']['output'];
  userProductLabelDesignPdfs: Scalars['Int']['output'];
  userProductLabelPrintPdfs: Scalars['Int']['output'];
  userProductsCoverImage: Scalars['Int']['output'];
};


export type UserProductFileCountLabelTransitionSourcesArgs = {
  where?: InputMaybe<LabelTransitionWhereInput>;
};


export type UserProductFileCountUserProductLabelDesignPdfsArgs = {
  where?: InputMaybe<UserProductLabelWhereInput>;
};


export type UserProductFileCountUserProductLabelPrintPdfsArgs = {
  where?: InputMaybe<UserProductLabelWhereInput>;
};


export type UserProductFileCountUserProductsCoverImageArgs = {
  where?: InputMaybe<UserProductWhereInput>;
};

export type UserProductFileCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isWatermarkApplied?: InputMaybe<Scalars['Boolean']['input']>;
  kind: UserProductFileKind;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductId: Scalars['String']['input'];
  userProductLabelMockupId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductFileCreateManyUserInputEnvelope = {
  data: Array<UserProductFileCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductFileCreateManyUserProductInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isWatermarkApplied?: InputMaybe<Scalars['Boolean']['input']>;
  kind: UserProductFileKind;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  userProductLabelMockupId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductFileCreateManyUserProductInputEnvelope = {
  data: Array<UserProductFileCreateManyUserProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductFileCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserProductFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductFileCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserProductFileCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserProductFileCreateManyUserInputEnvelope>;
};

export type UserProductFileCreateNestedManyWithoutUserProductInput = {
  connect?: InputMaybe<Array<UserProductFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductFileCreateOrConnectWithoutUserProductInput>>;
  create?: InputMaybe<Array<UserProductFileCreateWithoutUserProductInput>>;
  createMany?: InputMaybe<UserProductFileCreateManyUserProductInputEnvelope>;
};

export type UserProductFileCreateNestedOneWithoutUserProductsCoverImageInput = {
  connect?: InputMaybe<UserProductFileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductFileCreateOrConnectWithoutUserProductsCoverImageInput>;
  create?: InputMaybe<UserProductFileCreateWithoutUserProductsCoverImageInput>;
};

export type UserProductFileCreateOrConnectWithoutUserInput = {
  create: UserProductFileCreateWithoutUserInput;
  where: UserProductFileWhereUniqueInput;
};

export type UserProductFileCreateOrConnectWithoutUserProductInput = {
  create: UserProductFileCreateWithoutUserProductInput;
  where: UserProductFileWhereUniqueInput;
};

export type UserProductFileCreateOrConnectWithoutUserProductsCoverImageInput = {
  create: UserProductFileCreateWithoutUserProductsCoverImageInput;
  where: UserProductFileWhereUniqueInput;
};

export type UserProductFileCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isWatermarkApplied?: InputMaybe<Scalars['Boolean']['input']>;
  kind: UserProductFileKind;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProduct: UserProductCreateNestedOneWithoutFilesInput;
  userProductsCoverImage?: InputMaybe<UserProductCreateNestedManyWithoutCoverImageInput>;
};

export type UserProductFileCreateWithoutUserProductInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isWatermarkApplied?: InputMaybe<Scalars['Boolean']['input']>;
  kind: UserProductFileKind;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutFilesInput;
  userProductsCoverImage?: InputMaybe<UserProductCreateNestedManyWithoutCoverImageInput>;
};

export type UserProductFileCreateWithoutUserProductsCoverImageInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileKey: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isWatermarkApplied?: InputMaybe<Scalars['Boolean']['input']>;
  kind: UserProductFileKind;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutFilesInput;
  userProduct: UserProductCreateNestedOneWithoutFilesInput;
};

export enum UserProductFileKind {
  GalleryImage = 'GALLERY_IMAGE',
  GalleryImageGenerated = 'GALLERY_IMAGE_GENERATED',
  GalleryImageGeneratedRaw = 'GALLERY_IMAGE_GENERATED_RAW',
  LabelDesignImage = 'LABEL_DESIGN_IMAGE',
  LabelDesignPdf = 'LABEL_DESIGN_PDF',
  LabelDesignRaw = 'LABEL_DESIGN_RAW',
  LabelPreviewImage = 'LABEL_PREVIEW_IMAGE',
  PolotnoExportPdf = 'POLOTNO_EXPORT_PDF',
  ProductEditorImage = 'PRODUCT_EDITOR_IMAGE'
}

export type UserProductFileListRelationFilter = {
  every?: InputMaybe<UserProductFileWhereInput>;
  none?: InputMaybe<UserProductFileWhereInput>;
  some?: InputMaybe<UserProductFileWhereInput>;
};

export type UserProductFileNullableRelationFilter = {
  is?: InputMaybe<UserProductFileWhereInput>;
  isNot?: InputMaybe<UserProductFileWhereInput>;
};

export type UserProductFileOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserProductFileOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  fileKey?: InputMaybe<SortOrder>;
  fileName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isWatermarkApplied?: InputMaybe<SortOrder>;
  kind?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  userProduct?: InputMaybe<UserProductOrderByWithRelationInput>;
  userProductId?: InputMaybe<SortOrder>;
  userProductLabelMockupId?: InputMaybe<SortOrderInput>;
  userProductsCoverImage?: InputMaybe<UserProductOrderByRelationAggregateInput>;
};

export enum UserProductFileScalarFieldEnum {
  CreatedAt = 'createdAt',
  FileKey = 'fileKey',
  FileName = 'fileName',
  Id = 'id',
  IsWatermarkApplied = 'isWatermarkApplied',
  Kind = 'kind',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  UserProductId = 'userProductId',
  UserProductLabelMockupId = 'userProductLabelMockupId'
}

export type UserProductFileScalarWhereInput = {
  AND?: InputMaybe<Array<UserProductFileScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProductFileScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProductFileScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileKey?: InputMaybe<StringFilter>;
  fileName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isWatermarkApplied?: InputMaybe<BoolFilter>;
  kind?: InputMaybe<EnumUserProductFileKindFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProductId?: InputMaybe<UuidFilter>;
  userProductLabelMockupId?: InputMaybe<UuidNullableFilter>;
};

export type UserProductFileUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isWatermarkApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumUserProductFileKindFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserProductFileUpdateManyWithWhereWithoutUserInput = {
  data: UserProductFileUpdateManyMutationInput;
  where: UserProductFileScalarWhereInput;
};

export type UserProductFileUpdateManyWithWhereWithoutUserProductInput = {
  data: UserProductFileUpdateManyMutationInput;
  where: UserProductFileScalarWhereInput;
};

export type UserProductFileUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserProductFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductFileCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserProductFileCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserProductFileCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserProductFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductFileWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductFileWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductFileUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserProductFileUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserProductFileUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserProductFileUpdateManyWithoutUserProductNestedInput = {
  connect?: InputMaybe<Array<UserProductFileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductFileCreateOrConnectWithoutUserProductInput>>;
  create?: InputMaybe<Array<UserProductFileCreateWithoutUserProductInput>>;
  createMany?: InputMaybe<UserProductFileCreateManyUserProductInputEnvelope>;
  delete?: InputMaybe<Array<UserProductFileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductFileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductFileWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductFileWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductFileUpdateWithWhereUniqueWithoutUserProductInput>>;
  updateMany?: InputMaybe<Array<UserProductFileUpdateManyWithWhereWithoutUserProductInput>>;
  upsert?: InputMaybe<Array<UserProductFileUpsertWithWhereUniqueWithoutUserProductInput>>;
};

export type UserProductFileUpdateOneWithoutUserProductsCoverImageNestedInput = {
  connect?: InputMaybe<UserProductFileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductFileCreateOrConnectWithoutUserProductsCoverImageInput>;
  create?: InputMaybe<UserProductFileCreateWithoutUserProductsCoverImageInput>;
  delete?: InputMaybe<UserProductFileWhereInput>;
  disconnect?: InputMaybe<UserProductFileWhereInput>;
  update?: InputMaybe<UserProductFileUpdateToOneWithWhereWithoutUserProductsCoverImageInput>;
  upsert?: InputMaybe<UserProductFileUpsertWithoutUserProductsCoverImageInput>;
};

export type UserProductFileUpdateToOneWithWhereWithoutUserProductsCoverImageInput = {
  data: UserProductFileUpdateWithoutUserProductsCoverImageInput;
  where?: InputMaybe<UserProductFileWhereInput>;
};

export type UserProductFileUpdateWithWhereUniqueWithoutUserInput = {
  data: UserProductFileUpdateWithoutUserInput;
  where: UserProductFileWhereUniqueInput;
};

export type UserProductFileUpdateWithWhereUniqueWithoutUserProductInput = {
  data: UserProductFileUpdateWithoutUserProductInput;
  where: UserProductFileWhereUniqueInput;
};

export type UserProductFileUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isWatermarkApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumUserProductFileKindFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutFilesNestedInput>;
  userProductsCoverImage?: InputMaybe<UserProductUpdateManyWithoutCoverImageNestedInput>;
};

export type UserProductFileUpdateWithoutUserProductInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isWatermarkApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumUserProductFileKindFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutFilesNestedInput>;
  userProductsCoverImage?: InputMaybe<UserProductUpdateManyWithoutCoverImageNestedInput>;
};

export type UserProductFileUpdateWithoutUserProductsCoverImageInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isWatermarkApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumUserProductFileKindFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutFilesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutFilesNestedInput>;
};

export type UserProductFileUpsertWithWhereUniqueWithoutUserInput = {
  create: UserProductFileCreateWithoutUserInput;
  update: UserProductFileUpdateWithoutUserInput;
  where: UserProductFileWhereUniqueInput;
};

export type UserProductFileUpsertWithWhereUniqueWithoutUserProductInput = {
  create: UserProductFileCreateWithoutUserProductInput;
  update: UserProductFileUpdateWithoutUserProductInput;
  where: UserProductFileWhereUniqueInput;
};

export type UserProductFileUpsertWithoutUserProductsCoverImageInput = {
  create: UserProductFileCreateWithoutUserProductsCoverImageInput;
  update: UserProductFileUpdateWithoutUserProductsCoverImageInput;
  where?: InputMaybe<UserProductFileWhereInput>;
};

export type UserProductFileWhereInput = {
  AND?: InputMaybe<Array<UserProductFileWhereInput>>;
  NOT?: InputMaybe<Array<UserProductFileWhereInput>>;
  OR?: InputMaybe<Array<UserProductFileWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileKey?: InputMaybe<StringFilter>;
  fileName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isWatermarkApplied?: InputMaybe<BoolFilter>;
  kind?: InputMaybe<EnumUserProductFileKindFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProduct?: InputMaybe<UserProductRelationFilter>;
  userProductId?: InputMaybe<UuidFilter>;
  userProductLabelMockupId?: InputMaybe<UuidNullableFilter>;
  userProductsCoverImage?: InputMaybe<UserProductListRelationFilter>;
};

export type UserProductFileWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductFileWhereInput>>;
  NOT?: InputMaybe<Array<UserProductFileWhereInput>>;
  OR?: InputMaybe<Array<UserProductFileWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileKey?: InputMaybe<StringFilter>;
  fileName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isWatermarkApplied?: InputMaybe<BoolFilter>;
  kind?: InputMaybe<EnumUserProductFileKindFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProduct?: InputMaybe<UserProductRelationFilter>;
  userProductId?: InputMaybe<UuidFilter>;
  userProductLabelMockupId?: InputMaybe<UuidNullableFilter>;
  userProductsCoverImage?: InputMaybe<UserProductListRelationFilter>;
};

export type UserProductLabel = {
  __typename?: 'UserProductLabel';
  _count?: Maybe<UserProductLabelCount>;
  createdAt: Scalars['DateTime']['output'];
  designPdfId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  labelTransitionId?: Maybe<Scalars['String']['output']>;
  polotnoJson?: Maybe<Scalars['JSON']['output']>;
  previewImageId?: Maybe<Scalars['String']['output']>;
  printPdfId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userProductId: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedById?: Maybe<Scalars['String']['output']>;
};

export type UserProductLabelCount = {
  __typename?: 'UserProductLabelCount';
  currentForProducts: Scalars['Int']['output'];
  mockupImages: Scalars['Int']['output'];
  orderLines: Scalars['Int']['output'];
};


export type UserProductLabelCountCurrentForProductsArgs = {
  where?: InputMaybe<UserProductWhereInput>;
};


export type UserProductLabelCountMockupImagesArgs = {
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type UserProductLabelCountOrderLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductLabelCreateManyVerifiedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  designPdfId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  labelTransitionId?: InputMaybe<Scalars['String']['input']>;
  polotnoJson?: InputMaybe<Scalars['JSON']['input']>;
  previewImageId?: InputMaybe<Scalars['String']['input']>;
  printPdfId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductId: Scalars['String']['input'];
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProductLabelCreateManyVerifiedByInputEnvelope = {
  data: Array<UserProductLabelCreateManyVerifiedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductLabelCreateNestedOneWithoutOrderLinesInput = {
  connect?: InputMaybe<UserProductLabelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductLabelCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<UserProductLabelCreateWithoutOrderLinesInput>;
};

export type UserProductLabelCreateOrConnectWithoutOrderLinesInput = {
  create: UserProductLabelCreateWithoutOrderLinesInput;
  where: UserProductLabelWhereUniqueInput;
};

export type UserProductLabelCreateOrConnectWithoutVerifiedByInput = {
  create: UserProductLabelCreateWithoutVerifiedByInput;
  where: UserProductLabelWhereUniqueInput;
};

export type UserProductLabelCreateWithoutOrderLinesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  polotnoJson?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProductLabelCreateWithoutVerifiedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  polotnoJson?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProductLabelDraft = {
  __typename?: 'UserProductLabelDraft';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  polotnoJson: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userProductId: Scalars['String']['output'];
};

export type UserProductLabelDraftCreateNestedOneWithoutUserProductInput = {
  connect?: InputMaybe<UserProductLabelDraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductLabelDraftCreateOrConnectWithoutUserProductInput>;
  create?: InputMaybe<UserProductLabelDraftCreateWithoutUserProductInput>;
};

export type UserProductLabelDraftCreateOrConnectWithoutUserProductInput = {
  create: UserProductLabelDraftCreateWithoutUserProductInput;
  where: UserProductLabelDraftWhereUniqueInput;
};

export type UserProductLabelDraftCreateWithoutUserProductInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  polotnoJson: Scalars['JSON']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProductLabelDraftNullableRelationFilter = {
  is?: InputMaybe<UserProductLabelDraftWhereInput>;
  isNot?: InputMaybe<UserProductLabelDraftWhereInput>;
};

export type UserProductLabelDraftOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  polotnoJson?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userProduct?: InputMaybe<UserProductOrderByWithRelationInput>;
  userProductId?: InputMaybe<SortOrder>;
};

export type UserProductLabelDraftUpdateOneWithoutUserProductNestedInput = {
  connect?: InputMaybe<UserProductLabelDraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductLabelDraftCreateOrConnectWithoutUserProductInput>;
  create?: InputMaybe<UserProductLabelDraftCreateWithoutUserProductInput>;
  delete?: InputMaybe<UserProductLabelDraftWhereInput>;
  disconnect?: InputMaybe<UserProductLabelDraftWhereInput>;
  update?: InputMaybe<UserProductLabelDraftUpdateToOneWithWhereWithoutUserProductInput>;
  upsert?: InputMaybe<UserProductLabelDraftUpsertWithoutUserProductInput>;
};

export type UserProductLabelDraftUpdateToOneWithWhereWithoutUserProductInput = {
  data: UserProductLabelDraftUpdateWithoutUserProductInput;
  where?: InputMaybe<UserProductLabelDraftWhereInput>;
};

export type UserProductLabelDraftUpdateWithoutUserProductInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  polotnoJson?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserProductLabelDraftUpsertWithoutUserProductInput = {
  create: UserProductLabelDraftCreateWithoutUserProductInput;
  update: UserProductLabelDraftUpdateWithoutUserProductInput;
  where?: InputMaybe<UserProductLabelDraftWhereInput>;
};

export type UserProductLabelDraftWhereInput = {
  AND?: InputMaybe<Array<UserProductLabelDraftWhereInput>>;
  NOT?: InputMaybe<Array<UserProductLabelDraftWhereInput>>;
  OR?: InputMaybe<Array<UserProductLabelDraftWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  polotnoJson?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProduct?: InputMaybe<UserProductRelationFilter>;
  userProductId?: InputMaybe<UuidFilter>;
};

export type UserProductLabelDraftWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductLabelDraftWhereInput>>;
  NOT?: InputMaybe<Array<UserProductLabelDraftWhereInput>>;
  OR?: InputMaybe<Array<UserProductLabelDraftWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  polotnoJson?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProduct?: InputMaybe<UserProductRelationFilter>;
  userProductId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductLabelNullableRelationFilter = {
  is?: InputMaybe<UserProductLabelWhereInput>;
  isNot?: InputMaybe<UserProductLabelWhereInput>;
};

export type UserProductLabelOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  designPdfId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  labelTransitionId?: InputMaybe<SortOrderInput>;
  polotnoJson?: InputMaybe<SortOrderInput>;
  previewImageId?: InputMaybe<SortOrderInput>;
  printPdfId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userProductId?: InputMaybe<SortOrder>;
  verifiedAt?: InputMaybe<SortOrderInput>;
  verifiedById?: InputMaybe<SortOrderInput>;
};

export type UserProductLabelScalarWhereInput = {
  AND?: InputMaybe<Array<UserProductLabelScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProductLabelScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProductLabelScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  designPdfId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  labelTransitionId?: InputMaybe<UuidNullableFilter>;
  polotnoJson?: InputMaybe<JsonNullableFilter>;
  previewImageId?: InputMaybe<UuidNullableFilter>;
  printPdfId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProductId?: InputMaybe<UuidFilter>;
  verifiedAt?: InputMaybe<DateTimeNullableFilter>;
  verifiedById?: InputMaybe<UuidNullableFilter>;
};

export type UserProductLabelUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  polotnoJson?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserProductLabelUpdateManyWithWhereWithoutVerifiedByInput = {
  data: UserProductLabelUpdateManyMutationInput;
  where: UserProductLabelScalarWhereInput;
};

export type UserProductLabelUpdateManyWithoutVerifiedByNestedInput = {
  connect?: InputMaybe<Array<UserProductLabelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductLabelCreateOrConnectWithoutVerifiedByInput>>;
  create?: InputMaybe<Array<UserProductLabelCreateWithoutVerifiedByInput>>;
  createMany?: InputMaybe<UserProductLabelCreateManyVerifiedByInputEnvelope>;
  delete?: InputMaybe<Array<UserProductLabelWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductLabelScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductLabelWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductLabelWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductLabelUpdateWithWhereUniqueWithoutVerifiedByInput>>;
  updateMany?: InputMaybe<Array<UserProductLabelUpdateManyWithWhereWithoutVerifiedByInput>>;
  upsert?: InputMaybe<Array<UserProductLabelUpsertWithWhereUniqueWithoutVerifiedByInput>>;
};

export type UserProductLabelUpdateOneWithoutOrderLinesNestedInput = {
  connect?: InputMaybe<UserProductLabelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductLabelCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<UserProductLabelCreateWithoutOrderLinesInput>;
  delete?: InputMaybe<UserProductLabelWhereInput>;
  disconnect?: InputMaybe<UserProductLabelWhereInput>;
  update?: InputMaybe<UserProductLabelUpdateToOneWithWhereWithoutOrderLinesInput>;
  upsert?: InputMaybe<UserProductLabelUpsertWithoutOrderLinesInput>;
};

export type UserProductLabelUpdateToOneWithWhereWithoutOrderLinesInput = {
  data: UserProductLabelUpdateWithoutOrderLinesInput;
  where?: InputMaybe<UserProductLabelWhereInput>;
};

export type UserProductLabelUpdateWithWhereUniqueWithoutVerifiedByInput = {
  data: UserProductLabelUpdateWithoutVerifiedByInput;
  where: UserProductLabelWhereUniqueInput;
};

export type UserProductLabelUpdateWithoutOrderLinesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  polotnoJson?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserProductLabelUpdateWithoutVerifiedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  polotnoJson?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserProductLabelUpsertWithWhereUniqueWithoutVerifiedByInput = {
  create: UserProductLabelCreateWithoutVerifiedByInput;
  update: UserProductLabelUpdateWithoutVerifiedByInput;
  where: UserProductLabelWhereUniqueInput;
};

export type UserProductLabelUpsertWithoutOrderLinesInput = {
  create: UserProductLabelCreateWithoutOrderLinesInput;
  update: UserProductLabelUpdateWithoutOrderLinesInput;
  where?: InputMaybe<UserProductLabelWhereInput>;
};

export type UserProductLabelWhereInput = {
  AND?: InputMaybe<Array<UserProductLabelWhereInput>>;
  NOT?: InputMaybe<Array<UserProductLabelWhereInput>>;
  OR?: InputMaybe<Array<UserProductLabelWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  designPdfId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  labelTransitionId?: InputMaybe<UuidNullableFilter>;
  polotnoJson?: InputMaybe<JsonNullableFilter>;
  previewImageId?: InputMaybe<UuidNullableFilter>;
  printPdfId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProductId?: InputMaybe<UuidFilter>;
  verifiedAt?: InputMaybe<DateTimeNullableFilter>;
  verifiedById?: InputMaybe<UuidNullableFilter>;
};

export type UserProductLabelWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductLabelWhereInput>>;
  NOT?: InputMaybe<Array<UserProductLabelWhereInput>>;
  OR?: InputMaybe<Array<UserProductLabelWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  designPdfId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  labelTransitionId?: InputMaybe<Scalars['String']['input']>;
  polotnoJson?: InputMaybe<JsonNullableFilter>;
  previewImageId?: InputMaybe<Scalars['String']['input']>;
  printPdfId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userProductId?: InputMaybe<UuidFilter>;
  verifiedAt?: InputMaybe<DateTimeNullableFilter>;
  verifiedById?: InputMaybe<UuidNullableFilter>;
};

export type UserProductListRelationFilter = {
  every?: InputMaybe<UserProductWhereInput>;
  none?: InputMaybe<UserProductWhereInput>;
  some?: InputMaybe<UserProductWhereInput>;
};

export type UserProductModel = {
  __typename?: 'UserProductModel';
  _count?: Maybe<UserProductCount>;
  baseId?: Maybe<Scalars['String']['output']>;
  clickfunnelsId?: Maybe<Scalars['String']['output']>;
  clickfunnelsVariantId?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<UserProductFile>;
  coverImageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customSkuId?: Maybe<Scalars['String']['output']>;
  defaultShippingPackage?: Maybe<ShippingPackage>;
  defaultShippingPackageId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eligibilityCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  eligibilityResult?: Maybe<Scalars['JSON']['output']>;
  eligibilityScore?: Maybe<Scalars['Float']['output']>;
  files: Array<UserProductFile>;
  generatedSku?: Maybe<Scalars['String']['output']>;
  hasInsert: Scalars['Boolean']['output'];
  hasUnpushedImageChanges: Scalars['Boolean']['output'];
  hasV1LabelFile: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insertImage?: Maybe<Scalars['String']['output']>;
  isOnboardingSampleLabel: Scalars['Boolean']['output'];
  isPrelabeled: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isSingleSkuBundle: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  labelDraft?: Maybe<UserProductLabelDraft>;
  labelId?: Maybe<Scalars['String']['output']>;
  layoutId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onboardingSampleSession?: Maybe<OnboardingSampleOrderSession>;
  onboardingSampleSessionId?: Maybe<Scalars['String']['output']>;
  prePaidUnits?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  pricePrePaid?: Maybe<Scalars['Float']['output']>;
  priceSpecial?: Maybe<Scalars['Float']['output']>;
  productSettings: ProductSettingsModel;
  productSettingsId: Scalars['String']['output'];
  sanityProductId: Scalars['String']['output'];
  shipheroProductId?: Maybe<Scalars['String']['output']>;
  shipheroSampleProductId?: Maybe<Scalars['String']['output']>;
  shopifyId?: Maybe<Scalars['String']['output']>;
  shopifyVariantId?: Maybe<Scalars['String']['output']>;
  shortDescription: Scalars['String']['output'];
  singleSkuBundleQuantity?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  store?: Maybe<UserStore>;
  storeId?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  tiktokId?: Maybe<Scalars['String']['output']>;
  tiktokSkuId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  woocommerceId?: Maybe<Scalars['String']['output']>;
};


export type UserProductModelCoverImageArgs = {
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type UserProductModelDefaultShippingPackageArgs = {
  where?: InputMaybe<ShippingPackageWhereInput>;
};


export type UserProductModelFilesArgs = {
  cursor?: InputMaybe<UserProductFileWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductFileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductFileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type UserProductModelLabelDraftArgs = {
  where?: InputMaybe<UserProductLabelDraftWhereInput>;
};


export type UserProductModelOnboardingSampleSessionArgs = {
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};


export type UserProductModelStoreArgs = {
  where?: InputMaybe<UserStoreWhereInput>;
};

export type UserProductNullableRelationFilter = {
  is?: InputMaybe<UserProductWhereInput>;
  isNot?: InputMaybe<UserProductWhereInput>;
};

export type UserProductOrder = {
  __typename?: 'UserProductOrder';
  _count?: Maybe<UserProductOrderCount>;
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  billingAddress?: Maybe<UserProductOrderAddress>;
  billingAddressId?: Maybe<Scalars['String']['output']>;
  bulkDetails?: Maybe<UserProductOrderBulkDetails>;
  bulkDetailsId?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  chargeDiscount: Scalars['Float']['output'];
  chargeFulfillmentFee?: Maybe<Scalars['Float']['output']>;
  chargeProcessingFee?: Maybe<Scalars['Float']['output']>;
  chargeShipping?: Maybe<Scalars['Float']['output']>;
  chargeSubtotal?: Maybe<Scalars['Float']['output']>;
  clickfunnelsDetails?: Maybe<UserProductOrderClickFunnelsDetails>;
  clickfunnelsDetailsId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creditsPayments: Array<UserCreditsTransaction>;
  creditsRefund: Array<UserCreditsTransaction>;
  currency: Scalars['String']['output'];
  currencyConversionRate: Scalars['Float']['output'];
  customOnHoldReasons: Array<CustomOnHoldReason>;
  details?: Maybe<UserProductOrderDetails>;
  detailsId?: Maybe<Scalars['String']['output']>;
  everlabOrders: Array<EverlabOrder>;
  fbaDetails?: Maybe<UserProductOrderFbaDetails>;
  fbaDetailsId?: Maybe<Scalars['String']['output']>;
  fulfillmentDeadline?: Maybe<Scalars['DateTime']['output']>;
  holdReasonIntervals: Array<UserProductOrderOnHoldReasonInterval>;
  holdStatusIntervals: Array<UserProductOrderHoldStatusInterval>;
  id: Scalars['String']['output'];
  invoiceMode: InvoiceMode;
  invoices: Array<UserInvoice>;
  isPriorityLaneFulfillment: Scalars['Boolean']['output'];
  isReplacement: Scalars['Boolean']['output'];
  itemCountByWarehouse: Array<UserProductOrderItemCountByWarehouse>;
  itemCountTotal: Scalars['Int']['output'];
  jetpackApiOrders: Array<JetpackApiOrder>;
  kind: UserProductOrderKind;
  legacyOrderId?: Maybe<Scalars['String']['output']>;
  lineItemsCount?: Maybe<Scalars['Int']['output']>;
  lines: Array<UserProductOrderLine>;
  lockedBy?: Maybe<Admin>;
  lockedById?: Maybe<Scalars['String']['output']>;
  onHold: Scalars['Boolean']['output'];
  onHoldReasons: Array<OnHoldReason>;
  onboardingSampleSession?: Maybe<OnboardingSampleOrderSession>;
  onboardingSampleSessionId?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  originalCurrency: Scalars['String']['output'];
  originalOrder?: Maybe<UserProductOrder>;
  originalOrderId?: Maybe<Scalars['String']['output']>;
  /** This field to eventually replace details.charged. Currently optional and write-only */
  paymentStatus?: Maybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: Maybe<PostPaymentOrdersBucket>;
  postPaymentBucketId?: Maybe<Scalars['String']['output']>;
  productDiscount: Scalars['Float']['output'];
  replacementOrders: Array<UserProductOrder>;
  roastifyOrders: Array<RoastifyOrder>;
  sampleDiscountApplied: Scalars['Boolean']['output'];
  sampleExpressShippingApplied: Scalars['Boolean']['output'];
  sent: Scalars['Boolean']['output'];
  shipbobOrders: Array<ShipbobOrder>;
  shipheroOrderId?: Maybe<Scalars['String']['output']>;
  shipments: Array<Shipment>;
  shippingAddress?: Maybe<UserProductOrderAddress>;
  shippingAddressId?: Maybe<Scalars['String']['output']>;
  shopifyDetails?: Maybe<UserProductOrderShopifyDetails>;
  shopifyDetailsId?: Maybe<Scalars['String']['output']>;
  status: UserProductOrderStatus;
  store?: Maybe<UserStore>;
  storeId?: Maybe<Scalars['String']['output']>;
  stripeInvoices: Array<StripeInvoice>;
  stripePaymentId?: Maybe<Scalars['String']['output']>;
  tiktokDetails?: Maybe<UserProductOrderTiktokDetails>;
  tiktokDetailsId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
  warehouseShelfBins: Array<WarehouseShelfBin>;
  warehouseShelfReturnBin?: Maybe<WarehouseShelfReturnBin>;
  warehouseShelfReturnBinId?: Maybe<Scalars['String']['output']>;
};


export type UserProductOrderBillingAddressArgs = {
  where?: InputMaybe<UserProductOrderAddressWhereInput>;
};


export type UserProductOrderBulkDetailsArgs = {
  where?: InputMaybe<UserProductOrderBulkDetailsWhereInput>;
};


export type UserProductOrderClickfunnelsDetailsArgs = {
  where?: InputMaybe<UserProductOrderClickFunnelsDetailsWhereInput>;
};


export type UserProductOrderCreditsPaymentsArgs = {
  cursor?: InputMaybe<UserCreditsTransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserCreditsTransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserCreditsTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserCreditsTransactionWhereInput>;
};


export type UserProductOrderCreditsRefundArgs = {
  cursor?: InputMaybe<UserCreditsTransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserCreditsTransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserCreditsTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserCreditsTransactionWhereInput>;
};


export type UserProductOrderCustomOnHoldReasonsArgs = {
  cursor?: InputMaybe<CustomOnHoldReasonWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomOnHoldReasonScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomOnHoldReasonOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomOnHoldReasonWhereInput>;
};


export type UserProductOrderDetailsArgs = {
  where?: InputMaybe<UserProductOrderDetailsWhereInput>;
};


export type UserProductOrderEverlabOrdersArgs = {
  cursor?: InputMaybe<EverlabOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<EverlabOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EverlabOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EverlabOrderWhereInput>;
};


export type UserProductOrderFbaDetailsArgs = {
  where?: InputMaybe<UserProductOrderFbaDetailsWhereInput>;
};


export type UserProductOrderHoldReasonIntervalsArgs = {
  cursor?: InputMaybe<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderOnHoldReasonIntervalWhereInput>;
};


export type UserProductOrderHoldStatusIntervalsArgs = {
  cursor?: InputMaybe<UserProductOrderHoldStatusIntervalWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderHoldStatusIntervalScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderHoldStatusIntervalOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderHoldStatusIntervalWhereInput>;
};


export type UserProductOrderInvoicesArgs = {
  cursor?: InputMaybe<UserInvoiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserInvoiceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserInvoiceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserInvoiceWhereInput>;
};


export type UserProductOrderItemCountByWarehouseArgs = {
  cursor?: InputMaybe<UserProductOrderItemCountByWarehouseWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderItemCountByWarehouseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderItemCountByWarehouseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderItemCountByWarehouseWhereInput>;
};


export type UserProductOrderJetpackApiOrdersArgs = {
  cursor?: InputMaybe<JetpackApiOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<JetpackApiOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<JetpackApiOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<JetpackApiOrderWhereInput>;
};


export type UserProductOrderLinesArgs = {
  cursor?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type UserProductOrderLockedByArgs = {
  where?: InputMaybe<AdminWhereInput>;
};


export type UserProductOrderOnboardingSampleSessionArgs = {
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};


export type UserProductOrderOriginalOrderArgs = {
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type UserProductOrderPostPaymentBucketArgs = {
  where?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
};


export type UserProductOrderReplacementOrdersArgs = {
  cursor?: InputMaybe<UserProductOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type UserProductOrderRoastifyOrdersArgs = {
  cursor?: InputMaybe<RoastifyOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<RoastifyOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoastifyOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoastifyOrderWhereInput>;
};


export type UserProductOrderShipbobOrdersArgs = {
  cursor?: InputMaybe<ShipbobOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShipbobOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShipbobOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ShipbobOrderWhereInput>;
};


export type UserProductOrderShipmentsArgs = {
  cursor?: InputMaybe<ShipmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShipmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShipmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ShipmentWhereInput>;
};


export type UserProductOrderShippingAddressArgs = {
  where?: InputMaybe<UserProductOrderAddressWhereInput>;
};


export type UserProductOrderShopifyDetailsArgs = {
  where?: InputMaybe<UserProductOrderShopifyDetailsWhereInput>;
};


export type UserProductOrderStoreArgs = {
  where?: InputMaybe<UserStoreWhereInput>;
};


export type UserProductOrderStripeInvoicesArgs = {
  cursor?: InputMaybe<StripeInvoiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<StripeInvoiceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StripeInvoiceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StripeInvoiceWhereInput>;
};


export type UserProductOrderTiktokDetailsArgs = {
  where?: InputMaybe<UserProductOrderTiktokDetailsWhereInput>;
};


export type UserProductOrderWarehouseShelfBinsArgs = {
  cursor?: InputMaybe<WarehouseShelfBinWhereUniqueInput>;
  distinct?: InputMaybe<Array<WarehouseShelfBinScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WarehouseShelfBinOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WarehouseShelfBinWhereInput>;
};


export type UserProductOrderWarehouseShelfReturnBinArgs = {
  where?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
};

export type UserProductOrderAddress = {
  __typename?: 'UserProductOrderAddress';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput = {
  connect?: InputMaybe<UserProductOrderAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderAddressCreateOrConnectWithoutOrderBillingInput>;
  create?: InputMaybe<UserProductOrderAddressCreateWithoutOrderBillingInput>;
};

export type UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput = {
  connect?: InputMaybe<UserProductOrderAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderAddressCreateOrConnectWithoutOrderShippingInput>;
  create?: InputMaybe<UserProductOrderAddressCreateWithoutOrderShippingInput>;
};

export type UserProductOrderAddressCreateOrConnectWithoutOrderBillingInput = {
  create: UserProductOrderAddressCreateWithoutOrderBillingInput;
  where: UserProductOrderAddressWhereUniqueInput;
};

export type UserProductOrderAddressCreateOrConnectWithoutOrderShippingInput = {
  create: UserProductOrderAddressCreateWithoutOrderShippingInput;
  where: UserProductOrderAddressWhereUniqueInput;
};

export type UserProductOrderAddressCreateWithoutOrderBillingInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderShipping?: InputMaybe<UserProductOrderCreateNestedOneWithoutShippingAddressInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type UserProductOrderAddressCreateWithoutOrderShippingInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderBilling?: InputMaybe<UserProductOrderCreateNestedOneWithoutBillingAddressInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type UserProductOrderAddressModel = {
  __typename?: 'UserProductOrderAddressModel';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type UserProductOrderAddressNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderAddressWhereInput>;
  isNot?: InputMaybe<UserProductOrderAddressWhereInput>;
};

export type UserProductOrderAddressOrderByWithRelationInput = {
  address1?: InputMaybe<SortOrder>;
  address2?: InputMaybe<SortOrderInput>;
  city?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrderInput>;
  countryCode?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orderBilling?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  orderShipping?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  phone?: InputMaybe<SortOrderInput>;
  stateCode?: InputMaybe<SortOrderInput>;
  zip?: InputMaybe<SortOrder>;
};

export type UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput = {
  connect?: InputMaybe<UserProductOrderAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderAddressCreateOrConnectWithoutOrderBillingInput>;
  create?: InputMaybe<UserProductOrderAddressCreateWithoutOrderBillingInput>;
  delete?: InputMaybe<UserProductOrderAddressWhereInput>;
  disconnect?: InputMaybe<UserProductOrderAddressWhereInput>;
  update?: InputMaybe<UserProductOrderAddressUpdateToOneWithWhereWithoutOrderBillingInput>;
  upsert?: InputMaybe<UserProductOrderAddressUpsertWithoutOrderBillingInput>;
};

export type UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput = {
  connect?: InputMaybe<UserProductOrderAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderAddressCreateOrConnectWithoutOrderShippingInput>;
  create?: InputMaybe<UserProductOrderAddressCreateWithoutOrderShippingInput>;
  delete?: InputMaybe<UserProductOrderAddressWhereInput>;
  disconnect?: InputMaybe<UserProductOrderAddressWhereInput>;
  update?: InputMaybe<UserProductOrderAddressUpdateToOneWithWhereWithoutOrderShippingInput>;
  upsert?: InputMaybe<UserProductOrderAddressUpsertWithoutOrderShippingInput>;
};

export type UserProductOrderAddressUpdateToOneWithWhereWithoutOrderBillingInput = {
  data: UserProductOrderAddressUpdateWithoutOrderBillingInput;
  where?: InputMaybe<UserProductOrderAddressWhereInput>;
};

export type UserProductOrderAddressUpdateToOneWithWhereWithoutOrderShippingInput = {
  data: UserProductOrderAddressUpdateWithoutOrderShippingInput;
  where?: InputMaybe<UserProductOrderAddressWhereInput>;
};

export type UserProductOrderAddressUpdateWithoutOrderBillingInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderShipping?: InputMaybe<UserProductOrderUpdateOneWithoutShippingAddressNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProductOrderAddressUpdateWithoutOrderShippingInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  company?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<UserProductOrderUpdateOneWithoutBillingAddressNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProductOrderAddressUpsertWithoutOrderBillingInput = {
  create: UserProductOrderAddressCreateWithoutOrderBillingInput;
  update: UserProductOrderAddressUpdateWithoutOrderBillingInput;
  where?: InputMaybe<UserProductOrderAddressWhereInput>;
};

export type UserProductOrderAddressUpsertWithoutOrderShippingInput = {
  create: UserProductOrderAddressCreateWithoutOrderShippingInput;
  update: UserProductOrderAddressUpdateWithoutOrderShippingInput;
  where?: InputMaybe<UserProductOrderAddressWhereInput>;
};

export type UserProductOrderAddressWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderAddressWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderAddressWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderAddressWhereInput>>;
  address1?: InputMaybe<StringFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  company?: InputMaybe<StringNullableFilter>;
  countryCode?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  lastName?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  orderBilling?: InputMaybe<UserProductOrderNullableRelationFilter>;
  orderShipping?: InputMaybe<UserProductOrderNullableRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  stateCode?: InputMaybe<StringNullableFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type UserProductOrderAddressWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderAddressWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderAddressWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderAddressWhereInput>>;
  address1?: InputMaybe<StringFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  company?: InputMaybe<StringNullableFilter>;
  countryCode?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  orderBilling?: InputMaybe<UserProductOrderNullableRelationFilter>;
  orderShipping?: InputMaybe<UserProductOrderNullableRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  stateCode?: InputMaybe<StringNullableFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type UserProductOrderBulkDetails = {
  __typename?: 'UserProductOrderBulkDetails';
  id: Scalars['String']['output'];
  paymentKind: UserProductOrderManualPaymentKind;
  paymentStatus: UserProductOrderManualPaymentStatus;
  postPaymentDueDateDays?: Maybe<Scalars['Int']['output']>;
  postPaymentDueDateDaysType?: Maybe<UserPostPaymentDueDateDaysType>;
};

export type UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<UserProductOrderBulkDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderBulkDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderBulkDetailsCreateWithoutOrderInput>;
};

export type UserProductOrderBulkDetailsCreateOrConnectWithoutOrderInput = {
  create: UserProductOrderBulkDetailsCreateWithoutOrderInput;
  where: UserProductOrderBulkDetailsWhereUniqueInput;
};

export type UserProductOrderBulkDetailsCreateWithoutOrderInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  paymentKind: UserProductOrderManualPaymentKind;
  paymentStatus?: InputMaybe<UserProductOrderManualPaymentStatus>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
};

export type UserProductOrderBulkDetailsNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderBulkDetailsWhereInput>;
  isNot?: InputMaybe<UserProductOrderBulkDetailsWhereInput>;
};

export type UserProductOrderBulkDetailsOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  paymentKind?: InputMaybe<SortOrder>;
  paymentStatus?: InputMaybe<SortOrder>;
  postPaymentDueDateDays?: InputMaybe<SortOrderInput>;
  postPaymentDueDateDaysType?: InputMaybe<SortOrderInput>;
};

export type UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<UserProductOrderBulkDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderBulkDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderBulkDetailsCreateWithoutOrderInput>;
  delete?: InputMaybe<UserProductOrderBulkDetailsWhereInput>;
  disconnect?: InputMaybe<UserProductOrderBulkDetailsWhereInput>;
  update?: InputMaybe<UserProductOrderBulkDetailsUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<UserProductOrderBulkDetailsUpsertWithoutOrderInput>;
};

export type UserProductOrderBulkDetailsUpdateToOneWithWhereWithoutOrderInput = {
  data: UserProductOrderBulkDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderBulkDetailsWhereInput>;
};

export type UserProductOrderBulkDetailsUpdateWithoutOrderInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  paymentStatus?: InputMaybe<EnumUserProductOrderManualPaymentStatusFieldUpdateOperationsInput>;
  postPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
};

export type UserProductOrderBulkDetailsUpsertWithoutOrderInput = {
  create: UserProductOrderBulkDetailsCreateWithoutOrderInput;
  update: UserProductOrderBulkDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderBulkDetailsWhereInput>;
};

export type UserProductOrderBulkDetailsWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderBulkDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderBulkDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderBulkDetailsWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  paymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFilter>;
  paymentStatus?: InputMaybe<EnumUserProductOrderManualPaymentStatusFilter>;
  postPaymentDueDateDays?: InputMaybe<IntNullableFilter>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeNullableFilter>;
};

export type UserProductOrderBulkDetailsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderBulkDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderBulkDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderBulkDetailsWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  paymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFilter>;
  paymentStatus?: InputMaybe<EnumUserProductOrderManualPaymentStatusFilter>;
  postPaymentDueDateDays?: InputMaybe<IntNullableFilter>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeNullableFilter>;
};

export type UserProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserProductOrderByWithRelationInput = {
  baseId?: InputMaybe<SortOrderInput>;
  clickfunnelsId?: InputMaybe<SortOrderInput>;
  clickfunnelsVariantId?: InputMaybe<SortOrderInput>;
  coverImage?: InputMaybe<UserProductFileOrderByWithRelationInput>;
  coverImageId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customSkuId?: InputMaybe<SortOrderInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageOrderByWithRelationInput>;
  defaultShippingPackageId?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrder>;
  eligibilityCheckedAt?: InputMaybe<SortOrderInput>;
  eligibilityResult?: InputMaybe<SortOrderInput>;
  eligibilityScore?: InputMaybe<SortOrderInput>;
  files?: InputMaybe<UserProductFileOrderByRelationAggregateInput>;
  generatedSku?: InputMaybe<SortOrderInput>;
  hasInsert?: InputMaybe<SortOrder>;
  hasUnpushedImageChanges?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  insertImage?: InputMaybe<SortOrderInput>;
  isOnboardingSampleLabel?: InputMaybe<SortOrder>;
  isPrelabeled?: InputMaybe<SortOrder>;
  isPublished?: InputMaybe<SortOrder>;
  isSingleSkuBundle?: InputMaybe<SortOrder>;
  isVisible?: InputMaybe<SortOrder>;
  labelDraft?: InputMaybe<UserProductLabelDraftOrderByWithRelationInput>;
  labelId?: InputMaybe<SortOrderInput>;
  layoutId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionOrderByWithRelationInput>;
  onboardingSampleSessionId?: InputMaybe<SortOrderInput>;
  prePaidUnits?: InputMaybe<SortOrderInput>;
  price?: InputMaybe<SortOrder>;
  pricePrePaid?: InputMaybe<SortOrderInput>;
  priceSpecial?: InputMaybe<SortOrderInput>;
  productSettings?: InputMaybe<ProductSettingsOrderByWithRelationInput>;
  productSettingsId?: InputMaybe<SortOrder>;
  sanityProductId?: InputMaybe<SortOrder>;
  shipheroProductId?: InputMaybe<SortOrderInput>;
  shipheroSampleProductId?: InputMaybe<SortOrderInput>;
  shopifyId?: InputMaybe<SortOrderInput>;
  shopifyVariantId?: InputMaybe<SortOrderInput>;
  shortDescription?: InputMaybe<SortOrder>;
  singleSkuBundleQuantity?: InputMaybe<SortOrderInput>;
  slug?: InputMaybe<SortOrder>;
  store?: InputMaybe<UserStoreOrderByWithRelationInput>;
  storeId?: InputMaybe<SortOrderInput>;
  supplierId?: InputMaybe<SortOrderInput>;
  tiktokId?: InputMaybe<SortOrderInput>;
  tiktokSkuId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
  woocommerceId?: InputMaybe<SortOrderInput>;
};

export type UserProductOrderClickFunnelsDetails = {
  __typename?: 'UserProductOrderClickFunnelsDetails';
  clickfunnelsInvoiceId: Scalars['String']['output'];
  clickfunnelsOrderId: Scalars['String']['output'];
  contactId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  orderType: Scalars['String']['output'];
};

export type UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<UserProductOrderClickFunnelsDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateWithoutOrderInput>;
};

export type UserProductOrderClickFunnelsDetailsCreateOrConnectWithoutOrderInput = {
  create: UserProductOrderClickFunnelsDetailsCreateWithoutOrderInput;
  where: UserProductOrderClickFunnelsDetailsWhereUniqueInput;
};

export type UserProductOrderClickFunnelsDetailsCreateWithoutOrderInput = {
  clickfunnelsInvoiceId: Scalars['String']['input'];
  clickfunnelsOrderId: Scalars['String']['input'];
  contactId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  orderNumber: Scalars['String']['input'];
  orderType: Scalars['String']['input'];
};

export type UserProductOrderClickFunnelsDetailsNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderClickFunnelsDetailsWhereInput>;
  isNot?: InputMaybe<UserProductOrderClickFunnelsDetailsWhereInput>;
};

export type UserProductOrderClickFunnelsDetailsOrderByWithRelationInput = {
  clickfunnelsInvoiceId?: InputMaybe<SortOrder>;
  clickfunnelsOrderId?: InputMaybe<SortOrder>;
  contactId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  orderNumber?: InputMaybe<SortOrder>;
  orderType?: InputMaybe<SortOrder>;
};

export type UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<UserProductOrderClickFunnelsDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateWithoutOrderInput>;
  delete?: InputMaybe<UserProductOrderClickFunnelsDetailsWhereInput>;
  disconnect?: InputMaybe<UserProductOrderClickFunnelsDetailsWhereInput>;
  update?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<UserProductOrderClickFunnelsDetailsUpsertWithoutOrderInput>;
};

export type UserProductOrderClickFunnelsDetailsUpdateToOneWithWhereWithoutOrderInput = {
  data: UserProductOrderClickFunnelsDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderClickFunnelsDetailsWhereInput>;
};

export type UserProductOrderClickFunnelsDetailsUpdateWithoutOrderInput = {
  clickfunnelsInvoiceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  clickfunnelsOrderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  contactId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderType?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProductOrderClickFunnelsDetailsUpsertWithoutOrderInput = {
  create: UserProductOrderClickFunnelsDetailsCreateWithoutOrderInput;
  update: UserProductOrderClickFunnelsDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderClickFunnelsDetailsWhereInput>;
};

export type UserProductOrderClickFunnelsDetailsWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderClickFunnelsDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderClickFunnelsDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderClickFunnelsDetailsWhereInput>>;
  clickfunnelsInvoiceId?: InputMaybe<StringFilter>;
  clickfunnelsOrderId?: InputMaybe<StringFilter>;
  contactId?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  orderNumber?: InputMaybe<StringFilter>;
  orderType?: InputMaybe<StringFilter>;
};

export type UserProductOrderClickFunnelsDetailsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderClickFunnelsDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderClickFunnelsDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderClickFunnelsDetailsWhereInput>>;
  clickfunnelsInvoiceId?: InputMaybe<Scalars['String']['input']>;
  clickfunnelsOrderId?: InputMaybe<StringFilter>;
  contactId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  orderNumber?: InputMaybe<StringFilter>;
  orderType?: InputMaybe<StringFilter>;
};

export type UserProductOrderCount = {
  __typename?: 'UserProductOrderCount';
  creditsPayments: Scalars['Int']['output'];
  creditsRefund: Scalars['Int']['output'];
  customOnHoldReasons: Scalars['Int']['output'];
  everlabOrders: Scalars['Int']['output'];
  holdReasonIntervals: Scalars['Int']['output'];
  holdStatusIntervals: Scalars['Int']['output'];
  invoices: Scalars['Int']['output'];
  itemCountByWarehouse: Scalars['Int']['output'];
  jetpackApiOrders: Scalars['Int']['output'];
  lines: Scalars['Int']['output'];
  replacementOrders: Scalars['Int']['output'];
  roastifyOrders: Scalars['Int']['output'];
  shipbobOrders: Scalars['Int']['output'];
  shipments: Scalars['Int']['output'];
  stripeInvoices: Scalars['Int']['output'];
  warehouseShelfBins: Scalars['Int']['output'];
};


export type UserProductOrderCountCreditsPaymentsArgs = {
  where?: InputMaybe<UserCreditsTransactionWhereInput>;
};


export type UserProductOrderCountCreditsRefundArgs = {
  where?: InputMaybe<UserCreditsTransactionWhereInput>;
};


export type UserProductOrderCountCustomOnHoldReasonsArgs = {
  where?: InputMaybe<CustomOnHoldReasonWhereInput>;
};


export type UserProductOrderCountEverlabOrdersArgs = {
  where?: InputMaybe<EverlabOrderWhereInput>;
};


export type UserProductOrderCountHoldReasonIntervalsArgs = {
  where?: InputMaybe<UserProductOrderOnHoldReasonIntervalWhereInput>;
};


export type UserProductOrderCountHoldStatusIntervalsArgs = {
  where?: InputMaybe<UserProductOrderHoldStatusIntervalWhereInput>;
};


export type UserProductOrderCountInvoicesArgs = {
  where?: InputMaybe<UserInvoiceWhereInput>;
};


export type UserProductOrderCountItemCountByWarehouseArgs = {
  where?: InputMaybe<UserProductOrderItemCountByWarehouseWhereInput>;
};


export type UserProductOrderCountJetpackApiOrdersArgs = {
  where?: InputMaybe<JetpackApiOrderWhereInput>;
};


export type UserProductOrderCountLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type UserProductOrderCountReplacementOrdersArgs = {
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type UserProductOrderCountRoastifyOrdersArgs = {
  where?: InputMaybe<RoastifyOrderWhereInput>;
};


export type UserProductOrderCountShipbobOrdersArgs = {
  where?: InputMaybe<ShipbobOrderWhereInput>;
};


export type UserProductOrderCountShipmentsArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};


export type UserProductOrderCountStripeInvoicesArgs = {
  where?: InputMaybe<StripeInvoiceWhereInput>;
};


export type UserProductOrderCountWarehouseShelfBinsArgs = {
  where?: InputMaybe<WarehouseShelfBinWhereInput>;
};

export type UserProductOrderCreateManyLockedByInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
  bulkDetailsId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetailsId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  fbaDetailsId?: InputMaybe<Scalars['String']['input']>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrderId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucketId?: InputMaybe<Scalars['String']['input']>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shippingAddressId?: InputMaybe<Scalars['String']['input']>;
  shopifyDetailsId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserProductOrderStatus>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  tiktokDetailsId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  warehouseShelfReturnBinId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderCreateManyLockedByInputEnvelope = {
  data: Array<UserProductOrderCreateManyLockedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderCreateManyOriginalOrderInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
  bulkDetailsId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetailsId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  fbaDetailsId?: InputMaybe<Scalars['String']['input']>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lockedById?: InputMaybe<Scalars['String']['input']>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucketId?: InputMaybe<Scalars['String']['input']>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shippingAddressId?: InputMaybe<Scalars['String']['input']>;
  shopifyDetailsId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserProductOrderStatus>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  tiktokDetailsId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  warehouseShelfReturnBinId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderCreateManyOriginalOrderInputEnvelope = {
  data: Array<UserProductOrderCreateManyOriginalOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderCreateManyPostPaymentBucketInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
  bulkDetailsId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetailsId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  fbaDetailsId?: InputMaybe<Scalars['String']['input']>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lockedById?: InputMaybe<Scalars['String']['input']>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrderId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shippingAddressId?: InputMaybe<Scalars['String']['input']>;
  shopifyDetailsId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserProductOrderStatus>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  tiktokDetailsId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  warehouseShelfReturnBinId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderCreateManyPostPaymentBucketInputEnvelope = {
  data: Array<UserProductOrderCreateManyPostPaymentBucketInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderCreateManyStoreInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
  bulkDetailsId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetailsId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  fbaDetailsId?: InputMaybe<Scalars['String']['input']>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lockedById?: InputMaybe<Scalars['String']['input']>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrderId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucketId?: InputMaybe<Scalars['String']['input']>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shippingAddressId?: InputMaybe<Scalars['String']['input']>;
  shopifyDetailsId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserProductOrderStatus>;
  tiktokDetailsId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
  warehouseShelfReturnBinId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderCreateManyStoreInputEnvelope = {
  data: Array<UserProductOrderCreateManyStoreInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderCreateManyUserInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
  bulkDetailsId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetailsId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  fbaDetailsId?: InputMaybe<Scalars['String']['input']>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lockedById?: InputMaybe<Scalars['String']['input']>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrderId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucketId?: InputMaybe<Scalars['String']['input']>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shippingAddressId?: InputMaybe<Scalars['String']['input']>;
  shopifyDetailsId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserProductOrderStatus>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  tiktokDetailsId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  warehouseShelfReturnBinId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderCreateManyUserInputEnvelope = {
  data: Array<UserProductOrderCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderCreateManyWarehouseShelfReturnBinInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
  bulkDetailsId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetailsId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  fbaDetailsId?: InputMaybe<Scalars['String']['input']>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lockedById?: InputMaybe<Scalars['String']['input']>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrderId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucketId?: InputMaybe<Scalars['String']['input']>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shippingAddressId?: InputMaybe<Scalars['String']['input']>;
  shopifyDetailsId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserProductOrderStatus>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  tiktokDetailsId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type UserProductOrderCreateManyWarehouseShelfReturnBinInputEnvelope = {
  data: Array<UserProductOrderCreateManyWarehouseShelfReturnBinInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderCreateNestedManyWithoutLockedByInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutLockedByInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutLockedByInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyLockedByInputEnvelope>;
};

export type UserProductOrderCreateNestedManyWithoutOriginalOrderInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutOriginalOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutOriginalOrderInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyOriginalOrderInputEnvelope>;
};

export type UserProductOrderCreateNestedManyWithoutPostPaymentBucketInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutPostPaymentBucketInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutPostPaymentBucketInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyPostPaymentBucketInputEnvelope>;
};

export type UserProductOrderCreateNestedManyWithoutStoreInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutStoreInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutStoreInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyStoreInputEnvelope>;
};

export type UserProductOrderCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyUserInputEnvelope>;
};

export type UserProductOrderCreateNestedManyWithoutWarehouseShelfReturnBinInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutWarehouseShelfReturnBinInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutWarehouseShelfReturnBinInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyWarehouseShelfReturnBinInputEnvelope>;
};

export type UserProductOrderCreateNestedOneWithoutBillingAddressInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutBillingAddressInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutBillingAddressInput>;
};

export type UserProductOrderCreateNestedOneWithoutCreditsPaymentsInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutCreditsPaymentsInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutCreditsPaymentsInput>;
};

export type UserProductOrderCreateNestedOneWithoutCreditsRefundInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutCreditsRefundInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutCreditsRefundInput>;
};

export type UserProductOrderCreateNestedOneWithoutCustomOnHoldReasonsInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutCustomOnHoldReasonsInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutCustomOnHoldReasonsInput>;
};

export type UserProductOrderCreateNestedOneWithoutEverlabOrdersInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutEverlabOrdersInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutEverlabOrdersInput>;
};

export type UserProductOrderCreateNestedOneWithoutHoldReasonIntervalsInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutHoldReasonIntervalsInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutHoldReasonIntervalsInput>;
};

export type UserProductOrderCreateNestedOneWithoutHoldStatusIntervalsInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutHoldStatusIntervalsInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutHoldStatusIntervalsInput>;
};

export type UserProductOrderCreateNestedOneWithoutInvoicesInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutInvoicesInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutInvoicesInput>;
};

export type UserProductOrderCreateNestedOneWithoutJetpackApiOrdersInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutJetpackApiOrdersInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutJetpackApiOrdersInput>;
};

export type UserProductOrderCreateNestedOneWithoutLinesInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutLinesInput>;
};

export type UserProductOrderCreateNestedOneWithoutOnboardingSampleSessionInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutOnboardingSampleSessionInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutOnboardingSampleSessionInput>;
};

export type UserProductOrderCreateNestedOneWithoutReplacementOrdersInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutReplacementOrdersInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutReplacementOrdersInput>;
};

export type UserProductOrderCreateNestedOneWithoutRoastifyOrdersInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutRoastifyOrdersInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutRoastifyOrdersInput>;
};

export type UserProductOrderCreateNestedOneWithoutShipbobOrdersInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutShipbobOrdersInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutShipbobOrdersInput>;
};

export type UserProductOrderCreateNestedOneWithoutShipmentsInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutShipmentsInput>;
};

export type UserProductOrderCreateNestedOneWithoutShippingAddressInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutShippingAddressInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutShippingAddressInput>;
};

export type UserProductOrderCreateNestedOneWithoutStripeInvoicesInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutStripeInvoicesInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutStripeInvoicesInput>;
};

export type UserProductOrderCreateOrConnectWithoutBillingAddressInput = {
  create: UserProductOrderCreateWithoutBillingAddressInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutCreditsPaymentsInput = {
  create: UserProductOrderCreateWithoutCreditsPaymentsInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutCreditsRefundInput = {
  create: UserProductOrderCreateWithoutCreditsRefundInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutCustomOnHoldReasonsInput = {
  create: UserProductOrderCreateWithoutCustomOnHoldReasonsInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutEverlabOrdersInput = {
  create: UserProductOrderCreateWithoutEverlabOrdersInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutHoldReasonIntervalsInput = {
  create: UserProductOrderCreateWithoutHoldReasonIntervalsInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutHoldStatusIntervalsInput = {
  create: UserProductOrderCreateWithoutHoldStatusIntervalsInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutInvoicesInput = {
  create: UserProductOrderCreateWithoutInvoicesInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutJetpackApiOrdersInput = {
  create: UserProductOrderCreateWithoutJetpackApiOrdersInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutLinesInput = {
  create: UserProductOrderCreateWithoutLinesInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutLockedByInput = {
  create: UserProductOrderCreateWithoutLockedByInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutOnboardingSampleSessionInput = {
  create: UserProductOrderCreateWithoutOnboardingSampleSessionInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutOriginalOrderInput = {
  create: UserProductOrderCreateWithoutOriginalOrderInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutPostPaymentBucketInput = {
  create: UserProductOrderCreateWithoutPostPaymentBucketInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutReplacementOrdersInput = {
  create: UserProductOrderCreateWithoutReplacementOrdersInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutRoastifyOrdersInput = {
  create: UserProductOrderCreateWithoutRoastifyOrdersInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutShipbobOrdersInput = {
  create: UserProductOrderCreateWithoutShipbobOrdersInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutShipmentsInput = {
  create: UserProductOrderCreateWithoutShipmentsInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutShippingAddressInput = {
  create: UserProductOrderCreateWithoutShippingAddressInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutStoreInput = {
  create: UserProductOrderCreateWithoutStoreInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutStripeInvoicesInput = {
  create: UserProductOrderCreateWithoutStripeInvoicesInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutUserInput = {
  create: UserProductOrderCreateWithoutUserInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateOrConnectWithoutWarehouseShelfReturnBinInput = {
  create: UserProductOrderCreateWithoutWarehouseShelfReturnBinInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderCreateWithoutBillingAddressInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutCreditsPaymentsInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutCreditsRefundInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutCustomOnHoldReasonsInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutEverlabOrdersInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutHoldReasonIntervalsInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutHoldStatusIntervalsInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutInvoicesInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutJetpackApiOrdersInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutLinesInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutLockedByInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutOnboardingSampleSessionInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutOriginalOrderInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutPostPaymentBucketInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutReplacementOrdersInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutRoastifyOrdersInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutShipbobOrdersInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutShipmentsInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutShippingAddressInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutStoreInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutStripeInvoicesInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutUserInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput>;
};

export type UserProductOrderCreateWithoutWarehouseShelfReturnBinInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderBillingInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsCreateNestedOneWithoutOrderInput>;
  cancelledAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsCreateNestedOneWithoutOrderInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsPayments?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutPayForOrderInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionCreateNestedManyWithoutRefundOrderInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyConversionRate?: InputMaybe<Scalars['Float']['input']>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonCreateNestedManyWithoutOrderInput>;
  details?: InputMaybe<UserProductOrderDetailsCreateNestedOneWithoutOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderCreateNestedManyWithoutUserProductOrderInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput>;
  fulfillmentDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<InvoiceMode>;
  invoices?: InputMaybe<UserInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  isPriorityLaneFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput>;
  itemCountTotal?: InputMaybe<Scalars['Int']['input']>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderCreateNestedManyWithoutUserProductOrderInput>;
  kind?: InputMaybe<UserProductOrderKind>;
  legacyOrderId?: InputMaybe<Scalars['String']['input']>;
  lineItemsCount?: InputMaybe<Scalars['Int']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOrderInput>;
  lockedBy?: InputMaybe<AdminCreateNestedOneWithoutLockedOrdersInput>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  onHoldReasons?: InputMaybe<UserProductOrderCreateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionCreateNestedOneWithoutUserProductOrderInput>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  originalCurrency?: InputMaybe<Scalars['String']['input']>;
  originalOrder?: InputMaybe<UserProductOrderCreateNestedOneWithoutReplacementOrdersInput>;
  paymentStatus?: InputMaybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketCreateNestedOneWithoutOrdersInput>;
  replacementOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutOriginalOrderInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderCreateNestedManyWithoutUserProductOrderInput>;
  sampleDiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sampleExpressShippingApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  shipbobOrders?: InputMaybe<ShipbobOrderCreateNestedManyWithoutUserProductOrderInput>;
  shipheroOrderId?: InputMaybe<Scalars['String']['input']>;
  shipments?: InputMaybe<ShipmentCreateNestedManyWithoutUserProductOrderInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressCreateNestedOneWithoutOrderShippingInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<UserProductOrderStatus>;
  store?: InputMaybe<UserStoreCreateNestedOneWithoutUserProductOrdersInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceCreateNestedManyWithoutUserProductOrderInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput>;
};

export type UserProductOrderCreateonHoldReasonsInput = {
  set: Array<OnHoldReason>;
};

export type UserProductOrderDetails = {
  __typename?: 'UserProductOrderDetails';
  /** To be replaced by paymentStatus */
  charged: Scalars['Boolean']['output'];
  chargedAmount?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  express: Scalars['Boolean']['output'];
  fulfillmentFee?: Maybe<Scalars['Float']['output']>;
  fulfillmentOrderId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalChargedAmount?: Maybe<Scalars['Float']['output']>;
  originalFulfillmentFee?: Maybe<Scalars['Float']['output']>;
  originalShippingCost?: Maybe<Scalars['Float']['output']>;
  originalShippingPrice?: Maybe<Scalars['Float']['output']>;
  refundAmount: Scalars['Float']['output'];
  refundNote?: Maybe<Scalars['String']['output']>;
  refunded: Scalars['Boolean']['output'];
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  shippingCost?: Maybe<Scalars['Float']['output']>;
  shippingPrice: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  totalLineItemsPrice: Scalars['Float']['output'];
  totalLineItemsPriceSupliful: Scalars['Float']['output'];
};

export type UserProductOrderDetailsCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<UserProductOrderDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderDetailsCreateWithoutOrderInput>;
};

export type UserProductOrderDetailsCreateOrConnectWithoutOrderInput = {
  create: UserProductOrderDetailsCreateWithoutOrderInput;
  where: UserProductOrderDetailsWhereUniqueInput;
};

export type UserProductOrderDetailsCreateWithoutOrderInput = {
  charged?: InputMaybe<Scalars['Boolean']['input']>;
  chargedAmount?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  express: Scalars['Boolean']['input'];
  fulfillmentFee?: InputMaybe<Scalars['Float']['input']>;
  fulfillmentOrderId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  originalChargedAmount?: InputMaybe<Scalars['Float']['input']>;
  originalFulfillmentFee?: InputMaybe<Scalars['Float']['input']>;
  originalShippingCost?: InputMaybe<Scalars['Float']['input']>;
  originalShippingPrice?: InputMaybe<Scalars['Float']['input']>;
  refundAmount: Scalars['Float']['input'];
  refundNote?: InputMaybe<Scalars['String']['input']>;
  refunded?: InputMaybe<Scalars['Boolean']['input']>;
  refundedAt?: InputMaybe<Scalars['DateTime']['input']>;
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  shippingPrice: Scalars['Float']['input'];
  total: Scalars['Float']['input'];
  totalLineItemsPrice: Scalars['Float']['input'];
  totalLineItemsPriceSupliful: Scalars['Float']['input'];
};

export type UserProductOrderDetailsNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderDetailsWhereInput>;
  isNot?: InputMaybe<UserProductOrderDetailsWhereInput>;
};

export type UserProductOrderDetailsOrderByWithRelationInput = {
  charged?: InputMaybe<SortOrder>;
  chargedAmount?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrderInput>;
  express?: InputMaybe<SortOrder>;
  fulfillmentFee?: InputMaybe<SortOrderInput>;
  fulfillmentOrderId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  originalChargedAmount?: InputMaybe<SortOrderInput>;
  originalFulfillmentFee?: InputMaybe<SortOrderInput>;
  originalShippingCost?: InputMaybe<SortOrderInput>;
  originalShippingPrice?: InputMaybe<SortOrderInput>;
  refundAmount?: InputMaybe<SortOrder>;
  refundNote?: InputMaybe<SortOrderInput>;
  refunded?: InputMaybe<SortOrder>;
  refundedAt?: InputMaybe<SortOrderInput>;
  shippingCost?: InputMaybe<SortOrderInput>;
  shippingPrice?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalLineItemsPrice?: InputMaybe<SortOrder>;
  totalLineItemsPriceSupliful?: InputMaybe<SortOrder>;
};

export type UserProductOrderDetailsUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<UserProductOrderDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderDetailsCreateWithoutOrderInput>;
  delete?: InputMaybe<UserProductOrderDetailsWhereInput>;
  disconnect?: InputMaybe<UserProductOrderDetailsWhereInput>;
  update?: InputMaybe<UserProductOrderDetailsUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<UserProductOrderDetailsUpsertWithoutOrderInput>;
};

export type UserProductOrderDetailsUpdateToOneWithWhereWithoutOrderInput = {
  data: UserProductOrderDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderDetailsWhereInput>;
};

export type UserProductOrderDetailsUpdateWithoutOrderInput = {
  charged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chargedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  express?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fulfillmentFee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fulfillmentOrderId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalChargedAmount?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  originalFulfillmentFee?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  originalShippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  originalShippingPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  refundAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  refundNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refunded?: InputMaybe<BoolFieldUpdateOperationsInput>;
  refundedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippingCost?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalLineItemsPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  totalLineItemsPriceSupliful?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type UserProductOrderDetailsUpsertWithoutOrderInput = {
  create: UserProductOrderDetailsCreateWithoutOrderInput;
  update: UserProductOrderDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderDetailsWhereInput>;
};

export type UserProductOrderDetailsWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderDetailsWhereInput>>;
  charged?: InputMaybe<BoolFilter>;
  chargedAmount?: InputMaybe<FloatNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  express?: InputMaybe<BoolFilter>;
  fulfillmentFee?: InputMaybe<FloatNullableFilter>;
  fulfillmentOrderId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  originalChargedAmount?: InputMaybe<FloatNullableFilter>;
  originalFulfillmentFee?: InputMaybe<FloatNullableFilter>;
  originalShippingCost?: InputMaybe<FloatNullableFilter>;
  originalShippingPrice?: InputMaybe<FloatNullableFilter>;
  refundAmount?: InputMaybe<FloatFilter>;
  refundNote?: InputMaybe<StringNullableFilter>;
  refunded?: InputMaybe<BoolFilter>;
  refundedAt?: InputMaybe<DateTimeNullableFilter>;
  shippingCost?: InputMaybe<FloatNullableFilter>;
  shippingPrice?: InputMaybe<FloatFilter>;
  total?: InputMaybe<FloatFilter>;
  totalLineItemsPrice?: InputMaybe<FloatFilter>;
  totalLineItemsPriceSupliful?: InputMaybe<FloatFilter>;
};

export type UserProductOrderDetailsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderDetailsWhereInput>>;
  charged?: InputMaybe<BoolFilter>;
  chargedAmount?: InputMaybe<FloatNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  express?: InputMaybe<BoolFilter>;
  fulfillmentFee?: InputMaybe<FloatNullableFilter>;
  fulfillmentOrderId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  originalChargedAmount?: InputMaybe<FloatNullableFilter>;
  originalFulfillmentFee?: InputMaybe<FloatNullableFilter>;
  originalShippingCost?: InputMaybe<FloatNullableFilter>;
  originalShippingPrice?: InputMaybe<FloatNullableFilter>;
  refundAmount?: InputMaybe<FloatFilter>;
  refundNote?: InputMaybe<StringNullableFilter>;
  refunded?: InputMaybe<BoolFilter>;
  refundedAt?: InputMaybe<DateTimeNullableFilter>;
  shippingCost?: InputMaybe<FloatNullableFilter>;
  shippingPrice?: InputMaybe<FloatFilter>;
  total?: InputMaybe<FloatFilter>;
  totalLineItemsPrice?: InputMaybe<FloatFilter>;
  totalLineItemsPriceSupliful?: InputMaybe<FloatFilter>;
};

export type UserProductOrderFbaDetails = {
  __typename?: 'UserProductOrderFbaDetails';
  id: Scalars['String']['output'];
  paymentKind: UserProductOrderManualPaymentKind;
  paymentStatus: UserProductOrderManualPaymentStatus;
  postPaymentDueDateDays?: Maybe<Scalars['Int']['output']>;
  postPaymentDueDateDaysType?: Maybe<UserPostPaymentDueDateDaysType>;
  shippingLabelUrl?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type UserProductOrderFbaDetailsCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<UserProductOrderFbaDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderFbaDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderFbaDetailsCreateWithoutOrderInput>;
};

export type UserProductOrderFbaDetailsCreateOrConnectWithoutOrderInput = {
  create: UserProductOrderFbaDetailsCreateWithoutOrderInput;
  where: UserProductOrderFbaDetailsWhereUniqueInput;
};

export type UserProductOrderFbaDetailsCreateWithoutOrderInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  paymentKind: UserProductOrderManualPaymentKind;
  paymentStatus?: InputMaybe<UserProductOrderManualPaymentStatus>;
  postPaymentDueDateDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentDueDateDaysType?: InputMaybe<UserPostPaymentDueDateDaysType>;
  shippingLabelUrl?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderFbaDetailsNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderFbaDetailsWhereInput>;
  isNot?: InputMaybe<UserProductOrderFbaDetailsWhereInput>;
};

export type UserProductOrderFbaDetailsOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  paymentKind?: InputMaybe<SortOrder>;
  paymentStatus?: InputMaybe<SortOrder>;
  postPaymentDueDateDays?: InputMaybe<SortOrderInput>;
  postPaymentDueDateDaysType?: InputMaybe<SortOrderInput>;
  shippingLabelUrl?: InputMaybe<SortOrderInput>;
  trackingNumber?: InputMaybe<SortOrderInput>;
};

export type UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<UserProductOrderFbaDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderFbaDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderFbaDetailsCreateWithoutOrderInput>;
  delete?: InputMaybe<UserProductOrderFbaDetailsWhereInput>;
  disconnect?: InputMaybe<UserProductOrderFbaDetailsWhereInput>;
  update?: InputMaybe<UserProductOrderFbaDetailsUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<UserProductOrderFbaDetailsUpsertWithoutOrderInput>;
};

export type UserProductOrderFbaDetailsUpdateToOneWithWhereWithoutOrderInput = {
  data: UserProductOrderFbaDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderFbaDetailsWhereInput>;
};

export type UserProductOrderFbaDetailsUpdateWithoutOrderInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  paymentStatus?: InputMaybe<EnumUserProductOrderManualPaymentStatusFieldUpdateOperationsInput>;
  postPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  shippingLabelUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductOrderFbaDetailsUpsertWithoutOrderInput = {
  create: UserProductOrderFbaDetailsCreateWithoutOrderInput;
  update: UserProductOrderFbaDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderFbaDetailsWhereInput>;
};

export type UserProductOrderFbaDetailsWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderFbaDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderFbaDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderFbaDetailsWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  paymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFilter>;
  paymentStatus?: InputMaybe<EnumUserProductOrderManualPaymentStatusFilter>;
  postPaymentDueDateDays?: InputMaybe<IntNullableFilter>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeNullableFilter>;
  shippingLabelUrl?: InputMaybe<StringNullableFilter>;
  trackingNumber?: InputMaybe<StringNullableFilter>;
};

export type UserProductOrderFbaDetailsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderFbaDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderFbaDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderFbaDetailsWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  paymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFilter>;
  paymentStatus?: InputMaybe<EnumUserProductOrderManualPaymentStatusFilter>;
  postPaymentDueDateDays?: InputMaybe<IntNullableFilter>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeNullableFilter>;
  shippingLabelUrl?: InputMaybe<StringNullableFilter>;
  trackingNumber?: InputMaybe<StringNullableFilter>;
};

export type UserProductOrderHoldStatusInterval = {
  __typename?: 'UserProductOrderHoldStatusInterval';
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedById?: Maybe<Scalars['String']['output']>;
};

export type UserProductOrderHoldStatusIntervalCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedById?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderHoldStatusIntervalCreateManyCreatedByInputEnvelope = {
  data: Array<UserProductOrderHoldStatusIntervalCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderHoldStatusIntervalCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedById?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderHoldStatusIntervalCreateManyOrderInputEnvelope = {
  data: Array<UserProductOrderHoldStatusIntervalCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderHoldStatusIntervalCreateManyResolvedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProductOrderHoldStatusIntervalCreateManyResolvedByInputEnvelope = {
  data: Array<UserProductOrderHoldStatusIntervalCreateManyResolvedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderHoldStatusIntervalCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<UserProductOrderHoldStatusIntervalCreateManyCreatedByInputEnvelope>;
};

export type UserProductOrderHoldStatusIntervalCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateWithoutOrderInput>>;
  createMany?: InputMaybe<UserProductOrderHoldStatusIntervalCreateManyOrderInputEnvelope>;
};

export type UserProductOrderHoldStatusIntervalCreateNestedManyWithoutResolvedByInput = {
  connect?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateOrConnectWithoutResolvedByInput>>;
  create?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateWithoutResolvedByInput>>;
  createMany?: InputMaybe<UserProductOrderHoldStatusIntervalCreateManyResolvedByInputEnvelope>;
};

export type UserProductOrderHoldStatusIntervalCreateOrConnectWithoutCreatedByInput = {
  create: UserProductOrderHoldStatusIntervalCreateWithoutCreatedByInput;
  where: UserProductOrderHoldStatusIntervalWhereUniqueInput;
};

export type UserProductOrderHoldStatusIntervalCreateOrConnectWithoutOrderInput = {
  create: UserProductOrderHoldStatusIntervalCreateWithoutOrderInput;
  where: UserProductOrderHoldStatusIntervalWhereUniqueInput;
};

export type UserProductOrderHoldStatusIntervalCreateOrConnectWithoutResolvedByInput = {
  create: UserProductOrderHoldStatusIntervalCreateWithoutResolvedByInput;
  where: UserProductOrderHoldStatusIntervalWhereUniqueInput;
};

export type UserProductOrderHoldStatusIntervalCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: UserProductOrderCreateNestedOneWithoutHoldStatusIntervalsInput;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<AdminCreateNestedOneWithoutOnHoldIntervalResolvedInput>;
};

export type UserProductOrderHoldStatusIntervalCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<AdminCreateNestedOneWithoutOnHoldIntervalCreatedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<AdminCreateNestedOneWithoutOnHoldIntervalResolvedInput>;
};

export type UserProductOrderHoldStatusIntervalCreateWithoutResolvedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<AdminCreateNestedOneWithoutOnHoldIntervalCreatedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: UserProductOrderCreateNestedOneWithoutHoldStatusIntervalsInput;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProductOrderHoldStatusIntervalListRelationFilter = {
  every?: InputMaybe<UserProductOrderHoldStatusIntervalWhereInput>;
  none?: InputMaybe<UserProductOrderHoldStatusIntervalWhereInput>;
  some?: InputMaybe<UserProductOrderHoldStatusIntervalWhereInput>;
};

export type UserProductOrderHoldStatusIntervalOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserProductOrderHoldStatusIntervalOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<AdminOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  resolvedAt?: InputMaybe<SortOrderInput>;
  resolvedBy?: InputMaybe<AdminOrderByWithRelationInput>;
  resolvedById?: InputMaybe<SortOrderInput>;
};

export enum UserProductOrderHoldStatusIntervalScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  Id = 'id',
  OrderId = 'orderId',
  ResolvedAt = 'resolvedAt',
  ResolvedById = 'resolvedById'
}

export type UserProductOrderHoldStatusIntervalScalarWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderHoldStatusIntervalScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderHoldStatusIntervalScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderHoldStatusIntervalScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  orderId?: InputMaybe<UuidFilter>;
  resolvedAt?: InputMaybe<DateTimeNullableFilter>;
  resolvedById?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderHoldStatusIntervalUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserProductOrderHoldStatusIntervalUpdateManyWithWhereWithoutCreatedByInput = {
  data: UserProductOrderHoldStatusIntervalUpdateManyMutationInput;
  where: UserProductOrderHoldStatusIntervalScalarWhereInput;
};

export type UserProductOrderHoldStatusIntervalUpdateManyWithWhereWithoutOrderInput = {
  data: UserProductOrderHoldStatusIntervalUpdateManyMutationInput;
  where: UserProductOrderHoldStatusIntervalScalarWhereInput;
};

export type UserProductOrderHoldStatusIntervalUpdateManyWithWhereWithoutResolvedByInput = {
  data: UserProductOrderHoldStatusIntervalUpdateManyMutationInput;
  where: UserProductOrderHoldStatusIntervalScalarWhereInput;
};

export type UserProductOrderHoldStatusIntervalUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<UserProductOrderHoldStatusIntervalCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderHoldStatusIntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderHoldStatusIntervalUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderHoldStatusIntervalUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<UserProductOrderHoldStatusIntervalUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateWithoutOrderInput>>;
  createMany?: InputMaybe<UserProductOrderHoldStatusIntervalCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderHoldStatusIntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderHoldStatusIntervalUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderHoldStatusIntervalUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<UserProductOrderHoldStatusIntervalUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type UserProductOrderHoldStatusIntervalUpdateManyWithoutResolvedByNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateOrConnectWithoutResolvedByInput>>;
  create?: InputMaybe<Array<UserProductOrderHoldStatusIntervalCreateWithoutResolvedByInput>>;
  createMany?: InputMaybe<UserProductOrderHoldStatusIntervalCreateManyResolvedByInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderHoldStatusIntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderHoldStatusIntervalUpdateWithWhereUniqueWithoutResolvedByInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderHoldStatusIntervalUpdateManyWithWhereWithoutResolvedByInput>>;
  upsert?: InputMaybe<Array<UserProductOrderHoldStatusIntervalUpsertWithWhereUniqueWithoutResolvedByInput>>;
};

export type UserProductOrderHoldStatusIntervalUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: UserProductOrderHoldStatusIntervalUpdateWithoutCreatedByInput;
  where: UserProductOrderHoldStatusIntervalWhereUniqueInput;
};

export type UserProductOrderHoldStatusIntervalUpdateWithWhereUniqueWithoutOrderInput = {
  data: UserProductOrderHoldStatusIntervalUpdateWithoutOrderInput;
  where: UserProductOrderHoldStatusIntervalWhereUniqueInput;
};

export type UserProductOrderHoldStatusIntervalUpdateWithWhereUniqueWithoutResolvedByInput = {
  data: UserProductOrderHoldStatusIntervalUpdateWithoutResolvedByInput;
  where: UserProductOrderHoldStatusIntervalWhereUniqueInput;
};

export type UserProductOrderHoldStatusIntervalUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutHoldStatusIntervalsNestedInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  resolvedBy?: InputMaybe<AdminUpdateOneWithoutOnHoldIntervalResolvedNestedInput>;
};

export type UserProductOrderHoldStatusIntervalUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneWithoutOnHoldIntervalCreatedNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  resolvedBy?: InputMaybe<AdminUpdateOneWithoutOnHoldIntervalResolvedNestedInput>;
};

export type UserProductOrderHoldStatusIntervalUpdateWithoutResolvedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneWithoutOnHoldIntervalCreatedNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutHoldStatusIntervalsNestedInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserProductOrderHoldStatusIntervalUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: UserProductOrderHoldStatusIntervalCreateWithoutCreatedByInput;
  update: UserProductOrderHoldStatusIntervalUpdateWithoutCreatedByInput;
  where: UserProductOrderHoldStatusIntervalWhereUniqueInput;
};

export type UserProductOrderHoldStatusIntervalUpsertWithWhereUniqueWithoutOrderInput = {
  create: UserProductOrderHoldStatusIntervalCreateWithoutOrderInput;
  update: UserProductOrderHoldStatusIntervalUpdateWithoutOrderInput;
  where: UserProductOrderHoldStatusIntervalWhereUniqueInput;
};

export type UserProductOrderHoldStatusIntervalUpsertWithWhereUniqueWithoutResolvedByInput = {
  create: UserProductOrderHoldStatusIntervalCreateWithoutResolvedByInput;
  update: UserProductOrderHoldStatusIntervalUpdateWithoutResolvedByInput;
  where: UserProductOrderHoldStatusIntervalWhereUniqueInput;
};

export type UserProductOrderHoldStatusIntervalWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminNullableRelationFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<UserProductOrderRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  resolvedAt?: InputMaybe<DateTimeNullableFilter>;
  resolvedBy?: InputMaybe<AdminNullableRelationFilter>;
  resolvedById?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderHoldStatusIntervalWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderHoldStatusIntervalWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminNullableRelationFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<UserProductOrderRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  resolvedAt?: InputMaybe<DateTimeNullableFilter>;
  resolvedBy?: InputMaybe<AdminNullableRelationFilter>;
  resolvedById?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderItemCountByWarehouse = {
  __typename?: 'UserProductOrderItemCountByWarehouse';
  count: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  warehouseId: Scalars['String']['output'];
};

export type UserProductOrderItemCountByWarehouseCreateManyOrderInput = {
  count: Scalars['Int']['input'];
  warehouseId: Scalars['String']['input'];
};

export type UserProductOrderItemCountByWarehouseCreateManyOrderInputEnvelope = {
  data: Array<UserProductOrderItemCountByWarehouseCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderItemCountByWarehouseCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderItemCountByWarehouseCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderItemCountByWarehouseCreateWithoutOrderInput>>;
  createMany?: InputMaybe<UserProductOrderItemCountByWarehouseCreateManyOrderInputEnvelope>;
};

export type UserProductOrderItemCountByWarehouseCreateOrConnectWithoutOrderInput = {
  create: UserProductOrderItemCountByWarehouseCreateWithoutOrderInput;
  where: UserProductOrderItemCountByWarehouseWhereUniqueInput;
};

export type UserProductOrderItemCountByWarehouseCreateWithoutOrderInput = {
  count: Scalars['Int']['input'];
  warehouseId: Scalars['String']['input'];
};

export type UserProductOrderItemCountByWarehouseListRelationFilter = {
  every?: InputMaybe<UserProductOrderItemCountByWarehouseWhereInput>;
  none?: InputMaybe<UserProductOrderItemCountByWarehouseWhereInput>;
  some?: InputMaybe<UserProductOrderItemCountByWarehouseWhereInput>;
};

export type UserProductOrderItemCountByWarehouseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserProductOrderItemCountByWarehouseOrderByWithRelationInput = {
  count?: InputMaybe<SortOrder>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  warehouseId?: InputMaybe<SortOrder>;
};

export type UserProductOrderItemCountByWarehouseOrderIdWarehouseIdCompoundUniqueInput = {
  orderId: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
};

export enum UserProductOrderItemCountByWarehouseScalarFieldEnum {
  Count = 'count',
  OrderId = 'orderId',
  WarehouseId = 'warehouseId'
}

export type UserProductOrderItemCountByWarehouseScalarWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderItemCountByWarehouseScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderItemCountByWarehouseScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderItemCountByWarehouseScalarWhereInput>>;
  count?: InputMaybe<IntFilter>;
  orderId?: InputMaybe<UuidFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type UserProductOrderItemCountByWarehouseUpdateManyMutationInput = {
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  warehouseId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProductOrderItemCountByWarehouseUpdateManyWithWhereWithoutOrderInput = {
  data: UserProductOrderItemCountByWarehouseUpdateManyMutationInput;
  where: UserProductOrderItemCountByWarehouseScalarWhereInput;
};

export type UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderItemCountByWarehouseCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderItemCountByWarehouseCreateWithoutOrderInput>>;
  createMany?: InputMaybe<UserProductOrderItemCountByWarehouseCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderItemCountByWarehouseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderItemCountByWarehouseUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderItemCountByWarehouseUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<UserProductOrderItemCountByWarehouseUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type UserProductOrderItemCountByWarehouseUpdateWithWhereUniqueWithoutOrderInput = {
  data: UserProductOrderItemCountByWarehouseUpdateWithoutOrderInput;
  where: UserProductOrderItemCountByWarehouseWhereUniqueInput;
};

export type UserProductOrderItemCountByWarehouseUpdateWithoutOrderInput = {
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  warehouseId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProductOrderItemCountByWarehouseUpsertWithWhereUniqueWithoutOrderInput = {
  create: UserProductOrderItemCountByWarehouseCreateWithoutOrderInput;
  update: UserProductOrderItemCountByWarehouseUpdateWithoutOrderInput;
  where: UserProductOrderItemCountByWarehouseWhereUniqueInput;
};

export type UserProductOrderItemCountByWarehouseWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereInput>>;
  count?: InputMaybe<IntFilter>;
  order?: InputMaybe<UserProductOrderRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type UserProductOrderItemCountByWarehouseWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderItemCountByWarehouseWhereInput>>;
  count?: InputMaybe<IntFilter>;
  order?: InputMaybe<UserProductOrderRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  orderId_warehouseId?: InputMaybe<UserProductOrderItemCountByWarehouseOrderIdWarehouseIdCompoundUniqueInput>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export enum UserProductOrderKind {
  Amazon = 'AMAZON',
  Bulk = 'BULK',
  Clickfunnels = 'CLICKFUNNELS',
  Fba = 'FBA',
  Manual = 'MANUAL',
  Sample = 'SAMPLE',
  Shopify = 'SHOPIFY',
  Storefront = 'STOREFRONT',
  Tiktok = 'TIKTOK',
  Wix = 'WIX',
  Woocommerce = 'WOOCOMMERCE'
}

export type UserProductOrderLine = {
  __typename?: 'UserProductOrderLine';
  _count?: Maybe<UserProductOrderLineCount>;
  clickfunnelsLineDetails?: Maybe<UserProductOrderLineClickFunnelsDetails>;
  clickfunnelsLineDetailsId?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  details?: Maybe<UserProductOrderLineDetails>;
  detailsId?: Maybe<Scalars['String']['output']>;
  everlabOrder?: Maybe<EverlabOrder>;
  everlabOrderId?: Maybe<Scalars['String']['output']>;
  fulfillmentFees: Array<UserProductOrderLineFulfillmentFee>;
  id: Scalars['String']['output'];
  isReplacement: Scalars['Boolean']['output'];
  jetpackApiOrder?: Maybe<JetpackApiOrder>;
  jetpackApiOrderId?: Maybe<Scalars['String']['output']>;
  label?: Maybe<UserProductLabel>;
  labelId?: Maybe<Scalars['String']['output']>;
  order: UserProductOrder;
  orderId: Scalars['String']['output'];
  originalLine?: Maybe<UserProductOrderLine>;
  originalLineId?: Maybe<Scalars['String']['output']>;
  originalPriceSold: Scalars['Float']['output'];
  prePaidPriceApplied: Scalars['Boolean']['output'];
  preparationHistory: Array<UserProductOrderLinePreparationHistory>;
  preparedBy?: Maybe<Admin>;
  preparedById?: Maybe<Scalars['String']['output']>;
  priceSold: Scalars['Float']['output'];
  printBatches: Array<PrintBatchOrderLine>;
  refundedBy?: Maybe<Admin>;
  refundedById?: Maybe<Scalars['String']['output']>;
  replacementLines: Array<UserProductOrderLine>;
  reshipment?: Maybe<Shipment>;
  reshipmentId?: Maybe<Scalars['String']['output']>;
  roastifyOrder?: Maybe<RoastifyOrder>;
  roastifyOrderId?: Maybe<Scalars['String']['output']>;
  shipbobOrder?: Maybe<ShipbobOrder>;
  shipbobOrderId?: Maybe<Scalars['String']['output']>;
  shipheroInternalLineItemId?: Maybe<Scalars['String']['output']>;
  shipheroLineItemId?: Maybe<Scalars['String']['output']>;
  shipment?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  subLine?: Maybe<UserProductOrderSubLineItem>;
  subLineId?: Maybe<Scalars['String']['output']>;
  tiktokLineDetails?: Maybe<UserProductOrderLineTiktokDetails>;
  tiktokLineDetailsId?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['String']['output'];
  userProduct: UserProduct;
  userProductId: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId?: Maybe<Scalars['String']['output']>;
};


export type UserProductOrderLineClickfunnelsLineDetailsArgs = {
  where?: InputMaybe<UserProductOrderLineClickFunnelsDetailsWhereInput>;
};


export type UserProductOrderLineDetailsArgs = {
  where?: InputMaybe<UserProductOrderLineDetailsWhereInput>;
};


export type UserProductOrderLineEverlabOrderArgs = {
  where?: InputMaybe<EverlabOrderWhereInput>;
};


export type UserProductOrderLineFulfillmentFeesArgs = {
  cursor?: InputMaybe<UserProductOrderLineFulfillmentFeeWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLineFulfillmentFeeWhereInput>;
};


export type UserProductOrderLineJetpackApiOrderArgs = {
  where?: InputMaybe<JetpackApiOrderWhereInput>;
};


export type UserProductOrderLineLabelArgs = {
  where?: InputMaybe<UserProductLabelWhereInput>;
};


export type UserProductOrderLineOriginalLineArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type UserProductOrderLinePreparationHistoryArgs = {
  cursor?: InputMaybe<UserProductOrderLinePreparationHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLinePreparationHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLinePreparationHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLinePreparationHistoryWhereInput>;
};


export type UserProductOrderLinePreparedByArgs = {
  where?: InputMaybe<AdminWhereInput>;
};


export type UserProductOrderLinePrintBatchesArgs = {
  cursor?: InputMaybe<PrintBatchOrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<PrintBatchOrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PrintBatchOrderLineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PrintBatchOrderLineWhereInput>;
};


export type UserProductOrderLineRefundedByArgs = {
  where?: InputMaybe<AdminWhereInput>;
};


export type UserProductOrderLineReplacementLinesArgs = {
  cursor?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type UserProductOrderLineReshipmentArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};


export type UserProductOrderLineRoastifyOrderArgs = {
  where?: InputMaybe<RoastifyOrderWhereInput>;
};


export type UserProductOrderLineShipbobOrderArgs = {
  where?: InputMaybe<ShipbobOrderWhereInput>;
};


export type UserProductOrderLineShipmentArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};


export type UserProductOrderLineSubLineArgs = {
  where?: InputMaybe<UserProductOrderSubLineItemWhereInput>;
};


export type UserProductOrderLineTiktokLineDetailsArgs = {
  where?: InputMaybe<UserProductOrderLineTiktokDetailsWhereInput>;
};


export type UserProductOrderLineWarehouseArgs = {
  where?: InputMaybe<WarehouseWhereInput>;
};

export type UserProductOrderLineClickFunnelsDetails = {
  __typename?: 'UserProductOrderLineClickFunnelsDetails';
  clickfunnelsLineId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput = {
  connect?: InputMaybe<UserProductOrderLineClickFunnelsDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateOrConnectWithoutUserProductOrderLineInput>;
  create?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateWithoutUserProductOrderLineInput>;
};

export type UserProductOrderLineClickFunnelsDetailsCreateOrConnectWithoutUserProductOrderLineInput = {
  create: UserProductOrderLineClickFunnelsDetailsCreateWithoutUserProductOrderLineInput;
  where: UserProductOrderLineClickFunnelsDetailsWhereUniqueInput;
};

export type UserProductOrderLineClickFunnelsDetailsCreateWithoutUserProductOrderLineInput = {
  clickfunnelsLineId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineClickFunnelsDetailsNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderLineClickFunnelsDetailsWhereInput>;
  isNot?: InputMaybe<UserProductOrderLineClickFunnelsDetailsWhereInput>;
};

export type UserProductOrderLineClickFunnelsDetailsOrderByWithRelationInput = {
  clickfunnelsLineId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userProductOrderLine?: InputMaybe<UserProductOrderLineOrderByWithRelationInput>;
};

export type UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput = {
  connect?: InputMaybe<UserProductOrderLineClickFunnelsDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateOrConnectWithoutUserProductOrderLineInput>;
  create?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateWithoutUserProductOrderLineInput>;
  delete?: InputMaybe<UserProductOrderLineClickFunnelsDetailsWhereInput>;
  disconnect?: InputMaybe<UserProductOrderLineClickFunnelsDetailsWhereInput>;
  update?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateToOneWithWhereWithoutUserProductOrderLineInput>;
  upsert?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpsertWithoutUserProductOrderLineInput>;
};

export type UserProductOrderLineClickFunnelsDetailsUpdateToOneWithWhereWithoutUserProductOrderLineInput = {
  data: UserProductOrderLineClickFunnelsDetailsUpdateWithoutUserProductOrderLineInput;
  where?: InputMaybe<UserProductOrderLineClickFunnelsDetailsWhereInput>;
};

export type UserProductOrderLineClickFunnelsDetailsUpdateWithoutUserProductOrderLineInput = {
  clickfunnelsLineId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProductOrderLineClickFunnelsDetailsUpsertWithoutUserProductOrderLineInput = {
  create: UserProductOrderLineClickFunnelsDetailsCreateWithoutUserProductOrderLineInput;
  update: UserProductOrderLineClickFunnelsDetailsUpdateWithoutUserProductOrderLineInput;
  where?: InputMaybe<UserProductOrderLineClickFunnelsDetailsWhereInput>;
};

export type UserProductOrderLineClickFunnelsDetailsWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderLineClickFunnelsDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineClickFunnelsDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineClickFunnelsDetailsWhereInput>>;
  clickfunnelsLineId?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  userProductOrderLine?: InputMaybe<UserProductOrderLineNullableRelationFilter>;
};

export type UserProductOrderLineClickFunnelsDetailsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderLineClickFunnelsDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineClickFunnelsDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineClickFunnelsDetailsWhereInput>>;
  clickfunnelsLineId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  userProductOrderLine?: InputMaybe<UserProductOrderLineNullableRelationFilter>;
};

export type UserProductOrderLineCount = {
  __typename?: 'UserProductOrderLineCount';
  fulfillmentFees: Scalars['Int']['output'];
  preparationHistory: Scalars['Int']['output'];
  printBatches: Scalars['Int']['output'];
  replacementLines: Scalars['Int']['output'];
};


export type UserProductOrderLineCountFulfillmentFeesArgs = {
  where?: InputMaybe<UserProductOrderLineFulfillmentFeeWhereInput>;
};


export type UserProductOrderLineCountPreparationHistoryArgs = {
  where?: InputMaybe<UserProductOrderLinePreparationHistoryWhereInput>;
};


export type UserProductOrderLineCountPrintBatchesArgs = {
  where?: InputMaybe<PrintBatchOrderLineWhereInput>;
};


export type UserProductOrderLineCountReplacementLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductOrderLineCreateManyEverlabOrderInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyEverlabOrderInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyEverlabOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyJetpackApiOrderInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyJetpackApiOrderInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyJetpackApiOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyOrderInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyOrderInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyOriginalLineInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyOriginalLineInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyOriginalLineInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyPreparedByInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyPreparedByInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyPreparedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyRefundedByInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyRefundedByInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyRefundedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyReshipmentInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyReshipmentInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyReshipmentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyRoastifyOrderInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyRoastifyOrderInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyRoastifyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyShipbobOrderInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyShipbobOrderInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyShipbobOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyShipmentInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyShipmentInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyShipmentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyUserInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userProductId: Scalars['String']['input'];
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineCreateManyUserInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateManyWarehouseInput = {
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrderId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrderId?: InputMaybe<Scalars['String']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  originalLineId?: InputMaybe<Scalars['String']['input']>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedById?: InputMaybe<Scalars['String']['input']>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedById?: InputMaybe<Scalars['String']['input']>;
  reshipmentId?: InputMaybe<Scalars['String']['input']>;
  roastifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shipbobOrderId?: InputMaybe<Scalars['String']['input']>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userProductId: Scalars['String']['input'];
};

export type UserProductOrderLineCreateManyWarehouseInputEnvelope = {
  data: Array<UserProductOrderLineCreateManyWarehouseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineCreateNestedManyWithoutEverlabOrderInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutEverlabOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutEverlabOrderInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyEverlabOrderInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutJetpackApiOrderInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutJetpackApiOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutJetpackApiOrderInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyJetpackApiOrderInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutOrderInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyOrderInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutOriginalLineInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutOriginalLineInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutOriginalLineInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyOriginalLineInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutPreparedByInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutPreparedByInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutPreparedByInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyPreparedByInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutRefundedByInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutRefundedByInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutRefundedByInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyRefundedByInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutReshipmentInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutReshipmentInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutReshipmentInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyReshipmentInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutRoastifyOrderInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutRoastifyOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutRoastifyOrderInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyRoastifyOrderInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutShipbobOrderInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutShipbobOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutShipbobOrderInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyShipbobOrderInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutShipmentInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutShipmentInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutShipmentInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyShipmentInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyUserInputEnvelope>;
};

export type UserProductOrderLineCreateNestedManyWithoutWarehouseInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyWarehouseInputEnvelope>;
};

export type UserProductOrderLineCreateNestedOneWithoutPreparationHistoryInput = {
  connect?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineCreateOrConnectWithoutPreparationHistoryInput>;
  create?: InputMaybe<UserProductOrderLineCreateWithoutPreparationHistoryInput>;
};

export type UserProductOrderLineCreateNestedOneWithoutPrintBatchesInput = {
  connect?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineCreateOrConnectWithoutPrintBatchesInput>;
  create?: InputMaybe<UserProductOrderLineCreateWithoutPrintBatchesInput>;
};

export type UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput = {
  connect?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineCreateOrConnectWithoutReplacementLinesInput>;
  create?: InputMaybe<UserProductOrderLineCreateWithoutReplacementLinesInput>;
};

export type UserProductOrderLineCreateOrConnectWithoutEverlabOrderInput = {
  create: UserProductOrderLineCreateWithoutEverlabOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutJetpackApiOrderInput = {
  create: UserProductOrderLineCreateWithoutJetpackApiOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutOrderInput = {
  create: UserProductOrderLineCreateWithoutOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutOriginalLineInput = {
  create: UserProductOrderLineCreateWithoutOriginalLineInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutPreparationHistoryInput = {
  create: UserProductOrderLineCreateWithoutPreparationHistoryInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutPreparedByInput = {
  create: UserProductOrderLineCreateWithoutPreparedByInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutPrintBatchesInput = {
  create: UserProductOrderLineCreateWithoutPrintBatchesInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutRefundedByInput = {
  create: UserProductOrderLineCreateWithoutRefundedByInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutReplacementLinesInput = {
  create: UserProductOrderLineCreateWithoutReplacementLinesInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutReshipmentInput = {
  create: UserProductOrderLineCreateWithoutReshipmentInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutRoastifyOrderInput = {
  create: UserProductOrderLineCreateWithoutRoastifyOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutShipbobOrderInput = {
  create: UserProductOrderLineCreateWithoutShipbobOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutShipmentInput = {
  create: UserProductOrderLineCreateWithoutShipmentInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutUserInput = {
  create: UserProductOrderLineCreateWithoutUserInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateOrConnectWithoutWarehouseInput = {
  create: UserProductOrderLineCreateWithoutWarehouseInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineCreateWithoutEverlabOrderInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutJetpackApiOrderInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutOrderInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutOriginalLineInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutPreparationHistoryInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutPreparedByInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutPrintBatchesInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutRefundedByInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutReplacementLinesInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutReshipmentInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutRoastifyOrderInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutShipbobOrderInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutShipmentInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutUserInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
  warehouse?: InputMaybe<WarehouseCreateNestedOneWithoutLinesInput>;
};

export type UserProductOrderLineCreateWithoutWarehouseInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  count?: InputMaybe<Scalars['Int']['input']>;
  details?: InputMaybe<UserProductOrderLineDetailsCreateNestedOneWithoutLineInput>;
  everlabOrder?: InputMaybe<EverlabOrderCreateNestedOneWithoutOrderLinesInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderCreateNestedOneWithoutOrderLinesInput>;
  label?: InputMaybe<UserProductLabelCreateNestedOneWithoutOrderLinesInput>;
  order: UserProductOrderCreateNestedOneWithoutLinesInput;
  originalLine?: InputMaybe<UserProductOrderLineCreateNestedOneWithoutReplacementLinesInput>;
  originalPriceSold?: InputMaybe<Scalars['Float']['input']>;
  prePaidPriceApplied?: InputMaybe<Scalars['Boolean']['input']>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput>;
  preparedBy?: InputMaybe<AdminCreateNestedOneWithoutPreparedLineItemsInput>;
  priceSold?: InputMaybe<Scalars['Float']['input']>;
  printBatches?: InputMaybe<PrintBatchOrderLineCreateNestedManyWithoutLineInput>;
  refundedBy?: InputMaybe<AdminCreateNestedOneWithoutRefundedLineItemsInput>;
  replacementLines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutOriginalLineInput>;
  reshipment?: InputMaybe<ShipmentCreateNestedOneWithoutReshippedOrderLinesInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderCreateNestedOneWithoutOrderLinesInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderCreateNestedOneWithoutOrderLinesInput>;
  shipheroInternalLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutUserProductOrderLinesInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemCreateNestedOneWithoutLineInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput>;
  user: UserCreateNestedOneWithoutOrderLinesInput;
  userProduct: UserProductCreateNestedOneWithoutOrderLinesInput;
};

export type UserProductOrderLineDetails = {
  __typename?: 'UserProductOrderLineDetails';
  bundle: Scalars['Boolean']['output'];
  countPerBundle?: Maybe<Scalars['Int']['output']>;
  fbaBoxHeight?: Maybe<Scalars['Float']['output']>;
  fbaBoxLength?: Maybe<Scalars['Float']['output']>;
  fbaBoxWeight?: Maybe<Scalars['Float']['output']>;
  fbaBoxWidth?: Maybe<Scalars['Float']['output']>;
  fbaUnitsPerBox?: Maybe<Scalars['Int']['output']>;
  fulfillmentOrderLineItemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isPrepared: Scalars['Boolean']['output'];
  isRefunded: Scalars['Boolean']['output'];
  labelUrl: Scalars['String']['output'];
  /** @deprecated Legacy V1 verification, not maintained by the V2 flow. Verification lives on the line's linked UserProductLabel row — use isOrderLineLabelVerified / orderLineLabelVerifiedWhere. */
  labelVerified: Scalars['Boolean']['output'];
  nameSupliful: Scalars['String']['output'];
  preparedAt?: Maybe<Scalars['DateTime']['output']>;
  priceManufacturer: Scalars['Float']['output'];
  priceSpecial?: Maybe<Scalars['Float']['output']>;
  priceSupliful: Scalars['Float']['output'];
  productImageUrl: Scalars['String']['output'];
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
  weightUnit: WeightUnit;
};

export type UserProductOrderLineDetailsCreateNestedOneWithoutLineInput = {
  connect?: InputMaybe<UserProductOrderLineDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineDetailsCreateOrConnectWithoutLineInput>;
  create?: InputMaybe<UserProductOrderLineDetailsCreateWithoutLineInput>;
};

export type UserProductOrderLineDetailsCreateOrConnectWithoutLineInput = {
  create: UserProductOrderLineDetailsCreateWithoutLineInput;
  where: UserProductOrderLineDetailsWhereUniqueInput;
};

export type UserProductOrderLineDetailsCreateWithoutLineInput = {
  bundle?: InputMaybe<Scalars['Boolean']['input']>;
  countPerBundle?: InputMaybe<Scalars['Int']['input']>;
  fbaBoxHeight?: InputMaybe<Scalars['Float']['input']>;
  fbaBoxLength?: InputMaybe<Scalars['Float']['input']>;
  fbaBoxWeight?: InputMaybe<Scalars['Float']['input']>;
  fbaBoxWidth?: InputMaybe<Scalars['Float']['input']>;
  fbaUnitsPerBox?: InputMaybe<Scalars['Int']['input']>;
  fulfillmentOrderLineItemId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrepared?: InputMaybe<Scalars['Boolean']['input']>;
  isRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  labelUrl: Scalars['String']['input'];
  labelVerified?: InputMaybe<Scalars['Boolean']['input']>;
  nameSupliful: Scalars['String']['input'];
  preparedAt?: InputMaybe<Scalars['DateTime']['input']>;
  priceManufacturer: Scalars['Float']['input'];
  priceSpecial?: InputMaybe<Scalars['Float']['input']>;
  priceSupliful: Scalars['Float']['input'];
  productImageUrl: Scalars['String']['input'];
  refundedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  total: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
  weightUnit: WeightUnit;
};

export type UserProductOrderLineDetailsNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderLineDetailsWhereInput>;
  isNot?: InputMaybe<UserProductOrderLineDetailsWhereInput>;
};

export type UserProductOrderLineDetailsOrderByWithRelationInput = {
  bundle?: InputMaybe<SortOrder>;
  countPerBundle?: InputMaybe<SortOrderInput>;
  fbaBoxHeight?: InputMaybe<SortOrderInput>;
  fbaBoxLength?: InputMaybe<SortOrderInput>;
  fbaBoxWeight?: InputMaybe<SortOrderInput>;
  fbaBoxWidth?: InputMaybe<SortOrderInput>;
  fbaUnitsPerBox?: InputMaybe<SortOrderInput>;
  fulfillmentOrderLineItemId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isPrepared?: InputMaybe<SortOrder>;
  isRefunded?: InputMaybe<SortOrder>;
  labelUrl?: InputMaybe<SortOrder>;
  labelVerified?: InputMaybe<SortOrder>;
  line?: InputMaybe<UserProductOrderLineOrderByWithRelationInput>;
  nameSupliful?: InputMaybe<SortOrder>;
  preparedAt?: InputMaybe<SortOrderInput>;
  priceManufacturer?: InputMaybe<SortOrder>;
  priceSpecial?: InputMaybe<SortOrderInput>;
  priceSupliful?: InputMaybe<SortOrder>;
  productImageUrl?: InputMaybe<SortOrder>;
  refundedAt?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
  weightUnit?: InputMaybe<SortOrder>;
};

export type UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput = {
  connect?: InputMaybe<UserProductOrderLineDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineDetailsCreateOrConnectWithoutLineInput>;
  create?: InputMaybe<UserProductOrderLineDetailsCreateWithoutLineInput>;
  delete?: InputMaybe<UserProductOrderLineDetailsWhereInput>;
  disconnect?: InputMaybe<UserProductOrderLineDetailsWhereInput>;
  update?: InputMaybe<UserProductOrderLineDetailsUpdateToOneWithWhereWithoutLineInput>;
  upsert?: InputMaybe<UserProductOrderLineDetailsUpsertWithoutLineInput>;
};

export type UserProductOrderLineDetailsUpdateToOneWithWhereWithoutLineInput = {
  data: UserProductOrderLineDetailsUpdateWithoutLineInput;
  where?: InputMaybe<UserProductOrderLineDetailsWhereInput>;
};

export type UserProductOrderLineDetailsUpdateWithoutLineInput = {
  bundle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  countPerBundle?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaBoxHeight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fbaBoxLength?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fbaBoxWeight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fbaBoxWidth?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  fbaUnitsPerBox?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fulfillmentOrderLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPrepared?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRefunded?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  labelVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nameSupliful?: InputMaybe<StringFieldUpdateOperationsInput>;
  preparedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  priceManufacturer?: InputMaybe<FloatFieldUpdateOperationsInput>;
  priceSpecial?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSupliful?: InputMaybe<FloatFieldUpdateOperationsInput>;
  productImageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  refundedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  total?: InputMaybe<FloatFieldUpdateOperationsInput>;
  weight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  weightUnit?: InputMaybe<EnumWeightUnitFieldUpdateOperationsInput>;
};

export type UserProductOrderLineDetailsUpsertWithoutLineInput = {
  create: UserProductOrderLineDetailsCreateWithoutLineInput;
  update: UserProductOrderLineDetailsUpdateWithoutLineInput;
  where?: InputMaybe<UserProductOrderLineDetailsWhereInput>;
};

export type UserProductOrderLineDetailsWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderLineDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineDetailsWhereInput>>;
  bundle?: InputMaybe<BoolFilter>;
  countPerBundle?: InputMaybe<IntNullableFilter>;
  fbaBoxHeight?: InputMaybe<FloatNullableFilter>;
  fbaBoxLength?: InputMaybe<FloatNullableFilter>;
  fbaBoxWeight?: InputMaybe<FloatNullableFilter>;
  fbaBoxWidth?: InputMaybe<FloatNullableFilter>;
  fbaUnitsPerBox?: InputMaybe<IntNullableFilter>;
  fulfillmentOrderLineItemId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isPrepared?: InputMaybe<BoolFilter>;
  isRefunded?: InputMaybe<BoolFilter>;
  labelUrl?: InputMaybe<StringFilter>;
  labelVerified?: InputMaybe<BoolFilter>;
  line?: InputMaybe<UserProductOrderLineNullableRelationFilter>;
  nameSupliful?: InputMaybe<StringFilter>;
  preparedAt?: InputMaybe<DateTimeNullableFilter>;
  priceManufacturer?: InputMaybe<FloatFilter>;
  priceSpecial?: InputMaybe<FloatNullableFilter>;
  priceSupliful?: InputMaybe<FloatFilter>;
  productImageUrl?: InputMaybe<StringFilter>;
  refundedAt?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  total?: InputMaybe<FloatFilter>;
  weight?: InputMaybe<FloatFilter>;
  weightUnit?: InputMaybe<EnumWeightUnitFilter>;
};

export type UserProductOrderLineDetailsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderLineDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineDetailsWhereInput>>;
  bundle?: InputMaybe<BoolFilter>;
  countPerBundle?: InputMaybe<IntNullableFilter>;
  fbaBoxHeight?: InputMaybe<FloatNullableFilter>;
  fbaBoxLength?: InputMaybe<FloatNullableFilter>;
  fbaBoxWeight?: InputMaybe<FloatNullableFilter>;
  fbaBoxWidth?: InputMaybe<FloatNullableFilter>;
  fbaUnitsPerBox?: InputMaybe<IntNullableFilter>;
  fulfillmentOrderLineItemId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrepared?: InputMaybe<BoolFilter>;
  isRefunded?: InputMaybe<BoolFilter>;
  labelUrl?: InputMaybe<StringFilter>;
  labelVerified?: InputMaybe<BoolFilter>;
  line?: InputMaybe<UserProductOrderLineNullableRelationFilter>;
  nameSupliful?: InputMaybe<StringFilter>;
  preparedAt?: InputMaybe<DateTimeNullableFilter>;
  priceManufacturer?: InputMaybe<FloatFilter>;
  priceSpecial?: InputMaybe<FloatNullableFilter>;
  priceSupliful?: InputMaybe<FloatFilter>;
  productImageUrl?: InputMaybe<StringFilter>;
  refundedAt?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  total?: InputMaybe<FloatFilter>;
  weight?: InputMaybe<FloatFilter>;
  weightUnit?: InputMaybe<EnumWeightUnitFilter>;
};

export type UserProductOrderLineFulfillmentFee = {
  __typename?: 'UserProductOrderLineFulfillmentFee';
  count: Scalars['Int']['output'];
  fulfillmentFee: Scalars['Float']['output'];
  fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType;
  id: Scalars['String']['output'];
  lineId: Scalars['String']['output'];
};

export type UserProductOrderLineFulfillmentFeeCreateManyLineInput = {
  count: Scalars['Int']['input'];
  fulfillmentFee: Scalars['Float']['input'];
  fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineFulfillmentFeeCreateManyLineInputEnvelope = {
  data: Array<UserProductOrderLineFulfillmentFeeCreateManyLineInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLineFulfillmentFeeCreateNestedManyWithoutLineInput = {
  connect?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeCreateOrConnectWithoutLineInput>>;
  create?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeCreateWithoutLineInput>>;
  createMany?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateManyLineInputEnvelope>;
};

export type UserProductOrderLineFulfillmentFeeCreateOrConnectWithoutLineInput = {
  create: UserProductOrderLineFulfillmentFeeCreateWithoutLineInput;
  where: UserProductOrderLineFulfillmentFeeWhereUniqueInput;
};

export type UserProductOrderLineFulfillmentFeeCreateWithoutLineInput = {
  count: Scalars['Int']['input'];
  fulfillmentFee: Scalars['Float']['input'];
  fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineFulfillmentFeeListRelationFilter = {
  every?: InputMaybe<UserProductOrderLineFulfillmentFeeWhereInput>;
  none?: InputMaybe<UserProductOrderLineFulfillmentFeeWhereInput>;
  some?: InputMaybe<UserProductOrderLineFulfillmentFeeWhereInput>;
};

export type UserProductOrderLineFulfillmentFeeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserProductOrderLineFulfillmentFeeOrderByWithRelationInput = {
  count?: InputMaybe<SortOrder>;
  fulfillmentFee?: InputMaybe<SortOrder>;
  fulfillmentFeeType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  line?: InputMaybe<UserProductOrderLineOrderByWithRelationInput>;
  lineId?: InputMaybe<SortOrder>;
};

export enum UserProductOrderLineFulfillmentFeeScalarFieldEnum {
  Count = 'count',
  FulfillmentFee = 'fulfillmentFee',
  FulfillmentFeeType = 'fulfillmentFeeType',
  Id = 'id',
  LineId = 'lineId'
}

export type UserProductOrderLineFulfillmentFeeScalarWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeScalarWhereInput>>;
  count?: InputMaybe<IntFilter>;
  fulfillmentFee?: InputMaybe<FloatFilter>;
  fulfillmentFeeType?: InputMaybe<EnumUserProductOrderLineFulfillmentFeeTypeFilter>;
  id?: InputMaybe<UuidFilter>;
  lineId?: InputMaybe<UuidFilter>;
};

export enum UserProductOrderLineFulfillmentFeeType {
  AdditionalUnit = 'ADDITIONAL_UNIT',
  Exempt = 'EXEMPT',
  FirstUnit = 'FIRST_UNIT'
}

export type UserProductOrderLineFulfillmentFeeUpdateManyMutationInput = {
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  fulfillmentFee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fulfillmentFeeType?: InputMaybe<EnumUserProductOrderLineFulfillmentFeeTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProductOrderLineFulfillmentFeeUpdateManyWithWhereWithoutLineInput = {
  data: UserProductOrderLineFulfillmentFeeUpdateManyMutationInput;
  where: UserProductOrderLineFulfillmentFeeScalarWhereInput;
};

export type UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeCreateOrConnectWithoutLineInput>>;
  create?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeCreateWithoutLineInput>>;
  createMany?: InputMaybe<UserProductOrderLineFulfillmentFeeCreateManyLineInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeUpdateWithWhereUniqueWithoutLineInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeUpdateManyWithWhereWithoutLineInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeUpsertWithWhereUniqueWithoutLineInput>>;
};

export type UserProductOrderLineFulfillmentFeeUpdateWithWhereUniqueWithoutLineInput = {
  data: UserProductOrderLineFulfillmentFeeUpdateWithoutLineInput;
  where: UserProductOrderLineFulfillmentFeeWhereUniqueInput;
};

export type UserProductOrderLineFulfillmentFeeUpdateWithoutLineInput = {
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  fulfillmentFee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fulfillmentFeeType?: InputMaybe<EnumUserProductOrderLineFulfillmentFeeTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProductOrderLineFulfillmentFeeUpsertWithWhereUniqueWithoutLineInput = {
  create: UserProductOrderLineFulfillmentFeeCreateWithoutLineInput;
  update: UserProductOrderLineFulfillmentFeeUpdateWithoutLineInput;
  where: UserProductOrderLineFulfillmentFeeWhereUniqueInput;
};

export type UserProductOrderLineFulfillmentFeeWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereInput>>;
  count?: InputMaybe<IntFilter>;
  fulfillmentFee?: InputMaybe<FloatFilter>;
  fulfillmentFeeType?: InputMaybe<EnumUserProductOrderLineFulfillmentFeeTypeFilter>;
  id?: InputMaybe<UuidFilter>;
  line?: InputMaybe<UserProductOrderLineRelationFilter>;
  lineId?: InputMaybe<UuidFilter>;
};

export type UserProductOrderLineFulfillmentFeeWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeWhereInput>>;
  count?: InputMaybe<IntFilter>;
  fulfillmentFee?: InputMaybe<FloatFilter>;
  fulfillmentFeeType?: InputMaybe<EnumUserProductOrderLineFulfillmentFeeTypeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  line?: InputMaybe<UserProductOrderLineRelationFilter>;
  lineId?: InputMaybe<UuidFilter>;
};

export type UserProductOrderLineListRelationFilter = {
  every?: InputMaybe<UserProductOrderLineWhereInput>;
  none?: InputMaybe<UserProductOrderLineWhereInput>;
  some?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductOrderLineModel = {
  __typename?: 'UserProductOrderLineModel';
  _count?: Maybe<UserProductOrderLineCount>;
  clickfunnelsLineDetails?: Maybe<UserProductOrderLineClickFunnelsDetails>;
  clickfunnelsLineDetailsId?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  details?: Maybe<UserProductOrderLineDetails>;
  detailsId?: Maybe<Scalars['String']['output']>;
  everlabOrder?: Maybe<EverlabOrder>;
  everlabOrderId?: Maybe<Scalars['String']['output']>;
  fulfillmentFees: Array<UserProductOrderLineFulfillmentFee>;
  id: Scalars['String']['output'];
  isReplacement: Scalars['Boolean']['output'];
  jetpackApiOrder?: Maybe<JetpackApiOrder>;
  jetpackApiOrderId?: Maybe<Scalars['String']['output']>;
  label?: Maybe<UserProductLabel>;
  labelId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<UserProductOrderModel>;
  orderId: Scalars['String']['output'];
  originalLine?: Maybe<UserProductOrderLine>;
  originalLineId?: Maybe<Scalars['String']['output']>;
  originalPriceSold: Scalars['Float']['output'];
  prePaidPriceApplied: Scalars['Boolean']['output'];
  preparationHistory: Array<UserProductOrderLinePreparationHistory>;
  preparedBy?: Maybe<Admin>;
  preparedById?: Maybe<Scalars['String']['output']>;
  priceSold: Scalars['Float']['output'];
  printBatches: Array<PrintBatchOrderLine>;
  refundedBy?: Maybe<Admin>;
  refundedById?: Maybe<Scalars['String']['output']>;
  replacementLines: Array<UserProductOrderLine>;
  reshipment?: Maybe<Shipment>;
  reshipmentId?: Maybe<Scalars['String']['output']>;
  roastifyOrder?: Maybe<RoastifyOrder>;
  roastifyOrderId?: Maybe<Scalars['String']['output']>;
  shipbobOrder?: Maybe<ShipbobOrder>;
  shipbobOrderId?: Maybe<Scalars['String']['output']>;
  shipheroInternalLineItemId?: Maybe<Scalars['String']['output']>;
  shipheroLineItemId?: Maybe<Scalars['String']['output']>;
  shipment?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  subLine?: Maybe<UserProductOrderSubLineItem>;
  subLineId?: Maybe<Scalars['String']['output']>;
  tiktokLineDetails?: Maybe<UserProductOrderLineTiktokDetails>;
  tiktokLineDetailsId?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['String']['output'];
  userProduct: UserProductModel;
  userProductId: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId?: Maybe<Scalars['String']['output']>;
};


export type UserProductOrderLineModelClickfunnelsLineDetailsArgs = {
  where?: InputMaybe<UserProductOrderLineClickFunnelsDetailsWhereInput>;
};


export type UserProductOrderLineModelDetailsArgs = {
  where?: InputMaybe<UserProductOrderLineDetailsWhereInput>;
};


export type UserProductOrderLineModelEverlabOrderArgs = {
  where?: InputMaybe<EverlabOrderWhereInput>;
};


export type UserProductOrderLineModelFulfillmentFeesArgs = {
  cursor?: InputMaybe<UserProductOrderLineFulfillmentFeeWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLineFulfillmentFeeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLineFulfillmentFeeWhereInput>;
};


export type UserProductOrderLineModelJetpackApiOrderArgs = {
  where?: InputMaybe<JetpackApiOrderWhereInput>;
};


export type UserProductOrderLineModelLabelArgs = {
  where?: InputMaybe<UserProductLabelWhereInput>;
};


export type UserProductOrderLineModelOriginalLineArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type UserProductOrderLineModelPreparationHistoryArgs = {
  cursor?: InputMaybe<UserProductOrderLinePreparationHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLinePreparationHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLinePreparationHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLinePreparationHistoryWhereInput>;
};


export type UserProductOrderLineModelPreparedByArgs = {
  where?: InputMaybe<AdminWhereInput>;
};


export type UserProductOrderLineModelPrintBatchesArgs = {
  cursor?: InputMaybe<PrintBatchOrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<PrintBatchOrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PrintBatchOrderLineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PrintBatchOrderLineWhereInput>;
};


export type UserProductOrderLineModelRefundedByArgs = {
  where?: InputMaybe<AdminWhereInput>;
};


export type UserProductOrderLineModelReplacementLinesArgs = {
  cursor?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderLineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type UserProductOrderLineModelReshipmentArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};


export type UserProductOrderLineModelRoastifyOrderArgs = {
  where?: InputMaybe<RoastifyOrderWhereInput>;
};


export type UserProductOrderLineModelShipbobOrderArgs = {
  where?: InputMaybe<ShipbobOrderWhereInput>;
};


export type UserProductOrderLineModelShipmentArgs = {
  where?: InputMaybe<ShipmentWhereInput>;
};


export type UserProductOrderLineModelSubLineArgs = {
  where?: InputMaybe<UserProductOrderSubLineItemWhereInput>;
};


export type UserProductOrderLineModelTiktokLineDetailsArgs = {
  where?: InputMaybe<UserProductOrderLineTiktokDetailsWhereInput>;
};


export type UserProductOrderLineModelWarehouseArgs = {
  where?: InputMaybe<WarehouseWhereInput>;
};

export type UserProductOrderLineNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderLineWhereInput>;
  isNot?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductOrderLineOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserProductOrderLineOrderByWithRelationInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsOrderByWithRelationInput>;
  clickfunnelsLineDetailsId?: InputMaybe<SortOrderInput>;
  count?: InputMaybe<SortOrder>;
  details?: InputMaybe<UserProductOrderLineDetailsOrderByWithRelationInput>;
  detailsId?: InputMaybe<SortOrderInput>;
  everlabOrder?: InputMaybe<EverlabOrderOrderByWithRelationInput>;
  everlabOrderId?: InputMaybe<SortOrderInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isReplacement?: InputMaybe<SortOrder>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderOrderByWithRelationInput>;
  jetpackApiOrderId?: InputMaybe<SortOrderInput>;
  label?: InputMaybe<UserProductLabelOrderByWithRelationInput>;
  labelId?: InputMaybe<SortOrderInput>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  originalLine?: InputMaybe<UserProductOrderLineOrderByWithRelationInput>;
  originalLineId?: InputMaybe<SortOrderInput>;
  originalPriceSold?: InputMaybe<SortOrder>;
  prePaidPriceApplied?: InputMaybe<SortOrder>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryOrderByRelationAggregateInput>;
  preparedBy?: InputMaybe<AdminOrderByWithRelationInput>;
  preparedById?: InputMaybe<SortOrderInput>;
  priceSold?: InputMaybe<SortOrder>;
  printBatches?: InputMaybe<PrintBatchOrderLineOrderByRelationAggregateInput>;
  refundedBy?: InputMaybe<AdminOrderByWithRelationInput>;
  refundedById?: InputMaybe<SortOrderInput>;
  replacementLines?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  reshipment?: InputMaybe<ShipmentOrderByWithRelationInput>;
  reshipmentId?: InputMaybe<SortOrderInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderOrderByWithRelationInput>;
  roastifyOrderId?: InputMaybe<SortOrderInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderOrderByWithRelationInput>;
  shipbobOrderId?: InputMaybe<SortOrderInput>;
  shipheroInternalLineItemId?: InputMaybe<SortOrderInput>;
  shipheroLineItemId?: InputMaybe<SortOrderInput>;
  shipment?: InputMaybe<ShipmentOrderByWithRelationInput>;
  shipmentId?: InputMaybe<SortOrderInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemOrderByWithRelationInput>;
  subLineId?: InputMaybe<SortOrderInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsOrderByWithRelationInput>;
  tiktokLineDetailsId?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  userProduct?: InputMaybe<UserProductOrderByWithRelationInput>;
  userProductId?: InputMaybe<SortOrder>;
  warehouse?: InputMaybe<WarehouseOrderByWithRelationInput>;
  warehouseId?: InputMaybe<SortOrderInput>;
};

export type UserProductOrderLinePreparationHistory = {
  __typename?: 'UserProductOrderLinePreparationHistory';
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPrepared: Scalars['Boolean']['output'];
  lineId: Scalars['String']['output'];
  unprepareReason?: Maybe<UnprepareReason>;
};

export type UserProductOrderLinePreparationHistoryCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrepared?: InputMaybe<Scalars['Boolean']['input']>;
  lineId: Scalars['String']['input'];
  unprepareReason?: InputMaybe<UnprepareReason>;
};

export type UserProductOrderLinePreparationHistoryCreateManyCreatedByInputEnvelope = {
  data: Array<UserProductOrderLinePreparationHistoryCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLinePreparationHistoryCreateManyLineInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isPrepared?: InputMaybe<Scalars['Boolean']['input']>;
  unprepareReason?: InputMaybe<UnprepareReason>;
};

export type UserProductOrderLinePreparationHistoryCreateManyLineInputEnvelope = {
  data: Array<UserProductOrderLinePreparationHistoryCreateManyLineInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderLinePreparationHistoryCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLinePreparationHistoryCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<UserProductOrderLinePreparationHistoryCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<UserProductOrderLinePreparationHistoryCreateManyCreatedByInputEnvelope>;
};

export type UserProductOrderLinePreparationHistoryCreateNestedManyWithoutLineInput = {
  connect?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLinePreparationHistoryCreateOrConnectWithoutLineInput>>;
  create?: InputMaybe<Array<UserProductOrderLinePreparationHistoryCreateWithoutLineInput>>;
  createMany?: InputMaybe<UserProductOrderLinePreparationHistoryCreateManyLineInputEnvelope>;
};

export type UserProductOrderLinePreparationHistoryCreateOrConnectWithoutCreatedByInput = {
  create: UserProductOrderLinePreparationHistoryCreateWithoutCreatedByInput;
  where: UserProductOrderLinePreparationHistoryWhereUniqueInput;
};

export type UserProductOrderLinePreparationHistoryCreateOrConnectWithoutLineInput = {
  create: UserProductOrderLinePreparationHistoryCreateWithoutLineInput;
  where: UserProductOrderLinePreparationHistoryWhereUniqueInput;
};

export type UserProductOrderLinePreparationHistoryCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrepared?: InputMaybe<Scalars['Boolean']['input']>;
  line: UserProductOrderLineCreateNestedOneWithoutPreparationHistoryInput;
  unprepareReason?: InputMaybe<UnprepareReason>;
};

export type UserProductOrderLinePreparationHistoryCreateWithoutLineInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: AdminCreateNestedOneWithoutLinePreparationHistoryInput;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrepared?: InputMaybe<Scalars['Boolean']['input']>;
  unprepareReason?: InputMaybe<UnprepareReason>;
};

export type UserProductOrderLinePreparationHistoryListRelationFilter = {
  every?: InputMaybe<UserProductOrderLinePreparationHistoryWhereInput>;
  none?: InputMaybe<UserProductOrderLinePreparationHistoryWhereInput>;
  some?: InputMaybe<UserProductOrderLinePreparationHistoryWhereInput>;
};

export type UserProductOrderLinePreparationHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserProductOrderLinePreparationHistoryOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<AdminOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPrepared?: InputMaybe<SortOrder>;
  line?: InputMaybe<UserProductOrderLineOrderByWithRelationInput>;
  lineId?: InputMaybe<SortOrder>;
  unprepareReason?: InputMaybe<SortOrderInput>;
};

export enum UserProductOrderLinePreparationHistoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  Id = 'id',
  IsPrepared = 'isPrepared',
  LineId = 'lineId',
  UnprepareReason = 'unprepareReason'
}

export type UserProductOrderLinePreparationHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderLinePreparationHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLinePreparationHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLinePreparationHistoryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isPrepared?: InputMaybe<BoolFilter>;
  lineId?: InputMaybe<UuidFilter>;
  unprepareReason?: InputMaybe<EnumUnprepareReasonNullableFilter>;
};

export type UserProductOrderLinePreparationHistoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPrepared?: InputMaybe<BoolFieldUpdateOperationsInput>;
  unprepareReason?: InputMaybe<NullableEnumUnprepareReasonFieldUpdateOperationsInput>;
};

export type UserProductOrderLinePreparationHistoryUpdateManyWithWhereWithoutCreatedByInput = {
  data: UserProductOrderLinePreparationHistoryUpdateManyMutationInput;
  where: UserProductOrderLinePreparationHistoryScalarWhereInput;
};

export type UserProductOrderLinePreparationHistoryUpdateManyWithWhereWithoutLineInput = {
  data: UserProductOrderLinePreparationHistoryUpdateManyMutationInput;
  where: UserProductOrderLinePreparationHistoryScalarWhereInput;
};

export type UserProductOrderLinePreparationHistoryUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLinePreparationHistoryCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<UserProductOrderLinePreparationHistoryCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<UserProductOrderLinePreparationHistoryCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLinePreparationHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLinePreparationHistoryUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLinePreparationHistoryUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLinePreparationHistoryUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLinePreparationHistoryCreateOrConnectWithoutLineInput>>;
  create?: InputMaybe<Array<UserProductOrderLinePreparationHistoryCreateWithoutLineInput>>;
  createMany?: InputMaybe<UserProductOrderLinePreparationHistoryCreateManyLineInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLinePreparationHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLinePreparationHistoryUpdateWithWhereUniqueWithoutLineInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLinePreparationHistoryUpdateManyWithWhereWithoutLineInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLinePreparationHistoryUpsertWithWhereUniqueWithoutLineInput>>;
};

export type UserProductOrderLinePreparationHistoryUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: UserProductOrderLinePreparationHistoryUpdateWithoutCreatedByInput;
  where: UserProductOrderLinePreparationHistoryWhereUniqueInput;
};

export type UserProductOrderLinePreparationHistoryUpdateWithWhereUniqueWithoutLineInput = {
  data: UserProductOrderLinePreparationHistoryUpdateWithoutLineInput;
  where: UserProductOrderLinePreparationHistoryWhereUniqueInput;
};

export type UserProductOrderLinePreparationHistoryUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPrepared?: InputMaybe<BoolFieldUpdateOperationsInput>;
  line?: InputMaybe<UserProductOrderLineUpdateOneRequiredWithoutPreparationHistoryNestedInput>;
  unprepareReason?: InputMaybe<NullableEnumUnprepareReasonFieldUpdateOperationsInput>;
};

export type UserProductOrderLinePreparationHistoryUpdateWithoutLineInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneRequiredWithoutLinePreparationHistoryNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPrepared?: InputMaybe<BoolFieldUpdateOperationsInput>;
  unprepareReason?: InputMaybe<NullableEnumUnprepareReasonFieldUpdateOperationsInput>;
};

export type UserProductOrderLinePreparationHistoryUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: UserProductOrderLinePreparationHistoryCreateWithoutCreatedByInput;
  update: UserProductOrderLinePreparationHistoryUpdateWithoutCreatedByInput;
  where: UserProductOrderLinePreparationHistoryWhereUniqueInput;
};

export type UserProductOrderLinePreparationHistoryUpsertWithWhereUniqueWithoutLineInput = {
  create: UserProductOrderLinePreparationHistoryCreateWithoutLineInput;
  update: UserProductOrderLinePreparationHistoryUpdateWithoutLineInput;
  where: UserProductOrderLinePreparationHistoryWhereUniqueInput;
};

export type UserProductOrderLinePreparationHistoryWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminRelationFilter>;
  createdById?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isPrepared?: InputMaybe<BoolFilter>;
  line?: InputMaybe<UserProductOrderLineRelationFilter>;
  lineId?: InputMaybe<UuidFilter>;
  unprepareReason?: InputMaybe<EnumUnprepareReasonNullableFilter>;
};

export type UserProductOrderLinePreparationHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLinePreparationHistoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminRelationFilter>;
  createdById?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrepared?: InputMaybe<BoolFilter>;
  line?: InputMaybe<UserProductOrderLineRelationFilter>;
  lineId?: InputMaybe<UuidFilter>;
  unprepareReason?: InputMaybe<EnumUnprepareReasonNullableFilter>;
};

export type UserProductOrderLineRelationFilter = {
  is?: InputMaybe<UserProductOrderLineWhereInput>;
  isNot?: InputMaybe<UserProductOrderLineWhereInput>;
};

export enum UserProductOrderLineScalarFieldEnum {
  ClickfunnelsLineDetailsId = 'clickfunnelsLineDetailsId',
  Count = 'count',
  DetailsId = 'detailsId',
  EverlabOrderId = 'everlabOrderId',
  Id = 'id',
  IsReplacement = 'isReplacement',
  JetpackApiOrderId = 'jetpackApiOrderId',
  LabelId = 'labelId',
  OrderId = 'orderId',
  OriginalLineId = 'originalLineId',
  OriginalPriceSold = 'originalPriceSold',
  PrePaidPriceApplied = 'prePaidPriceApplied',
  PreparedById = 'preparedById',
  PriceSold = 'priceSold',
  RefundedById = 'refundedById',
  ReshipmentId = 'reshipmentId',
  RoastifyOrderId = 'roastifyOrderId',
  ShipbobOrderId = 'shipbobOrderId',
  ShipheroInternalLineItemId = 'shipheroInternalLineItemId',
  ShipheroLineItemId = 'shipheroLineItemId',
  ShipmentId = 'shipmentId',
  SubLineId = 'subLineId',
  TiktokLineDetailsId = 'tiktokLineDetailsId',
  UserId = 'userId',
  UserProductId = 'userProductId',
  WarehouseId = 'warehouseId'
}

export type UserProductOrderLineScalarWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  clickfunnelsLineDetailsId?: InputMaybe<UuidNullableFilter>;
  count?: InputMaybe<IntFilter>;
  detailsId?: InputMaybe<UuidNullableFilter>;
  everlabOrderId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isReplacement?: InputMaybe<BoolFilter>;
  jetpackApiOrderId?: InputMaybe<UuidNullableFilter>;
  labelId?: InputMaybe<UuidNullableFilter>;
  orderId?: InputMaybe<UuidFilter>;
  originalLineId?: InputMaybe<UuidNullableFilter>;
  originalPriceSold?: InputMaybe<FloatFilter>;
  prePaidPriceApplied?: InputMaybe<BoolFilter>;
  preparedById?: InputMaybe<UuidNullableFilter>;
  priceSold?: InputMaybe<FloatFilter>;
  refundedById?: InputMaybe<UuidNullableFilter>;
  reshipmentId?: InputMaybe<StringNullableFilter>;
  roastifyOrderId?: InputMaybe<UuidNullableFilter>;
  shipbobOrderId?: InputMaybe<UuidNullableFilter>;
  shipheroInternalLineItemId?: InputMaybe<StringNullableFilter>;
  shipheroLineItemId?: InputMaybe<StringNullableFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  subLineId?: InputMaybe<UuidNullableFilter>;
  tiktokLineDetailsId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProductId?: InputMaybe<UuidFilter>;
  warehouseId?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderLineTiktokDetails = {
  __typename?: 'UserProductOrderLineTiktokDetails';
  id: Scalars['String']['output'];
  tiktokLineId: Scalars['String']['output'];
  tiktokPackageId?: Maybe<Scalars['String']['output']>;
};

export type UserProductOrderLineTiktokDetailsCreateNestedOneWithoutUserProductOrderLineInput = {
  connect?: InputMaybe<UserProductOrderLineTiktokDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineTiktokDetailsCreateOrConnectWithoutUserProductOrderLineInput>;
  create?: InputMaybe<UserProductOrderLineTiktokDetailsCreateWithoutUserProductOrderLineInput>;
};

export type UserProductOrderLineTiktokDetailsCreateOrConnectWithoutUserProductOrderLineInput = {
  create: UserProductOrderLineTiktokDetailsCreateWithoutUserProductOrderLineInput;
  where: UserProductOrderLineTiktokDetailsWhereUniqueInput;
};

export type UserProductOrderLineTiktokDetailsCreateWithoutUserProductOrderLineInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  tiktokLineId: Scalars['String']['input'];
  tiktokPackageId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderLineTiktokDetailsNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderLineTiktokDetailsWhereInput>;
  isNot?: InputMaybe<UserProductOrderLineTiktokDetailsWhereInput>;
};

export type UserProductOrderLineTiktokDetailsOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  tiktokLineId?: InputMaybe<SortOrder>;
  tiktokPackageId?: InputMaybe<SortOrderInput>;
  userProductOrderLine?: InputMaybe<UserProductOrderLineOrderByWithRelationInput>;
};

export type UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput = {
  connect?: InputMaybe<UserProductOrderLineTiktokDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineTiktokDetailsCreateOrConnectWithoutUserProductOrderLineInput>;
  create?: InputMaybe<UserProductOrderLineTiktokDetailsCreateWithoutUserProductOrderLineInput>;
  delete?: InputMaybe<UserProductOrderLineTiktokDetailsWhereInput>;
  disconnect?: InputMaybe<UserProductOrderLineTiktokDetailsWhereInput>;
  update?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateToOneWithWhereWithoutUserProductOrderLineInput>;
  upsert?: InputMaybe<UserProductOrderLineTiktokDetailsUpsertWithoutUserProductOrderLineInput>;
};

export type UserProductOrderLineTiktokDetailsUpdateToOneWithWhereWithoutUserProductOrderLineInput = {
  data: UserProductOrderLineTiktokDetailsUpdateWithoutUserProductOrderLineInput;
  where?: InputMaybe<UserProductOrderLineTiktokDetailsWhereInput>;
};

export type UserProductOrderLineTiktokDetailsUpdateWithoutUserProductOrderLineInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  tiktokLineId?: InputMaybe<StringFieldUpdateOperationsInput>;
  tiktokPackageId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductOrderLineTiktokDetailsUpsertWithoutUserProductOrderLineInput = {
  create: UserProductOrderLineTiktokDetailsCreateWithoutUserProductOrderLineInput;
  update: UserProductOrderLineTiktokDetailsUpdateWithoutUserProductOrderLineInput;
  where?: InputMaybe<UserProductOrderLineTiktokDetailsWhereInput>;
};

export type UserProductOrderLineTiktokDetailsWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderLineTiktokDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineTiktokDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineTiktokDetailsWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  tiktokLineId?: InputMaybe<StringFilter>;
  tiktokPackageId?: InputMaybe<StringNullableFilter>;
  userProductOrderLine?: InputMaybe<UserProductOrderLineNullableRelationFilter>;
};

export type UserProductOrderLineTiktokDetailsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderLineTiktokDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineTiktokDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineTiktokDetailsWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  tiktokLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokPackageId?: InputMaybe<StringNullableFilter>;
  userProductOrderLine?: InputMaybe<UserProductOrderLineNullableRelationFilter>;
};

export type UserProductOrderLineUpdateManyMutationInput = {
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutEverlabOrderInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutJetpackApiOrderInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutOrderInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutOriginalLineInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutPreparedByInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutRefundedByInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutReshipmentInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutRoastifyOrderInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutShipbobOrderInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutShipmentInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutUserInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithWhereWithoutWarehouseInput = {
  data: UserProductOrderLineUpdateManyMutationInput;
  where: UserProductOrderLineScalarWhereInput;
};

export type UserProductOrderLineUpdateManyWithoutEverlabOrderNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutEverlabOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutEverlabOrderInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyEverlabOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutEverlabOrderInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutEverlabOrderInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutEverlabOrderInput>>;
};

export type UserProductOrderLineUpdateManyWithoutJetpackApiOrderNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutJetpackApiOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutJetpackApiOrderInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyJetpackApiOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutJetpackApiOrderInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutJetpackApiOrderInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutJetpackApiOrderInput>>;
};

export type UserProductOrderLineUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutOrderInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutOriginalLineInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutOriginalLineInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyOriginalLineInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutOriginalLineInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutOriginalLineInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutOriginalLineInput>>;
};

export type UserProductOrderLineUpdateManyWithoutPreparedByNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutPreparedByInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutPreparedByInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyPreparedByInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutPreparedByInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutPreparedByInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutPreparedByInput>>;
};

export type UserProductOrderLineUpdateManyWithoutRefundedByNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutRefundedByInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutRefundedByInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyRefundedByInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutRefundedByInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutRefundedByInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutRefundedByInput>>;
};

export type UserProductOrderLineUpdateManyWithoutReshipmentNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutReshipmentInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutReshipmentInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyReshipmentInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutReshipmentInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutReshipmentInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutReshipmentInput>>;
};

export type UserProductOrderLineUpdateManyWithoutRoastifyOrderNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutRoastifyOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutRoastifyOrderInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyRoastifyOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutRoastifyOrderInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutRoastifyOrderInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutRoastifyOrderInput>>;
};

export type UserProductOrderLineUpdateManyWithoutShipbobOrderNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutShipbobOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutShipbobOrderInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyShipbobOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutShipbobOrderInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutShipbobOrderInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutShipbobOrderInput>>;
};

export type UserProductOrderLineUpdateManyWithoutShipmentNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutShipmentInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutShipmentInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyShipmentInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutShipmentInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutShipmentInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutShipmentInput>>;
};

export type UserProductOrderLineUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserProductOrderLineUpdateManyWithoutWarehouseNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderLineCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<UserProductOrderLineCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<UserProductOrderLineCreateManyWarehouseInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderLineUpdateWithWhereUniqueWithoutWarehouseInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderLineUpdateManyWithWhereWithoutWarehouseInput>>;
  upsert?: InputMaybe<Array<UserProductOrderLineUpsertWithWhereUniqueWithoutWarehouseInput>>;
};

export type UserProductOrderLineUpdateOneRequiredWithoutPreparationHistoryNestedInput = {
  connect?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineCreateOrConnectWithoutPreparationHistoryInput>;
  create?: InputMaybe<UserProductOrderLineCreateWithoutPreparationHistoryInput>;
  update?: InputMaybe<UserProductOrderLineUpdateToOneWithWhereWithoutPreparationHistoryInput>;
  upsert?: InputMaybe<UserProductOrderLineUpsertWithoutPreparationHistoryInput>;
};

export type UserProductOrderLineUpdateOneRequiredWithoutPrintBatchesNestedInput = {
  connect?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineCreateOrConnectWithoutPrintBatchesInput>;
  create?: InputMaybe<UserProductOrderLineCreateWithoutPrintBatchesInput>;
  update?: InputMaybe<UserProductOrderLineUpdateToOneWithWhereWithoutPrintBatchesInput>;
  upsert?: InputMaybe<UserProductOrderLineUpsertWithoutPrintBatchesInput>;
};

export type UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput = {
  connect?: InputMaybe<UserProductOrderLineWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderLineCreateOrConnectWithoutReplacementLinesInput>;
  create?: InputMaybe<UserProductOrderLineCreateWithoutReplacementLinesInput>;
  delete?: InputMaybe<UserProductOrderLineWhereInput>;
  disconnect?: InputMaybe<UserProductOrderLineWhereInput>;
  update?: InputMaybe<UserProductOrderLineUpdateToOneWithWhereWithoutReplacementLinesInput>;
  upsert?: InputMaybe<UserProductOrderLineUpsertWithoutReplacementLinesInput>;
};

export type UserProductOrderLineUpdateToOneWithWhereWithoutPreparationHistoryInput = {
  data: UserProductOrderLineUpdateWithoutPreparationHistoryInput;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductOrderLineUpdateToOneWithWhereWithoutPrintBatchesInput = {
  data: UserProductOrderLineUpdateWithoutPrintBatchesInput;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductOrderLineUpdateToOneWithWhereWithoutReplacementLinesInput = {
  data: UserProductOrderLineUpdateWithoutReplacementLinesInput;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutEverlabOrderInput = {
  data: UserProductOrderLineUpdateWithoutEverlabOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutJetpackApiOrderInput = {
  data: UserProductOrderLineUpdateWithoutJetpackApiOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutOrderInput = {
  data: UserProductOrderLineUpdateWithoutOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutOriginalLineInput = {
  data: UserProductOrderLineUpdateWithoutOriginalLineInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutPreparedByInput = {
  data: UserProductOrderLineUpdateWithoutPreparedByInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutRefundedByInput = {
  data: UserProductOrderLineUpdateWithoutRefundedByInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutReshipmentInput = {
  data: UserProductOrderLineUpdateWithoutReshipmentInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutRoastifyOrderInput = {
  data: UserProductOrderLineUpdateWithoutRoastifyOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutShipbobOrderInput = {
  data: UserProductOrderLineUpdateWithoutShipbobOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutShipmentInput = {
  data: UserProductOrderLineUpdateWithoutShipmentInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutUserInput = {
  data: UserProductOrderLineUpdateWithoutUserInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithWhereUniqueWithoutWarehouseInput = {
  data: UserProductOrderLineUpdateWithoutWarehouseInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpdateWithoutEverlabOrderInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutJetpackApiOrderInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutOrderInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutOriginalLineInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutPreparationHistoryInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutPreparedByInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutPrintBatchesInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutRefundedByInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutReplacementLinesInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutReshipmentInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutRoastifyOrderInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutShipbobOrderInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutShipmentInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutUserInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneWithoutLinesNestedInput>;
};

export type UserProductOrderLineUpdateWithoutWarehouseInput = {
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderLineDetailsUpdateOneWithoutLineNestedInput>;
  everlabOrder?: InputMaybe<EverlabOrderUpdateOneWithoutOrderLinesNestedInput>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeUpdateManyWithoutLineNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderUpdateOneWithoutOrderLinesNestedInput>;
  label?: InputMaybe<UserProductLabelUpdateOneWithoutOrderLinesNestedInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutLinesNestedInput>;
  originalLine?: InputMaybe<UserProductOrderLineUpdateOneWithoutReplacementLinesNestedInput>;
  originalPriceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  prePaidPriceApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryUpdateManyWithoutLineNestedInput>;
  preparedBy?: InputMaybe<AdminUpdateOneWithoutPreparedLineItemsNestedInput>;
  priceSold?: InputMaybe<FloatFieldUpdateOperationsInput>;
  printBatches?: InputMaybe<PrintBatchOrderLineUpdateManyWithoutLineNestedInput>;
  refundedBy?: InputMaybe<AdminUpdateOneWithoutRefundedLineItemsNestedInput>;
  replacementLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOriginalLineNestedInput>;
  reshipment?: InputMaybe<ShipmentUpdateOneWithoutReshippedOrderLinesNestedInput>;
  roastifyOrder?: InputMaybe<RoastifyOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipbobOrder?: InputMaybe<ShipbobOrderUpdateOneWithoutOrderLinesNestedInput>;
  shipheroInternalLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroLineItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutUserProductOrderLinesNestedInput>;
  subLine?: InputMaybe<UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsUpdateOneWithoutUserProductOrderLineNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderLinesNestedInput>;
  userProduct?: InputMaybe<UserProductUpdateOneRequiredWithoutOrderLinesNestedInput>;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutEverlabOrderInput = {
  create: UserProductOrderLineCreateWithoutEverlabOrderInput;
  update: UserProductOrderLineUpdateWithoutEverlabOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutJetpackApiOrderInput = {
  create: UserProductOrderLineCreateWithoutJetpackApiOrderInput;
  update: UserProductOrderLineUpdateWithoutJetpackApiOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutOrderInput = {
  create: UserProductOrderLineCreateWithoutOrderInput;
  update: UserProductOrderLineUpdateWithoutOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutOriginalLineInput = {
  create: UserProductOrderLineCreateWithoutOriginalLineInput;
  update: UserProductOrderLineUpdateWithoutOriginalLineInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutPreparedByInput = {
  create: UserProductOrderLineCreateWithoutPreparedByInput;
  update: UserProductOrderLineUpdateWithoutPreparedByInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutRefundedByInput = {
  create: UserProductOrderLineCreateWithoutRefundedByInput;
  update: UserProductOrderLineUpdateWithoutRefundedByInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutReshipmentInput = {
  create: UserProductOrderLineCreateWithoutReshipmentInput;
  update: UserProductOrderLineUpdateWithoutReshipmentInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutRoastifyOrderInput = {
  create: UserProductOrderLineCreateWithoutRoastifyOrderInput;
  update: UserProductOrderLineUpdateWithoutRoastifyOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutShipbobOrderInput = {
  create: UserProductOrderLineCreateWithoutShipbobOrderInput;
  update: UserProductOrderLineUpdateWithoutShipbobOrderInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutShipmentInput = {
  create: UserProductOrderLineCreateWithoutShipmentInput;
  update: UserProductOrderLineUpdateWithoutShipmentInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutUserInput = {
  create: UserProductOrderLineCreateWithoutUserInput;
  update: UserProductOrderLineUpdateWithoutUserInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithWhereUniqueWithoutWarehouseInput = {
  create: UserProductOrderLineCreateWithoutWarehouseInput;
  update: UserProductOrderLineUpdateWithoutWarehouseInput;
  where: UserProductOrderLineWhereUniqueInput;
};

export type UserProductOrderLineUpsertWithoutPreparationHistoryInput = {
  create: UserProductOrderLineCreateWithoutPreparationHistoryInput;
  update: UserProductOrderLineUpdateWithoutPreparationHistoryInput;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductOrderLineUpsertWithoutPrintBatchesInput = {
  create: UserProductOrderLineCreateWithoutPrintBatchesInput;
  update: UserProductOrderLineUpdateWithoutPrintBatchesInput;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductOrderLineUpsertWithoutReplacementLinesInput = {
  create: UserProductOrderLineCreateWithoutReplacementLinesInput;
  update: UserProductOrderLineUpdateWithoutReplacementLinesInput;
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};

export type UserProductOrderLineWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderLineWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineWhereInput>>;
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsNullableRelationFilter>;
  clickfunnelsLineDetailsId?: InputMaybe<UuidNullableFilter>;
  count?: InputMaybe<IntFilter>;
  details?: InputMaybe<UserProductOrderLineDetailsNullableRelationFilter>;
  detailsId?: InputMaybe<UuidNullableFilter>;
  everlabOrder?: InputMaybe<EverlabOrderNullableRelationFilter>;
  everlabOrderId?: InputMaybe<UuidNullableFilter>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  isReplacement?: InputMaybe<BoolFilter>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderNullableRelationFilter>;
  jetpackApiOrderId?: InputMaybe<UuidNullableFilter>;
  label?: InputMaybe<UserProductLabelNullableRelationFilter>;
  labelId?: InputMaybe<UuidNullableFilter>;
  order?: InputMaybe<UserProductOrderRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  originalLine?: InputMaybe<UserProductOrderLineNullableRelationFilter>;
  originalLineId?: InputMaybe<UuidNullableFilter>;
  originalPriceSold?: InputMaybe<FloatFilter>;
  prePaidPriceApplied?: InputMaybe<BoolFilter>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryListRelationFilter>;
  preparedBy?: InputMaybe<AdminNullableRelationFilter>;
  preparedById?: InputMaybe<UuidNullableFilter>;
  priceSold?: InputMaybe<FloatFilter>;
  printBatches?: InputMaybe<PrintBatchOrderLineListRelationFilter>;
  refundedBy?: InputMaybe<AdminNullableRelationFilter>;
  refundedById?: InputMaybe<UuidNullableFilter>;
  replacementLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  reshipment?: InputMaybe<ShipmentNullableRelationFilter>;
  reshipmentId?: InputMaybe<StringNullableFilter>;
  roastifyOrder?: InputMaybe<RoastifyOrderNullableRelationFilter>;
  roastifyOrderId?: InputMaybe<UuidNullableFilter>;
  shipbobOrder?: InputMaybe<ShipbobOrderNullableRelationFilter>;
  shipbobOrderId?: InputMaybe<UuidNullableFilter>;
  shipheroInternalLineItemId?: InputMaybe<StringNullableFilter>;
  shipheroLineItemId?: InputMaybe<StringNullableFilter>;
  shipment?: InputMaybe<ShipmentNullableRelationFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  subLine?: InputMaybe<UserProductOrderSubLineItemNullableRelationFilter>;
  subLineId?: InputMaybe<UuidNullableFilter>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsNullableRelationFilter>;
  tiktokLineDetailsId?: InputMaybe<UuidNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProduct?: InputMaybe<UserProductRelationFilter>;
  userProductId?: InputMaybe<UuidFilter>;
  warehouse?: InputMaybe<WarehouseNullableRelationFilter>;
  warehouseId?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderLineWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderLineWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderLineWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderLineWhereInput>>;
  clickfunnelsLineDetails?: InputMaybe<UserProductOrderLineClickFunnelsDetailsNullableRelationFilter>;
  clickfunnelsLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<IntFilter>;
  details?: InputMaybe<UserProductOrderLineDetailsNullableRelationFilter>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrder?: InputMaybe<EverlabOrderNullableRelationFilter>;
  everlabOrderId?: InputMaybe<UuidNullableFilter>;
  fulfillmentFees?: InputMaybe<UserProductOrderLineFulfillmentFeeListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isReplacement?: InputMaybe<BoolFilter>;
  jetpackApiOrder?: InputMaybe<JetpackApiOrderNullableRelationFilter>;
  jetpackApiOrderId?: InputMaybe<UuidNullableFilter>;
  label?: InputMaybe<UserProductLabelNullableRelationFilter>;
  labelId?: InputMaybe<UuidNullableFilter>;
  order?: InputMaybe<UserProductOrderRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  originalLine?: InputMaybe<UserProductOrderLineNullableRelationFilter>;
  originalLineId?: InputMaybe<UuidNullableFilter>;
  originalPriceSold?: InputMaybe<FloatFilter>;
  prePaidPriceApplied?: InputMaybe<BoolFilter>;
  preparationHistory?: InputMaybe<UserProductOrderLinePreparationHistoryListRelationFilter>;
  preparedBy?: InputMaybe<AdminNullableRelationFilter>;
  preparedById?: InputMaybe<UuidNullableFilter>;
  priceSold?: InputMaybe<FloatFilter>;
  printBatches?: InputMaybe<PrintBatchOrderLineListRelationFilter>;
  refundedBy?: InputMaybe<AdminNullableRelationFilter>;
  refundedById?: InputMaybe<UuidNullableFilter>;
  replacementLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  reshipment?: InputMaybe<ShipmentNullableRelationFilter>;
  reshipmentId?: InputMaybe<StringNullableFilter>;
  roastifyOrder?: InputMaybe<RoastifyOrderNullableRelationFilter>;
  roastifyOrderId?: InputMaybe<UuidNullableFilter>;
  shipbobOrder?: InputMaybe<ShipbobOrderNullableRelationFilter>;
  shipbobOrderId?: InputMaybe<UuidNullableFilter>;
  shipheroInternalLineItemId?: InputMaybe<StringNullableFilter>;
  shipheroLineItemId?: InputMaybe<Scalars['String']['input']>;
  shipment?: InputMaybe<ShipmentNullableRelationFilter>;
  shipmentId?: InputMaybe<StringNullableFilter>;
  subLine?: InputMaybe<UserProductOrderSubLineItemNullableRelationFilter>;
  subLineId?: InputMaybe<Scalars['String']['input']>;
  tiktokLineDetails?: InputMaybe<UserProductOrderLineTiktokDetailsNullableRelationFilter>;
  tiktokLineDetailsId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProduct?: InputMaybe<UserProductRelationFilter>;
  userProductId?: InputMaybe<UuidFilter>;
  warehouse?: InputMaybe<WarehouseNullableRelationFilter>;
  warehouseId?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderListRelationFilter = {
  every?: InputMaybe<UserProductOrderWhereInput>;
  none?: InputMaybe<UserProductOrderWhereInput>;
  some?: InputMaybe<UserProductOrderWhereInput>;
};

export enum UserProductOrderManualPaymentKind {
  PostPayment = 'POST_PAYMENT',
  PrePayment = 'PRE_PAYMENT'
}

export enum UserProductOrderManualPaymentStatus {
  AwaitingPayment = 'AWAITING_PAYMENT',
  Canceled = 'CANCELED',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID'
}

export type UserProductOrderModel = {
  __typename?: 'UserProductOrderModel';
  _count?: Maybe<UserProductOrderCount>;
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  allProductLabelsVerified: Scalars['Boolean']['output'];
  billingAddress?: Maybe<UserProductOrderAddressModel>;
  billingAddressId?: Maybe<Scalars['String']['output']>;
  bulkDetails?: Maybe<UserProductOrderBulkDetails>;
  bulkDetailsId?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  chargeDiscount: Scalars['Float']['output'];
  chargeFulfillmentFee?: Maybe<Scalars['Float']['output']>;
  chargeProcessingFee?: Maybe<Scalars['Float']['output']>;
  chargeShipping?: Maybe<Scalars['Float']['output']>;
  chargeSubtotal?: Maybe<Scalars['Float']['output']>;
  clickfunnelsDetails?: Maybe<UserProductOrderClickFunnelsDetails>;
  clickfunnelsDetailsId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creditsPayments: Array<UserCreditsTransaction>;
  creditsRefund: Array<UserCreditsTransaction>;
  currency: Scalars['String']['output'];
  currencyConversionRate: Scalars['Float']['output'];
  customOnHoldReasons: Array<CustomOnHoldReason>;
  details?: Maybe<UserProductOrderDetails>;
  detailsId?: Maybe<Scalars['String']['output']>;
  everlabOrders: Array<EverlabOrder>;
  fbaDetails?: Maybe<UserProductOrderFbaDetails>;
  fbaDetailsId?: Maybe<Scalars['String']['output']>;
  fulfillmentDeadline?: Maybe<Scalars['DateTime']['output']>;
  holdReasonIntervals: Array<UserProductOrderOnHoldReasonInterval>;
  holdStatusIntervals: Array<UserProductOrderHoldStatusInterval>;
  id: Scalars['String']['output'];
  invoiceMode: InvoiceMode;
  invoices: Array<UserInvoice>;
  isPriorityLaneFulfillment: Scalars['Boolean']['output'];
  isReplacement: Scalars['Boolean']['output'];
  itemCountByWarehouse: Array<UserProductOrderItemCountByWarehouse>;
  itemCountTotal: Scalars['Int']['output'];
  jetpackApiOrders: Array<JetpackApiOrder>;
  kind: UserProductOrderKind;
  legacyOrderId?: Maybe<Scalars['String']['output']>;
  lineItemsCount?: Maybe<Scalars['Int']['output']>;
  lines: Array<UserProductOrderLineModel>;
  lockedBy?: Maybe<Admin>;
  lockedById?: Maybe<Scalars['String']['output']>;
  onHold: Scalars['Boolean']['output'];
  onHoldReasons: Array<OnHoldReason>;
  onboardingSampleSession?: Maybe<OnboardingSampleOrderSession>;
  onboardingSampleSessionId?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  originalCurrency: Scalars['String']['output'];
  originalOrder?: Maybe<UserProductOrder>;
  originalOrderId?: Maybe<Scalars['String']['output']>;
  paid: Scalars['Boolean']['output'];
  /** This field to eventually replace details.charged. Currently optional and write-only */
  paymentStatus?: Maybe<UserProductOrderPaymentStatus>;
  postPaymentBucket?: Maybe<PostPaymentOrdersBucket>;
  postPaymentBucketId?: Maybe<Scalars['String']['output']>;
  productDiscount: Scalars['Float']['output'];
  replacementOrders: Array<UserProductOrder>;
  roastifyOrders: Array<RoastifyOrder>;
  sampleDiscountApplied: Scalars['Boolean']['output'];
  sampleExpressShippingApplied: Scalars['Boolean']['output'];
  sent: Scalars['Boolean']['output'];
  shipbobOrders: Array<ShipbobOrder>;
  shipheroOrderId?: Maybe<Scalars['String']['output']>;
  shipments?: Maybe<Array<Shipment>>;
  shippingAddress?: Maybe<UserProductOrderAddressModel>;
  shippingAddressId?: Maybe<Scalars['String']['output']>;
  shopifyDetails?: Maybe<UserProductOrderShopifyDetails>;
  shopifyDetailsId?: Maybe<Scalars['String']['output']>;
  status: UserProductOrderStatus;
  store?: Maybe<UserStore>;
  storeId?: Maybe<Scalars['String']['output']>;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripeInvoices: Array<StripeInvoice>;
  stripePaymentId?: Maybe<Scalars['String']['output']>;
  tiktokDetails?: Maybe<UserProductOrderTiktokDetails>;
  tiktokDetailsId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
  warehouseShelfBin?: Maybe<WarehouseShelfBin>;
  warehouseShelfBins: Array<WarehouseShelfBin>;
  warehouseShelfReturnBin?: Maybe<WarehouseShelfReturnBin>;
  warehouseShelfReturnBinId?: Maybe<Scalars['String']['output']>;
};


export type UserProductOrderModelBulkDetailsArgs = {
  where?: InputMaybe<UserProductOrderBulkDetailsWhereInput>;
};


export type UserProductOrderModelClickfunnelsDetailsArgs = {
  where?: InputMaybe<UserProductOrderClickFunnelsDetailsWhereInput>;
};


export type UserProductOrderModelCreditsPaymentsArgs = {
  cursor?: InputMaybe<UserCreditsTransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserCreditsTransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserCreditsTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserCreditsTransactionWhereInput>;
};


export type UserProductOrderModelCreditsRefundArgs = {
  cursor?: InputMaybe<UserCreditsTransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserCreditsTransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserCreditsTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserCreditsTransactionWhereInput>;
};


export type UserProductOrderModelCustomOnHoldReasonsArgs = {
  cursor?: InputMaybe<CustomOnHoldReasonWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomOnHoldReasonScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomOnHoldReasonOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomOnHoldReasonWhereInput>;
};


export type UserProductOrderModelDetailsArgs = {
  where?: InputMaybe<UserProductOrderDetailsWhereInput>;
};


export type UserProductOrderModelEverlabOrdersArgs = {
  cursor?: InputMaybe<EverlabOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<EverlabOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EverlabOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EverlabOrderWhereInput>;
};


export type UserProductOrderModelFbaDetailsArgs = {
  where?: InputMaybe<UserProductOrderFbaDetailsWhereInput>;
};


export type UserProductOrderModelHoldReasonIntervalsArgs = {
  cursor?: InputMaybe<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderOnHoldReasonIntervalWhereInput>;
};


export type UserProductOrderModelHoldStatusIntervalsArgs = {
  cursor?: InputMaybe<UserProductOrderHoldStatusIntervalWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderHoldStatusIntervalScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderHoldStatusIntervalOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderHoldStatusIntervalWhereInput>;
};


export type UserProductOrderModelInvoicesArgs = {
  cursor?: InputMaybe<UserInvoiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserInvoiceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserInvoiceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserInvoiceWhereInput>;
};


export type UserProductOrderModelItemCountByWarehouseArgs = {
  cursor?: InputMaybe<UserProductOrderItemCountByWarehouseWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderItemCountByWarehouseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderItemCountByWarehouseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderItemCountByWarehouseWhereInput>;
};


export type UserProductOrderModelJetpackApiOrdersArgs = {
  cursor?: InputMaybe<JetpackApiOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<JetpackApiOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<JetpackApiOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<JetpackApiOrderWhereInput>;
};


export type UserProductOrderModelLockedByArgs = {
  where?: InputMaybe<AdminWhereInput>;
};


export type UserProductOrderModelOnboardingSampleSessionArgs = {
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};


export type UserProductOrderModelOriginalOrderArgs = {
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type UserProductOrderModelPostPaymentBucketArgs = {
  where?: InputMaybe<PostPaymentOrdersBucketWhereInput>;
};


export type UserProductOrderModelReplacementOrdersArgs = {
  cursor?: InputMaybe<UserProductOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type UserProductOrderModelRoastifyOrdersArgs = {
  cursor?: InputMaybe<RoastifyOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<RoastifyOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoastifyOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoastifyOrderWhereInput>;
};


export type UserProductOrderModelShipbobOrdersArgs = {
  cursor?: InputMaybe<ShipbobOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShipbobOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShipbobOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ShipbobOrderWhereInput>;
};


export type UserProductOrderModelShopifyDetailsArgs = {
  where?: InputMaybe<UserProductOrderShopifyDetailsWhereInput>;
};


export type UserProductOrderModelStripeInvoicesArgs = {
  cursor?: InputMaybe<StripeInvoiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<StripeInvoiceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StripeInvoiceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StripeInvoiceWhereInput>;
};


export type UserProductOrderModelTiktokDetailsArgs = {
  where?: InputMaybe<UserProductOrderTiktokDetailsWhereInput>;
};

export type UserProductOrderNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderWhereInput>;
  isNot?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderOnHoldReasonInterval = {
  __typename?: 'UserProductOrderOnHoldReasonInterval';
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  reason: OnHoldReason;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedById?: Maybe<Scalars['String']['output']>;
};

export type UserProductOrderOnHoldReasonIntervalCreateManyCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  reason: OnHoldReason;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedById?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderOnHoldReasonIntervalCreateManyCreatedByInputEnvelope = {
  data: Array<UserProductOrderOnHoldReasonIntervalCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderOnHoldReasonIntervalCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  reason: OnHoldReason;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedById?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderOnHoldReasonIntervalCreateManyOrderInputEnvelope = {
  data: Array<UserProductOrderOnHoldReasonIntervalCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderOnHoldReasonIntervalCreateManyResolvedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  reason: OnHoldReason;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProductOrderOnHoldReasonIntervalCreateManyResolvedByInputEnvelope = {
  data: Array<UserProductOrderOnHoldReasonIntervalCreateManyResolvedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateManyCreatedByInputEnvelope>;
};

export type UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateWithoutOrderInput>>;
  createMany?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateManyOrderInputEnvelope>;
};

export type UserProductOrderOnHoldReasonIntervalCreateNestedManyWithoutResolvedByInput = {
  connect?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateOrConnectWithoutResolvedByInput>>;
  create?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateWithoutResolvedByInput>>;
  createMany?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateManyResolvedByInputEnvelope>;
};

export type UserProductOrderOnHoldReasonIntervalCreateOrConnectWithoutCreatedByInput = {
  create: UserProductOrderOnHoldReasonIntervalCreateWithoutCreatedByInput;
  where: UserProductOrderOnHoldReasonIntervalWhereUniqueInput;
};

export type UserProductOrderOnHoldReasonIntervalCreateOrConnectWithoutOrderInput = {
  create: UserProductOrderOnHoldReasonIntervalCreateWithoutOrderInput;
  where: UserProductOrderOnHoldReasonIntervalWhereUniqueInput;
};

export type UserProductOrderOnHoldReasonIntervalCreateOrConnectWithoutResolvedByInput = {
  create: UserProductOrderOnHoldReasonIntervalCreateWithoutResolvedByInput;
  where: UserProductOrderOnHoldReasonIntervalWhereUniqueInput;
};

export type UserProductOrderOnHoldReasonIntervalCreateWithoutCreatedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: UserProductOrderCreateNestedOneWithoutHoldReasonIntervalsInput;
  reason: OnHoldReason;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<AdminCreateNestedOneWithoutOnHoldReasonIntervalResolvedInput>;
};

export type UserProductOrderOnHoldReasonIntervalCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<AdminCreateNestedOneWithoutOnHoldReasonIntervalCreatedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  reason: OnHoldReason;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedBy?: InputMaybe<AdminCreateNestedOneWithoutOnHoldReasonIntervalResolvedInput>;
};

export type UserProductOrderOnHoldReasonIntervalCreateWithoutResolvedByInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<AdminCreateNestedOneWithoutOnHoldReasonIntervalCreatedInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: UserProductOrderCreateNestedOneWithoutHoldReasonIntervalsInput;
  reason: OnHoldReason;
  resolvedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserProductOrderOnHoldReasonIntervalListRelationFilter = {
  every?: InputMaybe<UserProductOrderOnHoldReasonIntervalWhereInput>;
  none?: InputMaybe<UserProductOrderOnHoldReasonIntervalWhereInput>;
  some?: InputMaybe<UserProductOrderOnHoldReasonIntervalWhereInput>;
};

export type UserProductOrderOnHoldReasonIntervalOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserProductOrderOnHoldReasonIntervalOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<AdminOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
  resolvedAt?: InputMaybe<SortOrderInput>;
  resolvedBy?: InputMaybe<AdminOrderByWithRelationInput>;
  resolvedById?: InputMaybe<SortOrderInput>;
};

export enum UserProductOrderOnHoldReasonIntervalScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  Id = 'id',
  OrderId = 'orderId',
  Reason = 'reason',
  ResolvedAt = 'resolvedAt',
  ResolvedById = 'resolvedById'
}

export type UserProductOrderOnHoldReasonIntervalScalarWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  orderId?: InputMaybe<UuidFilter>;
  reason?: InputMaybe<EnumOnHoldReasonFilter>;
  resolvedAt?: InputMaybe<DateTimeNullableFilter>;
  resolvedById?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderOnHoldReasonIntervalUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<EnumOnHoldReasonFieldUpdateOperationsInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserProductOrderOnHoldReasonIntervalUpdateManyWithWhereWithoutCreatedByInput = {
  data: UserProductOrderOnHoldReasonIntervalUpdateManyMutationInput;
  where: UserProductOrderOnHoldReasonIntervalScalarWhereInput;
};

export type UserProductOrderOnHoldReasonIntervalUpdateManyWithWhereWithoutOrderInput = {
  data: UserProductOrderOnHoldReasonIntervalUpdateManyMutationInput;
  where: UserProductOrderOnHoldReasonIntervalScalarWhereInput;
};

export type UserProductOrderOnHoldReasonIntervalUpdateManyWithWhereWithoutResolvedByInput = {
  data: UserProductOrderOnHoldReasonIntervalUpdateManyMutationInput;
  where: UserProductOrderOnHoldReasonIntervalScalarWhereInput;
};

export type UserProductOrderOnHoldReasonIntervalUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateWithoutOrderInput>>;
  createMany?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type UserProductOrderOnHoldReasonIntervalUpdateManyWithoutResolvedByNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateOrConnectWithoutResolvedByInput>>;
  create?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalCreateWithoutResolvedByInput>>;
  createMany?: InputMaybe<UserProductOrderOnHoldReasonIntervalCreateManyResolvedByInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalUpdateWithWhereUniqueWithoutResolvedByInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalUpdateManyWithWhereWithoutResolvedByInput>>;
  upsert?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalUpsertWithWhereUniqueWithoutResolvedByInput>>;
};

export type UserProductOrderOnHoldReasonIntervalUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: UserProductOrderOnHoldReasonIntervalUpdateWithoutCreatedByInput;
  where: UserProductOrderOnHoldReasonIntervalWhereUniqueInput;
};

export type UserProductOrderOnHoldReasonIntervalUpdateWithWhereUniqueWithoutOrderInput = {
  data: UserProductOrderOnHoldReasonIntervalUpdateWithoutOrderInput;
  where: UserProductOrderOnHoldReasonIntervalWhereUniqueInput;
};

export type UserProductOrderOnHoldReasonIntervalUpdateWithWhereUniqueWithoutResolvedByInput = {
  data: UserProductOrderOnHoldReasonIntervalUpdateWithoutResolvedByInput;
  where: UserProductOrderOnHoldReasonIntervalWhereUniqueInput;
};

export type UserProductOrderOnHoldReasonIntervalUpdateWithoutCreatedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutHoldReasonIntervalsNestedInput>;
  reason?: InputMaybe<EnumOnHoldReasonFieldUpdateOperationsInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  resolvedBy?: InputMaybe<AdminUpdateOneWithoutOnHoldReasonIntervalResolvedNestedInput>;
};

export type UserProductOrderOnHoldReasonIntervalUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneWithoutOnHoldReasonIntervalCreatedNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<EnumOnHoldReasonFieldUpdateOperationsInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  resolvedBy?: InputMaybe<AdminUpdateOneWithoutOnHoldReasonIntervalResolvedNestedInput>;
};

export type UserProductOrderOnHoldReasonIntervalUpdateWithoutResolvedByInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<AdminUpdateOneWithoutOnHoldReasonIntervalCreatedNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<UserProductOrderUpdateOneRequiredWithoutHoldReasonIntervalsNestedInput>;
  reason?: InputMaybe<EnumOnHoldReasonFieldUpdateOperationsInput>;
  resolvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UserProductOrderOnHoldReasonIntervalUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: UserProductOrderOnHoldReasonIntervalCreateWithoutCreatedByInput;
  update: UserProductOrderOnHoldReasonIntervalUpdateWithoutCreatedByInput;
  where: UserProductOrderOnHoldReasonIntervalWhereUniqueInput;
};

export type UserProductOrderOnHoldReasonIntervalUpsertWithWhereUniqueWithoutOrderInput = {
  create: UserProductOrderOnHoldReasonIntervalCreateWithoutOrderInput;
  update: UserProductOrderOnHoldReasonIntervalUpdateWithoutOrderInput;
  where: UserProductOrderOnHoldReasonIntervalWhereUniqueInput;
};

export type UserProductOrderOnHoldReasonIntervalUpsertWithWhereUniqueWithoutResolvedByInput = {
  create: UserProductOrderOnHoldReasonIntervalCreateWithoutResolvedByInput;
  update: UserProductOrderOnHoldReasonIntervalUpdateWithoutResolvedByInput;
  where: UserProductOrderOnHoldReasonIntervalWhereUniqueInput;
};

export type UserProductOrderOnHoldReasonIntervalWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminNullableRelationFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<UserProductOrderRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  reason?: InputMaybe<EnumOnHoldReasonFilter>;
  resolvedAt?: InputMaybe<DateTimeNullableFilter>;
  resolvedBy?: InputMaybe<AdminNullableRelationFilter>;
  resolvedById?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderOnHoldReasonIntervalWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderOnHoldReasonIntervalWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<AdminNullableRelationFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<UserProductOrderRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  reason?: InputMaybe<EnumOnHoldReasonFilter>;
  resolvedAt?: InputMaybe<DateTimeNullableFilter>;
  resolvedBy?: InputMaybe<AdminNullableRelationFilter>;
  resolvedById?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserProductOrderOrderByWithRelationInput = {
  acceptedAt?: InputMaybe<SortOrderInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressOrderByWithRelationInput>;
  billingAddressId?: InputMaybe<SortOrderInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsOrderByWithRelationInput>;
  bulkDetailsId?: InputMaybe<SortOrderInput>;
  cancelledAt?: InputMaybe<SortOrderInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsOrderByWithRelationInput>;
  clickfunnelsDetailsId?: InputMaybe<SortOrderInput>;
  completedAt?: InputMaybe<SortOrderInput>;
  countryCode?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  creditsPayments?: InputMaybe<UserCreditsTransactionOrderByRelationAggregateInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionOrderByRelationAggregateInput>;
  currency?: InputMaybe<SortOrder>;
  currencyConversionRate?: InputMaybe<SortOrder>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonOrderByRelationAggregateInput>;
  details?: InputMaybe<UserProductOrderDetailsOrderByWithRelationInput>;
  detailsId?: InputMaybe<SortOrderInput>;
  everlabOrders?: InputMaybe<EverlabOrderOrderByRelationAggregateInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsOrderByWithRelationInput>;
  fbaDetailsId?: InputMaybe<SortOrderInput>;
  fulfillmentDeadline?: InputMaybe<SortOrderInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalOrderByRelationAggregateInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  invoiceMode?: InputMaybe<SortOrder>;
  invoices?: InputMaybe<UserInvoiceOrderByRelationAggregateInput>;
  isPriorityLaneFulfillment?: InputMaybe<SortOrder>;
  isReplacement?: InputMaybe<SortOrder>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseOrderByRelationAggregateInput>;
  itemCountTotal?: InputMaybe<SortOrder>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderOrderByRelationAggregateInput>;
  kind?: InputMaybe<SortOrder>;
  legacyOrderId?: InputMaybe<SortOrderInput>;
  lineItemsCount?: InputMaybe<SortOrderInput>;
  lines?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  lockedBy?: InputMaybe<AdminOrderByWithRelationInput>;
  lockedById?: InputMaybe<SortOrderInput>;
  onHold?: InputMaybe<SortOrder>;
  onHoldReasons?: InputMaybe<SortOrder>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionOrderByWithRelationInput>;
  onboardingSampleSessionId?: InputMaybe<SortOrderInput>;
  orderId?: InputMaybe<SortOrder>;
  originalCurrency?: InputMaybe<SortOrder>;
  originalOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  originalOrderId?: InputMaybe<SortOrderInput>;
  paymentStatus?: InputMaybe<SortOrderInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketOrderByWithRelationInput>;
  postPaymentBucketId?: InputMaybe<SortOrderInput>;
  replacementOrders?: InputMaybe<UserProductOrderOrderByRelationAggregateInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderOrderByRelationAggregateInput>;
  sampleDiscountApplied?: InputMaybe<SortOrder>;
  sampleExpressShippingApplied?: InputMaybe<SortOrder>;
  sent?: InputMaybe<SortOrder>;
  shipbobOrders?: InputMaybe<ShipbobOrderOrderByRelationAggregateInput>;
  shipheroOrderId?: InputMaybe<SortOrderInput>;
  shipments?: InputMaybe<ShipmentOrderByRelationAggregateInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressOrderByWithRelationInput>;
  shippingAddressId?: InputMaybe<SortOrderInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsOrderByWithRelationInput>;
  shopifyDetailsId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  store?: InputMaybe<UserStoreOrderByWithRelationInput>;
  storeId?: InputMaybe<SortOrderInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceOrderByRelationAggregateInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsOrderByWithRelationInput>;
  tiktokDetailsId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinOrderByRelationAggregateInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinOrderByWithRelationInput>;
  warehouseShelfReturnBinId?: InputMaybe<SortOrderInput>;
};

/** To eventually replace details.charged. Currently optional and write-only. (currently! )Not used for BULK and FBA orders as these have their own payment statuses. */
export enum UserProductOrderPaymentStatus {
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type UserProductOrderRefundStatusResponse = {
  __typename?: 'UserProductOrderRefundStatusResponse';
  canCreditNoteBeIssued: Scalars['Boolean']['output'];
  isLegacyPaymentIntentRefundable: Scalars['Boolean']['output'];
  isRefundableWithCredits: Scalars['Boolean']['output'];
};

export type UserProductOrderRelationFilter = {
  is?: InputMaybe<UserProductOrderWhereInput>;
  isNot?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderResponse = {
  __typename?: 'UserProductOrderResponse';
  items: Array<UserProductOrderModel>;
  total: Scalars['Int']['output'];
};

export enum UserProductOrderScalarFieldEnum {
  AcceptedAt = 'acceptedAt',
  BillingAddressId = 'billingAddressId',
  BulkDetailsId = 'bulkDetailsId',
  CancelledAt = 'cancelledAt',
  ChargeDiscount = 'chargeDiscount',
  ChargeFulfillmentFee = 'chargeFulfillmentFee',
  ChargeProcessingFee = 'chargeProcessingFee',
  ChargeShipping = 'chargeShipping',
  ChargeSubtotal = 'chargeSubtotal',
  ClickfunnelsDetailsId = 'clickfunnelsDetailsId',
  CompletedAt = 'completedAt',
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  CurrencyConversionRate = 'currencyConversionRate',
  DetailsId = 'detailsId',
  FbaDetailsId = 'fbaDetailsId',
  FulfillmentDeadline = 'fulfillmentDeadline',
  Id = 'id',
  InvoiceMode = 'invoiceMode',
  IsPriorityLaneFulfillment = 'isPriorityLaneFulfillment',
  IsReplacement = 'isReplacement',
  ItemCountTotal = 'itemCountTotal',
  Kind = 'kind',
  LegacyOrderId = 'legacyOrderId',
  LineItemsCount = 'lineItemsCount',
  LockedById = 'lockedById',
  OnHold = 'onHold',
  OnHoldReasons = 'onHoldReasons',
  OnboardingSampleSessionId = 'onboardingSampleSessionId',
  OrderId = 'orderId',
  OriginalCurrency = 'originalCurrency',
  OriginalOrderId = 'originalOrderId',
  PaymentStatus = 'paymentStatus',
  PostPaymentBucketId = 'postPaymentBucketId',
  ProductDiscount = 'productDiscount',
  SampleDiscountApplied = 'sampleDiscountApplied',
  SampleExpressShippingApplied = 'sampleExpressShippingApplied',
  Sent = 'sent',
  ShipheroOrderId = 'shipheroOrderId',
  ShippingAddressId = 'shippingAddressId',
  ShopifyDetailsId = 'shopifyDetailsId',
  Status = 'status',
  StoreId = 'storeId',
  StripePaymentId = 'stripePaymentId',
  TiktokDetailsId = 'tiktokDetailsId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  WarehouseShelfReturnBinId = 'warehouseShelfReturnBinId',
  WoocommerceDetailsId = 'woocommerceDetailsId'
}

export type UserProductOrderScalarWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderScalarWhereInput>>;
  acceptedAt?: InputMaybe<DateTimeNullableFilter>;
  billingAddressId?: InputMaybe<UuidNullableFilter>;
  bulkDetailsId?: InputMaybe<UuidNullableFilter>;
  cancelledAt?: InputMaybe<DateTimeNullableFilter>;
  clickfunnelsDetailsId?: InputMaybe<UuidNullableFilter>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<StringFilter>;
  currencyConversionRate?: InputMaybe<FloatFilter>;
  detailsId?: InputMaybe<UuidNullableFilter>;
  fbaDetailsId?: InputMaybe<UuidNullableFilter>;
  fulfillmentDeadline?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFilter>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFilter>;
  isReplacement?: InputMaybe<BoolFilter>;
  itemCountTotal?: InputMaybe<IntFilter>;
  kind?: InputMaybe<EnumUserProductOrderKindFilter>;
  legacyOrderId?: InputMaybe<StringNullableFilter>;
  lineItemsCount?: InputMaybe<IntNullableFilter>;
  lockedById?: InputMaybe<UuidNullableFilter>;
  onHold?: InputMaybe<BoolFilter>;
  onHoldReasons?: InputMaybe<EnumOnHoldReasonNullableListFilter>;
  onboardingSampleSessionId?: InputMaybe<UuidNullableFilter>;
  orderId?: InputMaybe<IntFilter>;
  originalCurrency?: InputMaybe<StringFilter>;
  originalOrderId?: InputMaybe<UuidNullableFilter>;
  paymentStatus?: InputMaybe<EnumUserProductOrderPaymentStatusNullableFilter>;
  postPaymentBucketId?: InputMaybe<UuidNullableFilter>;
  sampleDiscountApplied?: InputMaybe<BoolFilter>;
  sampleExpressShippingApplied?: InputMaybe<BoolFilter>;
  sent?: InputMaybe<BoolFilter>;
  shipheroOrderId?: InputMaybe<StringNullableFilter>;
  shippingAddressId?: InputMaybe<UuidNullableFilter>;
  shopifyDetailsId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumUserProductOrderStatusFilter>;
  storeId?: InputMaybe<UuidNullableFilter>;
  tiktokDetailsId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
  warehouseShelfReturnBinId?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderShopifyDetails = {
  __typename?: 'UserProductOrderShopifyDetails';
  id: Scalars['String']['output'];
  shopifyId: Scalars['BigInt']['output'];
  shopifyOrderName: Scalars['String']['output'];
};

export type UserProductOrderShopifyDetailsCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<UserProductOrderShopifyDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderShopifyDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderShopifyDetailsCreateWithoutOrderInput>;
};

export type UserProductOrderShopifyDetailsCreateOrConnectWithoutOrderInput = {
  create: UserProductOrderShopifyDetailsCreateWithoutOrderInput;
  where: UserProductOrderShopifyDetailsWhereUniqueInput;
};

export type UserProductOrderShopifyDetailsCreateWithoutOrderInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  shopifyId: Scalars['BigInt']['input'];
  shopifyOrderName: Scalars['String']['input'];
};

export type UserProductOrderShopifyDetailsNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderShopifyDetailsWhereInput>;
  isNot?: InputMaybe<UserProductOrderShopifyDetailsWhereInput>;
};

export type UserProductOrderShopifyDetailsOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  shopifyId?: InputMaybe<SortOrder>;
  shopifyOrderName?: InputMaybe<SortOrder>;
};

export type UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<UserProductOrderShopifyDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderShopifyDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderShopifyDetailsCreateWithoutOrderInput>;
  delete?: InputMaybe<UserProductOrderShopifyDetailsWhereInput>;
  disconnect?: InputMaybe<UserProductOrderShopifyDetailsWhereInput>;
  update?: InputMaybe<UserProductOrderShopifyDetailsUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<UserProductOrderShopifyDetailsUpsertWithoutOrderInput>;
};

export type UserProductOrderShopifyDetailsUpdateToOneWithWhereWithoutOrderInput = {
  data: UserProductOrderShopifyDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderShopifyDetailsWhereInput>;
};

export type UserProductOrderShopifyDetailsUpdateWithoutOrderInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  shopifyOrderName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProductOrderShopifyDetailsUpsertWithoutOrderInput = {
  create: UserProductOrderShopifyDetailsCreateWithoutOrderInput;
  update: UserProductOrderShopifyDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderShopifyDetailsWhereInput>;
};

export type UserProductOrderShopifyDetailsWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderShopifyDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderShopifyDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderShopifyDetailsWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  shopifyId?: InputMaybe<BigIntFilter>;
  shopifyOrderName?: InputMaybe<StringFilter>;
};

export type UserProductOrderShopifyDetailsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderShopifyDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderShopifyDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderShopifyDetailsWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  shopifyId?: InputMaybe<BigIntFilter>;
  shopifyOrderName?: InputMaybe<StringFilter>;
};

export enum UserProductOrderStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Processing = 'PROCESSING',
  Returned = 'RETURNED'
}

export type UserProductOrderSubLineItem = {
  __typename?: 'UserProductOrderSubLineItem';
  count: Scalars['Int']['output'];
  file: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPrepared: Scalars['Boolean']['output'];
};

export type UserProductOrderSubLineItemCreateNestedOneWithoutLineInput = {
  connect?: InputMaybe<UserProductOrderSubLineItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderSubLineItemCreateOrConnectWithoutLineInput>;
  create?: InputMaybe<UserProductOrderSubLineItemCreateWithoutLineInput>;
};

export type UserProductOrderSubLineItemCreateOrConnectWithoutLineInput = {
  create: UserProductOrderSubLineItemCreateWithoutLineInput;
  where: UserProductOrderSubLineItemWhereUniqueInput;
};

export type UserProductOrderSubLineItemCreateWithoutLineInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  file: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isPrepared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProductOrderSubLineItemNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderSubLineItemWhereInput>;
  isNot?: InputMaybe<UserProductOrderSubLineItemWhereInput>;
};

export type UserProductOrderSubLineItemOrderByWithRelationInput = {
  count?: InputMaybe<SortOrder>;
  file?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPrepared?: InputMaybe<SortOrder>;
  line?: InputMaybe<UserProductOrderLineOrderByWithRelationInput>;
};

export type UserProductOrderSubLineItemUpdateOneWithoutLineNestedInput = {
  connect?: InputMaybe<UserProductOrderSubLineItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderSubLineItemCreateOrConnectWithoutLineInput>;
  create?: InputMaybe<UserProductOrderSubLineItemCreateWithoutLineInput>;
  delete?: InputMaybe<UserProductOrderSubLineItemWhereInput>;
  disconnect?: InputMaybe<UserProductOrderSubLineItemWhereInput>;
  update?: InputMaybe<UserProductOrderSubLineItemUpdateToOneWithWhereWithoutLineInput>;
  upsert?: InputMaybe<UserProductOrderSubLineItemUpsertWithoutLineInput>;
};

export type UserProductOrderSubLineItemUpdateToOneWithWhereWithoutLineInput = {
  data: UserProductOrderSubLineItemUpdateWithoutLineInput;
  where?: InputMaybe<UserProductOrderSubLineItemWhereInput>;
};

export type UserProductOrderSubLineItemUpdateWithoutLineInput = {
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  file?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPrepared?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type UserProductOrderSubLineItemUpsertWithoutLineInput = {
  create: UserProductOrderSubLineItemCreateWithoutLineInput;
  update: UserProductOrderSubLineItemUpdateWithoutLineInput;
  where?: InputMaybe<UserProductOrderSubLineItemWhereInput>;
};

export type UserProductOrderSubLineItemWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderSubLineItemWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderSubLineItemWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderSubLineItemWhereInput>>;
  count?: InputMaybe<IntFilter>;
  file?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isPrepared?: InputMaybe<BoolFilter>;
  line?: InputMaybe<UserProductOrderLineNullableRelationFilter>;
};

export type UserProductOrderSubLineItemWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderSubLineItemWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderSubLineItemWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderSubLineItemWhereInput>>;
  count?: InputMaybe<IntFilter>;
  file?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPrepared?: InputMaybe<BoolFilter>;
  line?: InputMaybe<UserProductOrderLineNullableRelationFilter>;
};

export type UserProductOrderTiktokDetails = {
  __typename?: 'UserProductOrderTiktokDetails';
  deliveryOptionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isTiktokShipping: Scalars['Boolean']['output'];
  rtsSlaTime?: Maybe<Scalars['DateTime']['output']>;
  tiktokOrderId: Scalars['String']['output'];
};

export type UserProductOrderTiktokDetailsCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<UserProductOrderTiktokDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderTiktokDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderTiktokDetailsCreateWithoutOrderInput>;
};

export type UserProductOrderTiktokDetailsCreateOrConnectWithoutOrderInput = {
  create: UserProductOrderTiktokDetailsCreateWithoutOrderInput;
  where: UserProductOrderTiktokDetailsWhereUniqueInput;
};

export type UserProductOrderTiktokDetailsCreateWithoutOrderInput = {
  deliveryOptionId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isTiktokShipping?: InputMaybe<Scalars['Boolean']['input']>;
  rtsSlaTime?: InputMaybe<Scalars['DateTime']['input']>;
  tiktokOrderId: Scalars['String']['input'];
};

export type UserProductOrderTiktokDetailsNullableRelationFilter = {
  is?: InputMaybe<UserProductOrderTiktokDetailsWhereInput>;
  isNot?: InputMaybe<UserProductOrderTiktokDetailsWhereInput>;
};

export type UserProductOrderTiktokDetailsOrderByWithRelationInput = {
  deliveryOptionId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isTiktokShipping?: InputMaybe<SortOrder>;
  order?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  rtsSlaTime?: InputMaybe<SortOrderInput>;
  tiktokOrderId?: InputMaybe<SortOrder>;
};

export type UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<UserProductOrderTiktokDetailsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderTiktokDetailsCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<UserProductOrderTiktokDetailsCreateWithoutOrderInput>;
  delete?: InputMaybe<UserProductOrderTiktokDetailsWhereInput>;
  disconnect?: InputMaybe<UserProductOrderTiktokDetailsWhereInput>;
  update?: InputMaybe<UserProductOrderTiktokDetailsUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<UserProductOrderTiktokDetailsUpsertWithoutOrderInput>;
};

export type UserProductOrderTiktokDetailsUpdateToOneWithWhereWithoutOrderInput = {
  data: UserProductOrderTiktokDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderTiktokDetailsWhereInput>;
};

export type UserProductOrderTiktokDetailsUpdateWithoutOrderInput = {
  deliveryOptionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isTiktokShipping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  rtsSlaTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tiktokOrderId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserProductOrderTiktokDetailsUpsertWithoutOrderInput = {
  create: UserProductOrderTiktokDetailsCreateWithoutOrderInput;
  update: UserProductOrderTiktokDetailsUpdateWithoutOrderInput;
  where?: InputMaybe<UserProductOrderTiktokDetailsWhereInput>;
};

export type UserProductOrderTiktokDetailsWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderTiktokDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderTiktokDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderTiktokDetailsWhereInput>>;
  deliveryOptionId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isTiktokShipping?: InputMaybe<BoolFilter>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  rtsSlaTime?: InputMaybe<DateTimeNullableFilter>;
  tiktokOrderId?: InputMaybe<StringFilter>;
};

export type UserProductOrderTiktokDetailsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderTiktokDetailsWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderTiktokDetailsWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderTiktokDetailsWhereInput>>;
  deliveryOptionId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isTiktokShipping?: InputMaybe<BoolFilter>;
  order?: InputMaybe<UserProductOrderNullableRelationFilter>;
  rtsSlaTime?: InputMaybe<DateTimeNullableFilter>;
  tiktokOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type UserProductOrderUpdateManyMutationInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserProductOrderUpdateManyWithWhereWithoutLockedByInput = {
  data: UserProductOrderUpdateManyMutationInput;
  where: UserProductOrderScalarWhereInput;
};

export type UserProductOrderUpdateManyWithWhereWithoutOriginalOrderInput = {
  data: UserProductOrderUpdateManyMutationInput;
  where: UserProductOrderScalarWhereInput;
};

export type UserProductOrderUpdateManyWithWhereWithoutPostPaymentBucketInput = {
  data: UserProductOrderUpdateManyMutationInput;
  where: UserProductOrderScalarWhereInput;
};

export type UserProductOrderUpdateManyWithWhereWithoutStoreInput = {
  data: UserProductOrderUpdateManyMutationInput;
  where: UserProductOrderScalarWhereInput;
};

export type UserProductOrderUpdateManyWithWhereWithoutUserInput = {
  data: UserProductOrderUpdateManyMutationInput;
  where: UserProductOrderScalarWhereInput;
};

export type UserProductOrderUpdateManyWithWhereWithoutWarehouseShelfReturnBinInput = {
  data: UserProductOrderUpdateManyMutationInput;
  where: UserProductOrderScalarWhereInput;
};

export type UserProductOrderUpdateManyWithoutLockedByNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutLockedByInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutLockedByInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyLockedByInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderUpdateWithWhereUniqueWithoutLockedByInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderUpdateManyWithWhereWithoutLockedByInput>>;
  upsert?: InputMaybe<Array<UserProductOrderUpsertWithWhereUniqueWithoutLockedByInput>>;
};

export type UserProductOrderUpdateManyWithoutOriginalOrderNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutOriginalOrderInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutOriginalOrderInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyOriginalOrderInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderUpdateWithWhereUniqueWithoutOriginalOrderInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderUpdateManyWithWhereWithoutOriginalOrderInput>>;
  upsert?: InputMaybe<Array<UserProductOrderUpsertWithWhereUniqueWithoutOriginalOrderInput>>;
};

export type UserProductOrderUpdateManyWithoutPostPaymentBucketNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutPostPaymentBucketInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutPostPaymentBucketInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyPostPaymentBucketInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderUpdateWithWhereUniqueWithoutPostPaymentBucketInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderUpdateManyWithWhereWithoutPostPaymentBucketInput>>;
  upsert?: InputMaybe<Array<UserProductOrderUpsertWithWhereUniqueWithoutPostPaymentBucketInput>>;
};

export type UserProductOrderUpdateManyWithoutStoreNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutStoreInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutStoreInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyStoreInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderUpdateWithWhereUniqueWithoutStoreInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderUpdateManyWithWhereWithoutStoreInput>>;
  upsert?: InputMaybe<Array<UserProductOrderUpsertWithWhereUniqueWithoutStoreInput>>;
};

export type UserProductOrderUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserProductOrderUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserProductOrderUpdateManyWithoutWarehouseShelfReturnBinNestedInput = {
  connect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductOrderCreateOrConnectWithoutWarehouseShelfReturnBinInput>>;
  create?: InputMaybe<Array<UserProductOrderCreateWithoutWarehouseShelfReturnBinInput>>;
  createMany?: InputMaybe<UserProductOrderCreateManyWarehouseShelfReturnBinInputEnvelope>;
  delete?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductOrderUpdateWithWhereUniqueWithoutWarehouseShelfReturnBinInput>>;
  updateMany?: InputMaybe<Array<UserProductOrderUpdateManyWithWhereWithoutWarehouseShelfReturnBinInput>>;
  upsert?: InputMaybe<Array<UserProductOrderUpsertWithWhereUniqueWithoutWarehouseShelfReturnBinInput>>;
};

export type UserProductOrderUpdateOneRequiredWithoutCustomOnHoldReasonsNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutCustomOnHoldReasonsInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutCustomOnHoldReasonsInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutCustomOnHoldReasonsInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutCustomOnHoldReasonsInput>;
};

export type UserProductOrderUpdateOneRequiredWithoutEverlabOrdersNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutEverlabOrdersInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutEverlabOrdersInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutEverlabOrdersInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutEverlabOrdersInput>;
};

export type UserProductOrderUpdateOneRequiredWithoutHoldReasonIntervalsNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutHoldReasonIntervalsInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutHoldReasonIntervalsInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutHoldReasonIntervalsInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutHoldReasonIntervalsInput>;
};

export type UserProductOrderUpdateOneRequiredWithoutHoldStatusIntervalsNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutHoldStatusIntervalsInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutHoldStatusIntervalsInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutHoldStatusIntervalsInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutHoldStatusIntervalsInput>;
};

export type UserProductOrderUpdateOneRequiredWithoutJetpackApiOrdersNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutJetpackApiOrdersInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutJetpackApiOrdersInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutJetpackApiOrdersInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutJetpackApiOrdersInput>;
};

export type UserProductOrderUpdateOneRequiredWithoutLinesNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutLinesInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutLinesInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutLinesInput>;
};

export type UserProductOrderUpdateOneRequiredWithoutRoastifyOrdersNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutRoastifyOrdersInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutRoastifyOrdersInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutRoastifyOrdersInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutRoastifyOrdersInput>;
};

export type UserProductOrderUpdateOneRequiredWithoutShipbobOrdersNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutShipbobOrdersInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutShipbobOrdersInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutShipbobOrdersInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutShipbobOrdersInput>;
};

export type UserProductOrderUpdateOneRequiredWithoutShipmentsNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutShipmentsInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutShipmentsInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutShipmentsInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutShipmentsInput>;
};

export type UserProductOrderUpdateOneWithoutBillingAddressNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutBillingAddressInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutBillingAddressInput>;
  delete?: InputMaybe<UserProductOrderWhereInput>;
  disconnect?: InputMaybe<UserProductOrderWhereInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutBillingAddressInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutBillingAddressInput>;
};

export type UserProductOrderUpdateOneWithoutCreditsPaymentsNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutCreditsPaymentsInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutCreditsPaymentsInput>;
  delete?: InputMaybe<UserProductOrderWhereInput>;
  disconnect?: InputMaybe<UserProductOrderWhereInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutCreditsPaymentsInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutCreditsPaymentsInput>;
};

export type UserProductOrderUpdateOneWithoutCreditsRefundNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutCreditsRefundInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutCreditsRefundInput>;
  delete?: InputMaybe<UserProductOrderWhereInput>;
  disconnect?: InputMaybe<UserProductOrderWhereInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutCreditsRefundInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutCreditsRefundInput>;
};

export type UserProductOrderUpdateOneWithoutInvoicesNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutInvoicesInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutInvoicesInput>;
  delete?: InputMaybe<UserProductOrderWhereInput>;
  disconnect?: InputMaybe<UserProductOrderWhereInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutInvoicesInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutInvoicesInput>;
};

export type UserProductOrderUpdateOneWithoutOnboardingSampleSessionNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutOnboardingSampleSessionInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutOnboardingSampleSessionInput>;
  delete?: InputMaybe<UserProductOrderWhereInput>;
  disconnect?: InputMaybe<UserProductOrderWhereInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutOnboardingSampleSessionInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutOnboardingSampleSessionInput>;
};

export type UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutReplacementOrdersInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutReplacementOrdersInput>;
  delete?: InputMaybe<UserProductOrderWhereInput>;
  disconnect?: InputMaybe<UserProductOrderWhereInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutReplacementOrdersInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutReplacementOrdersInput>;
};

export type UserProductOrderUpdateOneWithoutShippingAddressNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutShippingAddressInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutShippingAddressInput>;
  delete?: InputMaybe<UserProductOrderWhereInput>;
  disconnect?: InputMaybe<UserProductOrderWhereInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutShippingAddressInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutShippingAddressInput>;
};

export type UserProductOrderUpdateOneWithoutStripeInvoicesNestedInput = {
  connect?: InputMaybe<UserProductOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductOrderCreateOrConnectWithoutStripeInvoicesInput>;
  create?: InputMaybe<UserProductOrderCreateWithoutStripeInvoicesInput>;
  delete?: InputMaybe<UserProductOrderWhereInput>;
  disconnect?: InputMaybe<UserProductOrderWhereInput>;
  update?: InputMaybe<UserProductOrderUpdateToOneWithWhereWithoutStripeInvoicesInput>;
  upsert?: InputMaybe<UserProductOrderUpsertWithoutStripeInvoicesInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutBillingAddressInput = {
  data: UserProductOrderUpdateWithoutBillingAddressInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutCreditsPaymentsInput = {
  data: UserProductOrderUpdateWithoutCreditsPaymentsInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutCreditsRefundInput = {
  data: UserProductOrderUpdateWithoutCreditsRefundInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutCustomOnHoldReasonsInput = {
  data: UserProductOrderUpdateWithoutCustomOnHoldReasonsInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutEverlabOrdersInput = {
  data: UserProductOrderUpdateWithoutEverlabOrdersInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutHoldReasonIntervalsInput = {
  data: UserProductOrderUpdateWithoutHoldReasonIntervalsInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutHoldStatusIntervalsInput = {
  data: UserProductOrderUpdateWithoutHoldStatusIntervalsInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutInvoicesInput = {
  data: UserProductOrderUpdateWithoutInvoicesInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutJetpackApiOrdersInput = {
  data: UserProductOrderUpdateWithoutJetpackApiOrdersInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutLinesInput = {
  data: UserProductOrderUpdateWithoutLinesInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutOnboardingSampleSessionInput = {
  data: UserProductOrderUpdateWithoutOnboardingSampleSessionInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutReplacementOrdersInput = {
  data: UserProductOrderUpdateWithoutReplacementOrdersInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutRoastifyOrdersInput = {
  data: UserProductOrderUpdateWithoutRoastifyOrdersInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutShipbobOrdersInput = {
  data: UserProductOrderUpdateWithoutShipbobOrdersInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutShipmentsInput = {
  data: UserProductOrderUpdateWithoutShipmentsInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutShippingAddressInput = {
  data: UserProductOrderUpdateWithoutShippingAddressInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateToOneWithWhereWithoutStripeInvoicesInput = {
  data: UserProductOrderUpdateWithoutStripeInvoicesInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpdateWithWhereUniqueWithoutLockedByInput = {
  data: UserProductOrderUpdateWithoutLockedByInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpdateWithWhereUniqueWithoutOriginalOrderInput = {
  data: UserProductOrderUpdateWithoutOriginalOrderInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpdateWithWhereUniqueWithoutPostPaymentBucketInput = {
  data: UserProductOrderUpdateWithoutPostPaymentBucketInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpdateWithWhereUniqueWithoutStoreInput = {
  data: UserProductOrderUpdateWithoutStoreInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpdateWithWhereUniqueWithoutUserInput = {
  data: UserProductOrderUpdateWithoutUserInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpdateWithWhereUniqueWithoutWarehouseShelfReturnBinInput = {
  data: UserProductOrderUpdateWithoutWarehouseShelfReturnBinInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpdateWithoutBillingAddressInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutCreditsPaymentsInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutCreditsRefundInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutCustomOnHoldReasonsInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutEverlabOrdersInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutHoldReasonIntervalsInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutHoldStatusIntervalsInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutInvoicesInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutJetpackApiOrdersInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutLinesInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutLockedByInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutOnboardingSampleSessionInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutOriginalOrderInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutPostPaymentBucketInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutReplacementOrdersInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutRoastifyOrdersInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutShipbobOrdersInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutShipmentsInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutShippingAddressInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutStoreInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutStripeInvoicesInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutUserInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput>;
};

export type UserProductOrderUpdateWithoutWarehouseShelfReturnBinInput = {
  acceptedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderBillingNestedInput>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsUpdateOneWithoutOrderNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsUpdateOneWithoutOrderNestedInput>;
  completedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsPayments?: InputMaybe<UserCreditsTransactionUpdateManyWithoutPayForOrderNestedInput>;
  creditsRefund?: InputMaybe<UserCreditsTransactionUpdateManyWithoutRefundOrderNestedInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  currencyConversionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonUpdateManyWithoutOrderNestedInput>;
  details?: InputMaybe<UserProductOrderDetailsUpdateOneWithoutOrderNestedInput>;
  everlabOrders?: InputMaybe<EverlabOrderUpdateManyWithoutUserProductOrderNestedInput>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsUpdateOneWithoutOrderNestedInput>;
  fulfillmentDeadline?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalUpdateManyWithoutOrderNestedInput>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFieldUpdateOperationsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseUpdateManyWithoutOrderNestedInput>;
  itemCountTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderUpdateManyWithoutUserProductOrderNestedInput>;
  kind?: InputMaybe<EnumUserProductOrderKindFieldUpdateOperationsInput>;
  legacyOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lineItemsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutOrderNestedInput>;
  lockedBy?: InputMaybe<AdminUpdateOneWithoutLockedOrdersNestedInput>;
  onHold?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onHoldReasons?: InputMaybe<UserProductOrderUpdateonHoldReasonsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductOrderNestedInput>;
  orderId?: InputMaybe<IntFieldUpdateOperationsInput>;
  originalCurrency?: InputMaybe<StringFieldUpdateOperationsInput>;
  originalOrder?: InputMaybe<UserProductOrderUpdateOneWithoutReplacementOrdersNestedInput>;
  paymentStatus?: InputMaybe<NullableEnumUserProductOrderPaymentStatusFieldUpdateOperationsInput>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketUpdateOneWithoutOrdersNestedInput>;
  replacementOrders?: InputMaybe<UserProductOrderUpdateManyWithoutOriginalOrderNestedInput>;
  roastifyOrders?: InputMaybe<RoastifyOrderUpdateManyWithoutUserProductOrderNestedInput>;
  sampleDiscountApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sampleExpressShippingApplied?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipbobOrders?: InputMaybe<ShipbobOrderUpdateManyWithoutUserProductOrderNestedInput>;
  shipheroOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipments?: InputMaybe<ShipmentUpdateManyWithoutUserProductOrderNestedInput>;
  shippingAddress?: InputMaybe<UserProductOrderAddressUpdateOneWithoutOrderShippingNestedInput>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumUserProductOrderStatusFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductOrdersNestedInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserProductOrderNestedInput>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsUpdateOneWithoutOrderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput>;
};

export type UserProductOrderUpdateonHoldReasonsInput = {
  push?: InputMaybe<Array<OnHoldReason>>;
  set?: InputMaybe<Array<OnHoldReason>>;
};

export type UserProductOrderUpsertWithWhereUniqueWithoutLockedByInput = {
  create: UserProductOrderCreateWithoutLockedByInput;
  update: UserProductOrderUpdateWithoutLockedByInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpsertWithWhereUniqueWithoutOriginalOrderInput = {
  create: UserProductOrderCreateWithoutOriginalOrderInput;
  update: UserProductOrderUpdateWithoutOriginalOrderInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpsertWithWhereUniqueWithoutPostPaymentBucketInput = {
  create: UserProductOrderCreateWithoutPostPaymentBucketInput;
  update: UserProductOrderUpdateWithoutPostPaymentBucketInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpsertWithWhereUniqueWithoutStoreInput = {
  create: UserProductOrderCreateWithoutStoreInput;
  update: UserProductOrderUpdateWithoutStoreInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpsertWithWhereUniqueWithoutUserInput = {
  create: UserProductOrderCreateWithoutUserInput;
  update: UserProductOrderUpdateWithoutUserInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpsertWithWhereUniqueWithoutWarehouseShelfReturnBinInput = {
  create: UserProductOrderCreateWithoutWarehouseShelfReturnBinInput;
  update: UserProductOrderUpdateWithoutWarehouseShelfReturnBinInput;
  where: UserProductOrderWhereUniqueInput;
};

export type UserProductOrderUpsertWithoutBillingAddressInput = {
  create: UserProductOrderCreateWithoutBillingAddressInput;
  update: UserProductOrderUpdateWithoutBillingAddressInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutCreditsPaymentsInput = {
  create: UserProductOrderCreateWithoutCreditsPaymentsInput;
  update: UserProductOrderUpdateWithoutCreditsPaymentsInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutCreditsRefundInput = {
  create: UserProductOrderCreateWithoutCreditsRefundInput;
  update: UserProductOrderUpdateWithoutCreditsRefundInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutCustomOnHoldReasonsInput = {
  create: UserProductOrderCreateWithoutCustomOnHoldReasonsInput;
  update: UserProductOrderUpdateWithoutCustomOnHoldReasonsInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutEverlabOrdersInput = {
  create: UserProductOrderCreateWithoutEverlabOrdersInput;
  update: UserProductOrderUpdateWithoutEverlabOrdersInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutHoldReasonIntervalsInput = {
  create: UserProductOrderCreateWithoutHoldReasonIntervalsInput;
  update: UserProductOrderUpdateWithoutHoldReasonIntervalsInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutHoldStatusIntervalsInput = {
  create: UserProductOrderCreateWithoutHoldStatusIntervalsInput;
  update: UserProductOrderUpdateWithoutHoldStatusIntervalsInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutInvoicesInput = {
  create: UserProductOrderCreateWithoutInvoicesInput;
  update: UserProductOrderUpdateWithoutInvoicesInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutJetpackApiOrdersInput = {
  create: UserProductOrderCreateWithoutJetpackApiOrdersInput;
  update: UserProductOrderUpdateWithoutJetpackApiOrdersInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutLinesInput = {
  create: UserProductOrderCreateWithoutLinesInput;
  update: UserProductOrderUpdateWithoutLinesInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutOnboardingSampleSessionInput = {
  create: UserProductOrderCreateWithoutOnboardingSampleSessionInput;
  update: UserProductOrderUpdateWithoutOnboardingSampleSessionInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutReplacementOrdersInput = {
  create: UserProductOrderCreateWithoutReplacementOrdersInput;
  update: UserProductOrderUpdateWithoutReplacementOrdersInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutRoastifyOrdersInput = {
  create: UserProductOrderCreateWithoutRoastifyOrdersInput;
  update: UserProductOrderUpdateWithoutRoastifyOrdersInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutShipbobOrdersInput = {
  create: UserProductOrderCreateWithoutShipbobOrdersInput;
  update: UserProductOrderUpdateWithoutShipbobOrdersInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutShipmentsInput = {
  create: UserProductOrderCreateWithoutShipmentsInput;
  update: UserProductOrderUpdateWithoutShipmentsInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutShippingAddressInput = {
  create: UserProductOrderCreateWithoutShippingAddressInput;
  update: UserProductOrderUpdateWithoutShippingAddressInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderUpsertWithoutStripeInvoicesInput = {
  create: UserProductOrderCreateWithoutStripeInvoicesInput;
  update: UserProductOrderUpdateWithoutStripeInvoicesInput;
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type UserProductOrderWhereInput = {
  AND?: InputMaybe<Array<UserProductOrderWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderWhereInput>>;
  acceptedAt?: InputMaybe<DateTimeNullableFilter>;
  billingAddress?: InputMaybe<UserProductOrderAddressNullableRelationFilter>;
  billingAddressId?: InputMaybe<UuidNullableFilter>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsNullableRelationFilter>;
  bulkDetailsId?: InputMaybe<UuidNullableFilter>;
  cancelledAt?: InputMaybe<DateTimeNullableFilter>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsNullableRelationFilter>;
  clickfunnelsDetailsId?: InputMaybe<UuidNullableFilter>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creditsPayments?: InputMaybe<UserCreditsTransactionListRelationFilter>;
  creditsRefund?: InputMaybe<UserCreditsTransactionListRelationFilter>;
  currency?: InputMaybe<StringFilter>;
  currencyConversionRate?: InputMaybe<FloatFilter>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonListRelationFilter>;
  details?: InputMaybe<UserProductOrderDetailsNullableRelationFilter>;
  detailsId?: InputMaybe<UuidNullableFilter>;
  everlabOrders?: InputMaybe<EverlabOrderListRelationFilter>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsNullableRelationFilter>;
  fbaDetailsId?: InputMaybe<UuidNullableFilter>;
  fulfillmentDeadline?: InputMaybe<DateTimeNullableFilter>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalListRelationFilter>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFilter>;
  invoices?: InputMaybe<UserInvoiceListRelationFilter>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFilter>;
  isReplacement?: InputMaybe<BoolFilter>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseListRelationFilter>;
  itemCountTotal?: InputMaybe<IntFilter>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderListRelationFilter>;
  kind?: InputMaybe<EnumUserProductOrderKindFilter>;
  legacyOrderId?: InputMaybe<StringNullableFilter>;
  lineItemsCount?: InputMaybe<IntNullableFilter>;
  lines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  lockedBy?: InputMaybe<AdminNullableRelationFilter>;
  lockedById?: InputMaybe<UuidNullableFilter>;
  onHold?: InputMaybe<BoolFilter>;
  onHoldReasons?: InputMaybe<EnumOnHoldReasonNullableListFilter>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionNullableRelationFilter>;
  onboardingSampleSessionId?: InputMaybe<UuidNullableFilter>;
  orderId?: InputMaybe<IntFilter>;
  originalCurrency?: InputMaybe<StringFilter>;
  originalOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  originalOrderId?: InputMaybe<UuidNullableFilter>;
  paymentStatus?: InputMaybe<EnumUserProductOrderPaymentStatusNullableFilter>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketNullableRelationFilter>;
  postPaymentBucketId?: InputMaybe<UuidNullableFilter>;
  replacementOrders?: InputMaybe<UserProductOrderListRelationFilter>;
  roastifyOrders?: InputMaybe<RoastifyOrderListRelationFilter>;
  sampleDiscountApplied?: InputMaybe<BoolFilter>;
  sampleExpressShippingApplied?: InputMaybe<BoolFilter>;
  sent?: InputMaybe<BoolFilter>;
  shipbobOrders?: InputMaybe<ShipbobOrderListRelationFilter>;
  shipheroOrderId?: InputMaybe<StringNullableFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  shippingAddress?: InputMaybe<UserProductOrderAddressNullableRelationFilter>;
  shippingAddressId?: InputMaybe<UuidNullableFilter>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsNullableRelationFilter>;
  shopifyDetailsId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumUserProductOrderStatusFilter>;
  store?: InputMaybe<UserStoreNullableRelationFilter>;
  storeId?: InputMaybe<UuidNullableFilter>;
  stripeInvoices?: InputMaybe<StripeInvoiceListRelationFilter>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsNullableRelationFilter>;
  tiktokDetailsId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinListRelationFilter>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinNullableRelationFilter>;
  warehouseShelfReturnBinId?: InputMaybe<UuidNullableFilter>;
};

export type UserProductOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductOrderWhereInput>>;
  NOT?: InputMaybe<Array<UserProductOrderWhereInput>>;
  OR?: InputMaybe<Array<UserProductOrderWhereInput>>;
  acceptedAt?: InputMaybe<DateTimeNullableFilter>;
  billingAddress?: InputMaybe<UserProductOrderAddressNullableRelationFilter>;
  billingAddressId?: InputMaybe<Scalars['String']['input']>;
  bulkDetails?: InputMaybe<UserProductOrderBulkDetailsNullableRelationFilter>;
  bulkDetailsId?: InputMaybe<Scalars['String']['input']>;
  cancelledAt?: InputMaybe<DateTimeNullableFilter>;
  clickfunnelsDetails?: InputMaybe<UserProductOrderClickFunnelsDetailsNullableRelationFilter>;
  clickfunnelsDetailsId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creditsPayments?: InputMaybe<UserCreditsTransactionListRelationFilter>;
  creditsRefund?: InputMaybe<UserCreditsTransactionListRelationFilter>;
  currency?: InputMaybe<StringFilter>;
  currencyConversionRate?: InputMaybe<FloatFilter>;
  customOnHoldReasons?: InputMaybe<CustomOnHoldReasonListRelationFilter>;
  details?: InputMaybe<UserProductOrderDetailsNullableRelationFilter>;
  detailsId?: InputMaybe<Scalars['String']['input']>;
  everlabOrders?: InputMaybe<EverlabOrderListRelationFilter>;
  fbaDetails?: InputMaybe<UserProductOrderFbaDetailsNullableRelationFilter>;
  fbaDetailsId?: InputMaybe<Scalars['String']['input']>;
  fulfillmentDeadline?: InputMaybe<DateTimeNullableFilter>;
  holdReasonIntervals?: InputMaybe<UserProductOrderOnHoldReasonIntervalListRelationFilter>;
  holdStatusIntervals?: InputMaybe<UserProductOrderHoldStatusIntervalListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoiceMode?: InputMaybe<EnumInvoiceModeFilter>;
  invoices?: InputMaybe<UserInvoiceListRelationFilter>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFilter>;
  isReplacement?: InputMaybe<BoolFilter>;
  itemCountByWarehouse?: InputMaybe<UserProductOrderItemCountByWarehouseListRelationFilter>;
  itemCountTotal?: InputMaybe<IntFilter>;
  jetpackApiOrders?: InputMaybe<JetpackApiOrderListRelationFilter>;
  kind?: InputMaybe<EnumUserProductOrderKindFilter>;
  legacyOrderId?: InputMaybe<StringNullableFilter>;
  lineItemsCount?: InputMaybe<IntNullableFilter>;
  lines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  lockedBy?: InputMaybe<AdminNullableRelationFilter>;
  lockedById?: InputMaybe<UuidNullableFilter>;
  onHold?: InputMaybe<BoolFilter>;
  onHoldReasons?: InputMaybe<EnumOnHoldReasonNullableListFilter>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionNullableRelationFilter>;
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<IntFilter>;
  originalCurrency?: InputMaybe<StringFilter>;
  originalOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  originalOrderId?: InputMaybe<UuidNullableFilter>;
  paymentStatus?: InputMaybe<EnumUserProductOrderPaymentStatusNullableFilter>;
  postPaymentBucket?: InputMaybe<PostPaymentOrdersBucketNullableRelationFilter>;
  postPaymentBucketId?: InputMaybe<UuidNullableFilter>;
  replacementOrders?: InputMaybe<UserProductOrderListRelationFilter>;
  roastifyOrders?: InputMaybe<RoastifyOrderListRelationFilter>;
  sampleDiscountApplied?: InputMaybe<BoolFilter>;
  sampleExpressShippingApplied?: InputMaybe<BoolFilter>;
  sent?: InputMaybe<BoolFilter>;
  shipbobOrders?: InputMaybe<ShipbobOrderListRelationFilter>;
  shipheroOrderId?: InputMaybe<StringNullableFilter>;
  shipments?: InputMaybe<ShipmentListRelationFilter>;
  shippingAddress?: InputMaybe<UserProductOrderAddressNullableRelationFilter>;
  shippingAddressId?: InputMaybe<Scalars['String']['input']>;
  shopifyDetails?: InputMaybe<UserProductOrderShopifyDetailsNullableRelationFilter>;
  shopifyDetailsId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserProductOrderStatusFilter>;
  store?: InputMaybe<UserStoreNullableRelationFilter>;
  storeId?: InputMaybe<UuidNullableFilter>;
  stripeInvoices?: InputMaybe<StripeInvoiceListRelationFilter>;
  tiktokDetails?: InputMaybe<UserProductOrderTiktokDetailsNullableRelationFilter>;
  tiktokDetailsId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  warehouseShelfBins?: InputMaybe<WarehouseShelfBinListRelationFilter>;
  warehouseShelfReturnBin?: InputMaybe<WarehouseShelfReturnBinNullableRelationFilter>;
  warehouseShelfReturnBinId?: InputMaybe<UuidNullableFilter>;
};

export type UserProductRelationFilter = {
  is?: InputMaybe<UserProductWhereInput>;
  isNot?: InputMaybe<UserProductWhereInput>;
};

export type UserProductScalarWhereInput = {
  AND?: InputMaybe<Array<UserProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserProductScalarWhereInput>>;
  OR?: InputMaybe<Array<UserProductScalarWhereInput>>;
  baseId?: InputMaybe<UuidNullableFilter>;
  clickfunnelsId?: InputMaybe<StringNullableFilter>;
  clickfunnelsVariantId?: InputMaybe<StringNullableFilter>;
  coverImageId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customSkuId?: InputMaybe<StringNullableFilter>;
  defaultShippingPackageId?: InputMaybe<UuidNullableFilter>;
  description?: InputMaybe<StringFilter>;
  eligibilityCheckedAt?: InputMaybe<DateTimeNullableFilter>;
  eligibilityResult?: InputMaybe<JsonNullableFilter>;
  eligibilityScore?: InputMaybe<FloatNullableFilter>;
  generatedSku?: InputMaybe<StringNullableFilter>;
  hasInsert?: InputMaybe<BoolFilter>;
  hasUnpushedImageChanges?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  insertImage?: InputMaybe<StringNullableFilter>;
  isOnboardingSampleLabel?: InputMaybe<BoolFilter>;
  isPrelabeled?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  isSingleSkuBundle?: InputMaybe<BoolFilter>;
  isVisible?: InputMaybe<BoolFilter>;
  labelId?: InputMaybe<UuidNullableFilter>;
  layoutId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  onboardingSampleSessionId?: InputMaybe<UuidNullableFilter>;
  prePaidUnits?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<FloatFilter>;
  pricePrePaid?: InputMaybe<FloatNullableFilter>;
  priceSpecial?: InputMaybe<FloatNullableFilter>;
  productSettingsId?: InputMaybe<StringFilter>;
  sanityProductId?: InputMaybe<StringFilter>;
  shipheroProductId?: InputMaybe<StringNullableFilter>;
  shipheroSampleProductId?: InputMaybe<StringNullableFilter>;
  shopifyId?: InputMaybe<StringNullableFilter>;
  shopifyVariantId?: InputMaybe<StringNullableFilter>;
  shortDescription?: InputMaybe<StringFilter>;
  singleSkuBundleQuantity?: InputMaybe<IntNullableFilter>;
  slug?: InputMaybe<StringFilter>;
  storeId?: InputMaybe<UuidNullableFilter>;
  supplierId?: InputMaybe<StringNullableFilter>;
  tiktokId?: InputMaybe<StringNullableFilter>;
  tiktokSkuId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
  verified?: InputMaybe<BoolFilter>;
  woocommerceId?: InputMaybe<StringNullableFilter>;
};

export type UserProductStoreIdShopifyIdCompoundUniqueInput = {
  shopifyId: Scalars['String']['input'];
  storeId: Scalars['String']['input'];
};

export type UserProductStoreIdSlugCompoundUniqueInput = {
  slug: Scalars['String']['input'];
  storeId: Scalars['String']['input'];
};

export type UserProductStoreIdWoocommerceIdCompoundUniqueInput = {
  storeId: Scalars['String']['input'];
  woocommerceId: Scalars['String']['input'];
};

export type UserProductToShip = {
  __typename?: 'UserProductToShip';
  _count?: Maybe<UserProductCount>;
  baseId?: Maybe<Scalars['String']['output']>;
  clickfunnelsId?: Maybe<Scalars['String']['output']>;
  clickfunnelsVariantId?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<UserProductFile>;
  coverImageId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customSkuId?: Maybe<Scalars['String']['output']>;
  defaultShippingPackage?: Maybe<ShippingPackage>;
  defaultShippingPackageId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eligibilityCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  eligibilityResult?: Maybe<Scalars['JSON']['output']>;
  eligibilityScore?: Maybe<Scalars['Float']['output']>;
  files: Array<UserProductFile>;
  generatedSku?: Maybe<Scalars['String']['output']>;
  hasInsert: Scalars['Boolean']['output'];
  hasUnpushedImageChanges: Scalars['Boolean']['output'];
  hasV1LabelFile: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  insertImage?: Maybe<Scalars['String']['output']>;
  isOnboardingSampleLabel: Scalars['Boolean']['output'];
  isPrelabeled: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isSingleSkuBundle: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  labelDraft?: Maybe<UserProductLabelDraft>;
  labelId?: Maybe<Scalars['String']['output']>;
  layoutId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onboardingSampleSession?: Maybe<OnboardingSampleOrderSession>;
  onboardingSampleSessionId?: Maybe<Scalars['String']['output']>;
  prePaidUnits?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  pricePrePaid?: Maybe<Scalars['Float']['output']>;
  priceSpecial?: Maybe<Scalars['Float']['output']>;
  productSettings: ProductSettings;
  productSettingsId: Scalars['String']['output'];
  sanityProductId: Scalars['String']['output'];
  shipheroProductId?: Maybe<Scalars['String']['output']>;
  shipheroSampleProductId?: Maybe<Scalars['String']['output']>;
  shopifyId?: Maybe<Scalars['String']['output']>;
  shopifyVariantId?: Maybe<Scalars['String']['output']>;
  shortDescription: Scalars['String']['output'];
  singleSkuBundleQuantity?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  store?: Maybe<UserStore>;
  storeId?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  tiktokId?: Maybe<Scalars['String']['output']>;
  tiktokSkuId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  woocommerceId?: Maybe<Scalars['String']['output']>;
};


export type UserProductToShipCoverImageArgs = {
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type UserProductToShipFilesArgs = {
  cursor?: InputMaybe<UserProductFileWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserProductFileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserProductFileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserProductFileWhereInput>;
};


export type UserProductToShipLabelDraftArgs = {
  where?: InputMaybe<UserProductLabelDraftWhereInput>;
};


export type UserProductToShipOnboardingSampleSessionArgs = {
  where?: InputMaybe<OnboardingSampleOrderSessionWhereInput>;
};


export type UserProductToShipStoreArgs = {
  where?: InputMaybe<UserStoreWhereInput>;
};

export type UserProductUpdateManyMutationInput = {
  baseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eligibilityCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  generatedSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasInsert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasUnpushedImageChanges?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  insertImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOnboardingSampleLabel?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPrelabeled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSingleSkuBundle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prePaidUnits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  pricePrePaid?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSpecial?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  sanityProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipheroProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroSampleProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescription?: InputMaybe<StringFieldUpdateOperationsInput>;
  singleSkuBundleQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  supplierId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  woocommerceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductUpdateManyWithWhereWithoutCoverImageInput = {
  data: UserProductUpdateManyMutationInput;
  where: UserProductScalarWhereInput;
};

export type UserProductUpdateManyWithWhereWithoutDefaultShippingPackageInput = {
  data: UserProductUpdateManyMutationInput;
  where: UserProductScalarWhereInput;
};

export type UserProductUpdateManyWithWhereWithoutProductSettingsInput = {
  data: UserProductUpdateManyMutationInput;
  where: UserProductScalarWhereInput;
};

export type UserProductUpdateManyWithWhereWithoutStoreInput = {
  data: UserProductUpdateManyMutationInput;
  where: UserProductScalarWhereInput;
};

export type UserProductUpdateManyWithWhereWithoutUserInput = {
  data: UserProductUpdateManyMutationInput;
  where: UserProductScalarWhereInput;
};

export type UserProductUpdateManyWithoutCoverImageNestedInput = {
  connect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductCreateOrConnectWithoutCoverImageInput>>;
  create?: InputMaybe<Array<UserProductCreateWithoutCoverImageInput>>;
  createMany?: InputMaybe<UserProductCreateManyCoverImageInputEnvelope>;
  delete?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductUpdateWithWhereUniqueWithoutCoverImageInput>>;
  updateMany?: InputMaybe<Array<UserProductUpdateManyWithWhereWithoutCoverImageInput>>;
  upsert?: InputMaybe<Array<UserProductUpsertWithWhereUniqueWithoutCoverImageInput>>;
};

export type UserProductUpdateManyWithoutDefaultShippingPackageNestedInput = {
  connect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductCreateOrConnectWithoutDefaultShippingPackageInput>>;
  create?: InputMaybe<Array<UserProductCreateWithoutDefaultShippingPackageInput>>;
  createMany?: InputMaybe<UserProductCreateManyDefaultShippingPackageInputEnvelope>;
  delete?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductUpdateWithWhereUniqueWithoutDefaultShippingPackageInput>>;
  updateMany?: InputMaybe<Array<UserProductUpdateManyWithWhereWithoutDefaultShippingPackageInput>>;
  upsert?: InputMaybe<Array<UserProductUpsertWithWhereUniqueWithoutDefaultShippingPackageInput>>;
};

export type UserProductUpdateManyWithoutProductSettingsNestedInput = {
  connect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductCreateOrConnectWithoutProductSettingsInput>>;
  create?: InputMaybe<Array<UserProductCreateWithoutProductSettingsInput>>;
  createMany?: InputMaybe<UserProductCreateManyProductSettingsInputEnvelope>;
  delete?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductUpdateWithWhereUniqueWithoutProductSettingsInput>>;
  updateMany?: InputMaybe<Array<UserProductUpdateManyWithWhereWithoutProductSettingsInput>>;
  upsert?: InputMaybe<Array<UserProductUpsertWithWhereUniqueWithoutProductSettingsInput>>;
};

export type UserProductUpdateManyWithoutStoreNestedInput = {
  connect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductCreateOrConnectWithoutStoreInput>>;
  create?: InputMaybe<Array<UserProductCreateWithoutStoreInput>>;
  createMany?: InputMaybe<UserProductCreateManyStoreInputEnvelope>;
  delete?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductUpdateWithWhereUniqueWithoutStoreInput>>;
  updateMany?: InputMaybe<Array<UserProductUpdateManyWithWhereWithoutStoreInput>>;
  upsert?: InputMaybe<Array<UserProductUpsertWithWhereUniqueWithoutStoreInput>>;
};

export type UserProductUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserProductCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserProductCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserProductCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  set?: InputMaybe<Array<UserProductWhereUniqueInput>>;
  update?: InputMaybe<Array<UserProductUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserProductUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserProductUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserProductUpdateOneRequiredWithoutFilesNestedInput = {
  connect?: InputMaybe<UserProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<UserProductCreateWithoutFilesInput>;
  update?: InputMaybe<UserProductUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<UserProductUpsertWithoutFilesInput>;
};

export type UserProductUpdateOneRequiredWithoutOrderLinesNestedInput = {
  connect?: InputMaybe<UserProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<UserProductCreateWithoutOrderLinesInput>;
  update?: InputMaybe<UserProductUpdateToOneWithWhereWithoutOrderLinesInput>;
  upsert?: InputMaybe<UserProductUpsertWithoutOrderLinesInput>;
};

export type UserProductUpdateOneWithoutOnboardingSampleSessionNestedInput = {
  connect?: InputMaybe<UserProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserProductCreateOrConnectWithoutOnboardingSampleSessionInput>;
  create?: InputMaybe<UserProductCreateWithoutOnboardingSampleSessionInput>;
  delete?: InputMaybe<UserProductWhereInput>;
  disconnect?: InputMaybe<UserProductWhereInput>;
  update?: InputMaybe<UserProductUpdateToOneWithWhereWithoutOnboardingSampleSessionInput>;
  upsert?: InputMaybe<UserProductUpsertWithoutOnboardingSampleSessionInput>;
};

export type UserProductUpdateToOneWithWhereWithoutFilesInput = {
  data: UserProductUpdateWithoutFilesInput;
  where?: InputMaybe<UserProductWhereInput>;
};

export type UserProductUpdateToOneWithWhereWithoutOnboardingSampleSessionInput = {
  data: UserProductUpdateWithoutOnboardingSampleSessionInput;
  where?: InputMaybe<UserProductWhereInput>;
};

export type UserProductUpdateToOneWithWhereWithoutOrderLinesInput = {
  data: UserProductUpdateWithoutOrderLinesInput;
  where?: InputMaybe<UserProductWhereInput>;
};

export type UserProductUpdateWithWhereUniqueWithoutCoverImageInput = {
  data: UserProductUpdateWithoutCoverImageInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductUpdateWithWhereUniqueWithoutDefaultShippingPackageInput = {
  data: UserProductUpdateWithoutDefaultShippingPackageInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductUpdateWithWhereUniqueWithoutProductSettingsInput = {
  data: UserProductUpdateWithoutProductSettingsInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductUpdateWithWhereUniqueWithoutStoreInput = {
  data: UserProductUpdateWithoutStoreInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductUpdateWithWhereUniqueWithoutUserInput = {
  data: UserProductUpdateWithoutUserInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductUpdateWithoutCoverImageInput = {
  baseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageUserProductsNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eligibilityCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserProductNestedInput>;
  generatedSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasInsert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasUnpushedImageChanges?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  insertImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOnboardingSampleLabel?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPrelabeled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSingleSkuBundle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelDraft?: InputMaybe<UserProductLabelDraftUpdateOneWithoutUserProductNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductNestedInput>;
  prePaidUnits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  pricePrePaid?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSpecial?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutUserProductsNestedInput>;
  sanityProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipheroProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroSampleProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescription?: InputMaybe<StringFieldUpdateOperationsInput>;
  singleSkuBundleQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductsNestedInput>;
  supplierId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutProductsNestedInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  woocommerceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductUpdateWithoutDefaultShippingPackageInput = {
  baseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImage?: InputMaybe<UserProductFileUpdateOneWithoutUserProductsCoverImageNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eligibilityCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserProductNestedInput>;
  generatedSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasInsert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasUnpushedImageChanges?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  insertImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOnboardingSampleLabel?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPrelabeled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSingleSkuBundle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelDraft?: InputMaybe<UserProductLabelDraftUpdateOneWithoutUserProductNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductNestedInput>;
  prePaidUnits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  pricePrePaid?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSpecial?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutUserProductsNestedInput>;
  sanityProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipheroProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroSampleProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescription?: InputMaybe<StringFieldUpdateOperationsInput>;
  singleSkuBundleQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductsNestedInput>;
  supplierId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutProductsNestedInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  woocommerceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductUpdateWithoutFilesInput = {
  baseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImage?: InputMaybe<UserProductFileUpdateOneWithoutUserProductsCoverImageNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageUserProductsNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eligibilityCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  generatedSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasInsert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasUnpushedImageChanges?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  insertImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOnboardingSampleLabel?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPrelabeled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSingleSkuBundle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelDraft?: InputMaybe<UserProductLabelDraftUpdateOneWithoutUserProductNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductNestedInput>;
  prePaidUnits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  pricePrePaid?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSpecial?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutUserProductsNestedInput>;
  sanityProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipheroProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroSampleProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescription?: InputMaybe<StringFieldUpdateOperationsInput>;
  singleSkuBundleQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductsNestedInput>;
  supplierId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutProductsNestedInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  woocommerceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductUpdateWithoutOnboardingSampleSessionInput = {
  baseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImage?: InputMaybe<UserProductFileUpdateOneWithoutUserProductsCoverImageNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageUserProductsNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eligibilityCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserProductNestedInput>;
  generatedSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasInsert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasUnpushedImageChanges?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  insertImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOnboardingSampleLabel?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPrelabeled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSingleSkuBundle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelDraft?: InputMaybe<UserProductLabelDraftUpdateOneWithoutUserProductNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  prePaidUnits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  pricePrePaid?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSpecial?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutUserProductsNestedInput>;
  sanityProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipheroProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroSampleProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescription?: InputMaybe<StringFieldUpdateOperationsInput>;
  singleSkuBundleQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductsNestedInput>;
  supplierId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutProductsNestedInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  woocommerceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductUpdateWithoutOrderLinesInput = {
  baseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImage?: InputMaybe<UserProductFileUpdateOneWithoutUserProductsCoverImageNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageUserProductsNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eligibilityCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserProductNestedInput>;
  generatedSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasInsert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasUnpushedImageChanges?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  insertImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOnboardingSampleLabel?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPrelabeled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSingleSkuBundle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelDraft?: InputMaybe<UserProductLabelDraftUpdateOneWithoutUserProductNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductNestedInput>;
  prePaidUnits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  pricePrePaid?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSpecial?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutUserProductsNestedInput>;
  sanityProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipheroProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroSampleProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescription?: InputMaybe<StringFieldUpdateOperationsInput>;
  singleSkuBundleQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductsNestedInput>;
  supplierId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutProductsNestedInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  woocommerceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductUpdateWithoutProductSettingsInput = {
  baseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImage?: InputMaybe<UserProductFileUpdateOneWithoutUserProductsCoverImageNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageUserProductsNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eligibilityCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserProductNestedInput>;
  generatedSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasInsert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasUnpushedImageChanges?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  insertImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOnboardingSampleLabel?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPrelabeled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSingleSkuBundle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelDraft?: InputMaybe<UserProductLabelDraftUpdateOneWithoutUserProductNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductNestedInput>;
  prePaidUnits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  pricePrePaid?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSpecial?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  sanityProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipheroProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroSampleProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescription?: InputMaybe<StringFieldUpdateOperationsInput>;
  singleSkuBundleQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductsNestedInput>;
  supplierId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutProductsNestedInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  woocommerceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductUpdateWithoutStoreInput = {
  baseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImage?: InputMaybe<UserProductFileUpdateOneWithoutUserProductsCoverImageNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageUserProductsNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eligibilityCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserProductNestedInput>;
  generatedSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasInsert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasUnpushedImageChanges?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  insertImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOnboardingSampleLabel?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPrelabeled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSingleSkuBundle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelDraft?: InputMaybe<UserProductLabelDraftUpdateOneWithoutUserProductNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductNestedInput>;
  prePaidUnits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  pricePrePaid?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSpecial?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutUserProductsNestedInput>;
  sanityProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipheroProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroSampleProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescription?: InputMaybe<StringFieldUpdateOperationsInput>;
  singleSkuBundleQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  supplierId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutProductsNestedInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  woocommerceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductUpdateWithoutUserInput = {
  baseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickfunnelsVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImage?: InputMaybe<UserProductFileUpdateOneWithoutUserProductsCoverImageNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  defaultShippingPackage?: InputMaybe<ShippingPackageUpdateOneWithoutDefaultShippingPackageUserProductsNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  eligibilityCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eligibilityResult?: InputMaybe<Scalars['JSON']['input']>;
  eligibilityScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserProductNestedInput>;
  generatedSku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasInsert?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasUnpushedImageChanges?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  insertImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isOnboardingSampleLabel?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPrelabeled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPublished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isSingleSkuBundle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isVisible?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelDraft?: InputMaybe<UserProductLabelDraftUpdateOneWithoutUserProductNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionUpdateOneWithoutUserProductNestedInput>;
  prePaidUnits?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  pricePrePaid?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceSpecial?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  productSettings?: InputMaybe<ProductSettingsUpdateOneRequiredWithoutUserProductsNestedInput>;
  sanityProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipheroProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shipheroSampleProductId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyVariantId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shortDescription?: InputMaybe<StringFieldUpdateOperationsInput>;
  singleSkuBundleQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  store?: InputMaybe<UserStoreUpdateOneWithoutUserProductsNestedInput>;
  supplierId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tiktokSkuId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  woocommerceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserProductUpsertWithWhereUniqueWithoutCoverImageInput = {
  create: UserProductCreateWithoutCoverImageInput;
  update: UserProductUpdateWithoutCoverImageInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductUpsertWithWhereUniqueWithoutDefaultShippingPackageInput = {
  create: UserProductCreateWithoutDefaultShippingPackageInput;
  update: UserProductUpdateWithoutDefaultShippingPackageInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductUpsertWithWhereUniqueWithoutProductSettingsInput = {
  create: UserProductCreateWithoutProductSettingsInput;
  update: UserProductUpdateWithoutProductSettingsInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductUpsertWithWhereUniqueWithoutStoreInput = {
  create: UserProductCreateWithoutStoreInput;
  update: UserProductUpdateWithoutStoreInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductUpsertWithWhereUniqueWithoutUserInput = {
  create: UserProductCreateWithoutUserInput;
  update: UserProductUpdateWithoutUserInput;
  where: UserProductWhereUniqueInput;
};

export type UserProductUpsertWithoutFilesInput = {
  create: UserProductCreateWithoutFilesInput;
  update: UserProductUpdateWithoutFilesInput;
  where?: InputMaybe<UserProductWhereInput>;
};

export type UserProductUpsertWithoutOnboardingSampleSessionInput = {
  create: UserProductCreateWithoutOnboardingSampleSessionInput;
  update: UserProductUpdateWithoutOnboardingSampleSessionInput;
  where?: InputMaybe<UserProductWhereInput>;
};

export type UserProductUpsertWithoutOrderLinesInput = {
  create: UserProductCreateWithoutOrderLinesInput;
  update: UserProductUpdateWithoutOrderLinesInput;
  where?: InputMaybe<UserProductWhereInput>;
};

export type UserProductWhereInput = {
  AND?: InputMaybe<Array<UserProductWhereInput>>;
  NOT?: InputMaybe<Array<UserProductWhereInput>>;
  OR?: InputMaybe<Array<UserProductWhereInput>>;
  baseId?: InputMaybe<UuidNullableFilter>;
  clickfunnelsId?: InputMaybe<StringNullableFilter>;
  clickfunnelsVariantId?: InputMaybe<StringNullableFilter>;
  coverImage?: InputMaybe<UserProductFileNullableRelationFilter>;
  coverImageId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customSkuId?: InputMaybe<StringNullableFilter>;
  defaultShippingPackage?: InputMaybe<ShippingPackageNullableRelationFilter>;
  defaultShippingPackageId?: InputMaybe<UuidNullableFilter>;
  description?: InputMaybe<StringFilter>;
  eligibilityCheckedAt?: InputMaybe<DateTimeNullableFilter>;
  eligibilityResult?: InputMaybe<JsonNullableFilter>;
  eligibilityScore?: InputMaybe<FloatNullableFilter>;
  files?: InputMaybe<UserProductFileListRelationFilter>;
  generatedSku?: InputMaybe<StringNullableFilter>;
  hasInsert?: InputMaybe<BoolFilter>;
  hasUnpushedImageChanges?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  insertImage?: InputMaybe<StringNullableFilter>;
  isOnboardingSampleLabel?: InputMaybe<BoolFilter>;
  isPrelabeled?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  isSingleSkuBundle?: InputMaybe<BoolFilter>;
  isVisible?: InputMaybe<BoolFilter>;
  labelDraft?: InputMaybe<UserProductLabelDraftNullableRelationFilter>;
  labelId?: InputMaybe<UuidNullableFilter>;
  layoutId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionNullableRelationFilter>;
  onboardingSampleSessionId?: InputMaybe<UuidNullableFilter>;
  prePaidUnits?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<FloatFilter>;
  pricePrePaid?: InputMaybe<FloatNullableFilter>;
  priceSpecial?: InputMaybe<FloatNullableFilter>;
  productSettings?: InputMaybe<ProductSettingsRelationFilter>;
  productSettingsId?: InputMaybe<StringFilter>;
  sanityProductId?: InputMaybe<StringFilter>;
  shipheroProductId?: InputMaybe<StringNullableFilter>;
  shipheroSampleProductId?: InputMaybe<StringNullableFilter>;
  shopifyId?: InputMaybe<StringNullableFilter>;
  shopifyVariantId?: InputMaybe<StringNullableFilter>;
  shortDescription?: InputMaybe<StringFilter>;
  singleSkuBundleQuantity?: InputMaybe<IntNullableFilter>;
  slug?: InputMaybe<StringFilter>;
  store?: InputMaybe<UserStoreNullableRelationFilter>;
  storeId?: InputMaybe<UuidNullableFilter>;
  supplierId?: InputMaybe<StringNullableFilter>;
  tiktokId?: InputMaybe<StringNullableFilter>;
  tiktokSkuId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  verified?: InputMaybe<BoolFilter>;
  woocommerceId?: InputMaybe<StringNullableFilter>;
};

export type UserProductWhereUniqueInput = {
  AND?: InputMaybe<Array<UserProductWhereInput>>;
  NOT?: InputMaybe<Array<UserProductWhereInput>>;
  OR?: InputMaybe<Array<UserProductWhereInput>>;
  baseId?: InputMaybe<UuidNullableFilter>;
  clickfunnelsId?: InputMaybe<StringNullableFilter>;
  clickfunnelsVariantId?: InputMaybe<StringNullableFilter>;
  coverImage?: InputMaybe<UserProductFileNullableRelationFilter>;
  coverImageId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customSkuId?: InputMaybe<StringNullableFilter>;
  defaultShippingPackage?: InputMaybe<ShippingPackageNullableRelationFilter>;
  defaultShippingPackageId?: InputMaybe<UuidNullableFilter>;
  description?: InputMaybe<StringFilter>;
  eligibilityCheckedAt?: InputMaybe<DateTimeNullableFilter>;
  eligibilityResult?: InputMaybe<JsonNullableFilter>;
  eligibilityScore?: InputMaybe<FloatNullableFilter>;
  files?: InputMaybe<UserProductFileListRelationFilter>;
  generatedSku?: InputMaybe<Scalars['String']['input']>;
  hasInsert?: InputMaybe<BoolFilter>;
  hasUnpushedImageChanges?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  insertImage?: InputMaybe<StringNullableFilter>;
  isOnboardingSampleLabel?: InputMaybe<BoolFilter>;
  isPrelabeled?: InputMaybe<BoolFilter>;
  isPublished?: InputMaybe<BoolFilter>;
  isSingleSkuBundle?: InputMaybe<BoolFilter>;
  isVisible?: InputMaybe<BoolFilter>;
  labelDraft?: InputMaybe<UserProductLabelDraftNullableRelationFilter>;
  labelId?: InputMaybe<UuidNullableFilter>;
  layoutId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  onboardingSampleSession?: InputMaybe<OnboardingSampleOrderSessionNullableRelationFilter>;
  onboardingSampleSessionId?: InputMaybe<Scalars['String']['input']>;
  prePaidUnits?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<FloatFilter>;
  pricePrePaid?: InputMaybe<FloatNullableFilter>;
  priceSpecial?: InputMaybe<FloatNullableFilter>;
  productSettings?: InputMaybe<ProductSettingsRelationFilter>;
  productSettingsId?: InputMaybe<StringFilter>;
  sanityProductId?: InputMaybe<StringFilter>;
  shipheroProductId?: InputMaybe<StringNullableFilter>;
  shipheroSampleProductId?: InputMaybe<StringNullableFilter>;
  shopifyId?: InputMaybe<StringNullableFilter>;
  shopifyVariantId?: InputMaybe<StringNullableFilter>;
  shortDescription?: InputMaybe<StringFilter>;
  singleSkuBundleQuantity?: InputMaybe<IntNullableFilter>;
  slug?: InputMaybe<StringFilter>;
  store?: InputMaybe<UserStoreNullableRelationFilter>;
  storeId?: InputMaybe<UuidNullableFilter>;
  storeId_shopifyId?: InputMaybe<UserProductStoreIdShopifyIdCompoundUniqueInput>;
  storeId_slug?: InputMaybe<UserProductStoreIdSlugCompoundUniqueInput>;
  storeId_woocommerceId?: InputMaybe<UserProductStoreIdWoocommerceIdCompoundUniqueInput>;
  supplierId?: InputMaybe<StringNullableFilter>;
  tiktokId?: InputMaybe<StringNullableFilter>;
  tiktokSkuId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  verified?: InputMaybe<BoolFilter>;
  woocommerceId?: InputMaybe<StringNullableFilter>;
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserStore = {
  __typename?: 'UserStore';
  _count?: Maybe<UserStoreCount>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  external: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isRemoved: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  platform: EcommercePlatform;
  scope: Scalars['String']['output'];
  shopUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type UserStoreClickFunnelsSettingsCreateNestedOneWithoutStoreInput = {
  connect?: InputMaybe<UserStoreClickFunnelsSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserStoreClickFunnelsSettingsCreateOrConnectWithoutStoreInput>;
  create?: InputMaybe<UserStoreClickFunnelsSettingsCreateWithoutStoreInput>;
};

export type UserStoreClickFunnelsSettingsCreateOrConnectWithoutStoreInput = {
  create: UserStoreClickFunnelsSettingsCreateWithoutStoreInput;
  where: UserStoreClickFunnelsSettingsWhereUniqueInput;
};

export type UserStoreClickFunnelsSettingsCreateWithoutStoreInput = {
  accessToken: Scalars['String']['input'];
  createdAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  scope: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
  teamName: Scalars['String']['input'];
  webhookEndpointId?: InputMaybe<Scalars['String']['input']>;
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
  workspaceName: Scalars['String']['input'];
  workspaceUrl: Scalars['String']['input'];
};

export type UserStoreClickFunnelsSettingsNullableRelationFilter = {
  is?: InputMaybe<UserStoreClickFunnelsSettingsWhereInput>;
  isNot?: InputMaybe<UserStoreClickFunnelsSettingsWhereInput>;
};

export type UserStoreClickFunnelsSettingsOrderByWithRelationInput = {
  accessToken?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  store?: InputMaybe<UserStoreOrderByWithRelationInput>;
  storeId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  teamName?: InputMaybe<SortOrder>;
  webhookEndpointId?: InputMaybe<SortOrderInput>;
  webhookSecret?: InputMaybe<SortOrderInput>;
  workspaceId?: InputMaybe<SortOrder>;
  workspaceName?: InputMaybe<SortOrder>;
  workspaceUrl?: InputMaybe<SortOrder>;
};

export type UserStoreClickFunnelsSettingsUpdateOneWithoutStoreNestedInput = {
  connect?: InputMaybe<UserStoreClickFunnelsSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserStoreClickFunnelsSettingsCreateOrConnectWithoutStoreInput>;
  create?: InputMaybe<UserStoreClickFunnelsSettingsCreateWithoutStoreInput>;
  delete?: InputMaybe<UserStoreClickFunnelsSettingsWhereInput>;
  disconnect?: InputMaybe<UserStoreClickFunnelsSettingsWhereInput>;
  update?: InputMaybe<UserStoreClickFunnelsSettingsUpdateToOneWithWhereWithoutStoreInput>;
  upsert?: InputMaybe<UserStoreClickFunnelsSettingsUpsertWithoutStoreInput>;
};

export type UserStoreClickFunnelsSettingsUpdateToOneWithWhereWithoutStoreInput = {
  data: UserStoreClickFunnelsSettingsUpdateWithoutStoreInput;
  where?: InputMaybe<UserStoreClickFunnelsSettingsWhereInput>;
};

export type UserStoreClickFunnelsSettingsUpdateWithoutStoreInput = {
  accessToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<StringFieldUpdateOperationsInput>;
  teamId?: InputMaybe<StringFieldUpdateOperationsInput>;
  teamName?: InputMaybe<StringFieldUpdateOperationsInput>;
  webhookEndpointId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  webhookSecret?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workspaceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  workspaceName?: InputMaybe<StringFieldUpdateOperationsInput>;
  workspaceUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserStoreClickFunnelsSettingsUpsertWithoutStoreInput = {
  create: UserStoreClickFunnelsSettingsCreateWithoutStoreInput;
  update: UserStoreClickFunnelsSettingsUpdateWithoutStoreInput;
  where?: InputMaybe<UserStoreClickFunnelsSettingsWhereInput>;
};

export type UserStoreClickFunnelsSettingsWhereInput = {
  AND?: InputMaybe<Array<UserStoreClickFunnelsSettingsWhereInput>>;
  NOT?: InputMaybe<Array<UserStoreClickFunnelsSettingsWhereInput>>;
  OR?: InputMaybe<Array<UserStoreClickFunnelsSettingsWhereInput>>;
  accessToken?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  scope?: InputMaybe<StringFilter>;
  store?: InputMaybe<UserStoreRelationFilter>;
  storeId?: InputMaybe<UuidFilter>;
  teamId?: InputMaybe<StringFilter>;
  teamName?: InputMaybe<StringFilter>;
  webhookEndpointId?: InputMaybe<StringNullableFilter>;
  webhookSecret?: InputMaybe<StringNullableFilter>;
  workspaceId?: InputMaybe<StringFilter>;
  workspaceName?: InputMaybe<StringFilter>;
  workspaceUrl?: InputMaybe<StringFilter>;
};

export type UserStoreClickFunnelsSettingsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserStoreClickFunnelsSettingsWhereInput>>;
  NOT?: InputMaybe<Array<UserStoreClickFunnelsSettingsWhereInput>>;
  OR?: InputMaybe<Array<UserStoreClickFunnelsSettingsWhereInput>>;
  accessToken?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<StringFilter>;
  store?: InputMaybe<UserStoreRelationFilter>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<StringFilter>;
  teamName?: InputMaybe<StringFilter>;
  webhookEndpointId?: InputMaybe<Scalars['String']['input']>;
  webhookSecret?: InputMaybe<StringNullableFilter>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  workspaceName?: InputMaybe<StringFilter>;
  workspaceUrl?: InputMaybe<StringFilter>;
};

export type UserStoreCount = {
  __typename?: 'UserStoreCount';
  UserSubscription: Scalars['Int']['output'];
  userProductOrders: Scalars['Int']['output'];
  userProducts: Scalars['Int']['output'];
};


export type UserStoreCountUserSubscriptionArgs = {
  where?: InputMaybe<UserSubscriptionWhereInput>;
};


export type UserStoreCountUserProductOrdersArgs = {
  where?: InputMaybe<UserProductOrderWhereInput>;
};


export type UserStoreCountUserProductsArgs = {
  where?: InputMaybe<UserProductWhereInput>;
};

export type UserStoreCreateManyUserInput = {
  accessToken: Scalars['String']['input'];
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: EcommercePlatform;
  scope?: InputMaybe<Scalars['String']['input']>;
  shopUrl: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserStoreCreateManyUserInputEnvelope = {
  data: Array<UserStoreCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserStoreCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserStoreWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserStoreCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserStoreCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserStoreCreateManyUserInputEnvelope>;
};

export type UserStoreCreateNestedOneWithoutUserProductOrdersInput = {
  connect?: InputMaybe<UserStoreWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserStoreCreateOrConnectWithoutUserProductOrdersInput>;
  create?: InputMaybe<UserStoreCreateWithoutUserProductOrdersInput>;
};

export type UserStoreCreateNestedOneWithoutUserProductsInput = {
  connect?: InputMaybe<UserStoreWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserStoreCreateOrConnectWithoutUserProductsInput>;
  create?: InputMaybe<UserStoreCreateWithoutUserProductsInput>;
};

export type UserStoreCreateNestedOneWithoutUserSubscriptionInput = {
  connect?: InputMaybe<UserStoreWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserStoreCreateOrConnectWithoutUserSubscriptionInput>;
  create?: InputMaybe<UserStoreCreateWithoutUserSubscriptionInput>;
};

export type UserStoreCreateOrConnectWithoutUserInput = {
  create: UserStoreCreateWithoutUserInput;
  where: UserStoreWhereUniqueInput;
};

export type UserStoreCreateOrConnectWithoutUserProductOrdersInput = {
  create: UserStoreCreateWithoutUserProductOrdersInput;
  where: UserStoreWhereUniqueInput;
};

export type UserStoreCreateOrConnectWithoutUserProductsInput = {
  create: UserStoreCreateWithoutUserProductsInput;
  where: UserStoreWhereUniqueInput;
};

export type UserStoreCreateOrConnectWithoutUserSubscriptionInput = {
  create: UserStoreCreateWithoutUserSubscriptionInput;
  where: UserStoreWhereUniqueInput;
};

export type UserStoreCreateWithoutUserInput = {
  UserSubscription?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserStoreInput>;
  accessToken: Scalars['String']['input'];
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsCreateNestedOneWithoutStoreInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentService?: InputMaybe<FulfillmentServiceCreateNestedOneWithoutStoreInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: EcommercePlatform;
  scope?: InputMaybe<Scalars['String']['input']>;
  shopUrl: Scalars['String']['input'];
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsCreateNestedOneWithoutStoreInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userProductOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutStoreInput>;
  userProducts?: InputMaybe<UserProductCreateNestedManyWithoutStoreInput>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserStoreCreateWithoutUserProductOrdersInput = {
  UserSubscription?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserStoreInput>;
  accessToken: Scalars['String']['input'];
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsCreateNestedOneWithoutStoreInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentService?: InputMaybe<FulfillmentServiceCreateNestedOneWithoutStoreInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: EcommercePlatform;
  scope?: InputMaybe<Scalars['String']['input']>;
  shopUrl: Scalars['String']['input'];
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsCreateNestedOneWithoutStoreInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutStoresInput;
  userProducts?: InputMaybe<UserProductCreateNestedManyWithoutStoreInput>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserStoreCreateWithoutUserProductsInput = {
  UserSubscription?: InputMaybe<UserSubscriptionCreateNestedManyWithoutUserStoreInput>;
  accessToken: Scalars['String']['input'];
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsCreateNestedOneWithoutStoreInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentService?: InputMaybe<FulfillmentServiceCreateNestedOneWithoutStoreInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: EcommercePlatform;
  scope?: InputMaybe<Scalars['String']['input']>;
  shopUrl: Scalars['String']['input'];
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsCreateNestedOneWithoutStoreInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutStoresInput;
  userProductOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutStoreInput>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserStoreCreateWithoutUserSubscriptionInput = {
  accessToken: Scalars['String']['input'];
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsCreateNestedOneWithoutStoreInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentService?: InputMaybe<FulfillmentServiceCreateNestedOneWithoutStoreInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: EcommercePlatform;
  scope?: InputMaybe<Scalars['String']['input']>;
  shopUrl: Scalars['String']['input'];
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsCreateNestedOneWithoutStoreInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutStoresInput;
  userProductOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutStoreInput>;
  userProducts?: InputMaybe<UserProductCreateNestedManyWithoutStoreInput>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserStoreListRelationFilter = {
  every?: InputMaybe<UserStoreWhereInput>;
  none?: InputMaybe<UserStoreWhereInput>;
  some?: InputMaybe<UserStoreWhereInput>;
};

export type UserStoreModel = {
  __typename?: 'UserStoreModel';
  _count?: Maybe<UserStoreCount>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  external: Scalars['Boolean']['output'];
  fulfillmentService?: Maybe<FulfillmentService>;
  id: Scalars['String']['output'];
  isRemoved: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  platform: EcommercePlatform;
  scope: Scalars['String']['output'];
  shopUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  webhooksInitialised: SuccessResponse;
  zip?: Maybe<Scalars['String']['output']>;
};

export type UserStoreNullableRelationFilter = {
  is?: InputMaybe<UserStoreWhereInput>;
  isNot?: InputMaybe<UserStoreWhereInput>;
};

export type UserStoreOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserStoreOrderByWithRelationInput = {
  UserSubscription?: InputMaybe<UserSubscriptionOrderByRelationAggregateInput>;
  accessToken?: InputMaybe<SortOrder>;
  address1?: InputMaybe<SortOrderInput>;
  address2?: InputMaybe<SortOrderInput>;
  city?: InputMaybe<SortOrderInput>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsOrderByWithRelationInput>;
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  external?: InputMaybe<SortOrder>;
  fulfillmentService?: InputMaybe<FulfillmentServiceOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  isRemoved?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrderInput>;
  platform?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  shopUrl?: InputMaybe<SortOrder>;
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsOrderByWithRelationInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
  userProductOrders?: InputMaybe<UserProductOrderOrderByRelationAggregateInput>;
  userProducts?: InputMaybe<UserProductOrderByRelationAggregateInput>;
  zip?: InputMaybe<SortOrderInput>;
};

export type UserStoreRelationFilter = {
  is?: InputMaybe<UserStoreWhereInput>;
  isNot?: InputMaybe<UserStoreWhereInput>;
};

export type UserStoreScalarWhereInput = {
  AND?: InputMaybe<Array<UserStoreScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserStoreScalarWhereInput>>;
  OR?: InputMaybe<Array<UserStoreScalarWhereInput>>;
  accessToken?: InputMaybe<StringFilter>;
  address1?: InputMaybe<StringNullableFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  external?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  isRemoved?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  platform?: InputMaybe<EnumEcommercePlatformFilter>;
  scope?: InputMaybe<StringFilter>;
  shopUrl?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
  zip?: InputMaybe<StringNullableFilter>;
};

export type UserStoreTikTokSettingsCreateNestedOneWithoutStoreInput = {
  connect?: InputMaybe<UserStoreTikTokSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserStoreTikTokSettingsCreateOrConnectWithoutStoreInput>;
  create?: InputMaybe<UserStoreTikTokSettingsCreateWithoutStoreInput>;
};

export type UserStoreTikTokSettingsCreateOrConnectWithoutStoreInput = {
  create: UserStoreTikTokSettingsCreateWithoutStoreInput;
  where: UserStoreTikTokSettingsWhereUniqueInput;
};

export type UserStoreTikTokSettingsCreateWithoutStoreInput = {
  accessToken: Scalars['String']['input'];
  accessTokenExpiresAt: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  refreshToken: Scalars['String']['input'];
  refreshTokenExpiresAt: Scalars['DateTime']['input'];
  shopCipher: Scalars['String']['input'];
  shopId: Scalars['String']['input'];
};

export type UserStoreTikTokSettingsNullableRelationFilter = {
  is?: InputMaybe<UserStoreTikTokSettingsWhereInput>;
  isNot?: InputMaybe<UserStoreTikTokSettingsWhereInput>;
};

export type UserStoreTikTokSettingsOrderByWithRelationInput = {
  accessToken?: InputMaybe<SortOrder>;
  accessTokenExpiresAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDisabled?: InputMaybe<SortOrder>;
  refreshToken?: InputMaybe<SortOrder>;
  refreshTokenExpiresAt?: InputMaybe<SortOrder>;
  shopCipher?: InputMaybe<SortOrder>;
  shopId?: InputMaybe<SortOrder>;
  store?: InputMaybe<UserStoreOrderByWithRelationInput>;
  storeId?: InputMaybe<SortOrder>;
};

export type UserStoreTikTokSettingsUpdateOneWithoutStoreNestedInput = {
  connect?: InputMaybe<UserStoreTikTokSettingsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserStoreTikTokSettingsCreateOrConnectWithoutStoreInput>;
  create?: InputMaybe<UserStoreTikTokSettingsCreateWithoutStoreInput>;
  delete?: InputMaybe<UserStoreTikTokSettingsWhereInput>;
  disconnect?: InputMaybe<UserStoreTikTokSettingsWhereInput>;
  update?: InputMaybe<UserStoreTikTokSettingsUpdateToOneWithWhereWithoutStoreInput>;
  upsert?: InputMaybe<UserStoreTikTokSettingsUpsertWithoutStoreInput>;
};

export type UserStoreTikTokSettingsUpdateToOneWithWhereWithoutStoreInput = {
  data: UserStoreTikTokSettingsUpdateWithoutStoreInput;
  where?: InputMaybe<UserStoreTikTokSettingsWhereInput>;
};

export type UserStoreTikTokSettingsUpdateWithoutStoreInput = {
  accessToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  accessTokenExpiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  refreshToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  refreshTokenExpiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  shopCipher?: InputMaybe<StringFieldUpdateOperationsInput>;
  shopId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserStoreTikTokSettingsUpsertWithoutStoreInput = {
  create: UserStoreTikTokSettingsCreateWithoutStoreInput;
  update: UserStoreTikTokSettingsUpdateWithoutStoreInput;
  where?: InputMaybe<UserStoreTikTokSettingsWhereInput>;
};

export type UserStoreTikTokSettingsWhereInput = {
  AND?: InputMaybe<Array<UserStoreTikTokSettingsWhereInput>>;
  NOT?: InputMaybe<Array<UserStoreTikTokSettingsWhereInput>>;
  OR?: InputMaybe<Array<UserStoreTikTokSettingsWhereInput>>;
  accessToken?: InputMaybe<StringFilter>;
  accessTokenExpiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  refreshToken?: InputMaybe<StringFilter>;
  refreshTokenExpiresAt?: InputMaybe<DateTimeFilter>;
  shopCipher?: InputMaybe<StringFilter>;
  shopId?: InputMaybe<StringFilter>;
  store?: InputMaybe<UserStoreRelationFilter>;
  storeId?: InputMaybe<UuidFilter>;
};

export type UserStoreTikTokSettingsWhereUniqueInput = {
  AND?: InputMaybe<Array<UserStoreTikTokSettingsWhereInput>>;
  NOT?: InputMaybe<Array<UserStoreTikTokSettingsWhereInput>>;
  OR?: InputMaybe<Array<UserStoreTikTokSettingsWhereInput>>;
  accessToken?: InputMaybe<StringFilter>;
  accessTokenExpiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<BoolFilter>;
  refreshToken?: InputMaybe<StringFilter>;
  refreshTokenExpiresAt?: InputMaybe<DateTimeFilter>;
  shopCipher?: InputMaybe<StringFilter>;
  shopId?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<UserStoreRelationFilter>;
  storeId?: InputMaybe<Scalars['String']['input']>;
};

export type UserStoreUpdateManyMutationInput = {
  accessToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  external?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isRemoved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  platform?: InputMaybe<EnumEcommercePlatformFieldUpdateOperationsInput>;
  scope?: InputMaybe<StringFieldUpdateOperationsInput>;
  shopUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserStoreUpdateManyWithWhereWithoutUserInput = {
  data: UserStoreUpdateManyMutationInput;
  where: UserStoreScalarWhereInput;
};

export type UserStoreUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserStoreWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserStoreCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserStoreCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserStoreCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserStoreWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserStoreScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserStoreWhereUniqueInput>>;
  set?: InputMaybe<Array<UserStoreWhereUniqueInput>>;
  update?: InputMaybe<Array<UserStoreUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserStoreUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserStoreUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserStoreUpdateOneWithoutUserProductOrdersNestedInput = {
  connect?: InputMaybe<UserStoreWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserStoreCreateOrConnectWithoutUserProductOrdersInput>;
  create?: InputMaybe<UserStoreCreateWithoutUserProductOrdersInput>;
  delete?: InputMaybe<UserStoreWhereInput>;
  disconnect?: InputMaybe<UserStoreWhereInput>;
  update?: InputMaybe<UserStoreUpdateToOneWithWhereWithoutUserProductOrdersInput>;
  upsert?: InputMaybe<UserStoreUpsertWithoutUserProductOrdersInput>;
};

export type UserStoreUpdateOneWithoutUserProductsNestedInput = {
  connect?: InputMaybe<UserStoreWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserStoreCreateOrConnectWithoutUserProductsInput>;
  create?: InputMaybe<UserStoreCreateWithoutUserProductsInput>;
  delete?: InputMaybe<UserStoreWhereInput>;
  disconnect?: InputMaybe<UserStoreWhereInput>;
  update?: InputMaybe<UserStoreUpdateToOneWithWhereWithoutUserProductsInput>;
  upsert?: InputMaybe<UserStoreUpsertWithoutUserProductsInput>;
};

export type UserStoreUpdateOneWithoutUserSubscriptionNestedInput = {
  connect?: InputMaybe<UserStoreWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserStoreCreateOrConnectWithoutUserSubscriptionInput>;
  create?: InputMaybe<UserStoreCreateWithoutUserSubscriptionInput>;
  delete?: InputMaybe<UserStoreWhereInput>;
  disconnect?: InputMaybe<UserStoreWhereInput>;
  update?: InputMaybe<UserStoreUpdateToOneWithWhereWithoutUserSubscriptionInput>;
  upsert?: InputMaybe<UserStoreUpsertWithoutUserSubscriptionInput>;
};

export type UserStoreUpdateToOneWithWhereWithoutUserProductOrdersInput = {
  data: UserStoreUpdateWithoutUserProductOrdersInput;
  where?: InputMaybe<UserStoreWhereInput>;
};

export type UserStoreUpdateToOneWithWhereWithoutUserProductsInput = {
  data: UserStoreUpdateWithoutUserProductsInput;
  where?: InputMaybe<UserStoreWhereInput>;
};

export type UserStoreUpdateToOneWithWhereWithoutUserSubscriptionInput = {
  data: UserStoreUpdateWithoutUserSubscriptionInput;
  where?: InputMaybe<UserStoreWhereInput>;
};

export type UserStoreUpdateWithWhereUniqueWithoutUserInput = {
  data: UserStoreUpdateWithoutUserInput;
  where: UserStoreWhereUniqueInput;
};

export type UserStoreUpdateWithoutUserInput = {
  UserSubscription?: InputMaybe<UserSubscriptionUpdateManyWithoutUserStoreNestedInput>;
  accessToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsUpdateOneWithoutStoreNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  external?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fulfillmentService?: InputMaybe<FulfillmentServiceUpdateOneWithoutStoreNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isRemoved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  platform?: InputMaybe<EnumEcommercePlatformFieldUpdateOperationsInput>;
  scope?: InputMaybe<StringFieldUpdateOperationsInput>;
  shopUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsUpdateOneWithoutStoreNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userProductOrders?: InputMaybe<UserProductOrderUpdateManyWithoutStoreNestedInput>;
  userProducts?: InputMaybe<UserProductUpdateManyWithoutStoreNestedInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserStoreUpdateWithoutUserProductOrdersInput = {
  UserSubscription?: InputMaybe<UserSubscriptionUpdateManyWithoutUserStoreNestedInput>;
  accessToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsUpdateOneWithoutStoreNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  external?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fulfillmentService?: InputMaybe<FulfillmentServiceUpdateOneWithoutStoreNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isRemoved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  platform?: InputMaybe<EnumEcommercePlatformFieldUpdateOperationsInput>;
  scope?: InputMaybe<StringFieldUpdateOperationsInput>;
  shopUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsUpdateOneWithoutStoreNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutStoresNestedInput>;
  userProducts?: InputMaybe<UserProductUpdateManyWithoutStoreNestedInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserStoreUpdateWithoutUserProductsInput = {
  UserSubscription?: InputMaybe<UserSubscriptionUpdateManyWithoutUserStoreNestedInput>;
  accessToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsUpdateOneWithoutStoreNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  external?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fulfillmentService?: InputMaybe<FulfillmentServiceUpdateOneWithoutStoreNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isRemoved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  platform?: InputMaybe<EnumEcommercePlatformFieldUpdateOperationsInput>;
  scope?: InputMaybe<StringFieldUpdateOperationsInput>;
  shopUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsUpdateOneWithoutStoreNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutStoresNestedInput>;
  userProductOrders?: InputMaybe<UserProductOrderUpdateManyWithoutStoreNestedInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserStoreUpdateWithoutUserSubscriptionInput = {
  accessToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsUpdateOneWithoutStoreNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  external?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fulfillmentService?: InputMaybe<FulfillmentServiceUpdateOneWithoutStoreNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isRemoved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  platform?: InputMaybe<EnumEcommercePlatformFieldUpdateOperationsInput>;
  scope?: InputMaybe<StringFieldUpdateOperationsInput>;
  shopUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsUpdateOneWithoutStoreNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutStoresNestedInput>;
  userProductOrders?: InputMaybe<UserProductOrderUpdateManyWithoutStoreNestedInput>;
  userProducts?: InputMaybe<UserProductUpdateManyWithoutStoreNestedInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserStoreUpsertWithWhereUniqueWithoutUserInput = {
  create: UserStoreCreateWithoutUserInput;
  update: UserStoreUpdateWithoutUserInput;
  where: UserStoreWhereUniqueInput;
};

export type UserStoreUpsertWithoutUserProductOrdersInput = {
  create: UserStoreCreateWithoutUserProductOrdersInput;
  update: UserStoreUpdateWithoutUserProductOrdersInput;
  where?: InputMaybe<UserStoreWhereInput>;
};

export type UserStoreUpsertWithoutUserProductsInput = {
  create: UserStoreCreateWithoutUserProductsInput;
  update: UserStoreUpdateWithoutUserProductsInput;
  where?: InputMaybe<UserStoreWhereInput>;
};

export type UserStoreUpsertWithoutUserSubscriptionInput = {
  create: UserStoreCreateWithoutUserSubscriptionInput;
  update: UserStoreUpdateWithoutUserSubscriptionInput;
  where?: InputMaybe<UserStoreWhereInput>;
};

export type UserStoreWhereInput = {
  AND?: InputMaybe<Array<UserStoreWhereInput>>;
  NOT?: InputMaybe<Array<UserStoreWhereInput>>;
  OR?: InputMaybe<Array<UserStoreWhereInput>>;
  UserSubscription?: InputMaybe<UserSubscriptionListRelationFilter>;
  accessToken?: InputMaybe<StringFilter>;
  address1?: InputMaybe<StringNullableFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsNullableRelationFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  external?: InputMaybe<BoolFilter>;
  fulfillmentService?: InputMaybe<FulfillmentServiceNullableRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  isRemoved?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  platform?: InputMaybe<EnumEcommercePlatformFilter>;
  scope?: InputMaybe<StringFilter>;
  shopUrl?: InputMaybe<StringFilter>;
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsNullableRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProductOrders?: InputMaybe<UserProductOrderListRelationFilter>;
  userProducts?: InputMaybe<UserProductListRelationFilter>;
  zip?: InputMaybe<StringNullableFilter>;
};

export type UserStoreWhereUniqueInput = {
  AND?: InputMaybe<Array<UserStoreWhereInput>>;
  NOT?: InputMaybe<Array<UserStoreWhereInput>>;
  OR?: InputMaybe<Array<UserStoreWhereInput>>;
  UserSubscription?: InputMaybe<UserSubscriptionListRelationFilter>;
  accessToken?: InputMaybe<StringFilter>;
  address1?: InputMaybe<StringNullableFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  clickFunnelsSettings?: InputMaybe<UserStoreClickFunnelsSettingsNullableRelationFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  external?: InputMaybe<BoolFilter>;
  fulfillmentService?: InputMaybe<FulfillmentServiceNullableRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRemoved?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  platform?: InputMaybe<EnumEcommercePlatformFilter>;
  scope?: InputMaybe<StringFilter>;
  shopUrl?: InputMaybe<Scalars['String']['input']>;
  tikTokSettings?: InputMaybe<UserStoreTikTokSettingsNullableRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userProductOrders?: InputMaybe<UserProductOrderListRelationFilter>;
  userProducts?: InputMaybe<UserProductListRelationFilter>;
  zip?: InputMaybe<StringNullableFilter>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  _count?: Maybe<UserSubscriptionCount>;
  checkoutSessionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Stripe or Shopify subscription id */
  id: Scalars['String']['output'];
  interval: UserSubscriptionBillingInterval;
  paymentProcessor: UserPaymentProcessor;
  status: UserSubscriptionStatus;
  stripePriceId: Scalars['String']['output'];
  stripeProductId: Scalars['String']['output'];
  tier: UserSubscriptionTier;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  /** Shopify subscription only */
  userStoreId?: Maybe<Scalars['String']['output']>;
};

export enum UserSubscriptionBillingInterval {
  Month = 'MONTH',
  Year = 'YEAR'
}

export type UserSubscriptionCount = {
  __typename?: 'UserSubscriptionCount';
  UserSubscriptionEvent: Scalars['Int']['output'];
};


export type UserSubscriptionCountUserSubscriptionEventArgs = {
  where?: InputMaybe<UserSubscriptionEventWhereInput>;
};

export type UserSubscriptionCreateManyUserInput = {
  checkoutSessionId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  interval: UserSubscriptionBillingInterval;
  paymentProcessor: UserPaymentProcessor;
  status: UserSubscriptionStatus;
  stripePriceId: Scalars['String']['input'];
  stripeProductId: Scalars['String']['input'];
  tier: UserSubscriptionTier;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userStoreId?: InputMaybe<Scalars['String']['input']>;
};

export type UserSubscriptionCreateManyUserInputEnvelope = {
  data: Array<UserSubscriptionCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSubscriptionCreateManyUserStoreInput = {
  checkoutSessionId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  interval: UserSubscriptionBillingInterval;
  paymentProcessor: UserPaymentProcessor;
  status: UserSubscriptionStatus;
  stripePriceId: Scalars['String']['input'];
  stripeProductId: Scalars['String']['input'];
  tier: UserSubscriptionTier;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type UserSubscriptionCreateManyUserStoreInputEnvelope = {
  data: Array<UserSubscriptionCreateManyUserStoreInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSubscriptionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscriptionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserSubscriptionCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserSubscriptionCreateManyUserInputEnvelope>;
};

export type UserSubscriptionCreateNestedManyWithoutUserStoreInput = {
  connect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscriptionCreateOrConnectWithoutUserStoreInput>>;
  create?: InputMaybe<Array<UserSubscriptionCreateWithoutUserStoreInput>>;
  createMany?: InputMaybe<UserSubscriptionCreateManyUserStoreInputEnvelope>;
};

export type UserSubscriptionCreateOrConnectWithoutUserInput = {
  create: UserSubscriptionCreateWithoutUserInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionCreateOrConnectWithoutUserStoreInput = {
  create: UserSubscriptionCreateWithoutUserStoreInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionCreateWithoutUserInput = {
  UserSubscriptionEvent?: InputMaybe<UserSubscriptionEventCreateNestedManyWithoutUserSubscriptionInput>;
  checkoutSessionId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  interval: UserSubscriptionBillingInterval;
  paymentProcessor: UserPaymentProcessor;
  status: UserSubscriptionStatus;
  stripePriceId: Scalars['String']['input'];
  stripeProductId: Scalars['String']['input'];
  tier: UserSubscriptionTier;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userStore?: InputMaybe<UserStoreCreateNestedOneWithoutUserSubscriptionInput>;
};

export type UserSubscriptionCreateWithoutUserStoreInput = {
  UserSubscriptionEvent?: InputMaybe<UserSubscriptionEventCreateNestedManyWithoutUserSubscriptionInput>;
  checkoutSessionId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  currentPeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  interval: UserSubscriptionBillingInterval;
  paymentProcessor: UserPaymentProcessor;
  status: UserSubscriptionStatus;
  stripePriceId: Scalars['String']['input'];
  stripeProductId: Scalars['String']['input'];
  tier: UserSubscriptionTier;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserCreateNestedOneWithoutSubscriptionsInput;
};

export type UserSubscriptionEventCreateManyUserSubscriptionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  externalEventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: UserSubscriptionEventType;
};

export type UserSubscriptionEventCreateManyUserSubscriptionInputEnvelope = {
  data: Array<UserSubscriptionEventCreateManyUserSubscriptionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSubscriptionEventCreateNestedManyWithoutUserSubscriptionInput = {
  connect?: InputMaybe<Array<UserSubscriptionEventWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscriptionEventCreateOrConnectWithoutUserSubscriptionInput>>;
  create?: InputMaybe<Array<UserSubscriptionEventCreateWithoutUserSubscriptionInput>>;
  createMany?: InputMaybe<UserSubscriptionEventCreateManyUserSubscriptionInputEnvelope>;
};

export type UserSubscriptionEventCreateOrConnectWithoutUserSubscriptionInput = {
  create: UserSubscriptionEventCreateWithoutUserSubscriptionInput;
  where: UserSubscriptionEventWhereUniqueInput;
};

export type UserSubscriptionEventCreateWithoutUserSubscriptionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  externalEventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: UserSubscriptionEventType;
};

export type UserSubscriptionEventListRelationFilter = {
  every?: InputMaybe<UserSubscriptionEventWhereInput>;
  none?: InputMaybe<UserSubscriptionEventWhereInput>;
  some?: InputMaybe<UserSubscriptionEventWhereInput>;
};

export type UserSubscriptionEventScalarWhereInput = {
  AND?: InputMaybe<Array<UserSubscriptionEventScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserSubscriptionEventScalarWhereInput>>;
  OR?: InputMaybe<Array<UserSubscriptionEventScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  externalEventId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  type?: InputMaybe<EnumUserSubscriptionEventTypeFilter>;
  userSubscriptionId?: InputMaybe<StringFilter>;
};

export enum UserSubscriptionEventType {
  CancelationScheduled = 'CANCELATION_SCHEDULED',
  Created = 'CREATED',
  DiscountMonthStarted = 'DISCOUNT_MONTH_STARTED',
  Ended = 'ENDED',
  FreeTrialStarted = 'FREE_TRIAL_STARTED',
  FullPriceStarted = 'FULL_PRICE_STARTED',
  IntervalChanged = 'INTERVAL_CHANGED',
  Paused = 'PAUSED',
  PlanChanged = 'PLAN_CHANGED',
  Resumed = 'RESUMED'
}

export type UserSubscriptionEventUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  externalEventId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserSubscriptionEventTypeFieldUpdateOperationsInput>;
};

export type UserSubscriptionEventUpdateManyWithWhereWithoutUserSubscriptionInput = {
  data: UserSubscriptionEventUpdateManyMutationInput;
  where: UserSubscriptionEventScalarWhereInput;
};

export type UserSubscriptionEventUpdateManyWithoutUserSubscriptionNestedInput = {
  connect?: InputMaybe<Array<UserSubscriptionEventWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscriptionEventCreateOrConnectWithoutUserSubscriptionInput>>;
  create?: InputMaybe<Array<UserSubscriptionEventCreateWithoutUserSubscriptionInput>>;
  createMany?: InputMaybe<UserSubscriptionEventCreateManyUserSubscriptionInputEnvelope>;
  delete?: InputMaybe<Array<UserSubscriptionEventWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserSubscriptionEventScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserSubscriptionEventWhereUniqueInput>>;
  set?: InputMaybe<Array<UserSubscriptionEventWhereUniqueInput>>;
  update?: InputMaybe<Array<UserSubscriptionEventUpdateWithWhereUniqueWithoutUserSubscriptionInput>>;
  updateMany?: InputMaybe<Array<UserSubscriptionEventUpdateManyWithWhereWithoutUserSubscriptionInput>>;
  upsert?: InputMaybe<Array<UserSubscriptionEventUpsertWithWhereUniqueWithoutUserSubscriptionInput>>;
};

export type UserSubscriptionEventUpdateWithWhereUniqueWithoutUserSubscriptionInput = {
  data: UserSubscriptionEventUpdateWithoutUserSubscriptionInput;
  where: UserSubscriptionEventWhereUniqueInput;
};

export type UserSubscriptionEventUpdateWithoutUserSubscriptionInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  externalEventId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserSubscriptionEventTypeFieldUpdateOperationsInput>;
};

export type UserSubscriptionEventUpsertWithWhereUniqueWithoutUserSubscriptionInput = {
  create: UserSubscriptionEventCreateWithoutUserSubscriptionInput;
  update: UserSubscriptionEventUpdateWithoutUserSubscriptionInput;
  where: UserSubscriptionEventWhereUniqueInput;
};

export type UserSubscriptionEventWhereInput = {
  AND?: InputMaybe<Array<UserSubscriptionEventWhereInput>>;
  NOT?: InputMaybe<Array<UserSubscriptionEventWhereInput>>;
  OR?: InputMaybe<Array<UserSubscriptionEventWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  externalEventId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  type?: InputMaybe<EnumUserSubscriptionEventTypeFilter>;
  userSubscription?: InputMaybe<UserSubscriptionRelationFilter>;
  userSubscriptionId?: InputMaybe<StringFilter>;
};

export type UserSubscriptionEventWhereUniqueInput = {
  AND?: InputMaybe<Array<UserSubscriptionEventWhereInput>>;
  NOT?: InputMaybe<Array<UserSubscriptionEventWhereInput>>;
  OR?: InputMaybe<Array<UserSubscriptionEventWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  externalEventId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserSubscriptionEventTypeFilter>;
  userSubscription?: InputMaybe<UserSubscriptionRelationFilter>;
  userSubscriptionId?: InputMaybe<StringFilter>;
};

export type UserSubscriptionListRelationFilter = {
  every?: InputMaybe<UserSubscriptionWhereInput>;
  none?: InputMaybe<UserSubscriptionWhereInput>;
  some?: InputMaybe<UserSubscriptionWhereInput>;
};

export type UserSubscriptionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserSubscriptionRelationFilter = {
  is?: InputMaybe<UserSubscriptionWhereInput>;
  isNot?: InputMaybe<UserSubscriptionWhereInput>;
};

export type UserSubscriptionScalarWhereInput = {
  AND?: InputMaybe<Array<UserSubscriptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserSubscriptionScalarWhereInput>>;
  OR?: InputMaybe<Array<UserSubscriptionScalarWhereInput>>;
  checkoutSessionId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currentPeriodEnd?: InputMaybe<DateTimeNullableFilter>;
  currentPeriodStart?: InputMaybe<DateTimeNullableFilter>;
  endedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  interval?: InputMaybe<EnumUserSubscriptionBillingIntervalFilter>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFilter>;
  status?: InputMaybe<EnumUserSubscriptionStatusFilter>;
  stripePriceId?: InputMaybe<StringFilter>;
  stripeProductId?: InputMaybe<StringFilter>;
  tier?: InputMaybe<EnumUserSubscriptionTierFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
  userStoreId?: InputMaybe<UuidNullableFilter>;
};

export enum UserSubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Paused = 'PAUSED'
}

export enum UserSubscriptionTier {
  Tier_10 = 'TIER_10',
  Tier_20 = 'TIER_20',
  Tier_30 = 'TIER_30'
}

export type UserSubscriptionUpdateManyMutationInput = {
  checkoutSessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currentPeriodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currentPeriodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interval?: InputMaybe<EnumUserSubscriptionBillingIntervalFieldUpdateOperationsInput>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserSubscriptionStatusFieldUpdateOperationsInput>;
  stripePriceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  stripeProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  tier?: InputMaybe<EnumUserSubscriptionTierFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserSubscriptionUpdateManyWithWhereWithoutUserInput = {
  data: UserSubscriptionUpdateManyMutationInput;
  where: UserSubscriptionScalarWhereInput;
};

export type UserSubscriptionUpdateManyWithWhereWithoutUserStoreInput = {
  data: UserSubscriptionUpdateManyMutationInput;
  where: UserSubscriptionScalarWhereInput;
};

export type UserSubscriptionUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscriptionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserSubscriptionCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserSubscriptionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<UserSubscriptionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserSubscriptionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserSubscriptionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserSubscriptionUpdateManyWithoutUserStoreNestedInput = {
  connect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscriptionCreateOrConnectWithoutUserStoreInput>>;
  create?: InputMaybe<Array<UserSubscriptionCreateWithoutUserStoreInput>>;
  createMany?: InputMaybe<UserSubscriptionCreateManyUserStoreInputEnvelope>;
  delete?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<UserSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<UserSubscriptionUpdateWithWhereUniqueWithoutUserStoreInput>>;
  updateMany?: InputMaybe<Array<UserSubscriptionUpdateManyWithWhereWithoutUserStoreInput>>;
  upsert?: InputMaybe<Array<UserSubscriptionUpsertWithWhereUniqueWithoutUserStoreInput>>;
};

export type UserSubscriptionUpdateWithWhereUniqueWithoutUserInput = {
  data: UserSubscriptionUpdateWithoutUserInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionUpdateWithWhereUniqueWithoutUserStoreInput = {
  data: UserSubscriptionUpdateWithoutUserStoreInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionUpdateWithoutUserInput = {
  UserSubscriptionEvent?: InputMaybe<UserSubscriptionEventUpdateManyWithoutUserSubscriptionNestedInput>;
  checkoutSessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currentPeriodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currentPeriodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interval?: InputMaybe<EnumUserSubscriptionBillingIntervalFieldUpdateOperationsInput>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserSubscriptionStatusFieldUpdateOperationsInput>;
  stripePriceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  stripeProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  tier?: InputMaybe<EnumUserSubscriptionTierFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userStore?: InputMaybe<UserStoreUpdateOneWithoutUserSubscriptionNestedInput>;
};

export type UserSubscriptionUpdateWithoutUserStoreInput = {
  UserSubscriptionEvent?: InputMaybe<UserSubscriptionEventUpdateManyWithoutUserSubscriptionNestedInput>;
  checkoutSessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currentPeriodEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currentPeriodStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interval?: InputMaybe<EnumUserSubscriptionBillingIntervalFieldUpdateOperationsInput>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserSubscriptionStatusFieldUpdateOperationsInput>;
  stripePriceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  stripeProductId?: InputMaybe<StringFieldUpdateOperationsInput>;
  tier?: InputMaybe<EnumUserSubscriptionTierFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutSubscriptionsNestedInput>;
};

export type UserSubscriptionUpsertWithWhereUniqueWithoutUserInput = {
  create: UserSubscriptionCreateWithoutUserInput;
  update: UserSubscriptionUpdateWithoutUserInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionUpsertWithWhereUniqueWithoutUserStoreInput = {
  create: UserSubscriptionCreateWithoutUserStoreInput;
  update: UserSubscriptionUpdateWithoutUserStoreInput;
  where: UserSubscriptionWhereUniqueInput;
};

export type UserSubscriptionWhereInput = {
  AND?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  UserSubscriptionEvent?: InputMaybe<UserSubscriptionEventListRelationFilter>;
  checkoutSessionId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currentPeriodEnd?: InputMaybe<DateTimeNullableFilter>;
  currentPeriodStart?: InputMaybe<DateTimeNullableFilter>;
  endedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  interval?: InputMaybe<EnumUserSubscriptionBillingIntervalFilter>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFilter>;
  status?: InputMaybe<EnumUserSubscriptionStatusFilter>;
  stripePriceId?: InputMaybe<StringFilter>;
  stripeProductId?: InputMaybe<StringFilter>;
  tier?: InputMaybe<EnumUserSubscriptionTierFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userStore?: InputMaybe<UserStoreNullableRelationFilter>;
  userStoreId?: InputMaybe<UuidNullableFilter>;
};

export type UserSubscriptionWhereUniqueInput = {
  AND?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<UserSubscriptionWhereInput>>;
  UserSubscriptionEvent?: InputMaybe<UserSubscriptionEventListRelationFilter>;
  checkoutSessionId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currentPeriodEnd?: InputMaybe<DateTimeNullableFilter>;
  currentPeriodStart?: InputMaybe<DateTimeNullableFilter>;
  endedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<EnumUserSubscriptionBillingIntervalFilter>;
  paymentProcessor?: InputMaybe<EnumUserPaymentProcessorFilter>;
  status?: InputMaybe<EnumUserSubscriptionStatusFilter>;
  stripePriceId?: InputMaybe<StringFilter>;
  stripeProductId?: InputMaybe<StringFilter>;
  tier?: InputMaybe<EnumUserSubscriptionTierFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  userStore?: InputMaybe<UserStoreNullableRelationFilter>;
  userStoreId?: InputMaybe<UuidNullableFilter>;
};

export type UserTransaction = {
  __typename?: 'UserTransaction';
  amountCents: Scalars['Float']['output'];
  balanceAfter?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Admin>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  manualCreditChangeReason?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionMethod: TransactionMethod;
  transactionType: TransactionType;
};

export type UserUpdateOneRequiredWithoutFilesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<UserCreateWithoutFilesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<UserUpsertWithoutFilesInput>;
};

export type UserUpdateOneRequiredWithoutInvoicesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutInvoicesInput>;
  create?: InputMaybe<UserCreateWithoutInvoicesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutInvoicesInput>;
  upsert?: InputMaybe<UserUpsertWithoutInvoicesInput>;
};

export type UserUpdateOneRequiredWithoutOrderLinesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderLinesInput>;
  create?: InputMaybe<UserCreateWithoutOrderLinesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutOrderLinesInput>;
  upsert?: InputMaybe<UserUpsertWithoutOrderLinesInput>;
};

export type UserUpdateOneRequiredWithoutOrdersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<UserCreateWithoutOrdersInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<UserUpsertWithoutOrdersInput>;
};

export type UserUpdateOneRequiredWithoutPostPaymentBucketsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPostPaymentBucketsInput>;
  create?: InputMaybe<UserCreateWithoutPostPaymentBucketsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutPostPaymentBucketsInput>;
  upsert?: InputMaybe<UserUpsertWithoutPostPaymentBucketsInput>;
};

export type UserUpdateOneRequiredWithoutProductsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<UserCreateWithoutProductsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutProductsInput>;
  upsert?: InputMaybe<UserUpsertWithoutProductsInput>;
};

export type UserUpdateOneRequiredWithoutStoresNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutStoresInput>;
  create?: InputMaybe<UserCreateWithoutStoresInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutStoresInput>;
  upsert?: InputMaybe<UserUpsertWithoutStoresInput>;
};

export type UserUpdateOneRequiredWithoutStripeInvoicesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutStripeInvoicesInput>;
  create?: InputMaybe<UserCreateWithoutStripeInvoicesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutStripeInvoicesInput>;
  upsert?: InputMaybe<UserUpsertWithoutStripeInvoicesInput>;
};

export type UserUpdateOneRequiredWithoutSubscriptionsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSubscriptionsInput>;
  create?: InputMaybe<UserCreateWithoutSubscriptionsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutSubscriptionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutSubscriptionsInput>;
};

export type UserUpdateOneRequiredWithoutTransactionsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<UserCreateWithoutTransactionsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutTransactionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutTransactionsInput>;
};

export type UserUpdateOneWithoutServicePurchasesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutServicePurchasesInput>;
  create?: InputMaybe<UserCreateWithoutServicePurchasesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutServicePurchasesInput>;
  upsert?: InputMaybe<UserUpsertWithoutServicePurchasesInput>;
};

export type UserUpdateToOneWithWhereWithoutFilesInput = {
  data: UserUpdateWithoutFilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutInvoicesInput = {
  data: UserUpdateWithoutInvoicesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutOrderLinesInput = {
  data: UserUpdateWithoutOrderLinesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutOrdersInput = {
  data: UserUpdateWithoutOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPostPaymentBucketsInput = {
  data: UserUpdateWithoutPostPaymentBucketsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutProductsInput = {
  data: UserUpdateWithoutProductsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutServicePurchasesInput = {
  data: UserUpdateWithoutServicePurchasesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutStoresInput = {
  data: UserUpdateWithoutStoresInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutStripeInvoicesInput = {
  data: UserUpdateWithoutStripeInvoicesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutSubscriptionsInput = {
  data: UserUpdateWithoutSubscriptionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutTransactionsInput = {
  data: UserUpdateWithoutTransactionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithoutFilesInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutCustomerNestedInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  products?: InputMaybe<UserProductUpdateManyWithoutUserNestedInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchases?: InputMaybe<ServicePurchaseUpdateManyWithoutUserNestedInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stores?: InputMaybe<UserStoreUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserNestedInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  subscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutInvoicesInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserNestedInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  products?: InputMaybe<UserProductUpdateManyWithoutUserNestedInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchases?: InputMaybe<ServicePurchaseUpdateManyWithoutUserNestedInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stores?: InputMaybe<UserStoreUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserNestedInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  subscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutOrderLinesInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserNestedInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutCustomerNestedInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  products?: InputMaybe<UserProductUpdateManyWithoutUserNestedInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchases?: InputMaybe<ServicePurchaseUpdateManyWithoutUserNestedInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stores?: InputMaybe<UserStoreUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserNestedInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  subscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutOrdersInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserNestedInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutCustomerNestedInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  products?: InputMaybe<UserProductUpdateManyWithoutUserNestedInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchases?: InputMaybe<ServicePurchaseUpdateManyWithoutUserNestedInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stores?: InputMaybe<UserStoreUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserNestedInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  subscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutPostPaymentBucketsInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserNestedInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutCustomerNestedInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  products?: InputMaybe<UserProductUpdateManyWithoutUserNestedInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchases?: InputMaybe<ServicePurchaseUpdateManyWithoutUserNestedInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stores?: InputMaybe<UserStoreUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserNestedInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  subscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutProductsInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserNestedInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutCustomerNestedInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchases?: InputMaybe<ServicePurchaseUpdateManyWithoutUserNestedInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stores?: InputMaybe<UserStoreUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserNestedInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  subscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutServicePurchasesInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserNestedInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutCustomerNestedInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  products?: InputMaybe<UserProductUpdateManyWithoutUserNestedInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stores?: InputMaybe<UserStoreUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserNestedInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  subscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutStoresInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserNestedInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutCustomerNestedInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  products?: InputMaybe<UserProductUpdateManyWithoutUserNestedInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchases?: InputMaybe<ServicePurchaseUpdateManyWithoutUserNestedInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserNestedInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  subscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutStripeInvoicesInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserNestedInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutCustomerNestedInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  products?: InputMaybe<UserProductUpdateManyWithoutUserNestedInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchases?: InputMaybe<ServicePurchaseUpdateManyWithoutUserNestedInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stores?: InputMaybe<UserStoreUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  subscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutSubscriptionsInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserNestedInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutCustomerNestedInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  products?: InputMaybe<UserProductUpdateManyWithoutUserNestedInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchases?: InputMaybe<ServicePurchaseUpdateManyWithoutUserNestedInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stores?: InputMaybe<UserStoreUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserNestedInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  transactions?: InputMaybe<UserCreditsTransactionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutTransactionsInput = {
  accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  becameActiveAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateUpdateManyWithoutUserNestedInput>;
  completedOnboardingSteps?: InputMaybe<UserUpdatecompletedOnboardingStepsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deactivationScheduledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  emailVerifiedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  eoriNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  exemptEmailVerified?: InputMaybe<BoolFieldUpdateOperationsInput>;
  exemptaxCustomerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDays?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<NullableEnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  files?: InputMaybe<UserProductFileUpdateManyWithoutUserNestedInput>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstSessionCampaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionCreative?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionDevice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionKeyword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  firstSessionSet?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSource?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionSourceMedium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstSessionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeTrialEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fullName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasCompletedOnboardingStepsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPublishedFirstProduct?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasSeenWelcomeModalAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hubspotContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  intercomId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceEmails?: InputMaybe<UserUpdateinvoiceEmailsInput>;
  invoices?: InputMaybe<UserInvoiceUpdateManyWithoutCustomerNestedInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDeactivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPostPaymentEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelAssets?: InputMaybe<UserLabelAssetUpdateManyWithoutUserNestedInput>;
  labelFonts?: InputMaybe<UserLabelFontUpdateManyWithoutUserNestedInput>;
  labelPalettes?: InputMaybe<UserLabelPaletteUpdateManyWithoutUserNestedInput>;
  lastLogin?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionFbclidUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionFbp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionGclid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionIp?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLandingUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionLiFatId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionRdtCid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastSessionUserAgent?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSessionWbraid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  leadGenerated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  minimumPricingTier?: InputMaybe<IntFieldUpdateOperationsInput>;
  onboardingSurveyDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  onboardingSurveyDoneAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderLines?: InputMaybe<UserProductOrderLineUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<UserProductOrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutUserNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketUpdateManyWithoutCustomerNestedInput>;
  postPaymentDueDateDays?: InputMaybe<IntFieldUpdateOperationsInput>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFieldUpdateOperationsInput>;
  postPaymentPeriodWeeks?: InputMaybe<IntFieldUpdateOperationsInput>;
  preventEmailNotifications?: InputMaybe<UserUpdatepreventEmailNotificationsInput>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFieldUpdateOperationsInput>;
  products?: InputMaybe<UserProductUpdateManyWithoutUserNestedInput>;
  referral?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  regNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFieldUpdateOperationsInput>;
  returnAddress1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnAddress2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnState?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  returnZip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rewardfulId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  servicePurchases?: InputMaybe<ServicePurchaseUpdateManyWithoutUserNestedInput>;
  sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
  smsMarketingConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  socialNetwork?: InputMaybe<NullableEnumSocialNetworkFieldUpdateOperationsInput>;
  socialUsername?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stores?: InputMaybe<UserStoreUpdateManyWithoutUserNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripeInvoices?: InputMaybe<StripeInvoiceUpdateManyWithoutUserNestedInput>;
  stripePostPaymentCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementUpdateManyWithoutUserNestedInput>;
  subscriptions?: InputMaybe<UserSubscriptionUpdateManyWithoutUserNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  useCustomReturnAddress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  userCategory?: InputMaybe<NullableEnumUserCategoryFieldUpdateOperationsInput>;
  userCategoryOther?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
  vip?: InputMaybe<BoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdatecompletedOnboardingStepsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserUpdateinvoiceEmailsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserUpdatepreventEmailNotificationsInput = {
  push?: InputMaybe<Array<NotificationReason>>;
  set?: InputMaybe<Array<NotificationReason>>;
};

export type UserUpsertWithoutFilesInput = {
  create: UserCreateWithoutFilesInput;
  update: UserUpdateWithoutFilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutInvoicesInput = {
  create: UserCreateWithoutInvoicesInput;
  update: UserUpdateWithoutInvoicesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutOrderLinesInput = {
  create: UserCreateWithoutOrderLinesInput;
  update: UserUpdateWithoutOrderLinesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutOrdersInput = {
  create: UserCreateWithoutOrdersInput;
  update: UserUpdateWithoutOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPostPaymentBucketsInput = {
  create: UserCreateWithoutPostPaymentBucketsInput;
  update: UserUpdateWithoutPostPaymentBucketsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutProductsInput = {
  create: UserCreateWithoutProductsInput;
  update: UserUpdateWithoutProductsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutServicePurchasesInput = {
  create: UserCreateWithoutServicePurchasesInput;
  update: UserUpdateWithoutServicePurchasesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutStoresInput = {
  create: UserCreateWithoutStoresInput;
  update: UserUpdateWithoutStoresInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutStripeInvoicesInput = {
  create: UserCreateWithoutStripeInvoicesInput;
  update: UserUpdateWithoutStripeInvoicesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutSubscriptionsInput = {
  create: UserCreateWithoutSubscriptionsInput;
  update: UserUpdateWithoutSubscriptionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutTransactionsInput = {
  create: UserCreateWithoutTransactionsInput;
  update: UserUpdateWithoutTransactionsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  accounts?: InputMaybe<AccountListRelationFilter>;
  avatar?: InputMaybe<StringNullableFilter>;
  becameActiveAt?: InputMaybe<DateTimeNullableFilter>;
  bic?: InputMaybe<StringNullableFilter>;
  billingAddress1?: InputMaybe<StringNullableFilter>;
  billingAddress2?: InputMaybe<StringNullableFilter>;
  billingCity?: InputMaybe<StringNullableFilter>;
  billingCountry?: InputMaybe<StringNullableFilter>;
  billingName?: InputMaybe<StringNullableFilter>;
  billingState?: InputMaybe<StringNullableFilter>;
  billingZip?: InputMaybe<StringNullableFilter>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFilter>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<IntNullableFilter>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeNullableFilter>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateListRelationFilter>;
  completedOnboardingSteps?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deactivatedAt?: InputMaybe<DateTimeNullableFilter>;
  deactivationScheduledAt?: InputMaybe<DateTimeNullableFilter>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFilter>;
  email?: InputMaybe<StringFilter>;
  emailVerified?: InputMaybe<BoolNullableFilter>;
  emailVerifiedAt?: InputMaybe<DateTimeNullableFilter>;
  eoriNumber?: InputMaybe<StringNullableFilter>;
  exemptEmailVerified?: InputMaybe<BoolFilter>;
  exemptaxCustomerId?: InputMaybe<IntNullableFilter>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFilter>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFilter>;
  fbaPostPaymentDueDateDays?: InputMaybe<IntNullableFilter>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeNullableFilter>;
  files?: InputMaybe<UserProductFileListRelationFilter>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFilter>;
  firstSessionCampaign?: InputMaybe<StringNullableFilter>;
  firstSessionCreative?: InputMaybe<StringNullableFilter>;
  firstSessionDevice?: InputMaybe<StringNullableFilter>;
  firstSessionGclid?: InputMaybe<StringNullableFilter>;
  firstSessionKeyword?: InputMaybe<StringNullableFilter>;
  firstSessionMedium?: InputMaybe<StringNullableFilter>;
  firstSessionQueryParams?: InputMaybe<JsonNullableFilter>;
  firstSessionSet?: InputMaybe<StringNullableFilter>;
  firstSessionSource?: InputMaybe<StringNullableFilter>;
  firstSessionSourceMedium?: InputMaybe<StringNullableFilter>;
  firstSessionType?: InputMaybe<StringNullableFilter>;
  firstSessionUrl?: InputMaybe<StringNullableFilter>;
  freeTrialEndsAt?: InputMaybe<DateTimeNullableFilter>;
  fullName?: InputMaybe<StringFilter>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFilter>;
  hasCompletedOnboardingStepsAt?: InputMaybe<DateTimeNullableFilter>;
  hasPublishedFirstProduct?: InputMaybe<BoolFilter>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFilter>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFilter>;
  hasSeenWelcomeModalAt?: InputMaybe<DateTimeNullableFilter>;
  hubspotContactId?: InputMaybe<StringNullableFilter>;
  iban?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  image?: InputMaybe<StringNullableFilter>;
  intercomId?: InputMaybe<StringNullableFilter>;
  invoiceEmails?: InputMaybe<StringNullableListFilter>;
  invoices?: InputMaybe<UserInvoiceListRelationFilter>;
  isActive?: InputMaybe<BoolFilter>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFilter>;
  isDeactivated?: InputMaybe<BoolFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  isPostPaymentEnabled?: InputMaybe<BoolFilter>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFilter>;
  labelAssets?: InputMaybe<UserLabelAssetListRelationFilter>;
  labelFonts?: InputMaybe<UserLabelFontListRelationFilter>;
  labelPalettes?: InputMaybe<UserLabelPaletteListRelationFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  lastSessionFbc?: InputMaybe<StringNullableFilter>;
  lastSessionFbclid?: InputMaybe<StringNullableFilter>;
  lastSessionFbclidUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  lastSessionFbp?: InputMaybe<StringNullableFilter>;
  lastSessionGbraid?: InputMaybe<StringNullableFilter>;
  lastSessionGclid?: InputMaybe<StringNullableFilter>;
  lastSessionIp?: InputMaybe<StringNullableFilter>;
  lastSessionLandingUrl?: InputMaybe<StringNullableFilter>;
  lastSessionLiFatId?: InputMaybe<StringNullableFilter>;
  lastSessionRdtCid?: InputMaybe<StringNullableFilter>;
  lastSessionUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  lastSessionUserAgent?: InputMaybe<StringNullableFilter>;
  lastSessionWbraid?: InputMaybe<StringNullableFilter>;
  leadGenerated?: InputMaybe<BoolNullableFilter>;
  minimumPricingTier?: InputMaybe<IntFilter>;
  onboardingSurveyDone?: InputMaybe<BoolFilter>;
  onboardingSurveyDoneAt?: InputMaybe<DateTimeNullableFilter>;
  orderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  orders?: InputMaybe<UserProductOrderListRelationFilter>;
  password?: InputMaybe<StringNullableFilter>;
  paymentMethods?: InputMaybe<PaymentMethodListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketListRelationFilter>;
  postPaymentDueDateDays?: InputMaybe<IntFilter>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFilter>;
  postPaymentPeriodWeeks?: InputMaybe<IntFilter>;
  preventEmailNotifications?: InputMaybe<EnumNotificationReasonNullableListFilter>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<BoolNullableFilter>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFilter>;
  products?: InputMaybe<UserProductListRelationFilter>;
  referral?: InputMaybe<StringNullableFilter>;
  regNumber?: InputMaybe<StringNullableFilter>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFilter>;
  returnAddress1?: InputMaybe<StringNullableFilter>;
  returnAddress2?: InputMaybe<StringNullableFilter>;
  returnCity?: InputMaybe<StringNullableFilter>;
  returnCompany?: InputMaybe<StringNullableFilter>;
  returnCountry?: InputMaybe<StringNullableFilter>;
  returnPhone?: InputMaybe<StringNullableFilter>;
  returnState?: InputMaybe<StringNullableFilter>;
  returnZip?: InputMaybe<StringNullableFilter>;
  rewardfulId?: InputMaybe<StringNullableFilter>;
  servicePurchases?: InputMaybe<ServicePurchaseListRelationFilter>;
  sessions?: InputMaybe<SessionListRelationFilter>;
  smsMarketingConsent?: InputMaybe<BoolFilter>;
  socialNetwork?: InputMaybe<EnumSocialNetworkNullableFilter>;
  socialUsername?: InputMaybe<StringNullableFilter>;
  stores?: InputMaybe<UserStoreListRelationFilter>;
  stripeCustomerId?: InputMaybe<StringNullableFilter>;
  stripeInvoices?: InputMaybe<StripeInvoiceListRelationFilter>;
  stripePostPaymentCustomerId?: InputMaybe<StringNullableFilter>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementListRelationFilter>;
  subscriptions?: InputMaybe<UserSubscriptionListRelationFilter>;
  transactions?: InputMaybe<UserCreditsTransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  useCustomReturnAddress?: InputMaybe<BoolFilter>;
  userCategory?: InputMaybe<EnumUserCategoryNullableFilter>;
  userCategoryOther?: InputMaybe<StringNullableFilter>;
  username?: InputMaybe<StringFilter>;
  vip?: InputMaybe<BoolFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  accounts?: InputMaybe<AccountListRelationFilter>;
  avatar?: InputMaybe<StringNullableFilter>;
  becameActiveAt?: InputMaybe<DateTimeNullableFilter>;
  bic?: InputMaybe<StringNullableFilter>;
  billingAddress1?: InputMaybe<StringNullableFilter>;
  billingAddress2?: InputMaybe<StringNullableFilter>;
  billingCity?: InputMaybe<StringNullableFilter>;
  billingCountry?: InputMaybe<StringNullableFilter>;
  billingName?: InputMaybe<StringNullableFilter>;
  billingState?: InputMaybe<StringNullableFilter>;
  billingZip?: InputMaybe<StringNullableFilter>;
  bulkOrderPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFilter>;
  bulkOrderPostPaymentDueDateDays?: InputMaybe<IntNullableFilter>;
  bulkOrderPostPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeNullableFilter>;
  certificates?: InputMaybe<ExemptaxCustomerCertificateListRelationFilter>;
  completedOnboardingSteps?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deactivatedAt?: InputMaybe<DateTimeNullableFilter>;
  deactivationScheduledAt?: InputMaybe<DateTimeNullableFilter>;
  defaultPaymentProcessor?: InputMaybe<EnumUserPaymentProcessorFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<BoolNullableFilter>;
  emailVerifiedAt?: InputMaybe<DateTimeNullableFilter>;
  eoriNumber?: InputMaybe<StringNullableFilter>;
  exemptEmailVerified?: InputMaybe<BoolFilter>;
  exemptaxCustomerId?: InputMaybe<Scalars['Int']['input']>;
  extendedFreeTrialGrantedOnInit?: InputMaybe<BoolFilter>;
  fbaPaymentKind?: InputMaybe<EnumUserProductOrderManualPaymentKindFilter>;
  fbaPostPaymentDueDateDays?: InputMaybe<IntNullableFilter>;
  fbaPostPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeNullableFilter>;
  files?: InputMaybe<UserProductFileListRelationFilter>;
  firstMonthDiscountAvailable?: InputMaybe<BoolFilter>;
  firstSessionCampaign?: InputMaybe<StringNullableFilter>;
  firstSessionCreative?: InputMaybe<StringNullableFilter>;
  firstSessionDevice?: InputMaybe<StringNullableFilter>;
  firstSessionGclid?: InputMaybe<StringNullableFilter>;
  firstSessionKeyword?: InputMaybe<StringNullableFilter>;
  firstSessionMedium?: InputMaybe<StringNullableFilter>;
  firstSessionQueryParams?: InputMaybe<JsonNullableFilter>;
  firstSessionSet?: InputMaybe<StringNullableFilter>;
  firstSessionSource?: InputMaybe<StringNullableFilter>;
  firstSessionSourceMedium?: InputMaybe<StringNullableFilter>;
  firstSessionType?: InputMaybe<StringNullableFilter>;
  firstSessionUrl?: InputMaybe<StringNullableFilter>;
  freeTrialEndsAt?: InputMaybe<DateTimeNullableFilter>;
  fullName?: InputMaybe<StringFilter>;
  hasCompletedOnboardingSteps?: InputMaybe<BoolFilter>;
  hasCompletedOnboardingStepsAt?: InputMaybe<DateTimeNullableFilter>;
  hasPublishedFirstProduct?: InputMaybe<BoolFilter>;
  hasSeenFreeTrialEndedModal?: InputMaybe<BoolFilter>;
  hasSeenFreeTrialStartedModal?: InputMaybe<BoolFilter>;
  hasSeenWelcomeModalAt?: InputMaybe<DateTimeNullableFilter>;
  hubspotContactId?: InputMaybe<StringNullableFilter>;
  iban?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringNullableFilter>;
  intercomId?: InputMaybe<StringNullableFilter>;
  invoiceEmails?: InputMaybe<StringNullableListFilter>;
  invoices?: InputMaybe<UserInvoiceListRelationFilter>;
  isActive?: InputMaybe<BoolFilter>;
  isBrandAcceleratorParticipant?: InputMaybe<BoolFilter>;
  isDeactivated?: InputMaybe<BoolFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  isPostPaymentEnabled?: InputMaybe<BoolFilter>;
  isPriorityLaneFulfillment?: InputMaybe<BoolFilter>;
  labelAssets?: InputMaybe<UserLabelAssetListRelationFilter>;
  labelFonts?: InputMaybe<UserLabelFontListRelationFilter>;
  labelPalettes?: InputMaybe<UserLabelPaletteListRelationFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  lastSessionFbc?: InputMaybe<StringNullableFilter>;
  lastSessionFbclid?: InputMaybe<StringNullableFilter>;
  lastSessionFbclidUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  lastSessionFbp?: InputMaybe<StringNullableFilter>;
  lastSessionGbraid?: InputMaybe<StringNullableFilter>;
  lastSessionGclid?: InputMaybe<StringNullableFilter>;
  lastSessionIp?: InputMaybe<StringNullableFilter>;
  lastSessionLandingUrl?: InputMaybe<StringNullableFilter>;
  lastSessionLiFatId?: InputMaybe<StringNullableFilter>;
  lastSessionRdtCid?: InputMaybe<StringNullableFilter>;
  lastSessionUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  lastSessionUserAgent?: InputMaybe<StringNullableFilter>;
  lastSessionWbraid?: InputMaybe<StringNullableFilter>;
  leadGenerated?: InputMaybe<BoolNullableFilter>;
  minimumPricingTier?: InputMaybe<IntFilter>;
  onboardingSurveyDone?: InputMaybe<BoolFilter>;
  onboardingSurveyDoneAt?: InputMaybe<DateTimeNullableFilter>;
  orderLines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  orders?: InputMaybe<UserProductOrderListRelationFilter>;
  password?: InputMaybe<StringNullableFilter>;
  paymentMethods?: InputMaybe<PaymentMethodListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  postPaymentBuckets?: InputMaybe<PostPaymentOrdersBucketListRelationFilter>;
  postPaymentDueDateDays?: InputMaybe<IntFilter>;
  postPaymentDueDateDaysType?: InputMaybe<EnumUserPostPaymentDueDateDaysTypeFilter>;
  postPaymentPeriodWeeks?: InputMaybe<IntFilter>;
  preventEmailNotifications?: InputMaybe<EnumNotificationReasonNullableListFilter>;
  preventShopifyUpdateOnPrintfileChange?: InputMaybe<BoolNullableFilter>;
  primaryPaymentSuplifulCredits?: InputMaybe<BoolFilter>;
  products?: InputMaybe<UserProductListRelationFilter>;
  referral?: InputMaybe<StringNullableFilter>;
  regNumber?: InputMaybe<StringNullableFilter>;
  resetShopifyStockOnSellout?: InputMaybe<BoolFilter>;
  returnAddress1?: InputMaybe<StringNullableFilter>;
  returnAddress2?: InputMaybe<StringNullableFilter>;
  returnCity?: InputMaybe<StringNullableFilter>;
  returnCompany?: InputMaybe<StringNullableFilter>;
  returnCountry?: InputMaybe<StringNullableFilter>;
  returnPhone?: InputMaybe<StringNullableFilter>;
  returnState?: InputMaybe<StringNullableFilter>;
  returnZip?: InputMaybe<StringNullableFilter>;
  rewardfulId?: InputMaybe<StringNullableFilter>;
  servicePurchases?: InputMaybe<ServicePurchaseListRelationFilter>;
  sessions?: InputMaybe<SessionListRelationFilter>;
  smsMarketingConsent?: InputMaybe<BoolFilter>;
  socialNetwork?: InputMaybe<EnumSocialNetworkNullableFilter>;
  socialUsername?: InputMaybe<StringNullableFilter>;
  stores?: InputMaybe<UserStoreListRelationFilter>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeInvoices?: InputMaybe<StripeInvoiceListRelationFilter>;
  stripePostPaymentCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePostPaymentStatements?: InputMaybe<StripePostPaymentStatementListRelationFilter>;
  subscriptions?: InputMaybe<UserSubscriptionListRelationFilter>;
  transactions?: InputMaybe<UserCreditsTransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  useCustomReturnAddress?: InputMaybe<BoolFilter>;
  userCategory?: InputMaybe<EnumUserCategoryNullableFilter>;
  userCategoryOther?: InputMaybe<StringNullableFilter>;
  username?: InputMaybe<Scalars['String']['input']>;
  vip?: InputMaybe<BoolFilter>;
  website?: InputMaybe<StringNullableFilter>;
};

export type UuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  _count?: Maybe<WarehouseCount>;
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  canShipExpress: Scalars['Boolean']['output'];
  canShipInternationally: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  codeName?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  defaultCarrierId?: Maybe<Scalars['String']['output']>;
  defaultExpressCarrierId?: Maybe<Scalars['String']['output']>;
  defaultInternationalCarrierId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  /**
   * Flips to true when this warehouse is delegated to ShipHero. Once set, the transition is one-way:
   * ShipHero owns stock + allocation for this warehouse and the OMS routes its lines through the
   * SHIPHERO-UNALLOCATED dummy warehouse until ShipHero's allocation webhook resolves them.
   */
  isShipHeroManaged: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
  warehouseName: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type WarehouseCount = {
  __typename?: 'WarehouseCount';
  admins: Scalars['Int']['output'];
  bulkShippings: Scalars['Int']['output'];
  carriers: Scalars['Int']['output'];
  labelRoll: Scalars['Int']['output'];
  lines: Scalars['Int']['output'];
  productStock: Scalars['Int']['output'];
  shelves: Scalars['Int']['output'];
};


export type WarehouseCountAdminsArgs = {
  where?: InputMaybe<AdminWhereInput>;
};


export type WarehouseCountBulkShippingsArgs = {
  where?: InputMaybe<BulkShippingWhereInput>;
};


export type WarehouseCountCarriersArgs = {
  where?: InputMaybe<CarrierWhereInput>;
};


export type WarehouseCountLabelRollArgs = {
  where?: InputMaybe<LabelRollWhereInput>;
};


export type WarehouseCountLinesArgs = {
  where?: InputMaybe<UserProductOrderLineWhereInput>;
};


export type WarehouseCountProductStockArgs = {
  where?: InputMaybe<ProductStockWhereInput>;
};


export type WarehouseCountShelvesArgs = {
  where?: InputMaybe<WarehouseShelfWhereInput>;
};

export type WarehouseCreateManyDefaultCarrierInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultExpressCarrierId?: InputMaybe<Scalars['String']['input']>;
  defaultInternationalCarrierId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateManyDefaultCarrierInputEnvelope = {
  data: Array<WarehouseCreateManyDefaultCarrierInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WarehouseCreateManyDefaultExpressCarrierInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrierId?: InputMaybe<Scalars['String']['input']>;
  defaultInternationalCarrierId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateManyDefaultExpressCarrierInputEnvelope = {
  data: Array<WarehouseCreateManyDefaultExpressCarrierInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WarehouseCreateManyDefaultInternationalCarrierInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrierId?: InputMaybe<Scalars['String']['input']>;
  defaultExpressCarrierId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateManyDefaultInternationalCarrierInputEnvelope = {
  data: Array<WarehouseCreateManyDefaultInternationalCarrierInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WarehouseCreateNestedManyWithoutDefaultCarrierInput = {
  connect?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseCreateOrConnectWithoutDefaultCarrierInput>>;
  create?: InputMaybe<Array<WarehouseCreateWithoutDefaultCarrierInput>>;
  createMany?: InputMaybe<WarehouseCreateManyDefaultCarrierInputEnvelope>;
};

export type WarehouseCreateNestedManyWithoutDefaultExpressCarrierInput = {
  connect?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseCreateOrConnectWithoutDefaultExpressCarrierInput>>;
  create?: InputMaybe<Array<WarehouseCreateWithoutDefaultExpressCarrierInput>>;
  createMany?: InputMaybe<WarehouseCreateManyDefaultExpressCarrierInputEnvelope>;
};

export type WarehouseCreateNestedManyWithoutDefaultInternationalCarrierInput = {
  connect?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseCreateOrConnectWithoutDefaultInternationalCarrierInput>>;
  create?: InputMaybe<Array<WarehouseCreateWithoutDefaultInternationalCarrierInput>>;
  createMany?: InputMaybe<WarehouseCreateManyDefaultInternationalCarrierInputEnvelope>;
};

export type WarehouseCreateNestedOneWithoutAdminsInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutAdminsInput>;
  create?: InputMaybe<WarehouseCreateWithoutAdminsInput>;
};

export type WarehouseCreateNestedOneWithoutBulkShippingsInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutBulkShippingsInput>;
  create?: InputMaybe<WarehouseCreateWithoutBulkShippingsInput>;
};

export type WarehouseCreateNestedOneWithoutCarriersInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutCarriersInput>;
  create?: InputMaybe<WarehouseCreateWithoutCarriersInput>;
};

export type WarehouseCreateNestedOneWithoutLabelRollInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutLabelRollInput>;
  create?: InputMaybe<WarehouseCreateWithoutLabelRollInput>;
};

export type WarehouseCreateNestedOneWithoutLinesInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<WarehouseCreateWithoutLinesInput>;
};

export type WarehouseCreateNestedOneWithoutProductStockInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutProductStockInput>;
  create?: InputMaybe<WarehouseCreateWithoutProductStockInput>;
};

export type WarehouseCreateNestedOneWithoutShelvesInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutShelvesInput>;
  create?: InputMaybe<WarehouseCreateWithoutShelvesInput>;
};

export type WarehouseCreateOrConnectWithoutAdminsInput = {
  create: WarehouseCreateWithoutAdminsInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseCreateOrConnectWithoutBulkShippingsInput = {
  create: WarehouseCreateWithoutBulkShippingsInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseCreateOrConnectWithoutCarriersInput = {
  create: WarehouseCreateWithoutCarriersInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseCreateOrConnectWithoutDefaultCarrierInput = {
  create: WarehouseCreateWithoutDefaultCarrierInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseCreateOrConnectWithoutDefaultExpressCarrierInput = {
  create: WarehouseCreateWithoutDefaultExpressCarrierInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseCreateOrConnectWithoutDefaultInternationalCarrierInput = {
  create: WarehouseCreateWithoutDefaultInternationalCarrierInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseCreateOrConnectWithoutLabelRollInput = {
  create: WarehouseCreateWithoutLabelRollInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseCreateOrConnectWithoutLinesInput = {
  create: WarehouseCreateWithoutLinesInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseCreateOrConnectWithoutProductStockInput = {
  create: WarehouseCreateWithoutProductStockInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseCreateOrConnectWithoutShelvesInput = {
  create: WarehouseCreateWithoutShelvesInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseCreateWithoutAdminsInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutWarehouseInput>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutWarehouseInput>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultCarrierForWarehousesInput>;
  defaultExpressCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultExpressCarrierForWarehousesInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultInternationalCarrierForWarehousesInput>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutWarehouseInput>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutWarehouseInput>;
  phone: Scalars['String']['input'];
  productStock?: InputMaybe<ProductStockCreateNestedManyWithoutWarehouseInput>;
  shelves?: InputMaybe<WarehouseShelfCreateNestedManyWithoutWarehouseInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateWithoutBulkShippingsInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  admins?: InputMaybe<AdminCreateNestedManyWithoutWarehouseInput>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutWarehouseInput>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultCarrierForWarehousesInput>;
  defaultExpressCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultExpressCarrierForWarehousesInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultInternationalCarrierForWarehousesInput>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutWarehouseInput>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutWarehouseInput>;
  phone: Scalars['String']['input'];
  productStock?: InputMaybe<ProductStockCreateNestedManyWithoutWarehouseInput>;
  shelves?: InputMaybe<WarehouseShelfCreateNestedManyWithoutWarehouseInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateWithoutCarriersInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  admins?: InputMaybe<AdminCreateNestedManyWithoutWarehouseInput>;
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutWarehouseInput>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultCarrierForWarehousesInput>;
  defaultExpressCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultExpressCarrierForWarehousesInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultInternationalCarrierForWarehousesInput>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutWarehouseInput>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutWarehouseInput>;
  phone: Scalars['String']['input'];
  productStock?: InputMaybe<ProductStockCreateNestedManyWithoutWarehouseInput>;
  shelves?: InputMaybe<WarehouseShelfCreateNestedManyWithoutWarehouseInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateWithoutDefaultCarrierInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  admins?: InputMaybe<AdminCreateNestedManyWithoutWarehouseInput>;
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutWarehouseInput>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutWarehouseInput>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultExpressCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultExpressCarrierForWarehousesInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultInternationalCarrierForWarehousesInput>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutWarehouseInput>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutWarehouseInput>;
  phone: Scalars['String']['input'];
  productStock?: InputMaybe<ProductStockCreateNestedManyWithoutWarehouseInput>;
  shelves?: InputMaybe<WarehouseShelfCreateNestedManyWithoutWarehouseInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateWithoutDefaultExpressCarrierInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  admins?: InputMaybe<AdminCreateNestedManyWithoutWarehouseInput>;
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutWarehouseInput>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutWarehouseInput>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultCarrierForWarehousesInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultInternationalCarrierForWarehousesInput>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutWarehouseInput>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutWarehouseInput>;
  phone: Scalars['String']['input'];
  productStock?: InputMaybe<ProductStockCreateNestedManyWithoutWarehouseInput>;
  shelves?: InputMaybe<WarehouseShelfCreateNestedManyWithoutWarehouseInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateWithoutDefaultInternationalCarrierInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  admins?: InputMaybe<AdminCreateNestedManyWithoutWarehouseInput>;
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutWarehouseInput>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutWarehouseInput>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultCarrierForWarehousesInput>;
  defaultExpressCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultExpressCarrierForWarehousesInput>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutWarehouseInput>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutWarehouseInput>;
  phone: Scalars['String']['input'];
  productStock?: InputMaybe<ProductStockCreateNestedManyWithoutWarehouseInput>;
  shelves?: InputMaybe<WarehouseShelfCreateNestedManyWithoutWarehouseInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateWithoutLabelRollInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  admins?: InputMaybe<AdminCreateNestedManyWithoutWarehouseInput>;
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutWarehouseInput>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutWarehouseInput>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultCarrierForWarehousesInput>;
  defaultExpressCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultExpressCarrierForWarehousesInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultInternationalCarrierForWarehousesInput>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutWarehouseInput>;
  phone: Scalars['String']['input'];
  productStock?: InputMaybe<ProductStockCreateNestedManyWithoutWarehouseInput>;
  shelves?: InputMaybe<WarehouseShelfCreateNestedManyWithoutWarehouseInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateWithoutLinesInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  admins?: InputMaybe<AdminCreateNestedManyWithoutWarehouseInput>;
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutWarehouseInput>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutWarehouseInput>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultCarrierForWarehousesInput>;
  defaultExpressCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultExpressCarrierForWarehousesInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultInternationalCarrierForWarehousesInput>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutWarehouseInput>;
  phone: Scalars['String']['input'];
  productStock?: InputMaybe<ProductStockCreateNestedManyWithoutWarehouseInput>;
  shelves?: InputMaybe<WarehouseShelfCreateNestedManyWithoutWarehouseInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateWithoutProductStockInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  admins?: InputMaybe<AdminCreateNestedManyWithoutWarehouseInput>;
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutWarehouseInput>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutWarehouseInput>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultCarrierForWarehousesInput>;
  defaultExpressCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultExpressCarrierForWarehousesInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultInternationalCarrierForWarehousesInput>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutWarehouseInput>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutWarehouseInput>;
  phone: Scalars['String']['input'];
  shelves?: InputMaybe<WarehouseShelfCreateNestedManyWithoutWarehouseInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseCreateWithoutShelvesInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  admins?: InputMaybe<AdminCreateNestedManyWithoutWarehouseInput>;
  bulkShippings?: InputMaybe<BulkShippingCreateNestedManyWithoutWarehouseInput>;
  canShipExpress?: InputMaybe<Scalars['Boolean']['input']>;
  canShipInternationally?: InputMaybe<Scalars['Boolean']['input']>;
  carriers?: InputMaybe<CarrierCreateNestedManyWithoutWarehouseInput>;
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  defaultCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultCarrierForWarehousesInput>;
  defaultExpressCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultExpressCarrierForWarehousesInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierCreateNestedOneWithoutDefaultInternationalCarrierForWarehousesInput>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShipHeroManaged?: InputMaybe<Scalars['Boolean']['input']>;
  labelRoll?: InputMaybe<LabelRollCreateNestedManyWithoutWarehouseInput>;
  lines?: InputMaybe<UserProductOrderLineCreateNestedManyWithoutWarehouseInput>;
  phone: Scalars['String']['input'];
  productStock?: InputMaybe<ProductStockCreateNestedManyWithoutWarehouseInput>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type WarehouseListRelationFilter = {
  every?: InputMaybe<WarehouseWhereInput>;
  none?: InputMaybe<WarehouseWhereInput>;
  some?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseNullableRelationFilter = {
  is?: InputMaybe<WarehouseWhereInput>;
  isNot?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WarehouseOrderByWithRelationInput = {
  address1?: InputMaybe<SortOrder>;
  address2?: InputMaybe<SortOrderInput>;
  admins?: InputMaybe<AdminOrderByRelationAggregateInput>;
  bulkShippings?: InputMaybe<BulkShippingOrderByRelationAggregateInput>;
  canShipExpress?: InputMaybe<SortOrder>;
  canShipInternationally?: InputMaybe<SortOrder>;
  carriers?: InputMaybe<CarrierOrderByRelationAggregateInput>;
  city?: InputMaybe<SortOrder>;
  companyName?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  defaultCarrier?: InputMaybe<CarrierOrderByWithRelationInput>;
  defaultCarrierId?: InputMaybe<SortOrderInput>;
  defaultExpressCarrier?: InputMaybe<CarrierOrderByWithRelationInput>;
  defaultExpressCarrierId?: InputMaybe<SortOrderInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierOrderByWithRelationInput>;
  defaultInternationalCarrierId?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDisabled?: InputMaybe<SortOrder>;
  isShipHeroManaged?: InputMaybe<SortOrder>;
  labelRoll?: InputMaybe<LabelRollOrderByRelationAggregateInput>;
  lines?: InputMaybe<UserProductOrderLineOrderByRelationAggregateInput>;
  phone?: InputMaybe<SortOrder>;
  productStock?: InputMaybe<ProductStockOrderByRelationAggregateInput>;
  shelves?: InputMaybe<WarehouseShelfOrderByRelationAggregateInput>;
  stateCode?: InputMaybe<SortOrderInput>;
  timezone?: InputMaybe<SortOrder>;
  warehouseName?: InputMaybe<SortOrder>;
  zip?: InputMaybe<SortOrder>;
};

export type WarehouseRelationFilter = {
  is?: InputMaybe<WarehouseWhereInput>;
  isNot?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseScalarWhereInput = {
  AND?: InputMaybe<Array<WarehouseScalarWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseScalarWhereInput>>;
  OR?: InputMaybe<Array<WarehouseScalarWhereInput>>;
  address1?: InputMaybe<StringFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  canShipExpress?: InputMaybe<BoolFilter>;
  canShipInternationally?: InputMaybe<BoolFilter>;
  city?: InputMaybe<StringFilter>;
  companyName?: InputMaybe<StringFilter>;
  countryCode?: InputMaybe<StringFilter>;
  defaultCarrierId?: InputMaybe<UuidNullableFilter>;
  defaultExpressCarrierId?: InputMaybe<UuidNullableFilter>;
  defaultInternationalCarrierId?: InputMaybe<UuidNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  isShipHeroManaged?: InputMaybe<BoolFilter>;
  phone?: InputMaybe<StringFilter>;
  stateCode?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringFilter>;
  warehouseName?: InputMaybe<StringFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type WarehouseShelf = {
  __typename?: 'WarehouseShelf';
  _count?: Maybe<WarehouseShelfCount>;
  bins: Array<WarehouseShelfBin>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  returnBins: Array<WarehouseShelfReturnBin>;
  type: WarehouseShelfType;
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['String']['output'];
};

export type WarehouseShelfBin = {
  __typename?: 'WarehouseShelfBin';
  details: WarehouseShelfBinDetailsModel;
  id: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  userProductOrderId?: Maybe<Scalars['String']['output']>;
  warehouseShelfId: Scalars['String']['output'];
};

export type WarehouseShelfBinCreateManyUserProductOrderInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['Int']['input'];
  warehouseShelfId: Scalars['String']['input'];
};

export type WarehouseShelfBinCreateManyUserProductOrderInputEnvelope = {
  data: Array<WarehouseShelfBinCreateManyUserProductOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WarehouseShelfBinCreateNestedManyWithoutUserProductOrderInput = {
  connect?: InputMaybe<Array<WarehouseShelfBinWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseShelfBinCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<WarehouseShelfBinCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<WarehouseShelfBinCreateManyUserProductOrderInputEnvelope>;
};

export type WarehouseShelfBinCreateOrConnectWithoutUserProductOrderInput = {
  create: WarehouseShelfBinCreateWithoutUserProductOrderInput;
  where: WarehouseShelfBinWhereUniqueInput;
};

export type WarehouseShelfBinCreateWithoutUserProductOrderInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['Int']['input'];
  warehouseShelf: WarehouseShelfCreateNestedOneWithoutBinsInput;
};

export type WarehouseShelfBinDetailsModel = {
  __typename?: 'WarehouseShelfBinDetailsModel';
  isOnHold: Scalars['Boolean']['output'];
  isPriority: Scalars['Boolean']['output'];
  isReady: Scalars['Boolean']['output'];
  itemsCount?: Maybe<Scalars['Float']['output']>;
  preparedItemsCount?: Maybe<Scalars['Float']['output']>;
};

export type WarehouseShelfBinListRelationFilter = {
  every?: InputMaybe<WarehouseShelfBinWhereInput>;
  none?: InputMaybe<WarehouseShelfBinWhereInput>;
  some?: InputMaybe<WarehouseShelfBinWhereInput>;
};

export type WarehouseShelfBinOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WarehouseShelfBinOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  userProductOrder?: InputMaybe<UserProductOrderOrderByWithRelationInput>;
  userProductOrderId?: InputMaybe<SortOrderInput>;
  warehouseShelf?: InputMaybe<WarehouseShelfOrderByWithRelationInput>;
  warehouseShelfId?: InputMaybe<SortOrder>;
};

export enum WarehouseShelfBinScalarFieldEnum {
  Id = 'id',
  Number = 'number',
  UserProductOrderId = 'userProductOrderId',
  WarehouseShelfId = 'warehouseShelfId'
}

export type WarehouseShelfBinScalarWhereInput = {
  AND?: InputMaybe<Array<WarehouseShelfBinScalarWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseShelfBinScalarWhereInput>>;
  OR?: InputMaybe<Array<WarehouseShelfBinScalarWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  number?: InputMaybe<IntFilter>;
  userProductOrderId?: InputMaybe<UuidNullableFilter>;
  warehouseShelfId?: InputMaybe<UuidFilter>;
};

export type WarehouseShelfBinUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WarehouseShelfBinUpdateManyWithWhereWithoutUserProductOrderInput = {
  data: WarehouseShelfBinUpdateManyMutationInput;
  where: WarehouseShelfBinScalarWhereInput;
};

export type WarehouseShelfBinUpdateManyWithoutUserProductOrderNestedInput = {
  connect?: InputMaybe<Array<WarehouseShelfBinWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseShelfBinCreateOrConnectWithoutUserProductOrderInput>>;
  create?: InputMaybe<Array<WarehouseShelfBinCreateWithoutUserProductOrderInput>>;
  createMany?: InputMaybe<WarehouseShelfBinCreateManyUserProductOrderInputEnvelope>;
  delete?: InputMaybe<Array<WarehouseShelfBinWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WarehouseShelfBinScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WarehouseShelfBinWhereUniqueInput>>;
  set?: InputMaybe<Array<WarehouseShelfBinWhereUniqueInput>>;
  update?: InputMaybe<Array<WarehouseShelfBinUpdateWithWhereUniqueWithoutUserProductOrderInput>>;
  updateMany?: InputMaybe<Array<WarehouseShelfBinUpdateManyWithWhereWithoutUserProductOrderInput>>;
  upsert?: InputMaybe<Array<WarehouseShelfBinUpsertWithWhereUniqueWithoutUserProductOrderInput>>;
};

export type WarehouseShelfBinUpdateWithWhereUniqueWithoutUserProductOrderInput = {
  data: WarehouseShelfBinUpdateWithoutUserProductOrderInput;
  where: WarehouseShelfBinWhereUniqueInput;
};

export type WarehouseShelfBinUpdateWithoutUserProductOrderInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<IntFieldUpdateOperationsInput>;
  warehouseShelf?: InputMaybe<WarehouseShelfUpdateOneRequiredWithoutBinsNestedInput>;
};

export type WarehouseShelfBinUpsertWithWhereUniqueWithoutUserProductOrderInput = {
  create: WarehouseShelfBinCreateWithoutUserProductOrderInput;
  update: WarehouseShelfBinUpdateWithoutUserProductOrderInput;
  where: WarehouseShelfBinWhereUniqueInput;
};

export type WarehouseShelfBinWarehouseShelfIdUserProductOrderIdCompoundUniqueInput = {
  userProductOrderId: Scalars['String']['input'];
  warehouseShelfId: Scalars['String']['input'];
};

export type WarehouseShelfBinWhereInput = {
  AND?: InputMaybe<Array<WarehouseShelfBinWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseShelfBinWhereInput>>;
  OR?: InputMaybe<Array<WarehouseShelfBinWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  number?: InputMaybe<IntFilter>;
  userProductOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  userProductOrderId?: InputMaybe<UuidNullableFilter>;
  warehouseShelf?: InputMaybe<WarehouseShelfRelationFilter>;
  warehouseShelfId?: InputMaybe<UuidFilter>;
};

export type WarehouseShelfBinWhereUniqueInput = {
  AND?: InputMaybe<Array<WarehouseShelfBinWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseShelfBinWhereInput>>;
  OR?: InputMaybe<Array<WarehouseShelfBinWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<IntFilter>;
  userProductOrder?: InputMaybe<UserProductOrderNullableRelationFilter>;
  userProductOrderId?: InputMaybe<UuidNullableFilter>;
  warehouseShelf?: InputMaybe<WarehouseShelfRelationFilter>;
  warehouseShelfId?: InputMaybe<UuidFilter>;
  warehouseShelfId_userProductOrderId?: InputMaybe<WarehouseShelfBinWarehouseShelfIdUserProductOrderIdCompoundUniqueInput>;
};

export type WarehouseShelfCount = {
  __typename?: 'WarehouseShelfCount';
  bins: Scalars['Int']['output'];
  returnBins: Scalars['Int']['output'];
};


export type WarehouseShelfCountBinsArgs = {
  where?: InputMaybe<WarehouseShelfBinWhereInput>;
};


export type WarehouseShelfCountReturnBinsArgs = {
  where?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
};

export type WarehouseShelfCreateManyWarehouseInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<WarehouseShelfType>;
};

export type WarehouseShelfCreateManyWarehouseInputEnvelope = {
  data: Array<WarehouseShelfCreateManyWarehouseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WarehouseShelfCreateNestedManyWithoutWarehouseInput = {
  connect?: InputMaybe<Array<WarehouseShelfWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseShelfCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<WarehouseShelfCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<WarehouseShelfCreateManyWarehouseInputEnvelope>;
};

export type WarehouseShelfCreateNestedOneWithoutBinsInput = {
  connect?: InputMaybe<WarehouseShelfWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseShelfCreateOrConnectWithoutBinsInput>;
  create?: InputMaybe<WarehouseShelfCreateWithoutBinsInput>;
};

export type WarehouseShelfCreateNestedOneWithoutReturnBinsInput = {
  connect?: InputMaybe<WarehouseShelfWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseShelfCreateOrConnectWithoutReturnBinsInput>;
  create?: InputMaybe<WarehouseShelfCreateWithoutReturnBinsInput>;
};

export type WarehouseShelfCreateOrConnectWithoutBinsInput = {
  create: WarehouseShelfCreateWithoutBinsInput;
  where: WarehouseShelfWhereUniqueInput;
};

export type WarehouseShelfCreateOrConnectWithoutReturnBinsInput = {
  create: WarehouseShelfCreateWithoutReturnBinsInput;
  where: WarehouseShelfWhereUniqueInput;
};

export type WarehouseShelfCreateOrConnectWithoutWarehouseInput = {
  create: WarehouseShelfCreateWithoutWarehouseInput;
  where: WarehouseShelfWhereUniqueInput;
};

export type WarehouseShelfCreateWithoutBinsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  returnBins?: InputMaybe<WarehouseShelfReturnBinCreateNestedManyWithoutWarehouseShelfInput>;
  type?: InputMaybe<WarehouseShelfType>;
  warehouse: WarehouseCreateNestedOneWithoutShelvesInput;
};

export type WarehouseShelfCreateWithoutReturnBinsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<WarehouseShelfType>;
  warehouse: WarehouseCreateNestedOneWithoutShelvesInput;
};

export type WarehouseShelfCreateWithoutWarehouseInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  returnBins?: InputMaybe<WarehouseShelfReturnBinCreateNestedManyWithoutWarehouseShelfInput>;
  type?: InputMaybe<WarehouseShelfType>;
};

export type WarehouseShelfListRelationFilter = {
  every?: InputMaybe<WarehouseShelfWhereInput>;
  none?: InputMaybe<WarehouseShelfWhereInput>;
  some?: InputMaybe<WarehouseShelfWhereInput>;
};

export type WarehouseShelfOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WarehouseShelfOrderByWithRelationInput = {
  bins?: InputMaybe<WarehouseShelfBinOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  returnBins?: InputMaybe<WarehouseShelfReturnBinOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  warehouse?: InputMaybe<WarehouseOrderByWithRelationInput>;
  warehouseId?: InputMaybe<SortOrder>;
};

export type WarehouseShelfRelationFilter = {
  is?: InputMaybe<WarehouseShelfWhereInput>;
  isNot?: InputMaybe<WarehouseShelfWhereInput>;
};

export type WarehouseShelfReturnBin = {
  __typename?: 'WarehouseShelfReturnBin';
  _count?: Maybe<WarehouseShelfReturnBinCount>;
  id: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  warehouseShelfId: Scalars['String']['output'];
};

export type WarehouseShelfReturnBinCount = {
  __typename?: 'WarehouseShelfReturnBinCount';
  userProductOrders: Scalars['Int']['output'];
};


export type WarehouseShelfReturnBinCountUserProductOrdersArgs = {
  where?: InputMaybe<UserProductOrderWhereInput>;
};

export type WarehouseShelfReturnBinCreateManyWarehouseShelfInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['Int']['input'];
};

export type WarehouseShelfReturnBinCreateManyWarehouseShelfInputEnvelope = {
  data: Array<WarehouseShelfReturnBinCreateManyWarehouseShelfInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WarehouseShelfReturnBinCreateNestedManyWithoutWarehouseShelfInput = {
  connect?: InputMaybe<Array<WarehouseShelfReturnBinWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseShelfReturnBinCreateOrConnectWithoutWarehouseShelfInput>>;
  create?: InputMaybe<Array<WarehouseShelfReturnBinCreateWithoutWarehouseShelfInput>>;
  createMany?: InputMaybe<WarehouseShelfReturnBinCreateManyWarehouseShelfInputEnvelope>;
};

export type WarehouseShelfReturnBinCreateNestedOneWithoutUserProductOrdersInput = {
  connect?: InputMaybe<WarehouseShelfReturnBinWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseShelfReturnBinCreateOrConnectWithoutUserProductOrdersInput>;
  create?: InputMaybe<WarehouseShelfReturnBinCreateWithoutUserProductOrdersInput>;
};

export type WarehouseShelfReturnBinCreateOrConnectWithoutUserProductOrdersInput = {
  create: WarehouseShelfReturnBinCreateWithoutUserProductOrdersInput;
  where: WarehouseShelfReturnBinWhereUniqueInput;
};

export type WarehouseShelfReturnBinCreateOrConnectWithoutWarehouseShelfInput = {
  create: WarehouseShelfReturnBinCreateWithoutWarehouseShelfInput;
  where: WarehouseShelfReturnBinWhereUniqueInput;
};

export type WarehouseShelfReturnBinCreateWithoutUserProductOrdersInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['Int']['input'];
  warehouseShelf: WarehouseShelfCreateNestedOneWithoutReturnBinsInput;
};

export type WarehouseShelfReturnBinCreateWithoutWarehouseShelfInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['Int']['input'];
  userProductOrders?: InputMaybe<UserProductOrderCreateNestedManyWithoutWarehouseShelfReturnBinInput>;
};

export type WarehouseShelfReturnBinListRelationFilter = {
  every?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
  none?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
  some?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
};

export type WarehouseShelfReturnBinNullableRelationFilter = {
  is?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
  isNot?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
};

export type WarehouseShelfReturnBinOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WarehouseShelfReturnBinOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  userProductOrders?: InputMaybe<UserProductOrderOrderByRelationAggregateInput>;
  warehouseShelf?: InputMaybe<WarehouseShelfOrderByWithRelationInput>;
  warehouseShelfId?: InputMaybe<SortOrder>;
};

export type WarehouseShelfReturnBinScalarWhereInput = {
  AND?: InputMaybe<Array<WarehouseShelfReturnBinScalarWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseShelfReturnBinScalarWhereInput>>;
  OR?: InputMaybe<Array<WarehouseShelfReturnBinScalarWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  number?: InputMaybe<IntFilter>;
  warehouseShelfId?: InputMaybe<UuidFilter>;
};

export type WarehouseShelfReturnBinUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<IntFieldUpdateOperationsInput>;
  userProductOrders?: InputMaybe<UserProductOrderUpdateManyWithoutWarehouseShelfReturnBinNestedInput>;
  warehouseShelf?: InputMaybe<WarehouseShelfUpdateOneRequiredWithoutReturnBinsNestedInput>;
};

export type WarehouseShelfReturnBinUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WarehouseShelfReturnBinUpdateManyWithWhereWithoutWarehouseShelfInput = {
  data: WarehouseShelfReturnBinUpdateManyMutationInput;
  where: WarehouseShelfReturnBinScalarWhereInput;
};

export type WarehouseShelfReturnBinUpdateManyWithoutWarehouseShelfNestedInput = {
  connect?: InputMaybe<Array<WarehouseShelfReturnBinWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseShelfReturnBinCreateOrConnectWithoutWarehouseShelfInput>>;
  create?: InputMaybe<Array<WarehouseShelfReturnBinCreateWithoutWarehouseShelfInput>>;
  createMany?: InputMaybe<WarehouseShelfReturnBinCreateManyWarehouseShelfInputEnvelope>;
  delete?: InputMaybe<Array<WarehouseShelfReturnBinWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WarehouseShelfReturnBinScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WarehouseShelfReturnBinWhereUniqueInput>>;
  set?: InputMaybe<Array<WarehouseShelfReturnBinWhereUniqueInput>>;
  update?: InputMaybe<Array<WarehouseShelfReturnBinUpdateWithWhereUniqueWithoutWarehouseShelfInput>>;
  updateMany?: InputMaybe<Array<WarehouseShelfReturnBinUpdateManyWithWhereWithoutWarehouseShelfInput>>;
  upsert?: InputMaybe<Array<WarehouseShelfReturnBinUpsertWithWhereUniqueWithoutWarehouseShelfInput>>;
};

export type WarehouseShelfReturnBinUpdateOneWithoutUserProductOrdersNestedInput = {
  connect?: InputMaybe<WarehouseShelfReturnBinWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseShelfReturnBinCreateOrConnectWithoutUserProductOrdersInput>;
  create?: InputMaybe<WarehouseShelfReturnBinCreateWithoutUserProductOrdersInput>;
  delete?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
  disconnect?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
  update?: InputMaybe<WarehouseShelfReturnBinUpdateToOneWithWhereWithoutUserProductOrdersInput>;
  upsert?: InputMaybe<WarehouseShelfReturnBinUpsertWithoutUserProductOrdersInput>;
};

export type WarehouseShelfReturnBinUpdateToOneWithWhereWithoutUserProductOrdersInput = {
  data: WarehouseShelfReturnBinUpdateWithoutUserProductOrdersInput;
  where?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
};

export type WarehouseShelfReturnBinUpdateWithWhereUniqueWithoutWarehouseShelfInput = {
  data: WarehouseShelfReturnBinUpdateWithoutWarehouseShelfInput;
  where: WarehouseShelfReturnBinWhereUniqueInput;
};

export type WarehouseShelfReturnBinUpdateWithoutUserProductOrdersInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<IntFieldUpdateOperationsInput>;
  warehouseShelf?: InputMaybe<WarehouseShelfUpdateOneRequiredWithoutReturnBinsNestedInput>;
};

export type WarehouseShelfReturnBinUpdateWithoutWarehouseShelfInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<IntFieldUpdateOperationsInput>;
  userProductOrders?: InputMaybe<UserProductOrderUpdateManyWithoutWarehouseShelfReturnBinNestedInput>;
};

export type WarehouseShelfReturnBinUpsertWithWhereUniqueWithoutWarehouseShelfInput = {
  create: WarehouseShelfReturnBinCreateWithoutWarehouseShelfInput;
  update: WarehouseShelfReturnBinUpdateWithoutWarehouseShelfInput;
  where: WarehouseShelfReturnBinWhereUniqueInput;
};

export type WarehouseShelfReturnBinUpsertWithoutUserProductOrdersInput = {
  create: WarehouseShelfReturnBinCreateWithoutUserProductOrdersInput;
  update: WarehouseShelfReturnBinUpdateWithoutUserProductOrdersInput;
  where?: InputMaybe<WarehouseShelfReturnBinWhereInput>;
};

export type WarehouseShelfReturnBinWhereInput = {
  AND?: InputMaybe<Array<WarehouseShelfReturnBinWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseShelfReturnBinWhereInput>>;
  OR?: InputMaybe<Array<WarehouseShelfReturnBinWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  number?: InputMaybe<IntFilter>;
  userProductOrders?: InputMaybe<UserProductOrderListRelationFilter>;
  warehouseShelf?: InputMaybe<WarehouseShelfRelationFilter>;
  warehouseShelfId?: InputMaybe<UuidFilter>;
};

export type WarehouseShelfReturnBinWhereUniqueInput = {
  AND?: InputMaybe<Array<WarehouseShelfReturnBinWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseShelfReturnBinWhereInput>>;
  OR?: InputMaybe<Array<WarehouseShelfReturnBinWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<IntFilter>;
  userProductOrders?: InputMaybe<UserProductOrderListRelationFilter>;
  warehouseShelf?: InputMaybe<WarehouseShelfRelationFilter>;
  warehouseShelfId?: InputMaybe<UuidFilter>;
};

export enum WarehouseShelfScalarFieldEnum {
  Id = 'id',
  Name = 'name',
  Type = 'type',
  WarehouseId = 'warehouseId'
}

export type WarehouseShelfScalarWhereInput = {
  AND?: InputMaybe<Array<WarehouseShelfScalarWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseShelfScalarWhereInput>>;
  OR?: InputMaybe<Array<WarehouseShelfScalarWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumWarehouseShelfTypeFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export enum WarehouseShelfType {
  Return = 'RETURN',
  Sorting = 'SORTING'
}

export type WarehouseShelfUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWarehouseShelfTypeFieldUpdateOperationsInput>;
};

export type WarehouseShelfUpdateManyWithWhereWithoutWarehouseInput = {
  data: WarehouseShelfUpdateManyMutationInput;
  where: WarehouseShelfScalarWhereInput;
};

export type WarehouseShelfUpdateManyWithoutWarehouseNestedInput = {
  connect?: InputMaybe<Array<WarehouseShelfWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseShelfCreateOrConnectWithoutWarehouseInput>>;
  create?: InputMaybe<Array<WarehouseShelfCreateWithoutWarehouseInput>>;
  createMany?: InputMaybe<WarehouseShelfCreateManyWarehouseInputEnvelope>;
  delete?: InputMaybe<Array<WarehouseShelfWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WarehouseShelfScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WarehouseShelfWhereUniqueInput>>;
  set?: InputMaybe<Array<WarehouseShelfWhereUniqueInput>>;
  update?: InputMaybe<Array<WarehouseShelfUpdateWithWhereUniqueWithoutWarehouseInput>>;
  updateMany?: InputMaybe<Array<WarehouseShelfUpdateManyWithWhereWithoutWarehouseInput>>;
  upsert?: InputMaybe<Array<WarehouseShelfUpsertWithWhereUniqueWithoutWarehouseInput>>;
};

export type WarehouseShelfUpdateOneRequiredWithoutBinsNestedInput = {
  connect?: InputMaybe<WarehouseShelfWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseShelfCreateOrConnectWithoutBinsInput>;
  create?: InputMaybe<WarehouseShelfCreateWithoutBinsInput>;
  update?: InputMaybe<WarehouseShelfUpdateToOneWithWhereWithoutBinsInput>;
  upsert?: InputMaybe<WarehouseShelfUpsertWithoutBinsInput>;
};

export type WarehouseShelfUpdateOneRequiredWithoutReturnBinsNestedInput = {
  connect?: InputMaybe<WarehouseShelfWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseShelfCreateOrConnectWithoutReturnBinsInput>;
  create?: InputMaybe<WarehouseShelfCreateWithoutReturnBinsInput>;
  update?: InputMaybe<WarehouseShelfUpdateToOneWithWhereWithoutReturnBinsInput>;
  upsert?: InputMaybe<WarehouseShelfUpsertWithoutReturnBinsInput>;
};

export type WarehouseShelfUpdateToOneWithWhereWithoutBinsInput = {
  data: WarehouseShelfUpdateWithoutBinsInput;
  where?: InputMaybe<WarehouseShelfWhereInput>;
};

export type WarehouseShelfUpdateToOneWithWhereWithoutReturnBinsInput = {
  data: WarehouseShelfUpdateWithoutReturnBinsInput;
  where?: InputMaybe<WarehouseShelfWhereInput>;
};

export type WarehouseShelfUpdateWithWhereUniqueWithoutWarehouseInput = {
  data: WarehouseShelfUpdateWithoutWarehouseInput;
  where: WarehouseShelfWhereUniqueInput;
};

export type WarehouseShelfUpdateWithoutBinsInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  returnBins?: InputMaybe<WarehouseShelfReturnBinUpdateManyWithoutWarehouseShelfNestedInput>;
  type?: InputMaybe<EnumWarehouseShelfTypeFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutShelvesNestedInput>;
};

export type WarehouseShelfUpdateWithoutReturnBinsInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWarehouseShelfTypeFieldUpdateOperationsInput>;
  warehouse?: InputMaybe<WarehouseUpdateOneRequiredWithoutShelvesNestedInput>;
};

export type WarehouseShelfUpdateWithoutWarehouseInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  returnBins?: InputMaybe<WarehouseShelfReturnBinUpdateManyWithoutWarehouseShelfNestedInput>;
  type?: InputMaybe<EnumWarehouseShelfTypeFieldUpdateOperationsInput>;
};

export type WarehouseShelfUpsertWithWhereUniqueWithoutWarehouseInput = {
  create: WarehouseShelfCreateWithoutWarehouseInput;
  update: WarehouseShelfUpdateWithoutWarehouseInput;
  where: WarehouseShelfWhereUniqueInput;
};

export type WarehouseShelfUpsertWithoutBinsInput = {
  create: WarehouseShelfCreateWithoutBinsInput;
  update: WarehouseShelfUpdateWithoutBinsInput;
  where?: InputMaybe<WarehouseShelfWhereInput>;
};

export type WarehouseShelfUpsertWithoutReturnBinsInput = {
  create: WarehouseShelfCreateWithoutReturnBinsInput;
  update: WarehouseShelfUpdateWithoutReturnBinsInput;
  where?: InputMaybe<WarehouseShelfWhereInput>;
};

export type WarehouseShelfWhereInput = {
  AND?: InputMaybe<Array<WarehouseShelfWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseShelfWhereInput>>;
  OR?: InputMaybe<Array<WarehouseShelfWhereInput>>;
  bins?: InputMaybe<WarehouseShelfBinListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  returnBins?: InputMaybe<WarehouseShelfReturnBinListRelationFilter>;
  type?: InputMaybe<EnumWarehouseShelfTypeFilter>;
  warehouse?: InputMaybe<WarehouseRelationFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type WarehouseShelfWhereUniqueInput = {
  AND?: InputMaybe<Array<WarehouseShelfWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseShelfWhereInput>>;
  OR?: InputMaybe<Array<WarehouseShelfWhereInput>>;
  bins?: InputMaybe<WarehouseShelfBinListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  returnBins?: InputMaybe<WarehouseShelfReturnBinListRelationFilter>;
  type?: InputMaybe<EnumWarehouseShelfTypeFilter>;
  warehouse?: InputMaybe<WarehouseRelationFilter>;
  warehouseId?: InputMaybe<UuidFilter>;
};

export type WarehouseUpdateManyMutationInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpdateManyWithWhereWithoutDefaultCarrierInput = {
  data: WarehouseUpdateManyMutationInput;
  where: WarehouseScalarWhereInput;
};

export type WarehouseUpdateManyWithWhereWithoutDefaultExpressCarrierInput = {
  data: WarehouseUpdateManyMutationInput;
  where: WarehouseScalarWhereInput;
};

export type WarehouseUpdateManyWithWhereWithoutDefaultInternationalCarrierInput = {
  data: WarehouseUpdateManyMutationInput;
  where: WarehouseScalarWhereInput;
};

export type WarehouseUpdateManyWithoutDefaultCarrierNestedInput = {
  connect?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseCreateOrConnectWithoutDefaultCarrierInput>>;
  create?: InputMaybe<Array<WarehouseCreateWithoutDefaultCarrierInput>>;
  createMany?: InputMaybe<WarehouseCreateManyDefaultCarrierInputEnvelope>;
  delete?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WarehouseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  set?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  update?: InputMaybe<Array<WarehouseUpdateWithWhereUniqueWithoutDefaultCarrierInput>>;
  updateMany?: InputMaybe<Array<WarehouseUpdateManyWithWhereWithoutDefaultCarrierInput>>;
  upsert?: InputMaybe<Array<WarehouseUpsertWithWhereUniqueWithoutDefaultCarrierInput>>;
};

export type WarehouseUpdateManyWithoutDefaultExpressCarrierNestedInput = {
  connect?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseCreateOrConnectWithoutDefaultExpressCarrierInput>>;
  create?: InputMaybe<Array<WarehouseCreateWithoutDefaultExpressCarrierInput>>;
  createMany?: InputMaybe<WarehouseCreateManyDefaultExpressCarrierInputEnvelope>;
  delete?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WarehouseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  set?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  update?: InputMaybe<Array<WarehouseUpdateWithWhereUniqueWithoutDefaultExpressCarrierInput>>;
  updateMany?: InputMaybe<Array<WarehouseUpdateManyWithWhereWithoutDefaultExpressCarrierInput>>;
  upsert?: InputMaybe<Array<WarehouseUpsertWithWhereUniqueWithoutDefaultExpressCarrierInput>>;
};

export type WarehouseUpdateManyWithoutDefaultInternationalCarrierNestedInput = {
  connect?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WarehouseCreateOrConnectWithoutDefaultInternationalCarrierInput>>;
  create?: InputMaybe<Array<WarehouseCreateWithoutDefaultInternationalCarrierInput>>;
  createMany?: InputMaybe<WarehouseCreateManyDefaultInternationalCarrierInputEnvelope>;
  delete?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WarehouseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  set?: InputMaybe<Array<WarehouseWhereUniqueInput>>;
  update?: InputMaybe<Array<WarehouseUpdateWithWhereUniqueWithoutDefaultInternationalCarrierInput>>;
  updateMany?: InputMaybe<Array<WarehouseUpdateManyWithWhereWithoutDefaultInternationalCarrierInput>>;
  upsert?: InputMaybe<Array<WarehouseUpsertWithWhereUniqueWithoutDefaultInternationalCarrierInput>>;
};

export type WarehouseUpdateOneRequiredWithoutBulkShippingsNestedInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutBulkShippingsInput>;
  create?: InputMaybe<WarehouseCreateWithoutBulkShippingsInput>;
  update?: InputMaybe<WarehouseUpdateToOneWithWhereWithoutBulkShippingsInput>;
  upsert?: InputMaybe<WarehouseUpsertWithoutBulkShippingsInput>;
};

export type WarehouseUpdateOneRequiredWithoutCarriersNestedInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutCarriersInput>;
  create?: InputMaybe<WarehouseCreateWithoutCarriersInput>;
  update?: InputMaybe<WarehouseUpdateToOneWithWhereWithoutCarriersInput>;
  upsert?: InputMaybe<WarehouseUpsertWithoutCarriersInput>;
};

export type WarehouseUpdateOneRequiredWithoutLabelRollNestedInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutLabelRollInput>;
  create?: InputMaybe<WarehouseCreateWithoutLabelRollInput>;
  update?: InputMaybe<WarehouseUpdateToOneWithWhereWithoutLabelRollInput>;
  upsert?: InputMaybe<WarehouseUpsertWithoutLabelRollInput>;
};

export type WarehouseUpdateOneRequiredWithoutProductStockNestedInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutProductStockInput>;
  create?: InputMaybe<WarehouseCreateWithoutProductStockInput>;
  update?: InputMaybe<WarehouseUpdateToOneWithWhereWithoutProductStockInput>;
  upsert?: InputMaybe<WarehouseUpsertWithoutProductStockInput>;
};

export type WarehouseUpdateOneRequiredWithoutShelvesNestedInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutShelvesInput>;
  create?: InputMaybe<WarehouseCreateWithoutShelvesInput>;
  update?: InputMaybe<WarehouseUpdateToOneWithWhereWithoutShelvesInput>;
  upsert?: InputMaybe<WarehouseUpsertWithoutShelvesInput>;
};

export type WarehouseUpdateOneWithoutAdminsNestedInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutAdminsInput>;
  create?: InputMaybe<WarehouseCreateWithoutAdminsInput>;
  delete?: InputMaybe<WarehouseWhereInput>;
  disconnect?: InputMaybe<WarehouseWhereInput>;
  update?: InputMaybe<WarehouseUpdateToOneWithWhereWithoutAdminsInput>;
  upsert?: InputMaybe<WarehouseUpsertWithoutAdminsInput>;
};

export type WarehouseUpdateOneWithoutLinesNestedInput = {
  connect?: InputMaybe<WarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WarehouseCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<WarehouseCreateWithoutLinesInput>;
  delete?: InputMaybe<WarehouseWhereInput>;
  disconnect?: InputMaybe<WarehouseWhereInput>;
  update?: InputMaybe<WarehouseUpdateToOneWithWhereWithoutLinesInput>;
  upsert?: InputMaybe<WarehouseUpsertWithoutLinesInput>;
};

export type WarehouseUpdateToOneWithWhereWithoutAdminsInput = {
  data: WarehouseUpdateWithoutAdminsInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpdateToOneWithWhereWithoutBulkShippingsInput = {
  data: WarehouseUpdateWithoutBulkShippingsInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpdateToOneWithWhereWithoutCarriersInput = {
  data: WarehouseUpdateWithoutCarriersInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpdateToOneWithWhereWithoutLabelRollInput = {
  data: WarehouseUpdateWithoutLabelRollInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpdateToOneWithWhereWithoutLinesInput = {
  data: WarehouseUpdateWithoutLinesInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpdateToOneWithWhereWithoutProductStockInput = {
  data: WarehouseUpdateWithoutProductStockInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpdateToOneWithWhereWithoutShelvesInput = {
  data: WarehouseUpdateWithoutShelvesInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpdateWithWhereUniqueWithoutDefaultCarrierInput = {
  data: WarehouseUpdateWithoutDefaultCarrierInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseUpdateWithWhereUniqueWithoutDefaultExpressCarrierInput = {
  data: WarehouseUpdateWithoutDefaultExpressCarrierInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseUpdateWithWhereUniqueWithoutDefaultInternationalCarrierInput = {
  data: WarehouseUpdateWithoutDefaultInternationalCarrierInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseUpdateWithoutAdminsInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutWarehouseNestedInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutWarehouseNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultCarrierForWarehousesNestedInput>;
  defaultExpressCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultExpressCarrierForWarehousesNestedInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultInternationalCarrierForWarehousesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutWarehouseNestedInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutWarehouseNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  productStock?: InputMaybe<ProductStockUpdateManyWithoutWarehouseNestedInput>;
  shelves?: InputMaybe<WarehouseShelfUpdateManyWithoutWarehouseNestedInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpdateWithoutBulkShippingsInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  admins?: InputMaybe<AdminUpdateManyWithoutWarehouseNestedInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutWarehouseNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultCarrierForWarehousesNestedInput>;
  defaultExpressCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultExpressCarrierForWarehousesNestedInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultInternationalCarrierForWarehousesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutWarehouseNestedInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutWarehouseNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  productStock?: InputMaybe<ProductStockUpdateManyWithoutWarehouseNestedInput>;
  shelves?: InputMaybe<WarehouseShelfUpdateManyWithoutWarehouseNestedInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpdateWithoutCarriersInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  admins?: InputMaybe<AdminUpdateManyWithoutWarehouseNestedInput>;
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutWarehouseNestedInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultCarrierForWarehousesNestedInput>;
  defaultExpressCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultExpressCarrierForWarehousesNestedInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultInternationalCarrierForWarehousesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutWarehouseNestedInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutWarehouseNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  productStock?: InputMaybe<ProductStockUpdateManyWithoutWarehouseNestedInput>;
  shelves?: InputMaybe<WarehouseShelfUpdateManyWithoutWarehouseNestedInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpdateWithoutDefaultCarrierInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  admins?: InputMaybe<AdminUpdateManyWithoutWarehouseNestedInput>;
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutWarehouseNestedInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutWarehouseNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultExpressCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultExpressCarrierForWarehousesNestedInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultInternationalCarrierForWarehousesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutWarehouseNestedInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutWarehouseNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  productStock?: InputMaybe<ProductStockUpdateManyWithoutWarehouseNestedInput>;
  shelves?: InputMaybe<WarehouseShelfUpdateManyWithoutWarehouseNestedInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpdateWithoutDefaultExpressCarrierInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  admins?: InputMaybe<AdminUpdateManyWithoutWarehouseNestedInput>;
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutWarehouseNestedInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutWarehouseNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultCarrierForWarehousesNestedInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultInternationalCarrierForWarehousesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutWarehouseNestedInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutWarehouseNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  productStock?: InputMaybe<ProductStockUpdateManyWithoutWarehouseNestedInput>;
  shelves?: InputMaybe<WarehouseShelfUpdateManyWithoutWarehouseNestedInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpdateWithoutDefaultInternationalCarrierInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  admins?: InputMaybe<AdminUpdateManyWithoutWarehouseNestedInput>;
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutWarehouseNestedInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutWarehouseNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultCarrierForWarehousesNestedInput>;
  defaultExpressCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultExpressCarrierForWarehousesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutWarehouseNestedInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutWarehouseNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  productStock?: InputMaybe<ProductStockUpdateManyWithoutWarehouseNestedInput>;
  shelves?: InputMaybe<WarehouseShelfUpdateManyWithoutWarehouseNestedInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpdateWithoutLabelRollInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  admins?: InputMaybe<AdminUpdateManyWithoutWarehouseNestedInput>;
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutWarehouseNestedInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutWarehouseNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultCarrierForWarehousesNestedInput>;
  defaultExpressCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultExpressCarrierForWarehousesNestedInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultInternationalCarrierForWarehousesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutWarehouseNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  productStock?: InputMaybe<ProductStockUpdateManyWithoutWarehouseNestedInput>;
  shelves?: InputMaybe<WarehouseShelfUpdateManyWithoutWarehouseNestedInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpdateWithoutLinesInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  admins?: InputMaybe<AdminUpdateManyWithoutWarehouseNestedInput>;
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutWarehouseNestedInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutWarehouseNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultCarrierForWarehousesNestedInput>;
  defaultExpressCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultExpressCarrierForWarehousesNestedInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultInternationalCarrierForWarehousesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutWarehouseNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  productStock?: InputMaybe<ProductStockUpdateManyWithoutWarehouseNestedInput>;
  shelves?: InputMaybe<WarehouseShelfUpdateManyWithoutWarehouseNestedInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpdateWithoutProductStockInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  admins?: InputMaybe<AdminUpdateManyWithoutWarehouseNestedInput>;
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutWarehouseNestedInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutWarehouseNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultCarrierForWarehousesNestedInput>;
  defaultExpressCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultExpressCarrierForWarehousesNestedInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultInternationalCarrierForWarehousesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutWarehouseNestedInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutWarehouseNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  shelves?: InputMaybe<WarehouseShelfUpdateManyWithoutWarehouseNestedInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpdateWithoutShelvesInput = {
  address1?: InputMaybe<StringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  admins?: InputMaybe<AdminUpdateManyWithoutWarehouseNestedInput>;
  bulkShippings?: InputMaybe<BulkShippingUpdateManyWithoutWarehouseNestedInput>;
  canShipExpress?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canShipInternationally?: InputMaybe<BoolFieldUpdateOperationsInput>;
  carriers?: InputMaybe<CarrierUpdateManyWithoutWarehouseNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  companyName?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultCarrierForWarehousesNestedInput>;
  defaultExpressCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultExpressCarrierForWarehousesNestedInput>;
  defaultInternationalCarrier?: InputMaybe<CarrierUpdateOneWithoutDefaultInternationalCarrierForWarehousesNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDisabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipHeroManaged?: InputMaybe<BoolFieldUpdateOperationsInput>;
  labelRoll?: InputMaybe<LabelRollUpdateManyWithoutWarehouseNestedInput>;
  lines?: InputMaybe<UserProductOrderLineUpdateManyWithoutWarehouseNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  productStock?: InputMaybe<ProductStockUpdateManyWithoutWarehouseNestedInput>;
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  warehouseName?: InputMaybe<StringFieldUpdateOperationsInput>;
  zip?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type WarehouseUpsertWithWhereUniqueWithoutDefaultCarrierInput = {
  create: WarehouseCreateWithoutDefaultCarrierInput;
  update: WarehouseUpdateWithoutDefaultCarrierInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseUpsertWithWhereUniqueWithoutDefaultExpressCarrierInput = {
  create: WarehouseCreateWithoutDefaultExpressCarrierInput;
  update: WarehouseUpdateWithoutDefaultExpressCarrierInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseUpsertWithWhereUniqueWithoutDefaultInternationalCarrierInput = {
  create: WarehouseCreateWithoutDefaultInternationalCarrierInput;
  update: WarehouseUpdateWithoutDefaultInternationalCarrierInput;
  where: WarehouseWhereUniqueInput;
};

export type WarehouseUpsertWithoutAdminsInput = {
  create: WarehouseCreateWithoutAdminsInput;
  update: WarehouseUpdateWithoutAdminsInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpsertWithoutBulkShippingsInput = {
  create: WarehouseCreateWithoutBulkShippingsInput;
  update: WarehouseUpdateWithoutBulkShippingsInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpsertWithoutCarriersInput = {
  create: WarehouseCreateWithoutCarriersInput;
  update: WarehouseUpdateWithoutCarriersInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpsertWithoutLabelRollInput = {
  create: WarehouseCreateWithoutLabelRollInput;
  update: WarehouseUpdateWithoutLabelRollInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpsertWithoutLinesInput = {
  create: WarehouseCreateWithoutLinesInput;
  update: WarehouseUpdateWithoutLinesInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpsertWithoutProductStockInput = {
  create: WarehouseCreateWithoutProductStockInput;
  update: WarehouseUpdateWithoutProductStockInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseUpsertWithoutShelvesInput = {
  create: WarehouseCreateWithoutShelvesInput;
  update: WarehouseUpdateWithoutShelvesInput;
  where?: InputMaybe<WarehouseWhereInput>;
};

export type WarehouseWhereInput = {
  AND?: InputMaybe<Array<WarehouseWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseWhereInput>>;
  OR?: InputMaybe<Array<WarehouseWhereInput>>;
  address1?: InputMaybe<StringFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  admins?: InputMaybe<AdminListRelationFilter>;
  bulkShippings?: InputMaybe<BulkShippingListRelationFilter>;
  canShipExpress?: InputMaybe<BoolFilter>;
  canShipInternationally?: InputMaybe<BoolFilter>;
  carriers?: InputMaybe<CarrierListRelationFilter>;
  city?: InputMaybe<StringFilter>;
  companyName?: InputMaybe<StringFilter>;
  countryCode?: InputMaybe<StringFilter>;
  defaultCarrier?: InputMaybe<CarrierNullableRelationFilter>;
  defaultCarrierId?: InputMaybe<UuidNullableFilter>;
  defaultExpressCarrier?: InputMaybe<CarrierNullableRelationFilter>;
  defaultExpressCarrierId?: InputMaybe<UuidNullableFilter>;
  defaultInternationalCarrier?: InputMaybe<CarrierNullableRelationFilter>;
  defaultInternationalCarrierId?: InputMaybe<UuidNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  isShipHeroManaged?: InputMaybe<BoolFilter>;
  labelRoll?: InputMaybe<LabelRollListRelationFilter>;
  lines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  phone?: InputMaybe<StringFilter>;
  productStock?: InputMaybe<ProductStockListRelationFilter>;
  shelves?: InputMaybe<WarehouseShelfListRelationFilter>;
  stateCode?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringFilter>;
  warehouseName?: InputMaybe<StringFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type WarehouseWhereUniqueInput = {
  AND?: InputMaybe<Array<WarehouseWhereInput>>;
  NOT?: InputMaybe<Array<WarehouseWhereInput>>;
  OR?: InputMaybe<Array<WarehouseWhereInput>>;
  address1?: InputMaybe<StringFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  admins?: InputMaybe<AdminListRelationFilter>;
  bulkShippings?: InputMaybe<BulkShippingListRelationFilter>;
  canShipExpress?: InputMaybe<BoolFilter>;
  canShipInternationally?: InputMaybe<BoolFilter>;
  carriers?: InputMaybe<CarrierListRelationFilter>;
  city?: InputMaybe<StringFilter>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<StringFilter>;
  defaultCarrier?: InputMaybe<CarrierNullableRelationFilter>;
  defaultCarrierId?: InputMaybe<UuidNullableFilter>;
  defaultExpressCarrier?: InputMaybe<CarrierNullableRelationFilter>;
  defaultExpressCarrierId?: InputMaybe<UuidNullableFilter>;
  defaultInternationalCarrier?: InputMaybe<CarrierNullableRelationFilter>;
  defaultInternationalCarrierId?: InputMaybe<UuidNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<BoolFilter>;
  isShipHeroManaged?: InputMaybe<BoolFilter>;
  labelRoll?: InputMaybe<LabelRollListRelationFilter>;
  lines?: InputMaybe<UserProductOrderLineListRelationFilter>;
  phone?: InputMaybe<StringFilter>;
  productStock?: InputMaybe<ProductStockListRelationFilter>;
  shelves?: InputMaybe<WarehouseShelfListRelationFilter>;
  stateCode?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringFilter>;
  warehouseName?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<StringFilter>;
};

export enum WeightUnit {
  Gram = 'GRAM',
  Kilogram = 'KILOGRAM',
  Ounce = 'OUNCE',
  Pound = 'POUND'
}

export type AdminOrdersExportQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductOrderOrderByWithRelationInput> | UserProductOrderOrderByWithRelationInput>;
  where?: InputMaybe<UserProductOrderWhereInput>;
}>;


export type AdminOrdersExportQuery = { __typename?: 'Query', adminOrders: { __typename?: 'UserProductOrderResponse', items: Array<{ __typename?: 'UserProductOrderModel', id: string, orderId: number, createdAt: string, fulfillmentDeadline?: string | null, lines: Array<{ __typename?: 'UserProductOrderLineModel', id: string, count: number, userProduct: { __typename?: 'UserProductModel', productSettings: { __typename?: 'ProductSettingsModel', sku: string } }, details?: { __typename?: 'UserProductOrderLineDetails', title: string, isPrepared: boolean, nameSupliful: string } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }> }> }> } };

export type CreateBulkShippingMutationVariables = Exact<{
  data: CreateBulkShippingInput;
}>;


export type CreateBulkShippingMutation = { __typename?: 'Mutation', createBulkShipping: { __typename?: 'CreateBulkShippingResponse', bulkShippingId: number, results: Array<{ __typename?: 'CreateBulkShippingOrderResult', id: string, errorMessage?: string | null, order: { __typename?: 'UserProductOrder', id: string, orderId: number } }> } };

export type GetBulkShippingDetailsQueryVariables = Exact<{
  bulkShippingId: Scalars['Float']['input'];
}>;


export type GetBulkShippingDetailsQuery = { __typename?: 'Query', getBulkShippingDetails: { __typename?: 'GetBulkShippingDetailsResponse', id: number, productImageUrl?: string | null, productSku?: string | null, shipments: Array<{ __typename?: 'Shipment', id: string, status: ShipmentStatus, completed: boolean, trackingNumber: string, trackingUrl: string, shippingLabelUrl: string, carrier?: { __typename?: 'Carrier', name: string } | null, shippingPackage?: { __typename?: 'ShippingPackage', name: string } | null, userProductOrder?: { __typename?: 'UserProductOrder', id: string, orderId: number, warehouseShelfBins: Array<{ __typename?: 'WarehouseShelfBin', id: string }>, warehouseShelfReturnBin?: { __typename?: 'WarehouseShelfReturnBin', id: string } | null } | null, userProductOrderLines?: Array<{ __typename?: 'UserProductOrderLineModel', count: number }> | null }> } };

export type MarkBulkShippingShipmentsAsReadyToShipMutationVariables = Exact<{
  bulkShippingId: Scalars['Float']['input'];
}>;


export type MarkBulkShippingShipmentsAsReadyToShipMutation = { __typename?: 'Mutation', markBulkShippingShipmentsAsReadyToShip: { __typename?: 'SuccessResponse', success: boolean, reason?: string | null } };

export type GetLatestBulkShippingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestBulkShippingQuery = { __typename?: 'Query', getLatestBulkShipping: { __typename?: 'GetBulkShippingDetailsResponse', id: number } };

export type GetBulkShippingSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBulkShippingSuggestionsQuery = { __typename?: 'Query', getBulkShippingSuggestions: Array<{ __typename?: 'BulkShippingSuggestion', id: string, serviceLevel: string, orders: Array<{ __typename?: 'OrderToShip', id: string, orderId: number, linesToShip: Array<{ __typename?: 'LineItemToShip', id: string, count: number }> }>, user: { __typename?: 'User', id: string, fullName: string }, userProducts: Array<{ __typename?: 'ProductToShip', count: number, userProduct: { __typename?: 'UserProductToShip', id: string, name: string, imageUrl: string, defaultShippingPackageId?: string | null, productSettings: { __typename?: 'ProductSettings', defaultShippingPackageId?: string | null } } }>, carrier: { __typename?: 'Carrier', id: string, name: string, logo?: string | null } }> };

export type CreateDigitalServiceProductMutationVariables = Exact<{
  input: DigitalServiceProductCreateWithoutCreatedByInput;
}>;


export type CreateDigitalServiceProductMutation = { __typename?: 'Mutation', createDigitalServiceProduct: { __typename?: 'DigitalServiceProduct', stripeProductId: string, hubspotProductId?: string | null, isActive: boolean, createdAt: string, updatedAt: string, createdById: string, refundPolicy?: string | null, createdBy: { __typename?: 'Admin', email: string } } };

export type UpdateDigitalServiceProductMutationVariables = Exact<{
  where: DigitalServiceProductWhereUniqueInput;
  data: DigitalServiceProductUpdateInput;
}>;


export type UpdateDigitalServiceProductMutation = { __typename?: 'Mutation', updateOneDigitalServiceProduct?: { __typename?: 'DigitalServiceProduct', stripeProductId: string, hubspotProductId?: string | null, isActive: boolean, createdAt: string, updatedAt: string, createdById: string, refundPolicy?: string | null, createdBy: { __typename?: 'Admin', email: string } } | null };

export type UserTransactionsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TransactionType>;
  paymentType?: InputMaybe<PaymentType>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  adminId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserTransactionsQuery = { __typename?: 'Query', userTransactions: Array<{ __typename?: 'UserTransaction', id: string, amountCents: number, balanceAfter?: number | null, manualCreditChangeReason?: string | null, reason?: string | null, status?: string | null, transactionMethod: TransactionMethod, description: string, createdAt: string, createdBy?: { __typename?: 'Admin', email: string } | null }> };

export type ShopifyStoreActionMutationVariables = Exact<{
  data: ShopifyStoreActionInput;
}>;


export type ShopifyStoreActionMutation = { __typename?: 'Mutation', shopifyStoreAction: { __typename?: 'SuccessResponse', success: boolean, reason?: string | null } };

export type CreateShipmentMutationVariables = Exact<{
  input: CreateShipmentInput;
}>;


export type CreateShipmentMutation = { __typename?: 'Mutation', createShipment: { __typename?: 'Shipment', id: string, shippingLabelUrl: string } };

export type OwnAutoGeneratedShipmentMutationVariables = Exact<{
  shipmentId: Scalars['String']['input'];
}>;


export type OwnAutoGeneratedShipmentMutation = { __typename?: 'Mutation', ownAutoGeneratedShipment: { __typename?: 'Shipment', id: string, status: ShipmentStatus, completed: boolean, completedAt?: any | null, sent: boolean, replacement: boolean, carrierId?: string | null, trackingNumber: string, trackingUrl: string, shippingLabelCreated: boolean, shippingLabelUrl: string, reshippingCost?: number | null, createdAt: any, reshipmentId?: string | null, carrier?: { __typename?: 'Carrier', name: string, externalId: string } | null, shippingPackage?: { __typename?: 'ShippingPackage', id: string, name: string } | null, createdBy?: { __typename?: 'Admin', email: string } | null, userProductOrder?: { __typename?: 'UserProductOrder', kind: UserProductOrderKind } | null, userProductOrderLines?: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }> | null, reshippedOrderLines?: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }> | null } };

export type ReportLabelIssueMutationVariables = Exact<{
  data: ReportLabelIssueInput;
}>;


export type ReportLabelIssueMutation = { __typename?: 'Mutation', reportLabelIssue: { __typename?: 'SuccessResponse', success: boolean } };

export type AdminOrderInvoicesCountQueryVariables = Exact<{
  userProductOrderId: Scalars['String']['input'];
}>;


export type AdminOrderInvoicesCountQuery = { __typename?: 'Query', adminOrderInvoices: { __typename?: 'FindManyInvoiceModelResponse', count: number, items: Array<{ __typename?: 'InvoiceModel', id: string, type: UserInvoiceType }> } };

export type SetOrderLockMutationVariables = Exact<{
  data: SetOrderLockInput;
}>;


export type SetOrderLockMutation = { __typename?: 'Mutation', setOrderLock: { __typename?: 'SuccessResponse', success: boolean } };

export type CreateQuickShipmentMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type CreateQuickShipmentMutation = { __typename?: 'Mutation', createQuickShipment?: { __typename?: 'Shipment', id: string, status: ShipmentStatus, completed: boolean, completedAt?: any | null, sent: boolean, replacement: boolean, carrierId?: string | null, trackingNumber: string, trackingUrl: string, shippingLabelCreated: boolean, shippingLabelUrl: string, reshippingCost?: number | null, createdAt: any, reshipmentId?: string | null, carrier?: { __typename?: 'Carrier', name: string, externalId: string } | null, shippingPackage?: { __typename?: 'ShippingPackage', id: string, name: string } | null, createdBy?: { __typename?: 'Admin', email: string } | null, userProductOrder?: { __typename?: 'UserProductOrder', kind: UserProductOrderKind } | null, userProductOrderLines?: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }> | null, reshippedOrderLines?: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }> | null } | null };

export type OrderRefundStatusQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OrderRefundStatusQuery = { __typename?: 'Query', userProductOrderRefundStatus: { __typename?: 'UserProductOrderRefundStatusResponse', isRefundableWithCredits: boolean, isLegacyPaymentIntentRefundable: boolean, canCreditNoteBeIssued: boolean } };

export type AdminRefundOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  data: RefundOrderInput;
  cancelRefundedOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdminRefundOrderMutation = { __typename?: 'Mutation', adminRefundOrder: { __typename?: 'SuccessResponse', success: boolean } };

export type UpdateBulkOrderDueDateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: BulkDueDateUpdateInput;
}>;


export type UpdateBulkOrderDueDateMutation = { __typename?: 'Mutation', updateBulkDueDate: { __typename?: 'UserProductOrderModel', id: string, orderId: number, kind: UserProductOrderKind, invoiceMode: InvoiceMode, status: UserProductOrderStatus, isReplacement: boolean, onHold: boolean, onHoldReasons: Array<OnHoldReason>, createdAt: string, updatedAt: string, completedAt?: string | null, cancelledAt?: string | null, fulfillmentDeadline?: string | null, lineItemsCount?: number | null, allProductLabelsVerified: boolean, sampleDiscountApplied: boolean, lockedById?: string | null, stripePaymentId?: string | null, chargeProcessingFee?: number | null, isPriorityLaneFulfillment: boolean, postPaymentBucketId?: string | null, customOnHoldReasons: Array<{ __typename?: 'CustomOnHoldReason', id: string, reason: string, resolved: boolean, createdAt: string, resolvedAt?: string | null, resolvedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, addedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null }>, user: { __typename?: 'User', id: string, username: string }, lockedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, store?: { __typename?: 'UserStore', shopUrl: string } | null, details?: { __typename?: 'UserProductOrderDetails', shippingCost?: number | null, chargedAmount?: number | null, refunded: boolean, refundAmount: number, express: boolean, charged: boolean, email?: string | null } | null, warehouseShelfBin?: { __typename?: 'WarehouseShelfBin', id: string } | null, warehouseShelfReturnBin?: { __typename?: 'WarehouseShelfReturnBin', id: string } | null, shopifyDetails?: { __typename?: 'UserProductOrderShopifyDetails', shopifyId: any, shopifyOrderName: string } | null, tiktokDetails?: { __typename?: 'UserProductOrderTiktokDetails', tiktokOrderId: string, isTiktokShipping: boolean } | null, lines: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }>, billingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, shippingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, fbaDetails?: { __typename?: 'UserProductOrderFbaDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, shippingLabelUrl?: string | null, trackingNumber?: string | null } | null, bulkDetails?: { __typename?: 'UserProductOrderBulkDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null } | null } };

export type UpdateUserProductOrderLineWarehouseMutationVariables = Exact<{
  lineId: Scalars['String']['input'];
  warehouseId: Scalars['String']['input'];
}>;


export type UpdateUserProductOrderLineWarehouseMutation = { __typename?: 'Mutation', updateUserProductOrderLineWarehouse: { __typename?: 'SuccessResponse', success: boolean, reason?: string | null } };

export type OrderShipmentsQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type OrderShipmentsQuery = { __typename?: 'Query', orderShipments: Array<{ __typename?: 'Shipment', id: string, status: ShipmentStatus, completed: boolean, completedAt?: any | null, sent: boolean, replacement: boolean, carrierId?: string | null, trackingNumber: string, trackingUrl: string, shippingLabelCreated: boolean, shippingLabelUrl: string, reshippingCost?: number | null, createdAt: any, reshipmentId?: string | null, carrier?: { __typename?: 'Carrier', name: string, externalId: string } | null, shippingPackage?: { __typename?: 'ShippingPackage', id: string, name: string } | null, createdBy?: { __typename?: 'Admin', email: string } | null, userProductOrder?: { __typename?: 'UserProductOrder', kind: UserProductOrderKind } | null, userProductOrderLines?: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }> | null, reshippedOrderLines?: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }> | null }> };

export type UpdateFbaOrderDueDateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: FbaDueDateUpdateInput;
}>;


export type UpdateFbaOrderDueDateMutation = { __typename?: 'Mutation', updateFbaDueDate: { __typename?: 'UserProductOrderModel', id: string, orderId: number, kind: UserProductOrderKind, invoiceMode: InvoiceMode, status: UserProductOrderStatus, isReplacement: boolean, onHold: boolean, onHoldReasons: Array<OnHoldReason>, createdAt: string, updatedAt: string, completedAt?: string | null, cancelledAt?: string | null, fulfillmentDeadline?: string | null, lineItemsCount?: number | null, allProductLabelsVerified: boolean, sampleDiscountApplied: boolean, lockedById?: string | null, stripePaymentId?: string | null, chargeProcessingFee?: number | null, isPriorityLaneFulfillment: boolean, postPaymentBucketId?: string | null, customOnHoldReasons: Array<{ __typename?: 'CustomOnHoldReason', id: string, reason: string, resolved: boolean, createdAt: string, resolvedAt?: string | null, resolvedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, addedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null }>, user: { __typename?: 'User', id: string, username: string }, lockedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, store?: { __typename?: 'UserStore', shopUrl: string } | null, details?: { __typename?: 'UserProductOrderDetails', shippingCost?: number | null, chargedAmount?: number | null, refunded: boolean, refundAmount: number, express: boolean, charged: boolean, email?: string | null } | null, warehouseShelfBin?: { __typename?: 'WarehouseShelfBin', id: string } | null, warehouseShelfReturnBin?: { __typename?: 'WarehouseShelfReturnBin', id: string } | null, shopifyDetails?: { __typename?: 'UserProductOrderShopifyDetails', shopifyId: any, shopifyOrderName: string } | null, tiktokDetails?: { __typename?: 'UserProductOrderTiktokDetails', tiktokOrderId: string, isTiktokShipping: boolean } | null, lines: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }>, billingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, shippingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, fbaDetails?: { __typename?: 'UserProductOrderFbaDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, shippingLabelUrl?: string | null, trackingNumber?: string | null } | null, bulkDetails?: { __typename?: 'UserProductOrderBulkDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null } | null } };

export type ResetActivePrintBatchesOfSkuMutationVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type ResetActivePrintBatchesOfSkuMutation = { __typename?: 'Mutation', resetActivePrintBatchesOfSku: { __typename?: 'SuccessResponse', success: boolean } };

export type CreatePrintBatchAndConnectOrderLinesMutationVariables = Exact<{
  data: CreatePrintBatchAndConnectOrderLinesInput;
}>;


export type CreatePrintBatchAndConnectOrderLinesMutation = { __typename?: 'Mutation', createPrintBatchAndConnectOrderLines: { __typename?: 'CreatePrintBatchAndConnectOrderLinesResult', id: number, url: string } };

export type CreateProductLabelSizeMutationVariables = Exact<{
  data: ProductLabelSizeCreateInput;
}>;


export type CreateProductLabelSizeMutation = { __typename?: 'Mutation', createOneProductLabelSize: { __typename?: 'ProductLabelSize', id: string, internalId: string, name: string, width: number, height: number, unit: LengthUnit, labelsPerProduct: number } };

export type GetActivePublishersQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type GetActivePublishersQuery = { __typename?: 'Query', getActivePublishers: Array<{ __typename?: 'ProductPublisherModel', email: string, fullName: string }> };

export type UpdateProductRestockDateMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  data: UpdateProductRestockDateInput;
}>;


export type UpdateProductRestockDateMutation = { __typename?: 'Mutation', updateProductRestockDate?: Array<{ __typename?: 'ProductPublisherModel', email: string, fullName: string }> | null };

export type ProductStockQuantityImportMutationVariables = Exact<{
  data: ProductStockQuantityImportInput;
}>;


export type ProductStockQuantityImportMutation = { __typename?: 'Mutation', importProductStockQuantity: { __typename?: 'ProductsImportResponse', importedCount: number, failedCount: number } };

export type CreateProductStockSnapshotMutationVariables = Exact<{
  data: CreateProductStockSnapshotInput;
}>;


export type CreateProductStockSnapshotMutation = { __typename?: 'Mutation', createProductStockSnapshot: { __typename?: 'SuccessResponse', success: boolean } };

export type ProductsSettingsImportMutationVariables = Exact<{
  data: ProductsSettingsImportInput;
}>;


export type ProductsSettingsImportMutation = { __typename?: 'Mutation', importProductsSettings: { __typename?: 'ProductsImportResponse', importedCount: number, failedCount: number } };

export type ExtendedCatalogImportMutationVariables = Exact<{
  data: ProductsSettingsImportInput;
}>;


export type ExtendedCatalogImportMutation = { __typename?: 'Mutation', importExtendedCatalogProducts: { __typename?: 'ProductsImportResponse', importedCount: number, failedCount: number } };

export type ProductStockFragmentFragment = { __typename?: 'ProductStock', id: string, quantity: number, isAvailable: boolean, priority: number, lastStockSnapshotDate?: string | null, sku: string, fulfillmentSku: string, warehouse?: { __typename?: 'Warehouse', id: string, codeName?: string | null, warehouseName: string, isDisabled: boolean, isShipHeroManaged: boolean } | null };

export type UpdateOneProductStockMutationVariables = Exact<{
  where: ProductStockWhereUniqueInput;
  data: ProductStockUpdateInput;
}>;


export type UpdateOneProductStockMutation = { __typename?: 'Mutation', updateOneProductStock?: { __typename?: 'ProductStock', id: string, quantity: number, isAvailable: boolean, priority: number, lastStockSnapshotDate?: string | null, sku: string, fulfillmentSku: string, warehouse?: { __typename?: 'Warehouse', id: string, codeName?: string | null, warehouseName: string, isDisabled: boolean, isShipHeroManaged: boolean } | null } | null };

export type CreateOneProductStockMutationVariables = Exact<{
  data: ProductStockCreateInput;
}>;


export type CreateOneProductStockMutation = { __typename?: 'Mutation', createOneProductStock: { __typename?: 'ProductStock', id: string, quantity: number, isAvailable: boolean, priority: number, lastStockSnapshotDate?: string | null, sku: string, fulfillmentSku: string, warehouse?: { __typename?: 'Warehouse', id: string, codeName?: string | null, warehouseName: string, isDisabled: boolean, isShipHeroManaged: boolean } | null } };

export type FindManyProductStockQueryVariables = Exact<{
  where?: InputMaybe<ProductStockWhereInput>;
}>;


export type FindManyProductStockQuery = { __typename?: 'Query', findManyProductStock: Array<{ __typename?: 'ProductStock', id: string, quantity: number, isAvailable: boolean, priority: number, lastStockSnapshotDate?: string | null, sku: string, fulfillmentSku: string, warehouse?: { __typename?: 'Warehouse', id: string, codeName?: string | null, warehouseName: string, isDisabled: boolean, isShipHeroManaged: boolean } | null }> };

export type ShipmentByCarrierQueryVariables = Exact<{
  status: ShipmentStatus;
}>;


export type ShipmentByCarrierQuery = { __typename?: 'Query', countShipmentsByCarrier: Array<{ __typename?: 'CountShipmentsByCarrierResponse', carrierId: string, count: number }> };

export type BinsAssignedToOrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type BinsAssignedToOrderQuery = { __typename?: 'Query', binsAssignedToOrder: { __typename?: 'BinsAssignedToOrderResponse', sorting: Array<{ __typename?: 'WarehouseShelfBin', id: string, number: number }>, returned: Array<{ __typename?: 'WarehouseShelfReturnBin', id: string, number: number }> } };

export type CreateWarehouseShelfMutationVariables = Exact<{
  data: CreateWarehouseShelfInput;
}>;


export type CreateWarehouseShelfMutation = { __typename?: 'Mutation', createOneWarehouseShelf: { __typename?: 'WarehouseShelf', id: string, name: string, type: WarehouseShelfType, warehouseId: string, bins: Array<{ __typename?: 'WarehouseShelfBin', id: string, number: number, userProductOrderId?: string | null }>, returnBins: Array<{ __typename?: 'WarehouseShelfReturnBin', id: string, number: number }>, warehouse?: { __typename?: 'Warehouse', warehouseName: string, codeName?: string | null } | null } };

export type ExtendedProductAdminListItemFragment = { __typename?: 'ProductSettingsModel', id: string, name: string, slug: string, sku: string, isFulfillmentReady: boolean, fulfillmentChecklist: { __typename?: 'ProductFulfillmentChecklist', nameAndSku: boolean, stockLevel: boolean, labelSizeAndDesign: boolean, containerMockups: boolean, denverWarehouseAssigned: boolean, stripeProductCreated: boolean, shipHeroProductStockSetup: boolean } };

export type ProductPublisherFragment = { __typename?: 'ProductPublisherModel', email: string, fullName: string };

export type CustomOnHoldReasonFragment = { __typename?: 'CustomOnHoldReason', id: string, reason: string, resolved: boolean, createdAt: string, resolvedAt?: string | null, resolvedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, addedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null };

export type UserProductOrderSubLineAdminItemFragment = { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number };

export type UserProductOrderLineAdminItemFragment = { __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null };

export type ShippingPackageAdminItemFragment = { __typename?: 'ShippingPackage', id: string, name: string };

export type ShipmentListItemFragment = { __typename?: 'Shipment', id: string, shipmentWeight: number, status: ShipmentStatus, trackingNumber: string, trackingUrl: string, createdAt: any, createdById: string, completedById?: string | null, warehouseName?: string | null, carrier?: { __typename?: 'Carrier', name: string } | null, userProductOrder?: { __typename?: 'UserProductOrder', orderId: number, kind: UserProductOrderKind } | null };

export type ShipmentOrderItemFragment = { __typename?: 'Shipment', id: string, status: ShipmentStatus, completed: boolean, completedAt?: any | null, sent: boolean, replacement: boolean, carrierId?: string | null, trackingNumber: string, trackingUrl: string, shippingLabelCreated: boolean, shippingLabelUrl: string, reshippingCost?: number | null, createdAt: any, reshipmentId?: string | null, carrier?: { __typename?: 'Carrier', name: string, externalId: string } | null, shippingPackage?: { __typename?: 'ShippingPackage', id: string, name: string } | null, createdBy?: { __typename?: 'Admin', email: string } | null, userProductOrder?: { __typename?: 'UserProductOrder', kind: UserProductOrderKind } | null, userProductOrderLines?: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }> | null, reshippedOrderLines?: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }> | null };

export type UserProductOrderAddressFragment = { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null };

export type OrderAdminListItemFragment = { __typename?: 'UserProductOrderModel', id: string, orderId: number, kind: UserProductOrderKind, status: UserProductOrderStatus, onHold: boolean, createdAt: string, fulfillmentDeadline?: string | null, isPriorityLaneFulfillment: boolean, lineItemsCount?: number | null, allProductLabelsVerified: boolean, itemCountTotal: number, shippingAddress?: { __typename?: 'UserProductOrderAddressModel', countryCode: string } | null, user: { __typename?: 'User', id: string, username: string, email: string }, lines: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, shipmentId?: string | null, count: number, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, isPrepared: boolean } | null }>, details?: { __typename?: 'UserProductOrderDetails', charged: boolean, express: boolean } | null, itemCountByWarehouse: Array<{ __typename?: 'UserProductOrderItemCountByWarehouse', count: number, warehouseId: string }> };

export type OrderAdminBrowseItemFragment = { __typename?: 'UserProductOrderModel', id: string, orderId: number, kind: UserProductOrderKind, invoiceMode: InvoiceMode, status: UserProductOrderStatus, isReplacement: boolean, onHold: boolean, onHoldReasons: Array<OnHoldReason>, createdAt: string, updatedAt: string, completedAt?: string | null, cancelledAt?: string | null, fulfillmentDeadline?: string | null, lineItemsCount?: number | null, allProductLabelsVerified: boolean, sampleDiscountApplied: boolean, lockedById?: string | null, stripePaymentId?: string | null, chargeProcessingFee?: number | null, isPriorityLaneFulfillment: boolean, postPaymentBucketId?: string | null, customOnHoldReasons: Array<{ __typename?: 'CustomOnHoldReason', id: string, reason: string, resolved: boolean, createdAt: string, resolvedAt?: string | null, resolvedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, addedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null }>, user: { __typename?: 'User', id: string, username: string }, lockedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, store?: { __typename?: 'UserStore', shopUrl: string } | null, details?: { __typename?: 'UserProductOrderDetails', shippingCost?: number | null, chargedAmount?: number | null, refunded: boolean, refundAmount: number, express: boolean, charged: boolean, email?: string | null } | null, warehouseShelfBin?: { __typename?: 'WarehouseShelfBin', id: string } | null, warehouseShelfReturnBin?: { __typename?: 'WarehouseShelfReturnBin', id: string } | null, shopifyDetails?: { __typename?: 'UserProductOrderShopifyDetails', shopifyId: any, shopifyOrderName: string } | null, tiktokDetails?: { __typename?: 'UserProductOrderTiktokDetails', tiktokOrderId: string, isTiktokShipping: boolean } | null, lines: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }>, billingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, shippingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, fbaDetails?: { __typename?: 'UserProductOrderFbaDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, shippingLabelUrl?: string | null, trackingNumber?: string | null } | null, bulkDetails?: { __typename?: 'UserProductOrderBulkDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null } | null };

export type LabelSizeFragment = { __typename?: 'ProductLabelSize', id: string, internalId: string, name: string, width: number, height: number, unit: LengthUnit };

export type UserStoreAdminItemFragment = { __typename?: 'UserStoreModel', id: string, userId: string, platform: EcommercePlatform, name?: string | null, shopUrl: string, email?: string | null, address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, country?: string | null, webhooksInitialised: { __typename?: 'SuccessResponse', success: boolean, reason?: string | null }, fulfillmentService?: { __typename?: 'FulfillmentService', id: string } | null };

export type UserCertificateAdminItemFragment = { __typename?: 'ExemptaxCustomerCertificate', id: string, certificateId: number, exemptionReason: string, state: string, expirationDate: string };

export type UserAdminItemFragment = { __typename?: 'UserModel', id: string, fullName: string, username: string, email: string, emailVerified?: boolean | null, failedOrderPaymentsCount: number, becameActiveAt?: string | null, createdAt: string, updatedAt: string, stripeCustomerId?: string | null, stripePostPaymentCustomerId?: string | null, isPriorityLaneFulfillment: boolean, isBrandAcceleratorParticipant: boolean, vip: boolean, isDisabled: boolean, isDeactivated: boolean, deactivationScheduledAt?: string | null, deactivatedAt?: string | null, isPostPaymentEnabled: boolean, postPaymentPeriodWeeks: number, postPaymentDueDateDays: number, postPaymentDueDateDaysType: UserPostPaymentDueDateDaysType, fbaPaymentKind: UserProductOrderManualPaymentKind, fbaPostPaymentDueDateDays?: number | null, fbaPostPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, bulkOrderPaymentKind: UserProductOrderManualPaymentKind, bulkOrderPostPaymentDueDateDays?: number | null, bulkOrderPostPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, currentSubscription?: { __typename?: 'UserSubscription', status: UserSubscriptionStatus, tier: UserSubscriptionTier } | null, certificates: Array<{ __typename?: 'ExemptaxCustomerCertificate', id: string, certificateId: number, exemptionReason: string, state: string, expirationDate: string }>, stores?: Array<{ __typename?: 'UserStoreModel', id: string, userId: string, platform: EcommercePlatform, name?: string | null, shopUrl: string, email?: string | null, address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, country?: string | null, webhooksInitialised: { __typename?: 'SuccessResponse', success: boolean, reason?: string | null }, fulfillmentService?: { __typename?: 'FulfillmentService', id: string } | null }> | null };

export type ProductAdminSettingsFragment = { __typename?: 'ProductSettingsModel', id: string, stripeProductId?: string | null, name: string, slug: string, sku: string, isFulfillmentReady: boolean, isInExtendedCatalog: boolean, isExclusive: boolean, shelf?: string | null, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, canvaTemplate?: string | null, priceSupliful?: number | null, status: ProductStatus, restockDate?: string | null, holdOrdersWhenOutOfStock: boolean, productLabellingTechnique: ProductLabellingTechnique, discontinued: boolean, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, stockLevel?: Array<{ __typename?: 'ProductStock', id: string, warehouseId: string, quantity: number, warehouse?: { __typename?: 'Warehouse', codeName?: string | null, warehouseName: string, isShipHeroManaged: boolean } | null }> | null, fulfillmentChecklist: { __typename?: 'ProductFulfillmentChecklist', nameAndSku: boolean, stockLevel: boolean, labelSizeAndDesign: boolean, containerMockups: boolean, denverWarehouseAssigned: boolean, stripeProductCreated: boolean, shipHeroProductStockSetup: boolean } };

export type ProductLabelSizeFragment = { __typename?: 'ProductLabelSize', id: string, internalId: string, name: string, width: number, height: number, unit: LengthUnit, labelsPerProduct: number };

export type ShipmentBatchFragment = { __typename?: 'ShipmentBatch', id: string, printFileUrl: string, createdAt: string, carrier?: { __typename?: 'Carrier', readable: string } | null, completedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null };

export type WarehouseShelfFragment = { __typename?: 'WarehouseShelf', id: string, name: string, type: WarehouseShelfType, warehouseId: string, bins: Array<{ __typename?: 'WarehouseShelfBin', id: string, number: number, userProductOrderId?: string | null }>, returnBins: Array<{ __typename?: 'WarehouseShelfReturnBin', id: string, number: number }>, warehouse?: { __typename?: 'Warehouse', warehouseName: string, codeName?: string | null } | null };

export type PrintFileQueueFragment = { __typename?: 'PrintFileQueueResponse', id: string, internalId: string, printFilesBySku: Array<{ __typename?: 'PrintFilesBySku', sku: string, name?: string | null, total: number, totalPriority: number, labellingTechnique: ProductLabellingTechnique, activeBatches: Array<number>, productForm?: { __typename?: 'SanityProductForm', id: string, name: string, slug?: string | null } | null }> };

export type UserCreditsTransactionFragment = { __typename?: 'UserCreditsTransaction', id: string, amountCents: number, createdAt: string, createdById?: string | null };

export type DigitalServiceProductFragment = { __typename?: 'DigitalServiceProduct', stripeProductId: string, hubspotProductId?: string | null, isActive: boolean, createdAt: string, updatedAt: string, createdById: string, refundPolicy?: string | null, createdBy: { __typename?: 'Admin', email: string } };

export type AdminDigitalServiceProductListItemFragment = { __typename?: 'AdminDigitalServiceProductListItem', digitalServiceProduct: { __typename?: 'DigitalServiceProduct', stripeProductId: string, hubspotProductId?: string | null, isActive: boolean, createdAt: string, updatedAt: string, createdById: string, refundPolicy?: string | null, createdBy: { __typename?: 'Admin', email: string } }, stripeProduct?: { __typename?: 'StripeProduct', id: string, name: string, description?: string | null, images: Array<string> } | null };

export type ProductSettingsFragment = { __typename?: 'ProductSettingsModel', isInExtendedCatalog: boolean, shelf?: string | null, holdOrdersWhenOutOfStock: boolean };

export type ProductAdminListItemFragment = { __typename?: 'ProductSettingsModel', id: string, name: string, slug: string, sku: string, discontinued: boolean, isFulfillmentReady: boolean, priceSupliful?: number | null, restockDate?: string | null, isInExtendedCatalog: boolean, shelf?: string | null, holdOrdersWhenOutOfStock: boolean, stockLevel?: Array<{ __typename?: 'ProductStock', id: string, warehouseId: string, quantity: number, fulfillmentSku: string, warehouse?: { __typename?: 'Warehouse', codeName?: string | null, warehouseName: string, isShipHeroManaged: boolean } | null }> | null, fulfillmentChecklist: { __typename?: 'ProductFulfillmentChecklist', nameAndSku: boolean, stockLevel: boolean, labelSizeAndDesign: boolean, containerMockups: boolean, denverWarehouseAssigned: boolean, stripeProductCreated: boolean, shipHeroProductStockSetup: boolean } };

export type AdminDigitalServiceProductListQueryVariables = Exact<{
  where?: InputMaybe<DigitalServiceProductWhereInput>;
}>;


export type AdminDigitalServiceProductListQuery = { __typename?: 'Query', adminDigitalServiceProductList: Array<{ __typename?: 'AdminDigitalServiceProductListItem', digitalServiceProduct: { __typename?: 'DigitalServiceProduct', stripeProductId: string, hubspotProductId?: string | null, isActive: boolean, createdAt: string, updatedAt: string, createdById: string, refundPolicy?: string | null, createdBy: { __typename?: 'Admin', email: string } }, stripeProduct?: { __typename?: 'StripeProduct', id: string, name: string, description?: string | null, images: Array<string> } | null }> };

export type AdminProductsQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ProductSettingsOrderByWithRelationInput> | ProductSettingsOrderByWithRelationInput>;
  where?: InputMaybe<ProductSettingsWhereInput>;
}>;


export type AdminProductsQuery = { __typename?: 'Query', findManyProductSettingsWithCount: { __typename?: 'FindManyProductSettingsResponse', count: number, items: Array<{ __typename?: 'ProductSettingsModel', id: string, name: string, slug: string, sku: string, discontinued: boolean, isFulfillmentReady: boolean, priceSupliful?: number | null, restockDate?: string | null, isInExtendedCatalog: boolean, shelf?: string | null, holdOrdersWhenOutOfStock: boolean, stockLevel?: Array<{ __typename?: 'ProductStock', id: string, warehouseId: string, quantity: number, fulfillmentSku: string, warehouse?: { __typename?: 'Warehouse', codeName?: string | null, warehouseName: string, isShipHeroManaged: boolean } | null }> | null, fulfillmentChecklist: { __typename?: 'ProductFulfillmentChecklist', nameAndSku: boolean, stockLevel: boolean, labelSizeAndDesign: boolean, containerMockups: boolean, denverWarehouseAssigned: boolean, stripeProductCreated: boolean, shipHeroProductStockSetup: boolean } }> } };

export type ChargeReshipmentMutationVariables = Exact<{
  shipmentId: Scalars['String']['input'];
}>;


export type ChargeReshipmentMutation = { __typename?: 'Mutation', chargeReshipment: { __typename?: 'SuccessResponse', success: boolean } };

export type CreateShipmentBatchMutationVariables = Exact<{
  input: CreateShipmentBatchInput;
}>;


export type CreateShipmentBatchMutation = { __typename?: 'Mutation', createShipmentBatch?: { __typename?: 'ShipmentBatch', id: string, printFileUrl: string, createdAt: string, carrier?: { __typename?: 'Carrier', readable: string } | null, completedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null } | null };

export type ManualUserCreditsTransactionMutationVariables = Exact<{
  amountCents: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
  manualCreditChangeReason: Scalars['String']['input'];
}>;


export type ManualUserCreditsTransactionMutation = { __typename?: 'Mutation', manualUserCreditsTransaction?: { __typename?: 'UserCreditsTransaction', id: string, amountCents: number, createdAt: string, createdById?: string | null } | null };

export type MarkOrderLineItemPreparedMutationVariables = Exact<{
  data: MarkOrderLineItemPreparedInput;
}>;


export type MarkOrderLineItemPreparedMutation = { __typename?: 'Mutation', markOrderLineItemPrepared: { __typename?: 'SuccessResponse', success: boolean } };

export type MarkShipmentsAsShippedMutationVariables = Exact<{
  input: MarkShipmentsAsShippedInput;
}>;


export type MarkShipmentsAsShippedMutation = { __typename?: 'Mutation', markShipmentsAsShipped?: number | null };

export type HoldOrdersMutationVariables = Exact<{
  orderIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  data: HoldOrderInput;
}>;


export type HoldOrdersMutation = { __typename?: 'Mutation', holdOrders: Array<{ __typename?: 'UserProductOrderModel', id: string, orderId: number, kind: UserProductOrderKind, invoiceMode: InvoiceMode, status: UserProductOrderStatus, isReplacement: boolean, onHold: boolean, onHoldReasons: Array<OnHoldReason>, createdAt: string, updatedAt: string, completedAt?: string | null, cancelledAt?: string | null, fulfillmentDeadline?: string | null, lineItemsCount?: number | null, allProductLabelsVerified: boolean, sampleDiscountApplied: boolean, lockedById?: string | null, stripePaymentId?: string | null, chargeProcessingFee?: number | null, isPriorityLaneFulfillment: boolean, postPaymentBucketId?: string | null, customOnHoldReasons: Array<{ __typename?: 'CustomOnHoldReason', id: string, reason: string, resolved: boolean, createdAt: string, resolvedAt?: string | null, resolvedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, addedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null }>, user: { __typename?: 'User', id: string, username: string }, lockedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, store?: { __typename?: 'UserStore', shopUrl: string } | null, details?: { __typename?: 'UserProductOrderDetails', shippingCost?: number | null, chargedAmount?: number | null, refunded: boolean, refundAmount: number, express: boolean, charged: boolean, email?: string | null } | null, warehouseShelfBin?: { __typename?: 'WarehouseShelfBin', id: string } | null, warehouseShelfReturnBin?: { __typename?: 'WarehouseShelfReturnBin', id: string } | null, shopifyDetails?: { __typename?: 'UserProductOrderShopifyDetails', shopifyId: any, shopifyOrderName: string } | null, tiktokDetails?: { __typename?: 'UserProductOrderTiktokDetails', tiktokOrderId: string, isTiktokShipping: boolean } | null, lines: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }>, billingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, shippingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, fbaDetails?: { __typename?: 'UserProductOrderFbaDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, shippingLabelUrl?: string | null, trackingNumber?: string | null } | null, bulkDetails?: { __typename?: 'UserProductOrderBulkDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null } | null }> };

export type AdminOrderQueryVariables = Exact<{
  where?: InputMaybe<UserProductOrderWhereInput>;
}>;


export type AdminOrderQuery = { __typename?: 'Query', adminOrder?: { __typename?: 'UserProductOrderModel', id: string, orderId: number, kind: UserProductOrderKind, invoiceMode: InvoiceMode, status: UserProductOrderStatus, isReplacement: boolean, onHold: boolean, onHoldReasons: Array<OnHoldReason>, createdAt: string, updatedAt: string, completedAt?: string | null, cancelledAt?: string | null, fulfillmentDeadline?: string | null, lineItemsCount?: number | null, allProductLabelsVerified: boolean, sampleDiscountApplied: boolean, lockedById?: string | null, stripePaymentId?: string | null, chargeProcessingFee?: number | null, isPriorityLaneFulfillment: boolean, postPaymentBucketId?: string | null, customOnHoldReasons: Array<{ __typename?: 'CustomOnHoldReason', id: string, reason: string, resolved: boolean, createdAt: string, resolvedAt?: string | null, resolvedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, addedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null }>, user: { __typename?: 'User', id: string, username: string }, lockedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, store?: { __typename?: 'UserStore', shopUrl: string } | null, details?: { __typename?: 'UserProductOrderDetails', shippingCost?: number | null, chargedAmount?: number | null, refunded: boolean, refundAmount: number, express: boolean, charged: boolean, email?: string | null } | null, warehouseShelfBin?: { __typename?: 'WarehouseShelfBin', id: string } | null, warehouseShelfReturnBin?: { __typename?: 'WarehouseShelfReturnBin', id: string } | null, shopifyDetails?: { __typename?: 'UserProductOrderShopifyDetails', shopifyId: any, shopifyOrderName: string } | null, tiktokDetails?: { __typename?: 'UserProductOrderTiktokDetails', tiktokOrderId: string, isTiktokShipping: boolean } | null, lines: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }>, billingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, shippingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, fbaDetails?: { __typename?: 'UserProductOrderFbaDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, shippingLabelUrl?: string | null, trackingNumber?: string | null } | null, bulkDetails?: { __typename?: 'UserProductOrderBulkDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null } | null } | null };

export type UpdateOrderMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: OrderUpdateInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'UserProductOrderModel', id: string, orderId: number, kind: UserProductOrderKind, invoiceMode: InvoiceMode, status: UserProductOrderStatus, isReplacement: boolean, onHold: boolean, onHoldReasons: Array<OnHoldReason>, createdAt: string, updatedAt: string, completedAt?: string | null, cancelledAt?: string | null, fulfillmentDeadline?: string | null, lineItemsCount?: number | null, allProductLabelsVerified: boolean, sampleDiscountApplied: boolean, lockedById?: string | null, stripePaymentId?: string | null, chargeProcessingFee?: number | null, isPriorityLaneFulfillment: boolean, postPaymentBucketId?: string | null, customOnHoldReasons: Array<{ __typename?: 'CustomOnHoldReason', id: string, reason: string, resolved: boolean, createdAt: string, resolvedAt?: string | null, resolvedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, addedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null }>, user: { __typename?: 'User', id: string, username: string }, lockedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, store?: { __typename?: 'UserStore', shopUrl: string } | null, details?: { __typename?: 'UserProductOrderDetails', shippingCost?: number | null, chargedAmount?: number | null, refunded: boolean, refundAmount: number, express: boolean, charged: boolean, email?: string | null } | null, warehouseShelfBin?: { __typename?: 'WarehouseShelfBin', id: string } | null, warehouseShelfReturnBin?: { __typename?: 'WarehouseShelfReturnBin', id: string } | null, shopifyDetails?: { __typename?: 'UserProductOrderShopifyDetails', shopifyId: any, shopifyOrderName: string } | null, tiktokDetails?: { __typename?: 'UserProductOrderTiktokDetails', tiktokOrderId: string, isTiktokShipping: boolean } | null, lines: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, count: number, shipmentId?: string | null, reshipmentId?: string | null, isReplacement: boolean, shipbobOrderId?: string | null, userProduct: { __typename?: 'UserProductModel', name: string, defaultShippingPackageId?: string | null, isSingleSkuBundle: boolean, singleSkuBundleQuantity?: number | null, productSettings: { __typename?: 'ProductSettingsModel', sku: string, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, restockDate?: string | null, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, labelSize?: { __typename?: 'ProductLabelSize', width: number, height: number, unit: LengthUnit } | null, stockLevel?: Array<{ __typename?: 'ProductStock', warehouseId: string, fulfillmentSku: string }> | null } }, shipment?: { __typename?: 'Shipment', createdBy?: { __typename?: 'Admin', email: string } | null } | null, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string, defaultCarrierId?: string | null, defaultInternationalCarrierId?: string | null, defaultExpressCarrierId?: string | null, codeName?: string | null, countryCode: string, isShipHeroManaged: boolean } | null, roastifyOrder?: { __typename?: 'RoastifyOrder', externalId?: string | null } | null, jetpackApiOrder?: { __typename?: 'JetpackApiOrder', externalId?: string | null } | null, printBatches: Array<{ __typename?: 'PrintBatchOrderLine', printBatchId: number, countPrepared: number, confirmed?: boolean | null }>, preparedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, nameSupliful: string, priceSupliful: number, weight: number, weightUnit: WeightUnit, isPrepared: boolean, isRefunded: boolean, preparedAt?: string | null, labelVerified: boolean, labelUrl: string, productImageUrl: string, bundle: boolean, fbaUnitsPerBox?: number | null, fbaBoxWidth?: number | null, fbaBoxHeight?: number | null, fbaBoxLength?: number | null } | null, fulfillmentFees: Array<{ __typename?: 'UserProductOrderLineFulfillmentFee', count: number, fulfillmentFee: number, fulfillmentFeeType: UserProductOrderLineFulfillmentFeeType }>, subLine?: { __typename?: 'UserProductOrderSubLineItem', id: string, file: string, isPrepared: boolean, count: number } | null }>, billingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, shippingAddress?: { __typename?: 'UserProductOrderAddressModel', name: string, firstName: string, lastName: string, address1: string, address2?: string | null, city: string, zip: string, stateCode?: string | null, countryCode: string, company?: string | null, phone?: string | null } | null, fbaDetails?: { __typename?: 'UserProductOrderFbaDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, shippingLabelUrl?: string | null, trackingNumber?: string | null } | null, bulkDetails?: { __typename?: 'UserProductOrderBulkDetails', id: string, paymentStatus: UserProductOrderManualPaymentStatus, paymentKind: UserProductOrderManualPaymentKind, postPaymentDueDateDays?: number | null, postPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null } | null } };

export type AdminProductLabelSizeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminProductLabelSizeQuery = { __typename?: 'Query', findUniqueProductLabelSize?: { __typename?: 'ProductLabelSize', id: string, internalId: string, name: string, width: number, height: number, unit: LengthUnit, labelsPerProduct: number } | null };

export type UpdateProductLabelSizeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: ProductLabelSizeUpdateInput;
}>;


export type UpdateProductLabelSizeMutation = { __typename?: 'Mutation', updateOneProductLabelSize?: { __typename?: 'ProductLabelSize', id: string, internalId: string, name: string, width: number, height: number, unit: LengthUnit, labelsPerProduct: number } | null };

export type ProductLabelSizesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductLabelSizeWhereInput>;
  orderBy?: InputMaybe<Array<ProductLabelSizeOrderByWithRelationInput> | ProductLabelSizeOrderByWithRelationInput>;
}>;


export type ProductLabelSizesQuery = { __typename?: 'Query', findManyProductLabelSize: Array<{ __typename?: 'ProductLabelSize', id: string, internalId: string, name: string, width: number, height: number, unit: LengthUnit, labelsPerProduct: number }> };

export type ProductSettingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProductSettingsQuery = { __typename?: 'Query', productSettings?: { __typename?: 'ProductSettingsModel', id: string, stripeProductId?: string | null, name: string, slug: string, sku: string, isFulfillmentReady: boolean, isInExtendedCatalog: boolean, isExclusive: boolean, shelf?: string | null, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, canvaTemplate?: string | null, priceSupliful?: number | null, status: ProductStatus, restockDate?: string | null, holdOrdersWhenOutOfStock: boolean, productLabellingTechnique: ProductLabellingTechnique, discontinued: boolean, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, stockLevel?: Array<{ __typename?: 'ProductStock', id: string, warehouseId: string, quantity: number, warehouse?: { __typename?: 'Warehouse', codeName?: string | null, warehouseName: string, isShipHeroManaged: boolean } | null }> | null, fulfillmentChecklist: { __typename?: 'ProductFulfillmentChecklist', nameAndSku: boolean, stockLevel: boolean, labelSizeAndDesign: boolean, containerMockups: boolean, denverWarehouseAssigned: boolean, stripeProductCreated: boolean, shipHeroProductStockSetup: boolean } } | null };

export type ProductSettingsUpdateMutationVariables = Exact<{
  data: ProductSettingsUpdateInput;
  where: ProductSettingsWhereUniqueInput;
}>;


export type ProductSettingsUpdateMutation = { __typename?: 'Mutation', updateProductSettings: { __typename?: 'ProductSettingsModel', id: string, stripeProductId?: string | null, name: string, slug: string, sku: string, isFulfillmentReady: boolean, isInExtendedCatalog: boolean, isExclusive: boolean, shelf?: string | null, genericLabelFile?: string | null, labelMockupsFile?: string | null, labelMockupsFileV2?: string | null, canvaTemplate?: string | null, priceSupliful?: number | null, status: ProductStatus, restockDate?: string | null, holdOrdersWhenOutOfStock: boolean, productLabellingTechnique: ProductLabellingTechnique, discontinued: boolean, defaultShippingPackageId?: string | null, defaultInternationalShippingPackageId?: string | null, stockLevel?: Array<{ __typename?: 'ProductStock', id: string, warehouseId: string, quantity: number, warehouse?: { __typename?: 'Warehouse', codeName?: string | null, warehouseName: string, isShipHeroManaged: boolean } | null }> | null, fulfillmentChecklist: { __typename?: 'ProductFulfillmentChecklist', nameAndSku: boolean, stockLevel: boolean, labelSizeAndDesign: boolean, containerMockups: boolean, denverWarehouseAssigned: boolean, stripeProductCreated: boolean, shipHeroProductStockSetup: boolean } } };

export type ReshipMutationVariables = Exact<{
  input: ReshipInput;
}>;


export type ReshipMutation = { __typename?: 'Mutation', reship: { __typename?: 'Shipment', id: string } };

export type SetPriorityLaneFulfillmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: SetPriorityLaneFulfillmentInput;
}>;


export type SetPriorityLaneFulfillmentMutation = { __typename?: 'Mutation', setPriorityLaneFulfillment: { __typename?: 'UserModel', id: string, fullName: string, username: string, email: string, emailVerified?: boolean | null, failedOrderPaymentsCount: number, becameActiveAt?: string | null, createdAt: string, updatedAt: string, stripeCustomerId?: string | null, stripePostPaymentCustomerId?: string | null, isPriorityLaneFulfillment: boolean, isBrandAcceleratorParticipant: boolean, vip: boolean, isDisabled: boolean, isDeactivated: boolean, deactivationScheduledAt?: string | null, deactivatedAt?: string | null, isPostPaymentEnabled: boolean, postPaymentPeriodWeeks: number, postPaymentDueDateDays: number, postPaymentDueDateDaysType: UserPostPaymentDueDateDaysType, fbaPaymentKind: UserProductOrderManualPaymentKind, fbaPostPaymentDueDateDays?: number | null, fbaPostPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, bulkOrderPaymentKind: UserProductOrderManualPaymentKind, bulkOrderPostPaymentDueDateDays?: number | null, bulkOrderPostPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, currentSubscription?: { __typename?: 'UserSubscription', status: UserSubscriptionStatus, tier: UserSubscriptionTier } | null, certificates: Array<{ __typename?: 'ExemptaxCustomerCertificate', id: string, certificateId: number, exemptionReason: string, state: string, expirationDate: string }>, stores?: Array<{ __typename?: 'UserStoreModel', id: string, userId: string, platform: EcommercePlatform, name?: string | null, shopUrl: string, email?: string | null, address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, country?: string | null, webhooksInitialised: { __typename?: 'SuccessResponse', success: boolean, reason?: string | null }, fulfillmentService?: { __typename?: 'FulfillmentService', id: string } | null }> | null } };

export type ShipmentBatchesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ShipmentBatchWhereInput>;
}>;


export type ShipmentBatchesQuery = { __typename?: 'Query', findManyShipmentBatch: Array<{ __typename?: 'ShipmentBatch', id: string, printFileUrl: string, createdAt: string, carrier?: { __typename?: 'Carrier', readable: string } | null, completedBy?: { __typename?: 'Admin', firstName: string, lastName: string } | null }> };

export type ShipmentMarkAsReadyToShipMutationVariables = Exact<{
  shipmentId: Scalars['String']['input'];
}>;


export type ShipmentMarkAsReadyToShipMutation = { __typename?: 'Mutation', shipmentMarkAsReadyToShip: { __typename?: 'SuccessResponse', success: boolean } };

export type ShipmentMarkAsReturnedMutationVariables = Exact<{
  shipmentId: Scalars['String']['input'];
}>;


export type ShipmentMarkAsReturnedMutation = { __typename?: 'Mutation', shipmentMarkAsReturned: { __typename?: 'SuccessResponse', success: boolean } };

export type ShipmentRefundAndDeleteMutationVariables = Exact<{
  shipmentId: Scalars['String']['input'];
}>;


export type ShipmentRefundAndDeleteMutation = { __typename?: 'Mutation', shipmentRefundAndDelete: { __typename?: 'SuccessResponse', success: boolean } };

export type UserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'UserModel', id: string, fullName: string, username: string, email: string, emailVerified?: boolean | null, failedOrderPaymentsCount: number, becameActiveAt?: string | null, createdAt: string, updatedAt: string, stripeCustomerId?: string | null, stripePostPaymentCustomerId?: string | null, isPriorityLaneFulfillment: boolean, isBrandAcceleratorParticipant: boolean, vip: boolean, isDisabled: boolean, isDeactivated: boolean, deactivationScheduledAt?: string | null, deactivatedAt?: string | null, isPostPaymentEnabled: boolean, postPaymentPeriodWeeks: number, postPaymentDueDateDays: number, postPaymentDueDateDaysType: UserPostPaymentDueDateDaysType, fbaPaymentKind: UserProductOrderManualPaymentKind, fbaPostPaymentDueDateDays?: number | null, fbaPostPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, bulkOrderPaymentKind: UserProductOrderManualPaymentKind, bulkOrderPostPaymentDueDateDays?: number | null, bulkOrderPostPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, currentSubscription?: { __typename?: 'UserSubscription', status: UserSubscriptionStatus, tier: UserSubscriptionTier } | null, certificates: Array<{ __typename?: 'ExemptaxCustomerCertificate', id: string, certificateId: number, exemptionReason: string, state: string, expirationDate: string }>, stores?: Array<{ __typename?: 'UserStoreModel', id: string, userId: string, platform: EcommercePlatform, name?: string | null, shopUrl: string, email?: string | null, address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, country?: string | null, webhooksInitialised: { __typename?: 'SuccessResponse', success: boolean, reason?: string | null }, fulfillmentService?: { __typename?: 'FulfillmentService', id: string } | null }> | null } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserModel', id: string, fullName: string, username: string, email: string, emailVerified?: boolean | null, failedOrderPaymentsCount: number, becameActiveAt?: string | null, createdAt: string, updatedAt: string, stripeCustomerId?: string | null, stripePostPaymentCustomerId?: string | null, isPriorityLaneFulfillment: boolean, isBrandAcceleratorParticipant: boolean, vip: boolean, isDisabled: boolean, isDeactivated: boolean, deactivationScheduledAt?: string | null, deactivatedAt?: string | null, isPostPaymentEnabled: boolean, postPaymentPeriodWeeks: number, postPaymentDueDateDays: number, postPaymentDueDateDaysType: UserPostPaymentDueDateDaysType, fbaPaymentKind: UserProductOrderManualPaymentKind, fbaPostPaymentDueDateDays?: number | null, fbaPostPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, bulkOrderPaymentKind: UserProductOrderManualPaymentKind, bulkOrderPostPaymentDueDateDays?: number | null, bulkOrderPostPaymentDueDateDaysType?: UserPostPaymentDueDateDaysType | null, currentSubscription?: { __typename?: 'UserSubscription', status: UserSubscriptionStatus, tier: UserSubscriptionTier } | null, certificates: Array<{ __typename?: 'ExemptaxCustomerCertificate', id: string, certificateId: number, exemptionReason: string, state: string, expirationDate: string }>, stores?: Array<{ __typename?: 'UserStoreModel', id: string, userId: string, platform: EcommercePlatform, name?: string | null, shopUrl: string, email?: string | null, address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, country?: string | null, webhooksInitialised: { __typename?: 'SuccessResponse', success: boolean, reason?: string | null }, fulfillmentService?: { __typename?: 'FulfillmentService', id: string } | null }> | null } };

export type UpdateWarehouseShelfReturnBinMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: WarehouseShelfReturnBinUpdateInput;
}>;


export type UpdateWarehouseShelfReturnBinMutation = { __typename?: 'Mutation', updateOneWarehouseShelfReturnBin?: { __typename?: 'WarehouseShelfReturnBin', id: string } | null };

export type AdminWarehouseShelfQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminWarehouseShelfQuery = { __typename?: 'Query', findUniqueWarehouseShelf?: { __typename?: 'WarehouseShelf', id: string, name: string, type: WarehouseShelfType, warehouseId: string, bins: Array<{ __typename?: 'WarehouseShelfBin', id: string, number: number, userProductOrderId?: string | null }>, returnBins: Array<{ __typename?: 'WarehouseShelfReturnBin', id: string, number: number }>, warehouse?: { __typename?: 'Warehouse', warehouseName: string, codeName?: string | null } | null } | null };

export type UpdateWarehouseShelfMutationVariables = Exact<{
  where: WarehouseShelfWhereUniqueInput;
  data: UpdateWarehouseShelfInput;
}>;


export type UpdateWarehouseShelfMutation = { __typename?: 'Mutation', updateOneWarehouseShelf: { __typename?: 'WarehouseShelf', id: string, name: string, type: WarehouseShelfType, warehouseId: string, bins: Array<{ __typename?: 'WarehouseShelfBin', id: string, number: number, userProductOrderId?: string | null }>, returnBins: Array<{ __typename?: 'WarehouseShelfReturnBin', id: string, number: number }>, warehouse?: { __typename?: 'Warehouse', warehouseName: string, codeName?: string | null } | null } };

export type FindManyWarehouseShelfQueryVariables = Exact<{
  where?: InputMaybe<WarehouseShelfWhereInput>;
  orderBy?: InputMaybe<Array<WarehouseShelfOrderByWithRelationInput> | WarehouseShelfOrderByWithRelationInput>;
}>;


export type FindManyWarehouseShelfQuery = { __typename?: 'Query', findManyWarehouseShelf: Array<{ __typename?: 'WarehouseShelf', id: string, name: string, type: WarehouseShelfType, warehouseId: string, bins: Array<{ __typename?: 'WarehouseShelfBin', id: string, number: number, userProductOrderId?: string | null }>, returnBins: Array<{ __typename?: 'WarehouseShelfReturnBin', id: string, number: number }>, warehouse?: { __typename?: 'Warehouse', warehouseName: string, codeName?: string | null } | null }> };

export type DeleteProductLabelSizeMutationVariables = Exact<{
  where: ProductLabelSizeWhereUniqueInput;
}>;


export type DeleteProductLabelSizeMutation = { __typename?: 'Mutation', deleteOneProductLabelSize?: { __typename?: 'ProductLabelSize', id: string } | null };

export type ProductStockFragment = { __typename?: 'ProductStock', id: string, name: string, sku: string, fulfillmentSku: string, quantity: number, pendingItems: number, warehouse?: { __typename?: 'Warehouse', codeName?: string | null, isShipHeroManaged: boolean } | null };

export type ProductsStockQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ProductStockOrderByWithRelationInput> | ProductStockOrderByWithRelationInput>;
}>;


export type ProductsStockQuery = { __typename?: 'Query', productsStock: { __typename?: 'FindManyProductStockResponse', count: number, items: Array<{ __typename?: 'ProductStock', id: string, name: string, sku: string, fulfillmentSku: string, quantity: number, pendingItems: number, warehouse?: { __typename?: 'Warehouse', codeName?: string | null, isShipHeroManaged: boolean } | null }> } };

export type AdminWarehouseShelvesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WarehouseShelfOrderByWithRelationInput> | WarehouseShelfOrderByWithRelationInput>;
  where?: InputMaybe<WarehouseShelfWhereInput>;
}>;


export type AdminWarehouseShelvesQuery = { __typename?: 'Query', findManyWarehouseShelf: Array<{ __typename?: 'WarehouseShelf', id: string, name: string, type: WarehouseShelfType, warehouseId: string, bins: Array<{ __typename?: 'WarehouseShelfBin', id: string, number: number, userProductOrderId?: string | null }>, returnBins: Array<{ __typename?: 'WarehouseShelfReturnBin', id: string, number: number }>, warehouse?: { __typename?: 'Warehouse', warehouseName: string, codeName?: string | null } | null }> };

export type DeleteWarehouseShelfMutationVariables = Exact<{
  where: WarehouseShelfWhereUniqueInput;
}>;


export type DeleteWarehouseShelfMutation = { __typename?: 'Mutation', deleteOneWarehouseShelf?: { __typename?: 'WarehouseShelf', id: string } | null };

export type PrintFileQueueQueryVariables = Exact<{
  data: PrintFileQueueInput;
}>;


export type PrintFileQueueQuery = { __typename?: 'Query', printFileQueue?: Array<{ __typename?: 'PrintFileQueueResponse', id: string, internalId: string, printFilesBySku: Array<{ __typename?: 'PrintFilesBySku', sku: string, name?: string | null, total: number, totalPriority: number, labellingTechnique: ProductLabellingTechnique, activeBatches: Array<number>, productForm?: { __typename?: 'SanityProductForm', id: string, name: string, slug?: string | null } | null }> }> | null };

export type PrintFileFilterUserListQueryVariables = Exact<{
  data: PrintFileFilterUserListInput;
}>;


export type PrintFileFilterUserListQuery = { __typename?: 'Query', printFileFilterUserList: Array<{ __typename?: 'BasicUserModel', id: string, username: string, fullName?: string | null, count?: number | null }> };

export type PrintFileFilterUserBasicInfoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PrintFileFilterUserBasicInfoQuery = { __typename?: 'Query', printFileFilterUserBasicInfo: { __typename?: 'BasicUserModel', username: string, fullName?: string | null } };

export type PrintFileFilterOrderKindListQueryVariables = Exact<{
  data: PrintFileFilterOrderKindsListInput;
}>;


export type PrintFileFilterOrderKindListQuery = { __typename?: 'Query', printFileFilterOrderKindList: Array<string> };

export type AdminShipmentsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentOrderByWithRelationInput> | ShipmentOrderByWithRelationInput>;
  where?: InputMaybe<ShipmentWhereInput>;
}>;


export type AdminShipmentsQuery = { __typename?: 'Query', shipments: { __typename?: 'FindManyShipmentResponse', count: number, items: Array<{ __typename?: 'Shipment', id: string, shipmentWeight: number, status: ShipmentStatus, trackingNumber: string, trackingUrl: string, createdAt: any, createdById: string, completedById?: string | null, warehouseName?: string | null, carrier?: { __typename?: 'Carrier', name: string } | null, userProductOrder?: { __typename?: 'UserProductOrder', orderId: number, kind: UserProductOrderKind } | null }> } };

export type SetLineItemCountPreparedInBulkMutationVariables = Exact<{
  data: SetLineItemCountPreparedInBulkInput;
}>;


export type SetLineItemCountPreparedInBulkMutation = { __typename?: 'Mutation', setLineItemCountPreparedInBulk: { __typename?: 'SetLineItemCountPreparedInBulkResponse', results: Array<{ __typename?: 'LineItemResult', lineId: string, success: { __typename?: 'SuccessResponse', success: boolean } }> } };

export type CreateQuickShipmentsFromPrintBatchMutationVariables = Exact<{
  data: CreateQuickShipmentsFromPrintBatchInput;
}>;


export type CreateQuickShipmentsFromPrintBatchMutation = { __typename?: 'Mutation', createQuickShipmentsFromPrintBatch: { __typename?: 'CreateQuickShipmentsFromPrintBatchResponse', countFailed: number, countSucceeded: number } };

export type FindWarehouseShelfDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FindWarehouseShelfDetailsQuery = { __typename?: 'Query', findUniqueWarehouseShelf?: { __typename?: 'WarehouseShelf', id: string, name: string, bins: Array<{ __typename?: 'WarehouseShelfBin', id: string, number: number, userProductOrderId?: string | null, details: { __typename?: 'WarehouseShelfBinDetailsModel', isReady: boolean, isOnHold: boolean, isPriority: boolean, preparedItemsCount?: number | null, itemsCount?: number | null } }> } | null };

export type AdminOrdersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductOrderOrderByWithRelationInput> | UserProductOrderOrderByWithRelationInput>;
  where?: InputMaybe<UserProductOrderWhereInput>;
}>;


export type AdminOrdersQuery = { __typename?: 'Query', adminOrders: { __typename?: 'UserProductOrderResponse', total: number, items: Array<{ __typename?: 'UserProductOrderModel', id: string, orderId: number, kind: UserProductOrderKind, status: UserProductOrderStatus, onHold: boolean, createdAt: string, fulfillmentDeadline?: string | null, isPriorityLaneFulfillment: boolean, lineItemsCount?: number | null, allProductLabelsVerified: boolean, itemCountTotal: number, shippingAddress?: { __typename?: 'UserProductOrderAddressModel', countryCode: string } | null, user: { __typename?: 'User', id: string, username: string, email: string }, lines: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, shipmentId?: string | null, count: number, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, isPrepared: boolean } | null }>, details?: { __typename?: 'UserProductOrderDetails', charged: boolean, express: boolean } | null, itemCountByWarehouse: Array<{ __typename?: 'UserProductOrderItemCountByWarehouse', count: number, warehouseId: string }> }> } };

export type ReturnedAdminOrdersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductOrderOrderByWithRelationInput> | UserProductOrderOrderByWithRelationInput>;
  where?: InputMaybe<UserProductOrderWhereInput>;
}>;


export type ReturnedAdminOrdersQuery = { __typename?: 'Query', returnedAdminOrders: { __typename?: 'UserProductOrderResponse', total: number, items: Array<{ __typename?: 'UserProductOrderModel', id: string, orderId: number, kind: UserProductOrderKind, status: UserProductOrderStatus, onHold: boolean, createdAt: string, fulfillmentDeadline?: string | null, isPriorityLaneFulfillment: boolean, lineItemsCount?: number | null, allProductLabelsVerified: boolean, itemCountTotal: number, shippingAddress?: { __typename?: 'UserProductOrderAddressModel', countryCode: string } | null, user: { __typename?: 'User', id: string, username: string, email: string }, lines: Array<{ __typename?: 'UserProductOrderLineModel', id: string, userProductId: string, shipmentId?: string | null, count: number, warehouse?: { __typename?: 'Warehouse', id: string, warehouseName: string } | null, details?: { __typename?: 'UserProductOrderLineDetails', title: string, isPrepared: boolean } | null }>, details?: { __typename?: 'UserProductOrderDetails', charged: boolean, express: boolean } | null, itemCountByWarehouse: Array<{ __typename?: 'UserProductOrderItemCountByWarehouse', count: number, warehouseId: string }> }> } };

export const ProductStockFragmentFragmentDoc = gql`
    fragment ProductStockFragment on ProductStock {
  id
  quantity
  isAvailable
  priority
  lastStockSnapshotDate
  sku
  fulfillmentSku
  warehouse {
    id
    codeName
    warehouseName
    isDisabled
    isShipHeroManaged
  }
}
    `;
export const ExtendedProductAdminListItemFragmentDoc = gql`
    fragment ExtendedProductAdminListItem on ProductSettingsModel {
  id
  name
  slug
  sku
  isFulfillmentReady
  fulfillmentChecklist {
    nameAndSku
    stockLevel
    labelSizeAndDesign
    containerMockups
    denverWarehouseAssigned
    stripeProductCreated
    shipHeroProductStockSetup
  }
}
    `;
export const ProductPublisherFragmentDoc = gql`
    fragment ProductPublisher on ProductPublisherModel {
  email
  fullName
}
    `;
export const ShipmentListItemFragmentDoc = gql`
    fragment ShipmentListItem on Shipment {
  id
  carrier {
    name
  }
  shipmentWeight
  userProductOrder {
    orderId
    kind
  }
  status
  trackingNumber
  trackingUrl
  createdAt
  createdById
  completedById
  warehouseName
}
    `;
export const ShippingPackageAdminItemFragmentDoc = gql`
    fragment ShippingPackageAdminItem on ShippingPackage {
  id
  name
}
    `;
export const UserProductOrderSubLineAdminItemFragmentDoc = gql`
    fragment UserProductOrderSubLineAdminItem on UserProductOrderSubLineItem {
  id
  file
  isPrepared
  count
}
    `;
export const UserProductOrderLineAdminItemFragmentDoc = gql`
    fragment UserProductOrderLineAdminItem on UserProductOrderLineModel {
  id
  userProductId
  userProduct {
    name
    defaultShippingPackageId
    isSingleSkuBundle
    singleSkuBundleQuantity
    productSettings {
      sku
      genericLabelFile
      labelMockupsFile
      labelMockupsFileV2
      restockDate
      labelSize {
        width
        height
        unit
      }
      defaultShippingPackageId
      defaultInternationalShippingPackageId
      stockLevel {
        warehouseId
        fulfillmentSku
      }
    }
  }
  count
  shipmentId
  shipment {
    createdBy {
      email
    }
  }
  reshipmentId
  isReplacement
  warehouse {
    id
    warehouseName
    defaultCarrierId
    defaultInternationalCarrierId
    defaultExpressCarrierId
    codeName
    countryCode
    isShipHeroManaged
  }
  shipbobOrderId
  roastifyOrder {
    externalId
  }
  jetpackApiOrder {
    externalId
  }
  printBatches {
    printBatchId
    countPrepared
    confirmed
  }
  preparedBy {
    firstName
    lastName
  }
  details {
    title
    nameSupliful
    priceSupliful
    weight
    weightUnit
    isPrepared
    isRefunded
    preparedAt
    labelVerified
    labelUrl
    productImageUrl
    bundle
    fbaUnitsPerBox
    fbaBoxWidth
    fbaBoxHeight
    fbaBoxLength
  }
  fulfillmentFees {
    count
    fulfillmentFee
    fulfillmentFeeType
  }
  subLine {
    ...UserProductOrderSubLineAdminItem
  }
}
    ${UserProductOrderSubLineAdminItemFragmentDoc}`;
export const ShipmentOrderItemFragmentDoc = gql`
    fragment ShipmentOrderItem on Shipment {
  id
  status
  completed
  completedAt
  sent
  replacement
  carrierId
  carrier {
    name
    externalId
  }
  trackingNumber
  trackingUrl
  shippingPackage {
    ...ShippingPackageAdminItem
  }
  shippingLabelCreated
  shippingLabelUrl
  reshippingCost
  createdAt
  createdBy {
    email
  }
  userProductOrder {
    kind
  }
  userProductOrderLines {
    ...UserProductOrderLineAdminItem
  }
  reshippedOrderLines {
    ...UserProductOrderLineAdminItem
  }
  reshipmentId
}
    ${ShippingPackageAdminItemFragmentDoc}
${UserProductOrderLineAdminItemFragmentDoc}`;
export const OrderAdminListItemFragmentDoc = gql`
    fragment OrderAdminListItem on UserProductOrderModel {
  id
  orderId
  kind
  status
  onHold
  createdAt
  fulfillmentDeadline
  isPriorityLaneFulfillment
  lineItemsCount
  allProductLabelsVerified
  shippingAddress {
    countryCode
  }
  user {
    id
    username
    email
  }
  lines {
    id
    userProductId
    shipmentId
    count
    warehouse {
      id
      warehouseName
    }
    details {
      title
      isPrepared
    }
  }
  details {
    charged
    express
  }
  itemCountTotal
  itemCountByWarehouse {
    count
    warehouseId
  }
}
    `;
export const CustomOnHoldReasonFragmentDoc = gql`
    fragment CustomOnHoldReason on CustomOnHoldReason {
  id
  reason
  resolved
  resolvedBy {
    firstName
    lastName
  }
  addedBy {
    firstName
    lastName
  }
  createdAt
  resolvedAt
}
    `;
export const UserProductOrderAddressFragmentDoc = gql`
    fragment UserProductOrderAddress on UserProductOrderAddressModel {
  name
  firstName
  lastName
  address1
  address2
  city
  zip
  stateCode
  countryCode
  company
  phone
}
    `;
export const OrderAdminBrowseItemFragmentDoc = gql`
    fragment OrderAdminBrowseItem on UserProductOrderModel {
  id
  orderId
  kind
  invoiceMode
  status
  isReplacement
  onHold
  onHoldReasons
  customOnHoldReasons {
    ...CustomOnHoldReason
  }
  createdAt
  updatedAt
  completedAt
  cancelledAt
  fulfillmentDeadline
  lineItemsCount
  allProductLabelsVerified
  sampleDiscountApplied
  user {
    id
    username
  }
  lockedById
  lockedBy {
    firstName
    lastName
  }
  store {
    shopUrl
  }
  stripePaymentId
  chargeProcessingFee
  details {
    shippingCost
    chargedAmount
    refunded
    refundAmount
    express
    charged
    email
  }
  warehouseShelfBin {
    id
  }
  warehouseShelfReturnBin {
    id
  }
  shopifyDetails {
    shopifyId
    shopifyOrderName
  }
  tiktokDetails {
    tiktokOrderId
    isTiktokShipping
  }
  lines {
    ...UserProductOrderLineAdminItem
  }
  billingAddress {
    ...UserProductOrderAddress
  }
  shippingAddress {
    ...UserProductOrderAddress
  }
  isPriorityLaneFulfillment
  postPaymentBucketId
  fbaDetails {
    id
    paymentStatus
    paymentKind
    postPaymentDueDateDays
    postPaymentDueDateDaysType
    shippingLabelUrl
    trackingNumber
  }
  bulkDetails {
    id
    paymentStatus
    paymentKind
    postPaymentDueDateDays
    postPaymentDueDateDaysType
  }
}
    ${CustomOnHoldReasonFragmentDoc}
${UserProductOrderLineAdminItemFragmentDoc}
${UserProductOrderAddressFragmentDoc}`;
export const LabelSizeFragmentDoc = gql`
    fragment LabelSize on ProductLabelSize {
  id
  internalId
  name
  width
  height
  unit
}
    `;
export const UserCertificateAdminItemFragmentDoc = gql`
    fragment UserCertificateAdminItem on ExemptaxCustomerCertificate {
  id
  certificateId
  exemptionReason
  state
  expirationDate
}
    `;
export const UserStoreAdminItemFragmentDoc = gql`
    fragment UserStoreAdminItem on UserStoreModel {
  id
  userId
  platform
  name
  shopUrl
  email
  address1
  address2
  city
  zip
  country
  webhooksInitialised {
    success
    reason
  }
  fulfillmentService {
    id
  }
}
    `;
export const UserAdminItemFragmentDoc = gql`
    fragment UserAdminItem on UserModel {
  id
  fullName
  username
  email
  emailVerified
  failedOrderPaymentsCount
  becameActiveAt
  createdAt
  updatedAt
  stripeCustomerId
  stripePostPaymentCustomerId
  currentSubscription {
    status
    tier
  }
  certificates {
    ...UserCertificateAdminItem
  }
  stores {
    ...UserStoreAdminItem
  }
  isPriorityLaneFulfillment
  isBrandAcceleratorParticipant
  vip
  isDisabled
  isDeactivated
  deactivationScheduledAt
  deactivatedAt
  isPostPaymentEnabled
  postPaymentPeriodWeeks
  postPaymentDueDateDays
  postPaymentDueDateDaysType
  fbaPaymentKind
  fbaPostPaymentDueDateDays
  fbaPostPaymentDueDateDaysType
  bulkOrderPaymentKind
  bulkOrderPostPaymentDueDateDays
  bulkOrderPostPaymentDueDateDaysType
}
    ${UserCertificateAdminItemFragmentDoc}
${UserStoreAdminItemFragmentDoc}`;
export const ProductAdminSettingsFragmentDoc = gql`
    fragment ProductAdminSettings on ProductSettingsModel {
  id
  stripeProductId
  name
  slug
  sku
  isFulfillmentReady
  isInExtendedCatalog
  isExclusive
  shelf
  genericLabelFile
  labelMockupsFile
  labelMockupsFileV2
  canvaTemplate
  priceSupliful
  status
  restockDate
  holdOrdersWhenOutOfStock
  productLabellingTechnique
  stockLevel {
    id
    warehouseId
    warehouse {
      codeName
      warehouseName
      isShipHeroManaged
    }
    quantity
  }
  discontinued
  defaultShippingPackageId
  defaultInternationalShippingPackageId
  fulfillmentChecklist {
    nameAndSku
    stockLevel
    labelSizeAndDesign
    containerMockups
    denverWarehouseAssigned
    stripeProductCreated
    shipHeroProductStockSetup
  }
}
    `;
export const ProductLabelSizeFragmentDoc = gql`
    fragment ProductLabelSize on ProductLabelSize {
  id
  internalId
  name
  width
  height
  unit
  labelsPerProduct
}
    `;
export const ShipmentBatchFragmentDoc = gql`
    fragment ShipmentBatch on ShipmentBatch {
  id
  carrier {
    readable
  }
  completedBy {
    firstName
    lastName
  }
  printFileUrl
  createdAt
}
    `;
export const WarehouseShelfFragmentDoc = gql`
    fragment WarehouseShelf on WarehouseShelf {
  id
  name
  type
  bins {
    id
    number
    userProductOrderId
  }
  returnBins {
    id
    number
  }
  warehouseId
  warehouse {
    warehouseName
    codeName
  }
}
    `;
export const PrintFileQueueFragmentDoc = gql`
    fragment PrintFileQueue on PrintFileQueueResponse {
  id
  internalId
  printFilesBySku {
    sku
    name
    productForm {
      id
      name
      slug
    }
    total
    totalPriority
    labellingTechnique
    activeBatches
  }
}
    `;
export const UserCreditsTransactionFragmentDoc = gql`
    fragment UserCreditsTransaction on UserCreditsTransaction {
  id
  amountCents
  createdAt
  createdById
}
    `;
export const DigitalServiceProductFragmentDoc = gql`
    fragment DigitalServiceProduct on DigitalServiceProduct {
  stripeProductId
  hubspotProductId
  isActive
  createdAt
  updatedAt
  createdBy {
    email
  }
  createdById
  refundPolicy
}
    `;
export const AdminDigitalServiceProductListItemFragmentDoc = gql`
    fragment AdminDigitalServiceProductListItem on AdminDigitalServiceProductListItem {
  digitalServiceProduct {
    ...DigitalServiceProduct
  }
  stripeProduct {
    id
    name
    description
    images
  }
}
    ${DigitalServiceProductFragmentDoc}`;
export const ProductSettingsFragmentDoc = gql`
    fragment ProductSettings on ProductSettingsModel {
  isInExtendedCatalog
  shelf
  holdOrdersWhenOutOfStock
}
    `;
export const ProductAdminListItemFragmentDoc = gql`
    fragment ProductAdminListItem on ProductSettingsModel {
  id
  name
  slug
  sku
  discontinued
  isFulfillmentReady
  priceSupliful
  stockLevel {
    id
    warehouseId
    warehouse {
      codeName
      warehouseName
      isShipHeroManaged
    }
    quantity
    fulfillmentSku
  }
  restockDate
  fulfillmentChecklist {
    nameAndSku
    stockLevel
    labelSizeAndDesign
    containerMockups
    denverWarehouseAssigned
    stripeProductCreated
    shipHeroProductStockSetup
  }
  ...ProductSettings
}
    ${ProductSettingsFragmentDoc}`;
export const ProductStockFragmentDoc = gql`
    fragment ProductStock on ProductStock {
  id
  name
  sku
  fulfillmentSku
  quantity
  pendingItems
  warehouse {
    codeName
    isShipHeroManaged
  }
}
    `;
export const AdminOrdersExportDocument = gql`
    query AdminOrdersExport($skip: Int, $take: Int, $orderBy: [UserProductOrderOrderByWithRelationInput!], $where: UserProductOrderWhereInput) {
  adminOrders(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    items {
      id
      orderId
      createdAt
      fulfillmentDeadline
      lines {
        id
        count
        userProduct {
          productSettings {
            sku
          }
        }
        details {
          title
          isPrepared
          nameSupliful
        }
        printBatches {
          printBatchId
          countPrepared
          confirmed
        }
      }
    }
  }
}
    `;
export function useAdminOrdersExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminOrdersExportQuery, AdminOrdersExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminOrdersExportQuery, AdminOrdersExportQueryVariables>(AdminOrdersExportDocument, options);
      }
export function useAdminOrdersExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminOrdersExportQuery, AdminOrdersExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminOrdersExportQuery, AdminOrdersExportQueryVariables>(AdminOrdersExportDocument, options);
        }
export function useAdminOrdersExportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminOrdersExportQuery, AdminOrdersExportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminOrdersExportQuery, AdminOrdersExportQueryVariables>(AdminOrdersExportDocument, options);
        }
export type AdminOrdersExportQueryHookResult = ReturnType<typeof useAdminOrdersExportQuery>;
export type AdminOrdersExportLazyQueryHookResult = ReturnType<typeof useAdminOrdersExportLazyQuery>;
export type AdminOrdersExportSuspenseQueryHookResult = ReturnType<typeof useAdminOrdersExportSuspenseQuery>;
export type AdminOrdersExportQueryResult = Apollo.QueryResult<AdminOrdersExportQuery, AdminOrdersExportQueryVariables>;
export const CreateBulkShippingDocument = gql`
    mutation CreateBulkShipping($data: CreateBulkShippingInput!) {
  createBulkShipping(data: $data) {
    bulkShippingId
    results {
      id
      order {
        id
        orderId
      }
      errorMessage
    }
  }
}
    `;
export function useCreateBulkShippingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBulkShippingMutation, CreateBulkShippingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBulkShippingMutation, CreateBulkShippingMutationVariables>(CreateBulkShippingDocument, options);
      }
export type CreateBulkShippingMutationHookResult = ReturnType<typeof useCreateBulkShippingMutation>;
export type CreateBulkShippingMutationResult = Apollo.MutationResult<CreateBulkShippingMutation>;
export type CreateBulkShippingMutationOptions = Apollo.BaseMutationOptions<CreateBulkShippingMutation, CreateBulkShippingMutationVariables>;
export const GetBulkShippingDetailsDocument = gql`
    query GetBulkShippingDetails($bulkShippingId: Float!) {
  getBulkShippingDetails(bulkShippingId: $bulkShippingId) {
    id
    productImageUrl
    productSku
    shipments {
      id
      status
      completed
      trackingNumber
      trackingUrl
      carrier {
        name
      }
      shippingPackage {
        name
      }
      shippingLabelUrl
      userProductOrder {
        id
        orderId
        warehouseShelfBins {
          id
        }
        warehouseShelfReturnBin {
          id
        }
      }
      userProductOrderLines {
        count
      }
    }
  }
}
    `;
export function useGetBulkShippingDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBulkShippingDetailsQuery, GetBulkShippingDetailsQueryVariables> & ({ variables: GetBulkShippingDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBulkShippingDetailsQuery, GetBulkShippingDetailsQueryVariables>(GetBulkShippingDetailsDocument, options);
      }
export function useGetBulkShippingDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBulkShippingDetailsQuery, GetBulkShippingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBulkShippingDetailsQuery, GetBulkShippingDetailsQueryVariables>(GetBulkShippingDetailsDocument, options);
        }
export function useGetBulkShippingDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBulkShippingDetailsQuery, GetBulkShippingDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBulkShippingDetailsQuery, GetBulkShippingDetailsQueryVariables>(GetBulkShippingDetailsDocument, options);
        }
export type GetBulkShippingDetailsQueryHookResult = ReturnType<typeof useGetBulkShippingDetailsQuery>;
export type GetBulkShippingDetailsLazyQueryHookResult = ReturnType<typeof useGetBulkShippingDetailsLazyQuery>;
export type GetBulkShippingDetailsSuspenseQueryHookResult = ReturnType<typeof useGetBulkShippingDetailsSuspenseQuery>;
export type GetBulkShippingDetailsQueryResult = Apollo.QueryResult<GetBulkShippingDetailsQuery, GetBulkShippingDetailsQueryVariables>;
export const MarkBulkShippingShipmentsAsReadyToShipDocument = gql`
    mutation MarkBulkShippingShipmentsAsReadyToShip($bulkShippingId: Float!) {
  markBulkShippingShipmentsAsReadyToShip(bulkShippingId: $bulkShippingId) {
    success
    reason
  }
}
    `;
export function useMarkBulkShippingShipmentsAsReadyToShipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkBulkShippingShipmentsAsReadyToShipMutation, MarkBulkShippingShipmentsAsReadyToShipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkBulkShippingShipmentsAsReadyToShipMutation, MarkBulkShippingShipmentsAsReadyToShipMutationVariables>(MarkBulkShippingShipmentsAsReadyToShipDocument, options);
      }
export type MarkBulkShippingShipmentsAsReadyToShipMutationHookResult = ReturnType<typeof useMarkBulkShippingShipmentsAsReadyToShipMutation>;
export type MarkBulkShippingShipmentsAsReadyToShipMutationResult = Apollo.MutationResult<MarkBulkShippingShipmentsAsReadyToShipMutation>;
export type MarkBulkShippingShipmentsAsReadyToShipMutationOptions = Apollo.BaseMutationOptions<MarkBulkShippingShipmentsAsReadyToShipMutation, MarkBulkShippingShipmentsAsReadyToShipMutationVariables>;
export const GetLatestBulkShippingDocument = gql`
    query GetLatestBulkShipping {
  getLatestBulkShipping {
    id
  }
}
    `;
export function useGetLatestBulkShippingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLatestBulkShippingQuery, GetLatestBulkShippingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLatestBulkShippingQuery, GetLatestBulkShippingQueryVariables>(GetLatestBulkShippingDocument, options);
      }
export function useGetLatestBulkShippingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLatestBulkShippingQuery, GetLatestBulkShippingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLatestBulkShippingQuery, GetLatestBulkShippingQueryVariables>(GetLatestBulkShippingDocument, options);
        }
export function useGetLatestBulkShippingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLatestBulkShippingQuery, GetLatestBulkShippingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLatestBulkShippingQuery, GetLatestBulkShippingQueryVariables>(GetLatestBulkShippingDocument, options);
        }
export type GetLatestBulkShippingQueryHookResult = ReturnType<typeof useGetLatestBulkShippingQuery>;
export type GetLatestBulkShippingLazyQueryHookResult = ReturnType<typeof useGetLatestBulkShippingLazyQuery>;
export type GetLatestBulkShippingSuspenseQueryHookResult = ReturnType<typeof useGetLatestBulkShippingSuspenseQuery>;
export type GetLatestBulkShippingQueryResult = Apollo.QueryResult<GetLatestBulkShippingQuery, GetLatestBulkShippingQueryVariables>;
export const GetBulkShippingSuggestionsDocument = gql`
    query GetBulkShippingSuggestions {
  getBulkShippingSuggestions {
    id
    orders {
      id
      orderId
      linesToShip {
        id
        count
      }
    }
    user {
      id
      fullName
    }
    userProducts {
      count
      userProduct {
        id
        name
        imageUrl
        defaultShippingPackageId
        productSettings {
          defaultShippingPackageId
        }
      }
    }
    carrier {
      id
      name
      logo
    }
    serviceLevel
  }
}
    `;
export function useGetBulkShippingSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBulkShippingSuggestionsQuery, GetBulkShippingSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBulkShippingSuggestionsQuery, GetBulkShippingSuggestionsQueryVariables>(GetBulkShippingSuggestionsDocument, options);
      }
export function useGetBulkShippingSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBulkShippingSuggestionsQuery, GetBulkShippingSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBulkShippingSuggestionsQuery, GetBulkShippingSuggestionsQueryVariables>(GetBulkShippingSuggestionsDocument, options);
        }
export function useGetBulkShippingSuggestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBulkShippingSuggestionsQuery, GetBulkShippingSuggestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBulkShippingSuggestionsQuery, GetBulkShippingSuggestionsQueryVariables>(GetBulkShippingSuggestionsDocument, options);
        }
export type GetBulkShippingSuggestionsQueryHookResult = ReturnType<typeof useGetBulkShippingSuggestionsQuery>;
export type GetBulkShippingSuggestionsLazyQueryHookResult = ReturnType<typeof useGetBulkShippingSuggestionsLazyQuery>;
export type GetBulkShippingSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetBulkShippingSuggestionsSuspenseQuery>;
export type GetBulkShippingSuggestionsQueryResult = Apollo.QueryResult<GetBulkShippingSuggestionsQuery, GetBulkShippingSuggestionsQueryVariables>;
export const CreateDigitalServiceProductDocument = gql`
    mutation CreateDigitalServiceProduct($input: DigitalServiceProductCreateWithoutCreatedByInput!) {
  createDigitalServiceProduct(input: $input) {
    ...DigitalServiceProduct
  }
}
    ${DigitalServiceProductFragmentDoc}`;
export function useCreateDigitalServiceProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDigitalServiceProductMutation, CreateDigitalServiceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDigitalServiceProductMutation, CreateDigitalServiceProductMutationVariables>(CreateDigitalServiceProductDocument, options);
      }
export type CreateDigitalServiceProductMutationHookResult = ReturnType<typeof useCreateDigitalServiceProductMutation>;
export type CreateDigitalServiceProductMutationResult = Apollo.MutationResult<CreateDigitalServiceProductMutation>;
export type CreateDigitalServiceProductMutationOptions = Apollo.BaseMutationOptions<CreateDigitalServiceProductMutation, CreateDigitalServiceProductMutationVariables>;
export const UpdateDigitalServiceProductDocument = gql`
    mutation UpdateDigitalServiceProduct($where: DigitalServiceProductWhereUniqueInput!, $data: DigitalServiceProductUpdateInput!) {
  updateOneDigitalServiceProduct(where: $where, data: $data) {
    ...DigitalServiceProduct
  }
}
    ${DigitalServiceProductFragmentDoc}`;
export function useUpdateDigitalServiceProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDigitalServiceProductMutation, UpdateDigitalServiceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDigitalServiceProductMutation, UpdateDigitalServiceProductMutationVariables>(UpdateDigitalServiceProductDocument, options);
      }
export type UpdateDigitalServiceProductMutationHookResult = ReturnType<typeof useUpdateDigitalServiceProductMutation>;
export type UpdateDigitalServiceProductMutationResult = Apollo.MutationResult<UpdateDigitalServiceProductMutation>;
export type UpdateDigitalServiceProductMutationOptions = Apollo.BaseMutationOptions<UpdateDigitalServiceProductMutation, UpdateDigitalServiceProductMutationVariables>;
export const UserTransactionsDocument = gql`
    query UserTransactions($userId: ID!, $days: Int, $type: TransactionType, $paymentType: PaymentType, $orderId: String, $adminId: ID) {
  userTransactions(
    userId: $userId
    days: $days
    type: $type
    paymentType: $paymentType
    orderId: $orderId
    adminId: $adminId
  ) {
    id
    createdBy {
      email
    }
    amountCents
    balanceAfter
    manualCreditChangeReason
    reason
    status
    transactionMethod
    description
    createdAt
  }
}
    `;
export function useUserTransactionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserTransactionsQuery, UserTransactionsQueryVariables> & ({ variables: UserTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserTransactionsQuery, UserTransactionsQueryVariables>(UserTransactionsDocument, options);
      }
export function useUserTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserTransactionsQuery, UserTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserTransactionsQuery, UserTransactionsQueryVariables>(UserTransactionsDocument, options);
        }
export function useUserTransactionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserTransactionsQuery, UserTransactionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserTransactionsQuery, UserTransactionsQueryVariables>(UserTransactionsDocument, options);
        }
export type UserTransactionsQueryHookResult = ReturnType<typeof useUserTransactionsQuery>;
export type UserTransactionsLazyQueryHookResult = ReturnType<typeof useUserTransactionsLazyQuery>;
export type UserTransactionsSuspenseQueryHookResult = ReturnType<typeof useUserTransactionsSuspenseQuery>;
export type UserTransactionsQueryResult = Apollo.QueryResult<UserTransactionsQuery, UserTransactionsQueryVariables>;
export const ShopifyStoreActionDocument = gql`
    mutation ShopifyStoreAction($data: ShopifyStoreActionInput!) {
  shopifyStoreAction(data: $data) {
    success
    reason
  }
}
    `;
export function useShopifyStoreActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShopifyStoreActionMutation, ShopifyStoreActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShopifyStoreActionMutation, ShopifyStoreActionMutationVariables>(ShopifyStoreActionDocument, options);
      }
export type ShopifyStoreActionMutationHookResult = ReturnType<typeof useShopifyStoreActionMutation>;
export type ShopifyStoreActionMutationResult = Apollo.MutationResult<ShopifyStoreActionMutation>;
export type ShopifyStoreActionMutationOptions = Apollo.BaseMutationOptions<ShopifyStoreActionMutation, ShopifyStoreActionMutationVariables>;
export const CreateShipmentDocument = gql`
    mutation CreateShipment($input: CreateShipmentInput!) {
  createShipment(input: $input) {
    id
    shippingLabelUrl
  }
}
    `;
export function useCreateShipmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateShipmentMutation, CreateShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateShipmentMutation, CreateShipmentMutationVariables>(CreateShipmentDocument, options);
      }
export type CreateShipmentMutationHookResult = ReturnType<typeof useCreateShipmentMutation>;
export type CreateShipmentMutationResult = Apollo.MutationResult<CreateShipmentMutation>;
export type CreateShipmentMutationOptions = Apollo.BaseMutationOptions<CreateShipmentMutation, CreateShipmentMutationVariables>;
export const OwnAutoGeneratedShipmentDocument = gql`
    mutation OwnAutoGeneratedShipment($shipmentId: String!) {
  ownAutoGeneratedShipment(shipmentId: $shipmentId) {
    ...ShipmentOrderItem
  }
}
    ${ShipmentOrderItemFragmentDoc}`;
export function useOwnAutoGeneratedShipmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OwnAutoGeneratedShipmentMutation, OwnAutoGeneratedShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OwnAutoGeneratedShipmentMutation, OwnAutoGeneratedShipmentMutationVariables>(OwnAutoGeneratedShipmentDocument, options);
      }
export type OwnAutoGeneratedShipmentMutationHookResult = ReturnType<typeof useOwnAutoGeneratedShipmentMutation>;
export type OwnAutoGeneratedShipmentMutationResult = Apollo.MutationResult<OwnAutoGeneratedShipmentMutation>;
export type OwnAutoGeneratedShipmentMutationOptions = Apollo.BaseMutationOptions<OwnAutoGeneratedShipmentMutation, OwnAutoGeneratedShipmentMutationVariables>;
export const ReportLabelIssueDocument = gql`
    mutation ReportLabelIssue($data: ReportLabelIssueInput!) {
  reportLabelIssue(data: $data) {
    success
  }
}
    `;
export function useReportLabelIssueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReportLabelIssueMutation, ReportLabelIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReportLabelIssueMutation, ReportLabelIssueMutationVariables>(ReportLabelIssueDocument, options);
      }
export type ReportLabelIssueMutationHookResult = ReturnType<typeof useReportLabelIssueMutation>;
export type ReportLabelIssueMutationResult = Apollo.MutationResult<ReportLabelIssueMutation>;
export type ReportLabelIssueMutationOptions = Apollo.BaseMutationOptions<ReportLabelIssueMutation, ReportLabelIssueMutationVariables>;
export const AdminOrderInvoicesCountDocument = gql`
    query AdminOrderInvoicesCount($userProductOrderId: String!) {
  adminOrderInvoices(userProductOrderId: $userProductOrderId) {
    items {
      id
      type
    }
    count
  }
}
    `;
export function useAdminOrderInvoicesCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminOrderInvoicesCountQuery, AdminOrderInvoicesCountQueryVariables> & ({ variables: AdminOrderInvoicesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminOrderInvoicesCountQuery, AdminOrderInvoicesCountQueryVariables>(AdminOrderInvoicesCountDocument, options);
      }
export function useAdminOrderInvoicesCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminOrderInvoicesCountQuery, AdminOrderInvoicesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminOrderInvoicesCountQuery, AdminOrderInvoicesCountQueryVariables>(AdminOrderInvoicesCountDocument, options);
        }
export function useAdminOrderInvoicesCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminOrderInvoicesCountQuery, AdminOrderInvoicesCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminOrderInvoicesCountQuery, AdminOrderInvoicesCountQueryVariables>(AdminOrderInvoicesCountDocument, options);
        }
export type AdminOrderInvoicesCountQueryHookResult = ReturnType<typeof useAdminOrderInvoicesCountQuery>;
export type AdminOrderInvoicesCountLazyQueryHookResult = ReturnType<typeof useAdminOrderInvoicesCountLazyQuery>;
export type AdminOrderInvoicesCountSuspenseQueryHookResult = ReturnType<typeof useAdminOrderInvoicesCountSuspenseQuery>;
export type AdminOrderInvoicesCountQueryResult = Apollo.QueryResult<AdminOrderInvoicesCountQuery, AdminOrderInvoicesCountQueryVariables>;
export const SetOrderLockDocument = gql`
    mutation SetOrderLock($data: SetOrderLockInput!) {
  setOrderLock(data: $data) {
    success
  }
}
    `;
export function useSetOrderLockMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetOrderLockMutation, SetOrderLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetOrderLockMutation, SetOrderLockMutationVariables>(SetOrderLockDocument, options);
      }
export type SetOrderLockMutationHookResult = ReturnType<typeof useSetOrderLockMutation>;
export type SetOrderLockMutationResult = Apollo.MutationResult<SetOrderLockMutation>;
export type SetOrderLockMutationOptions = Apollo.BaseMutationOptions<SetOrderLockMutation, SetOrderLockMutationVariables>;
export const CreateQuickShipmentDocument = gql`
    mutation CreateQuickShipment($orderId: String!) {
  createQuickShipment(orderId: $orderId) {
    ...ShipmentOrderItem
  }
}
    ${ShipmentOrderItemFragmentDoc}`;
export function useCreateQuickShipmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQuickShipmentMutation, CreateQuickShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateQuickShipmentMutation, CreateQuickShipmentMutationVariables>(CreateQuickShipmentDocument, options);
      }
export type CreateQuickShipmentMutationHookResult = ReturnType<typeof useCreateQuickShipmentMutation>;
export type CreateQuickShipmentMutationResult = Apollo.MutationResult<CreateQuickShipmentMutation>;
export type CreateQuickShipmentMutationOptions = Apollo.BaseMutationOptions<CreateQuickShipmentMutation, CreateQuickShipmentMutationVariables>;
export const OrderRefundStatusDocument = gql`
    query OrderRefundStatus($id: String!) {
  userProductOrderRefundStatus(id: $id) {
    isRefundableWithCredits
    isLegacyPaymentIntentRefundable
    canCreditNoteBeIssued
  }
}
    `;
export function useOrderRefundStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrderRefundStatusQuery, OrderRefundStatusQueryVariables> & ({ variables: OrderRefundStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrderRefundStatusQuery, OrderRefundStatusQueryVariables>(OrderRefundStatusDocument, options);
      }
export function useOrderRefundStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderRefundStatusQuery, OrderRefundStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrderRefundStatusQuery, OrderRefundStatusQueryVariables>(OrderRefundStatusDocument, options);
        }
export function useOrderRefundStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrderRefundStatusQuery, OrderRefundStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrderRefundStatusQuery, OrderRefundStatusQueryVariables>(OrderRefundStatusDocument, options);
        }
export type OrderRefundStatusQueryHookResult = ReturnType<typeof useOrderRefundStatusQuery>;
export type OrderRefundStatusLazyQueryHookResult = ReturnType<typeof useOrderRefundStatusLazyQuery>;
export type OrderRefundStatusSuspenseQueryHookResult = ReturnType<typeof useOrderRefundStatusSuspenseQuery>;
export type OrderRefundStatusQueryResult = Apollo.QueryResult<OrderRefundStatusQuery, OrderRefundStatusQueryVariables>;
export const AdminRefundOrderDocument = gql`
    mutation AdminRefundOrder($orderId: String!, $data: RefundOrderInput!, $cancelRefundedOrder: Boolean) {
  adminRefundOrder(
    orderId: $orderId
    data: $data
    cancelRefundedOrder: $cancelRefundedOrder
  ) {
    success
  }
}
    `;
export function useAdminRefundOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminRefundOrderMutation, AdminRefundOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminRefundOrderMutation, AdminRefundOrderMutationVariables>(AdminRefundOrderDocument, options);
      }
export type AdminRefundOrderMutationHookResult = ReturnType<typeof useAdminRefundOrderMutation>;
export type AdminRefundOrderMutationResult = Apollo.MutationResult<AdminRefundOrderMutation>;
export type AdminRefundOrderMutationOptions = Apollo.BaseMutationOptions<AdminRefundOrderMutation, AdminRefundOrderMutationVariables>;
export const UpdateBulkOrderDueDateDocument = gql`
    mutation UpdateBulkOrderDueDate($id: String!, $data: BulkDueDateUpdateInput!) {
  updateBulkDueDate(id: $id, data: $data) {
    ...OrderAdminBrowseItem
  }
}
    ${OrderAdminBrowseItemFragmentDoc}`;
export function useUpdateBulkOrderDueDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBulkOrderDueDateMutation, UpdateBulkOrderDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBulkOrderDueDateMutation, UpdateBulkOrderDueDateMutationVariables>(UpdateBulkOrderDueDateDocument, options);
      }
export type UpdateBulkOrderDueDateMutationHookResult = ReturnType<typeof useUpdateBulkOrderDueDateMutation>;
export type UpdateBulkOrderDueDateMutationResult = Apollo.MutationResult<UpdateBulkOrderDueDateMutation>;
export type UpdateBulkOrderDueDateMutationOptions = Apollo.BaseMutationOptions<UpdateBulkOrderDueDateMutation, UpdateBulkOrderDueDateMutationVariables>;
export const UpdateUserProductOrderLineWarehouseDocument = gql`
    mutation UpdateUserProductOrderLineWarehouse($lineId: String!, $warehouseId: String!) {
  updateUserProductOrderLineWarehouse(lineId: $lineId, warehouseId: $warehouseId) {
    success
    reason
  }
}
    `;
export function useUpdateUserProductOrderLineWarehouseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserProductOrderLineWarehouseMutation, UpdateUserProductOrderLineWarehouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserProductOrderLineWarehouseMutation, UpdateUserProductOrderLineWarehouseMutationVariables>(UpdateUserProductOrderLineWarehouseDocument, options);
      }
export type UpdateUserProductOrderLineWarehouseMutationHookResult = ReturnType<typeof useUpdateUserProductOrderLineWarehouseMutation>;
export type UpdateUserProductOrderLineWarehouseMutationResult = Apollo.MutationResult<UpdateUserProductOrderLineWarehouseMutation>;
export type UpdateUserProductOrderLineWarehouseMutationOptions = Apollo.BaseMutationOptions<UpdateUserProductOrderLineWarehouseMutation, UpdateUserProductOrderLineWarehouseMutationVariables>;
export const OrderShipmentsDocument = gql`
    query OrderShipments($orderId: String!) {
  orderShipments(orderId: $orderId) {
    ...ShipmentOrderItem
  }
}
    ${ShipmentOrderItemFragmentDoc}`;
export function useOrderShipmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrderShipmentsQuery, OrderShipmentsQueryVariables> & ({ variables: OrderShipmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrderShipmentsQuery, OrderShipmentsQueryVariables>(OrderShipmentsDocument, options);
      }
export function useOrderShipmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderShipmentsQuery, OrderShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrderShipmentsQuery, OrderShipmentsQueryVariables>(OrderShipmentsDocument, options);
        }
export function useOrderShipmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrderShipmentsQuery, OrderShipmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrderShipmentsQuery, OrderShipmentsQueryVariables>(OrderShipmentsDocument, options);
        }
export type OrderShipmentsQueryHookResult = ReturnType<typeof useOrderShipmentsQuery>;
export type OrderShipmentsLazyQueryHookResult = ReturnType<typeof useOrderShipmentsLazyQuery>;
export type OrderShipmentsSuspenseQueryHookResult = ReturnType<typeof useOrderShipmentsSuspenseQuery>;
export type OrderShipmentsQueryResult = Apollo.QueryResult<OrderShipmentsQuery, OrderShipmentsQueryVariables>;
export const UpdateFbaOrderDueDateDocument = gql`
    mutation UpdateFbaOrderDueDate($id: String!, $data: FbaDueDateUpdateInput!) {
  updateFbaDueDate(id: $id, data: $data) {
    ...OrderAdminBrowseItem
  }
}
    ${OrderAdminBrowseItemFragmentDoc}`;
export function useUpdateFbaOrderDueDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFbaOrderDueDateMutation, UpdateFbaOrderDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFbaOrderDueDateMutation, UpdateFbaOrderDueDateMutationVariables>(UpdateFbaOrderDueDateDocument, options);
      }
export type UpdateFbaOrderDueDateMutationHookResult = ReturnType<typeof useUpdateFbaOrderDueDateMutation>;
export type UpdateFbaOrderDueDateMutationResult = Apollo.MutationResult<UpdateFbaOrderDueDateMutation>;
export type UpdateFbaOrderDueDateMutationOptions = Apollo.BaseMutationOptions<UpdateFbaOrderDueDateMutation, UpdateFbaOrderDueDateMutationVariables>;
export const ResetActivePrintBatchesOfSkuDocument = gql`
    mutation ResetActivePrintBatchesOfSku($sku: String!) {
  resetActivePrintBatchesOfSku(sku: $sku) {
    success
  }
}
    `;
export function useResetActivePrintBatchesOfSkuMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetActivePrintBatchesOfSkuMutation, ResetActivePrintBatchesOfSkuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetActivePrintBatchesOfSkuMutation, ResetActivePrintBatchesOfSkuMutationVariables>(ResetActivePrintBatchesOfSkuDocument, options);
      }
export type ResetActivePrintBatchesOfSkuMutationHookResult = ReturnType<typeof useResetActivePrintBatchesOfSkuMutation>;
export type ResetActivePrintBatchesOfSkuMutationResult = Apollo.MutationResult<ResetActivePrintBatchesOfSkuMutation>;
export type ResetActivePrintBatchesOfSkuMutationOptions = Apollo.BaseMutationOptions<ResetActivePrintBatchesOfSkuMutation, ResetActivePrintBatchesOfSkuMutationVariables>;
export const CreatePrintBatchAndConnectOrderLinesDocument = gql`
    mutation CreatePrintBatchAndConnectOrderLines($data: CreatePrintBatchAndConnectOrderLinesInput!) {
  createPrintBatchAndConnectOrderLines(data: $data) {
    id
    url
  }
}
    `;
export function useCreatePrintBatchAndConnectOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePrintBatchAndConnectOrderLinesMutation, CreatePrintBatchAndConnectOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePrintBatchAndConnectOrderLinesMutation, CreatePrintBatchAndConnectOrderLinesMutationVariables>(CreatePrintBatchAndConnectOrderLinesDocument, options);
      }
export type CreatePrintBatchAndConnectOrderLinesMutationHookResult = ReturnType<typeof useCreatePrintBatchAndConnectOrderLinesMutation>;
export type CreatePrintBatchAndConnectOrderLinesMutationResult = Apollo.MutationResult<CreatePrintBatchAndConnectOrderLinesMutation>;
export type CreatePrintBatchAndConnectOrderLinesMutationOptions = Apollo.BaseMutationOptions<CreatePrintBatchAndConnectOrderLinesMutation, CreatePrintBatchAndConnectOrderLinesMutationVariables>;
export const CreateProductLabelSizeDocument = gql`
    mutation CreateProductLabelSize($data: ProductLabelSizeCreateInput!) {
  createOneProductLabelSize(data: $data) {
    ...ProductLabelSize
  }
}
    ${ProductLabelSizeFragmentDoc}`;
export function useCreateProductLabelSizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProductLabelSizeMutation, CreateProductLabelSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProductLabelSizeMutation, CreateProductLabelSizeMutationVariables>(CreateProductLabelSizeDocument, options);
      }
export type CreateProductLabelSizeMutationHookResult = ReturnType<typeof useCreateProductLabelSizeMutation>;
export type CreateProductLabelSizeMutationResult = Apollo.MutationResult<CreateProductLabelSizeMutation>;
export type CreateProductLabelSizeMutationOptions = Apollo.BaseMutationOptions<CreateProductLabelSizeMutation, CreateProductLabelSizeMutationVariables>;
export const GetActivePublishersDocument = gql`
    query GetActivePublishers($productId: String!) {
  getActivePublishers(productId: $productId) {
    ...ProductPublisher
  }
}
    ${ProductPublisherFragmentDoc}`;
export function useGetActivePublishersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActivePublishersQuery, GetActivePublishersQueryVariables> & ({ variables: GetActivePublishersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActivePublishersQuery, GetActivePublishersQueryVariables>(GetActivePublishersDocument, options);
      }
export function useGetActivePublishersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActivePublishersQuery, GetActivePublishersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActivePublishersQuery, GetActivePublishersQueryVariables>(GetActivePublishersDocument, options);
        }
export function useGetActivePublishersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetActivePublishersQuery, GetActivePublishersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActivePublishersQuery, GetActivePublishersQueryVariables>(GetActivePublishersDocument, options);
        }
export type GetActivePublishersQueryHookResult = ReturnType<typeof useGetActivePublishersQuery>;
export type GetActivePublishersLazyQueryHookResult = ReturnType<typeof useGetActivePublishersLazyQuery>;
export type GetActivePublishersSuspenseQueryHookResult = ReturnType<typeof useGetActivePublishersSuspenseQuery>;
export type GetActivePublishersQueryResult = Apollo.QueryResult<GetActivePublishersQuery, GetActivePublishersQueryVariables>;
export const UpdateProductRestockDateDocument = gql`
    mutation UpdateProductRestockDate($productId: String!, $data: UpdateProductRestockDateInput!) {
  updateProductRestockDate(productId: $productId, data: $data) {
    ...ProductPublisher
  }
}
    ${ProductPublisherFragmentDoc}`;
export function useUpdateProductRestockDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductRestockDateMutation, UpdateProductRestockDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProductRestockDateMutation, UpdateProductRestockDateMutationVariables>(UpdateProductRestockDateDocument, options);
      }
export type UpdateProductRestockDateMutationHookResult = ReturnType<typeof useUpdateProductRestockDateMutation>;
export type UpdateProductRestockDateMutationResult = Apollo.MutationResult<UpdateProductRestockDateMutation>;
export type UpdateProductRestockDateMutationOptions = Apollo.BaseMutationOptions<UpdateProductRestockDateMutation, UpdateProductRestockDateMutationVariables>;
export const ProductStockQuantityImportDocument = gql`
    mutation ProductStockQuantityImport($data: ProductStockQuantityImportInput!) {
  importProductStockQuantity(data: $data) {
    importedCount
    failedCount
  }
}
    `;
export function useProductStockQuantityImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProductStockQuantityImportMutation, ProductStockQuantityImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProductStockQuantityImportMutation, ProductStockQuantityImportMutationVariables>(ProductStockQuantityImportDocument, options);
      }
export type ProductStockQuantityImportMutationHookResult = ReturnType<typeof useProductStockQuantityImportMutation>;
export type ProductStockQuantityImportMutationResult = Apollo.MutationResult<ProductStockQuantityImportMutation>;
export type ProductStockQuantityImportMutationOptions = Apollo.BaseMutationOptions<ProductStockQuantityImportMutation, ProductStockQuantityImportMutationVariables>;
export const CreateProductStockSnapshotDocument = gql`
    mutation CreateProductStockSnapshot($data: CreateProductStockSnapshotInput!) {
  createProductStockSnapshot(data: $data) {
    success
  }
}
    `;
export function useCreateProductStockSnapshotMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProductStockSnapshotMutation, CreateProductStockSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProductStockSnapshotMutation, CreateProductStockSnapshotMutationVariables>(CreateProductStockSnapshotDocument, options);
      }
export type CreateProductStockSnapshotMutationHookResult = ReturnType<typeof useCreateProductStockSnapshotMutation>;
export type CreateProductStockSnapshotMutationResult = Apollo.MutationResult<CreateProductStockSnapshotMutation>;
export type CreateProductStockSnapshotMutationOptions = Apollo.BaseMutationOptions<CreateProductStockSnapshotMutation, CreateProductStockSnapshotMutationVariables>;
export const ProductsSettingsImportDocument = gql`
    mutation ProductsSettingsImport($data: ProductsSettingsImportInput!) {
  importProductsSettings(data: $data) {
    importedCount
    failedCount
  }
}
    `;
export function useProductsSettingsImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProductsSettingsImportMutation, ProductsSettingsImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProductsSettingsImportMutation, ProductsSettingsImportMutationVariables>(ProductsSettingsImportDocument, options);
      }
export type ProductsSettingsImportMutationHookResult = ReturnType<typeof useProductsSettingsImportMutation>;
export type ProductsSettingsImportMutationResult = Apollo.MutationResult<ProductsSettingsImportMutation>;
export type ProductsSettingsImportMutationOptions = Apollo.BaseMutationOptions<ProductsSettingsImportMutation, ProductsSettingsImportMutationVariables>;
export const ExtendedCatalogImportDocument = gql`
    mutation ExtendedCatalogImport($data: ProductsSettingsImportInput!) {
  importExtendedCatalogProducts(data: $data) {
    importedCount
    failedCount
  }
}
    `;
export function useExtendedCatalogImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExtendedCatalogImportMutation, ExtendedCatalogImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExtendedCatalogImportMutation, ExtendedCatalogImportMutationVariables>(ExtendedCatalogImportDocument, options);
      }
export type ExtendedCatalogImportMutationHookResult = ReturnType<typeof useExtendedCatalogImportMutation>;
export type ExtendedCatalogImportMutationResult = Apollo.MutationResult<ExtendedCatalogImportMutation>;
export type ExtendedCatalogImportMutationOptions = Apollo.BaseMutationOptions<ExtendedCatalogImportMutation, ExtendedCatalogImportMutationVariables>;
export const UpdateOneProductStockDocument = gql`
    mutation UpdateOneProductStock($where: ProductStockWhereUniqueInput!, $data: ProductStockUpdateInput!) {
  updateOneProductStock(where: $where, data: $data) {
    ...ProductStockFragment
  }
}
    ${ProductStockFragmentFragmentDoc}`;
export function useUpdateOneProductStockMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOneProductStockMutation, UpdateOneProductStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOneProductStockMutation, UpdateOneProductStockMutationVariables>(UpdateOneProductStockDocument, options);
      }
export type UpdateOneProductStockMutationHookResult = ReturnType<typeof useUpdateOneProductStockMutation>;
export type UpdateOneProductStockMutationResult = Apollo.MutationResult<UpdateOneProductStockMutation>;
export type UpdateOneProductStockMutationOptions = Apollo.BaseMutationOptions<UpdateOneProductStockMutation, UpdateOneProductStockMutationVariables>;
export const CreateOneProductStockDocument = gql`
    mutation CreateOneProductStock($data: ProductStockCreateInput!) {
  createOneProductStock(data: $data) {
    ...ProductStockFragment
  }
}
    ${ProductStockFragmentFragmentDoc}`;
export function useCreateOneProductStockMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOneProductStockMutation, CreateOneProductStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOneProductStockMutation, CreateOneProductStockMutationVariables>(CreateOneProductStockDocument, options);
      }
export type CreateOneProductStockMutationHookResult = ReturnType<typeof useCreateOneProductStockMutation>;
export type CreateOneProductStockMutationResult = Apollo.MutationResult<CreateOneProductStockMutation>;
export type CreateOneProductStockMutationOptions = Apollo.BaseMutationOptions<CreateOneProductStockMutation, CreateOneProductStockMutationVariables>;
export const FindManyProductStockDocument = gql`
    query FindManyProductStock($where: ProductStockWhereInput) {
  findManyProductStock(where: $where) {
    ...ProductStockFragment
  }
}
    ${ProductStockFragmentFragmentDoc}`;
export function useFindManyProductStockQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindManyProductStockQuery, FindManyProductStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindManyProductStockQuery, FindManyProductStockQueryVariables>(FindManyProductStockDocument, options);
      }
export function useFindManyProductStockLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindManyProductStockQuery, FindManyProductStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindManyProductStockQuery, FindManyProductStockQueryVariables>(FindManyProductStockDocument, options);
        }
export function useFindManyProductStockSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindManyProductStockQuery, FindManyProductStockQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FindManyProductStockQuery, FindManyProductStockQueryVariables>(FindManyProductStockDocument, options);
        }
export type FindManyProductStockQueryHookResult = ReturnType<typeof useFindManyProductStockQuery>;
export type FindManyProductStockLazyQueryHookResult = ReturnType<typeof useFindManyProductStockLazyQuery>;
export type FindManyProductStockSuspenseQueryHookResult = ReturnType<typeof useFindManyProductStockSuspenseQuery>;
export type FindManyProductStockQueryResult = Apollo.QueryResult<FindManyProductStockQuery, FindManyProductStockQueryVariables>;
export const ShipmentByCarrierDocument = gql`
    query ShipmentByCarrier($status: ShipmentStatus!) {
  countShipmentsByCarrier(status: $status) {
    carrierId
    count
  }
}
    `;
export function useShipmentByCarrierQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShipmentByCarrierQuery, ShipmentByCarrierQueryVariables> & ({ variables: ShipmentByCarrierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShipmentByCarrierQuery, ShipmentByCarrierQueryVariables>(ShipmentByCarrierDocument, options);
      }
export function useShipmentByCarrierLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShipmentByCarrierQuery, ShipmentByCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShipmentByCarrierQuery, ShipmentByCarrierQueryVariables>(ShipmentByCarrierDocument, options);
        }
export function useShipmentByCarrierSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShipmentByCarrierQuery, ShipmentByCarrierQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShipmentByCarrierQuery, ShipmentByCarrierQueryVariables>(ShipmentByCarrierDocument, options);
        }
export type ShipmentByCarrierQueryHookResult = ReturnType<typeof useShipmentByCarrierQuery>;
export type ShipmentByCarrierLazyQueryHookResult = ReturnType<typeof useShipmentByCarrierLazyQuery>;
export type ShipmentByCarrierSuspenseQueryHookResult = ReturnType<typeof useShipmentByCarrierSuspenseQuery>;
export type ShipmentByCarrierQueryResult = Apollo.QueryResult<ShipmentByCarrierQuery, ShipmentByCarrierQueryVariables>;
export const BinsAssignedToOrderDocument = gql`
    query BinsAssignedToOrder($orderId: String!) {
  binsAssignedToOrder(orderId: $orderId) {
    sorting {
      id
      number
    }
    returned {
      id
      number
    }
  }
}
    `;
export function useBinsAssignedToOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BinsAssignedToOrderQuery, BinsAssignedToOrderQueryVariables> & ({ variables: BinsAssignedToOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BinsAssignedToOrderQuery, BinsAssignedToOrderQueryVariables>(BinsAssignedToOrderDocument, options);
      }
export function useBinsAssignedToOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BinsAssignedToOrderQuery, BinsAssignedToOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BinsAssignedToOrderQuery, BinsAssignedToOrderQueryVariables>(BinsAssignedToOrderDocument, options);
        }
export function useBinsAssignedToOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BinsAssignedToOrderQuery, BinsAssignedToOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BinsAssignedToOrderQuery, BinsAssignedToOrderQueryVariables>(BinsAssignedToOrderDocument, options);
        }
export type BinsAssignedToOrderQueryHookResult = ReturnType<typeof useBinsAssignedToOrderQuery>;
export type BinsAssignedToOrderLazyQueryHookResult = ReturnType<typeof useBinsAssignedToOrderLazyQuery>;
export type BinsAssignedToOrderSuspenseQueryHookResult = ReturnType<typeof useBinsAssignedToOrderSuspenseQuery>;
export type BinsAssignedToOrderQueryResult = Apollo.QueryResult<BinsAssignedToOrderQuery, BinsAssignedToOrderQueryVariables>;
export const CreateWarehouseShelfDocument = gql`
    mutation CreateWarehouseShelf($data: CreateWarehouseShelfInput!) {
  createOneWarehouseShelf(data: $data) {
    ...WarehouseShelf
  }
}
    ${WarehouseShelfFragmentDoc}`;
export function useCreateWarehouseShelfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWarehouseShelfMutation, CreateWarehouseShelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWarehouseShelfMutation, CreateWarehouseShelfMutationVariables>(CreateWarehouseShelfDocument, options);
      }
export type CreateWarehouseShelfMutationHookResult = ReturnType<typeof useCreateWarehouseShelfMutation>;
export type CreateWarehouseShelfMutationResult = Apollo.MutationResult<CreateWarehouseShelfMutation>;
export type CreateWarehouseShelfMutationOptions = Apollo.BaseMutationOptions<CreateWarehouseShelfMutation, CreateWarehouseShelfMutationVariables>;
export const AdminDigitalServiceProductListDocument = gql`
    query AdminDigitalServiceProductList($where: DigitalServiceProductWhereInput) {
  adminDigitalServiceProductList(where: $where) {
    ...AdminDigitalServiceProductListItem
  }
}
    ${AdminDigitalServiceProductListItemFragmentDoc}`;
export function useAdminDigitalServiceProductListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminDigitalServiceProductListQuery, AdminDigitalServiceProductListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminDigitalServiceProductListQuery, AdminDigitalServiceProductListQueryVariables>(AdminDigitalServiceProductListDocument, options);
      }
export function useAdminDigitalServiceProductListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminDigitalServiceProductListQuery, AdminDigitalServiceProductListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminDigitalServiceProductListQuery, AdminDigitalServiceProductListQueryVariables>(AdminDigitalServiceProductListDocument, options);
        }
export function useAdminDigitalServiceProductListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminDigitalServiceProductListQuery, AdminDigitalServiceProductListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminDigitalServiceProductListQuery, AdminDigitalServiceProductListQueryVariables>(AdminDigitalServiceProductListDocument, options);
        }
export type AdminDigitalServiceProductListQueryHookResult = ReturnType<typeof useAdminDigitalServiceProductListQuery>;
export type AdminDigitalServiceProductListLazyQueryHookResult = ReturnType<typeof useAdminDigitalServiceProductListLazyQuery>;
export type AdminDigitalServiceProductListSuspenseQueryHookResult = ReturnType<typeof useAdminDigitalServiceProductListSuspenseQuery>;
export type AdminDigitalServiceProductListQueryResult = Apollo.QueryResult<AdminDigitalServiceProductListQuery, AdminDigitalServiceProductListQueryVariables>;
export const AdminProductsDocument = gql`
    query AdminProducts($skip: Int!, $take: Int!, $orderBy: [ProductSettingsOrderByWithRelationInput!], $where: ProductSettingsWhereInput) {
  findManyProductSettingsWithCount(
    skip: $skip
    take: $take
    orderBy: $orderBy
    where: $where
  ) {
    items {
      ...ProductAdminListItem
    }
    count
  }
}
    ${ProductAdminListItemFragmentDoc}`;
export function useAdminProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables> & ({ variables: AdminProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
      }
export function useAdminProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
        }
export function useAdminProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminProductsQuery, AdminProductsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminProductsQuery, AdminProductsQueryVariables>(AdminProductsDocument, options);
        }
export type AdminProductsQueryHookResult = ReturnType<typeof useAdminProductsQuery>;
export type AdminProductsLazyQueryHookResult = ReturnType<typeof useAdminProductsLazyQuery>;
export type AdminProductsSuspenseQueryHookResult = ReturnType<typeof useAdminProductsSuspenseQuery>;
export type AdminProductsQueryResult = Apollo.QueryResult<AdminProductsQuery, AdminProductsQueryVariables>;
export const ChargeReshipmentDocument = gql`
    mutation ChargeReshipment($shipmentId: String!) {
  chargeReshipment(shipmentId: $shipmentId) {
    success
  }
}
    `;
export function useChargeReshipmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChargeReshipmentMutation, ChargeReshipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChargeReshipmentMutation, ChargeReshipmentMutationVariables>(ChargeReshipmentDocument, options);
      }
export type ChargeReshipmentMutationHookResult = ReturnType<typeof useChargeReshipmentMutation>;
export type ChargeReshipmentMutationResult = Apollo.MutationResult<ChargeReshipmentMutation>;
export type ChargeReshipmentMutationOptions = Apollo.BaseMutationOptions<ChargeReshipmentMutation, ChargeReshipmentMutationVariables>;
export const CreateShipmentBatchDocument = gql`
    mutation CreateShipmentBatch($input: CreateShipmentBatchInput!) {
  createShipmentBatch(input: $input) {
    ...ShipmentBatch
  }
}
    ${ShipmentBatchFragmentDoc}`;
export function useCreateShipmentBatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateShipmentBatchMutation, CreateShipmentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateShipmentBatchMutation, CreateShipmentBatchMutationVariables>(CreateShipmentBatchDocument, options);
      }
export type CreateShipmentBatchMutationHookResult = ReturnType<typeof useCreateShipmentBatchMutation>;
export type CreateShipmentBatchMutationResult = Apollo.MutationResult<CreateShipmentBatchMutation>;
export type CreateShipmentBatchMutationOptions = Apollo.BaseMutationOptions<CreateShipmentBatchMutation, CreateShipmentBatchMutationVariables>;
export const ManualUserCreditsTransactionDocument = gql`
    mutation ManualUserCreditsTransaction($amountCents: Int!, $userId: ID!, $manualCreditChangeReason: String!) {
  manualUserCreditsTransaction(
    amountCents: $amountCents
    userId: $userId
    manualCreditChangeReason: $manualCreditChangeReason
  ) {
    ...UserCreditsTransaction
  }
}
    ${UserCreditsTransactionFragmentDoc}`;
export function useManualUserCreditsTransactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ManualUserCreditsTransactionMutation, ManualUserCreditsTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ManualUserCreditsTransactionMutation, ManualUserCreditsTransactionMutationVariables>(ManualUserCreditsTransactionDocument, options);
      }
export type ManualUserCreditsTransactionMutationHookResult = ReturnType<typeof useManualUserCreditsTransactionMutation>;
export type ManualUserCreditsTransactionMutationResult = Apollo.MutationResult<ManualUserCreditsTransactionMutation>;
export type ManualUserCreditsTransactionMutationOptions = Apollo.BaseMutationOptions<ManualUserCreditsTransactionMutation, ManualUserCreditsTransactionMutationVariables>;
export const MarkOrderLineItemPreparedDocument = gql`
    mutation MarkOrderLineItemPrepared($data: MarkOrderLineItemPreparedInput!) {
  markOrderLineItemPrepared(data: $data) {
    success
  }
}
    `;
export function useMarkOrderLineItemPreparedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkOrderLineItemPreparedMutation, MarkOrderLineItemPreparedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkOrderLineItemPreparedMutation, MarkOrderLineItemPreparedMutationVariables>(MarkOrderLineItemPreparedDocument, options);
      }
export type MarkOrderLineItemPreparedMutationHookResult = ReturnType<typeof useMarkOrderLineItemPreparedMutation>;
export type MarkOrderLineItemPreparedMutationResult = Apollo.MutationResult<MarkOrderLineItemPreparedMutation>;
export type MarkOrderLineItemPreparedMutationOptions = Apollo.BaseMutationOptions<MarkOrderLineItemPreparedMutation, MarkOrderLineItemPreparedMutationVariables>;
export const MarkShipmentsAsShippedDocument = gql`
    mutation MarkShipmentsAsShipped($input: MarkShipmentsAsShippedInput!) {
  markShipmentsAsShipped(input: $input)
}
    `;
export function useMarkShipmentsAsShippedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkShipmentsAsShippedMutation, MarkShipmentsAsShippedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkShipmentsAsShippedMutation, MarkShipmentsAsShippedMutationVariables>(MarkShipmentsAsShippedDocument, options);
      }
export type MarkShipmentsAsShippedMutationHookResult = ReturnType<typeof useMarkShipmentsAsShippedMutation>;
export type MarkShipmentsAsShippedMutationResult = Apollo.MutationResult<MarkShipmentsAsShippedMutation>;
export type MarkShipmentsAsShippedMutationOptions = Apollo.BaseMutationOptions<MarkShipmentsAsShippedMutation, MarkShipmentsAsShippedMutationVariables>;
export const HoldOrdersDocument = gql`
    mutation HoldOrders($orderIds: [String!]!, $data: HoldOrderInput!) {
  holdOrders(orderIds: $orderIds, data: $data) {
    ...OrderAdminBrowseItem
  }
}
    ${OrderAdminBrowseItemFragmentDoc}`;
export function useHoldOrdersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<HoldOrdersMutation, HoldOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<HoldOrdersMutation, HoldOrdersMutationVariables>(HoldOrdersDocument, options);
      }
export type HoldOrdersMutationHookResult = ReturnType<typeof useHoldOrdersMutation>;
export type HoldOrdersMutationResult = Apollo.MutationResult<HoldOrdersMutation>;
export type HoldOrdersMutationOptions = Apollo.BaseMutationOptions<HoldOrdersMutation, HoldOrdersMutationVariables>;
export const AdminOrderDocument = gql`
    query AdminOrder($where: UserProductOrderWhereInput) {
  adminOrder(where: $where) {
    ...OrderAdminBrowseItem
  }
}
    ${OrderAdminBrowseItemFragmentDoc}`;
export function useAdminOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminOrderQuery, AdminOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminOrderQuery, AdminOrderQueryVariables>(AdminOrderDocument, options);
      }
export function useAdminOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminOrderQuery, AdminOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminOrderQuery, AdminOrderQueryVariables>(AdminOrderDocument, options);
        }
export function useAdminOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminOrderQuery, AdminOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminOrderQuery, AdminOrderQueryVariables>(AdminOrderDocument, options);
        }
export type AdminOrderQueryHookResult = ReturnType<typeof useAdminOrderQuery>;
export type AdminOrderLazyQueryHookResult = ReturnType<typeof useAdminOrderLazyQuery>;
export type AdminOrderSuspenseQueryHookResult = ReturnType<typeof useAdminOrderSuspenseQuery>;
export type AdminOrderQueryResult = Apollo.QueryResult<AdminOrderQuery, AdminOrderQueryVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($id: String!, $data: OrderUpdateInput!) {
  updateOrder(id: $id, data: $data) {
    ...OrderAdminBrowseItem
  }
}
    ${OrderAdminBrowseItemFragmentDoc}`;
export function useUpdateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const AdminProductLabelSizeDocument = gql`
    query AdminProductLabelSize($id: String!) {
  findUniqueProductLabelSize(where: {id: $id}) {
    ...ProductLabelSize
  }
}
    ${ProductLabelSizeFragmentDoc}`;
export function useAdminProductLabelSizeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminProductLabelSizeQuery, AdminProductLabelSizeQueryVariables> & ({ variables: AdminProductLabelSizeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminProductLabelSizeQuery, AdminProductLabelSizeQueryVariables>(AdminProductLabelSizeDocument, options);
      }
export function useAdminProductLabelSizeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminProductLabelSizeQuery, AdminProductLabelSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminProductLabelSizeQuery, AdminProductLabelSizeQueryVariables>(AdminProductLabelSizeDocument, options);
        }
export function useAdminProductLabelSizeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminProductLabelSizeQuery, AdminProductLabelSizeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminProductLabelSizeQuery, AdminProductLabelSizeQueryVariables>(AdminProductLabelSizeDocument, options);
        }
export type AdminProductLabelSizeQueryHookResult = ReturnType<typeof useAdminProductLabelSizeQuery>;
export type AdminProductLabelSizeLazyQueryHookResult = ReturnType<typeof useAdminProductLabelSizeLazyQuery>;
export type AdminProductLabelSizeSuspenseQueryHookResult = ReturnType<typeof useAdminProductLabelSizeSuspenseQuery>;
export type AdminProductLabelSizeQueryResult = Apollo.QueryResult<AdminProductLabelSizeQuery, AdminProductLabelSizeQueryVariables>;
export const UpdateProductLabelSizeDocument = gql`
    mutation UpdateProductLabelSize($id: String!, $data: ProductLabelSizeUpdateInput!) {
  updateOneProductLabelSize(where: {id: $id}, data: $data) {
    ...ProductLabelSize
  }
}
    ${ProductLabelSizeFragmentDoc}`;
export function useUpdateProductLabelSizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductLabelSizeMutation, UpdateProductLabelSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProductLabelSizeMutation, UpdateProductLabelSizeMutationVariables>(UpdateProductLabelSizeDocument, options);
      }
export type UpdateProductLabelSizeMutationHookResult = ReturnType<typeof useUpdateProductLabelSizeMutation>;
export type UpdateProductLabelSizeMutationResult = Apollo.MutationResult<UpdateProductLabelSizeMutation>;
export type UpdateProductLabelSizeMutationOptions = Apollo.BaseMutationOptions<UpdateProductLabelSizeMutation, UpdateProductLabelSizeMutationVariables>;
export const ProductLabelSizesDocument = gql`
    query ProductLabelSizes($skip: Int, $take: Int, $where: ProductLabelSizeWhereInput, $orderBy: [ProductLabelSizeOrderByWithRelationInput!]) {
  findManyProductLabelSize(
    skip: $skip
    take: $take
    where: $where
    orderBy: $orderBy
  ) {
    ...ProductLabelSize
  }
}
    ${ProductLabelSizeFragmentDoc}`;
export function useProductLabelSizesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductLabelSizesQuery, ProductLabelSizesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductLabelSizesQuery, ProductLabelSizesQueryVariables>(ProductLabelSizesDocument, options);
      }
export function useProductLabelSizesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductLabelSizesQuery, ProductLabelSizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductLabelSizesQuery, ProductLabelSizesQueryVariables>(ProductLabelSizesDocument, options);
        }
export function useProductLabelSizesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductLabelSizesQuery, ProductLabelSizesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductLabelSizesQuery, ProductLabelSizesQueryVariables>(ProductLabelSizesDocument, options);
        }
export type ProductLabelSizesQueryHookResult = ReturnType<typeof useProductLabelSizesQuery>;
export type ProductLabelSizesLazyQueryHookResult = ReturnType<typeof useProductLabelSizesLazyQuery>;
export type ProductLabelSizesSuspenseQueryHookResult = ReturnType<typeof useProductLabelSizesSuspenseQuery>;
export type ProductLabelSizesQueryResult = Apollo.QueryResult<ProductLabelSizesQuery, ProductLabelSizesQueryVariables>;
export const ProductSettingsDocument = gql`
    query ProductSettings($id: String!) {
  productSettings(id: $id) {
    ...ProductAdminSettings
  }
}
    ${ProductAdminSettingsFragmentDoc}`;
export function useProductSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductSettingsQuery, ProductSettingsQueryVariables> & ({ variables: ProductSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductSettingsQuery, ProductSettingsQueryVariables>(ProductSettingsDocument, options);
      }
export function useProductSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductSettingsQuery, ProductSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductSettingsQuery, ProductSettingsQueryVariables>(ProductSettingsDocument, options);
        }
export function useProductSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductSettingsQuery, ProductSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductSettingsQuery, ProductSettingsQueryVariables>(ProductSettingsDocument, options);
        }
export type ProductSettingsQueryHookResult = ReturnType<typeof useProductSettingsQuery>;
export type ProductSettingsLazyQueryHookResult = ReturnType<typeof useProductSettingsLazyQuery>;
export type ProductSettingsSuspenseQueryHookResult = ReturnType<typeof useProductSettingsSuspenseQuery>;
export type ProductSettingsQueryResult = Apollo.QueryResult<ProductSettingsQuery, ProductSettingsQueryVariables>;
export const ProductSettingsUpdateDocument = gql`
    mutation ProductSettingsUpdate($data: ProductSettingsUpdateInput!, $where: ProductSettingsWhereUniqueInput!) {
  updateProductSettings(data: $data, where: $where) {
    ...ProductAdminSettings
  }
}
    ${ProductAdminSettingsFragmentDoc}`;
export function useProductSettingsUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProductSettingsUpdateMutation, ProductSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProductSettingsUpdateMutation, ProductSettingsUpdateMutationVariables>(ProductSettingsUpdateDocument, options);
      }
export type ProductSettingsUpdateMutationHookResult = ReturnType<typeof useProductSettingsUpdateMutation>;
export type ProductSettingsUpdateMutationResult = Apollo.MutationResult<ProductSettingsUpdateMutation>;
export type ProductSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<ProductSettingsUpdateMutation, ProductSettingsUpdateMutationVariables>;
export const ReshipDocument = gql`
    mutation Reship($input: ReshipInput!) {
  reship(input: $input) {
    id
  }
}
    `;
export function useReshipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReshipMutation, ReshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReshipMutation, ReshipMutationVariables>(ReshipDocument, options);
      }
export type ReshipMutationHookResult = ReturnType<typeof useReshipMutation>;
export type ReshipMutationResult = Apollo.MutationResult<ReshipMutation>;
export type ReshipMutationOptions = Apollo.BaseMutationOptions<ReshipMutation, ReshipMutationVariables>;
export const SetPriorityLaneFulfillmentDocument = gql`
    mutation SetPriorityLaneFulfillment($id: String!, $data: SetPriorityLaneFulfillmentInput!) {
  setPriorityLaneFulfillment(id: $id, data: $data) {
    ...UserAdminItem
  }
}
    ${UserAdminItemFragmentDoc}`;
export function useSetPriorityLaneFulfillmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPriorityLaneFulfillmentMutation, SetPriorityLaneFulfillmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetPriorityLaneFulfillmentMutation, SetPriorityLaneFulfillmentMutationVariables>(SetPriorityLaneFulfillmentDocument, options);
      }
export type SetPriorityLaneFulfillmentMutationHookResult = ReturnType<typeof useSetPriorityLaneFulfillmentMutation>;
export type SetPriorityLaneFulfillmentMutationResult = Apollo.MutationResult<SetPriorityLaneFulfillmentMutation>;
export type SetPriorityLaneFulfillmentMutationOptions = Apollo.BaseMutationOptions<SetPriorityLaneFulfillmentMutation, SetPriorityLaneFulfillmentMutationVariables>;
export const ShipmentBatchesDocument = gql`
    query ShipmentBatches($skip: Int, $take: Int, $where: ShipmentBatchWhereInput) {
  findManyShipmentBatch(
    skip: $skip
    take: $take
    orderBy: {createdAt: desc}
    where: $where
  ) {
    ...ShipmentBatch
  }
}
    ${ShipmentBatchFragmentDoc}`;
export function useShipmentBatchesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShipmentBatchesQuery, ShipmentBatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShipmentBatchesQuery, ShipmentBatchesQueryVariables>(ShipmentBatchesDocument, options);
      }
export function useShipmentBatchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShipmentBatchesQuery, ShipmentBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShipmentBatchesQuery, ShipmentBatchesQueryVariables>(ShipmentBatchesDocument, options);
        }
export function useShipmentBatchesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ShipmentBatchesQuery, ShipmentBatchesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShipmentBatchesQuery, ShipmentBatchesQueryVariables>(ShipmentBatchesDocument, options);
        }
export type ShipmentBatchesQueryHookResult = ReturnType<typeof useShipmentBatchesQuery>;
export type ShipmentBatchesLazyQueryHookResult = ReturnType<typeof useShipmentBatchesLazyQuery>;
export type ShipmentBatchesSuspenseQueryHookResult = ReturnType<typeof useShipmentBatchesSuspenseQuery>;
export type ShipmentBatchesQueryResult = Apollo.QueryResult<ShipmentBatchesQuery, ShipmentBatchesQueryVariables>;
export const ShipmentMarkAsReadyToShipDocument = gql`
    mutation ShipmentMarkAsReadyToShip($shipmentId: String!) {
  shipmentMarkAsReadyToShip(shipmentId: $shipmentId) {
    success
  }
}
    `;
export function useShipmentMarkAsReadyToShipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShipmentMarkAsReadyToShipMutation, ShipmentMarkAsReadyToShipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShipmentMarkAsReadyToShipMutation, ShipmentMarkAsReadyToShipMutationVariables>(ShipmentMarkAsReadyToShipDocument, options);
      }
export type ShipmentMarkAsReadyToShipMutationHookResult = ReturnType<typeof useShipmentMarkAsReadyToShipMutation>;
export type ShipmentMarkAsReadyToShipMutationResult = Apollo.MutationResult<ShipmentMarkAsReadyToShipMutation>;
export type ShipmentMarkAsReadyToShipMutationOptions = Apollo.BaseMutationOptions<ShipmentMarkAsReadyToShipMutation, ShipmentMarkAsReadyToShipMutationVariables>;
export const ShipmentMarkAsReturnedDocument = gql`
    mutation ShipmentMarkAsReturned($shipmentId: String!) {
  shipmentMarkAsReturned(shipmentId: $shipmentId) {
    success
  }
}
    `;
export function useShipmentMarkAsReturnedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShipmentMarkAsReturnedMutation, ShipmentMarkAsReturnedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShipmentMarkAsReturnedMutation, ShipmentMarkAsReturnedMutationVariables>(ShipmentMarkAsReturnedDocument, options);
      }
export type ShipmentMarkAsReturnedMutationHookResult = ReturnType<typeof useShipmentMarkAsReturnedMutation>;
export type ShipmentMarkAsReturnedMutationResult = Apollo.MutationResult<ShipmentMarkAsReturnedMutation>;
export type ShipmentMarkAsReturnedMutationOptions = Apollo.BaseMutationOptions<ShipmentMarkAsReturnedMutation, ShipmentMarkAsReturnedMutationVariables>;
export const ShipmentRefundAndDeleteDocument = gql`
    mutation ShipmentRefundAndDelete($shipmentId: String!) {
  shipmentRefundAndDelete(shipmentId: $shipmentId) {
    success
  }
}
    `;
export function useShipmentRefundAndDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShipmentRefundAndDeleteMutation, ShipmentRefundAndDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShipmentRefundAndDeleteMutation, ShipmentRefundAndDeleteMutationVariables>(ShipmentRefundAndDeleteDocument, options);
      }
export type ShipmentRefundAndDeleteMutationHookResult = ReturnType<typeof useShipmentRefundAndDeleteMutation>;
export type ShipmentRefundAndDeleteMutationResult = Apollo.MutationResult<ShipmentRefundAndDeleteMutation>;
export type ShipmentRefundAndDeleteMutationOptions = Apollo.BaseMutationOptions<ShipmentRefundAndDeleteMutation, ShipmentRefundAndDeleteMutationVariables>;
export const UserDocument = gql`
    query User($id: String!) {
  user(id: $id) {
    ...UserAdminItem
  }
}
    ${UserAdminItemFragmentDoc}`;
export function useUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: String!, $data: UpdateUserInput!) {
  updateUser(id: $id, data: $data) {
    ...UserAdminItem
  }
}
    ${UserAdminItemFragmentDoc}`;
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateWarehouseShelfReturnBinDocument = gql`
    mutation UpdateWarehouseShelfReturnBin($id: String!, $data: WarehouseShelfReturnBinUpdateInput!) {
  updateOneWarehouseShelfReturnBin(where: {id: $id}, data: $data) {
    id
  }
}
    `;
export function useUpdateWarehouseShelfReturnBinMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWarehouseShelfReturnBinMutation, UpdateWarehouseShelfReturnBinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWarehouseShelfReturnBinMutation, UpdateWarehouseShelfReturnBinMutationVariables>(UpdateWarehouseShelfReturnBinDocument, options);
      }
export type UpdateWarehouseShelfReturnBinMutationHookResult = ReturnType<typeof useUpdateWarehouseShelfReturnBinMutation>;
export type UpdateWarehouseShelfReturnBinMutationResult = Apollo.MutationResult<UpdateWarehouseShelfReturnBinMutation>;
export type UpdateWarehouseShelfReturnBinMutationOptions = Apollo.BaseMutationOptions<UpdateWarehouseShelfReturnBinMutation, UpdateWarehouseShelfReturnBinMutationVariables>;
export const AdminWarehouseShelfDocument = gql`
    query AdminWarehouseShelf($id: String!) {
  findUniqueWarehouseShelf(where: {id: $id}) {
    ...WarehouseShelf
  }
}
    ${WarehouseShelfFragmentDoc}`;
export function useAdminWarehouseShelfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminWarehouseShelfQuery, AdminWarehouseShelfQueryVariables> & ({ variables: AdminWarehouseShelfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminWarehouseShelfQuery, AdminWarehouseShelfQueryVariables>(AdminWarehouseShelfDocument, options);
      }
export function useAdminWarehouseShelfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminWarehouseShelfQuery, AdminWarehouseShelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminWarehouseShelfQuery, AdminWarehouseShelfQueryVariables>(AdminWarehouseShelfDocument, options);
        }
export function useAdminWarehouseShelfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminWarehouseShelfQuery, AdminWarehouseShelfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminWarehouseShelfQuery, AdminWarehouseShelfQueryVariables>(AdminWarehouseShelfDocument, options);
        }
export type AdminWarehouseShelfQueryHookResult = ReturnType<typeof useAdminWarehouseShelfQuery>;
export type AdminWarehouseShelfLazyQueryHookResult = ReturnType<typeof useAdminWarehouseShelfLazyQuery>;
export type AdminWarehouseShelfSuspenseQueryHookResult = ReturnType<typeof useAdminWarehouseShelfSuspenseQuery>;
export type AdminWarehouseShelfQueryResult = Apollo.QueryResult<AdminWarehouseShelfQuery, AdminWarehouseShelfQueryVariables>;
export const UpdateWarehouseShelfDocument = gql`
    mutation UpdateWarehouseShelf($where: WarehouseShelfWhereUniqueInput!, $data: UpdateWarehouseShelfInput!) {
  updateOneWarehouseShelf(where: $where, data: $data) {
    ...WarehouseShelf
  }
}
    ${WarehouseShelfFragmentDoc}`;
export function useUpdateWarehouseShelfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWarehouseShelfMutation, UpdateWarehouseShelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWarehouseShelfMutation, UpdateWarehouseShelfMutationVariables>(UpdateWarehouseShelfDocument, options);
      }
export type UpdateWarehouseShelfMutationHookResult = ReturnType<typeof useUpdateWarehouseShelfMutation>;
export type UpdateWarehouseShelfMutationResult = Apollo.MutationResult<UpdateWarehouseShelfMutation>;
export type UpdateWarehouseShelfMutationOptions = Apollo.BaseMutationOptions<UpdateWarehouseShelfMutation, UpdateWarehouseShelfMutationVariables>;
export const FindManyWarehouseShelfDocument = gql`
    query FindManyWarehouseShelf($where: WarehouseShelfWhereInput, $orderBy: [WarehouseShelfOrderByWithRelationInput!]) {
  findManyWarehouseShelf(where: $where, orderBy: $orderBy) {
    ...WarehouseShelf
  }
}
    ${WarehouseShelfFragmentDoc}`;
export function useFindManyWarehouseShelfQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindManyWarehouseShelfQuery, FindManyWarehouseShelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindManyWarehouseShelfQuery, FindManyWarehouseShelfQueryVariables>(FindManyWarehouseShelfDocument, options);
      }
export function useFindManyWarehouseShelfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindManyWarehouseShelfQuery, FindManyWarehouseShelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindManyWarehouseShelfQuery, FindManyWarehouseShelfQueryVariables>(FindManyWarehouseShelfDocument, options);
        }
export function useFindManyWarehouseShelfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindManyWarehouseShelfQuery, FindManyWarehouseShelfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FindManyWarehouseShelfQuery, FindManyWarehouseShelfQueryVariables>(FindManyWarehouseShelfDocument, options);
        }
export type FindManyWarehouseShelfQueryHookResult = ReturnType<typeof useFindManyWarehouseShelfQuery>;
export type FindManyWarehouseShelfLazyQueryHookResult = ReturnType<typeof useFindManyWarehouseShelfLazyQuery>;
export type FindManyWarehouseShelfSuspenseQueryHookResult = ReturnType<typeof useFindManyWarehouseShelfSuspenseQuery>;
export type FindManyWarehouseShelfQueryResult = Apollo.QueryResult<FindManyWarehouseShelfQuery, FindManyWarehouseShelfQueryVariables>;
export const DeleteProductLabelSizeDocument = gql`
    mutation DeleteProductLabelSize($where: ProductLabelSizeWhereUniqueInput!) {
  deleteOneProductLabelSize(where: $where) {
    id
  }
}
    `;
export function useDeleteProductLabelSizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProductLabelSizeMutation, DeleteProductLabelSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProductLabelSizeMutation, DeleteProductLabelSizeMutationVariables>(DeleteProductLabelSizeDocument, options);
      }
export type DeleteProductLabelSizeMutationHookResult = ReturnType<typeof useDeleteProductLabelSizeMutation>;
export type DeleteProductLabelSizeMutationResult = Apollo.MutationResult<DeleteProductLabelSizeMutation>;
export type DeleteProductLabelSizeMutationOptions = Apollo.BaseMutationOptions<DeleteProductLabelSizeMutation, DeleteProductLabelSizeMutationVariables>;
export const ProductsStockDocument = gql`
    query ProductsStock($skip: Int!, $take: Int!, $orderBy: [ProductStockOrderByWithRelationInput!]) {
  productsStock(skip: $skip, take: $take, orderBy: $orderBy) {
    items {
      ...ProductStock
    }
    count
  }
}
    ${ProductStockFragmentDoc}`;
export function useProductsStockQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductsStockQuery, ProductsStockQueryVariables> & ({ variables: ProductsStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductsStockQuery, ProductsStockQueryVariables>(ProductsStockDocument, options);
      }
export function useProductsStockLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductsStockQuery, ProductsStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductsStockQuery, ProductsStockQueryVariables>(ProductsStockDocument, options);
        }
export function useProductsStockSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductsStockQuery, ProductsStockQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductsStockQuery, ProductsStockQueryVariables>(ProductsStockDocument, options);
        }
export type ProductsStockQueryHookResult = ReturnType<typeof useProductsStockQuery>;
export type ProductsStockLazyQueryHookResult = ReturnType<typeof useProductsStockLazyQuery>;
export type ProductsStockSuspenseQueryHookResult = ReturnType<typeof useProductsStockSuspenseQuery>;
export type ProductsStockQueryResult = Apollo.QueryResult<ProductsStockQuery, ProductsStockQueryVariables>;
export const AdminWarehouseShelvesDocument = gql`
    query AdminWarehouseShelves($skip: Int, $take: Int, $orderBy: [WarehouseShelfOrderByWithRelationInput!], $where: WarehouseShelfWhereInput) {
  findManyWarehouseShelf(
    skip: $skip
    take: $take
    orderBy: $orderBy
    where: $where
  ) {
    ...WarehouseShelf
  }
}
    ${WarehouseShelfFragmentDoc}`;
export function useAdminWarehouseShelvesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminWarehouseShelvesQuery, AdminWarehouseShelvesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminWarehouseShelvesQuery, AdminWarehouseShelvesQueryVariables>(AdminWarehouseShelvesDocument, options);
      }
export function useAdminWarehouseShelvesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminWarehouseShelvesQuery, AdminWarehouseShelvesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminWarehouseShelvesQuery, AdminWarehouseShelvesQueryVariables>(AdminWarehouseShelvesDocument, options);
        }
export function useAdminWarehouseShelvesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminWarehouseShelvesQuery, AdminWarehouseShelvesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminWarehouseShelvesQuery, AdminWarehouseShelvesQueryVariables>(AdminWarehouseShelvesDocument, options);
        }
export type AdminWarehouseShelvesQueryHookResult = ReturnType<typeof useAdminWarehouseShelvesQuery>;
export type AdminWarehouseShelvesLazyQueryHookResult = ReturnType<typeof useAdminWarehouseShelvesLazyQuery>;
export type AdminWarehouseShelvesSuspenseQueryHookResult = ReturnType<typeof useAdminWarehouseShelvesSuspenseQuery>;
export type AdminWarehouseShelvesQueryResult = Apollo.QueryResult<AdminWarehouseShelvesQuery, AdminWarehouseShelvesQueryVariables>;
export const DeleteWarehouseShelfDocument = gql`
    mutation DeleteWarehouseShelf($where: WarehouseShelfWhereUniqueInput!) {
  deleteOneWarehouseShelf(where: $where) {
    id
  }
}
    `;
export function useDeleteWarehouseShelfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWarehouseShelfMutation, DeleteWarehouseShelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWarehouseShelfMutation, DeleteWarehouseShelfMutationVariables>(DeleteWarehouseShelfDocument, options);
      }
export type DeleteWarehouseShelfMutationHookResult = ReturnType<typeof useDeleteWarehouseShelfMutation>;
export type DeleteWarehouseShelfMutationResult = Apollo.MutationResult<DeleteWarehouseShelfMutation>;
export type DeleteWarehouseShelfMutationOptions = Apollo.BaseMutationOptions<DeleteWarehouseShelfMutation, DeleteWarehouseShelfMutationVariables>;
export const PrintFileQueueDocument = gql`
    query PrintFileQueue($data: PrintFileQueueInput!) {
  printFileQueue(data: $data) {
    ...PrintFileQueue
  }
}
    ${PrintFileQueueFragmentDoc}`;
export function usePrintFileQueueQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PrintFileQueueQuery, PrintFileQueueQueryVariables> & ({ variables: PrintFileQueueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrintFileQueueQuery, PrintFileQueueQueryVariables>(PrintFileQueueDocument, options);
      }
export function usePrintFileQueueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrintFileQueueQuery, PrintFileQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrintFileQueueQuery, PrintFileQueueQueryVariables>(PrintFileQueueDocument, options);
        }
export function usePrintFileQueueSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrintFileQueueQuery, PrintFileQueueQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PrintFileQueueQuery, PrintFileQueueQueryVariables>(PrintFileQueueDocument, options);
        }
export type PrintFileQueueQueryHookResult = ReturnType<typeof usePrintFileQueueQuery>;
export type PrintFileQueueLazyQueryHookResult = ReturnType<typeof usePrintFileQueueLazyQuery>;
export type PrintFileQueueSuspenseQueryHookResult = ReturnType<typeof usePrintFileQueueSuspenseQuery>;
export type PrintFileQueueQueryResult = Apollo.QueryResult<PrintFileQueueQuery, PrintFileQueueQueryVariables>;
export const PrintFileFilterUserListDocument = gql`
    query PrintFileFilterUserList($data: PrintFileFilterUserListInput!) {
  printFileFilterUserList(data: $data) {
    id
    username
    fullName
    count
  }
}
    `;
export function usePrintFileFilterUserListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PrintFileFilterUserListQuery, PrintFileFilterUserListQueryVariables> & ({ variables: PrintFileFilterUserListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrintFileFilterUserListQuery, PrintFileFilterUserListQueryVariables>(PrintFileFilterUserListDocument, options);
      }
export function usePrintFileFilterUserListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrintFileFilterUserListQuery, PrintFileFilterUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrintFileFilterUserListQuery, PrintFileFilterUserListQueryVariables>(PrintFileFilterUserListDocument, options);
        }
export function usePrintFileFilterUserListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrintFileFilterUserListQuery, PrintFileFilterUserListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PrintFileFilterUserListQuery, PrintFileFilterUserListQueryVariables>(PrintFileFilterUserListDocument, options);
        }
export type PrintFileFilterUserListQueryHookResult = ReturnType<typeof usePrintFileFilterUserListQuery>;
export type PrintFileFilterUserListLazyQueryHookResult = ReturnType<typeof usePrintFileFilterUserListLazyQuery>;
export type PrintFileFilterUserListSuspenseQueryHookResult = ReturnType<typeof usePrintFileFilterUserListSuspenseQuery>;
export type PrintFileFilterUserListQueryResult = Apollo.QueryResult<PrintFileFilterUserListQuery, PrintFileFilterUserListQueryVariables>;
export const PrintFileFilterUserBasicInfoDocument = gql`
    query PrintFileFilterUserBasicInfo($id: String!) {
  printFileFilterUserBasicInfo(id: $id) {
    username
    fullName
  }
}
    `;
export function usePrintFileFilterUserBasicInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PrintFileFilterUserBasicInfoQuery, PrintFileFilterUserBasicInfoQueryVariables> & ({ variables: PrintFileFilterUserBasicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrintFileFilterUserBasicInfoQuery, PrintFileFilterUserBasicInfoQueryVariables>(PrintFileFilterUserBasicInfoDocument, options);
      }
export function usePrintFileFilterUserBasicInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrintFileFilterUserBasicInfoQuery, PrintFileFilterUserBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrintFileFilterUserBasicInfoQuery, PrintFileFilterUserBasicInfoQueryVariables>(PrintFileFilterUserBasicInfoDocument, options);
        }
export function usePrintFileFilterUserBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrintFileFilterUserBasicInfoQuery, PrintFileFilterUserBasicInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PrintFileFilterUserBasicInfoQuery, PrintFileFilterUserBasicInfoQueryVariables>(PrintFileFilterUserBasicInfoDocument, options);
        }
export type PrintFileFilterUserBasicInfoQueryHookResult = ReturnType<typeof usePrintFileFilterUserBasicInfoQuery>;
export type PrintFileFilterUserBasicInfoLazyQueryHookResult = ReturnType<typeof usePrintFileFilterUserBasicInfoLazyQuery>;
export type PrintFileFilterUserBasicInfoSuspenseQueryHookResult = ReturnType<typeof usePrintFileFilterUserBasicInfoSuspenseQuery>;
export type PrintFileFilterUserBasicInfoQueryResult = Apollo.QueryResult<PrintFileFilterUserBasicInfoQuery, PrintFileFilterUserBasicInfoQueryVariables>;
export const PrintFileFilterOrderKindListDocument = gql`
    query PrintFileFilterOrderKindList($data: PrintFileFilterOrderKindsListInput!) {
  printFileFilterOrderKindList(data: $data)
}
    `;
export function usePrintFileFilterOrderKindListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PrintFileFilterOrderKindListQuery, PrintFileFilterOrderKindListQueryVariables> & ({ variables: PrintFileFilterOrderKindListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrintFileFilterOrderKindListQuery, PrintFileFilterOrderKindListQueryVariables>(PrintFileFilterOrderKindListDocument, options);
      }
export function usePrintFileFilterOrderKindListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrintFileFilterOrderKindListQuery, PrintFileFilterOrderKindListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrintFileFilterOrderKindListQuery, PrintFileFilterOrderKindListQueryVariables>(PrintFileFilterOrderKindListDocument, options);
        }
export function usePrintFileFilterOrderKindListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrintFileFilterOrderKindListQuery, PrintFileFilterOrderKindListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PrintFileFilterOrderKindListQuery, PrintFileFilterOrderKindListQueryVariables>(PrintFileFilterOrderKindListDocument, options);
        }
export type PrintFileFilterOrderKindListQueryHookResult = ReturnType<typeof usePrintFileFilterOrderKindListQuery>;
export type PrintFileFilterOrderKindListLazyQueryHookResult = ReturnType<typeof usePrintFileFilterOrderKindListLazyQuery>;
export type PrintFileFilterOrderKindListSuspenseQueryHookResult = ReturnType<typeof usePrintFileFilterOrderKindListSuspenseQuery>;
export type PrintFileFilterOrderKindListQueryResult = Apollo.QueryResult<PrintFileFilterOrderKindListQuery, PrintFileFilterOrderKindListQueryVariables>;
export const AdminShipmentsDocument = gql`
    query AdminShipments($skip: Int, $take: Int, $orderBy: [ShipmentOrderByWithRelationInput!], $where: ShipmentWhereInput) {
  shipments(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    items {
      ...ShipmentListItem
    }
    count
  }
}
    ${ShipmentListItemFragmentDoc}`;
export function useAdminShipmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminShipmentsQuery, AdminShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminShipmentsQuery, AdminShipmentsQueryVariables>(AdminShipmentsDocument, options);
      }
export function useAdminShipmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminShipmentsQuery, AdminShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminShipmentsQuery, AdminShipmentsQueryVariables>(AdminShipmentsDocument, options);
        }
export function useAdminShipmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminShipmentsQuery, AdminShipmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminShipmentsQuery, AdminShipmentsQueryVariables>(AdminShipmentsDocument, options);
        }
export type AdminShipmentsQueryHookResult = ReturnType<typeof useAdminShipmentsQuery>;
export type AdminShipmentsLazyQueryHookResult = ReturnType<typeof useAdminShipmentsLazyQuery>;
export type AdminShipmentsSuspenseQueryHookResult = ReturnType<typeof useAdminShipmentsSuspenseQuery>;
export type AdminShipmentsQueryResult = Apollo.QueryResult<AdminShipmentsQuery, AdminShipmentsQueryVariables>;
export const SetLineItemCountPreparedInBulkDocument = gql`
    mutation SetLineItemCountPreparedInBulk($data: SetLineItemCountPreparedInBulkInput!) {
  setLineItemCountPreparedInBulk(data: $data) {
    results {
      lineId
      success {
        success
      }
    }
  }
}
    `;
export function useSetLineItemCountPreparedInBulkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetLineItemCountPreparedInBulkMutation, SetLineItemCountPreparedInBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetLineItemCountPreparedInBulkMutation, SetLineItemCountPreparedInBulkMutationVariables>(SetLineItemCountPreparedInBulkDocument, options);
      }
export type SetLineItemCountPreparedInBulkMutationHookResult = ReturnType<typeof useSetLineItemCountPreparedInBulkMutation>;
export type SetLineItemCountPreparedInBulkMutationResult = Apollo.MutationResult<SetLineItemCountPreparedInBulkMutation>;
export type SetLineItemCountPreparedInBulkMutationOptions = Apollo.BaseMutationOptions<SetLineItemCountPreparedInBulkMutation, SetLineItemCountPreparedInBulkMutationVariables>;
export const CreateQuickShipmentsFromPrintBatchDocument = gql`
    mutation CreateQuickShipmentsFromPrintBatch($data: CreateQuickShipmentsFromPrintBatchInput!) {
  createQuickShipmentsFromPrintBatch(data: $data) {
    countFailed
    countSucceeded
  }
}
    `;
export function useCreateQuickShipmentsFromPrintBatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQuickShipmentsFromPrintBatchMutation, CreateQuickShipmentsFromPrintBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateQuickShipmentsFromPrintBatchMutation, CreateQuickShipmentsFromPrintBatchMutationVariables>(CreateQuickShipmentsFromPrintBatchDocument, options);
      }
export type CreateQuickShipmentsFromPrintBatchMutationHookResult = ReturnType<typeof useCreateQuickShipmentsFromPrintBatchMutation>;
export type CreateQuickShipmentsFromPrintBatchMutationResult = Apollo.MutationResult<CreateQuickShipmentsFromPrintBatchMutation>;
export type CreateQuickShipmentsFromPrintBatchMutationOptions = Apollo.BaseMutationOptions<CreateQuickShipmentsFromPrintBatchMutation, CreateQuickShipmentsFromPrintBatchMutationVariables>;
export const FindWarehouseShelfDetailsDocument = gql`
    query FindWarehouseShelfDetails($id: String!) {
  findUniqueWarehouseShelf(where: {id: $id}) {
    id
    name
    bins {
      id
      number
      userProductOrderId
      details {
        isReady
        isOnHold
        isPriority
        preparedItemsCount
        itemsCount
      }
    }
  }
}
    `;
export function useFindWarehouseShelfDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindWarehouseShelfDetailsQuery, FindWarehouseShelfDetailsQueryVariables> & ({ variables: FindWarehouseShelfDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindWarehouseShelfDetailsQuery, FindWarehouseShelfDetailsQueryVariables>(FindWarehouseShelfDetailsDocument, options);
      }
export function useFindWarehouseShelfDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindWarehouseShelfDetailsQuery, FindWarehouseShelfDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindWarehouseShelfDetailsQuery, FindWarehouseShelfDetailsQueryVariables>(FindWarehouseShelfDetailsDocument, options);
        }
export function useFindWarehouseShelfDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindWarehouseShelfDetailsQuery, FindWarehouseShelfDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FindWarehouseShelfDetailsQuery, FindWarehouseShelfDetailsQueryVariables>(FindWarehouseShelfDetailsDocument, options);
        }
export type FindWarehouseShelfDetailsQueryHookResult = ReturnType<typeof useFindWarehouseShelfDetailsQuery>;
export type FindWarehouseShelfDetailsLazyQueryHookResult = ReturnType<typeof useFindWarehouseShelfDetailsLazyQuery>;
export type FindWarehouseShelfDetailsSuspenseQueryHookResult = ReturnType<typeof useFindWarehouseShelfDetailsSuspenseQuery>;
export type FindWarehouseShelfDetailsQueryResult = Apollo.QueryResult<FindWarehouseShelfDetailsQuery, FindWarehouseShelfDetailsQueryVariables>;
export const AdminOrdersDocument = gql`
    query AdminOrders($skip: Int, $take: Int, $orderBy: [UserProductOrderOrderByWithRelationInput!], $where: UserProductOrderWhereInput) {
  adminOrders(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    items {
      ...OrderAdminListItem
    }
    total
  }
}
    ${OrderAdminListItemFragmentDoc}`;
export function useAdminOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminOrdersQuery, AdminOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminOrdersQuery, AdminOrdersQueryVariables>(AdminOrdersDocument, options);
      }
export function useAdminOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminOrdersQuery, AdminOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminOrdersQuery, AdminOrdersQueryVariables>(AdminOrdersDocument, options);
        }
export function useAdminOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminOrdersQuery, AdminOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminOrdersQuery, AdminOrdersQueryVariables>(AdminOrdersDocument, options);
        }
export type AdminOrdersQueryHookResult = ReturnType<typeof useAdminOrdersQuery>;
export type AdminOrdersLazyQueryHookResult = ReturnType<typeof useAdminOrdersLazyQuery>;
export type AdminOrdersSuspenseQueryHookResult = ReturnType<typeof useAdminOrdersSuspenseQuery>;
export type AdminOrdersQueryResult = Apollo.QueryResult<AdminOrdersQuery, AdminOrdersQueryVariables>;
export const ReturnedAdminOrdersDocument = gql`
    query ReturnedAdminOrders($skip: Int, $take: Int, $orderBy: [UserProductOrderOrderByWithRelationInput!], $where: UserProductOrderWhereInput) {
  returnedAdminOrders(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
    items {
      ...OrderAdminListItem
    }
    total
  }
}
    ${OrderAdminListItemFragmentDoc}`;
export function useReturnedAdminOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReturnedAdminOrdersQuery, ReturnedAdminOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReturnedAdminOrdersQuery, ReturnedAdminOrdersQueryVariables>(ReturnedAdminOrdersDocument, options);
      }
export function useReturnedAdminOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReturnedAdminOrdersQuery, ReturnedAdminOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReturnedAdminOrdersQuery, ReturnedAdminOrdersQueryVariables>(ReturnedAdminOrdersDocument, options);
        }
export function useReturnedAdminOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReturnedAdminOrdersQuery, ReturnedAdminOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReturnedAdminOrdersQuery, ReturnedAdminOrdersQueryVariables>(ReturnedAdminOrdersDocument, options);
        }
export type ReturnedAdminOrdersQueryHookResult = ReturnType<typeof useReturnedAdminOrdersQuery>;
export type ReturnedAdminOrdersLazyQueryHookResult = ReturnType<typeof useReturnedAdminOrdersLazyQuery>;
export type ReturnedAdminOrdersSuspenseQueryHookResult = ReturnType<typeof useReturnedAdminOrdersSuspenseQuery>;
export type ReturnedAdminOrdersQueryResult = Apollo.QueryResult<ReturnedAdminOrdersQuery, ReturnedAdminOrdersQueryVariables>;